import "./worker.326ae55d.js";


function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5f6c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5f6c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");

var $beQI1 = parcelRequire("beQI1");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");
// Generated by purs version 0.15.16
function $f58bea5e58d54301$export$e49cfe3e3ab3c67c(err) {
    return err.stack || err.toString();
}
function $f58bea5e58d54301$export$a3bc9b8ed74fc(msg) {
    return new Error(msg);
}
function $f58bea5e58d54301$export$a8ecead220dd38a6(e) {
    return e.message;
}
function $f58bea5e58d54301$export$a8ff84c12d48cfa6(e) {
    return e.name || "Error";
}
function $f58bea5e58d54301$export$c159e25936a96837(just) {
    return function(nothing) {
        return function(e) {
            return e.stack ? just(e.stack) : nothing;
        };
    };
}
function $f58bea5e58d54301$export$de0c4a986b439e52(e) {
    return function() {
        throw e;
    };
}
function $f58bea5e58d54301$export$d49c1c6bf2cedce5(c) {
    return function(t) {
        return function() {
            try {
                return t();
            } catch (e) {
                if (e instanceof Error || Object.prototype.toString.call(e) === "[object Error]") return c(e)();
                else return c(new Error(e.toString()))();
            }
        };
    };
}



var $bQdkN = parcelRequire("bQdkN");

var $beQI1 = parcelRequire("beQI1");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $1rTTn = parcelRequire("1rTTn");
var $0185c1dbbe0f9876$var$pure = /* #__PURE__ */ $bQdkN.pure($1rTTn.applicativeEffect);
var $0185c1dbbe0f9876$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $0185c1dbbe0f9876$export$410a452afcd48948 = function(action) {
    return $f58bea5e58d54301$export$d49c1c6bf2cedce5(function($3) {
        return $0185c1dbbe0f9876$var$pure($beQI1.Left.create($3));
    })($0185c1dbbe0f9876$var$map($beQI1.Right.create)(action));
};
var $0185c1dbbe0f9876$export$7b1a37e4f0fe815 = function($4) {
    return $f58bea5e58d54301$export$de0c4a986b439e52($f58bea5e58d54301$export$a3bc9b8ed74fc($4));
};
var $0185c1dbbe0f9876$export$a57ab32f40f83ea9 = /* #__PURE__ */ function() {
    return $f58bea5e58d54301$export$c159e25936a96837($h2xUu.Just.create)($h2xUu.Nothing.value);
}();
var $0185c1dbbe0f9876$export$3879b24e8245693d = {
    show: $f58bea5e58d54301$export$e49cfe3e3ab3c67c
};


var $693a27a8782d8e71$var$discard = /* #__PURE__ */ $cADnC.discard($cADnC.discardUnit);
var $693a27a8782d8e71$export$8bf7aba4a9e09055 = function(dict) {
    return dict.throwError;
};
var $693a27a8782d8e71$export$fff877a725e9aba1 = /* #__PURE__ */ function() {
    return {
        throwError: $jhsiw.const($h2xUu.Nothing.value),
        Monad0: function() {
            return $h2xUu.monadMaybe;
        }
    };
}();
var $693a27a8782d8e71$export$390154ec55cffb04 = /* #__PURE__ */ function() {
    return {
        throwError: $beQI1.Left.create,
        Monad0: function() {
            return $beQI1.monadEither;
        }
    };
}();
var $693a27a8782d8e71$export$e4992fc673e7b027 = {
    throwError: $f58bea5e58d54301$export$de0c4a986b439e52,
    Monad0: function() {
        return $1rTTn.monadEffect;
    }
};
var $693a27a8782d8e71$export$438e6a8af9a8a22d = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $h2xUu.Nothing) return v1($2jM6U.unit);
            if (v instanceof $h2xUu.Just) return new $h2xUu.Just(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 79, column 1 - line 81, column 33): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $693a27a8782d8e71$export$fff877a725e9aba1;
    }
};
var $693a27a8782d8e71$export$abb16404f142771a = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $beQI1.Left) return v1(v.value0);
            if (v instanceof $beQI1.Right) return new $beQI1.Right(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 72, column 1 - line 74, column 35): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $693a27a8782d8e71$export$390154ec55cffb04;
    }
};
var $693a27a8782d8e71$export$434b8bb3cd954f77 = {
    catchError: /* #__PURE__ */ $jhsiw.flip($f58bea5e58d54301$export$d49c1c6bf2cedce5),
    MonadThrow0: function() {
        return $693a27a8782d8e71$export$e4992fc673e7b027;
    }
};
var $693a27a8782d8e71$export$1cf01ae67112be7b = function(dictMonadThrow) {
    var throwError1 = $693a27a8782d8e71$export$8bf7aba4a9e09055(dictMonadThrow);
    var pure = $bQdkN.pure(dictMonadThrow.Monad0().Applicative0());
    return function(error) {
        return $h2xUu.maybe(throwError1(error))(pure);
    };
};
var $693a27a8782d8e71$export$bd6bd7bb5418f998 = function(dictMonadThrow) {
    return $beQI1.either($693a27a8782d8e71$export$8bf7aba4a9e09055(dictMonadThrow))($bQdkN.pure(dictMonadThrow.Monad0().Applicative0()));
};
var $693a27a8782d8e71$export$3dede90624df3ba9 = function(dict) {
    return dict.catchError;
};
var $693a27a8782d8e71$export$b726b0cdf642257a = function(dictMonadError) {
    var throwError1 = $693a27a8782d8e71$export$8bf7aba4a9e09055(dictMonadError.MonadThrow0());
    var catchError1 = $693a27a8782d8e71$export$3dede90624df3ba9(dictMonadError);
    return function(p) {
        return function(act) {
            return function(handler) {
                var handle = function(e) {
                    var v = p(e);
                    if (v instanceof $h2xUu.Nothing) return throwError1(e);
                    if (v instanceof $h2xUu.Just) return handler(v.value0);
                    throw new Error("Failed pattern match at Control.Monad.Error.Class (line 57, column 5 - line 59, column 26): " + [
                        v.constructor.name
                    ]);
                };
                return catchError1(act)(handle);
            };
        };
    };
};
var $693a27a8782d8e71$export$410a452afcd48948 = function(dictMonadError) {
    var catchError1 = $693a27a8782d8e71$export$3dede90624df3ba9(dictMonadError);
    var Monad0 = dictMonadError.MonadThrow0().Monad0();
    var map = $7FzSN.map(Monad0.Bind1().Apply0().Functor0());
    var pure = $bQdkN.pure(Monad0.Applicative0());
    return function(a) {
        return catchError1(map($beQI1.Right.create)(a))(function($52) {
            return pure($beQI1.Left.create($52));
        });
    };
};
var $693a27a8782d8e71$export$8f240c41514f3a3e = function(dictMonadError) {
    var MonadThrow0 = dictMonadError.MonadThrow0();
    var Monad0 = MonadThrow0.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $cADnC.bind(Bind1);
    var try1 = $693a27a8782d8e71$export$410a452afcd48948(dictMonadError);
    var discard1 = $693a27a8782d8e71$var$discard(Bind1);
    var throwError1 = $693a27a8782d8e71$export$8bf7aba4a9e09055(MonadThrow0);
    var pure = $bQdkN.pure(Monad0.Applicative0());
    return function(acquire) {
        return function(release) {
            return function(kleisli) {
                return bind(acquire)(function(resource) {
                    return bind(try1(kleisli(resource)))(function(result) {
                        return discard1(release(resource))(function() {
                            return $beQI1.either(throwError1)(pure)(result);
                        });
                    });
                });
            };
        };
    };
};


// Generated by purs version 0.15.16

var $7O0Q4 = parcelRequire("7O0Q4");

var $2jM6U = parcelRequire("2jM6U");
var $60ebc5becec1930f$export$ca000e230c0caa3e = function(dict) {
    return dict.state;
};
var $60ebc5becec1930f$export$327f7b26ebf455db = function(dictMonadState) {
    var state1 = $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState);
    return function(s) {
        return state1(function(v) {
            return new $7O0Q4.Tuple($2jM6U.unit, s);
        });
    };
};
var $60ebc5becec1930f$export$45b91115a89d6020 = function(dictMonadState) {
    var state1 = $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $7O0Q4.Tuple($2jM6U.unit, f(s));
        });
    };
};
var $60ebc5becec1930f$export$3ff57735a52b8713 = function(dictMonadState) {
    var state1 = $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            var s$prime = f(s);
            return new $7O0Q4.Tuple(s$prime, s$prime);
        });
    };
};
var $60ebc5becec1930f$export$49487f6cbb79019d = function(dictMonadState) {
    var state1 = $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $7O0Q4.Tuple(f(s), s);
        });
    };
};
var $60ebc5becec1930f$export$3988ae62b71be9a3 = function(dictMonadState) {
    return $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState)(function(s) {
        return new $7O0Q4.Tuple(s, s);
    });
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $d71a736f4ee3881a$export$f2f6344eac5a3091 = /* #__PURE__ */ function() {
    function ButtonButton() {}
    ButtonButton.value = new ButtonButton();
    return ButtonButton;
}();
var $d71a736f4ee3881a$export$883ac606d954afa4 = /* #__PURE__ */ function() {
    function ButtonSubmit() {}
    ButtonSubmit.value = new ButtonSubmit();
    return ButtonSubmit;
}();
var $d71a736f4ee3881a$export$7c5d4436120726a7 = /* #__PURE__ */ function() {
    function ButtonReset() {}
    ButtonReset.value = new ButtonReset();
    return ButtonReset;
}();
var $d71a736f4ee3881a$export$354e79e7f4fdf8f9 = function(v) {
    if (v instanceof $d71a736f4ee3881a$export$f2f6344eac5a3091) return "button";
    if (v instanceof $d71a736f4ee3881a$export$883ac606d954afa4) return "submit";
    if (v instanceof $d71a736f4ee3881a$export$7c5d4436120726a7) return "reset";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.ButtonType (line 14, column 20 - line 17, column 25): " + [
        v.constructor.name
    ]);
};
var $d71a736f4ee3881a$export$eedf6d78b7217aa7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $d71a736f4ee3881a$export$f2f6344eac5a3091 && y instanceof $d71a736f4ee3881a$export$f2f6344eac5a3091) return true;
            if (x instanceof $d71a736f4ee3881a$export$883ac606d954afa4 && y instanceof $d71a736f4ee3881a$export$883ac606d954afa4) return true;
            if (x instanceof $d71a736f4ee3881a$export$7c5d4436120726a7 && y instanceof $d71a736f4ee3881a$export$7c5d4436120726a7) return true;
            return false;
        };
    }
};
var $d71a736f4ee3881a$export$d2ecbd2aa2e5439c = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $d71a736f4ee3881a$export$f2f6344eac5a3091 && y instanceof $d71a736f4ee3881a$export$f2f6344eac5a3091) return $ibsD5.EQ.value;
            if (x instanceof $d71a736f4ee3881a$export$f2f6344eac5a3091) return $ibsD5.LT.value;
            if (y instanceof $d71a736f4ee3881a$export$f2f6344eac5a3091) return $ibsD5.GT.value;
            if (x instanceof $d71a736f4ee3881a$export$883ac606d954afa4 && y instanceof $d71a736f4ee3881a$export$883ac606d954afa4) return $ibsD5.EQ.value;
            if (x instanceof $d71a736f4ee3881a$export$883ac606d954afa4) return $ibsD5.LT.value;
            if (y instanceof $d71a736f4ee3881a$export$883ac606d954afa4) return $ibsD5.GT.value;
            if (x instanceof $d71a736f4ee3881a$export$7c5d4436120726a7 && y instanceof $d71a736f4ee3881a$export$7c5d4436120726a7) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.ButtonType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $d71a736f4ee3881a$export$eedf6d78b7217aa7;
    }
};



var $brrpF = parcelRequire("brrpF");

var $iQTlW = parcelRequire("iQTlW");
// Generated by purs version 0.15.16
var $6e55caeb87d1882f$var$createUTC = function(y, mo, d, h, m, s, ms) {
    var date = new Date(Date.UTC(y, mo, d, h, m, s, ms));
    if (y >= 0 && y < 100) date.setUTCFullYear(y);
    return date.getTime();
};
function $6e55caeb87d1882f$export$345f31f1ea862984(rec1, rec2) {
    var msUTC1 = $6e55caeb87d1882f$var$createUTC(rec1.year, rec1.month - 1, rec1.day, rec1.hour, rec1.minute, rec1.second, rec1.millisecond);
    var msUTC2 = $6e55caeb87d1882f$var$createUTC(rec2.year, rec2.month - 1, rec2.day, rec2.hour, rec2.minute, rec2.second, rec2.millisecond);
    return msUTC1 - msUTC2;
}
function $6e55caeb87d1882f$export$e01c022ccf7c1b57(just) {
    return function(nothing) {
        return function(offset) {
            return function(rec) {
                var msUTC = $6e55caeb87d1882f$var$createUTC(rec.year, rec.month - 1, rec.day, rec.hour, rec.minute, rec.second, rec.millisecond);
                var dt = new Date(msUTC + offset);
                return isNaN(dt.getTime()) ? nothing : just({
                    year: dt.getUTCFullYear(),
                    month: dt.getUTCMonth() + 1,
                    day: dt.getUTCDate(),
                    hour: dt.getUTCHours(),
                    minute: dt.getUTCMinutes(),
                    second: dt.getUTCSeconds(),
                    millisecond: dt.getUTCMilliseconds()
                });
            };
        };
    };
}



var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $8zsOy = parcelRequire("8zsOy");
// Generated by purs version 0.15.16
var $6d6288a80dab3db3$var$createDate = function(y, m, d) {
    var date = new Date(Date.UTC(y, m, d));
    if (y >= 0 && y < 100) date.setUTCFullYear(y);
    return date;
};
function $6d6288a80dab3db3$export$278f2462bca80341(ctor, y, m, d) {
    var date = $6d6288a80dab3db3$var$createDate(y, m - 1, d);
    return ctor(date.getUTCFullYear())(date.getUTCMonth() + 1)(date.getUTCDate());
}
function $6d6288a80dab3db3$export$ee51fdb63bd93b0d(y, m, d) {
    return $6d6288a80dab3db3$var$createDate(y, m - 1, d).getUTCDay();
}
function $6d6288a80dab3db3$export$345f31f1ea862984(y1, m1, d1, y2, m2, d2) {
    var dt1 = $6d6288a80dab3db3$var$createDate(y1, m1 - 1, d1);
    var dt2 = $6d6288a80dab3db3$var$createDate(y2, m2 - 1, d2);
    return dt1.getTime() - dt2.getTime();
}



var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $iQTlW = parcelRequire("iQTlW");

var $8zsOy = parcelRequire("8zsOy");
// Generated by purs version 0.15.16

var $iQTlW = parcelRequire("iQTlW");

var $dIXGo = parcelRequire("dIXGo");

var $aJhEx = parcelRequire("aJhEx");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $2XxiF = parcelRequire("2XxiF");
var $7db6d676966daa12$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $7db6d676966daa12$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showInt);
var $7db6d676966daa12$var$Year = function(x) {
    return x;
};
var $7db6d676966daa12$export$7ee64068511a2cf0 = /* #__PURE__ */ function() {
    function Monday() {}
    Monday.value = new Monday();
    return Monday;
}();
var $7db6d676966daa12$export$238f9ec8ec28fcac = /* #__PURE__ */ function() {
    function Tuesday() {}
    Tuesday.value = new Tuesday();
    return Tuesday;
}();
var $7db6d676966daa12$export$6f4beda448624874 = /* #__PURE__ */ function() {
    function Wednesday() {}
    Wednesday.value = new Wednesday();
    return Wednesday;
}();
var $7db6d676966daa12$export$ee7232f0b12ab062 = /* #__PURE__ */ function() {
    function Thursday() {}
    Thursday.value = new Thursday();
    return Thursday;
}();
var $7db6d676966daa12$export$bb123522327d81ed = /* #__PURE__ */ function() {
    function Friday() {}
    Friday.value = new Friday();
    return Friday;
}();
var $7db6d676966daa12$export$446056e25969c735 = /* #__PURE__ */ function() {
    function Saturday() {}
    Saturday.value = new Saturday();
    return Saturday;
}();
var $7db6d676966daa12$export$8c9ac6ac028cebb2 = /* #__PURE__ */ function() {
    function Sunday() {}
    Sunday.value = new Sunday();
    return Sunday;
}();
var $7db6d676966daa12$export$abbad8e042a8ca41 = /* #__PURE__ */ function() {
    function January() {}
    January.value = new January();
    return January;
}();
var $7db6d676966daa12$export$e047bba63374153d = /* #__PURE__ */ function() {
    function February() {}
    February.value = new February();
    return February;
}();
var $7db6d676966daa12$export$ed40a0eacb1c1a7d = /* #__PURE__ */ function() {
    function March() {}
    March.value = new March();
    return March;
}();
var $7db6d676966daa12$export$b6e6de8185ac3568 = /* #__PURE__ */ function() {
    function April() {}
    April.value = new April();
    return April;
}();
var $7db6d676966daa12$export$50f4a85d6a193e43 = /* #__PURE__ */ function() {
    function May() {}
    May.value = new May();
    return May;
}();
var $7db6d676966daa12$export$ce3b81704c71b930 = /* #__PURE__ */ function() {
    function June() {}
    June.value = new June();
    return June;
}();
var $7db6d676966daa12$export$c35bbee8dc2d7f43 = /* #__PURE__ */ function() {
    function July() {}
    July.value = new July();
    return July;
}();
var $7db6d676966daa12$export$2646d2f8aef985a3 = /* #__PURE__ */ function() {
    function August() {}
    August.value = new August();
    return August;
}();
var $7db6d676966daa12$export$e18cdb270c0e647a = /* #__PURE__ */ function() {
    function September() {}
    September.value = new September();
    return September;
}();
var $7db6d676966daa12$export$af81d92e3606877a = /* #__PURE__ */ function() {
    function October() {}
    October.value = new October();
    return October;
}();
var $7db6d676966daa12$export$f440124e379d2b2 = /* #__PURE__ */ function() {
    function November() {}
    November.value = new November();
    return November;
}();
var $7db6d676966daa12$export$2d0bdb7c83ff083d = /* #__PURE__ */ function() {
    function December() {}
    December.value = new December();
    return December;
}();
var $7db6d676966daa12$var$Day = function(x) {
    return x;
};
var $7db6d676966daa12$export$fceec8b7cf7955e1 = {
    show: function(v) {
        return "(Year " + ($7db6d676966daa12$var$show(v) + ")");
    }
};
var $7db6d676966daa12$export$dca9d2e6bdb73ac1 = {
    show: function(v) {
        if (v instanceof $7db6d676966daa12$export$7ee64068511a2cf0) return "Monday";
        if (v instanceof $7db6d676966daa12$export$238f9ec8ec28fcac) return "Tuesday";
        if (v instanceof $7db6d676966daa12$export$6f4beda448624874) return "Wednesday";
        if (v instanceof $7db6d676966daa12$export$ee7232f0b12ab062) return "Thursday";
        if (v instanceof $7db6d676966daa12$export$bb123522327d81ed) return "Friday";
        if (v instanceof $7db6d676966daa12$export$446056e25969c735) return "Saturday";
        if (v instanceof $7db6d676966daa12$export$8c9ac6ac028cebb2) return "Sunday";
        throw new Error("Failed pattern match at Data.Date.Component (line 184, column 1 - line 191, column 25): " + [
            v.constructor.name
        ]);
    }
};
var $7db6d676966daa12$export$448238afa9640888 = {
    show: function(v) {
        if (v instanceof $7db6d676966daa12$export$abbad8e042a8ca41) return "January";
        if (v instanceof $7db6d676966daa12$export$e047bba63374153d) return "February";
        if (v instanceof $7db6d676966daa12$export$ed40a0eacb1c1a7d) return "March";
        if (v instanceof $7db6d676966daa12$export$b6e6de8185ac3568) return "April";
        if (v instanceof $7db6d676966daa12$export$50f4a85d6a193e43) return "May";
        if (v instanceof $7db6d676966daa12$export$ce3b81704c71b930) return "June";
        if (v instanceof $7db6d676966daa12$export$c35bbee8dc2d7f43) return "July";
        if (v instanceof $7db6d676966daa12$export$2646d2f8aef985a3) return "August";
        if (v instanceof $7db6d676966daa12$export$e18cdb270c0e647a) return "September";
        if (v instanceof $7db6d676966daa12$export$af81d92e3606877a) return "October";
        if (v instanceof $7db6d676966daa12$export$f440124e379d2b2) return "November";
        if (v instanceof $7db6d676966daa12$export$2d0bdb7c83ff083d) return "December";
        throw new Error("Failed pattern match at Data.Date.Component (line 101, column 1 - line 113, column 29): " + [
            v.constructor.name
        ]);
    }
};
var $7db6d676966daa12$export$4cdce79cadb90595 = {
    show: function(v) {
        return "(Day " + ($7db6d676966daa12$var$show(v) + ")");
    }
};
var $7db6d676966daa12$export$265bd81dab95f118 = $gwBF5.ordInt;
var $7db6d676966daa12$export$87032c9ef54f957e = $gwBF5.ordInt;
var $7db6d676966daa12$export$a20272c1d8245ff5 = $aJhEx.eqInt;
var $7db6d676966daa12$export$4d379f0fc2d943bb = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $7db6d676966daa12$export$7ee64068511a2cf0 && y instanceof $7db6d676966daa12$export$7ee64068511a2cf0) return true;
            if (x instanceof $7db6d676966daa12$export$238f9ec8ec28fcac && y instanceof $7db6d676966daa12$export$238f9ec8ec28fcac) return true;
            if (x instanceof $7db6d676966daa12$export$6f4beda448624874 && y instanceof $7db6d676966daa12$export$6f4beda448624874) return true;
            if (x instanceof $7db6d676966daa12$export$ee7232f0b12ab062 && y instanceof $7db6d676966daa12$export$ee7232f0b12ab062) return true;
            if (x instanceof $7db6d676966daa12$export$bb123522327d81ed && y instanceof $7db6d676966daa12$export$bb123522327d81ed) return true;
            if (x instanceof $7db6d676966daa12$export$446056e25969c735 && y instanceof $7db6d676966daa12$export$446056e25969c735) return true;
            if (x instanceof $7db6d676966daa12$export$8c9ac6ac028cebb2 && y instanceof $7db6d676966daa12$export$8c9ac6ac028cebb2) return true;
            return false;
        };
    }
};
var $7db6d676966daa12$export$a765516151070d24 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $7db6d676966daa12$export$7ee64068511a2cf0 && y instanceof $7db6d676966daa12$export$7ee64068511a2cf0) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$7ee64068511a2cf0) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$7ee64068511a2cf0) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$238f9ec8ec28fcac && y instanceof $7db6d676966daa12$export$238f9ec8ec28fcac) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$238f9ec8ec28fcac) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$238f9ec8ec28fcac) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$6f4beda448624874 && y instanceof $7db6d676966daa12$export$6f4beda448624874) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$6f4beda448624874) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$6f4beda448624874) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$ee7232f0b12ab062 && y instanceof $7db6d676966daa12$export$ee7232f0b12ab062) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$ee7232f0b12ab062) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$ee7232f0b12ab062) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$bb123522327d81ed && y instanceof $7db6d676966daa12$export$bb123522327d81ed) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$bb123522327d81ed) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$bb123522327d81ed) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$446056e25969c735 && y instanceof $7db6d676966daa12$export$446056e25969c735) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$446056e25969c735) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$446056e25969c735) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$8c9ac6ac028cebb2 && y instanceof $7db6d676966daa12$export$8c9ac6ac028cebb2) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Data.Date.Component (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $7db6d676966daa12$export$4d379f0fc2d943bb;
    }
};
var $7db6d676966daa12$export$927de8112dffb3f8 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $7db6d676966daa12$export$abbad8e042a8ca41 && y instanceof $7db6d676966daa12$export$abbad8e042a8ca41) return true;
            if (x instanceof $7db6d676966daa12$export$e047bba63374153d && y instanceof $7db6d676966daa12$export$e047bba63374153d) return true;
            if (x instanceof $7db6d676966daa12$export$ed40a0eacb1c1a7d && y instanceof $7db6d676966daa12$export$ed40a0eacb1c1a7d) return true;
            if (x instanceof $7db6d676966daa12$export$b6e6de8185ac3568 && y instanceof $7db6d676966daa12$export$b6e6de8185ac3568) return true;
            if (x instanceof $7db6d676966daa12$export$50f4a85d6a193e43 && y instanceof $7db6d676966daa12$export$50f4a85d6a193e43) return true;
            if (x instanceof $7db6d676966daa12$export$ce3b81704c71b930 && y instanceof $7db6d676966daa12$export$ce3b81704c71b930) return true;
            if (x instanceof $7db6d676966daa12$export$c35bbee8dc2d7f43 && y instanceof $7db6d676966daa12$export$c35bbee8dc2d7f43) return true;
            if (x instanceof $7db6d676966daa12$export$2646d2f8aef985a3 && y instanceof $7db6d676966daa12$export$2646d2f8aef985a3) return true;
            if (x instanceof $7db6d676966daa12$export$e18cdb270c0e647a && y instanceof $7db6d676966daa12$export$e18cdb270c0e647a) return true;
            if (x instanceof $7db6d676966daa12$export$af81d92e3606877a && y instanceof $7db6d676966daa12$export$af81d92e3606877a) return true;
            if (x instanceof $7db6d676966daa12$export$f440124e379d2b2 && y instanceof $7db6d676966daa12$export$f440124e379d2b2) return true;
            if (x instanceof $7db6d676966daa12$export$2d0bdb7c83ff083d && y instanceof $7db6d676966daa12$export$2d0bdb7c83ff083d) return true;
            return false;
        };
    }
};
var $7db6d676966daa12$export$98d905cecec08501 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $7db6d676966daa12$export$abbad8e042a8ca41 && y instanceof $7db6d676966daa12$export$abbad8e042a8ca41) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$abbad8e042a8ca41) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$abbad8e042a8ca41) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$e047bba63374153d && y instanceof $7db6d676966daa12$export$e047bba63374153d) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$e047bba63374153d) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$e047bba63374153d) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$ed40a0eacb1c1a7d && y instanceof $7db6d676966daa12$export$ed40a0eacb1c1a7d) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$ed40a0eacb1c1a7d) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$ed40a0eacb1c1a7d) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$b6e6de8185ac3568 && y instanceof $7db6d676966daa12$export$b6e6de8185ac3568) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$b6e6de8185ac3568) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$b6e6de8185ac3568) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$50f4a85d6a193e43 && y instanceof $7db6d676966daa12$export$50f4a85d6a193e43) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$50f4a85d6a193e43) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$50f4a85d6a193e43) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$ce3b81704c71b930 && y instanceof $7db6d676966daa12$export$ce3b81704c71b930) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$ce3b81704c71b930) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$ce3b81704c71b930) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$c35bbee8dc2d7f43 && y instanceof $7db6d676966daa12$export$c35bbee8dc2d7f43) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$c35bbee8dc2d7f43) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$c35bbee8dc2d7f43) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$2646d2f8aef985a3 && y instanceof $7db6d676966daa12$export$2646d2f8aef985a3) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$2646d2f8aef985a3) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$2646d2f8aef985a3) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$e18cdb270c0e647a && y instanceof $7db6d676966daa12$export$e18cdb270c0e647a) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$e18cdb270c0e647a) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$e18cdb270c0e647a) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$af81d92e3606877a && y instanceof $7db6d676966daa12$export$af81d92e3606877a) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$af81d92e3606877a) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$af81d92e3606877a) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$f440124e379d2b2 && y instanceof $7db6d676966daa12$export$f440124e379d2b2) return $ibsD5.EQ.value;
            if (x instanceof $7db6d676966daa12$export$f440124e379d2b2) return $ibsD5.LT.value;
            if (y instanceof $7db6d676966daa12$export$f440124e379d2b2) return $ibsD5.GT.value;
            if (x instanceof $7db6d676966daa12$export$2d0bdb7c83ff083d && y instanceof $7db6d676966daa12$export$2d0bdb7c83ff083d) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Data.Date.Component (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $7db6d676966daa12$export$927de8112dffb3f8;
    }
};
var $7db6d676966daa12$export$9736822bc4d08a1e = $aJhEx.eqInt;
var $7db6d676966daa12$export$bcd3d7e0476c0ec3 = /* #__PURE__ */ function() {
    return {
        bottom: -271820,
        top: 275759,
        Ord0: function() {
            return $7db6d676966daa12$export$265bd81dab95f118;
        }
    };
}();
var $7db6d676966daa12$export$a8f04630df721b18 = /* #__PURE__ */ function() {
    return {
        bottom: $7db6d676966daa12$export$7ee64068511a2cf0.value,
        top: $7db6d676966daa12$export$8c9ac6ac028cebb2.value,
        Ord0: function() {
            return $7db6d676966daa12$export$a765516151070d24;
        }
    };
}();
var $7db6d676966daa12$export$ab1d1b39e9a2bfeb = /* #__PURE__ */ function() {
    return {
        bottom: $7db6d676966daa12$export$abbad8e042a8ca41.value,
        top: $7db6d676966daa12$export$2d0bdb7c83ff083d.value,
        Ord0: function() {
            return $7db6d676966daa12$export$98d905cecec08501;
        }
    };
}();
var $7db6d676966daa12$export$2391dde84a7e2cbd = {
    cardinality: 547580,
    toEnum: function(n) {
        if (n >= -271820 && n <= 275759) return new $h2xUu.Just(n);
        if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Data.Date.Component (line 35, column 1 - line 40, column 24): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $7db6d676966daa12$export$bcd3d7e0476c0ec3;
    },
    Enum1: function() {
        return $7db6d676966daa12$var$$lazy_enumYear(0);
    }
};
var $7db6d676966daa12$var$$lazy_enumYear = /* #__PURE__ */ $7db6d676966daa12$var$$runtime_lazy("enumYear", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $55 = $dIXGo.toEnum($7db6d676966daa12$export$2391dde84a7e2cbd);
            var $56 = $dIXGo.fromEnum($7db6d676966daa12$export$2391dde84a7e2cbd);
            return function($57) {
                return $55(function(v) {
                    return v + 1 | 0;
                }($56($57)));
            };
        }(),
        pred: function() {
            var $58 = $dIXGo.toEnum($7db6d676966daa12$export$2391dde84a7e2cbd);
            var $59 = $dIXGo.fromEnum($7db6d676966daa12$export$2391dde84a7e2cbd);
            return function($60) {
                return $58(function(v) {
                    return v - 1 | 0;
                }($59($60)));
            };
        }(),
        Ord0: function() {
            return $7db6d676966daa12$export$265bd81dab95f118;
        }
    };
});
var $7db6d676966daa12$export$71b4ec642fe3649 = /* #__PURE__ */ $7db6d676966daa12$var$$lazy_enumYear(31);
var $7db6d676966daa12$export$f8fb631899e9bc28 = {
    cardinality: 7,
    toEnum: function(v) {
        if (v === 1) return new $h2xUu.Just($7db6d676966daa12$export$7ee64068511a2cf0.value);
        if (v === 2) return new $h2xUu.Just($7db6d676966daa12$export$238f9ec8ec28fcac.value);
        if (v === 3) return new $h2xUu.Just($7db6d676966daa12$export$6f4beda448624874.value);
        if (v === 4) return new $h2xUu.Just($7db6d676966daa12$export$ee7232f0b12ab062.value);
        if (v === 5) return new $h2xUu.Just($7db6d676966daa12$export$bb123522327d81ed.value);
        if (v === 6) return new $h2xUu.Just($7db6d676966daa12$export$446056e25969c735.value);
        if (v === 7) return new $h2xUu.Just($7db6d676966daa12$export$8c9ac6ac028cebb2.value);
        return $h2xUu.Nothing.value;
    },
    fromEnum: function(v) {
        if (v instanceof $7db6d676966daa12$export$7ee64068511a2cf0) return 1;
        if (v instanceof $7db6d676966daa12$export$238f9ec8ec28fcac) return 2;
        if (v instanceof $7db6d676966daa12$export$6f4beda448624874) return 3;
        if (v instanceof $7db6d676966daa12$export$ee7232f0b12ab062) return 4;
        if (v instanceof $7db6d676966daa12$export$bb123522327d81ed) return 5;
        if (v instanceof $7db6d676966daa12$export$446056e25969c735) return 6;
        if (v instanceof $7db6d676966daa12$export$8c9ac6ac028cebb2) return 7;
        throw new Error("Failed pattern match at Data.Date.Component (line 175, column 14 - line 182, column 16): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $7db6d676966daa12$export$a8f04630df721b18;
    },
    Enum1: function() {
        return $7db6d676966daa12$var$$lazy_enumWeekday(0);
    }
};
var $7db6d676966daa12$var$$lazy_enumWeekday = /* #__PURE__ */ $7db6d676966daa12$var$$runtime_lazy("enumWeekday", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $61 = $dIXGo.toEnum($7db6d676966daa12$export$f8fb631899e9bc28);
            var $62 = $dIXGo.fromEnum($7db6d676966daa12$export$f8fb631899e9bc28);
            return function($63) {
                return $61(function(v) {
                    return v + 1 | 0;
                }($62($63)));
            };
        }(),
        pred: function() {
            var $64 = $dIXGo.toEnum($7db6d676966daa12$export$f8fb631899e9bc28);
            var $65 = $dIXGo.fromEnum($7db6d676966daa12$export$f8fb631899e9bc28);
            return function($66) {
                return $64(function(v) {
                    return v - 1 | 0;
                }($65($66)));
            };
        }(),
        Ord0: function() {
            return $7db6d676966daa12$export$a765516151070d24;
        }
    };
});
var $7db6d676966daa12$export$63166656fe259224 = /* #__PURE__ */ $7db6d676966daa12$var$$lazy_enumWeekday(160);
var $7db6d676966daa12$export$e744bc4044126e99 = {
    cardinality: 12,
    toEnum: function(v) {
        if (v === 1) return new $h2xUu.Just($7db6d676966daa12$export$abbad8e042a8ca41.value);
        if (v === 2) return new $h2xUu.Just($7db6d676966daa12$export$e047bba63374153d.value);
        if (v === 3) return new $h2xUu.Just($7db6d676966daa12$export$ed40a0eacb1c1a7d.value);
        if (v === 4) return new $h2xUu.Just($7db6d676966daa12$export$b6e6de8185ac3568.value);
        if (v === 5) return new $h2xUu.Just($7db6d676966daa12$export$50f4a85d6a193e43.value);
        if (v === 6) return new $h2xUu.Just($7db6d676966daa12$export$ce3b81704c71b930.value);
        if (v === 7) return new $h2xUu.Just($7db6d676966daa12$export$c35bbee8dc2d7f43.value);
        if (v === 8) return new $h2xUu.Just($7db6d676966daa12$export$2646d2f8aef985a3.value);
        if (v === 9) return new $h2xUu.Just($7db6d676966daa12$export$e18cdb270c0e647a.value);
        if (v === 10) return new $h2xUu.Just($7db6d676966daa12$export$af81d92e3606877a.value);
        if (v === 11) return new $h2xUu.Just($7db6d676966daa12$export$f440124e379d2b2.value);
        if (v === 12) return new $h2xUu.Just($7db6d676966daa12$export$2d0bdb7c83ff083d.value);
        return $h2xUu.Nothing.value;
    },
    fromEnum: function(v) {
        if (v instanceof $7db6d676966daa12$export$abbad8e042a8ca41) return 1;
        if (v instanceof $7db6d676966daa12$export$e047bba63374153d) return 2;
        if (v instanceof $7db6d676966daa12$export$ed40a0eacb1c1a7d) return 3;
        if (v instanceof $7db6d676966daa12$export$b6e6de8185ac3568) return 4;
        if (v instanceof $7db6d676966daa12$export$50f4a85d6a193e43) return 5;
        if (v instanceof $7db6d676966daa12$export$ce3b81704c71b930) return 6;
        if (v instanceof $7db6d676966daa12$export$c35bbee8dc2d7f43) return 7;
        if (v instanceof $7db6d676966daa12$export$2646d2f8aef985a3) return 8;
        if (v instanceof $7db6d676966daa12$export$e18cdb270c0e647a) return 9;
        if (v instanceof $7db6d676966daa12$export$af81d92e3606877a) return 10;
        if (v instanceof $7db6d676966daa12$export$f440124e379d2b2) return 11;
        if (v instanceof $7db6d676966daa12$export$2d0bdb7c83ff083d) return 12;
        throw new Error("Failed pattern match at Data.Date.Component (line 87, column 14 - line 99, column 19): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $7db6d676966daa12$export$ab1d1b39e9a2bfeb;
    },
    Enum1: function() {
        return $7db6d676966daa12$var$$lazy_enumMonth(0);
    }
};
var $7db6d676966daa12$var$$lazy_enumMonth = /* #__PURE__ */ $7db6d676966daa12$var$$runtime_lazy("enumMonth", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $67 = $dIXGo.toEnum($7db6d676966daa12$export$e744bc4044126e99);
            var $68 = $dIXGo.fromEnum($7db6d676966daa12$export$e744bc4044126e99);
            return function($69) {
                return $67(function(v) {
                    return v + 1 | 0;
                }($68($69)));
            };
        }(),
        pred: function() {
            var $70 = $dIXGo.toEnum($7db6d676966daa12$export$e744bc4044126e99);
            var $71 = $dIXGo.fromEnum($7db6d676966daa12$export$e744bc4044126e99);
            return function($72) {
                return $70(function(v) {
                    return v - 1 | 0;
                }($71($72)));
            };
        }(),
        Ord0: function() {
            return $7db6d676966daa12$export$98d905cecec08501;
        }
    };
});
var $7db6d676966daa12$export$fe5733da28f67bc = /* #__PURE__ */ $7db6d676966daa12$var$$lazy_enumMonth(67);
var $7db6d676966daa12$export$337e475a74d6aff0 = {
    bottom: 1,
    top: 31,
    Ord0: function() {
        return $7db6d676966daa12$export$87032c9ef54f957e;
    }
};
var $7db6d676966daa12$export$2f59e9c675f625db = {
    cardinality: 31,
    toEnum: function(n) {
        if (n >= 1 && n <= 31) return new $h2xUu.Just(n);
        if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Data.Date.Component (line 133, column 1 - line 138, column 23): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $7db6d676966daa12$export$337e475a74d6aff0;
    },
    Enum1: function() {
        return $7db6d676966daa12$var$$lazy_enumDay(0);
    }
};
var $7db6d676966daa12$var$$lazy_enumDay = /* #__PURE__ */ $7db6d676966daa12$var$$runtime_lazy("enumDay", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $73 = $dIXGo.toEnum($7db6d676966daa12$export$2f59e9c675f625db);
            var $74 = $dIXGo.fromEnum($7db6d676966daa12$export$2f59e9c675f625db);
            return function($75) {
                return $73(function(v) {
                    return v + 1 | 0;
                }($74($75)));
            };
        }(),
        pred: function() {
            var $76 = $dIXGo.toEnum($7db6d676966daa12$export$2f59e9c675f625db);
            var $77 = $dIXGo.fromEnum($7db6d676966daa12$export$2f59e9c675f625db);
            return function($78) {
                return $76(function(v) {
                    return v - 1 | 0;
                }($77($78)));
            };
        }(),
        Ord0: function() {
            return $7db6d676966daa12$export$87032c9ef54f957e;
        }
    };
});
var $7db6d676966daa12$export$14dd55f5b902975a = /* #__PURE__ */ $7db6d676966daa12$var$$lazy_enumDay(129);



var $dIXGo = parcelRequire("dIXGo");

var $aJhEx = parcelRequire("aJhEx");

var $8tuSi = parcelRequire("8tuSi");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $hCjGZ = parcelRequire("hCjGZ");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $2XxiF = parcelRequire("2XxiF");
// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $aJhEx = parcelRequire("aJhEx");

var $46y1S = parcelRequire("46y1S");

var $gwBF5 = parcelRequire("gwBF5");

var $aop8q = parcelRequire("aop8q");

var $2XxiF = parcelRequire("2XxiF");
var $1de5dd48369d2a6b$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showNumber);
var $1de5dd48369d2a6b$var$over = /* #__PURE__ */ $46y1S.over()();
var $1de5dd48369d2a6b$var$negate = /* #__PURE__ */ $aop8q.negate($aop8q.ringNumber);
var $1de5dd48369d2a6b$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $1de5dd48369d2a6b$export$f2a120b78af04023 = function(x) {
    return x;
};
var $1de5dd48369d2a6b$export$760297a502ec68f7 = function(x) {
    return x;
};
var $1de5dd48369d2a6b$export$e4eccef8f937a949 = function(x) {
    return x;
};
var $1de5dd48369d2a6b$export$8c68c012e85c37f4 = function(x) {
    return x;
};
var $1de5dd48369d2a6b$export$d3134eff2123aadb = function(x) {
    return x;
};
var $1de5dd48369d2a6b$export$9eabacebe6624782 = function(dict) {
    return dict.toDuration;
};
var $1de5dd48369d2a6b$export$358ac052a84a2abd = {
    show: function(v) {
        return "(Seconds " + ($1de5dd48369d2a6b$var$show(v) + ")");
    }
};
var $1de5dd48369d2a6b$export$f5f4de8badcbd545 = {
    show: function(v) {
        return "(Minutes " + ($1de5dd48369d2a6b$var$show(v) + ")");
    }
};
var $1de5dd48369d2a6b$export$1d3b9b5391a72ae7 = {
    show: function(v) {
        return "(Milliseconds " + ($1de5dd48369d2a6b$var$show(v) + ")");
    }
};
var $1de5dd48369d2a6b$export$c5d3ca6fc3468bcf = {
    show: function(v) {
        return "(Hours " + ($1de5dd48369d2a6b$var$show(v) + ")");
    }
};
var $1de5dd48369d2a6b$export$de46f7d16350d367 = {
    show: function(v) {
        return "(Days " + ($1de5dd48369d2a6b$var$show(v) + ")");
    }
};
var $1de5dd48369d2a6b$export$bccfb43682e4a5e4 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $1de5dd48369d2a6b$export$d9bc7c6e66ddf272 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $1de5dd48369d2a6b$export$def67087bd72fdb7 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $1de5dd48369d2a6b$export$5f6754e19ae8b602 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $1de5dd48369d2a6b$export$e8bb798e27d1673b = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $1de5dd48369d2a6b$export$34e2a018de95f3d = $gwBF5.ordNumber;
var $1de5dd48369d2a6b$export$d6d247637e7494c9 = $gwBF5.ordNumber;
var $1de5dd48369d2a6b$export$e0a5c04af6395341 = $gwBF5.ordNumber;
var $1de5dd48369d2a6b$export$4ccf8d6c1ebfa128 = $gwBF5.ordNumber;
var $1de5dd48369d2a6b$export$3ab38ab5accb6ec2 = $gwBF5.ordNumber;
var $1de5dd48369d2a6b$export$321d65ffd9e957ce = {
    Coercible0: function() {
        return undefined;
    }
};
var $1de5dd48369d2a6b$export$f5994f75b457cdcc = {
    Coercible0: function() {
        return undefined;
    }
};
var $1de5dd48369d2a6b$export$961a021281e4c248 = {
    Coercible0: function() {
        return undefined;
    }
};
var $1de5dd48369d2a6b$export$5ca80b70b64299ae = {
    Coercible0: function() {
        return undefined;
    }
};
var $1de5dd48369d2a6b$export$a5ba0a6cacc34910 = {
    Coercible0: function() {
        return undefined;
    }
};
var $1de5dd48369d2a6b$export$5b5983dc8ed41daa = {
    mempty: 0.0,
    Semigroup0: function() {
        return $1de5dd48369d2a6b$export$bccfb43682e4a5e4;
    }
};
var $1de5dd48369d2a6b$export$1857fd2af0af50be = {
    mempty: 0.0,
    Semigroup0: function() {
        return $1de5dd48369d2a6b$export$d9bc7c6e66ddf272;
    }
};
var $1de5dd48369d2a6b$export$70200b12758a7a61 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $1de5dd48369d2a6b$export$def67087bd72fdb7;
    }
};
var $1de5dd48369d2a6b$export$22829380fb9f2b93 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $1de5dd48369d2a6b$export$5f6754e19ae8b602;
    }
};
var $1de5dd48369d2a6b$export$9bd04d01a6c9ebc2 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $1de5dd48369d2a6b$export$e8bb798e27d1673b;
    }
};
var $1de5dd48369d2a6b$export$1a0a2c8fdf902748 = function(dict) {
    return dict.fromDuration;
};
var $1de5dd48369d2a6b$export$28743521ea1cb8f9 = function(dictDuration) {
    var $57 = $1de5dd48369d2a6b$export$9eabacebe6624782(dictDuration);
    var $58 = $1de5dd48369d2a6b$var$over($1de5dd48369d2a6b$export$e4eccef8f937a949)($1de5dd48369d2a6b$var$negate);
    var $59 = $1de5dd48369d2a6b$export$1a0a2c8fdf902748(dictDuration);
    return function($60) {
        return $57($58($59($60)));
    };
};
var $1de5dd48369d2a6b$export$980dbec50a957fc7 = $aJhEx.eqNumber;
var $1de5dd48369d2a6b$export$4771a2ee9f50caac = $aJhEx.eqNumber;
var $1de5dd48369d2a6b$export$699cb56941ecf990 = $aJhEx.eqNumber;
var $1de5dd48369d2a6b$export$fd6d5f49667130a4 = $aJhEx.eqNumber;
var $1de5dd48369d2a6b$export$c66ee96f983a5e21 = $aJhEx.eqNumber;
var $1de5dd48369d2a6b$export$1791f02d01a6ae8 = {
    fromDuration: /* #__PURE__ */ $1de5dd48369d2a6b$var$over($1de5dd48369d2a6b$export$f2a120b78af04023)(function(v) {
        return v * 1000.0;
    }),
    toDuration: /* #__PURE__ */ $1de5dd48369d2a6b$var$over($1de5dd48369d2a6b$export$e4eccef8f937a949)(function(v) {
        return v / 1000.0;
    })
};
var $1de5dd48369d2a6b$export$563c2be46809b74f = {
    fromDuration: /* #__PURE__ */ $1de5dd48369d2a6b$var$over($1de5dd48369d2a6b$export$760297a502ec68f7)(function(v) {
        return v * 60000.0;
    }),
    toDuration: /* #__PURE__ */ $1de5dd48369d2a6b$var$over($1de5dd48369d2a6b$export$e4eccef8f937a949)(function(v) {
        return v / 60000.0;
    })
};
var $1de5dd48369d2a6b$export$44304cbc75c995e8 = {
    fromDuration: $1de5dd48369d2a6b$var$identity,
    toDuration: $1de5dd48369d2a6b$var$identity
};
var $1de5dd48369d2a6b$export$117f08340b9f6c14 = {
    fromDuration: /* #__PURE__ */ $1de5dd48369d2a6b$var$over($1de5dd48369d2a6b$export$8c68c012e85c37f4)(function(v) {
        return v * 3600000.0;
    }),
    toDuration: /* #__PURE__ */ $1de5dd48369d2a6b$var$over($1de5dd48369d2a6b$export$e4eccef8f937a949)(function(v) {
        return v / 3600000.0;
    })
};
var $1de5dd48369d2a6b$export$93ad8ffd4576e464 = {
    fromDuration: /* #__PURE__ */ $1de5dd48369d2a6b$var$over($1de5dd48369d2a6b$export$d3134eff2123aadb)(function(v) {
        return v * 8.64e7;
    }),
    toDuration: /* #__PURE__ */ $1de5dd48369d2a6b$var$over($1de5dd48369d2a6b$export$e4eccef8f937a949)(function(v) {
        return v / 8.64e7;
    })
};
var $1de5dd48369d2a6b$export$3082151037402ab5 = function(dictDuration) {
    var fromDuration1 = $1de5dd48369d2a6b$export$1a0a2c8fdf902748(dictDuration);
    return function(dictDuration1) {
        var $61 = $1de5dd48369d2a6b$export$9eabacebe6624782(dictDuration1);
        return function($62) {
            return $61(fromDuration1($62));
        };
    };
};


var $4284d909e8818db0$var$fromEnum = /* #__PURE__ */ $dIXGo.fromEnum($7db6d676966daa12$export$e744bc4044126e99);
var $4284d909e8818db0$var$fromJust = /* #__PURE__ */ $h2xUu.fromJust();
var $4284d909e8818db0$var$toEnum = /* #__PURE__ */ $dIXGo.toEnum($7db6d676966daa12$export$f8fb631899e9bc28);
var $4284d909e8818db0$var$show = /* #__PURE__ */ $2XxiF.show($7db6d676966daa12$export$fceec8b7cf7955e1);
var $4284d909e8818db0$var$show1 = /* #__PURE__ */ $2XxiF.show($7db6d676966daa12$export$448238afa9640888);
var $4284d909e8818db0$var$show2 = /* #__PURE__ */ $2XxiF.show($7db6d676966daa12$export$4cdce79cadb90595);
var $4284d909e8818db0$var$fromEnum1 = /* #__PURE__ */ $dIXGo.fromEnum($7db6d676966daa12$export$2391dde84a7e2cbd);
var $4284d909e8818db0$var$mod = /* #__PURE__ */ $8tuSi.mod($8tuSi.euclideanRingInt);
var $4284d909e8818db0$var$toEnum1 = /* #__PURE__ */ $dIXGo.toEnum($7db6d676966daa12$export$2f59e9c675f625db);
var $4284d909e8818db0$var$eq1 = /* #__PURE__ */ $aJhEx.eq($7db6d676966daa12$export$a20272c1d8245ff5);
var $4284d909e8818db0$var$eq2 = /* #__PURE__ */ $aJhEx.eq($7db6d676966daa12$export$927de8112dffb3f8);
var $4284d909e8818db0$var$eq3 = /* #__PURE__ */ $aJhEx.eq($7db6d676966daa12$export$9736822bc4d08a1e);
var $4284d909e8818db0$var$compare = /* #__PURE__ */ $gwBF5.compare($7db6d676966daa12$export$265bd81dab95f118);
var $4284d909e8818db0$var$compare1 = /* #__PURE__ */ $gwBF5.compare($7db6d676966daa12$export$98d905cecec08501);
var $4284d909e8818db0$var$compare2 = /* #__PURE__ */ $gwBF5.compare($7db6d676966daa12$export$87032c9ef54f957e);
var $4284d909e8818db0$var$succ = /* #__PURE__ */ $dIXGo.succ($7db6d676966daa12$export$fe5733da28f67bc);
var $4284d909e8818db0$var$succ1 = /* #__PURE__ */ $dIXGo.succ($7db6d676966daa12$export$14dd55f5b902975a);
var $4284d909e8818db0$var$greaterThan = /* #__PURE__ */ $gwBF5.greaterThan(/* #__PURE__ */ $h2xUu.ordMaybe($7db6d676966daa12$export$87032c9ef54f957e));
var $4284d909e8818db0$var$succ2 = /* #__PURE__ */ $dIXGo.succ($7db6d676966daa12$export$71b4ec642fe3649);
var $4284d909e8818db0$var$apply = /* #__PURE__ */ $26ZCq.apply($h2xUu.applyMaybe);
var $4284d909e8818db0$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $4284d909e8818db0$var$pure = /* #__PURE__ */ $bQdkN.pure($h2xUu.applicativeMaybe);
var $4284d909e8818db0$var$pred = /* #__PURE__ */ $dIXGo.pred($7db6d676966daa12$export$fe5733da28f67bc);
var $4284d909e8818db0$var$pred1 = /* #__PURE__ */ $dIXGo.pred($7db6d676966daa12$export$14dd55f5b902975a);
var $4284d909e8818db0$var$pred2 = /* #__PURE__ */ $dIXGo.pred($7db6d676966daa12$export$71b4ec642fe3649);
var $4284d909e8818db0$var$toEnum2 = /* #__PURE__ */ $dIXGo.toEnum($7db6d676966daa12$export$e744bc4044126e99);
var $4284d909e8818db0$var$fromEnum2 = /* #__PURE__ */ $dIXGo.fromEnum($7db6d676966daa12$export$2f59e9c675f625db);
var $4284d909e8818db0$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($h2xUu.bindMaybe);
var $4284d909e8818db0$var$bind = /* #__PURE__ */ $cADnC.bind($h2xUu.bindMaybe);
var $4284d909e8818db0$var$$$Date = /* #__PURE__ */ function() {
    function $$Date(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    $$Date.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new $$Date(value0, value1, value2);
            };
        };
    };
    return $$Date;
}();
var $4284d909e8818db0$export$31803937850fb2da = function(v) {
    return v.value0;
};
var $4284d909e8818db0$export$b7f7efbe9ab39b25 = function(v) {
    var n = $6d6288a80dab3db3$export$ee51fdb63bd93b0d(v.value0, $4284d909e8818db0$var$fromEnum(v.value1), v.value2);
    var $86 = n === 0;
    if ($86) return $4284d909e8818db0$var$fromJust($4284d909e8818db0$var$toEnum(7));
    return $4284d909e8818db0$var$fromJust($4284d909e8818db0$var$toEnum(n));
};
var $4284d909e8818db0$export$893a9e6d06ff9c67 = {
    show: function(v) {
        return "(Date " + ($4284d909e8818db0$var$show(v.value0) + (" " + ($4284d909e8818db0$var$show1(v.value1) + (" " + ($4284d909e8818db0$var$show2(v.value2) + ")")))));
    }
};
var $4284d909e8818db0$export$af5de1609f06c8e6 = function(v) {
    return v.value1;
};
var $4284d909e8818db0$export$553d7fa8e3805fc0 = function(y) {
    var y$prime = $4284d909e8818db0$var$fromEnum1(y);
    return $4284d909e8818db0$var$mod(y$prime)(4) === 0 && ($4284d909e8818db0$var$mod(y$prime)(400) === 0 || !($4284d909e8818db0$var$mod(y$prime)(100) === 0));
};
var $4284d909e8818db0$export$36818250d6c87922 = function(y) {
    return function(m) {
        var unsafeDay = function($154) {
            return $4284d909e8818db0$var$fromJust($4284d909e8818db0$var$toEnum1($154));
        };
        if (m instanceof $7db6d676966daa12$export$abbad8e042a8ca41) return unsafeDay(31);
        if (m instanceof $7db6d676966daa12$export$e047bba63374153d) {
            if ($4284d909e8818db0$export$553d7fa8e3805fc0(y)) return unsafeDay(29);
            if ($iQTlW.otherwise) return unsafeDay(28);
        }
        if (m instanceof $7db6d676966daa12$export$ed40a0eacb1c1a7d) return unsafeDay(31);
        if (m instanceof $7db6d676966daa12$export$b6e6de8185ac3568) return unsafeDay(30);
        if (m instanceof $7db6d676966daa12$export$50f4a85d6a193e43) return unsafeDay(31);
        if (m instanceof $7db6d676966daa12$export$ce3b81704c71b930) return unsafeDay(30);
        if (m instanceof $7db6d676966daa12$export$c35bbee8dc2d7f43) return unsafeDay(31);
        if (m instanceof $7db6d676966daa12$export$2646d2f8aef985a3) return unsafeDay(31);
        if (m instanceof $7db6d676966daa12$export$e18cdb270c0e647a) return unsafeDay(30);
        if (m instanceof $7db6d676966daa12$export$af81d92e3606877a) return unsafeDay(31);
        if (m instanceof $7db6d676966daa12$export$f440124e379d2b2) return unsafeDay(30);
        if (m instanceof $7db6d676966daa12$export$2d0bdb7c83ff083d) return unsafeDay(31);
        throw new Error("Failed pattern match at Data.Date (line 127, column 22 - line 141, column 27): " + [
            m.constructor.name
        ]);
    };
};
var $4284d909e8818db0$export$4eced57d6183c43d = {
    eq: function(x) {
        return function(y) {
            return $4284d909e8818db0$var$eq1(x.value0)(y.value0) && $4284d909e8818db0$var$eq2(x.value1)(y.value1) && $4284d909e8818db0$var$eq3(x.value2)(y.value2);
        };
    }
};
var $4284d909e8818db0$var$eq4 = /* #__PURE__ */ $aJhEx.eq($4284d909e8818db0$export$4eced57d6183c43d);
var $4284d909e8818db0$export$722593c82468f9f4 = {
    compare: function(x) {
        return function(y) {
            var v = $4284d909e8818db0$var$compare(x.value0)(y.value0);
            if (v instanceof $ibsD5.LT) return $ibsD5.LT.value;
            if (v instanceof $ibsD5.GT) return $ibsD5.GT.value;
            var v1 = $4284d909e8818db0$var$compare1(x.value1)(y.value1);
            if (v1 instanceof $ibsD5.LT) return $ibsD5.LT.value;
            if (v1 instanceof $ibsD5.GT) return $ibsD5.GT.value;
            return $4284d909e8818db0$var$compare2(x.value2)(y.value2);
        };
    },
    Eq0: function() {
        return $4284d909e8818db0$export$4eced57d6183c43d;
    }
};
var $4284d909e8818db0$export$72e9e4e3053b6c59 = {
    succ: function(v) {
        var sm = $4284d909e8818db0$var$succ(v.value1);
        var l = $4284d909e8818db0$export$36818250d6c87922(v.value0)(v.value1);
        var sd = function() {
            var v1 = $4284d909e8818db0$var$succ1(v.value2);
            var $118 = $4284d909e8818db0$var$greaterThan(v1)(new $h2xUu.Just(l));
            if ($118) return $h2xUu.Nothing.value;
            return v1;
        }();
        var m$prime = function() {
            var $119 = $h2xUu.isNothing(sd);
            if ($119) return $h2xUu.fromMaybe($7db6d676966daa12$export$abbad8e042a8ca41.value)(sm);
            return v.value1;
        }();
        var y$prime = function() {
            var $120 = $h2xUu.isNothing(sd) && $h2xUu.isNothing(sm);
            if ($120) return $4284d909e8818db0$var$succ2(v.value0);
            return new $h2xUu.Just(v.value0);
        }();
        var d$prime = function() {
            var $121 = $h2xUu.isNothing(sd);
            if ($121) return $4284d909e8818db0$var$toEnum1(1);
            return sd;
        }();
        return $4284d909e8818db0$var$apply($4284d909e8818db0$var$apply($4284d909e8818db0$var$map($4284d909e8818db0$var$$$Date.create)(y$prime))($4284d909e8818db0$var$pure(m$prime)))(d$prime);
    },
    pred: function(v) {
        var pm = $4284d909e8818db0$var$pred(v.value1);
        var pd = $4284d909e8818db0$var$pred1(v.value2);
        var y$prime = function() {
            var $126 = $h2xUu.isNothing(pd) && $h2xUu.isNothing(pm);
            if ($126) return $4284d909e8818db0$var$pred2(v.value0);
            return new $h2xUu.Just(v.value0);
        }();
        var m$prime = function() {
            var $127 = $h2xUu.isNothing(pd);
            if ($127) return $h2xUu.fromMaybe($7db6d676966daa12$export$2d0bdb7c83ff083d.value)(pm);
            return v.value1;
        }();
        var l = $4284d909e8818db0$export$36818250d6c87922(v.value0)(m$prime);
        var d$prime = function() {
            var $128 = $h2xUu.isNothing(pd);
            if ($128) return new $h2xUu.Just(l);
            return pd;
        }();
        return $4284d909e8818db0$var$apply($4284d909e8818db0$var$apply($4284d909e8818db0$var$map($4284d909e8818db0$var$$$Date.create)(y$prime))($4284d909e8818db0$var$pure(m$prime)))(d$prime);
    },
    Ord0: function() {
        return $4284d909e8818db0$export$722593c82468f9f4;
    }
};
var $4284d909e8818db0$var$pred3 = /* #__PURE__ */ $dIXGo.pred($4284d909e8818db0$export$72e9e4e3053b6c59);
var $4284d909e8818db0$var$succ3 = /* #__PURE__ */ $dIXGo.succ($4284d909e8818db0$export$72e9e4e3053b6c59);
var $4284d909e8818db0$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $1de5dd48369d2a6b$export$9eabacebe6624782(dictDuration);
    return function(v) {
        return function(v1) {
            return toDuration($6d6288a80dab3db3$export$345f31f1ea862984(v.value0, $4284d909e8818db0$var$fromEnum(v.value1), v.value2, v1.value0, $4284d909e8818db0$var$fromEnum(v1.value1), v1.value2));
        };
    };
};
var $4284d909e8818db0$export$d2d39d1adcc883a2 = function(v) {
    return v.value2;
};
var $4284d909e8818db0$export$e352e11a7fa73bba = function(y) {
    return function(m) {
        return function(d) {
            var mkDate = function(y$prime) {
                return function(m$prime) {
                    return function(d$prime) {
                        return new $4284d909e8818db0$var$$$Date(y$prime, $4284d909e8818db0$var$fromJust($4284d909e8818db0$var$toEnum2(m$prime)), d$prime);
                    };
                };
            };
            return $6d6288a80dab3db3$export$278f2462bca80341(mkDate, y, $4284d909e8818db0$var$fromEnum(m), d);
        };
    };
};
var $4284d909e8818db0$export$4803c954abcb09a = function(y) {
    return function(m) {
        return function(d) {
            var dt = new $4284d909e8818db0$var$$$Date(y, m, d);
            var $144 = $4284d909e8818db0$var$eq4($4284d909e8818db0$export$e352e11a7fa73bba(y)(m)(d))(dt);
            if ($144) return new $h2xUu.Just(dt);
            return $h2xUu.Nothing.value;
        };
    };
};
var $4284d909e8818db0$export$590ef5e04dc36aa5 = /* #__PURE__ */ function() {
    return {
        bottom: new $4284d909e8818db0$var$$$Date($8zsOy.bottom($7db6d676966daa12$export$bcd3d7e0476c0ec3), $8zsOy.bottom($7db6d676966daa12$export$ab1d1b39e9a2bfeb), $8zsOy.bottom($7db6d676966daa12$export$337e475a74d6aff0)),
        top: new $4284d909e8818db0$var$$$Date($8zsOy.top($7db6d676966daa12$export$bcd3d7e0476c0ec3), $8zsOy.top($7db6d676966daa12$export$ab1d1b39e9a2bfeb), $8zsOy.top($7db6d676966daa12$export$337e475a74d6aff0)),
        Ord0: function() {
            return $4284d909e8818db0$export$722593c82468f9f4;
        }
    };
}();
var $4284d909e8818db0$export$2c0e788bcc82013 = function(v) {
    return function(date) {
        var adj = function(v1) {
            return function(v2) {
                if (v1 === 0) return new $h2xUu.Just(v2);
                var j = v1 + $4284d909e8818db0$var$fromEnum2(v2.value2) | 0;
                var low = j < 1;
                var l = $4284d909e8818db0$export$36818250d6c87922(v2.value0)(function() {
                    if (low) return $h2xUu.fromMaybe($7db6d676966daa12$export$2d0bdb7c83ff083d.value)($4284d909e8818db0$var$pred(v2.value1));
                    return v2.value1;
                }());
                var hi = j > $4284d909e8818db0$var$fromEnum2(l);
                var i$prime = function() {
                    if (low) return j;
                    if (hi) return (j - $4284d909e8818db0$var$fromEnum2(l) | 0) - 1 | 0;
                    if ($iQTlW.otherwise) return 0;
                    throw new Error("Failed pattern match at Data.Date (line 101, column 9 - line 103, column 28): ");
                }();
                var dt$prime = function() {
                    if (low) return $4284d909e8818db0$var$bindFlipped($4284d909e8818db0$var$pred3)($4284d909e8818db0$var$map($4284d909e8818db0$var$$$Date.create(v2.value0)(v2.value1))($4284d909e8818db0$var$toEnum1(1)));
                    if (hi) return $4284d909e8818db0$var$succ3(new $4284d909e8818db0$var$$$Date(v2.value0, v2.value1, l));
                    if ($iQTlW.otherwise) return $4284d909e8818db0$var$map($4284d909e8818db0$var$$$Date.create(v2.value0)(v2.value1))($4284d909e8818db0$var$toEnum1(j));
                    throw new Error("Failed pattern match at Data.Date (line 104, column 9 - line 106, column 48): ");
                }();
                return $4284d909e8818db0$var$bindFlipped(adj(i$prime))(dt$prime);
            };
        };
        return $4284d909e8818db0$var$bind($hCjGZ.fromNumber(v))($jhsiw.flip(adj)(date));
    };
};




var $dIXGo = parcelRequire("dIXGo");

var $aJhEx = parcelRequire("aJhEx");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $2XxiF = parcelRequire("2XxiF");
// Generated by purs version 0.15.16

var $26ZCq = parcelRequire("26ZCq");

var $8zsOy = parcelRequire("8zsOy");

var $dIXGo = parcelRequire("dIXGo");

var $aJhEx = parcelRequire("aJhEx");

var $7FzSN = parcelRequire("7FzSN");

var $hCjGZ = parcelRequire("hCjGZ");

var $h2xUu = parcelRequire("h2xUu");

var $46y1S = parcelRequire("46y1S");

var $kBxBi = parcelRequire("kBxBi");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");
// Generated by purs version 0.15.16

var $iQTlW = parcelRequire("iQTlW");

var $dIXGo = parcelRequire("dIXGo");

var $aJhEx = parcelRequire("aJhEx");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $2XxiF = parcelRequire("2XxiF");
var $3bee0c7cd04e615a$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $3bee0c7cd04e615a$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showInt);
var $3bee0c7cd04e615a$var$Second = function(x) {
    return x;
};
var $3bee0c7cd04e615a$var$Minute = function(x) {
    return x;
};
var $3bee0c7cd04e615a$var$Millisecond = function(x) {
    return x;
};
var $3bee0c7cd04e615a$var$Hour = function(x) {
    return x;
};
var $3bee0c7cd04e615a$export$ded5f90a35c30d2e = {
    show: function(v) {
        return "(Second " + ($3bee0c7cd04e615a$var$show(v) + ")");
    }
};
var $3bee0c7cd04e615a$export$59c06e2004fc98a4 = {
    show: function(v) {
        return "(Minute " + ($3bee0c7cd04e615a$var$show(v) + ")");
    }
};
var $3bee0c7cd04e615a$export$5bcc2f09c21d8c42 = {
    show: function(v) {
        return "(Millisecond " + ($3bee0c7cd04e615a$var$show(v) + ")");
    }
};
var $3bee0c7cd04e615a$export$737acbed1f5b7f59 = {
    show: function(v) {
        return "(Hour " + ($3bee0c7cd04e615a$var$show(v) + ")");
    }
};
var $3bee0c7cd04e615a$export$cda9505f3bbd31a6 = $gwBF5.ordInt;
var $3bee0c7cd04e615a$export$cbed256bda88f39a = $gwBF5.ordInt;
var $3bee0c7cd04e615a$export$6e4c39aa0b4b11bf = $gwBF5.ordInt;
var $3bee0c7cd04e615a$export$9ae204e537c07a49 = $gwBF5.ordInt;
var $3bee0c7cd04e615a$export$1d37a2519784e654 = $aJhEx.eqInt;
var $3bee0c7cd04e615a$export$17f5c7433e4de947 = $aJhEx.eqInt;
var $3bee0c7cd04e615a$export$10d6cfb0f5850aca = $aJhEx.eqInt;
var $3bee0c7cd04e615a$export$a2181cffc8c78aa4 = $aJhEx.eqInt;
var $3bee0c7cd04e615a$export$14f9cc6a73419a24 = {
    bottom: 0,
    top: 59,
    Ord0: function() {
        return $3bee0c7cd04e615a$export$cda9505f3bbd31a6;
    }
};
var $3bee0c7cd04e615a$export$2e9ad76d003e68e6 = {
    bottom: 0,
    top: 59,
    Ord0: function() {
        return $3bee0c7cd04e615a$export$cbed256bda88f39a;
    }
};
var $3bee0c7cd04e615a$export$1bc1fc48769dfdc5 = {
    bottom: 0,
    top: 999,
    Ord0: function() {
        return $3bee0c7cd04e615a$export$6e4c39aa0b4b11bf;
    }
};
var $3bee0c7cd04e615a$export$a07dd689fd52f43a = {
    bottom: 0,
    top: 23,
    Ord0: function() {
        return $3bee0c7cd04e615a$export$9ae204e537c07a49;
    }
};
var $3bee0c7cd04e615a$export$c9467b6184dd9c81 = {
    cardinality: 60,
    toEnum: function(n) {
        if (n >= 0 && n <= 59) return new $h2xUu.Just(n);
        if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 90, column 1 - line 95, column 26): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $3bee0c7cd04e615a$export$14f9cc6a73419a24;
    },
    Enum1: function() {
        return $3bee0c7cd04e615a$var$$lazy_enumSecond(0);
    }
};
var $3bee0c7cd04e615a$var$$lazy_enumSecond = /* #__PURE__ */ $3bee0c7cd04e615a$var$$runtime_lazy("enumSecond", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $36 = $dIXGo.toEnum($3bee0c7cd04e615a$export$c9467b6184dd9c81);
            var $37 = $dIXGo.fromEnum($3bee0c7cd04e615a$export$c9467b6184dd9c81);
            return function($38) {
                return $36(function(v) {
                    return v + 1 | 0;
                }($37($38)));
            };
        }(),
        pred: function() {
            var $39 = $dIXGo.toEnum($3bee0c7cd04e615a$export$c9467b6184dd9c81);
            var $40 = $dIXGo.fromEnum($3bee0c7cd04e615a$export$c9467b6184dd9c81);
            return function($41) {
                return $39(function(v) {
                    return v - 1 | 0;
                }($40($41)));
            };
        }(),
        Ord0: function() {
            return $3bee0c7cd04e615a$export$cda9505f3bbd31a6;
        }
    };
});
var $3bee0c7cd04e615a$export$a7beee32098a9d39 = /* #__PURE__ */ $3bee0c7cd04e615a$var$$lazy_enumSecond(86);
var $3bee0c7cd04e615a$export$d4e91fe4c2aba62a = {
    cardinality: 60,
    toEnum: function(n) {
        if (n >= 0 && n <= 59) return new $h2xUu.Just(n);
        if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 61, column 1 - line 66, column 26): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $3bee0c7cd04e615a$export$2e9ad76d003e68e6;
    },
    Enum1: function() {
        return $3bee0c7cd04e615a$var$$lazy_enumMinute(0);
    }
};
var $3bee0c7cd04e615a$var$$lazy_enumMinute = /* #__PURE__ */ $3bee0c7cd04e615a$var$$runtime_lazy("enumMinute", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $42 = $dIXGo.toEnum($3bee0c7cd04e615a$export$d4e91fe4c2aba62a);
            var $43 = $dIXGo.fromEnum($3bee0c7cd04e615a$export$d4e91fe4c2aba62a);
            return function($44) {
                return $42(function(v) {
                    return v + 1 | 0;
                }($43($44)));
            };
        }(),
        pred: function() {
            var $45 = $dIXGo.toEnum($3bee0c7cd04e615a$export$d4e91fe4c2aba62a);
            var $46 = $dIXGo.fromEnum($3bee0c7cd04e615a$export$d4e91fe4c2aba62a);
            return function($47) {
                return $45(function(v) {
                    return v - 1 | 0;
                }($46($47)));
            };
        }(),
        Ord0: function() {
            return $3bee0c7cd04e615a$export$cbed256bda88f39a;
        }
    };
});
var $3bee0c7cd04e615a$export$997c451dd6e71518 = /* #__PURE__ */ $3bee0c7cd04e615a$var$$lazy_enumMinute(57);
var $3bee0c7cd04e615a$export$4789fa20e673c035 = {
    cardinality: 1000,
    toEnum: function(n) {
        if (n >= 0 && n <= 999) return new $h2xUu.Just(n);
        if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 120, column 1 - line 125, column 31): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $3bee0c7cd04e615a$export$1bc1fc48769dfdc5;
    },
    Enum1: function() {
        return $3bee0c7cd04e615a$var$$lazy_enumMillisecond(0);
    }
};
var $3bee0c7cd04e615a$var$$lazy_enumMillisecond = /* #__PURE__ */ $3bee0c7cd04e615a$var$$runtime_lazy("enumMillisecond", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $48 = $dIXGo.toEnum($3bee0c7cd04e615a$export$4789fa20e673c035);
            var $49 = $dIXGo.fromEnum($3bee0c7cd04e615a$export$4789fa20e673c035);
            return function($50) {
                return $48(function(v) {
                    return v + 1 | 0;
                }($49($50)));
            };
        }(),
        pred: function() {
            var $51 = $dIXGo.toEnum($3bee0c7cd04e615a$export$4789fa20e673c035);
            var $52 = $dIXGo.fromEnum($3bee0c7cd04e615a$export$4789fa20e673c035);
            return function($53) {
                return $51(function(v) {
                    return v - 1 | 0;
                }($52($53)));
            };
        }(),
        Ord0: function() {
            return $3bee0c7cd04e615a$export$6e4c39aa0b4b11bf;
        }
    };
});
var $3bee0c7cd04e615a$export$f76f413973d04ccc = /* #__PURE__ */ $3bee0c7cd04e615a$var$$lazy_enumMillisecond(116);
var $3bee0c7cd04e615a$export$3e668e9da55710cb = {
    cardinality: 24,
    toEnum: function(n) {
        if (n >= 0 && n <= 23) return new $h2xUu.Just(n);
        if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 32, column 1 - line 37, column 24): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $3bee0c7cd04e615a$export$a07dd689fd52f43a;
    },
    Enum1: function() {
        return $3bee0c7cd04e615a$var$$lazy_enumHour(0);
    }
};
var $3bee0c7cd04e615a$var$$lazy_enumHour = /* #__PURE__ */ $3bee0c7cd04e615a$var$$runtime_lazy("enumHour", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $54 = $dIXGo.toEnum($3bee0c7cd04e615a$export$3e668e9da55710cb);
            var $55 = $dIXGo.fromEnum($3bee0c7cd04e615a$export$3e668e9da55710cb);
            return function($56) {
                return $54(function(v) {
                    return v + 1 | 0;
                }($55($56)));
            };
        }(),
        pred: function() {
            var $57 = $dIXGo.toEnum($3bee0c7cd04e615a$export$3e668e9da55710cb);
            var $58 = $dIXGo.fromEnum($3bee0c7cd04e615a$export$3e668e9da55710cb);
            return function($59) {
                return $57(function(v) {
                    return v - 1 | 0;
                }($58($59)));
            };
        }(),
        Ord0: function() {
            return $3bee0c7cd04e615a$export$9ae204e537c07a49;
        }
    };
});
var $3bee0c7cd04e615a$export$dac2f6c805cf929f = /* #__PURE__ */ $3bee0c7cd04e615a$var$$lazy_enumHour(28);




var $7O0Q4 = parcelRequire("7O0Q4");
var $b6cb56993f075571$var$show = /* #__PURE__ */ $2XxiF.show($3bee0c7cd04e615a$export$737acbed1f5b7f59);
var $b6cb56993f075571$var$show1 = /* #__PURE__ */ $2XxiF.show($3bee0c7cd04e615a$export$59c06e2004fc98a4);
var $b6cb56993f075571$var$show2 = /* #__PURE__ */ $2XxiF.show($3bee0c7cd04e615a$export$ded5f90a35c30d2e);
var $b6cb56993f075571$var$show3 = /* #__PURE__ */ $2XxiF.show($3bee0c7cd04e615a$export$5bcc2f09c21d8c42);
var $b6cb56993f075571$var$fromJust = /* #__PURE__ */ $h2xUu.fromJust();
var $b6cb56993f075571$var$apply = /* #__PURE__ */ $26ZCq.apply($h2xUu.applyMaybe);
var $b6cb56993f075571$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $b6cb56993f075571$var$toEnum = /* #__PURE__ */ $dIXGo.toEnum($3bee0c7cd04e615a$export$3e668e9da55710cb);
var $b6cb56993f075571$var$toEnum1 = /* #__PURE__ */ $dIXGo.toEnum($3bee0c7cd04e615a$export$d4e91fe4c2aba62a);
var $b6cb56993f075571$var$toEnum2 = /* #__PURE__ */ $dIXGo.toEnum($3bee0c7cd04e615a$export$c9467b6184dd9c81);
var $b6cb56993f075571$var$toEnum3 = /* #__PURE__ */ $dIXGo.toEnum($3bee0c7cd04e615a$export$4789fa20e673c035);
var $b6cb56993f075571$var$fromEnum = /* #__PURE__ */ $dIXGo.fromEnum($3bee0c7cd04e615a$export$3e668e9da55710cb);
var $b6cb56993f075571$var$fromEnum1 = /* #__PURE__ */ $dIXGo.fromEnum($3bee0c7cd04e615a$export$d4e91fe4c2aba62a);
var $b6cb56993f075571$var$fromEnum2 = /* #__PURE__ */ $dIXGo.fromEnum($3bee0c7cd04e615a$export$c9467b6184dd9c81);
var $b6cb56993f075571$var$fromEnum3 = /* #__PURE__ */ $dIXGo.fromEnum($3bee0c7cd04e615a$export$4789fa20e673c035);
var $b6cb56993f075571$var$eq = /* #__PURE__ */ $aJhEx.eq($3bee0c7cd04e615a$export$a2181cffc8c78aa4);
var $b6cb56993f075571$var$eq1 = /* #__PURE__ */ $aJhEx.eq($3bee0c7cd04e615a$export$17f5c7433e4de947);
var $b6cb56993f075571$var$eq2 = /* #__PURE__ */ $aJhEx.eq($3bee0c7cd04e615a$export$1d37a2519784e654);
var $b6cb56993f075571$var$eq3 = /* #__PURE__ */ $aJhEx.eq($3bee0c7cd04e615a$export$10d6cfb0f5850aca);
var $b6cb56993f075571$var$compare = /* #__PURE__ */ $gwBF5.compare($3bee0c7cd04e615a$export$9ae204e537c07a49);
var $b6cb56993f075571$var$compare1 = /* #__PURE__ */ $gwBF5.compare($3bee0c7cd04e615a$export$cbed256bda88f39a);
var $b6cb56993f075571$var$compare2 = /* #__PURE__ */ $gwBF5.compare($3bee0c7cd04e615a$export$cda9505f3bbd31a6);
var $b6cb56993f075571$var$compare3 = /* #__PURE__ */ $gwBF5.compare($3bee0c7cd04e615a$export$6e4c39aa0b4b11bf);
var $b6cb56993f075571$var$append1 = /* #__PURE__ */ $d5vvq.append($1de5dd48369d2a6b$export$def67087bd72fdb7);
var $b6cb56993f075571$var$negateDuration = /* #__PURE__ */ $1de5dd48369d2a6b$export$28743521ea1cb8f9($1de5dd48369d2a6b$export$44304cbc75c995e8);
var $b6cb56993f075571$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $b6cb56993f075571$var$fromDuration = /* #__PURE__ */ $1de5dd48369d2a6b$export$1a0a2c8fdf902748($1de5dd48369d2a6b$export$93ad8ffd4576e464);
var $b6cb56993f075571$var$greaterThan = /* #__PURE__ */ $gwBF5.greaterThan($1de5dd48369d2a6b$export$e0a5c04af6395341);
var $b6cb56993f075571$var$lessThan = /* #__PURE__ */ $gwBF5.lessThan($1de5dd48369d2a6b$export$e0a5c04af6395341);
var $b6cb56993f075571$var$append2 = /* #__PURE__ */ $d5vvq.append($1de5dd48369d2a6b$export$e8bb798e27d1673b);
var $b6cb56993f075571$export$680ea196effce5f = /* #__PURE__ */ function() {
    function Time(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Time.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Time(value0, value1, value2, value3);
                };
            };
        };
    };
    return Time;
}();
var $b6cb56993f075571$export$a8b500dc61192962 = {
    show: function(v) {
        return "(Time " + ($b6cb56993f075571$var$show(v.value0) + (" " + ($b6cb56993f075571$var$show1(v.value1) + (" " + ($b6cb56993f075571$var$show2(v.value2) + (" " + ($b6cb56993f075571$var$show3(v.value3) + ")")))))));
    }
};
var $b6cb56993f075571$export$6d7f956f1942326e = function(s) {
    return function(v) {
        return new $b6cb56993f075571$export$680ea196effce5f(v.value0, v.value1, s, v.value3);
    };
};
var $b6cb56993f075571$export$9488e8f97d913fb3 = function(m) {
    return function(v) {
        return new $b6cb56993f075571$export$680ea196effce5f(v.value0, m, v.value2, v.value3);
    };
};
var $b6cb56993f075571$export$694994bc4ee8aa99 = function(ms) {
    return function(v) {
        return new $b6cb56993f075571$export$680ea196effce5f(v.value0, v.value1, v.value2, ms);
    };
};
var $b6cb56993f075571$export$73c2a04c9ce973a8 = function(h) {
    return function(v) {
        return new $b6cb56993f075571$export$680ea196effce5f(h, v.value1, v.value2, v.value3);
    };
};
var $b6cb56993f075571$export$3d3c77ce7df7d30d = function(v) {
    return v.value2;
};
var $b6cb56993f075571$export$1cacba1045a8e790 = function(v) {
    return v.value1;
};
var $b6cb56993f075571$export$edc5e5cb87280477 = function(v) {
    return v.value3;
};
var $b6cb56993f075571$var$millisToTime = function(v) {
    var hours = $kBxBi.floor(v / 3600000.0);
    var minutes = $kBxBi.floor((v - hours * 3600000.0) / 60000.0);
    var seconds = $kBxBi.floor((v - (hours * 3600000.0 + minutes * 60000.0)) / 1000.0);
    var milliseconds = v - (hours * 3600000.0 + minutes * 60000.0 + seconds * 1000.0);
    return $b6cb56993f075571$var$fromJust($b6cb56993f075571$var$apply($b6cb56993f075571$var$apply($b6cb56993f075571$var$apply($b6cb56993f075571$var$map($b6cb56993f075571$export$680ea196effce5f.create)($b6cb56993f075571$var$toEnum($hCjGZ.floor(hours))))($b6cb56993f075571$var$toEnum1($hCjGZ.floor(minutes))))($b6cb56993f075571$var$toEnum2($hCjGZ.floor(seconds))))($b6cb56993f075571$var$toEnum3($hCjGZ.floor(milliseconds))));
};
var $b6cb56993f075571$export$842e383dfc19bc67 = function(v) {
    return v.value0;
};
var $b6cb56993f075571$var$timeToMillis = function(t) {
    return 3600000.0 * $hCjGZ.toNumber($b6cb56993f075571$var$fromEnum($b6cb56993f075571$export$842e383dfc19bc67(t))) + 60000.0 * $hCjGZ.toNumber($b6cb56993f075571$var$fromEnum1($b6cb56993f075571$export$1cacba1045a8e790(t))) + 1000.0 * $hCjGZ.toNumber($b6cb56993f075571$var$fromEnum2($b6cb56993f075571$export$3d3c77ce7df7d30d(t))) + $hCjGZ.toNumber($b6cb56993f075571$var$fromEnum3($b6cb56993f075571$export$edc5e5cb87280477(t)));
};
var $b6cb56993f075571$export$9fe01c5d451d5493 = {
    eq: function(x) {
        return function(y) {
            return $b6cb56993f075571$var$eq(x.value0)(y.value0) && $b6cb56993f075571$var$eq1(x.value1)(y.value1) && $b6cb56993f075571$var$eq2(x.value2)(y.value2) && $b6cb56993f075571$var$eq3(x.value3)(y.value3);
        };
    }
};
var $b6cb56993f075571$export$153601f213258a17 = {
    compare: function(x) {
        return function(y) {
            var v = $b6cb56993f075571$var$compare(x.value0)(y.value0);
            if (v instanceof $ibsD5.LT) return $ibsD5.LT.value;
            if (v instanceof $ibsD5.GT) return $ibsD5.GT.value;
            var v1 = $b6cb56993f075571$var$compare1(x.value1)(y.value1);
            if (v1 instanceof $ibsD5.LT) return $ibsD5.LT.value;
            if (v1 instanceof $ibsD5.GT) return $ibsD5.GT.value;
            var v2 = $b6cb56993f075571$var$compare2(x.value2)(y.value2);
            if (v2 instanceof $ibsD5.LT) return $ibsD5.LT.value;
            if (v2 instanceof $ibsD5.GT) return $ibsD5.GT.value;
            return $b6cb56993f075571$var$compare3(x.value3)(y.value3);
        };
    },
    Eq0: function() {
        return $b6cb56993f075571$export$9fe01c5d451d5493;
    }
};
var $b6cb56993f075571$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $1de5dd48369d2a6b$export$9eabacebe6624782(dictDuration);
    return function(t1) {
        return function(t2) {
            return toDuration($b6cb56993f075571$var$append1($b6cb56993f075571$var$timeToMillis(t1))($b6cb56993f075571$var$negateDuration($b6cb56993f075571$var$timeToMillis(t2))));
        };
    };
};
var $b6cb56993f075571$export$70fbaefa75d69ccd = /* #__PURE__ */ function() {
    return {
        bottom: new $b6cb56993f075571$export$680ea196effce5f($8zsOy.bottom($3bee0c7cd04e615a$export$a07dd689fd52f43a), $8zsOy.bottom($3bee0c7cd04e615a$export$2e9ad76d003e68e6), $8zsOy.bottom($3bee0c7cd04e615a$export$14f9cc6a73419a24), $8zsOy.bottom($3bee0c7cd04e615a$export$1bc1fc48769dfdc5)),
        top: new $b6cb56993f075571$export$680ea196effce5f($8zsOy.top($3bee0c7cd04e615a$export$a07dd689fd52f43a), $8zsOy.top($3bee0c7cd04e615a$export$2e9ad76d003e68e6), $8zsOy.top($3bee0c7cd04e615a$export$14f9cc6a73419a24), $8zsOy.top($3bee0c7cd04e615a$export$1bc1fc48769dfdc5)),
        Ord0: function() {
            return $b6cb56993f075571$export$153601f213258a17;
        }
    };
}();
var $b6cb56993f075571$var$maxTime = /* #__PURE__ */ $b6cb56993f075571$var$timeToMillis(/* #__PURE__ */ $8zsOy.top($b6cb56993f075571$export$70fbaefa75d69ccd));
var $b6cb56993f075571$var$minTime = /* #__PURE__ */ $b6cb56993f075571$var$timeToMillis(/* #__PURE__ */ $8zsOy.bottom($b6cb56993f075571$export$70fbaefa75d69ccd));
var $b6cb56993f075571$export$2c0e788bcc82013 = function(dictDuration) {
    var fromDuration1 = $1de5dd48369d2a6b$export$1a0a2c8fdf902748(dictDuration);
    return function(d) {
        return function(t) {
            var tLength = $b6cb56993f075571$var$timeToMillis(t);
            var d$prime = fromDuration1(d);
            var wholeDays = $kBxBi.floor($b6cb56993f075571$var$unwrap(d$prime) / 8.64e7);
            var msAdjust = $b6cb56993f075571$var$append1(d$prime)($b6cb56993f075571$var$negateDuration($b6cb56993f075571$var$fromDuration(wholeDays)));
            var msAdjusted = $b6cb56993f075571$var$append1(tLength)(msAdjust);
            var wrap = function() {
                var $157 = $b6cb56993f075571$var$greaterThan(msAdjusted)($b6cb56993f075571$var$maxTime);
                if ($157) return 1.0;
                var $158 = $b6cb56993f075571$var$lessThan(msAdjusted)($b6cb56993f075571$var$minTime);
                if ($158) return -1;
                return 0.0;
            }();
            return new $7O0Q4.Tuple($b6cb56993f075571$var$append2(wholeDays)(wrap), $b6cb56993f075571$var$millisToTime($b6cb56993f075571$var$append1(msAdjusted)(8.64e7 * -wrap)));
        };
    };
};




var $3043ecd2e3978a63$var$fromEnum = /* #__PURE__ */ $dIXGo.fromEnum($7db6d676966daa12$export$2391dde84a7e2cbd);
var $3043ecd2e3978a63$var$fromEnum1 = /* #__PURE__ */ $dIXGo.fromEnum($7db6d676966daa12$export$e744bc4044126e99);
var $3043ecd2e3978a63$var$fromEnum2 = /* #__PURE__ */ $dIXGo.fromEnum($7db6d676966daa12$export$2f59e9c675f625db);
var $3043ecd2e3978a63$var$fromEnum3 = /* #__PURE__ */ $dIXGo.fromEnum($3bee0c7cd04e615a$export$3e668e9da55710cb);
var $3043ecd2e3978a63$var$fromEnum4 = /* #__PURE__ */ $dIXGo.fromEnum($3bee0c7cd04e615a$export$d4e91fe4c2aba62a);
var $3043ecd2e3978a63$var$fromEnum5 = /* #__PURE__ */ $dIXGo.fromEnum($3bee0c7cd04e615a$export$c9467b6184dd9c81);
var $3043ecd2e3978a63$var$fromEnum6 = /* #__PURE__ */ $dIXGo.fromEnum($3bee0c7cd04e615a$export$4789fa20e673c035);
var $3043ecd2e3978a63$var$show = /* #__PURE__ */ $2XxiF.show($4284d909e8818db0$export$893a9e6d06ff9c67);
var $3043ecd2e3978a63$var$show1 = /* #__PURE__ */ $2XxiF.show($b6cb56993f075571$export$a8b500dc61192962);
var $3043ecd2e3978a63$var$eq = /* #__PURE__ */ $aJhEx.eq($4284d909e8818db0$export$4eced57d6183c43d);
var $3043ecd2e3978a63$var$eq1 = /* #__PURE__ */ $aJhEx.eq($b6cb56993f075571$export$9fe01c5d451d5493);
var $3043ecd2e3978a63$var$compare = /* #__PURE__ */ $gwBF5.compare($4284d909e8818db0$export$722593c82468f9f4);
var $3043ecd2e3978a63$var$compare1 = /* #__PURE__ */ $gwBF5.compare($b6cb56993f075571$export$153601f213258a17);
var $3043ecd2e3978a63$var$bind = /* #__PURE__ */ $cADnC.bind($h2xUu.bindMaybe);
var $3043ecd2e3978a63$var$apply = /* #__PURE__ */ $26ZCq.apply($h2xUu.applyMaybe);
var $3043ecd2e3978a63$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $3043ecd2e3978a63$var$join = /* #__PURE__ */ $cADnC.join($h2xUu.bindMaybe);
var $3043ecd2e3978a63$var$toEnum = /* #__PURE__ */ $dIXGo.toEnum($7db6d676966daa12$export$2391dde84a7e2cbd);
var $3043ecd2e3978a63$var$toEnum1 = /* #__PURE__ */ $dIXGo.toEnum($7db6d676966daa12$export$e744bc4044126e99);
var $3043ecd2e3978a63$var$toEnum2 = /* #__PURE__ */ $dIXGo.toEnum($7db6d676966daa12$export$2f59e9c675f625db);
var $3043ecd2e3978a63$var$toEnum3 = /* #__PURE__ */ $dIXGo.toEnum($3bee0c7cd04e615a$export$3e668e9da55710cb);
var $3043ecd2e3978a63$var$toEnum4 = /* #__PURE__ */ $dIXGo.toEnum($3bee0c7cd04e615a$export$d4e91fe4c2aba62a);
var $3043ecd2e3978a63$var$toEnum5 = /* #__PURE__ */ $dIXGo.toEnum($3bee0c7cd04e615a$export$c9467b6184dd9c81);
var $3043ecd2e3978a63$var$toEnum6 = /* #__PURE__ */ $dIXGo.toEnum($3bee0c7cd04e615a$export$4789fa20e673c035);
var $3043ecd2e3978a63$export$82f9ebd9adeba146 = /* #__PURE__ */ function() {
    function DateTime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DateTime.create = function(value0) {
        return function(value1) {
            return new DateTime(value0, value1);
        };
    };
    return DateTime;
}();
var $3043ecd2e3978a63$var$toRecord = function(v) {
    return {
        year: $3043ecd2e3978a63$var$fromEnum($4284d909e8818db0$export$31803937850fb2da(v.value0)),
        month: $3043ecd2e3978a63$var$fromEnum1($4284d909e8818db0$export$af5de1609f06c8e6(v.value0)),
        day: $3043ecd2e3978a63$var$fromEnum2($4284d909e8818db0$export$d2d39d1adcc883a2(v.value0)),
        hour: $3043ecd2e3978a63$var$fromEnum3($b6cb56993f075571$export$842e383dfc19bc67(v.value1)),
        minute: $3043ecd2e3978a63$var$fromEnum4($b6cb56993f075571$export$1cacba1045a8e790(v.value1)),
        second: $3043ecd2e3978a63$var$fromEnum5($b6cb56993f075571$export$3d3c77ce7df7d30d(v.value1)),
        millisecond: $3043ecd2e3978a63$var$fromEnum6($b6cb56993f075571$export$edc5e5cb87280477(v.value1))
    };
};
var $3043ecd2e3978a63$export$2da9be4cfdb689b1 = function(v) {
    return v.value1;
};
var $3043ecd2e3978a63$export$a1af12e21b57795a = {
    show: function(v) {
        return "(DateTime " + ($3043ecd2e3978a63$var$show(v.value0) + (" " + ($3043ecd2e3978a63$var$show1(v.value1) + ")")));
    }
};
var $3043ecd2e3978a63$export$1c14df74454c0d0b = function(dictFunctor) {
    var map1 = $7FzSN.map(dictFunctor);
    return function(f) {
        return function(v) {
            return map1($3043ecd2e3978a63$export$82f9ebd9adeba146.create(v.value0))(f(v.value1));
        };
    };
};
var $3043ecd2e3978a63$export$26fd29b5462b0349 = function(f) {
    return function(v) {
        return new $3043ecd2e3978a63$export$82f9ebd9adeba146(v.value0, f(v.value1));
    };
};
var $3043ecd2e3978a63$export$715dbfedef2473ff = function(dictFunctor) {
    var map1 = $7FzSN.map(dictFunctor);
    return function(f) {
        return function(v) {
            return map1($jhsiw.flip($3043ecd2e3978a63$export$82f9ebd9adeba146.create)(v.value1))(f(v.value0));
        };
    };
};
var $3043ecd2e3978a63$export$fd4b8ebd80749cf = function(f) {
    return function(v) {
        return new $3043ecd2e3978a63$export$82f9ebd9adeba146(f(v.value0), v.value1);
    };
};
var $3043ecd2e3978a63$export$a99463abb2339a45 = {
    eq: function(x) {
        return function(y) {
            return $3043ecd2e3978a63$var$eq(x.value0)(y.value0) && $3043ecd2e3978a63$var$eq1(x.value1)(y.value1);
        };
    }
};
var $3043ecd2e3978a63$export$e2fa58ffd7b3a1ab = {
    compare: function(x) {
        return function(y) {
            var v = $3043ecd2e3978a63$var$compare(x.value0)(y.value0);
            if (v instanceof $ibsD5.LT) return $ibsD5.LT.value;
            if (v instanceof $ibsD5.GT) return $ibsD5.GT.value;
            return $3043ecd2e3978a63$var$compare1(x.value1)(y.value1);
        };
    },
    Eq0: function() {
        return $3043ecd2e3978a63$export$a99463abb2339a45;
    }
};
var $3043ecd2e3978a63$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $1de5dd48369d2a6b$export$9eabacebe6624782(dictDuration);
    return function(dt1) {
        return function(dt2) {
            return toDuration($6e55caeb87d1882f$export$345f31f1ea862984($3043ecd2e3978a63$var$toRecord(dt1), $3043ecd2e3978a63$var$toRecord(dt2)));
        };
    };
};
var $3043ecd2e3978a63$export$324d90190a8b822a = function(v) {
    return v.value0;
};
var $3043ecd2e3978a63$export$d0805f5a2dd21c64 = /* #__PURE__ */ function() {
    return {
        bottom: new $3043ecd2e3978a63$export$82f9ebd9adeba146($8zsOy.bottom($4284d909e8818db0$export$590ef5e04dc36aa5), $8zsOy.bottom($b6cb56993f075571$export$70fbaefa75d69ccd)),
        top: new $3043ecd2e3978a63$export$82f9ebd9adeba146($8zsOy.top($4284d909e8818db0$export$590ef5e04dc36aa5), $8zsOy.top($b6cb56993f075571$export$70fbaefa75d69ccd)),
        Ord0: function() {
            return $3043ecd2e3978a63$export$e2fa58ffd7b3a1ab;
        }
    };
}();
var $3043ecd2e3978a63$export$2c0e788bcc82013 = function(dictDuration) {
    var fromDuration = $1de5dd48369d2a6b$export$1a0a2c8fdf902748(dictDuration);
    return function(d) {
        return function(dt) {
            return $3043ecd2e3978a63$var$bind($6e55caeb87d1882f$export$e01c022ccf7c1b57($h2xUu.Just.create)($h2xUu.Nothing.value)(fromDuration(d))($3043ecd2e3978a63$var$toRecord(dt)))(function(rec) {
                return $3043ecd2e3978a63$var$apply($3043ecd2e3978a63$var$map($3043ecd2e3978a63$export$82f9ebd9adeba146.create)($3043ecd2e3978a63$var$join($3043ecd2e3978a63$var$apply($3043ecd2e3978a63$var$apply($3043ecd2e3978a63$var$map($4284d909e8818db0$export$4803c954abcb09a)($3043ecd2e3978a63$var$toEnum(rec.year)))($3043ecd2e3978a63$var$toEnum1(rec.month)))($3043ecd2e3978a63$var$toEnum2(rec.day)))))($3043ecd2e3978a63$var$apply($3043ecd2e3978a63$var$apply($3043ecd2e3978a63$var$apply($3043ecd2e3978a63$var$map($b6cb56993f075571$export$680ea196effce5f.create)($3043ecd2e3978a63$var$toEnum3(rec.hour)))($3043ecd2e3978a63$var$toEnum4(rec.minute)))($3043ecd2e3978a63$var$toEnum5(rec.second)))($3043ecd2e3978a63$var$toEnum6(rec.millisecond)));
            });
        };
    };
};


// Generated by purs version 0.15.16
var $76bf1852d0bb1a96$var$createDateTime = function(y, m, d, h, mi, s, ms) {
    var dateTime = new Date(Date.UTC(y, m, d, h, mi, s, ms));
    if (y >= 0 && y < 100) dateTime.setUTCFullYear(y);
    return dateTime;
};
function $76bf1852d0bb1a96$export$4ceb5c6f8416b1d0(y, mo, d, h, mi, s, ms) {
    return $76bf1852d0bb1a96$var$createDateTime(y, mo - 1, d, h, mi, s, ms).getTime();
}
function $76bf1852d0bb1a96$export$e7e4adb27c12afea(ctor) {
    return function(instant) {
        var dt = new Date(instant);
        return ctor(dt.getUTCFullYear())(dt.getUTCMonth() + 1)(dt.getUTCDate())(dt.getUTCHours())(dt.getUTCMinutes())(dt.getUTCSeconds())(dt.getUTCMilliseconds());
    };
}



var $iQTlW = parcelRequire("iQTlW");

var $8zsOy = parcelRequire("8zsOy");




var $dIXGo = parcelRequire("dIXGo");

var $h2xUu = parcelRequire("h2xUu");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");



var $1ca97124a62e2e75$var$fromJust = /* #__PURE__ */ $h2xUu.fromJust();
var $1ca97124a62e2e75$var$toEnum = /* #__PURE__ */ $dIXGo.toEnum($7db6d676966daa12$export$e744bc4044126e99);
var $1ca97124a62e2e75$var$show = /* #__PURE__ */ $2XxiF.show($1de5dd48369d2a6b$export$1d3b9b5391a72ae7);
var $1ca97124a62e2e75$var$fromEnum = /* #__PURE__ */ $dIXGo.fromEnum($7db6d676966daa12$export$e744bc4044126e99);
var $1ca97124a62e2e75$var$bottom = /* #__PURE__ */ $8zsOy.bottom($3bee0c7cd04e615a$export$a07dd689fd52f43a);
var $1ca97124a62e2e75$var$bottom1 = /* #__PURE__ */ $8zsOy.bottom($3bee0c7cd04e615a$export$2e9ad76d003e68e6);
var $1ca97124a62e2e75$var$bottom2 = /* #__PURE__ */ $8zsOy.bottom($3bee0c7cd04e615a$export$14f9cc6a73419a24);
var $1ca97124a62e2e75$var$bottom3 = /* #__PURE__ */ $8zsOy.bottom($3bee0c7cd04e615a$export$1bc1fc48769dfdc5);
var $1ca97124a62e2e75$var$append1 = /* #__PURE__ */ $d5vvq.append($1de5dd48369d2a6b$export$def67087bd72fdb7);
var $1ca97124a62e2e75$var$negateDuration = /* #__PURE__ */ $1de5dd48369d2a6b$export$28743521ea1cb8f9($1de5dd48369d2a6b$export$44304cbc75c995e8);
var $1ca97124a62e2e75$var$Instant = function(x) {
    return x;
};
var $1ca97124a62e2e75$export$d09033f410e6cbd8 = function(v) {
    return v;
};
var $1ca97124a62e2e75$export$c2dea5c02f48568d = /* #__PURE__ */ function() {
    var mkDateTime = function(y) {
        return function(mo) {
            return function(d) {
                return function(h) {
                    return function(mi) {
                        return function(s) {
                            return function(ms) {
                                return new $3043ecd2e3978a63$export$82f9ebd9adeba146($4284d909e8818db0$export$e352e11a7fa73bba(y)($1ca97124a62e2e75$var$fromJust($1ca97124a62e2e75$var$toEnum(mo)))(d), new $b6cb56993f075571$export$680ea196effce5f(h, mi, s, ms));
                            };
                        };
                    };
                };
            };
        };
    };
    return $76bf1852d0bb1a96$export$e7e4adb27c12afea(mkDateTime);
}();
var $1ca97124a62e2e75$export$84fb2716d05f64f3 = {
    show: function(v) {
        return "(Instant " + ($1ca97124a62e2e75$var$show(v) + ")");
    }
};
var $1ca97124a62e2e75$export$e2fa58ffd7b3a1ab = $1de5dd48369d2a6b$export$e0a5c04af6395341;
var $1ca97124a62e2e75$export$6e4cd7a6d73ce13e = function(v) {
    if (v >= -8639977881600000 && v <= 8.639977881599999e15) return new $h2xUu.Just(v);
    if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
    throw new Error("Failed pattern match at Data.DateTime.Instant (line 44, column 1 - line 44, column 41): " + [
        v.constructor.name
    ]);
};
var $1ca97124a62e2e75$export$e141e740b7704cc4 = function(v) {
    return $76bf1852d0bb1a96$export$4ceb5c6f8416b1d0($4284d909e8818db0$export$31803937850fb2da(v.value0), $1ca97124a62e2e75$var$fromEnum($4284d909e8818db0$export$af5de1609f06c8e6(v.value0)), $4284d909e8818db0$export$d2d39d1adcc883a2(v.value0), $b6cb56993f075571$export$842e383dfc19bc67(v.value1), $b6cb56993f075571$export$1cacba1045a8e790(v.value1), $b6cb56993f075571$export$3d3c77ce7df7d30d(v.value1), $b6cb56993f075571$export$edc5e5cb87280477(v.value1));
};
var $1ca97124a62e2e75$export$e57ff100d91bd4b9 = function(d) {
    return $76bf1852d0bb1a96$export$4ceb5c6f8416b1d0($4284d909e8818db0$export$31803937850fb2da(d), $1ca97124a62e2e75$var$fromEnum($4284d909e8818db0$export$af5de1609f06c8e6(d)), $4284d909e8818db0$export$d2d39d1adcc883a2(d), $1ca97124a62e2e75$var$bottom, $1ca97124a62e2e75$var$bottom1, $1ca97124a62e2e75$var$bottom2, $1ca97124a62e2e75$var$bottom3);
};
var $1ca97124a62e2e75$export$a99463abb2339a45 = $1de5dd48369d2a6b$export$699cb56941ecf990;
var $1ca97124a62e2e75$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $1de5dd48369d2a6b$export$9eabacebe6624782(dictDuration);
    return function(dt1) {
        return function(dt2) {
            return toDuration($1ca97124a62e2e75$var$append1($1ca97124a62e2e75$export$d09033f410e6cbd8(dt1))($1ca97124a62e2e75$var$negateDuration($1ca97124a62e2e75$export$d09033f410e6cbd8(dt2))));
        };
    };
};
var $1ca97124a62e2e75$export$af36687d2b3e6466 = /* #__PURE__ */ function() {
    return {
        bottom: -8639977881600000,
        top: 8.639977881599999e15,
        Ord0: function() {
            return $1ca97124a62e2e75$export$e2fa58ffd7b3a1ab;
        }
    };
}();



var $beQI1 = parcelRequire("beQI1");

var $dIXGo = parcelRequire("dIXGo");

var $aJhEx = parcelRequire("aJhEx");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");

var $4Fu8m = parcelRequire("4Fu8m");

var $d8ahy = parcelRequire("d8ahy");


var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");
// Generated by purs version 0.15.16
/* globals setImmediate, clearImmediate, setTimeout, clearTimeout */ /* eslint-disable no-unused-vars, no-prototype-builtins, no-use-before-define, no-unused-labels, no-param-reassign */ var $c88db571692c73b3$var$Aff = function() {
    // A unique value for empty.
    var EMPTY = {};
    /*

  An awkward approximation. We elide evidence we would otherwise need in PS for
  efficiency sake.

  data Aff eff a
    = Pure a
    | Throw Error
    | Catch (Aff eff a) (Error -> Aff eff a)
    | Sync (Eff eff a)
    | Async ((Either Error a -> Eff eff Unit) -> Eff eff (Canceler eff))
    | forall b. Bind (Aff eff b) (b -> Aff eff a)
    | forall b. Bracket (Aff eff b) (BracketConditions eff b) (b -> Aff eff a)
    | forall b. Fork Boolean (Aff eff b) ?(Fiber eff b -> a)
    | Sequential (ParAff aff a)

  */ var PURE = "Pure";
    var THROW = "Throw";
    var CATCH = "Catch";
    var SYNC = "Sync";
    var ASYNC = "Async";
    var BIND = "Bind";
    var BRACKET = "Bracket";
    var FORK = "Fork";
    var SEQ = "Sequential";
    /*

  data ParAff eff a
    = forall b. Map (b -> a) (ParAff eff b)
    | forall b. Apply (ParAff eff (b -> a)) (ParAff eff b)
    | Alt (ParAff eff a) (ParAff eff a)
    | ?Par (Aff eff a)

  */ var MAP = "Map";
    var APPLY = "Apply";
    var ALT = "Alt";
    // Various constructors used in interpretation
    var CONS = "Cons"; // Cons-list, for stacks
    var RESUME = "Resume"; // Continue indiscriminately
    var RELEASE = "Release"; // Continue with bracket finalizers
    var FINALIZER = "Finalizer"; // A non-interruptible effect
    var FINALIZED = "Finalized"; // Marker for finalization
    var FORKED = "Forked"; // Reference to a forked fiber, with resumption stack
    var FIBER = "Fiber"; // Actual fiber reference
    var THUNK = "Thunk"; // Primed effect, ready to invoke
    function Aff(tag, _1, _2, _3) {
        this.tag = tag;
        this._1 = _1;
        this._2 = _2;
        this._3 = _3;
    }
    function AffCtr(tag) {
        var fn = function(_1, _2, _3) {
            return new Aff(tag, _1, _2, _3);
        };
        fn.tag = tag;
        return fn;
    }
    function nonCanceler(error) {
        return new Aff(PURE, void 0);
    }
    function runEff(eff) {
        try {
            eff();
        } catch (error) {
            setTimeout(function() {
                throw error;
            }, 0);
        }
    }
    function runSync(left, right, eff) {
        try {
            return right(eff());
        } catch (error) {
            return left(error);
        }
    }
    function runAsync(left, eff, k) {
        try {
            return eff(k)();
        } catch (error) {
            k(left(error))();
            return nonCanceler;
        }
    }
    var Scheduler = function() {
        var limit = 1024;
        var size = 0;
        var ix = 0;
        var queue = new Array(limit);
        var draining = false;
        function drain() {
            var thunk;
            draining = true;
            while(size !== 0){
                size--;
                thunk = queue[ix];
                queue[ix] = void 0;
                ix = (ix + 1) % limit;
                thunk();
            }
            draining = false;
        }
        return {
            isDraining: function() {
                return draining;
            },
            enqueue: function(cb) {
                var i, tmp;
                if (size === limit) {
                    tmp = draining;
                    drain();
                    draining = tmp;
                }
                queue[(ix + size) % limit] = cb;
                size++;
                if (!draining) drain();
            }
        };
    }();
    function Supervisor(util) {
        var fibers = {};
        var fiberId = 0;
        var count = 0;
        return {
            register: function(fiber) {
                var fid = fiberId++;
                fiber.onComplete({
                    rethrow: true,
                    handler: function(result) {
                        return function() {
                            count--;
                            delete fibers[fid];
                        };
                    }
                })();
                fibers[fid] = fiber;
                count++;
            },
            isEmpty: function() {
                return count === 0;
            },
            killAll: function(killError, cb) {
                return function() {
                    if (count === 0) return cb();
                    var killCount = 0;
                    var kills = {};
                    function kill(fid) {
                        kills[fid] = fibers[fid].kill(killError, function(result) {
                            return function() {
                                delete kills[fid];
                                killCount--;
                                if (util.isLeft(result) && util.fromLeft(result)) setTimeout(function() {
                                    throw util.fromLeft(result);
                                }, 0);
                                if (killCount === 0) cb();
                            };
                        })();
                    }
                    for(var k in fibers)if (fibers.hasOwnProperty(k)) {
                        killCount++;
                        kill(k);
                    }
                    fibers = {};
                    fiberId = 0;
                    count = 0;
                    return function(error) {
                        return new Aff(SYNC, function() {
                            for(var k in kills)if (kills.hasOwnProperty(k)) kills[k]();
                        });
                    };
                };
            }
        };
    }
    // Fiber state machine
    var SUSPENDED = 0; // Suspended, pending a join.
    var CONTINUE = 1; // Interpret the next instruction.
    var STEP_BIND = 2; // Apply the next bind.
    var STEP_RESULT = 3; // Handle potential failure from a result.
    var PENDING = 4; // An async effect is running.
    var RETURN = 5; // The current stack has returned.
    var COMPLETED = 6; // The entire fiber has completed.
    function Fiber(util, supervisor, aff) {
        // Monotonically increasing tick, increased on each asynchronous turn.
        var runTick = 0;
        // The current branch of the state machine.
        var status = SUSPENDED;
        // The current point of interest for the state machine branch.
        var step = aff; // Successful step
        var fail = null; // Failure step
        var interrupt = null; // Asynchronous interrupt
        // Stack of continuations for the current fiber.
        var bhead = null;
        var btail = null;
        // Stack of attempts and finalizers for error recovery. Every `Cons` is also
        // tagged with current `interrupt` state. We use this to track which items
        // should be ignored or evaluated as a result of a kill.
        var attempts = null;
        // A special state is needed for Bracket, because it cannot be killed. When
        // we enter a bracket acquisition or finalizer, we increment the counter,
        // and then decrement once complete.
        var bracketCount = 0;
        // Each join gets a new id so they can be revoked.
        var joinId = 0;
        var joins = null;
        var rethrow = true;
        // Each invocation of `run` requires a tick. When an asynchronous effect is
        // resolved, we must check that the local tick coincides with the fiber
        // tick before resuming. This prevents multiple async continuations from
        // accidentally resuming the same fiber. A common example may be invoking
        // the provided callback in `makeAff` more than once, but it may also be an
        // async effect resuming after the fiber was already cancelled.
        function run(localRunTick) {
            var tmp, result, attempt;
            while(true){
                tmp = null;
                result = null;
                attempt = null;
                switch(status){
                    case STEP_BIND:
                        status = CONTINUE;
                        try {
                            step = bhead(step);
                            if (btail === null) bhead = null;
                            else {
                                bhead = btail._1;
                                btail = btail._2;
                            }
                        } catch (e) {
                            status = RETURN;
                            fail = util.left(e);
                            step = null;
                        }
                        break;
                    case STEP_RESULT:
                        if (util.isLeft(step)) {
                            status = RETURN;
                            fail = step;
                            step = null;
                        } else if (bhead === null) status = RETURN;
                        else {
                            status = STEP_BIND;
                            step = util.fromRight(step);
                        }
                        break;
                    case CONTINUE:
                        switch(step.tag){
                            case BIND:
                                if (bhead) btail = new Aff(CONS, bhead, btail);
                                bhead = step._2;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case PURE:
                                if (bhead === null) {
                                    status = RETURN;
                                    step = util.right(step._1);
                                } else {
                                    status = STEP_BIND;
                                    step = step._1;
                                }
                                break;
                            case SYNC:
                                status = STEP_RESULT;
                                step = runSync(util.left, util.right, step._1);
                                break;
                            case ASYNC:
                                status = PENDING;
                                step = runAsync(util.left, step._1, function(result) {
                                    return function() {
                                        if (runTick !== localRunTick) return;
                                        runTick++;
                                        Scheduler.enqueue(function() {
                                            // It's possible to interrupt the fiber between enqueuing and
                                            // resuming, so we need to check that the runTick is still
                                            // valid.
                                            if (runTick !== localRunTick + 1) return;
                                            status = STEP_RESULT;
                                            step = result;
                                            run(runTick);
                                        });
                                    };
                                });
                                return;
                            case THROW:
                                status = RETURN;
                                fail = util.left(step._1);
                                step = null;
                                break;
                            // Enqueue the Catch so that we can call the error handler later on
                            // in case of an exception.
                            case CATCH:
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            // Enqueue the Bracket so that we can call the appropriate handlers
                            // after resource acquisition.
                            case BRACKET:
                                bracketCount++;
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case FORK:
                                status = STEP_RESULT;
                                tmp = Fiber(util, supervisor, step._2);
                                if (supervisor) supervisor.register(tmp);
                                if (step._1) tmp.run();
                                step = util.right(tmp);
                                break;
                            case SEQ:
                                status = CONTINUE;
                                step = sequential(util, supervisor, step._1);
                                break;
                        }
                        break;
                    case RETURN:
                        bhead = null;
                        btail = null;
                        // If the current stack has returned, and we have no other stacks to
                        // resume or finalizers to run, the fiber has halted and we can
                        // invoke all join callbacks. Otherwise we need to resume.
                        if (attempts === null) {
                            status = COMPLETED;
                            step = interrupt || fail || step;
                        } else {
                            // The interrupt status for the enqueued item.
                            tmp = attempts._3;
                            attempt = attempts._1;
                            attempts = attempts._2;
                            switch(attempt.tag){
                                // We cannot recover from an unmasked interrupt. Otherwise we should
                                // continue stepping, or run the exception handler if an exception
                                // was raised.
                                case CATCH:
                                    // We should compare the interrupt status as well because we
                                    // only want it to apply if there has been an interrupt since
                                    // enqueuing the catch.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) status = RETURN;
                                    else if (fail) {
                                        status = CONTINUE;
                                        step = attempt._2(util.fromLeft(fail));
                                        fail = null;
                                    }
                                    break;
                                // We cannot resume from an unmasked interrupt or exception.
                                case RESUME:
                                    // As with Catch, we only want to ignore in the case of an
                                    // interrupt since enqueing the item.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0 || fail) status = RETURN;
                                    else {
                                        bhead = attempt._1;
                                        btail = attempt._2;
                                        status = STEP_BIND;
                                        step = util.fromRight(step);
                                    }
                                    break;
                                // If we have a bracket, we should enqueue the handlers,
                                // and continue with the success branch only if the fiber has
                                // not been interrupted. If the bracket acquisition failed, we
                                // should not run either.
                                case BRACKET:
                                    bracketCount--;
                                    if (fail === null) {
                                        result = util.fromRight(step);
                                        // We need to enqueue the Release with the same interrupt
                                        // status as the Bracket that is initiating it.
                                        attempts = new Aff(CONS, new Aff(RELEASE, attempt._2, result), attempts, tmp);
                                        // We should only coninue as long as the interrupt status has not changed or
                                        // we are currently within a non-interruptable finalizer.
                                        if (interrupt === tmp || bracketCount > 0) {
                                            status = CONTINUE;
                                            step = attempt._3(result);
                                        }
                                    }
                                    break;
                                // Enqueue the appropriate handler. We increase the bracket count
                                // because it should not be cancelled.
                                case RELEASE:
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    // It has only been killed if the interrupt status has changed
                                    // since we enqueued the item, and the bracket count is 0. If the
                                    // bracket count is non-zero then we are in a masked state so it's
                                    // impossible to be killed.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) step = attempt._1.killed(util.fromLeft(interrupt))(attempt._2);
                                    else if (fail) step = attempt._1.failed(util.fromLeft(fail))(attempt._2);
                                    else step = attempt._1.completed(util.fromRight(step))(attempt._2);
                                    fail = null;
                                    bracketCount++;
                                    break;
                                case FINALIZER:
                                    bracketCount++;
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    step = attempt._1;
                                    break;
                                case FINALIZED:
                                    bracketCount--;
                                    status = RETURN;
                                    step = attempt._1;
                                    fail = attempt._2;
                                    break;
                            }
                        }
                        break;
                    case COMPLETED:
                        for(var k in joins)if (joins.hasOwnProperty(k)) {
                            rethrow = rethrow && joins[k].rethrow;
                            runEff(joins[k].handler(step));
                        }
                        joins = null;
                        // If we have an interrupt and a fail, then the thread threw while
                        // running finalizers. This should always rethrow in a fresh stack.
                        if (interrupt && fail) setTimeout(function() {
                            throw util.fromLeft(fail);
                        }, 0);
                        else if (util.isLeft(step) && rethrow) setTimeout(function() {
                            // Guard on reathrow because a completely synchronous fiber can
                            // still have an observer which was added after-the-fact.
                            if (rethrow) throw util.fromLeft(step);
                        }, 0);
                        return;
                    case SUSPENDED:
                        status = CONTINUE;
                        break;
                    case PENDING:
                        return;
                }
            }
        }
        function onComplete(join) {
            return function() {
                if (status === COMPLETED) {
                    rethrow = rethrow && join.rethrow;
                    join.handler(step)();
                    return function() {};
                }
                var jid = joinId++;
                joins = joins || {};
                joins[jid] = join;
                return function() {
                    if (joins !== null) delete joins[jid];
                };
            };
        }
        function kill(error, cb) {
            return function() {
                if (status === COMPLETED) {
                    cb(util.right(void 0))();
                    return function() {};
                }
                var canceler = onComplete({
                    rethrow: false,
                    handler: function() {
                        return cb(util.right(void 0));
                    }
                })();
                switch(status){
                    case SUSPENDED:
                        interrupt = util.left(error);
                        status = COMPLETED;
                        step = interrupt;
                        run(runTick);
                        break;
                    case PENDING:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            if (status === PENDING) attempts = new Aff(CONS, new Aff(FINALIZER, step(error)), attempts, interrupt);
                            status = RETURN;
                            step = null;
                            fail = null;
                            run(++runTick);
                        }
                        break;
                    default:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            status = RETURN;
                            step = null;
                            fail = null;
                        }
                }
                return canceler;
            };
        }
        function join(cb) {
            return function() {
                var canceler = onComplete({
                    rethrow: false,
                    handler: cb
                })();
                if (status === SUSPENDED) run(runTick);
                return canceler;
            };
        }
        return {
            kill: kill,
            join: join,
            onComplete: onComplete,
            isSuspended: function() {
                return status === SUSPENDED;
            },
            run: function() {
                if (status === SUSPENDED) {
                    if (!Scheduler.isDraining()) Scheduler.enqueue(function() {
                        run(runTick);
                    });
                    else run(runTick);
                }
            }
        };
    }
    function runPar(util, supervisor, par, cb) {
        // Table of all forked fibers.
        var fiberId = 0;
        var fibers = {};
        // Table of currently running cancelers, as a product of `Alt` behavior.
        var killId = 0;
        var kills = {};
        // Error used for early cancelation on Alt branches.
        var early = new Error("[ParAff] Early exit");
        // Error used to kill the entire tree.
        var interrupt = null;
        // The root pointer of the tree.
        var root = EMPTY;
        // Walks a tree, invoking all the cancelers. Returns the table of pending
        // cancellation fibers.
        function kill(error, par, cb) {
            var step = par;
            var head = null;
            var tail = null;
            var count = 0;
            var kills = {};
            var tmp, kid;
            loop: while(true){
                tmp = null;
                switch(step.tag){
                    case FORKED:
                        if (step._3 === EMPTY) {
                            tmp = fibers[step._1];
                            kills[count++] = tmp.kill(error, function(result) {
                                return function() {
                                    count--;
                                    if (count === 0) cb(result)();
                                };
                            });
                        }
                        // Terminal case.
                        if (head === null) break loop;
                        // Go down the right side of the tree.
                        step = head._2;
                        if (tail === null) head = null;
                        else {
                            head = tail._1;
                            tail = tail._2;
                        }
                        break;
                    case MAP:
                        step = step._2;
                        break;
                    case APPLY:
                    case ALT:
                        if (head) tail = new Aff(CONS, head, tail);
                        head = step;
                        step = step._1;
                        break;
                }
            }
            if (count === 0) cb(util.right(void 0))();
            else {
                // Run the cancelation effects. We alias `count` because it's mutable.
                kid = 0;
                tmp = count;
                for(; kid < tmp; kid++)kills[kid] = kills[kid]();
            }
            return kills;
        }
        // When a fiber resolves, we need to bubble back up the tree with the
        // result, computing the applicative nodes.
        function join(result, head, tail) {
            var fail, step, lhs, rhs, tmp, kid;
            if (util.isLeft(result)) {
                fail = result;
                step = null;
            } else {
                step = result;
                fail = null;
            }
            loop: while(true){
                lhs = null;
                rhs = null;
                tmp = null;
                kid = null;
                // We should never continue if the entire tree has been interrupted.
                if (interrupt !== null) return;
                // We've made it all the way to the root of the tree, which means
                // the tree has fully evaluated.
                if (head === null) {
                    cb(fail || step)();
                    return;
                }
                // The tree has already been computed, so we shouldn't try to do it
                // again. This should never happen.
                // TODO: Remove this?
                if (head._3 !== EMPTY) return;
                switch(head.tag){
                    case MAP:
                        if (fail === null) {
                            head._3 = util.right(head._1(util.fromRight(step)));
                            step = head._3;
                        } else head._3 = fail;
                        break;
                    case APPLY:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // If we have a failure we should kill the other side because we
                        // can't possible yield a result anymore.
                        if (fail) {
                            head._3 = fail;
                            tmp = true;
                            kid = killId++;
                            kills[kid] = kill(early, fail === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(fail, null, null);
                                    else join(fail, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        } else if (lhs === EMPTY || rhs === EMPTY) // We can only proceed if both sides have resolved.
                        return;
                        else {
                            step = util.right(util.fromRight(lhs)(util.fromRight(rhs)));
                            head._3 = step;
                        }
                        break;
                    case ALT:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // We can only proceed if both have resolved or we have a success
                        if (lhs === EMPTY && util.isLeft(rhs) || rhs === EMPTY && util.isLeft(lhs)) return;
                        // If both sides resolve with an error, we should continue with the
                        // first error
                        if (lhs !== EMPTY && util.isLeft(lhs) && rhs !== EMPTY && util.isLeft(rhs)) {
                            fail = step === lhs ? rhs : lhs;
                            step = null;
                            head._3 = fail;
                        } else {
                            head._3 = step;
                            tmp = true;
                            kid = killId++;
                            // Once a side has resolved, we need to cancel the side that is still
                            // pending before we can continue.
                            kills[kid] = kill(early, step === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(step, null, null);
                                    else join(step, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        }
                        break;
                }
                if (tail === null) head = null;
                else {
                    head = tail._1;
                    tail = tail._2;
                }
            }
        }
        function resolve(fiber) {
            return function(result) {
                return function() {
                    delete fibers[fiber._1];
                    fiber._3 = result;
                    join(result, fiber._2._1, fiber._2._2);
                };
            };
        }
        // Walks the applicative tree, substituting non-applicative nodes with
        // `FORKED` nodes. In this tree, all applicative nodes use the `_3` slot
        // as a mutable slot for memoization. In an unresolved state, the `_3`
        // slot is `EMPTY`. In the cases of `ALT` and `APPLY`, we always walk
        // the left side first, because both operations are left-associative. As
        // we `RETURN` from those branches, we then walk the right side.
        function run() {
            var status = CONTINUE;
            var step = par;
            var head = null;
            var tail = null;
            var tmp, fid;
            loop: while(true){
                tmp = null;
                fid = null;
                switch(status){
                    case CONTINUE:
                        switch(step.tag){
                            case MAP:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(MAP, step._1, EMPTY, EMPTY);
                                step = step._2;
                                break;
                            case APPLY:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(APPLY, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            case ALT:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(ALT, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            default:
                                // When we hit a leaf value, we suspend the stack in the `FORKED`.
                                // When the fiber resolves, it can bubble back up the tree.
                                fid = fiberId++;
                                status = RETURN;
                                tmp = step;
                                step = new Aff(FORKED, fid, new Aff(CONS, head, tail), EMPTY);
                                tmp = Fiber(util, supervisor, tmp);
                                tmp.onComplete({
                                    rethrow: false,
                                    handler: resolve(step)
                                })();
                                fibers[fid] = tmp;
                                if (supervisor) supervisor.register(tmp);
                        }
                        break;
                    case RETURN:
                        // Terminal case, we are back at the root.
                        if (head === null) break loop;
                        // If we are done with the right side, we need to continue down the
                        // left. Otherwise we should continue up the stack.
                        if (head._1 === EMPTY) {
                            head._1 = step;
                            status = CONTINUE;
                            step = head._2;
                            head._2 = EMPTY;
                        } else {
                            head._2 = step;
                            step = head;
                            if (tail === null) head = null;
                            else {
                                head = tail._1;
                                tail = tail._2;
                            }
                        }
                }
            }
            // Keep a reference to the tree root so it can be cancelled.
            root = step;
            for(fid = 0; fid < fiberId; fid++)fibers[fid].run();
        }
        // Cancels the entire tree. If there are already subtrees being canceled,
        // we need to first cancel those joins. We will then add fresh joins for
        // all pending branches including those that were in the process of being
        // canceled.
        function cancel(error, cb) {
            interrupt = util.left(error);
            var innerKills;
            for(var kid in kills)if (kills.hasOwnProperty(kid)) {
                innerKills = kills[kid];
                for(kid in innerKills)if (innerKills.hasOwnProperty(kid)) innerKills[kid]();
            }
            kills = null;
            var newKills = kill(error, root, cb);
            return function(killError) {
                return new Aff(ASYNC, function(killCb) {
                    return function() {
                        for(var kid in newKills)if (newKills.hasOwnProperty(kid)) newKills[kid]();
                        return nonCanceler;
                    };
                });
            };
        }
        run();
        return function(killError) {
            return new Aff(ASYNC, function(killCb) {
                return function() {
                    return cancel(killError, killCb);
                };
            });
        };
    }
    function sequential(util, supervisor, par) {
        return new Aff(ASYNC, function(cb) {
            return function() {
                return runPar(util, supervisor, par, cb);
            };
        });
    }
    Aff.EMPTY = EMPTY;
    Aff.Pure = AffCtr(PURE);
    Aff.Throw = AffCtr(THROW);
    Aff.Catch = AffCtr(CATCH);
    Aff.Sync = AffCtr(SYNC);
    Aff.Async = AffCtr(ASYNC);
    Aff.Bind = AffCtr(BIND);
    Aff.Bracket = AffCtr(BRACKET);
    Aff.Fork = AffCtr(FORK);
    Aff.Seq = AffCtr(SEQ);
    Aff.ParMap = AffCtr(MAP);
    Aff.ParApply = AffCtr(APPLY);
    Aff.ParAlt = AffCtr(ALT);
    Aff.Fiber = Fiber;
    Aff.Supervisor = Supervisor;
    Aff.Scheduler = Scheduler;
    Aff.nonCanceler = nonCanceler;
    return Aff;
}();
const $c88db571692c73b3$export$68c6660df485915b = $c88db571692c73b3$var$Aff.Pure;
const $c88db571692c73b3$export$520252a01094c36e = $c88db571692c73b3$var$Aff.Throw;
function $c88db571692c73b3$export$eb5e86cd5464556e(aff) {
    return function(k) {
        return $c88db571692c73b3$var$Aff.Catch(aff, k);
    };
}
function $c88db571692c73b3$export$a0135aecf4a782ab(f) {
    return function(aff) {
        if (aff.tag === $c88db571692c73b3$var$Aff.Pure.tag) return $c88db571692c73b3$var$Aff.Pure(f(aff._1));
        else return $c88db571692c73b3$var$Aff.Bind(aff, function(value) {
            return $c88db571692c73b3$var$Aff.Pure(f(value));
        });
    };
}
function $c88db571692c73b3$export$8fe95d71d8c6b6f3(aff) {
    return function(k) {
        return $c88db571692c73b3$var$Aff.Bind(aff, k);
    };
}
function $c88db571692c73b3$export$f97e7884af471963(immediate) {
    return function(aff) {
        return $c88db571692c73b3$var$Aff.Fork(immediate, aff);
    };
}
const $c88db571692c73b3$export$3c6532f01a0290eb = $c88db571692c73b3$var$Aff.Sync;
function $c88db571692c73b3$export$68695d37eb163711(f) {
    return function(aff) {
        return $c88db571692c73b3$var$Aff.ParMap(f, aff);
    };
}
function $c88db571692c73b3$export$bce00526579b3344(aff1) {
    return function(aff2) {
        return $c88db571692c73b3$var$Aff.ParApply(aff1, aff2);
    };
}
function $c88db571692c73b3$export$6a44b66c7edadaa(aff1) {
    return function(aff2) {
        return $c88db571692c73b3$var$Aff.ParAlt(aff1, aff2);
    };
}
const $c88db571692c73b3$export$49d5975414e0a979 = $c88db571692c73b3$var$Aff.Async;
function $c88db571692c73b3$export$9ad792f02752f447(acquire) {
    return function(options) {
        return function(k) {
            return $c88db571692c73b3$var$Aff.Bracket(acquire, options, k);
        };
    };
}
function $c88db571692c73b3$export$f24188c8fd3f1234(util, aff) {
    return function() {
        return $c88db571692c73b3$var$Aff.Fiber(util, null, aff);
    };
}
function $c88db571692c73b3$export$7a3baea9562462c7(util, aff) {
    return function() {
        var supervisor = $c88db571692c73b3$var$Aff.Supervisor(util);
        return {
            fiber: $c88db571692c73b3$var$Aff.Fiber(util, supervisor, aff),
            supervisor: supervisor
        };
    };
}
function $c88db571692c73b3$export$a494cc11bfc0c750(error, supervisor, cb) {
    return supervisor.killAll(error, cb);
}
const $c88db571692c73b3$export$389c1406f5ae6ae7 = function() {
    function setDelay(n, k) {
        if (n === 0 && typeof setImmediate !== "undefined") return setImmediate(k);
        else return setTimeout(k, n);
    }
    function clearDelay(n, t) {
        if (n === 0 && typeof clearImmediate !== "undefined") return clearImmediate(t);
        else return clearTimeout(t);
    }
    return function(right, ms) {
        return $c88db571692c73b3$var$Aff.Async(function(cb) {
            return function() {
                var timer = setDelay(ms, cb(right()));
                return function() {
                    return $c88db571692c73b3$var$Aff.Sync(function() {
                        return right(clearDelay(ms, timer));
                    });
                };
            };
        });
    };
}();
const $c88db571692c73b3$export$139486a45824a247 = $c88db571692c73b3$var$Aff.Seq;



var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $kkdfo = parcelRequire("kkdfo");


var $bcJ05 = parcelRequire("bcJ05");
// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");
// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");
var $3890443dd4ac5537$export$2bf63e57346d9602 = $k2DSm.unsafeCoerce;



var $k1We4 = parcelRequire("k1We4");

var $1rTTn = parcelRequire("1rTTn");
var $c4342a0c2c1aab96$export$162690b6fa074d8b = {
    liftST: /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn),
    Monad0: function() {
        return $k1We4.monadST;
    }
};
var $c4342a0c2c1aab96$export$d1b56b21630310a5 = {
    liftST: $3890443dd4ac5537$export$2bf63e57346d9602,
    Monad0: function() {
        return $1rTTn.monadEffect;
    }
};
var $c4342a0c2c1aab96$export$90556654c9c47d5f = function(dict) {
    return dict.liftST;
};


// Generated by purs version 0.15.16

var $26ZCq = parcelRequire("26ZCq");

var $26SV5 = parcelRequire("26SV5");
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");
// Generated by purs version 0.15.16
var $45c1976f946e1989$export$bb801a161a3121f0 = function(dict) {
    return dict.callCC;
};


// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $kkdfo = parcelRequire("kkdfo");

var $gZ030 = parcelRequire("gZ030");

var $7FzSN = parcelRequire("7FzSN");
var $ce0fad135b75d1f6$export$97f42efbb325fef6 = {
    ask: /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn),
    Monad0: function() {
        return $kkdfo.monadFn;
    }
};
var $ce0fad135b75d1f6$export$487d42cd354774ee = {
    local: /* #__PURE__ */ $gZ030.composeFlipped($gZ030.semigroupoidFn),
    MonadAsk0: function() {
        return $ce0fad135b75d1f6$export$97f42efbb325fef6;
    }
};
var $ce0fad135b75d1f6$export$3bf5078b16209b91 = function(dict) {
    return dict.local;
};
var $ce0fad135b75d1f6$export$1b4aee0b51c3def8 = function(dict) {
    return dict.ask;
};
var $ce0fad135b75d1f6$export$5551e829c4b2a916 = function(dictMonadAsk) {
    var map = $7FzSN.map(dictMonadAsk.Monad0().Bind1().Apply0().Functor0());
    var ask1 = $ce0fad135b75d1f6$export$1b4aee0b51c3def8(dictMonadAsk);
    return function(f) {
        return map(f)(ask1);
    };
};



// Generated by purs version 0.15.16
var $0db1509836ffbf7e$export$590e8b2c435046d9 = function(dict) {
    return dict.lift;
};



var $jhsiw = parcelRequire("jhsiw");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");
// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $1rTTn = parcelRequire("1rTTn");
var $54d5aa8d31ad5798$export$86a2e24932ca2aa0 = {
    liftEffect: /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn),
    Monad0: function() {
        return $1rTTn.monadEffect;
    }
};
var $54d5aa8d31ad5798$export$34255e15eb56d2b3 = function(dict) {
    return dict.liftEffect;
};


var $145dc4a2d647cf5f$export$14010cd19909b6b = function(x) {
    return x;
};
var $145dc4a2d647cf5f$export$2a106bc5b2e64dce = function(f) {
    return function(v) {
        return function(k) {
            return v(f(k));
        };
    };
};
var $145dc4a2d647cf5f$export$358211fab263c66b = function(v) {
    return function(k) {
        return v(k);
    };
};
var $145dc4a2d647cf5f$export$5419b7e78c76e565 = {
    Coercible0: function() {
        return undefined;
    }
};
var $145dc4a2d647cf5f$export$6a2bb59a0c53ce17 = {
    lift: function(dictMonad) {
        var bind = $cADnC.bind(dictMonad.Bind1());
        return function(m) {
            return function(k) {
                return bind(m)(k);
            };
        };
    }
};
var $145dc4a2d647cf5f$var$lift = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($145dc4a2d647cf5f$export$6a2bb59a0c53ce17);
var $145dc4a2d647cf5f$export$604f139dbf56bccf = function(f) {
    return function(v) {
        return function(k) {
            return f(v(k));
        };
    };
};
var $145dc4a2d647cf5f$export$232156ef715cfc9b = function(dictFunctor) {
    return {
        map: function(f) {
            return function(v) {
                return function(k) {
                    return v(function(a) {
                        return k(f(a));
                    });
                };
            };
        }
    };
};
var $145dc4a2d647cf5f$export$6b05a2ec606a3559 = function(dictApply) {
    var functorContT1 = $145dc4a2d647cf5f$export$232156ef715cfc9b(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return v(function(g) {
                        return v1(function(a) {
                            return k(g(a));
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorContT1;
        }
    };
};
var $145dc4a2d647cf5f$export$91905d227b995e9d = function(dictBind) {
    var applyContT1 = $145dc4a2d647cf5f$export$6b05a2ec606a3559(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(k$prime) {
                    return v(function(a) {
                        var v1 = k(a);
                        return v1(k$prime);
                    });
                };
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $145dc4a2d647cf5f$export$ebd715a8b64afb39 = function(dictApply) {
    var lift2 = $26ZCq.lift2($145dc4a2d647cf5f$export$6b05a2ec606a3559(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($d5vvq.append(dictSemigroup))
        };
    };
};
var $145dc4a2d647cf5f$export$d73f0595e894296c = function(dictApplicative) {
    var applyContT1 = $145dc4a2d647cf5f$export$6b05a2ec606a3559(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(k) {
                return k(a);
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $145dc4a2d647cf5f$export$735f43b0215ad39 = function(dictMonad) {
    var applicativeContT1 = $145dc4a2d647cf5f$export$d73f0595e894296c(dictMonad.Applicative0());
    var bindContT1 = $145dc4a2d647cf5f$export$91905d227b995e9d(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeContT1;
        },
        Bind1: function() {
            return bindContT1;
        }
    };
};
var $145dc4a2d647cf5f$export$6062b41302ddcd80 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadContT1 = $145dc4a2d647cf5f$export$735f43b0215ad39(Monad0);
    return {
        ask: $145dc4a2d647cf5f$var$lift(Monad0)($ce0fad135b75d1f6$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $145dc4a2d647cf5f$export$dbf903f187194ce5 = function(dictMonadReader) {
    var MonadAsk0 = dictMonadReader.MonadAsk0();
    var bind = $cADnC.bind(MonadAsk0.Monad0().Bind1());
    var ask = $ce0fad135b75d1f6$export$1b4aee0b51c3def8(MonadAsk0);
    var local = $ce0fad135b75d1f6$export$3bf5078b16209b91(dictMonadReader);
    var monadAskContT1 = $145dc4a2d647cf5f$export$6062b41302ddcd80(MonadAsk0);
    return {
        local: function(f) {
            return function(v) {
                return function(k) {
                    return bind(ask)(function(r) {
                        return local(f)(v(function() {
                            var $88 = local($jhsiw.const(r));
                            return function($89) {
                                return $88(k($89));
                            };
                        }()));
                    });
                };
            };
        },
        MonadAsk0: function() {
            return monadAskContT1;
        }
    };
};
var $145dc4a2d647cf5f$export$fd982f3f83dedfc9 = function(dictMonad) {
    var monadContT1 = $145dc4a2d647cf5f$export$735f43b0215ad39(dictMonad);
    return {
        callCC: function(f) {
            return function(k) {
                var v = f(function(a) {
                    return function(v1) {
                        return k(a);
                    };
                });
                return v(k);
            };
        },
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $145dc4a2d647cf5f$export$35d988300b9091c9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadContT1 = $145dc4a2d647cf5f$export$735f43b0215ad39(Monad0);
    return {
        liftEffect: function() {
            var $90 = $145dc4a2d647cf5f$var$lift(Monad0);
            var $91 = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
            return function($92) {
                return $90($91($92));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $145dc4a2d647cf5f$export$1aa60909d07c5b2d = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadContT1 = $145dc4a2d647cf5f$export$735f43b0215ad39(Monad0);
    return {
        state: function() {
            var $93 = $145dc4a2d647cf5f$var$lift(Monad0);
            var $94 = $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState);
            return function($95) {
                return $93($94($95));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $145dc4a2d647cf5f$export$e824ef6fc9053d43 = function(dictApplicative) {
    var pure = $bQdkN.pure($145dc4a2d647cf5f$export$d73f0595e894296c(dictApplicative));
    var semigroupContT1 = $145dc4a2d647cf5f$export$ebd715a8b64afb39(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupContT2 = semigroupContT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($3aOYV.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupContT2;
            }
        };
    };
};


// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $kkdfo = parcelRequire("kkdfo");




var $bcJ05 = parcelRequire("bcJ05");


// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");

var $7O0Q4 = parcelRequire("7O0Q4");
var $1ef973452f9b4285$export$de3113ed932c61ab = function(dict) {
    return dict.tell;
};
var $1ef973452f9b4285$export$167b0ad523238611 = function(dict) {
    return dict.pass;
};
var $1ef973452f9b4285$export$63174c828edd6ff8 = function(dict) {
    return dict.listen;
};
var $1ef973452f9b4285$export$e63807bfd37abcc0 = function(dictMonadWriter) {
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $cADnC.bind(Monad1.Bind1());
    var listen1 = $1ef973452f9b4285$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $bQdkN.pure(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return bind(listen1(m))(function(v) {
                return pure(new $7O0Q4.Tuple(v.value0, f(v.value1)));
            });
        };
    };
};
var $1ef973452f9b4285$export$b0a417369eddf9f2 = function(dictMonadWriter) {
    var pass1 = $1ef973452f9b4285$export$167b0ad523238611(dictMonadWriter);
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $cADnC.bind(Monad1.Bind1());
    var pure = $bQdkN.pure(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return pass1(bind(m)(function(a) {
                return pure(new $7O0Q4.Tuple(a, f));
            }));
        };
    };
};



var $beQI1 = parcelRequire("beQI1");

var $7FzSN = parcelRequire("7FzSN");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $7O0Q4 = parcelRequire("7O0Q4");

var $2603701dab447006$var$map = /* #__PURE__ */ $7FzSN.map($beQI1.functorEither);
var $2603701dab447006$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $2603701dab447006$export$2e7afd25df37516b = function(x) {
    return x;
};
var $2603701dab447006$export$998a9a780731dd5b = function(dictFunctor) {
    var map1 = $7FzSN.map(dictFunctor);
    return function(f) {
        return function(v) {
            var mapLeft = function(v1) {
                return function(v2) {
                    if (v2 instanceof $beQI1.Right) return new $beQI1.Right(v2.value0);
                    if (v2 instanceof $beQI1.Left) return new $beQI1.Left(v1(v2.value0));
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 42, column 3 - line 42, column 32): " + [
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
            return map1(mapLeft(f))(v);
        };
    };
};
var $2603701dab447006$export$8291c2122093ac93 = function(v) {
    return v;
};
var $2603701dab447006$export$779e60e46c1e0f8b = {
    Coercible0: function() {
        return undefined;
    }
};
var $2603701dab447006$export$fa93accd6d6dc1d2 = {
    lift: function(dictMonad) {
        var bind = $cADnC.bind(dictMonad.Bind1());
        var pure = $bQdkN.pure(dictMonad.Applicative0());
        return function(m) {
            return bind(m)(function(a) {
                return pure(new $beQI1.Right(a));
            });
        };
    }
};
var $2603701dab447006$var$lift = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($2603701dab447006$export$fa93accd6d6dc1d2);
var $2603701dab447006$export$34cbd9fbda5c1fb2 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $2603701dab447006$export$d684c62fe584fcfa = function(dictFunctor) {
    var map1 = $7FzSN.map(dictFunctor);
    return {
        map: function(f) {
            return $2603701dab447006$export$34cbd9fbda5c1fb2(map1($2603701dab447006$var$map(f)));
        }
    };
};
var $2603701dab447006$export$67aba9fb222c5e1d = function(dictApplicative) {
    var $185 = $bQdkN.pure(dictApplicative);
    return function($186) {
        return $2603701dab447006$export$2e7afd25df37516b($185($186));
    };
};
var $2603701dab447006$export$5a198347e9244c74 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $2603701dab447006$export$963960a96c103d2f(dictMonad);
        },
        Bind1: function() {
            return $2603701dab447006$export$a8cbc0f84e8b069b(dictMonad);
        }
    };
};
var $2603701dab447006$export$a8cbc0f84e8b069b = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(k) {
                return bind(v)($beQI1.either(function($187) {
                    return pure($beQI1.Left.create($187));
                })(function(a) {
                    var v1 = k(a);
                    return v1;
                }));
            };
        },
        Apply0: function() {
            return $2603701dab447006$export$581feac922061bf0(dictMonad);
        }
    };
};
var $2603701dab447006$export$581feac922061bf0 = function(dictMonad) {
    var functorExceptT1 = $2603701dab447006$export$d684c62fe584fcfa(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $kkdfo.ap($2603701dab447006$export$5a198347e9244c74(dictMonad)),
        Functor0: function() {
            return functorExceptT1;
        }
    };
};
var $2603701dab447006$export$963960a96c103d2f = function(dictMonad) {
    return {
        pure: function() {
            var $188 = $bQdkN.pure(dictMonad.Applicative0());
            return function($189) {
                return $2603701dab447006$export$2e7afd25df37516b($188($beQI1.Right.create($189)));
            };
        }(),
        Apply0: function() {
            return $2603701dab447006$export$581feac922061bf0(dictMonad);
        }
    };
};
var $2603701dab447006$export$3539db811b3307bc = function(dictMonad) {
    var lift2 = $26ZCq.lift2($2603701dab447006$export$581feac922061bf0(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d5vvq.append(dictSemigroup))
        };
    };
};
var $2603701dab447006$export$90c373eb83297b8e = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadExceptT1 = $2603701dab447006$export$5a198347e9244c74(Monad0);
    return {
        ask: $2603701dab447006$var$lift(Monad0)($ce0fad135b75d1f6$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $2603701dab447006$export$fb6edd8453289893 = function(dictMonadReader) {
    var local = $ce0fad135b75d1f6$export$3bf5078b16209b91(dictMonadReader);
    var monadAskExceptT1 = $2603701dab447006$export$90c373eb83297b8e(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $2603701dab447006$export$34cbd9fbda5c1fb2(local(f));
        },
        MonadAsk0: function() {
            return monadAskExceptT1;
        }
    };
};
var $2603701dab447006$export$aed911633663c3d8 = function(dictMonadCont) {
    var callCC = $45c1976f946e1989$export$bb801a161a3121f0(dictMonadCont);
    var monadExceptT1 = $2603701dab447006$export$5a198347e9244c74(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $beQI1.Right(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $2603701dab447006$export$14ff7e4e497a86b1 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadExceptT1 = $2603701dab447006$export$5a198347e9244c74(Monad0);
    return {
        liftEffect: function() {
            var $190 = $2603701dab447006$var$lift(Monad0);
            var $191 = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
            return function($192) {
                return $190($191($192));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $2603701dab447006$export$fed8f4223a283613 = function(dictMonadRec) {
    var tailRecM = $bcJ05.tailRecM(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $cADnC.bind(Monad0.Bind1());
    var pure = $bQdkN.pure(Monad0.Applicative0());
    var monadExceptT1 = $2603701dab447006$export$5a198347e9244c74(Monad0);
    return {
        tailRecM: function(f) {
            var $193 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $beQI1.Left) return new $bcJ05.Done(new $beQI1.Left(m$prime.value0));
                        if (m$prime instanceof $beQI1.Right && m$prime.value0 instanceof $bcJ05.Loop) return new $bcJ05.Loop(m$prime.value0.value0);
                        if (m$prime instanceof $beQI1.Right && m$prime.value0 instanceof $bcJ05.Done) return new $bcJ05.Done(new $beQI1.Right(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 74, column 14 - line 77, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($194) {
                return $2603701dab447006$export$2e7afd25df37516b($193($194));
            };
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $2603701dab447006$export$e8228b6b505171fd = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $2603701dab447006$var$lift(Monad0);
    var state = $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState);
    var monadExceptT1 = $2603701dab447006$export$5a198347e9244c74(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $2603701dab447006$export$7a7c2ab3eaa0a3e9 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadExceptT1 = $2603701dab447006$export$5a198347e9244c74(Monad1);
    return {
        tell: function() {
            var $195 = $2603701dab447006$var$lift(Monad1);
            var $196 = $1ef973452f9b4285$export$de3113ed932c61ab(dictMonadTell);
            return function($197) {
                return $195($196($197));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadExceptT1;
        }
    };
};
var $2603701dab447006$export$a9c9aad9aca5566b = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $cADnC.bind(Monad1.Bind1());
    var listen = $1ef973452f9b4285$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $bQdkN.pure(Monad1.Applicative0());
    var pass = $1ef973452f9b4285$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellExceptT1 = $2603701dab447006$export$7a7c2ab3eaa0a3e9(MonadTell1);
    return {
        listen: $2603701dab447006$export$34cbd9fbda5c1fb2(function(m) {
            return bind(listen(m))(function(v) {
                return pure($2603701dab447006$var$map(function(r) {
                    return new $7O0Q4.Tuple(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $2603701dab447006$export$34cbd9fbda5c1fb2(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $beQI1.Left) return new $7O0Q4.Tuple(new $beQI1.Left(a.value0), $2603701dab447006$var$identity);
                    if (a instanceof $beQI1.Right) return new $7O0Q4.Tuple(new $beQI1.Right(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 134, column 10 - line 136, column 45): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellExceptT1;
        }
    };
};
var $2603701dab447006$export$75f89ba5e7a712b0 = function(dictMonad) {
    var monadExceptT1 = $2603701dab447006$export$5a198347e9244c74(dictMonad);
    return {
        throwError: function() {
            var $198 = $bQdkN.pure(dictMonad.Applicative0());
            return function($199) {
                return $2603701dab447006$export$2e7afd25df37516b($198($beQI1.Left.create($199)));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $2603701dab447006$export$78c1353d784c47dd = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var monadThrowExceptT1 = $2603701dab447006$export$75f89ba5e7a712b0(dictMonad);
    return {
        catchError: function(v) {
            return function(k) {
                return bind(v)($beQI1.either(function(a) {
                    var v1 = k(a);
                    return v1;
                })(function($200) {
                    return pure($beQI1.Right.create($200));
                }));
            };
        },
        MonadThrow0: function() {
            return monadThrowExceptT1;
        }
    };
};
var $2603701dab447006$export$9a16ccee20eb55ce = function(dictMonad) {
    var pure = $bQdkN.pure($2603701dab447006$export$963960a96c103d2f(dictMonad));
    var semigroupExceptT1 = $2603701dab447006$export$3539db811b3307bc(dictMonad);
    return function(dictMonoid) {
        var semigroupExceptT2 = semigroupExceptT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($3aOYV.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupExceptT2;
            }
        };
    };
};
var $2603701dab447006$export$4cca4d0f6dfbd781 = function(dictSemigroup) {
    var append = $d5vvq.append(dictSemigroup);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var bind = $cADnC.bind(Bind1);
        var pure = $bQdkN.pure(dictMonad.Applicative0());
        var functorExceptT1 = $2603701dab447006$export$d684c62fe584fcfa(Bind1.Apply0().Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return bind(v)(function(rm) {
                        if (rm instanceof $beQI1.Right) return pure(new $beQI1.Right(rm.value0));
                        if (rm instanceof $beQI1.Left) return bind(v1)(function(rn) {
                            if (rn instanceof $beQI1.Right) return pure(new $beQI1.Right(rn.value0));
                            if (rn instanceof $beQI1.Left) return pure(new $beQI1.Left(append(rm.value0)(rn.value0)));
                            throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 86, column 9 - line 88, column 49): " + [
                                rn.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 82, column 5 - line 88, column 49): " + [
                            rm.constructor.name
                        ]);
                    });
                };
            },
            Functor0: function() {
                return functorExceptT1;
            }
        };
    };
};
var $2603701dab447006$export$c5d1f65b4da4d62f = function(dictMonoid) {
    var mempty = $3aOYV.mempty(dictMonoid);
    var altExceptT1 = $2603701dab447006$export$4cca4d0f6dfbd781(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var altExceptT2 = altExceptT1(dictMonad);
        return {
            empty: $693a27a8782d8e71$export$8bf7aba4a9e09055($2603701dab447006$export$75f89ba5e7a712b0(dictMonad))(mempty),
            Alt0: function() {
                return altExceptT2;
            }
        };
    };
};
var $2603701dab447006$export$bfd291e36e6170e5 = function(dictMonoid) {
    var plusExceptT1 = $2603701dab447006$export$c5d1f65b4da4d62f(dictMonoid);
    return function(dictMonad) {
        var applicativeExceptT1 = $2603701dab447006$export$963960a96c103d2f(dictMonad);
        var plusExceptT2 = plusExceptT1(dictMonad);
        return {
            Applicative0: function() {
                return applicativeExceptT1;
            },
            Plus1: function() {
                return plusExceptT2;
            }
        };
    };
};
var $2603701dab447006$export$2b1e74d8588fcb7c = function(dictMonoid) {
    var alternativeExceptT1 = $2603701dab447006$export$bfd291e36e6170e5(dictMonoid);
    return function(dictMonad) {
        var monadExceptT1 = $2603701dab447006$export$5a198347e9244c74(dictMonad);
        var alternativeExceptT2 = alternativeExceptT1(dictMonad);
        return {
            Monad0: function() {
                return monadExceptT1;
            },
            Alternative1: function() {
                return alternativeExceptT2;
            }
        };
    };
};


// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $kkdfo = parcelRequire("kkdfo");




var $bcJ05 = parcelRequire("bcJ05");




var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $7O0Q4 = parcelRequire("7O0Q4");

var $0084a6f1dda72e44$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $0084a6f1dda72e44$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $0084a6f1dda72e44$export$ad3c05b40854bc17 = function(x) {
    return x;
};
var $0084a6f1dda72e44$export$74b507a1130daad6 = function(v) {
    return v;
};
var $0084a6f1dda72e44$export$e423059046893ebc = {
    Coercible0: function() {
        return undefined;
    }
};
var $0084a6f1dda72e44$export$84eda9cb75492c36 = {
    lift: function(dictMonad) {
        var $157 = $kkdfo.liftM1(dictMonad)($h2xUu.Just.create);
        return function($158) {
            return $0084a6f1dda72e44$export$ad3c05b40854bc17($157($158));
        };
    }
};
var $0084a6f1dda72e44$var$lift = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($0084a6f1dda72e44$export$84eda9cb75492c36);
var $0084a6f1dda72e44$export$d0ac118ccd5cda07 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $0084a6f1dda72e44$export$3bf77092340654e0 = function(dictFunctor) {
    var map1 = $7FzSN.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return map1($0084a6f1dda72e44$var$map(f))(v);
            };
        }
    };
};
var $0084a6f1dda72e44$export$63cf87c0678a1d2c = function(dictMonad) {
    return {
        Applicative0: function() {
            return $0084a6f1dda72e44$export$4797150488333da1(dictMonad);
        },
        Bind1: function() {
            return $0084a6f1dda72e44$export$c4ec8f671a263573(dictMonad);
        }
    };
};
var $0084a6f1dda72e44$export$c4ec8f671a263573 = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(f) {
                return bind(v)(function(v1) {
                    if (v1 instanceof $h2xUu.Nothing) return pure($h2xUu.Nothing.value);
                    if (v1 instanceof $h2xUu.Just) {
                        var v2 = f(v1.value0);
                        return v2;
                    }
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 54, column 11 - line 56, column 42): " + [
                        v1.constructor.name
                    ]);
                });
            };
        },
        Apply0: function() {
            return $0084a6f1dda72e44$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $0084a6f1dda72e44$export$2fa55c29b4f8d86e = function(dictMonad) {
    var functorMaybeT1 = $0084a6f1dda72e44$export$3bf77092340654e0(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $kkdfo.ap($0084a6f1dda72e44$export$63cf87c0678a1d2c(dictMonad)),
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$4797150488333da1 = function(dictMonad) {
    return {
        pure: function() {
            var $159 = $bQdkN.pure(dictMonad.Applicative0());
            return function($160) {
                return $0084a6f1dda72e44$export$ad3c05b40854bc17($159($h2xUu.Just.create($160)));
            };
        }(),
        Apply0: function() {
            return $0084a6f1dda72e44$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $0084a6f1dda72e44$export$984e03b79d8c6656 = function(dictMonad) {
    var lift2 = $26ZCq.lift2($0084a6f1dda72e44$export$2fa55c29b4f8d86e(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d5vvq.append(dictSemigroup))
        };
    };
};
var $0084a6f1dda72e44$export$36c6624b0bef0761 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadMaybeT1 = $0084a6f1dda72e44$export$63cf87c0678a1d2c(Monad0);
    return {
        ask: $0084a6f1dda72e44$var$lift(Monad0)($ce0fad135b75d1f6$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$d73769631c0edb39 = function(dictMonadReader) {
    var local = $ce0fad135b75d1f6$export$3bf5078b16209b91(dictMonadReader);
    var monadAskMaybeT1 = $0084a6f1dda72e44$export$36c6624b0bef0761(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $0084a6f1dda72e44$export$d0ac118ccd5cda07(local(f));
        },
        MonadAsk0: function() {
            return monadAskMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$ec6a88a02083ed25 = function(dictMonadCont) {
    var callCC = $45c1976f946e1989$export$bb801a161a3121f0(dictMonadCont);
    var monadMaybeT1 = $0084a6f1dda72e44$export$63cf87c0678a1d2c(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $h2xUu.Just(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$2f876a9cb1e407d9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadMaybeT1 = $0084a6f1dda72e44$export$63cf87c0678a1d2c(Monad0);
    return {
        liftEffect: function() {
            var $161 = $0084a6f1dda72e44$var$lift(Monad0);
            var $162 = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
            return function($163) {
                return $161($162($163));
            };
        }(),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$7b9e3f37a9f7f6b2 = function(dictMonadRec) {
    var tailRecM = $bcJ05.tailRecM(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $cADnC.bind(Monad0.Bind1());
    var pure = $bQdkN.pure(Monad0.Applicative0());
    var monadMaybeT1 = $0084a6f1dda72e44$export$63cf87c0678a1d2c(Monad0);
    return {
        tailRecM: function(f) {
            var $164 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $h2xUu.Nothing) return new $bcJ05.Done($h2xUu.Nothing.value);
                        if (m$prime instanceof $h2xUu.Just && m$prime.value0 instanceof $bcJ05.Loop) return new $bcJ05.Loop(m$prime.value0.value0);
                        if (m$prime instanceof $h2xUu.Just && m$prime.value0 instanceof $bcJ05.Done) return new $bcJ05.Done(new $h2xUu.Just(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 82, column 16 - line 85, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($165) {
                return $0084a6f1dda72e44$export$ad3c05b40854bc17($164($165));
            };
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$99cfcc8edd025934 = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $0084a6f1dda72e44$var$lift(Monad0);
    var state = $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState);
    var monadMaybeT1 = $0084a6f1dda72e44$export$63cf87c0678a1d2c(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$907950ecc201e8fb = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadMaybeT1 = $0084a6f1dda72e44$export$63cf87c0678a1d2c(Monad1);
    return {
        tell: function() {
            var $166 = $0084a6f1dda72e44$var$lift(Monad1);
            var $167 = $1ef973452f9b4285$export$de3113ed932c61ab(dictMonadTell);
            return function($168) {
                return $166($167($168));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$5afebe755b331e96 = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $cADnC.bind(Monad1.Bind1());
    var listen = $1ef973452f9b4285$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $bQdkN.pure(Monad1.Applicative0());
    var pass = $1ef973452f9b4285$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellMaybeT1 = $0084a6f1dda72e44$export$907950ecc201e8fb(MonadTell1);
    return {
        listen: $0084a6f1dda72e44$export$d0ac118ccd5cda07(function(m) {
            return bind(listen(m))(function(v) {
                return pure($0084a6f1dda72e44$var$map(function(r) {
                    return new $7O0Q4.Tuple(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $0084a6f1dda72e44$export$d0ac118ccd5cda07(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $h2xUu.Nothing) return new $7O0Q4.Tuple($h2xUu.Nothing.value, $0084a6f1dda72e44$var$identity);
                    if (a instanceof $h2xUu.Just) return new $7O0Q4.Tuple(new $h2xUu.Just(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 119, column 10 - line 121, column 43): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$8908e8a28a021e1c = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $0084a6f1dda72e44$var$lift(Monad0);
    var throwError = $693a27a8782d8e71$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadMaybeT1 = $0084a6f1dda72e44$export$63cf87c0678a1d2c(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$f77b055a7835b1d0 = function(dictMonadError) {
    var catchError = $693a27a8782d8e71$export$3dede90624df3ba9(dictMonadError);
    var monadThrowMaybeT1 = $0084a6f1dda72e44$export$8908e8a28a021e1c(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return catchError(v)(function(a) {
                    var v1 = h(a);
                    return v1;
                });
            };
        },
        MonadThrow0: function() {
            return monadThrowMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$20ac3a2d3113d020 = function(dictMonad) {
    var pure = $bQdkN.pure($0084a6f1dda72e44$export$4797150488333da1(dictMonad));
    var semigroupMaybeT1 = $0084a6f1dda72e44$export$984e03b79d8c6656(dictMonad);
    return function(dictMonoid) {
        var semigroupMaybeT2 = semigroupMaybeT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($3aOYV.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupMaybeT2;
            }
        };
    };
};
var $0084a6f1dda72e44$export$e14125e5a208a0c9 = function(dictMonad) {
    var Bind1 = dictMonad.Bind1();
    var bind = $cADnC.bind(Bind1);
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var functorMaybeT1 = $0084a6f1dda72e44$export$3bf77092340654e0(Bind1.Apply0().Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return bind(v)(function(m) {
                    if (m instanceof $h2xUu.Nothing) return v1;
                    return pure(m);
                });
            };
        },
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$140a10b5716e1900 = function(dictMonad) {
    var altMaybeT1 = $0084a6f1dda72e44$export$e14125e5a208a0c9(dictMonad);
    return {
        empty: $bQdkN.pure(dictMonad.Applicative0())($h2xUu.Nothing.value),
        Alt0: function() {
            return altMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$68df7d2debd59865 = function(dictMonad) {
    var applicativeMaybeT1 = $0084a6f1dda72e44$export$4797150488333da1(dictMonad);
    var plusMaybeT1 = $0084a6f1dda72e44$export$140a10b5716e1900(dictMonad);
    return {
        Applicative0: function() {
            return applicativeMaybeT1;
        },
        Plus1: function() {
            return plusMaybeT1;
        }
    };
};
var $0084a6f1dda72e44$export$d4030eff1969644e = function(dictMonad) {
    var monadMaybeT1 = $0084a6f1dda72e44$export$63cf87c0678a1d2c(dictMonad);
    var alternativeMaybeT1 = $0084a6f1dda72e44$export$68df7d2debd59865(dictMonad);
    return {
        Monad0: function() {
            return monadMaybeT1;
        },
        Alternative1: function() {
            return alternativeMaybeT1;
        }
    };
};


// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");




var $bcJ05 = parcelRequire("bcJ05");




var $j7FrY = parcelRequire("j7FrY");
// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $7FzSN = parcelRequire("7FzSN");

var $8pkky = parcelRequire("8pkky");

var $46y1S = parcelRequire("46y1S");

var $7O0Q4 = parcelRequire("7O0Q4");

var $2jM6U = parcelRequire("2jM6U");
// Generated by purs version 0.15.16
var $c225868ad087c7d7$var$To = function(x) {
    return x;
};
var $c225868ad087c7d7$var$From = function(x) {
    return x;
};
var $c225868ad087c7d7$export$9fc2f52ae8ba6578 = {
    proof: function(a) {
        return a;
    },
    Coercible0: function() {
        return undefined;
    }
};
var $c225868ad087c7d7$export$3d466392f5188420 = function(dict) {
    return dict.proof;
};
var $c225868ad087c7d7$export$2c618a4308a30424 = function(dictTypeEquals) {
    var v = $c225868ad087c7d7$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};
var $c225868ad087c7d7$export$6788812c4e6611e6 = function(dictTypeEquals) {
    var v = $c225868ad087c7d7$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};


var $04114899412aeb9b$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $04114899412aeb9b$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $04114899412aeb9b$export$c2a69422949c6b5c = {
    distribute: function(dictFunctor) {
        var $34 = $7FzSN.map(dictFunctor)($04114899412aeb9b$var$unwrap);
        return function($35) {
            return $8pkky.Identity($34($35));
        };
    },
    collect: function(dictFunctor) {
        var map = $7FzSN.map(dictFunctor);
        return function(f) {
            var $36 = map(function($38) {
                return $04114899412aeb9b$var$unwrap(f($38));
            });
            return function($37) {
                return $8pkky.Identity($36($37));
            };
        };
    },
    Functor0: function() {
        return $8pkky.functorIdentity;
    }
};
var $04114899412aeb9b$export$f02a9ddbe4480f19 = function(dict) {
    return dict.distribute;
};
var $04114899412aeb9b$export$31ac6c2237b1bf1b = {
    distribute: function(dictFunctor) {
        var map = $7FzSN.map(dictFunctor);
        return function(a) {
            return function(e) {
                return map(function(v) {
                    return v(e);
                })(a);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $7FzSN.map(dictFunctor);
        return function(f) {
            var $39 = $04114899412aeb9b$export$f02a9ddbe4480f19($04114899412aeb9b$export$31ac6c2237b1bf1b)(dictFunctor);
            var $40 = map(f);
            return function($41) {
                return $39($40($41));
            };
        };
    },
    Functor0: function() {
        return $7FzSN.functorFn;
    }
};
var $04114899412aeb9b$export$e6005abdfe1aac80 = function(dictDistributive) {
    var map = $7FzSN.map(dictDistributive.Functor0());
    var distribute1 = $04114899412aeb9b$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        return function(f) {
            var $42 = map(f);
            return function($43) {
                return $42(distribute2($43));
            };
        };
    };
};
var $04114899412aeb9b$export$2d5a930f1676b9b7 = function(dictDistributive) {
    var distribute1 = $04114899412aeb9b$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        var map = $7FzSN.map(dictFunctor);
        return function(f) {
            var $44 = map(f);
            return function($45) {
                return distribute2($44($45));
            };
        };
    };
};
var $04114899412aeb9b$export$76df48f9f3fb8eb1 = function(dictTypeEquals) {
    var from = $c225868ad087c7d7$export$6788812c4e6611e6(dictTypeEquals);
    return {
        collect: function(dictFunctor) {
            return $04114899412aeb9b$export$2d5a930f1676b9b7($04114899412aeb9b$export$76df48f9f3fb8eb1(dictTypeEquals))(dictFunctor);
        },
        distribute: function(dictFunctor) {
            var $46 = $7O0Q4.Tuple.create(from($2jM6U.unit));
            var $47 = $7FzSN.map(dictFunctor)($7O0Q4.snd);
            return function($48) {
                return $46($47($48));
            };
        },
        Functor0: function() {
            return $7O0Q4.functorTuple;
        }
    };
};
var $04114899412aeb9b$export$bb44f104e3c54dae = function(dict) {
    return dict.collect;
};
var $04114899412aeb9b$export$f13cbf7f76d41467 = function(dictDistributive) {
    var collect1 = $04114899412aeb9b$export$bb44f104e3c54dae(dictDistributive);
    return function(dictFunctor) {
        return collect1(dictFunctor)($04114899412aeb9b$var$identity);
    };
};



var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $024201b10fb9f490$export$ea3c61b219e01d1e = function(x) {
    return x;
};
var $024201b10fb9f490$export$36ee99cc8d1d67c9 = function(f) {
    return function(v) {
        return function($146) {
            return v(f($146));
        };
    };
};
var $024201b10fb9f490$export$f356de2c51baae29 = function(v) {
    return v;
};
var $024201b10fb9f490$export$f52dceb6bbe9cc1f = {
    Coercible0: function() {
        return undefined;
    }
};
var $024201b10fb9f490$export$95510d0cd7e6e7eb = {
    lift: function(dictMonad) {
        return function($147) {
            return $024201b10fb9f490$export$ea3c61b219e01d1e($jhsiw.const($147));
        };
    }
};
var $024201b10fb9f490$var$lift = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($024201b10fb9f490$export$95510d0cd7e6e7eb);
var $024201b10fb9f490$export$1b8048a192a96779 = function(f) {
    return function(v) {
        return function($148) {
            return f(v($148));
        };
    };
};
var $024201b10fb9f490$export$9ef8da126720992c = function(dictFunctor) {
    return {
        map: function() {
            var $149 = $7FzSN.map(dictFunctor);
            return function($150) {
                return $024201b10fb9f490$export$1b8048a192a96779($149($150));
            };
        }()
    };
};
var $024201b10fb9f490$export$4b73f9411376f1b4 = function(dictDistributive) {
    var collect = $04114899412aeb9b$export$bb44f104e3c54dae(dictDistributive);
    var functorReaderT1 = $024201b10fb9f490$export$9ef8da126720992c(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(a) {
                return function(e) {
                    return collect1(function(r) {
                        return r(e);
                    })(a);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $7FzSN.map(dictFunctor);
            return function(f) {
                var $151 = $04114899412aeb9b$export$f02a9ddbe4480f19($024201b10fb9f490$export$4b73f9411376f1b4(dictDistributive))(dictFunctor);
                var $152 = map(f);
                return function($153) {
                    return $151($152($153));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $024201b10fb9f490$export$fee188993a7996b7 = function(dictApply) {
    var apply = $26ZCq.apply(dictApply);
    var functorReaderT1 = $024201b10fb9f490$export$9ef8da126720992c(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(r) {
                    return apply(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $024201b10fb9f490$export$4255fb962d7d3c76 = function(dictBind) {
    var bind = $cADnC.bind(dictBind);
    var applyReaderT1 = $024201b10fb9f490$export$fee188993a7996b7(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(r) {
                    return bind(v(r))(function(a) {
                        var v1 = k(a);
                        return v1(r);
                    });
                };
            };
        },
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $024201b10fb9f490$export$12572275428491c2 = function(dictApply) {
    var lift2 = $26ZCq.lift2($024201b10fb9f490$export$fee188993a7996b7(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($d5vvq.append(dictSemigroup))
        };
    };
};
var $024201b10fb9f490$export$aef633589549fee0 = function(dictApplicative) {
    var applyReaderT1 = $024201b10fb9f490$export$fee188993a7996b7(dictApplicative.Apply0());
    return {
        pure: function() {
            var $154 = $bQdkN.pure(dictApplicative);
            return function($155) {
                return $024201b10fb9f490$export$ea3c61b219e01d1e($jhsiw.const($154($155)));
            };
        }(),
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $024201b10fb9f490$export$6f721f6865c71dd2 = function(dictMonad) {
    var applicativeReaderT1 = $024201b10fb9f490$export$aef633589549fee0(dictMonad.Applicative0());
    var bindReaderT1 = $024201b10fb9f490$export$4255fb962d7d3c76(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Bind1: function() {
            return bindReaderT1;
        }
    };
};
var $024201b10fb9f490$export$1fc6951fa9cc0730 = function(dictMonad) {
    var monadReaderT1 = $024201b10fb9f490$export$6f721f6865c71dd2(dictMonad);
    return {
        ask: $bQdkN.pure(dictMonad.Applicative0()),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $024201b10fb9f490$export$202df576a32d0b15 = function(dictMonad) {
    var monadAskReaderT1 = $024201b10fb9f490$export$1fc6951fa9cc0730(dictMonad);
    return {
        local: $024201b10fb9f490$export$36ee99cc8d1d67c9,
        MonadAsk0: function() {
            return monadAskReaderT1;
        }
    };
};
var $024201b10fb9f490$export$9f6c922afb6673fe = function(dictMonadCont) {
    var callCC = $45c1976f946e1989$export$bb801a161a3121f0(dictMonadCont);
    var monadReaderT1 = $024201b10fb9f490$export$6f721f6865c71dd2(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(r) {
                return callCC(function(c) {
                    var v = f(function($156) {
                        return $024201b10fb9f490$export$ea3c61b219e01d1e($jhsiw.const(c($156)));
                    });
                    return v(r);
                });
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $024201b10fb9f490$export$a554ebf369a3f56d = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadReaderT1 = $024201b10fb9f490$export$6f721f6865c71dd2(Monad0);
    return {
        liftEffect: function() {
            var $157 = $024201b10fb9f490$var$lift(Monad0);
            var $158 = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
            return function($159) {
                return $157($158($159));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $024201b10fb9f490$export$b063aaccf75fba13 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bindFlipped = $cADnC.bindFlipped(Monad0.Bind1());
    var pure = $bQdkN.pure(Monad0.Applicative0());
    var tailRecM = $bcJ05.tailRecM(dictMonadRec);
    var monadReaderT1 = $024201b10fb9f490$export$6f721f6865c71dd2(Monad0);
    return {
        tailRecM: function(k) {
            return function(a) {
                var k$prime = function(r) {
                    return function(a$prime) {
                        var v = k(a$prime);
                        return bindFlipped(pure)(v(r));
                    };
                };
                return function(r) {
                    return tailRecM(k$prime(r))(a);
                };
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $024201b10fb9f490$export$48d7aff14d826a4f = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadReaderT1 = $024201b10fb9f490$export$6f721f6865c71dd2(Monad0);
    return {
        state: function() {
            var $160 = $024201b10fb9f490$var$lift(Monad0);
            var $161 = $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState);
            return function($162) {
                return $160($161($162));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $024201b10fb9f490$export$ab1235cf7f047d07 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadReaderT1 = $024201b10fb9f490$export$6f721f6865c71dd2(Monad1);
    return {
        tell: function() {
            var $163 = $024201b10fb9f490$var$lift(Monad1);
            var $164 = $1ef973452f9b4285$export$de3113ed932c61ab(dictMonadTell);
            return function($165) {
                return $163($164($165));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadReaderT1;
        }
    };
};
var $024201b10fb9f490$export$662fa4b34fb6720c = function(dictMonadWriter) {
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellReaderT1 = $024201b10fb9f490$export$ab1235cf7f047d07(dictMonadWriter.MonadTell1());
    return {
        listen: $024201b10fb9f490$export$1b8048a192a96779($1ef973452f9b4285$export$63174c828edd6ff8(dictMonadWriter)),
        pass: $024201b10fb9f490$export$1b8048a192a96779($1ef973452f9b4285$export$167b0ad523238611(dictMonadWriter)),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellReaderT1;
        }
    };
};
var $024201b10fb9f490$export$1b067e2856bff729 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var monadReaderT1 = $024201b10fb9f490$export$6f721f6865c71dd2(Monad0);
    return {
        throwError: function() {
            var $166 = $024201b10fb9f490$var$lift(Monad0);
            var $167 = $693a27a8782d8e71$export$8bf7aba4a9e09055(dictMonadThrow);
            return function($168) {
                return $166($167($168));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $024201b10fb9f490$export$484cd3c856ffc7 = function(dictMonadError) {
    var catchError = $693a27a8782d8e71$export$3dede90624df3ba9(dictMonadError);
    var monadThrowReaderT1 = $024201b10fb9f490$export$1b067e2856bff729(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(r) {
                    return catchError(v(r))(function(e) {
                        var v1 = h(e);
                        return v1(r);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowReaderT1;
        }
    };
};
var $024201b10fb9f490$export$df55f2197442fd9 = function(dictApplicative) {
    var pure = $bQdkN.pure($024201b10fb9f490$export$aef633589549fee0(dictApplicative));
    var semigroupReaderT1 = $024201b10fb9f490$export$12572275428491c2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupReaderT2 = semigroupReaderT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($3aOYV.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupReaderT2;
            }
        };
    };
};
var $024201b10fb9f490$export$32cadcb66dd98ef3 = function(dictAlt) {
    var alt = $56VjJ.alt(dictAlt);
    var functorReaderT1 = $024201b10fb9f490$export$9ef8da126720992c(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return alt(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $024201b10fb9f490$export$97f8c30f9c69a13c = function(dictPlus) {
    var altReaderT1 = $024201b10fb9f490$export$32cadcb66dd98ef3(dictPlus.Alt0());
    return {
        empty: $jhsiw.const($j7FrY.empty(dictPlus)),
        Alt0: function() {
            return altReaderT1;
        }
    };
};
var $024201b10fb9f490$export$8bebb77f5bc043a9 = function(dictAlternative) {
    var applicativeReaderT1 = $024201b10fb9f490$export$aef633589549fee0(dictAlternative.Applicative0());
    var plusReaderT1 = $024201b10fb9f490$export$97f8c30f9c69a13c(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Plus1: function() {
            return plusReaderT1;
        }
    };
};
var $024201b10fb9f490$export$3772d6c9d5f8e735 = function(dictMonadPlus) {
    var monadReaderT1 = $024201b10fb9f490$export$6f721f6865c71dd2(dictMonadPlus.Monad0());
    var alternativeReaderT1 = $024201b10fb9f490$export$8bebb77f5bc043a9(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadReaderT1;
        },
        Alternative1: function() {
            return alternativeReaderT1;
        }
    };
};


// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");




var $bcJ05 = parcelRequire("bcJ05");




var $j7FrY = parcelRequire("j7FrY");

var $7FzSN = parcelRequire("7FzSN");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $7O0Q4 = parcelRequire("7O0Q4");

var $2jM6U = parcelRequire("2jM6U");

var $6765fe209155a20b$export$6bef9d59f22e8880 = function(x) {
    return x;
};
var $6765fe209155a20b$export$973e92d98e897dbf = function(v) {
    return v;
};
var $6765fe209155a20b$export$d5b925da5ee69c31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6765fe209155a20b$export$6b749a3db2c2aac6 = function(dictMonoid) {
    var mempty = $3aOYV.mempty(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $cADnC.bind(dictMonad.Bind1());
            var pure = $bQdkN.pure(dictMonad.Applicative0());
            return function(m) {
                return bind(m)(function(a) {
                    return pure(new $7O0Q4.Tuple(a, mempty));
                });
            };
        }
    };
};
var $6765fe209155a20b$export$c950a71321ef1ffc = function(f) {
    return function(v) {
        return f(v);
    };
};
var $6765fe209155a20b$export$502115c714790859 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return {
        map: function(f) {
            return $6765fe209155a20b$export$c950a71321ef1ffc(map(function(v) {
                return new $7O0Q4.Tuple(f(v.value0), v.value1);
            }));
        }
    };
};
var $6765fe209155a20b$export$730fbe746bee115d = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return function(v) {
        return map($7O0Q4.snd)(v);
    };
};
var $6765fe209155a20b$export$2f46a8de9e2e0acc = function(dictSemigroup) {
    var append = $d5vvq.append(dictSemigroup);
    return function(dictApply) {
        var apply = $26ZCq.apply(dictApply);
        var Functor0 = dictApply.Functor0();
        var map = $7FzSN.map(Functor0);
        var functorWriterT1 = $6765fe209155a20b$export$502115c714790859(Functor0);
        return {
            apply: function(v) {
                return function(v1) {
                    var k = function(v3) {
                        return function(v4) {
                            return new $7O0Q4.Tuple(v3.value0(v4.value0), append(v3.value1)(v4.value1));
                        };
                    };
                    return apply(map(k)(v))(v1);
                };
            },
            Functor0: function() {
                return functorWriterT1;
            }
        };
    };
};
var $6765fe209155a20b$export$4483e5256f36d121 = function(dictSemigroup) {
    var append = $d5vvq.append(dictSemigroup);
    var applyWriterT1 = $6765fe209155a20b$export$2f46a8de9e2e0acc(dictSemigroup);
    return function(dictBind) {
        var bind = $cADnC.bind(dictBind);
        var Apply0 = dictBind.Apply0();
        var map = $7FzSN.map(Apply0.Functor0());
        var applyWriterT2 = applyWriterT1(Apply0);
        return {
            bind: function(v) {
                return function(k) {
                    return bind(v)(function(v1) {
                        var v2 = k(v1.value0);
                        return map(function(v3) {
                            return new $7O0Q4.Tuple(v3.value0, append(v1.value1)(v3.value1));
                        })(v2);
                    });
                };
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$8c475e05f959fff2 = function(dictApply) {
    return function(dictSemigroup) {
        var lift2 = $26ZCq.lift2($6765fe209155a20b$export$2f46a8de9e2e0acc(dictSemigroup)(dictApply));
        return function(dictSemigroup1) {
            return {
                append: lift2($d5vvq.append(dictSemigroup1))
            };
        };
    };
};
var $6765fe209155a20b$export$c3b0a193a5475c40 = function(dictMonoid) {
    var mempty = $3aOYV.mempty(dictMonoid);
    var applyWriterT1 = $6765fe209155a20b$export$2f46a8de9e2e0acc(dictMonoid.Semigroup0());
    return function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        var applyWriterT2 = applyWriterT1(dictApplicative.Apply0());
        return {
            pure: function(a) {
                return pure(new $7O0Q4.Tuple(a, mempty));
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$a45df43c41b778a = function(dictMonoid) {
    var applicativeWriterT1 = $6765fe209155a20b$export$c3b0a193a5475c40(dictMonoid);
    var bindWriterT1 = $6765fe209155a20b$export$4483e5256f36d121(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var applicativeWriterT2 = applicativeWriterT1(dictMonad.Applicative0());
        var bindWriterT2 = bindWriterT1(dictMonad.Bind1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Bind1: function() {
                return bindWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$2b88d21fdbd23b84 = function(dictMonoid) {
    var lift = $0db1509836ffbf7e$export$590e8b2c435046d9($6765fe209155a20b$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $6765fe209155a20b$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadAsk) {
        var Monad0 = dictMonadAsk.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            ask: lift(Monad0)($ce0fad135b75d1f6$export$1b4aee0b51c3def8(dictMonadAsk)),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$1e8e23b27bf4b6eb = function(dictMonoid) {
    var monadAskWriterT1 = $6765fe209155a20b$export$2b88d21fdbd23b84(dictMonoid);
    return function(dictMonadReader) {
        var local = $ce0fad135b75d1f6$export$3bf5078b16209b91(dictMonadReader);
        var monadAskWriterT2 = monadAskWriterT1(dictMonadReader.MonadAsk0());
        return {
            local: function(f) {
                return $6765fe209155a20b$export$c950a71321ef1ffc(local(f));
            },
            MonadAsk0: function() {
                return monadAskWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$7520b5391c6ad7c7 = function(dictMonoid) {
    var mempty = $3aOYV.mempty(dictMonoid);
    var monadWriterT1 = $6765fe209155a20b$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadCont) {
        var callCC = $45c1976f946e1989$export$bb801a161a3121f0(dictMonadCont);
        var monadWriterT2 = monadWriterT1(dictMonadCont.Monad0());
        return {
            callCC: function(f) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return c(new $7O0Q4.Tuple(a, mempty));
                    });
                    return v;
                });
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$29fece65832b4369 = function(dictMonoid) {
    var lift = $0db1509836ffbf7e$export$590e8b2c435046d9($6765fe209155a20b$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $6765fe209155a20b$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            liftEffect: function() {
                var $249 = lift(Monad0);
                var $250 = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
                return function($251) {
                    return $249($250($251));
                };
            }(),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$36179168852a11d0 = function(dictMonoid) {
    var append = $d5vvq.append(dictMonoid.Semigroup0());
    var mempty = $3aOYV.mempty(dictMonoid);
    var monadWriterT1 = $6765fe209155a20b$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var bind = $cADnC.bind(Monad0.Bind1());
        var pure = $bQdkN.pure(Monad0.Applicative0());
        var tailRecM = $bcJ05.tailRecM(dictMonadRec);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            tailRecM: function(f) {
                return function(a) {
                    var f$prime = function(v) {
                        var v1 = f(v.value0);
                        return bind(v1)(function(v2) {
                            return pure(function() {
                                if (v2.value0 instanceof $bcJ05.Loop) return new $bcJ05.Loop(new $7O0Q4.Tuple(v2.value0.value0, append(v.value1)(v2.value1)));
                                if (v2.value0 instanceof $bcJ05.Done) return new $bcJ05.Done(new $7O0Q4.Tuple(v2.value0.value0, append(v.value1)(v2.value1)));
                                throw new Error("Failed pattern match at Control.Monad.Writer.Trans (line 83, column 16 - line 85, column 47): " + [
                                    v2.value0.constructor.name
                                ]);
                            }());
                        });
                    };
                    return tailRecM(f$prime)(new $7O0Q4.Tuple(a, mempty));
                };
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$6594c621b12bf0b9 = function(dictMonoid) {
    var lift = $0db1509836ffbf7e$export$590e8b2c435046d9($6765fe209155a20b$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $6765fe209155a20b$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadState) {
        var Monad0 = dictMonadState.Monad0();
        var lift1 = lift(Monad0);
        var state = $60ebc5becec1930f$export$ca000e230c0caa3e(dictMonadState);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            state: function(f) {
                return lift1(state(f));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$b022f808a9791225 = function(dictMonoid) {
    var Semigroup0 = dictMonoid.Semigroup0();
    var monadWriterT1 = $6765fe209155a20b$export$a45df43c41b778a(dictMonoid);
    return function(dictMonad) {
        var monadWriterT2 = monadWriterT1(dictMonad);
        return {
            tell: function() {
                var $252 = $bQdkN.pure(dictMonad.Applicative0());
                var $253 = $7O0Q4.Tuple.create($2jM6U.unit);
                return function($254) {
                    return $6765fe209155a20b$export$6bef9d59f22e8880($252($253($254)));
                };
            }(),
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$f2385bf9afd45c19 = function(dictMonoid) {
    var monadTellWriterT1 = $6765fe209155a20b$export$b022f808a9791225(dictMonoid);
    return function(dictMonad) {
        var bind = $cADnC.bind(dictMonad.Bind1());
        var pure = $bQdkN.pure(dictMonad.Applicative0());
        var monadTellWriterT2 = monadTellWriterT1(dictMonad);
        return {
            listen: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $7O0Q4.Tuple(new $7O0Q4.Tuple(v1.value0, v1.value1), v1.value1));
                });
            },
            pass: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $7O0Q4.Tuple(v1.value0.value0, v1.value0.value1(v1.value1)));
                });
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$8fbe11284b53cf18 = function(dictMonoid) {
    var lift = $0db1509836ffbf7e$export$590e8b2c435046d9($6765fe209155a20b$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $6765fe209155a20b$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadThrow) {
        var Monad0 = dictMonadThrow.Monad0();
        var lift1 = lift(Monad0);
        var throwError = $693a27a8782d8e71$export$8bf7aba4a9e09055(dictMonadThrow);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            throwError: function(e) {
                return lift1(throwError(e));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$f7d1d5bacfa0742c = function(dictMonoid) {
    var monadThrowWriterT1 = $6765fe209155a20b$export$8fbe11284b53cf18(dictMonoid);
    return function(dictMonadError) {
        var catchError = $693a27a8782d8e71$export$3dede90624df3ba9(dictMonadError);
        var monadThrowWriterT2 = monadThrowWriterT1(dictMonadError.MonadThrow0());
        return {
            catchError: function(v) {
                return function(h) {
                    return catchError(v)(function(e) {
                        var v1 = h(e);
                        return v1;
                    });
                };
            },
            MonadThrow0: function() {
                return monadThrowWriterT2;
            }
        };
    };
};
var $6765fe209155a20b$export$8a353f8c5b798525 = function(dictApplicative) {
    var semigroupWriterT1 = $6765fe209155a20b$export$8c475e05f959fff2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var pure = $bQdkN.pure($6765fe209155a20b$export$c3b0a193a5475c40(dictMonoid)(dictApplicative));
        var semigroupWriterT2 = semigroupWriterT1(dictMonoid.Semigroup0());
        return function(dictMonoid1) {
            var semigroupWriterT3 = semigroupWriterT2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($3aOYV.mempty(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupWriterT3;
                }
            };
        };
    };
};
var $6765fe209155a20b$export$6f6793d950011736 = function(dictAlt) {
    var alt = $56VjJ.alt(dictAlt);
    var functorWriterT1 = $6765fe209155a20b$export$502115c714790859(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        },
        Functor0: function() {
            return functorWriterT1;
        }
    };
};
var $6765fe209155a20b$export$a57a36ca2cee11fb = function(dictPlus) {
    var altWriterT1 = $6765fe209155a20b$export$6f6793d950011736(dictPlus.Alt0());
    return {
        empty: $j7FrY.empty(dictPlus),
        Alt0: function() {
            return altWriterT1;
        }
    };
};
var $6765fe209155a20b$export$c91ecc30f23c76ec = function(dictMonoid) {
    var applicativeWriterT1 = $6765fe209155a20b$export$c3b0a193a5475c40(dictMonoid);
    return function(dictAlternative) {
        var applicativeWriterT2 = applicativeWriterT1(dictAlternative.Applicative0());
        var plusWriterT1 = $6765fe209155a20b$export$a57a36ca2cee11fb(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Plus1: function() {
                return plusWriterT1;
            }
        };
    };
};
var $6765fe209155a20b$export$1c68552a87a434af = function(dictMonoid) {
    var monadWriterT1 = $6765fe209155a20b$export$a45df43c41b778a(dictMonoid);
    var alternativeWriterT1 = $6765fe209155a20b$export$c91ecc30f23c76ec(dictMonoid);
    return function(dictMonadPlus) {
        var monadWriterT2 = monadWriterT1(dictMonadPlus.Monad0());
        var alternativeWriterT2 = alternativeWriterT1(dictMonadPlus.Alternative1());
        return {
            Monad0: function() {
                return monadWriterT2;
            },
            Alternative1: function() {
                return alternativeWriterT2;
            }
        };
    };
};



var $beQI1 = parcelRequire("beQI1");

var $7FzSN = parcelRequire("7FzSN");

var $iMzH1 = parcelRequire("iMzH1");
// Generated by purs version 0.15.16

var $49WxQ = parcelRequire("49WxQ");

var $eJa4O = parcelRequire("eJa4O");


var $7FzSN = parcelRequire("7FzSN");
// Generated by purs version 0.15.16

var $7FzSN = parcelRequire("7FzSN");

var $Hhp3L = parcelRequire("Hhp3L");
var $de7e5b0b395c3745$export$578ae18717ba10de = {
    cmap: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $de7e5b0b395c3745$export$b186cb408b99d7fc = function(dict) {
    return dict.cmap;
};
var $de7e5b0b395c3745$export$d0a699a1379b7fb5 = function(dictContravariant) {
    var cmap1 = $de7e5b0b395c3745$export$b186cb408b99d7fc(dictContravariant);
    return function(x) {
        return function(f) {
            return cmap1(f)(x);
        };
    };
};
var $de7e5b0b395c3745$export$8c14e57e778d3873 = function(dictContravariant) {
    var cmap1 = $de7e5b0b395c3745$export$b186cb408b99d7fc(dictContravariant);
    return function(dictFunctor) {
        var map = $7FzSN.map(dictFunctor);
        return function(a) {
            return map($Hhp3L.absurd)(cmap1($Hhp3L.absurd)(a));
        };
    };
};
var $de7e5b0b395c3745$export$dc224e55acb863f5 = function(dictContravariant) {
    var cmap1 = $de7e5b0b395c3745$export$b186cb408b99d7fc(dictContravariant);
    return function(v) {
        return function(f) {
            return cmap1(f);
        };
    };
};



var $7nwca = parcelRequire("7nwca");
// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $46y1S = parcelRequire("46y1S");
var $5f0af51369e64665$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $5f0af51369e64665$var$wrap = /* #__PURE__ */ $46y1S.wrap();
var $5f0af51369e64665$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $5f0af51369e64665$export$e10497e40cde5fd3 = {
    dimap: function(a2b) {
        return function(c2d) {
            return function(b2c) {
                return function($18) {
                    return c2d(b2c(a2b($18)));
                };
            };
        };
    }
};
var $5f0af51369e64665$export$7c344215185fc3ac = function(dict) {
    return dict.dimap;
};
var $5f0af51369e64665$export$48f54268254cf7d0 = function(dictProfunctor) {
    var dimap1 = $5f0af51369e64665$export$7c344215185fc3ac(dictProfunctor);
    return function(a2b) {
        return dimap1(a2b)($5f0af51369e64665$var$identity);
    };
};
var $5f0af51369e64665$export$6630987c9d273301 = function(dictProfunctor) {
    var dimap1 = $5f0af51369e64665$export$7c344215185fc3ac(dictProfunctor);
    return function(b2c) {
        return dimap1($5f0af51369e64665$var$identity)(b2c);
    };
};
var $5f0af51369e64665$export$93b4506d26e3367 = function(dictProfunctor) {
    var dimap1 = $5f0af51369e64665$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return dimap1($5f0af51369e64665$var$wrap)($5f0af51369e64665$var$unwrap);
    };
};
var $5f0af51369e64665$export$d25bf6793fd4dfcb = function(dictProfunctor) {
    var dimap1 = $5f0af51369e64665$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return function(v) {
            return dimap1($5f0af51369e64665$var$unwrap)($5f0af51369e64665$var$wrap);
        };
    };
};
var $5f0af51369e64665$export$29d5d0b2414dfc5c = function(dictCategory) {
    var identity1 = $26SV5.identity(dictCategory);
    return function(dictProfunctor) {
        var rmap1 = $5f0af51369e64665$export$6630987c9d273301(dictProfunctor);
        return function(f) {
            return rmap1(f)(identity1);
        };
    };
};



var $7O0Q4 = parcelRequire("7O0Q4");
var $cf167883453a4dee$var$lcmap = /* #__PURE__ */ $5f0af51369e64665$export$48f54268254cf7d0($5f0af51369e64665$export$e10497e40cde5fd3);
var $cf167883453a4dee$export$c8d61c7aefcd2eb9 = function(x) {
    return x;
};
var $cf167883453a4dee$export$4b8724da343f8670 = function(dictExtend) {
    var composeCoKleisliFlipped = $eJa4O.composeCoKleisliFlipped(dictExtend);
    return {
        compose: function(v) {
            return function(v1) {
                return composeCoKleisliFlipped(v)(v1);
            };
        }
    };
};
var $cf167883453a4dee$export$7c2608c347081d34 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $65 = map(f);
                    return function($66) {
                        return g(v($65($66)));
                    };
                };
            };
        }
    };
};
var $cf167883453a4dee$export$1b28cf6e14cef765 = function(dictComonad) {
    var Functor0 = dictComonad.Extend0().Functor0();
    var map = $7FzSN.map(Functor0);
    var extract = $49WxQ.extract(dictComonad);
    var profunctorCostar1 = $cf167883453a4dee$export$7c2608c347081d34(Functor0);
    return {
        first: function(v) {
            return function(x) {
                return new $7O0Q4.Tuple(v(map($7O0Q4.fst)(x)), $7O0Q4.snd(extract(x)));
            };
        },
        second: function(v) {
            return function(x) {
                return new $7O0Q4.Tuple($7O0Q4.fst(extract(x)), v(map($7O0Q4.snd)(x)));
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $cf167883453a4dee$export$95b15c3b108c70f1 = {
    Coercible0: function() {
        return undefined;
    }
};
var $cf167883453a4dee$export$538b19297a2c28a0 = function(f) {
    return function(v) {
        return $cf167883453a4dee$var$lcmap(f)(v);
    };
};
var $cf167883453a4dee$export$85082d7f68510c56 = {
    map: function(f) {
        return function(v) {
            return function($67) {
                return f(v($67));
            };
        };
    }
};
var $cf167883453a4dee$export$c2eec9047e1c22f6 = {
    imap: /* #__PURE__ */ $7nwca.imapF($cf167883453a4dee$export$85082d7f68510c56)
};
var $cf167883453a4dee$export$6ca61216e8ebd2dc = {
    distribute: function(dictFunctor) {
        var map = $7FzSN.map(dictFunctor);
        return function(f) {
            return function(a) {
                return map(function(v) {
                    return v(a);
                })(f);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $7FzSN.map(dictFunctor);
        return function(f) {
            var $68 = $04114899412aeb9b$export$f02a9ddbe4480f19($cf167883453a4dee$export$6ca61216e8ebd2dc)(dictFunctor);
            var $69 = map(f);
            return function($70) {
                return $68($69($70));
            };
        };
    },
    Functor0: function() {
        return $cf167883453a4dee$export$85082d7f68510c56;
    }
};
var $cf167883453a4dee$export$45296f90ce78a5aa = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    var profunctorCostar1 = $cf167883453a4dee$export$7c2608c347081d34(dictFunctor);
    return {
        closed: function(v) {
            return function(g) {
                return function(x) {
                    return v(map(function(v1) {
                        return v1(x);
                    })(g));
                };
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $cf167883453a4dee$export$1b18a904dcda2b6c = function(dictComonad) {
    var semigroupoidCostar1 = $cf167883453a4dee$export$4b8724da343f8670(dictComonad.Extend0());
    return {
        identity: $49WxQ.extract(dictComonad),
        Semigroupoid0: function() {
            return semigroupoidCostar1;
        }
    };
};
var $cf167883453a4dee$export$12684125bae58283 = function(dictContravariant) {
    var cmap = $de7e5b0b395c3745$export$b186cb408b99d7fc(dictContravariant);
    return {
        bimap: function(f) {
            return function(g) {
                return function(v) {
                    var $71 = cmap(f);
                    return function($72) {
                        return g(v($71($72)));
                    };
                };
            };
        }
    };
};
var $cf167883453a4dee$export$bee433edbc7aed34 = {
    apply: function(v) {
        return function(v1) {
            return function(a) {
                return v(a)(v1(a));
            };
        };
    },
    Functor0: function() {
        return $cf167883453a4dee$export$85082d7f68510c56;
    }
};
var $cf167883453a4dee$export$9af761d291db49ef = {
    bind: function(v) {
        return function(f) {
            return function(x) {
                var v1 = f(v(x));
                return v1(x);
            };
        };
    },
    Apply0: function() {
        return $cf167883453a4dee$export$bee433edbc7aed34;
    }
};
var $cf167883453a4dee$export$ddef3771953a3c3c = {
    pure: function(a) {
        return function(v) {
            return a;
        };
    },
    Apply0: function() {
        return $cf167883453a4dee$export$bee433edbc7aed34;
    }
};
var $cf167883453a4dee$export$88fc0f5d12a9e446 = {
    Applicative0: function() {
        return $cf167883453a4dee$export$ddef3771953a3c3c;
    },
    Bind1: function() {
        return $cf167883453a4dee$export$9af761d291db49ef;
    }
};



var $h2xUu = parcelRequire("h2xUu");
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $j7FrY = parcelRequire("j7FrY");


var $beQI1 = parcelRequire("beQI1");

var $7FzSN = parcelRequire("7FzSN");

var $7nwca = parcelRequire("7nwca");

var $7O0Q4 = parcelRequire("7O0Q4");
var $1b86fd31b6915ce5$export$1644ba17714857f1 = function(x) {
    return x;
};
var $1b86fd31b6915ce5$export$5c32215407d0c561 = function(dictBind) {
    var bind = $cADnC.bind(dictBind);
    return {
        compose: function(v) {
            return function(v1) {
                return function(x) {
                    return bind(v1(x))(v);
                };
            };
        }
    };
};
var $1b86fd31b6915ce5$export$a1c7b121a12f67f7 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $127 = map(g);
                    return function($128) {
                        return $127(v(f($128)));
                    };
                };
            };
        }
    };
};
var $1b86fd31b6915ce5$export$1bd208d997e69566 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    var profunctorStar1 = $1b86fd31b6915ce5$export$a1c7b121a12f67f7(dictFunctor);
    return {
        first: function(v) {
            return function(v1) {
                return map(function(v2) {
                    return new $7O0Q4.Tuple(v2, v1.value1);
                })(v(v1.value0));
            };
        },
        second: function(v) {
            return function(v1) {
                return map($7O0Q4.Tuple.create(v1.value0))(v(v1.value1));
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$5646bceeba0ed2e7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $1b86fd31b6915ce5$export$8ba4b27aef989a18 = function(dictInvariant) {
    var imap = $7nwca.imap(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    var $129 = imap(f)(g);
                    return function($130) {
                        return $129(v($130));
                    };
                };
            };
        }
    };
};
var $1b86fd31b6915ce5$export$e7b43b239cd8e22a = function(f) {
    return function(v) {
        return function($131) {
            return f(v($131));
        };
    };
};
var $1b86fd31b6915ce5$export$a72d0b1c26a6fe63 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                var $132 = map(f);
                return function($133) {
                    return $132(v($133));
                };
            };
        }
    };
};
var $1b86fd31b6915ce5$export$8e00b62431cd4eb7 = function(dictDistributive) {
    var collect = $04114899412aeb9b$export$bb44f104e3c54dae(dictDistributive);
    var functorStar1 = $1b86fd31b6915ce5$export$a72d0b1c26a6fe63(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(f) {
                return function(a) {
                    return collect1(function(v) {
                        return v(a);
                    })(f);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $7FzSN.map(dictFunctor);
            return function(f) {
                var $134 = $04114899412aeb9b$export$f02a9ddbe4480f19($1b86fd31b6915ce5$export$8e00b62431cd4eb7(dictDistributive))(dictFunctor);
                var $135 = map(f);
                return function($136) {
                    return $134($135($136));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$ee38dceaf1b0a7c1 = function(dictDistributive) {
    var distribute = $04114899412aeb9b$export$f02a9ddbe4480f19(dictDistributive)($7FzSN.functorFn);
    var profunctorStar1 = $1b86fd31b6915ce5$export$a1c7b121a12f67f7(dictDistributive.Functor0());
    return {
        closed: function(v) {
            return function(g) {
                return distribute(function($137) {
                    return v(g($137));
                });
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$9b633f3f90080760 = function(dictApplicative) {
    var Functor0 = dictApplicative.Apply0().Functor0();
    var map = $7FzSN.map(Functor0);
    var pure = $bQdkN.pure(dictApplicative);
    var profunctorStar1 = $1b86fd31b6915ce5$export$a1c7b121a12f67f7(Functor0);
    return {
        left: function(v) {
            return $beQI1.either(function() {
                var $138 = map($beQI1.Left.create);
                return function($139) {
                    return $138(v($139));
                };
            }())(function($140) {
                return pure($beQI1.Right.create($140));
            });
        },
        right: function(v) {
            return $beQI1.either(function($141) {
                return pure($beQI1.Left.create($141));
            })(function() {
                var $142 = map($beQI1.Right.create);
                return function($143) {
                    return $142(v($143));
                };
            }());
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$2315b5444b191e9f = function(dictMonad) {
    var semigroupoidStar1 = $1b86fd31b6915ce5$export$5c32215407d0c561(dictMonad.Bind1());
    return {
        identity: $bQdkN.pure(dictMonad.Applicative0()),
        Semigroupoid0: function() {
            return semigroupoidStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$3a827cf342dc199f = function(dictApply) {
    var apply = $26ZCq.apply(dictApply);
    var functorStar1 = $1b86fd31b6915ce5$export$a72d0b1c26a6fe63(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(a) {
                    return apply(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$a9fd453e55672cc4 = function(dictBind) {
    var bind = $cADnC.bind(dictBind);
    var applyStar1 = $1b86fd31b6915ce5$export$3a827cf342dc199f(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(f) {
                return function(x) {
                    return bind(v(x))(function(a) {
                        var v1 = f(a);
                        return v1(x);
                    });
                };
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$7a1642fc72453036 = function(dictApplicative) {
    var pure = $bQdkN.pure(dictApplicative);
    var applyStar1 = $1b86fd31b6915ce5$export$3a827cf342dc199f(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(v) {
                return pure(a);
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$be30334ea1d81019 = function(dictMonad) {
    var applicativeStar1 = $1b86fd31b6915ce5$export$7a1642fc72453036(dictMonad.Applicative0());
    var bindStar1 = $1b86fd31b6915ce5$export$a9fd453e55672cc4(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Bind1: function() {
            return bindStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$35f44c8ce889b889 = function(dictAlt) {
    var alt = $56VjJ.alt(dictAlt);
    var functorStar1 = $1b86fd31b6915ce5$export$a72d0b1c26a6fe63(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(a) {
                    return alt(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$a37a0eff981675fc = function(dictPlus) {
    var empty = $j7FrY.empty(dictPlus);
    var altStar1 = $1b86fd31b6915ce5$export$35f44c8ce889b889(dictPlus.Alt0());
    return {
        empty: function(v) {
            return empty;
        },
        Alt0: function() {
            return altStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$b508333aabf9ba3d = function(dictAlternative) {
    var applicativeStar1 = $1b86fd31b6915ce5$export$7a1642fc72453036(dictAlternative.Applicative0());
    var plusStar1 = $1b86fd31b6915ce5$export$a37a0eff981675fc(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Plus1: function() {
            return plusStar1;
        }
    };
};
var $1b86fd31b6915ce5$export$7fe0d763dfe145d = function(dictMonadPlus) {
    var monadStar1 = $1b86fd31b6915ce5$export$be30334ea1d81019(dictMonadPlus.Monad0());
    var alternativeStar1 = $1b86fd31b6915ce5$export$b508333aabf9ba3d(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStar1;
        },
        Alternative1: function() {
            return alternativeStar1;
        }
    };
};



var $2jM6U = parcelRequire("2jM6U");


var $7fHqi = parcelRequire("7fHqi");
var $ef3bc277abaf9997$var$discard = /* #__PURE__ */ $cADnC.discard($cADnC.discardUnit);
var $ef3bc277abaf9997$export$e97768dcd3ffe6df = function(x) {
    return x;
};
var $ef3bc277abaf9997$export$3c7b24ce1c81e349 = function(dict) {
    return dict.sequential;
};
var $ef3bc277abaf9997$export$451942af9381149c = function(dict) {
    return dict.parallel;
};
var $ef3bc277abaf9997$export$ddc88912bc863338 = {
    Coercible0: function() {
        return undefined;
    }
};
var $ef3bc277abaf9997$export$76ad2e05fec13cc8 = function(dictMonoid) {
    var monadWriterT = $6765fe209155a20b$export$a45df43c41b778a(dictMonoid);
    var applicativeWriterT = $6765fe209155a20b$export$c3b0a193a5475c40(dictMonoid);
    return function(dictParallel) {
        var monadWriterT1 = monadWriterT(dictParallel.Monad0());
        var applicativeWriterT1 = applicativeWriterT(dictParallel.Applicative1());
        return {
            parallel: $6765fe209155a20b$export$c950a71321ef1ffc($ef3bc277abaf9997$export$451942af9381149c(dictParallel)),
            sequential: $6765fe209155a20b$export$c950a71321ef1ffc($ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel)),
            Monad0: function() {
                return monadWriterT1;
            },
            Applicative1: function() {
                return applicativeWriterT1;
            }
        };
    };
};
var $ef3bc277abaf9997$export$48c6c5bbf7c98dc9 = function(dictParallel) {
    var parallel1 = $ef3bc277abaf9997$export$451942af9381149c(dictParallel);
    var sequential1 = $ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel);
    var monadStar = $1b86fd31b6915ce5$export$be30334ea1d81019(dictParallel.Monad0());
    var applicativeStar = $1b86fd31b6915ce5$export$7a1642fc72453036(dictParallel.Applicative1());
    return {
        parallel: function(v) {
            return function($119) {
                return parallel1(v($119));
            };
        },
        sequential: function(v) {
            return function($120) {
                return sequential1(v($120));
            };
        },
        Monad0: function() {
            return monadStar;
        },
        Applicative1: function() {
            return applicativeStar;
        }
    };
};
var $ef3bc277abaf9997$export$cfbddc4e0911f419 = function(dictParallel) {
    var monadReaderT = $024201b10fb9f490$export$6f721f6865c71dd2(dictParallel.Monad0());
    var applicativeReaderT = $024201b10fb9f490$export$aef633589549fee0(dictParallel.Applicative1());
    return {
        parallel: $024201b10fb9f490$export$1b8048a192a96779($ef3bc277abaf9997$export$451942af9381149c(dictParallel)),
        sequential: $024201b10fb9f490$export$1b8048a192a96779($ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel)),
        Monad0: function() {
            return monadReaderT;
        },
        Applicative1: function() {
            return applicativeReaderT;
        }
    };
};
var $ef3bc277abaf9997$export$31d7210ae04b04da = function(dictParallel) {
    var parallel1 = $ef3bc277abaf9997$export$451942af9381149c(dictParallel);
    var sequential1 = $ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel);
    var monadMaybeT = $0084a6f1dda72e44$export$63cf87c0678a1d2c(dictParallel.Monad0());
    var applicativeCompose = $iMzH1.applicativeCompose(dictParallel.Applicative1())($h2xUu.applicativeMaybe);
    return {
        parallel: function(v) {
            return parallel1(v);
        },
        sequential: function(v) {
            return sequential1(v);
        },
        Monad0: function() {
            return monadMaybeT;
        },
        Applicative1: function() {
            return applicativeCompose;
        }
    };
};
var $ef3bc277abaf9997$export$29ed81e6361e826b = function(dictParallel) {
    var parallel1 = $ef3bc277abaf9997$export$451942af9381149c(dictParallel);
    var sequential1 = $ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel);
    var monadExceptT = $2603701dab447006$export$5a198347e9244c74(dictParallel.Monad0());
    var applicativeCompose = $iMzH1.applicativeCompose(dictParallel.Applicative1())($beQI1.applicativeEither);
    return {
        parallel: function(v) {
            return parallel1(v);
        },
        sequential: function(v) {
            return sequential1(v);
        },
        Monad0: function() {
            return monadExceptT;
        },
        Applicative1: function() {
            return applicativeCompose;
        }
    };
};
var $ef3bc277abaf9997$export$36431f0cd2fca0df = function(dictParallel) {
    var sequential1 = $ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel);
    var parallel1 = $ef3bc277abaf9997$export$451942af9381149c(dictParallel);
    return {
        parallel: function(v) {
            return function($121) {
                return v(sequential1($121));
            };
        },
        sequential: function(v) {
            return function($122) {
                return v(parallel1($122));
            };
        },
        Monad0: function() {
            return $cf167883453a4dee$export$88fc0f5d12a9e446;
        },
        Applicative1: function() {
            return $cf167883453a4dee$export$ddef3771953a3c3c;
        }
    };
};
var $ef3bc277abaf9997$export$aecfbd788a6caa47 = function(dictMonadEffect) {
    var monadContT = $145dc4a2d647cf5f$export$735f43b0215ad39(dictMonadEffect.Monad0());
    return {
        parallel: $ef3bc277abaf9997$export$e97768dcd3ffe6df,
        sequential: function(v) {
            return v;
        },
        Monad0: function() {
            return monadContT;
        },
        Applicative1: function() {
            return $ef3bc277abaf9997$export$5823fd8d45c99450(dictMonadEffect);
        }
    };
};
var $ef3bc277abaf9997$export$bf3675a1b3711367 = function(dictMonadEffect) {
    var map = $7FzSN.map($145dc4a2d647cf5f$export$232156ef715cfc9b(dictMonadEffect.Monad0().Bind1().Apply0().Functor0()));
    return {
        map: function(f) {
            var $123 = $ef3bc277abaf9997$export$451942af9381149c($ef3bc277abaf9997$export$aecfbd788a6caa47(dictMonadEffect));
            var $124 = map(f);
            var $125 = $ef3bc277abaf9997$export$3c7b24ce1c81e349($ef3bc277abaf9997$export$aecfbd788a6caa47(dictMonadEffect));
            return function($126) {
                return $123($124($125($126)));
            };
        }
    };
};
var $ef3bc277abaf9997$export$803a06b7a7e59726 = function(dictMonadEffect) {
    var Bind1 = dictMonadEffect.Monad0().Bind1();
    var bind = $cADnC.bind(Bind1);
    var liftEffect = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
    var discard1 = $ef3bc277abaf9997$var$discard(Bind1);
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($7fHqi.new($h2xUu.Nothing.value)))(function(ra) {
                        return bind(liftEffect($7fHqi.new($h2xUu.Nothing.value)))(function(rb) {
                            return discard1($145dc4a2d647cf5f$export$358211fab263c66b(v)(function(a) {
                                return bind(liftEffect($7fHqi.read(rb)))(function(mb) {
                                    if (mb instanceof $h2xUu.Nothing) return liftEffect($7fHqi.write(new $h2xUu.Just(a))(ra));
                                    if (mb instanceof $h2xUu.Just) return k(a(mb.value0));
                                    throw new Error("Failed pattern match at Control.Parallel.Class (line 82, column 7 - line 84, column 26): " + [
                                        mb.constructor.name
                                    ]);
                                });
                            }))(function() {
                                return $145dc4a2d647cf5f$export$358211fab263c66b(v1)(function(b) {
                                    return bind(liftEffect($7fHqi.read(ra)))(function(ma) {
                                        if (ma instanceof $h2xUu.Nothing) return liftEffect($7fHqi.write(new $h2xUu.Just(b))(rb));
                                        if (ma instanceof $h2xUu.Just) return k(ma.value0(b));
                                        throw new Error("Failed pattern match at Control.Parallel.Class (line 88, column 7 - line 90, column 26): " + [
                                            ma.constructor.name
                                        ]);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return $ef3bc277abaf9997$export$bf3675a1b3711367(dictMonadEffect);
        }
    };
};
var $ef3bc277abaf9997$export$5823fd8d45c99450 = function(dictMonadEffect) {
    return {
        pure: function() {
            var $127 = $ef3bc277abaf9997$export$451942af9381149c($ef3bc277abaf9997$export$aecfbd788a6caa47(dictMonadEffect));
            var $128 = $bQdkN.pure($145dc4a2d647cf5f$export$d73f0595e894296c(dictMonadEffect.Monad0().Applicative0()));
            return function($129) {
                return $127($128($129));
            };
        }(),
        Apply0: function() {
            return $ef3bc277abaf9997$export$803a06b7a7e59726(dictMonadEffect);
        }
    };
};
var $ef3bc277abaf9997$export$e02ea57753bb8483 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $cADnC.bind(Bind1);
    var liftEffect = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
    var discard1 = $ef3bc277abaf9997$var$discard(Bind1);
    var pure = $bQdkN.pure(Monad0.Applicative0());
    var functorParCont1 = $ef3bc277abaf9997$export$bf3675a1b3711367(dictMonadEffect);
    return {
        alt: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($7fHqi.new(false)))(function(done) {
                        return discard1($145dc4a2d647cf5f$export$358211fab263c66b(v)(function(a) {
                            return bind(liftEffect($7fHqi.read(done)))(function(b) {
                                if (b) return pure($2jM6U.unit);
                                return discard1(liftEffect($7fHqi.write(true)(done)))(function() {
                                    return k(a);
                                });
                            });
                        }))(function() {
                            return $145dc4a2d647cf5f$export$358211fab263c66b(v1)(function(a) {
                                return bind(liftEffect($7fHqi.read(done)))(function(b) {
                                    if (b) return pure($2jM6U.unit);
                                    return discard1(liftEffect($7fHqi.write(true)(done)))(function() {
                                        return k(a);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorParCont1;
        }
    };
};
var $ef3bc277abaf9997$export$eed929a02bcaa239 = function(dictMonadEffect) {
    var pure = $bQdkN.pure(dictMonadEffect.Monad0().Applicative0());
    var altParCont1 = $ef3bc277abaf9997$export$e02ea57753bb8483(dictMonadEffect);
    return {
        empty: function(v) {
            return pure($2jM6U.unit);
        },
        Alt0: function() {
            return altParCont1;
        }
    };
};
var $ef3bc277abaf9997$export$2e55be12f6c16793 = function(dictMonadEffect) {
    var applicativeParCont1 = $ef3bc277abaf9997$export$5823fd8d45c99450(dictMonadEffect);
    var plusParCont1 = $ef3bc277abaf9997$export$eed929a02bcaa239(dictMonadEffect);
    return {
        Applicative0: function() {
            return applicativeParCont1;
        },
        Plus1: function() {
            return plusParCont1;
        }
    };
};



var $dNwPt = parcelRequire("dNwPt");

var $9OOYG = parcelRequire("9OOYG");
var $2dd7e3695251593b$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $2dd7e3695251593b$export$3b8cfe43eb195e1d = function(dictParallel) {
    var sequential = $ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel);
    var traverse_ = $dNwPt.traverse_(dictParallel.Applicative1());
    var parallel = $ef3bc277abaf9997$export$451942af9381149c(dictParallel);
    return function(dictFoldable) {
        var traverse_1 = traverse_(dictFoldable);
        return function(f) {
            var $48 = traverse_1(function($50) {
                return parallel(f($50));
            });
            return function($49) {
                return sequential($48($49));
            };
        };
    };
};
var $2dd7e3695251593b$export$bb703a54931a70b6 = function(dictParallel) {
    var sequential = $ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel);
    var Applicative1 = dictParallel.Applicative1();
    var parallel = $ef3bc277abaf9997$export$451942af9381149c(dictParallel);
    return function(dictTraversable) {
        var traverse = $9OOYG.traverse(dictTraversable)(Applicative1);
        return function(f) {
            var $51 = traverse(function($53) {
                return parallel(f($53));
            });
            return function($52) {
                return sequential($51($52));
            };
        };
    };
};
var $2dd7e3695251593b$export$a907a2b4fd85b16b = function(dictParallel) {
    var parTraverse_1 = $2dd7e3695251593b$export$3b8cfe43eb195e1d(dictParallel);
    return function(dictFoldable) {
        return parTraverse_1(dictFoldable)($2dd7e3695251593b$var$identity);
    };
};
var $2dd7e3695251593b$export$b9becc45c388432c = function(dictParallel) {
    var parTraverse1 = $2dd7e3695251593b$export$bb703a54931a70b6(dictParallel);
    return function(dictTraversable) {
        return parTraverse1(dictTraversable)($2dd7e3695251593b$var$identity);
    };
};
var $2dd7e3695251593b$export$a82aaa9906cdb569 = function(dictParallel) {
    var sequential = $ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $ef3bc277abaf9997$export$451942af9381149c(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $dNwPt.oneOfMap(dictFoldable)(Plus1);
            return function(dictFunctor) {
                return function(f) {
                    var $54 = oneOfMap(function($56) {
                        return parallel(f($56));
                    });
                    return function($55) {
                        return sequential($54($55));
                    };
                };
            };
        };
    };
};
var $2dd7e3695251593b$export$70e1ad49970879b5 = function(dictParallel) {
    var sequential = $ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $ef3bc277abaf9997$export$451942af9381149c(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $dNwPt.oneOfMap(dictFoldable)(Plus1);
            return function(dictFunctor) {
                var $57 = oneOfMap(parallel);
                return function($58) {
                    return sequential($57($58));
                };
            };
        };
    };
};
var $2dd7e3695251593b$export$3d88e33b68f7b8a5 = function(dictParallel) {
    var sequential = $ef3bc277abaf9997$export$3c7b24ce1c81e349(dictParallel);
    var apply = $26ZCq.apply(dictParallel.Applicative1().Apply0());
    var parallel = $ef3bc277abaf9997$export$451942af9381149c(dictParallel);
    return function(mf) {
        return function(ma) {
            return sequential(apply(parallel(mf))(parallel(ma)));
        };
    };
};




var $j7FrY = parcelRequire("j7FrY");

var $beQI1 = parcelRequire("beQI1");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");


var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");


// Generated by purs version 0.15.16
const $b81e9b4392e02a01$export$c62839628b30a695 = function(f) {
    return f();
};





var $lqv9L = parcelRequire("lqv9L");

var $k2DSm = parcelRequire("k2DSm");
var $7244ec56ae5630bd$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $7244ec56ae5630bd$var$pure = /* #__PURE__ */ $bQdkN.pure($1rTTn.applicativeEffect);
var $7244ec56ae5630bd$var$$$void = /* #__PURE__ */ $7FzSN.void($1rTTn.functorEffect);
var $7244ec56ae5630bd$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $7244ec56ae5630bd$var$pure1 = /* #__PURE__ */ $bQdkN.pure($beQI1.applicativeEither);
var $7244ec56ae5630bd$var$Fiber = function(x) {
    return x;
};
var $7244ec56ae5630bd$var$FFIUtil = function(x) {
    return x;
};
var $7244ec56ae5630bd$export$22f79b48f44c15eb = function(x) {
    return x;
};
var $7244ec56ae5630bd$export$4de6f17bc3dfa03 = /* #__PURE__ */ $c88db571692c73b3$export$f97e7884af471963(false);
var $7244ec56ae5630bd$export$608d3e3a27b14320 = {
    Coercible0: function() {
        return undefined;
    }
};
var $7244ec56ae5630bd$export$d7f9012ed771d686 = {
    map: $c88db571692c73b3$export$68695d37eb163711
};
var $7244ec56ae5630bd$export$e8a7d9b8d7dc616a = {
    map: $c88db571692c73b3$export$a0135aecf4a782ab
};
var $7244ec56ae5630bd$var$map1 = /* #__PURE__ */ $7FzSN.map($7244ec56ae5630bd$export$e8a7d9b8d7dc616a);
var $7244ec56ae5630bd$export$469c8a16c186651e = /* #__PURE__ */ $c88db571692c73b3$export$f97e7884af471963(true);
var $7244ec56ae5630bd$var$ffiUtil = /* #__PURE__ */ function() {
    var unsafeFromRight = function(v) {
        if (v instanceof $beQI1.Right) return v.value0;
        if (v instanceof $beQI1.Left) return $lqv9L.unsafeCrashWith("unsafeFromRight: Left");
        throw new Error("Failed pattern match at Effect.Aff (line 412, column 21 - line 414, column 54): " + [
            v.constructor.name
        ]);
    };
    var unsafeFromLeft = function(v) {
        if (v instanceof $beQI1.Left) return v.value0;
        if (v instanceof $beQI1.Right) return $lqv9L.unsafeCrashWith("unsafeFromLeft: Right");
        throw new Error("Failed pattern match at Effect.Aff (line 407, column 20 - line 409, column 55): " + [
            v.constructor.name
        ]);
    };
    var isLeft = function(v) {
        if (v instanceof $beQI1.Left) return true;
        if (v instanceof $beQI1.Right) return false;
        throw new Error("Failed pattern match at Effect.Aff (line 402, column 12 - line 404, column 21): " + [
            v.constructor.name
        ]);
    };
    return {
        isLeft: isLeft,
        fromLeft: unsafeFromLeft,
        fromRight: unsafeFromRight,
        left: $beQI1.Left.create,
        right: $beQI1.Right.create
    };
}();
var $7244ec56ae5630bd$var$makeFiber = function(aff) {
    return $c88db571692c73b3$export$f24188c8fd3f1234($7244ec56ae5630bd$var$ffiUtil, aff);
};
var $7244ec56ae5630bd$export$30b347ca11a80af4 = function(aff) {
    return function __do() {
        var fiber = $7244ec56ae5630bd$var$makeFiber(aff)();
        fiber.run();
        return fiber;
    };
};
var $7244ec56ae5630bd$export$c8704a1045ed544d = function($74) {
    return $7244ec56ae5630bd$var$$$void($7244ec56ae5630bd$export$30b347ca11a80af4($74));
};
var $7244ec56ae5630bd$export$d133944c527f2403 = $7244ec56ae5630bd$var$makeFiber;
var $7244ec56ae5630bd$export$1391212d75b2ee65 = function(v) {
    return $c88db571692c73b3$export$389c1406f5ae6ae7($beQI1.Right.create, v);
};
var $7244ec56ae5630bd$export$df5598cc12b9c8c = function(acquire) {
    return function(completed) {
        return $c88db571692c73b3$export$9ad792f02752f447(acquire)({
            killed: $jhsiw.const(completed),
            failed: $jhsiw.const(completed),
            completed: $jhsiw.const(completed)
        });
    };
};
var $7244ec56ae5630bd$export$83901714774e2edc = {
    apply: $c88db571692c73b3$export$bce00526579b3344,
    Functor0: function() {
        return $7244ec56ae5630bd$export$d7f9012ed771d686;
    }
};
var $7244ec56ae5630bd$var$lift2 = /* #__PURE__ */ $26ZCq.lift2($7244ec56ae5630bd$export$83901714774e2edc);
var $7244ec56ae5630bd$export$fc7e409bd1eae683 = function(dictSemigroup) {
    return {
        append: $7244ec56ae5630bd$var$lift2($d5vvq.append(dictSemigroup))
    };
};
var $7244ec56ae5630bd$export$b147a380fa8fdc0e = {
    Applicative0: function() {
        return $7244ec56ae5630bd$export$9dc0454a98607988;
    },
    Bind1: function() {
        return $7244ec56ae5630bd$export$f885f489dcf38a2d;
    }
};
var $7244ec56ae5630bd$export$f885f489dcf38a2d = {
    bind: $c88db571692c73b3$export$8fe95d71d8c6b6f3,
    Apply0: function() {
        return $7244ec56ae5630bd$var$$lazy_applyAff(0);
    }
};
var $7244ec56ae5630bd$export$9dc0454a98607988 = {
    pure: $c88db571692c73b3$export$68c6660df485915b,
    Apply0: function() {
        return $7244ec56ae5630bd$var$$lazy_applyAff(0);
    }
};
var $7244ec56ae5630bd$var$$lazy_applyAff = /* #__PURE__ */ $7244ec56ae5630bd$var$$runtime_lazy("applyAff", "Effect.Aff", function() {
    return {
        apply: $kkdfo.ap($7244ec56ae5630bd$export$b147a380fa8fdc0e),
        Functor0: function() {
            return $7244ec56ae5630bd$export$e8a7d9b8d7dc616a;
        }
    };
});
var $7244ec56ae5630bd$export$114a07f1fb466c63 = /* #__PURE__ */ $7244ec56ae5630bd$var$$lazy_applyAff(73);
var $7244ec56ae5630bd$var$pure2 = /* #__PURE__ */ $bQdkN.pure($7244ec56ae5630bd$export$9dc0454a98607988);
var $7244ec56ae5630bd$var$bind1 = /* #__PURE__ */ $cADnC.bind($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $7244ec56ae5630bd$var$lift21 = /* #__PURE__ */ $26ZCq.lift2($7244ec56ae5630bd$export$114a07f1fb466c63);
var $7244ec56ae5630bd$var$apply = /* #__PURE__ */ $26ZCq.apply($7244ec56ae5630bd$export$114a07f1fb466c63);
var $7244ec56ae5630bd$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $7244ec56ae5630bd$export$d0776e69f204de29 = function(aff) {
    return function(v) {
        return $c88db571692c73b3$export$9ad792f02752f447($7244ec56ae5630bd$var$pure2($2jM6U.unit))({
            killed: function(e) {
                return function(v1) {
                    return v(e);
                };
            },
            failed: $jhsiw.const($7244ec56ae5630bd$var$pure2),
            completed: $jhsiw.const($7244ec56ae5630bd$var$pure2)
        })($jhsiw.const(aff));
    };
};
var $7244ec56ae5630bd$export$7f8bd3bb7f01e042 = function(fin) {
    return function(a) {
        return $7244ec56ae5630bd$export$df5598cc12b9c8c($7244ec56ae5630bd$var$pure2($2jM6U.unit))($jhsiw.const(fin))($jhsiw.const(a));
    };
};
var $7244ec56ae5630bd$export$859f4dae848ac0ae = function(a) {
    return $7244ec56ae5630bd$export$df5598cc12b9c8c(a)($jhsiw.const($7244ec56ae5630bd$var$pure2($2jM6U.unit)))($7244ec56ae5630bd$var$pure2);
};
var $7244ec56ae5630bd$export$6c7682db87129472 = {
    defer: function(f) {
        return $7244ec56ae5630bd$var$bind1($7244ec56ae5630bd$var$pure2($2jM6U.unit))(f);
    }
};
var $7244ec56ae5630bd$export$1dbf838572c25e01 = function(dictSemigroup) {
    return {
        append: $7244ec56ae5630bd$var$lift21($d5vvq.append(dictSemigroup))
    };
};
var $7244ec56ae5630bd$export$666a030cecdf96c = {
    liftEffect: $c88db571692c73b3$export$3c6532f01a0290eb,
    Monad0: function() {
        return $7244ec56ae5630bd$export$b147a380fa8fdc0e;
    }
};
var $7244ec56ae5630bd$var$liftEffect = /* #__PURE__ */ $54d5aa8d31ad5798$export$34255e15eb56d2b3($7244ec56ae5630bd$export$666a030cecdf96c);
var $7244ec56ae5630bd$export$952106a975f35ae2 = function($75) {
    return $7244ec56ae5630bd$export$22f79b48f44c15eb($jhsiw.const($7244ec56ae5630bd$var$liftEffect($75)));
};
var $7244ec56ae5630bd$export$f3d782c2b95165ad = function(v) {
    return $c88db571692c73b3$export$49d5975414e0a979(function(k) {
        return $7244ec56ae5630bd$var$map($7244ec56ae5630bd$export$952106a975f35ae2)(v.join(k));
    });
};
var $7244ec56ae5630bd$export$29466a041ff3b3e0 = {
    map: function(f) {
        return function(t) {
            return $b81e9b4392e02a01$export$c62839628b30a695($7244ec56ae5630bd$var$makeFiber($7244ec56ae5630bd$var$map1(f)($7244ec56ae5630bd$export$f3d782c2b95165ad(t))));
        };
    }
};
var $7244ec56ae5630bd$export$4d705d914d07c7a7 = {
    apply: function(t1) {
        return function(t2) {
            return $b81e9b4392e02a01$export$c62839628b30a695($7244ec56ae5630bd$var$makeFiber($7244ec56ae5630bd$var$apply($7244ec56ae5630bd$export$f3d782c2b95165ad(t1))($7244ec56ae5630bd$export$f3d782c2b95165ad(t2))));
        };
    },
    Functor0: function() {
        return $7244ec56ae5630bd$export$29466a041ff3b3e0;
    }
};
var $7244ec56ae5630bd$export$6db27cd2d1558d76 = {
    pure: function(a) {
        return $b81e9b4392e02a01$export$c62839628b30a695($7244ec56ae5630bd$var$makeFiber($7244ec56ae5630bd$var$pure2(a)));
    },
    Apply0: function() {
        return $7244ec56ae5630bd$export$4d705d914d07c7a7;
    }
};
var $7244ec56ae5630bd$export$c65b2010df1810d = function(e) {
    return function(v) {
        return $7244ec56ae5630bd$var$bind1($7244ec56ae5630bd$var$liftEffect(v.isSuspended))(function(suspended) {
            if (suspended) return $7244ec56ae5630bd$var$liftEffect($7244ec56ae5630bd$var$$$void(v.kill(e, $jhsiw.const($7244ec56ae5630bd$var$pure($2jM6U.unit)))));
            return $c88db571692c73b3$export$49d5975414e0a979(function(k) {
                return $7244ec56ae5630bd$var$map($7244ec56ae5630bd$export$952106a975f35ae2)(v.kill(e, k));
            });
        });
    };
};
var $7244ec56ae5630bd$export$12fb9217a4d25158 = /* #__PURE__ */ function() {
    var $76 = $jhsiw.flip($7244ec56ae5630bd$export$c65b2010df1810d);
    return function($77) {
        return $7244ec56ae5630bd$export$22f79b48f44c15eb($76($77));
    };
}();
var $7244ec56ae5630bd$export$d9b2f32f45e29810 = {
    liftST: /* #__PURE__ */ function() {
        var $78 = $c4342a0c2c1aab96$export$90556654c9c47d5f($c4342a0c2c1aab96$export$d1b56b21630310a5);
        return function($79) {
            return $7244ec56ae5630bd$var$liftEffect($78($79));
        };
    }(),
    Monad0: function() {
        return $7244ec56ae5630bd$export$b147a380fa8fdc0e;
    }
};
var $7244ec56ae5630bd$export$37a9b80154c7d256 = {
    throwError: $c88db571692c73b3$export$520252a01094c36e,
    Monad0: function() {
        return $7244ec56ae5630bd$export$b147a380fa8fdc0e;
    }
};
var $7244ec56ae5630bd$export$9efce1646e93cba4 = {
    catchError: $c88db571692c73b3$export$eb5e86cd5464556e,
    MonadThrow0: function() {
        return $7244ec56ae5630bd$export$37a9b80154c7d256;
    }
};
var $7244ec56ae5630bd$var$$$try = /* #__PURE__ */ $693a27a8782d8e71$export$410a452afcd48948($7244ec56ae5630bd$export$9efce1646e93cba4);
var $7244ec56ae5630bd$var$catchError = /* #__PURE__ */ $693a27a8782d8e71$export$3dede90624df3ba9($7244ec56ae5630bd$export$9efce1646e93cba4);
var $7244ec56ae5630bd$export$77f9e426014f6edd = $7244ec56ae5630bd$var$$$try;
var $7244ec56ae5630bd$export$60f50bfed4143f9d = function(k) {
    return function(aff) {
        return $7244ec56ae5630bd$export$30b347ca11a80af4($7244ec56ae5630bd$var$bindFlipped(function($80) {
            return $7244ec56ae5630bd$var$liftEffect(k($80));
        })($7244ec56ae5630bd$var$$$try(aff)));
    };
};
var $7244ec56ae5630bd$export$ef62257e6f8a5f8c = function(k) {
    return function(aff) {
        return $7244ec56ae5630bd$var$$$void($7244ec56ae5630bd$export$60f50bfed4143f9d(k)(aff));
    };
};
var $7244ec56ae5630bd$export$52011fb9f1f7b7e2 = function(k) {
    return function(aff) {
        return $7244ec56ae5630bd$export$d133944c527f2403($7244ec56ae5630bd$var$bindFlipped(function($81) {
            return $7244ec56ae5630bd$var$liftEffect(k($81));
        })($7244ec56ae5630bd$var$$$try(aff)));
    };
};
var $7244ec56ae5630bd$export$cb4623454f96d5e0 = {
    parallel: $k2DSm.unsafeCoerce,
    sequential: $c88db571692c73b3$export$139486a45824a247,
    Monad0: function() {
        return $7244ec56ae5630bd$export$b147a380fa8fdc0e;
    },
    Applicative1: function() {
        return $7244ec56ae5630bd$var$$lazy_applicativeParAff(0);
    }
};
var $7244ec56ae5630bd$var$$lazy_applicativeParAff = /* #__PURE__ */ $7244ec56ae5630bd$var$$runtime_lazy("applicativeParAff", "Effect.Aff", function() {
    return {
        pure: function() {
            var $82 = $ef3bc277abaf9997$export$451942af9381149c($7244ec56ae5630bd$export$cb4623454f96d5e0);
            return function($83) {
                return $82($7244ec56ae5630bd$var$pure2($83));
            };
        }(),
        Apply0: function() {
            return $7244ec56ae5630bd$export$83901714774e2edc;
        }
    };
});
var $7244ec56ae5630bd$export$389e6cb252ce112f = /* #__PURE__ */ $7244ec56ae5630bd$var$$lazy_applicativeParAff(136);
var $7244ec56ae5630bd$var$pure3 = /* #__PURE__ */ $bQdkN.pure($7244ec56ae5630bd$export$389e6cb252ce112f);
var $7244ec56ae5630bd$var$parSequence_ = /* #__PURE__ */ $2dd7e3695251593b$export$a907a2b4fd85b16b($7244ec56ae5630bd$export$cb4623454f96d5e0)($dNwPt.foldableArray);
var $7244ec56ae5630bd$export$aa5306b4d3514fa0 = function(dictMonoid) {
    var semigroupParAff1 = $7244ec56ae5630bd$export$fc7e409bd1eae683(dictMonoid.Semigroup0());
    return {
        mempty: $7244ec56ae5630bd$var$pure3($3aOYV.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupParAff1;
        }
    };
};
var $7244ec56ae5630bd$export$1cab8188db0c4c1f = {
    append: function(v) {
        return function(v1) {
            return function(err) {
                return $7244ec56ae5630bd$var$parSequence_([
                    v(err),
                    v1(err)
                ]);
            };
        };
    }
};
var $7244ec56ae5630bd$export$54b8dc42dcff4ab1 = function(aff) {
    var killError = $f58bea5e58d54301$export$a3bc9b8ed74fc("[Aff] Child fiber outlived parent");
    var killAll = function(err) {
        return function(sup) {
            return $c88db571692c73b3$export$49d5975414e0a979(function(k) {
                return $c88db571692c73b3$export$a494cc11bfc0c750(err, sup.supervisor, k($7244ec56ae5630bd$var$pure1($2jM6U.unit)));
            });
        };
    };
    var acquire = function __do() {
        var sup = $c88db571692c73b3$export$7a3baea9562462c7($7244ec56ae5630bd$var$ffiUtil, aff)();
        sup.fiber.run();
        return sup;
    };
    return $c88db571692c73b3$export$9ad792f02752f447($7244ec56ae5630bd$var$liftEffect(acquire))({
        killed: function(err) {
            return function(sup) {
                return $7244ec56ae5630bd$var$parSequence_([
                    $7244ec56ae5630bd$export$c65b2010df1810d(err)(sup.fiber),
                    killAll(err)(sup)
                ]);
            };
        },
        failed: $jhsiw.const(killAll(killError)),
        completed: $jhsiw.const(killAll(killError))
    })(function($84) {
        return $7244ec56ae5630bd$export$f3d782c2b95165ad(function(v) {
            return v.fiber;
        }($84));
    });
};
var $7244ec56ae5630bd$export$974f8db4a62dd716 = {
    tailRecM: function(k) {
        var go = function(a) {
            return $7244ec56ae5630bd$var$bind1(k(a))(function(res) {
                if (res instanceof $bcJ05.Done) return $7244ec56ae5630bd$var$pure2(res.value0);
                if (res instanceof $bcJ05.Loop) return go(res.value0);
                throw new Error("Failed pattern match at Effect.Aff (line 104, column 7 - line 106, column 23): " + [
                    res.constructor.name
                ]);
            });
        };
        return go;
    },
    Monad0: function() {
        return $7244ec56ae5630bd$export$b147a380fa8fdc0e;
    }
};
var $7244ec56ae5630bd$export$b59d1737970253ab = function(dictMonoid) {
    var semigroupAff1 = $7244ec56ae5630bd$export$1dbf838572c25e01(dictMonoid.Semigroup0());
    return {
        mempty: $7244ec56ae5630bd$var$pure2($3aOYV.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupAff1;
        }
    };
};
var $7244ec56ae5630bd$export$8deb6e154ce67af6 = /* #__PURE__ */ $jhsiw.const(/* #__PURE__ */ $7244ec56ae5630bd$var$pure2($2jM6U.unit));
var $7244ec56ae5630bd$export$800a937b75981c0e = {
    mempty: $7244ec56ae5630bd$export$8deb6e154ce67af6,
    Semigroup0: function() {
        return $7244ec56ae5630bd$export$1cab8188db0c4c1f;
    }
};
var $7244ec56ae5630bd$var$mempty = /* #__PURE__ */ $3aOYV.mempty($7244ec56ae5630bd$export$800a937b75981c0e);
var $7244ec56ae5630bd$export$b3e22bcfd64c1022 = /* #__PURE__ */ $c88db571692c73b3$export$49d5975414e0a979(function(v) {
    return $7244ec56ae5630bd$var$pure($7244ec56ae5630bd$var$mempty);
});
var $7244ec56ae5630bd$export$a19cb95a0294477 = /* #__PURE__ */ function() {
    var $85 = $7244ec56ae5630bd$var$map1($jhsiw.const($2jM6U.unit));
    return function($86) {
        return $85($7244ec56ae5630bd$export$77f9e426014f6edd($86));
    };
}();
var $7244ec56ae5630bd$export$371c34bc9954b4c6 = {
    alt: $c88db571692c73b3$export$6a44b66c7edadaa,
    Functor0: function() {
        return $7244ec56ae5630bd$export$d7f9012ed771d686;
    }
};
var $7244ec56ae5630bd$export$75f84a0612e9fcac = {
    alt: function(a1) {
        return function(a2) {
            return $7244ec56ae5630bd$var$catchError(a1)($jhsiw.const(a2));
        };
    },
    Functor0: function() {
        return $7244ec56ae5630bd$export$e8a7d9b8d7dc616a;
    }
};
var $7244ec56ae5630bd$export$982abcb51ccf01ce = {
    empty: /* #__PURE__ */ $693a27a8782d8e71$export$8bf7aba4a9e09055($7244ec56ae5630bd$export$37a9b80154c7d256)(/* #__PURE__ */ $f58bea5e58d54301$export$a3bc9b8ed74fc("Always fails")),
    Alt0: function() {
        return $7244ec56ae5630bd$export$75f84a0612e9fcac;
    }
};
var $7244ec56ae5630bd$export$a77596dfa1aa0c51 = {
    empty: /* #__PURE__ */ $ef3bc277abaf9997$export$451942af9381149c($7244ec56ae5630bd$export$cb4623454f96d5e0)(/* #__PURE__ */ $j7FrY.empty($7244ec56ae5630bd$export$982abcb51ccf01ce)),
    Alt0: function() {
        return $7244ec56ae5630bd$export$371c34bc9954b4c6;
    }
};
var $7244ec56ae5630bd$export$96ad65bdc35fd68a = {
    Applicative0: function() {
        return $7244ec56ae5630bd$export$389e6cb252ce112f;
    },
    Plus1: function() {
        return $7244ec56ae5630bd$export$a77596dfa1aa0c51;
    }
};


// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");


// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $kkdfo = parcelRequire("kkdfo");

var $bcJ05 = parcelRequire("bcJ05");


var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $3gIn7 = parcelRequire("3gIn7");

var $h2xUu = parcelRequire("h2xUu");

var $d5vvq = parcelRequire("d5vvq");

var $7O0Q4 = parcelRequire("7O0Q4");

var $2jM6U = parcelRequire("2jM6U");

var $34a4e1610a6ffedc$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $34a4e1610a6ffedc$var$map1 = /* #__PURE__ */ $7FzSN.map($3gIn7.functorLazy);
var $34a4e1610a6ffedc$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $34a4e1610a6ffedc$var$pure = /* #__PURE__ */ $bQdkN.pure($3gIn7.applicativeLazy);
var $34a4e1610a6ffedc$export$1bffd077443cd981 = /* #__PURE__ */ function() {
    function Yield(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Yield.create = function(value0) {
        return function(value1) {
            return new Yield(value0, value1);
        };
    };
    return Yield;
}();
var $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0 = /* #__PURE__ */ function() {
    function Skip(value0) {
        this.value0 = value0;
    }
    Skip.create = function(value0) {
        return new Skip(value0);
    };
    return Skip;
}();
var $34a4e1610a6ffedc$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done() {}
    Done.value = new Done();
    return Done;
}();
var $34a4e1610a6ffedc$export$4ae3cbbaa857dd72 = function(x) {
    return x;
};
var $34a4e1610a6ffedc$export$72a5dac3748973f0 = function(dictApplicative) {
    var pure1 = $bQdkN.pure(dictApplicative);
    return function(v) {
        return pure1(new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0(v));
    };
};
var $34a4e1610a6ffedc$export$860beaf0e87f1a9f = function(dictFunctor) {
    var map2 = $7FzSN.map(dictFunctor);
    return function(v) {
        return map2(function($332) {
            return $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0.create($3gIn7.defer($jhsiw.const($332)));
        })(v);
    };
};
var $34a4e1610a6ffedc$export$c48e357c1a89b78d = function(dictMonad) {
    var map2 = $7FzSN.map(dictMonad.Bind1().Apply0().Functor0());
    return function(f) {
        return function(z) {
            var g = function(v) {
                if (v instanceof $h2xUu.Just) return new $34a4e1610a6ffedc$export$1bffd077443cd981(v.value0.value1, $3gIn7.defer(function(v1) {
                    return $34a4e1610a6ffedc$export$c48e357c1a89b78d(dictMonad)(f)(v.value0.value0);
                }));
                if (v instanceof $h2xUu.Nothing) return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 129, column 3 - line 129, column 60): " + [
                    v.constructor.name
                ]);
            };
            return map2(g)(f(z));
        };
    };
};
var $34a4e1610a6ffedc$export$b446f6baa3bb1430 = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    var bind = $cADnC.bind(dictMonad.Bind1());
    return function(v) {
        var g = function(v1) {
            if (v1 instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) return pure1(new $h2xUu.Just(new $7O0Q4.Tuple(v1.value0, $3gIn7.force(v1.value1))));
            if (v1 instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return $34a4e1610a6ffedc$export$b446f6baa3bb1430(dictMonad)($3gIn7.force(v1.value0));
            if (v1 instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return pure1($h2xUu.Nothing.value);
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 194, column 3 - line 194, column 50): " + [
                v1.constructor.name
            ]);
        };
        return bind(v)(g);
    };
};
var $34a4e1610a6ffedc$export$c01875f616615628 = function(dictMonad) {
    var map2 = $7FzSN.map(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $34a4e1610a6ffedc$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($34a4e1610a6ffedc$var$map($7O0Q4.snd))(uncons1(l));
    };
};
var $34a4e1610a6ffedc$var$stepMap = function(dictFunctor) {
    var map2 = $7FzSN.map(dictFunctor);
    return function(f) {
        return function(v) {
            return map2(f)(v);
        };
    };
};
var $34a4e1610a6ffedc$export$9384c7afe4015e42 = function(dictApplicative) {
    var stepMap1 = $34a4e1610a6ffedc$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) {
                var $249 = f(v.value0);
                if ($249) return new $34a4e1610a6ffedc$export$1bffd077443cd981(v.value0, $34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$9384c7afe4015e42(dictApplicative)(f))(v.value1));
                return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
            }
            if (v instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$9384c7afe4015e42(dictApplicative)(f))(v.value0));
            if (v instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 153, column 3 - line 153, column 68): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $34a4e1610a6ffedc$export$65f513eaf3c582b8 = function(dictMonad) {
    var map2 = $7FzSN.map(dictMonad.Bind1().Apply0().Functor0());
    var unfold1 = $34a4e1610a6ffedc$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(b) {
            return function(l) {
                var g = function(v) {
                    var h = function(v1) {
                        if (v1 instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) {
                            var b$prime$prime = f(v.value0)(v1.value0);
                            return new $h2xUu.Just(new $7O0Q4.Tuple(new $7O0Q4.Tuple(b$prime$prime, $3gIn7.force(v1.value1)), v.value0));
                        }
                        if (v1 instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return new $h2xUu.Just(new $7O0Q4.Tuple(new $7O0Q4.Tuple(v.value0, $3gIn7.force(v1.value0)), v.value0));
                        if (v1 instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return $h2xUu.Nothing.value;
                        throw new Error("Failed pattern match at Control.Monad.List.Trans (line 247, column 5 - line 247, column 78): " + [
                            v1.constructor.name
                        ]);
                    };
                    return map2(h)(v.value1);
                };
                return unfold1(g)(new $7O0Q4.Tuple(b, l));
            };
        };
    };
};
var $34a4e1610a6ffedc$export$3466dae21163a3ee = function(dictApplicative) {
    var pure1 = $bQdkN.pure(dictApplicative);
    return function(h) {
        return function(t) {
            return pure1(new $34a4e1610a6ffedc$export$1bffd077443cd981(h, t));
        };
    };
};
var $34a4e1610a6ffedc$export$68159836694e22c1 = function(dictApplicative) {
    var prepend$prime1 = $34a4e1610a6ffedc$export$3466dae21163a3ee(dictApplicative);
    return function(h) {
        return function(t) {
            return prepend$prime1(h)($3gIn7.defer($jhsiw.const(t)));
        };
    };
};
var $34a4e1610a6ffedc$export$f2c4f74e8fe88e34 = function(dictApplicative) {
    return $bQdkN.pure(dictApplicative)($34a4e1610a6ffedc$export$7fe28cb29e71bf10.value);
};
var $34a4e1610a6ffedc$export$439306a4dcaafbb9 = function(dictApplicative) {
    var prepend1 = $34a4e1610a6ffedc$export$68159836694e22c1(dictApplicative);
    var nil1 = $34a4e1610a6ffedc$export$f2c4f74e8fe88e34(dictApplicative);
    return function(a) {
        return prepend1(a)(nil1);
    };
};
var $34a4e1610a6ffedc$export$b7df5d561049483a = function(dictApplicative) {
    var nil1 = $34a4e1610a6ffedc$export$f2c4f74e8fe88e34(dictApplicative);
    var stepMap1 = $34a4e1610a6ffedc$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return nil1;
            var f = function(v2) {
                if (v2 instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) return new $34a4e1610a6ffedc$export$1bffd077443cd981(v2.value0, $34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$b7df5d561049483a(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$b7df5d561049483a(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 146, column 3 - line 146, column 47): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $34a4e1610a6ffedc$export$e3b52f6f0a4bd72e = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var pure1 = $bQdkN.pure(Applicative0);
    var nil1 = $34a4e1610a6ffedc$export$f2c4f74e8fe88e34(Applicative0);
    var Bind1 = dictMonad.Bind1();
    var Functor0 = Bind1.Apply0().Functor0();
    var map2 = $7FzSN.map(Functor0);
    var prepend$prime1 = $34a4e1610a6ffedc$export$3466dae21163a3ee(Applicative0);
    var wrapEffect1 = $34a4e1610a6ffedc$export$860beaf0e87f1a9f(Functor0);
    var bind = $cADnC.bind(Bind1);
    var uncons1 = $34a4e1610a6ffedc$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var g = function(v) {
            return function(v1) {
                if (v1 instanceof $h2xUu.Nothing) return pure1(nil1);
                if (v instanceof $h2xUu.Nothing) return pure1(nil1);
                if (v instanceof $h2xUu.Just && v1 instanceof $h2xUu.Just) return map2($jhsiw.flip(prepend$prime1)($3gIn7.defer(function(v2) {
                    return $34a4e1610a6ffedc$export$e3b52f6f0a4bd72e(dictMonad)(f)(v.value0.value1)(v1.value0.value1);
                })))(f(v.value0.value0)(v1.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 259, column 3 - line 259, column 25): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        var loop = function(fa) {
            return function(fb) {
                return wrapEffect1(bind(uncons1(fa))(function(ua) {
                    return bind(uncons1(fb))(function(ub) {
                        return g(ua)(ub);
                    });
                }));
            };
        };
        return loop;
    };
};
var $34a4e1610a6ffedc$export$b634740ce272acb5 = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    var zipWith$prime1 = $34a4e1610a6ffedc$export$e3b52f6f0a4bd72e(dictMonad);
    return function(f) {
        var g = function(a) {
            return function(b) {
                return pure1(f(a)(b));
            };
        };
        return zipWith$prime1(g);
    };
};
var $34a4e1610a6ffedc$export$acf0795b499e2d1a = {
    Coercible0: function() {
        return undefined;
    }
};
var $34a4e1610a6ffedc$export$e70771d2e7e590a = function(dictFunctor) {
    var stepMap1 = $34a4e1610a6ffedc$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) return $h2xUu.fromMaybe($34a4e1610a6ffedc$export$38d24f5c1eb0e4c0.create)($34a4e1610a6ffedc$var$map($34a4e1610a6ffedc$export$1bffd077443cd981.create)(f(v.value0)))($34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$e70771d2e7e590a(dictFunctor)(f))(v.value1));
            if (v instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$e70771d2e7e590a(dictFunctor)(f))(v.value0));
            if (v instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 182, column 3 - line 182, column 72): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $34a4e1610a6ffedc$export$c1a059043cc9c119 = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    var unfold1 = $34a4e1610a6ffedc$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(a) {
            var g = function(x) {
                return pure1(new $h2xUu.Just(new $7O0Q4.Tuple(f(x), x)));
            };
            return unfold1(g)(a);
        };
    };
};
var $34a4e1610a6ffedc$export$76d90c956114f2c2 = function(dictMonad) {
    return $34a4e1610a6ffedc$export$c1a059043cc9c119(dictMonad)($34a4e1610a6ffedc$var$identity);
};
var $34a4e1610a6ffedc$export$5fd5031fecdacec3 = function(dictMonad) {
    var map2 = $7FzSN.map(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $34a4e1610a6ffedc$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($34a4e1610a6ffedc$var$map($7O0Q4.fst))(uncons1(l));
    };
};
var $34a4e1610a6ffedc$export$5af6b427ff316359 = function(dictFunctor) {
    var stepMap1 = $34a4e1610a6ffedc$var$stepMap(dictFunctor);
    return {
        map: function(f) {
            var g = function(v) {
                if (v instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) return new $34a4e1610a6ffedc$export$1bffd077443cd981(f(v.value0), $34a4e1610a6ffedc$var$map1($7FzSN.map($34a4e1610a6ffedc$export$5af6b427ff316359(dictFunctor))(f))(v.value1));
                if (v instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1($7FzSN.map($34a4e1610a6ffedc$export$5af6b427ff316359(dictFunctor))(f))(v.value0));
                if (v instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 279, column 5 - line 279, column 48): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(g);
        }
    };
};
var $34a4e1610a6ffedc$export$df62323340295157 = function(dictApplicative) {
    var map2 = $7FzSN.map(dictApplicative.Apply0().Functor0());
    var nil1 = $34a4e1610a6ffedc$export$f2c4f74e8fe88e34(dictApplicative);
    return function(fa) {
        return map2($jhsiw.flip($34a4e1610a6ffedc$export$1bffd077443cd981.create)($3gIn7.defer(function(v) {
            return nil1;
        })))(fa);
    };
};
var $34a4e1610a6ffedc$export$619131e858bec5bb = {
    lift: function(dictMonad) {
        return $34a4e1610a6ffedc$export$df62323340295157(dictMonad.Applicative0());
    }
};
var $34a4e1610a6ffedc$var$lift = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($34a4e1610a6ffedc$export$619131e858bec5bb);
var $34a4e1610a6ffedc$export$5f62080e6ea5ad16 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $bQdkN.pure(Monad0.Applicative0());
    var bind = $cADnC.bind(Monad0.Bind1());
    var uncons1 = $34a4e1610a6ffedc$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $bcJ05.tailRecM2(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $h2xUu.Nothing) return pure1(new $bcJ05.Done(b));
                    if (v instanceof $h2xUu.Just) return bind(f(b)(v.value0.value0))(function(b$prime) {
                        return pure1(new $bcJ05.Loop({
                            a: b$prime,
                            b: v.value0.value1
                        }));
                    });
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 220, column 5 - line 220, column 45): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $34a4e1610a6ffedc$export$3120598051129cb3 = function(dictMonadRec) {
    var pure1 = $bQdkN.pure(dictMonadRec.Monad0().Applicative0());
    return $34a4e1610a6ffedc$export$5f62080e6ea5ad16(dictMonadRec)(function(v) {
        return function(v1) {
            return pure1($2jM6U.unit);
        };
    })($2jM6U.unit);
};
var $34a4e1610a6ffedc$export$48b115eebb7f3c53 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $bQdkN.pure(Monad0.Applicative0());
    var bind = $cADnC.bind(Monad0.Bind1());
    var uncons1 = $34a4e1610a6ffedc$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $bcJ05.tailRecM2(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $h2xUu.Nothing) return pure1(new $bcJ05.Done(b));
                    if (v instanceof $h2xUu.Just) return pure1(new $bcJ05.Loop({
                        a: f(b)(v.value0.value0),
                        b: v.value0.value1
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 238, column 7 - line 238, column 47): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $34a4e1610a6ffedc$export$fa87a49fad651048 = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    var bind = $cADnC.bind(dictMonad.Bind1());
    var uncons1 = $34a4e1610a6ffedc$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $h2xUu.Nothing) return pure1(b);
                    if (v instanceof $h2xUu.Just) return bind(f(b)(v.value0.value0))($jhsiw.flip(loop)(v.value0.value1));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 211, column 5 - line 211, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $34a4e1610a6ffedc$export$99ac321f734efd9b = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    return $34a4e1610a6ffedc$export$fa87a49fad651048(dictMonad)(function(v) {
        return function(v1) {
            return pure1($2jM6U.unit);
        };
    })($2jM6U.unit);
};
var $34a4e1610a6ffedc$export$50ae948ca12cdcbc = function(dictMonad) {
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    var bind = $cADnC.bind(dictMonad.Bind1());
    var uncons1 = $34a4e1610a6ffedc$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $h2xUu.Nothing) return pure1(b);
                    if (v instanceof $h2xUu.Just) return loop(f(b)(v.value0.value0))(v.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 228, column 5 - line 228, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $34a4e1610a6ffedc$export$3dea766d36a8935f = function(dictFunctor) {
    var stepMap1 = $34a4e1610a6ffedc$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) {
                var s$prime = $34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$3dea766d36a8935f(dictFunctor)(f))(v.value1);
                var $299 = f(v.value0);
                if ($299) return new $34a4e1610a6ffedc$export$1bffd077443cd981(v.value0, s$prime);
                return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) {
                var s$prime = $34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$3dea766d36a8935f(dictFunctor)(f))(v.value0);
                return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 175, column 3 - line 175, column 80): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $34a4e1610a6ffedc$export$533af5c8cd6afa16 = function(dictApplicative) {
    var stepMap1 = $34a4e1610a6ffedc$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) {
                var $304 = f(v.value0);
                if ($304) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$533af5c8cd6afa16(dictApplicative)(f))(v.value1));
                return new $34a4e1610a6ffedc$export$1bffd077443cd981(v.value0, v.value1);
            }
            if (v instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$533af5c8cd6afa16(dictApplicative)(f))(v.value0));
            if (v instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 168, column 3 - line 168, column 70): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $34a4e1610a6ffedc$export$663103110d94aac9 = function(dictApplicative) {
    var stepMap1 = $34a4e1610a6ffedc$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return v1;
            var f = function(v2) {
                if (v2 instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$663103110d94aac9(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1($34a4e1610a6ffedc$export$663103110d94aac9(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 161, column 3 - line 161, column 44): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $34a4e1610a6ffedc$export$8327ebbef2a0ba76 = function(dictApplicative) {
    var pure1 = $bQdkN.pure(dictApplicative);
    return function(lh) {
        return function(t) {
            return pure1(new $34a4e1610a6ffedc$export$1bffd077443cd981($3gIn7.force(lh), t));
        };
    };
};
var $34a4e1610a6ffedc$export$e5d91f6921d97963 = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var singleton1 = $34a4e1610a6ffedc$export$439306a4dcaafbb9(Applicative0);
    var cons1 = $34a4e1610a6ffedc$export$8327ebbef2a0ba76(Applicative0);
    return {
        unfoldr1: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v.value1 instanceof $h2xUu.Nothing) return singleton1(v.value0);
                    if (v.value1 instanceof $h2xUu.Just) return cons1($34a4e1610a6ffedc$var$pure(v.value0))($3gIn7.defer(function(v1) {
                        return go(f(v.value1.value0));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 293, column 12 - line 295, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        }
    };
};
var $34a4e1610a6ffedc$export$bbfbcefbf94b996f = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var nil1 = $34a4e1610a6ffedc$export$f2c4f74e8fe88e34(Applicative0);
    var cons1 = $34a4e1610a6ffedc$export$8327ebbef2a0ba76(Applicative0);
    var unfoldable1ListT1 = $34a4e1610a6ffedc$export$e5d91f6921d97963(dictMonad);
    return {
        unfoldr: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v instanceof $h2xUu.Nothing) return nil1;
                    if (v instanceof $h2xUu.Just) return cons1($34a4e1610a6ffedc$var$pure(v.value0.value0))($3gIn7.defer(function(v1) {
                        return go(f(v.value0.value1));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 286, column 12 - line 288, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        },
        Unfoldable10: function() {
            return unfoldable1ListT1;
        }
    };
};
var $34a4e1610a6ffedc$export$e65aba2be8e37f8a = function(dictApplicative) {
    return {
        append: $34a4e1610a6ffedc$var$concat(dictApplicative)
    };
};
var $34a4e1610a6ffedc$var$concat = function(dictApplicative) {
    var stepMap1 = $34a4e1610a6ffedc$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(x) {
        return function(y) {
            var f = function(v) {
                if (v instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) return new $34a4e1610a6ffedc$export$1bffd077443cd981(v.value0, $34a4e1610a6ffedc$var$map1(function(v1) {
                    return $d5vvq.append($34a4e1610a6ffedc$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value1));
                if (v instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1(function(v1) {
                    return $d5vvq.append($34a4e1610a6ffedc$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value0));
                if (v instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($3gIn7.defer($jhsiw.const(y)));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 105, column 3 - line 105, column 43): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(f)(x);
        };
    };
};
var $34a4e1610a6ffedc$export$6b8d2264760710b = function(dictApplicative) {
    var semigroupListT1 = $34a4e1610a6ffedc$export$e65aba2be8e37f8a(dictApplicative);
    return {
        mempty: $34a4e1610a6ffedc$export$f2c4f74e8fe88e34(dictApplicative),
        Semigroup0: function() {
            return semigroupListT1;
        }
    };
};
var $34a4e1610a6ffedc$export$986c2bbe7a34be0b = function(dictFunctor) {
    return $34a4e1610a6ffedc$export$e70771d2e7e590a(dictFunctor)($34a4e1610a6ffedc$var$identity);
};
var $34a4e1610a6ffedc$export$204d5ba0706a4088 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $34a4e1610a6ffedc$export$cf70c952df59e46e(dictMonad);
        },
        Bind1: function() {
            return $34a4e1610a6ffedc$export$871b02513702e0(dictMonad);
        }
    };
};
var $34a4e1610a6ffedc$export$871b02513702e0 = function(dictMonad) {
    var append = $d5vvq.append($34a4e1610a6ffedc$export$e65aba2be8e37f8a(dictMonad.Applicative0()));
    var stepMap1 = $34a4e1610a6ffedc$var$stepMap(dictMonad.Bind1().Apply0().Functor0());
    return {
        bind: function(fa) {
            return function(f) {
                var g = function(v) {
                    if (v instanceof $34a4e1610a6ffedc$export$1bffd077443cd981) {
                        var h = function(s$prime) {
                            return append(f(v.value0))($cADnC.bind($34a4e1610a6ffedc$export$871b02513702e0(dictMonad))(s$prime)(f));
                        };
                        return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1(h)(v.value1));
                    }
                    if (v instanceof $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0) return new $34a4e1610a6ffedc$export$38d24f5c1eb0e4c0($34a4e1610a6ffedc$var$map1(function(v1) {
                        return $cADnC.bind($34a4e1610a6ffedc$export$871b02513702e0(dictMonad))(v1)(f);
                    })(v.value0));
                    if (v instanceof $34a4e1610a6ffedc$export$7fe28cb29e71bf10) return $34a4e1610a6ffedc$export$7fe28cb29e71bf10.value;
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 305, column 5 - line 307, column 31): " + [
                        v.constructor.name
                    ]);
                };
                return stepMap1(g)(fa);
            };
        },
        Apply0: function() {
            return $34a4e1610a6ffedc$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $34a4e1610a6ffedc$export$fd7d3bacedac3347 = function(dictMonad) {
    var functorListT1 = $34a4e1610a6ffedc$export$5af6b427ff316359(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $kkdfo.ap($34a4e1610a6ffedc$export$204d5ba0706a4088(dictMonad)),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $34a4e1610a6ffedc$export$cf70c952df59e46e = function(dictMonad) {
    return {
        pure: $34a4e1610a6ffedc$export$439306a4dcaafbb9(dictMonad.Applicative0()),
        Apply0: function() {
            return $34a4e1610a6ffedc$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $34a4e1610a6ffedc$export$f00d8368ae31463f = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadListT1 = $34a4e1610a6ffedc$export$204d5ba0706a4088(Monad0);
    return {
        liftEffect: function() {
            var $333 = $34a4e1610a6ffedc$var$lift(Monad0);
            var $334 = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
            return function($335) {
                return $333($334($335));
            };
        }(),
        Monad0: function() {
            return monadListT1;
        }
    };
};
var $34a4e1610a6ffedc$export$bf13ffdc6b7113ca = function(dictApplicative) {
    var functorListT1 = $34a4e1610a6ffedc$export$5af6b427ff316359(dictApplicative.Apply0().Functor0());
    return {
        alt: $34a4e1610a6ffedc$var$concat(dictApplicative),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $34a4e1610a6ffedc$export$82f742a0347e990a = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var altListT1 = $34a4e1610a6ffedc$export$bf13ffdc6b7113ca(Applicative0);
    return {
        empty: $34a4e1610a6ffedc$export$f2c4f74e8fe88e34(Applicative0),
        Alt0: function() {
            return altListT1;
        }
    };
};
var $34a4e1610a6ffedc$export$183e8a1c18c60fd3 = function(dictMonad) {
    var applicativeListT1 = $34a4e1610a6ffedc$export$cf70c952df59e46e(dictMonad);
    var plusListT1 = $34a4e1610a6ffedc$export$82f742a0347e990a(dictMonad);
    return {
        Applicative0: function() {
            return applicativeListT1;
        },
        Plus1: function() {
            return plusListT1;
        }
    };
};
var $34a4e1610a6ffedc$export$bb0af79e56ac53fe = function(dictMonad) {
    var monadListT1 = $34a4e1610a6ffedc$export$204d5ba0706a4088(dictMonad);
    var alternativeListT1 = $34a4e1610a6ffedc$export$183e8a1c18c60fd3(dictMonad);
    return {
        Monad0: function() {
            return monadListT1;
        },
        Alternative1: function() {
            return alternativeListT1;
        }
    };
};



// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");


var $bcJ05 = parcelRequire("bcJ05");


var $j7FrY = parcelRequire("j7FrY");

var $7FzSN = parcelRequire("7FzSN");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $7O0Q4 = parcelRequire("7O0Q4");

var $2jM6U = parcelRequire("2jM6U");

var $69d388ec4019abf8$export$6950f537d8cb5965 = /* #__PURE__ */ function() {
    function RWSResult(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RWSResult.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RWSResult(value0, value1, value2);
            };
        };
    };
    return RWSResult;
}();
var $69d388ec4019abf8$export$f3fc26d039f92fdf = function(x) {
    return x;
};
var $69d388ec4019abf8$export$82c3159babd6b403 = function(f) {
    return function(m) {
        return function(r) {
            return function(s) {
                return $7O0Q4.uncurry(m)(f(r)(s));
            };
        };
    };
};
var $69d388ec4019abf8$export$4c8676657688a1cd = function(v) {
    return v;
};
var $69d388ec4019abf8$export$7bded133c80fee1b = {
    Coercible0: function() {
        return undefined;
    }
};
var $69d388ec4019abf8$export$1d2bc64ff0e647b4 = function(dictMonoid) {
    var mempty = $3aOYV.mempty(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $cADnC.bind(dictMonad.Bind1());
            var pure = $bQdkN.pure(dictMonad.Applicative0());
            return function(m) {
                return function(v) {
                    return function(s) {
                        return bind(m)(function(a) {
                            return pure(new $69d388ec4019abf8$export$6950f537d8cb5965(s, a, mempty));
                        });
                    };
                };
            };
        }
    };
};
var $69d388ec4019abf8$export$b3b7a52c4baabcad = function(f) {
    return function(v) {
        return function(r) {
            return function(s) {
                return f(v(r)(s));
            };
        };
    };
};
var $69d388ec4019abf8$export$ab4be9af97c7111d = {
    defer: function(f) {
        return function(r) {
            return function(s) {
                var v = f($2jM6U.unit);
                return v(r)(s);
            };
        };
    }
};
var $69d388ec4019abf8$export$799f7a47278c4ab2 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(r) {
                    return function(s) {
                        return map(function(v1) {
                            return new $69d388ec4019abf8$export$6950f537d8cb5965(v1.value0, f(v1.value1), v1.value2);
                        })(v(r)(s));
                    };
                };
            };
        }
    };
};
var $69d388ec4019abf8$export$8f895b27f6bea35a = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $7O0Q4.Tuple(v1.value0, v1.value2));
                });
            };
        };
    };
};
var $69d388ec4019abf8$export$9492f7142a7c6dda = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $7O0Q4.Tuple(v1.value1, v1.value2));
                });
            };
        };
    };
};
var $69d388ec4019abf8$export$3f72b7b9b643060e = function(dictBind) {
    var bind = $cADnC.bind(dictBind);
    var Functor0 = dictBind.Apply0().Functor0();
    var mapFlipped = $7FzSN.mapFlipped(Functor0);
    var functorRWST1 = $69d388ec4019abf8$export$799f7a47278c4ab2(Functor0);
    return function(dictMonoid) {
        var append = $d5vvq.append(dictMonoid.Semigroup0());
        return {
            apply: function(v) {
                return function(v1) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v2) {
                                return mapFlipped(v1(r)(v2.value0))(function(v3) {
                                    return new $69d388ec4019abf8$export$6950f537d8cb5965(v3.value0, v2.value1(v3.value1), append(v2.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Functor0: function() {
                return functorRWST1;
            }
        };
    };
};
var $69d388ec4019abf8$export$ecf0616f2cad1379 = function(dictBind) {
    var bind = $cADnC.bind(dictBind);
    var mapFlipped = $7FzSN.mapFlipped(dictBind.Apply0().Functor0());
    var applyRWST1 = $69d388ec4019abf8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var append = $d5vvq.append(dictMonoid.Semigroup0());
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            bind: function(v) {
                return function(f) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v1) {
                                var v2 = f(v1.value1);
                                return mapFlipped(v2(r)(v1.value0))(function(v3) {
                                    return new $69d388ec4019abf8$export$6950f537d8cb5965(v3.value0, v3.value1, append(v1.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$863b3ca33677d9b2 = function(dictBind) {
    var applyRWST1 = $69d388ec4019abf8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var lift2 = $26ZCq.lift2(applyRWST1(dictMonoid));
        return function(dictSemigroup) {
            return {
                append: lift2($d5vvq.append(dictSemigroup))
            };
        };
    };
};
var $69d388ec4019abf8$export$b7ffaf6687c91068 = function(dictMonad) {
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var applyRWST1 = $69d388ec4019abf8$export$3f72b7b9b643060e(dictMonad.Bind1());
    return function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            pure: function(a) {
                return function(v) {
                    return function(s) {
                        return pure(new $69d388ec4019abf8$export$6950f537d8cb5965(s, a, mempty));
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$3addf8bc39ac949f = function(dictMonad) {
    var applicativeRWST1 = $69d388ec4019abf8$export$b7ffaf6687c91068(dictMonad);
    var bindRWST1 = $69d388ec4019abf8$export$ecf0616f2cad1379(dictMonad.Bind1());
    return function(dictMonoid) {
        var applicativeRWST2 = applicativeRWST1(dictMonoid);
        var bindRWST2 = bindRWST1(dictMonoid);
        return {
            Applicative0: function() {
                return applicativeRWST2;
            },
            Bind1: function() {
                return bindRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$b3a6ad9a80cd89aa = function(dictMonad) {
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var monadRWST1 = $69d388ec4019abf8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            ask: function(r) {
                return function(s) {
                    return pure(new $69d388ec4019abf8$export$6950f537d8cb5965(s, r, mempty));
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$149b7da9e90e1eac = function(dictMonad) {
    var monadAskRWST1 = $69d388ec4019abf8$export$b3a6ad9a80cd89aa(dictMonad);
    return function(dictMonoid) {
        var monadAskRWST2 = monadAskRWST1(dictMonoid);
        return {
            local: function(f) {
                return function(m) {
                    return function(r) {
                        return function(s) {
                            return m(f(r))(s);
                        };
                    };
                };
            },
            MonadAsk0: function() {
                return monadAskRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$1947b5c08efdf68f = function(dictMonoid) {
    var lift = $0db1509836ffbf7e$export$590e8b2c435046d9($69d388ec4019abf8$export$1d2bc64ff0e647b4(dictMonoid));
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadRWST1 = $69d388ec4019abf8$export$3addf8bc39ac949f(Monad0)(dictMonoid);
        return {
            liftEffect: function() {
                var $274 = lift(Monad0);
                var $275 = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
                return function($276) {
                    return $274($275($276));
                };
            }(),
            Monad0: function() {
                return monadRWST1;
            }
        };
    };
};
var $69d388ec4019abf8$export$858b449733703d7f = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $cADnC.bind(Monad0.Bind1());
    var pure = $bQdkN.pure(Monad0.Applicative0());
    var tailRecM = $bcJ05.tailRecM(dictMonadRec);
    var monadRWST1 = $69d388ec4019abf8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var append = $d5vvq.append(dictMonoid.Semigroup0());
        var mempty = $3aOYV.mempty(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tailRecM: function(k) {
                return function(a) {
                    var k$prime = function(r) {
                        return function(v) {
                            var v1 = k(v.value1);
                            return bind(v1(r)(v.value0))(function(v2) {
                                return pure(function() {
                                    if (v2.value1 instanceof $bcJ05.Loop) return new $bcJ05.Loop(new $69d388ec4019abf8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    if (v2.value1 instanceof $bcJ05.Done) return new $bcJ05.Done(new $69d388ec4019abf8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    throw new Error("Failed pattern match at Control.Monad.RWS.Trans (line 128, column 16 - line 130, column 68): " + [
                                        v2.value1.constructor.name
                                    ]);
                                }());
                            });
                        };
                    };
                    return function(r) {
                        return function(s) {
                            return tailRecM(k$prime(r))(new $69d388ec4019abf8$export$6950f537d8cb5965(s, a, mempty));
                        };
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$c835aca1626da706 = function(dictMonad) {
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var monadRWST1 = $69d388ec4019abf8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $3aOYV.mempty(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            state: function(f) {
                return function(v) {
                    return function(s) {
                        var v1 = f(s);
                        return pure(new $69d388ec4019abf8$export$6950f537d8cb5965(v1.value1, v1.value0, mempty));
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$5538632dd3cd70cc = function(dictMonad) {
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var monadRWST1 = $69d388ec4019abf8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var Semigroup0 = dictMonoid.Semigroup0();
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tell: function(w) {
                return function(v) {
                    return function(s) {
                        return pure(new $69d388ec4019abf8$export$6950f537d8cb5965(s, $2jM6U.unit, w));
                    };
                };
            },
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$d26d81ccbf9cc981 = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var monadTellRWST1 = $69d388ec4019abf8$export$5538632dd3cd70cc(dictMonad);
    return function(dictMonoid) {
        var monadTellRWST2 = monadTellRWST1(dictMonoid);
        return {
            listen: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $69d388ec4019abf8$export$6950f537d8cb5965(v.value0, new $7O0Q4.Tuple(v.value1, v.value2), v.value2));
                        });
                    };
                };
            },
            pass: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $69d388ec4019abf8$export$6950f537d8cb5965(v.value0, v.value1.value0, v.value1.value1(v.value2)));
                        });
                    };
                };
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$9d857fb7268a3f42 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var throwError = $693a27a8782d8e71$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadRWST1 = $69d388ec4019abf8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var lift = $0db1509836ffbf7e$export$590e8b2c435046d9($69d388ec4019abf8$export$1d2bc64ff0e647b4(dictMonoid))(Monad0);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            throwError: function(e) {
                return lift(throwError(e));
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$f1aa4e7ce0e20856 = function(dictMonadError) {
    var catchError = $693a27a8782d8e71$export$3dede90624df3ba9(dictMonadError);
    var monadThrowRWST1 = $69d388ec4019abf8$export$9d857fb7268a3f42(dictMonadError.MonadThrow0());
    return function(dictMonoid) {
        var monadThrowRWST2 = monadThrowRWST1(dictMonoid);
        return {
            catchError: function(m) {
                return function(h) {
                    return function(r) {
                        return function(s) {
                            return catchError(m(r)(s))(function(e) {
                                var v = h(e);
                                return v(r)(s);
                            });
                        };
                    };
                };
            },
            MonadThrow0: function() {
                return monadThrowRWST2;
            }
        };
    };
};
var $69d388ec4019abf8$export$83c8cfee0365f931 = function(dictMonad) {
    var applicativeRWST1 = $69d388ec4019abf8$export$b7ffaf6687c91068(dictMonad);
    var semigroupRWST1 = $69d388ec4019abf8$export$863b3ca33677d9b2(dictMonad.Bind1());
    return function(dictMonoid) {
        var pure = $bQdkN.pure(applicativeRWST1(dictMonoid));
        var semigroupRWST2 = semigroupRWST1(dictMonoid);
        return function(dictMonoid1) {
            var semigroupRWST3 = semigroupRWST2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($3aOYV.mempty(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupRWST3;
                }
            };
        };
    };
};
var $69d388ec4019abf8$export$cfb751420c588279 = function(dictAlt) {
    var alt = $56VjJ.alt(dictAlt);
    var functorRWST1 = $69d388ec4019abf8$export$799f7a47278c4ab2(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return function(s) {
                        return alt(v(r)(s))(v1(r)(s));
                    };
                };
            };
        },
        Functor0: function() {
            return functorRWST1;
        }
    };
};
var $69d388ec4019abf8$export$6179beba56f1d9b2 = function(dictPlus) {
    var empty = $j7FrY.empty(dictPlus);
    var altRWST1 = $69d388ec4019abf8$export$cfb751420c588279(dictPlus.Alt0());
    return {
        empty: function(v) {
            return function(v1) {
                return empty;
            };
        },
        Alt0: function() {
            return altRWST1;
        }
    };
};
var $69d388ec4019abf8$export$26aad7e9ffabe87b = function(dictMonoid) {
    return function(dictAlternative) {
        var plusRWST1 = $69d388ec4019abf8$export$6179beba56f1d9b2(dictAlternative.Plus1());
        return function(dictMonad) {
            var applicativeRWST1 = $69d388ec4019abf8$export$b7ffaf6687c91068(dictMonad)(dictMonoid);
            return {
                Applicative0: function() {
                    return applicativeRWST1;
                },
                Plus1: function() {
                    return plusRWST1;
                }
            };
        };
    };
};



// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $kkdfo = parcelRequire("kkdfo");




var $bcJ05 = parcelRequire("bcJ05");




var $j7FrY = parcelRequire("j7FrY");

var $7FzSN = parcelRequire("7FzSN");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $7O0Q4 = parcelRequire("7O0Q4");

var $2jM6U = parcelRequire("2jM6U");

var $6753045408c02656$export$73ce73bddfe2800a = function(x) {
    return x;
};
var $6753045408c02656$export$72aea7109e8312dd = function(f) {
    return function(v) {
        return function($193) {
            return v(f($193));
        };
    };
};
var $6753045408c02656$export$c5ba8a89d9140c32 = function(v) {
    return v;
};
var $6753045408c02656$export$dce35699eedd4739 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6753045408c02656$export$5e0a9e9fea50cb88 = {
    lift: function(dictMonad) {
        var bind = $cADnC.bind(dictMonad.Bind1());
        var pure = $bQdkN.pure(dictMonad.Applicative0());
        return function(m) {
            return function(s) {
                return bind(m)(function(x) {
                    return pure(new $7O0Q4.Tuple(x, s));
                });
            };
        };
    }
};
var $6753045408c02656$var$lift = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($6753045408c02656$export$5e0a9e9fea50cb88);
var $6753045408c02656$export$8342df5ddac360cd = function(f) {
    return function(v) {
        return function($194) {
            return f(v($194));
        };
    };
};
var $6753045408c02656$export$dce43013fc3a5fe1 = {
    defer: function(f) {
        return function(s) {
            var v = f($2jM6U.unit);
            return v(s);
        };
    }
};
var $6753045408c02656$export$d5449d946db19e3a = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(s) {
                    return map(function(v1) {
                        return new $7O0Q4.Tuple(f(v1.value0), v1.value1);
                    })(v(s));
                };
            };
        }
    };
};
var $6753045408c02656$export$193956ba360b7728 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return function(v) {
        return function(s) {
            return map($7O0Q4.snd)(v(s));
        };
    };
};
var $6753045408c02656$export$99aa49a66d7c0535 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return function(v) {
        return function(s) {
            return map($7O0Q4.fst)(v(s));
        };
    };
};
var $6753045408c02656$export$345b4840c14ff10f = function(dictMonad) {
    return {
        Applicative0: function() {
            return $6753045408c02656$export$5cbc630d6fbe2e14(dictMonad);
        },
        Bind1: function() {
            return $6753045408c02656$export$f28534bdc7259c7(dictMonad);
        }
    };
};
var $6753045408c02656$export$f28534bdc7259c7 = function(dictMonad) {
    var bind = $cADnC.bind(dictMonad.Bind1());
    return {
        bind: function(v) {
            return function(f) {
                return function(s) {
                    return bind(v(s))(function(v1) {
                        var v3 = f(v1.value0);
                        return v3(v1.value1);
                    });
                };
            };
        },
        Apply0: function() {
            return $6753045408c02656$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $6753045408c02656$export$2ea3d0ecd25a5eef = function(dictMonad) {
    var functorStateT1 = $6753045408c02656$export$d5449d946db19e3a(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $kkdfo.ap($6753045408c02656$export$345b4840c14ff10f(dictMonad)),
        Functor0: function() {
            return functorStateT1;
        }
    };
};
var $6753045408c02656$export$5cbc630d6fbe2e14 = function(dictMonad) {
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    return {
        pure: function(a) {
            return function(s) {
                return pure(new $7O0Q4.Tuple(a, s));
            };
        },
        Apply0: function() {
            return $6753045408c02656$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $6753045408c02656$export$726f0b075e4f5d8b = function(dictMonad) {
    var lift2 = $26ZCq.lift2($6753045408c02656$export$2ea3d0ecd25a5eef(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d5vvq.append(dictSemigroup))
        };
    };
};
var $6753045408c02656$export$45bacc938270e8f5 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadStateT1 = $6753045408c02656$export$345b4840c14ff10f(Monad0);
    return {
        ask: $6753045408c02656$var$lift(Monad0)($ce0fad135b75d1f6$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $6753045408c02656$export$20f71c563c2e6d49 = function(dictMonadReader) {
    var monadAskStateT1 = $6753045408c02656$export$45bacc938270e8f5(dictMonadReader.MonadAsk0());
    return {
        local: function() {
            var $195 = $ce0fad135b75d1f6$export$3bf5078b16209b91(dictMonadReader);
            return function($196) {
                return $6753045408c02656$export$8342df5ddac360cd($195($196));
            };
        }(),
        MonadAsk0: function() {
            return monadAskStateT1;
        }
    };
};
var $6753045408c02656$export$2e498a385f8c30f1 = function(dictMonadCont) {
    var callCC = $45c1976f946e1989$export$bb801a161a3121f0(dictMonadCont);
    var monadStateT1 = $6753045408c02656$export$345b4840c14ff10f(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(s) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return function(s$prime) {
                            return c(new $7O0Q4.Tuple(a, s$prime));
                        };
                    });
                    return v(s);
                });
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $6753045408c02656$export$cba9856135198781 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadStateT1 = $6753045408c02656$export$345b4840c14ff10f(Monad0);
    return {
        liftEffect: function() {
            var $197 = $6753045408c02656$var$lift(Monad0);
            var $198 = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
            return function($199) {
                return $197($198($199));
            };
        }(),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $6753045408c02656$export$ade5de830b656137 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $cADnC.bind(Monad0.Bind1());
    var pure = $bQdkN.pure(Monad0.Applicative0());
    var tailRecM = $bcJ05.tailRecM(dictMonadRec);
    var monadStateT1 = $6753045408c02656$export$345b4840c14ff10f(Monad0);
    return {
        tailRecM: function(f) {
            return function(a) {
                var f$prime = function(v) {
                    var v1 = f(v.value0);
                    return bind(v1(v.value1))(function(v2) {
                        return pure(function() {
                            if (v2.value0 instanceof $bcJ05.Loop) return new $bcJ05.Loop(new $7O0Q4.Tuple(v2.value0.value0, v2.value1));
                            if (v2.value0 instanceof $bcJ05.Done) return new $bcJ05.Done(new $7O0Q4.Tuple(v2.value0.value0, v2.value1));
                            throw new Error("Failed pattern match at Control.Monad.State.Trans (line 87, column 16 - line 89, column 40): " + [
                                v2.value0.constructor.name
                            ]);
                        }());
                    });
                };
                return function(s) {
                    return tailRecM(f$prime)(new $7O0Q4.Tuple(a, s));
                };
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $6753045408c02656$export$fc3b89a546fa5c5c = function(dictMonad) {
    var pure = $bQdkN.pure(dictMonad.Applicative0());
    var monadStateT1 = $6753045408c02656$export$345b4840c14ff10f(dictMonad);
    return {
        state: function(f) {
            return function($200) {
                return pure(f($200));
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $6753045408c02656$export$7fdbbf63ca644aa6 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadStateT1 = $6753045408c02656$export$345b4840c14ff10f(Monad1);
    return {
        tell: function() {
            var $201 = $6753045408c02656$var$lift(Monad1);
            var $202 = $1ef973452f9b4285$export$de3113ed932c61ab(dictMonadTell);
            return function($203) {
                return $201($202($203));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadStateT1;
        }
    };
};
var $6753045408c02656$export$f97520cd68688e2d = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $cADnC.bind(Monad1.Bind1());
    var listen = $1ef973452f9b4285$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $bQdkN.pure(Monad1.Applicative0());
    var pass = $1ef973452f9b4285$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellStateT1 = $6753045408c02656$export$7fdbbf63ca644aa6(MonadTell1);
    return {
        listen: function(m) {
            return function(s) {
                return bind(listen(m(s)))(function(v) {
                    return pure(new $7O0Q4.Tuple(new $7O0Q4.Tuple(v.value0.value0, v.value1), v.value0.value1));
                });
            };
        },
        pass: function(m) {
            return function(s) {
                return pass(bind(m(s))(function(v) {
                    return pure(new $7O0Q4.Tuple(new $7O0Q4.Tuple(v.value0.value0, v.value1), v.value0.value1));
                }));
            };
        },
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellStateT1;
        }
    };
};
var $6753045408c02656$export$89cac97299cfdec2 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $6753045408c02656$var$lift(Monad0);
    var throwError = $693a27a8782d8e71$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadStateT1 = $6753045408c02656$export$345b4840c14ff10f(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $6753045408c02656$export$c2a2ecf63b1e47e2 = function(dictMonadError) {
    var catchError = $693a27a8782d8e71$export$3dede90624df3ba9(dictMonadError);
    var monadThrowStateT1 = $6753045408c02656$export$89cac97299cfdec2(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(s) {
                    return catchError(v(s))(function(e) {
                        var v1 = h(e);
                        return v1(s);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowStateT1;
        }
    };
};
var $6753045408c02656$export$9d9b8c7bcee971bf = function(dictMonad) {
    var pure = $bQdkN.pure($6753045408c02656$export$5cbc630d6fbe2e14(dictMonad));
    var semigroupStateT1 = $6753045408c02656$export$726f0b075e4f5d8b(dictMonad);
    return function(dictMonoid) {
        var semigroupStateT2 = semigroupStateT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($3aOYV.mempty(dictMonoid)),
            Semigroup0: function() {
                return semigroupStateT2;
            }
        };
    };
};
var $6753045408c02656$export$d5bde0fdc0bca75b = function(dictMonad) {
    return function(dictAlt) {
        var alt = $56VjJ.alt(dictAlt);
        var functorStateT1 = $6753045408c02656$export$d5449d946db19e3a(dictAlt.Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return function(s) {
                        return alt(v(s))(v1(s));
                    };
                };
            },
            Functor0: function() {
                return functorStateT1;
            }
        };
    };
};
var $6753045408c02656$export$300a7627bf7b0e65 = function(dictMonad) {
    var altStateT1 = $6753045408c02656$export$d5bde0fdc0bca75b(dictMonad);
    return function(dictPlus) {
        var empty = $j7FrY.empty(dictPlus);
        var altStateT2 = altStateT1(dictPlus.Alt0());
        return {
            empty: function(v) {
                return empty;
            },
            Alt0: function() {
                return altStateT2;
            }
        };
    };
};
var $6753045408c02656$export$d31747194ff6662e = function(dictMonad) {
    var applicativeStateT1 = $6753045408c02656$export$5cbc630d6fbe2e14(dictMonad);
    var plusStateT1 = $6753045408c02656$export$300a7627bf7b0e65(dictMonad);
    return function(dictAlternative) {
        var plusStateT2 = plusStateT1(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeStateT1;
            },
            Plus1: function() {
                return plusStateT2;
            }
        };
    };
};
var $6753045408c02656$export$b08eeaf68c7005d9 = function(dictMonadPlus) {
    var Monad0 = dictMonadPlus.Monad0();
    var monadStateT1 = $6753045408c02656$export$345b4840c14ff10f(Monad0);
    var alternativeStateT1 = $6753045408c02656$export$d31747194ff6662e(Monad0)(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStateT1;
        },
        Alternative1: function() {
            return alternativeStateT1;
        }
    };
};





var $ec5cc86f53a11c6b$var$lift = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($145dc4a2d647cf5f$export$6a2bb59a0c53ce17);
var $ec5cc86f53a11c6b$var$lift1 = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($2603701dab447006$export$fa93accd6d6dc1d2);
var $ec5cc86f53a11c6b$var$lift2 = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($34a4e1610a6ffedc$export$619131e858bec5bb);
var $ec5cc86f53a11c6b$var$lift3 = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($0084a6f1dda72e44$export$84eda9cb75492c36);
var $ec5cc86f53a11c6b$var$lift4 = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($024201b10fb9f490$export$95510d0cd7e6e7eb);
var $ec5cc86f53a11c6b$var$lift5 = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($6753045408c02656$export$5e0a9e9fea50cb88);
var $ec5cc86f53a11c6b$export$bd75e69808ef8e57 = {
    liftAff: /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn),
    MonadEffect0: function() {
        return $7244ec56ae5630bd$export$666a030cecdf96c;
    }
};
var $ec5cc86f53a11c6b$export$37f61af225938e0f = function(dict) {
    return dict.liftAff;
};
var $ec5cc86f53a11c6b$export$53acd6df2cbe3344 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectContT = $145dc4a2d647cf5f$export$35d988300b9091c9(MonadEffect0);
    return {
        liftAff: function() {
            var $65 = $ec5cc86f53a11c6b$var$lift(MonadEffect0.Monad0());
            var $66 = $ec5cc86f53a11c6b$export$37f61af225938e0f(dictMonadAff);
            return function($67) {
                return $65($66($67));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectContT;
        }
    };
};
var $ec5cc86f53a11c6b$export$87a4e9dc50af0c41 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectExceptT = $2603701dab447006$export$14ff7e4e497a86b1(MonadEffect0);
    return {
        liftAff: function() {
            var $68 = $ec5cc86f53a11c6b$var$lift1(MonadEffect0.Monad0());
            var $69 = $ec5cc86f53a11c6b$export$37f61af225938e0f(dictMonadAff);
            return function($70) {
                return $68($69($70));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectExceptT;
        }
    };
};
var $ec5cc86f53a11c6b$export$72b48760d563ad73 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectListT = $34a4e1610a6ffedc$export$f00d8368ae31463f(MonadEffect0);
    return {
        liftAff: function() {
            var $71 = $ec5cc86f53a11c6b$var$lift2(MonadEffect0.Monad0());
            var $72 = $ec5cc86f53a11c6b$export$37f61af225938e0f(dictMonadAff);
            return function($73) {
                return $71($72($73));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectListT;
        }
    };
};
var $ec5cc86f53a11c6b$export$7091efe953cca892 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectMaybe = $0084a6f1dda72e44$export$2f876a9cb1e407d9(MonadEffect0);
    return {
        liftAff: function() {
            var $74 = $ec5cc86f53a11c6b$var$lift3(MonadEffect0.Monad0());
            var $75 = $ec5cc86f53a11c6b$export$37f61af225938e0f(dictMonadAff);
            return function($76) {
                return $74($75($76));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectMaybe;
        }
    };
};
var $ec5cc86f53a11c6b$export$5fd9f999a5266faf = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $ec5cc86f53a11c6b$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectRWS = $69d388ec4019abf8$export$1947b5c08efdf68f(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $77 = $0db1509836ffbf7e$export$590e8b2c435046d9($69d388ec4019abf8$export$1d2bc64ff0e647b4(dictMonoid))(Monad0);
                return function($78) {
                    return $77(liftAff1($78));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectRWS;
            }
        };
    };
};
var $ec5cc86f53a11c6b$export$fa61c33f24d5bab = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectReader = $024201b10fb9f490$export$a554ebf369a3f56d(MonadEffect0);
    return {
        liftAff: function() {
            var $79 = $ec5cc86f53a11c6b$var$lift4(MonadEffect0.Monad0());
            var $80 = $ec5cc86f53a11c6b$export$37f61af225938e0f(dictMonadAff);
            return function($81) {
                return $79($80($81));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectReader;
        }
    };
};
var $ec5cc86f53a11c6b$export$1c14dadc45d4bfb9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectState = $6753045408c02656$export$cba9856135198781(MonadEffect0);
    return {
        liftAff: function() {
            var $82 = $ec5cc86f53a11c6b$var$lift5(MonadEffect0.Monad0());
            var $83 = $ec5cc86f53a11c6b$export$37f61af225938e0f(dictMonadAff);
            return function($84) {
                return $82($83($84));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectState;
        }
    };
};
var $ec5cc86f53a11c6b$export$7ad7619eecdb33a9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $ec5cc86f53a11c6b$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectWriter = $6765fe209155a20b$export$29fece65832b4369(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $85 = $0db1509836ffbf7e$export$590e8b2c435046d9($6765fe209155a20b$export$6b749a3db2c2aac6(dictMonoid))(Monad0);
                return function($86) {
                    return $85(liftAff1($86));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectWriter;
            }
        };
    };
};



// Generated by purs version 0.15.16
const $63b30336f9a70767$export$bef1f36f5486a6a3 = function(s) {
    return function() {
        console.log(s);
    };
};
const $63b30336f9a70767$export$c106dd0671a0fc2d = function(s) {
    return function() {
        console.warn(s);
    };
};
const $63b30336f9a70767$export$a3bc9b8ed74fc = function(s) {
    return function() {
        console.error(s);
    };
};
const $63b30336f9a70767$export$a80b3bd66acc52ff = function(s) {
    return function() {
        console.info(s);
    };
};
const $63b30336f9a70767$export$1c9f709888824e05 = function(s) {
    return function() {
        console.debug(s);
    };
};
const $63b30336f9a70767$export$2da9be4cfdb689b1 = function(s) {
    return function() {
        console.time(s);
    };
};
const $63b30336f9a70767$export$1694f226a9241aae = function(s) {
    return function() {
        console.timeLog(s);
    };
};
const $63b30336f9a70767$export$8f2977fb54cb3601 = function(s) {
    return function() {
        console.timeEnd(s);
    };
};
const $63b30336f9a70767$export$42ffd38884aecdac = function() {
    console.clear();
};



var $2XxiF = parcelRequire("2XxiF");
var $1b75e722f5a42dbc$export$28709abf85ddce1d = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(a) {
        return $63b30336f9a70767$export$c106dd0671a0fc2d(show(a));
    };
};
var $1b75e722f5a42dbc$export$9f43f5977f8d5609 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(a) {
        return $63b30336f9a70767$export$bef1f36f5486a6a3(show(a));
    };
};
var $1b75e722f5a42dbc$export$fc9467e2ad369291 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(a) {
        return $63b30336f9a70767$export$a80b3bd66acc52ff(show(a));
    };
};
var $1b75e722f5a42dbc$export$cbd229996ecd7704 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(a) {
        return $63b30336f9a70767$export$a3bc9b8ed74fc(show(a));
    };
};
var $1b75e722f5a42dbc$export$18fab8ed91d044eb = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return function(a) {
        return $63b30336f9a70767$export$1c9f709888824e05(show(a));
    };
};



// Generated by purs version 0.15.16
function $6703b3904c45131d$export$461939dd4422153() {
    return Date.now();
}
function $6703b3904c45131d$export$4c9db454e2785fd9() {
    var n = new Date(Date.now());
    return n.getTimezoneOffset();
}





var $7FzSN = parcelRequire("7FzSN");

var $1rTTn = parcelRequire("1rTTn");
var $522cd61666c66694$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $522cd61666c66694$export$1789df67d9a28d08 = /* #__PURE__ */ $522cd61666c66694$var$map(function($2) {
    return $3043ecd2e3978a63$export$2da9be4cfdb689b1($1ca97124a62e2e75$export$c2dea5c02f48568d($2));
})($6703b3904c45131d$export$461939dd4422153);
var $522cd61666c66694$export$9123026da2f03e72 = /* #__PURE__ */ $522cd61666c66694$var$map($1ca97124a62e2e75$export$c2dea5c02f48568d)($6703b3904c45131d$export$461939dd4422153);
var $522cd61666c66694$export$4197fd15784ef012 = /* #__PURE__ */ $522cd61666c66694$var$map(function($3) {
    return $3043ecd2e3978a63$export$324d90190a8b822a($1ca97124a62e2e75$export$c2dea5c02f48568d($3));
})($6703b3904c45131d$export$461939dd4422153);


// Generated by purs version 0.15.16
function $bbd1c096e2c7f227$export$f5bbd400c2f4426f(value) {
    return typeof value;
}
function $bbd1c096e2c7f227$export$348caad1e8d41c5f(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $bbd1c096e2c7f227$export$630801d484da15df(value) {
    return value === null;
}
function $bbd1c096e2c7f227$export$fce6876652108ab(value) {
    return value === undefined;
}
const $bbd1c096e2c7f227$export$43bee75e5e14138e = Array.isArray || function(value) {
    return Object.prototype.toString.call(value) === "[object Array]";
};



var $bQdkN = parcelRequire("bQdkN");



var $iQTlW = parcelRequire("iQTlW");

var $beQI1 = parcelRequire("beQI1");

var $aJhEx = parcelRequire("aJhEx");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $hCjGZ = parcelRequire("hCjGZ");
// Generated by purs version 0.15.16

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $iQTlW = parcelRequire("iQTlW");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $5krR0 = parcelRequire("5krR0");

var $fZenR = parcelRequire("fZenR");

var $h2xUu = parcelRequire("h2xUu");

var $9aSRU = parcelRequire("9aSRU");

var $gwBF5 = parcelRequire("gwBF5");

var $d5vvq = parcelRequire("d5vvq");

var $kAvps = parcelRequire("kAvps");

var $6ywL5 = parcelRequire("6ywL5");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");

var $lqv9L = parcelRequire("lqv9L");
var $795e171a0788c8e1$var$sequence1 = /* #__PURE__ */ $6ywL5.sequence1($fZenR.traversable1NonEmptyList);
var $795e171a0788c8e1$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $795e171a0788c8e1$var$map1 = /* #__PURE__ */ $7FzSN.map($fZenR.functorNonEmptyList);
var $795e171a0788c8e1$var$bind = /* #__PURE__ */ $cADnC.bind($fZenR.bindNonEmptyList);
var $795e171a0788c8e1$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $795e171a0788c8e1$var$append1 = /* #__PURE__ */ $d5vvq.append($fZenR.semigroupList);
var $795e171a0788c8e1$export$b634740ce272acb5 = function(f) {
    return function(v) {
        return function(v1) {
            return new $9aSRU.NonEmpty(f(v.value0)(v1.value0), $5krR0.zipWith(f)(v.value1)(v1.value1));
        };
    };
};
var $795e171a0788c8e1$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence11 = $795e171a0788c8e1$var$sequence1(dictApplicative.Apply0());
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence11($795e171a0788c8e1$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $795e171a0788c8e1$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $795e171a0788c8e1$export$b634740ce272acb5($7O0Q4.Tuple.create);
}();
var $795e171a0788c8e1$var$wrappedOperation2 = function(name) {
    return function(f) {
        return function(v) {
            return function(v1) {
                var v2 = f(new $fZenR.Cons(v.value0, v.value1))(new $fZenR.Cons(v1.value0, v1.value1));
                if (v2 instanceof $fZenR.Cons) return new $9aSRU.NonEmpty(v2.value0, v2.value1);
                if (v2 instanceof $fZenR.Nil) return $lqv9L.unsafeCrashWith("Impossible: empty list in NonEmptyList " + name);
                throw new Error("Failed pattern match at Data.List.NonEmpty (line 105, column 3 - line 107, column 81): " + [
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $795e171a0788c8e1$var$wrappedOperation = function(name) {
    return function(f) {
        return function(v) {
            var v1 = f(new $fZenR.Cons(v.value0, v.value1));
            if (v1 instanceof $fZenR.Cons) return new $9aSRU.NonEmpty(v1.value0, v1.value1);
            if (v1 instanceof $fZenR.Nil) return $lqv9L.unsafeCrashWith("Impossible: empty list in NonEmptyList " + name);
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 92, column 3 - line 94, column 81): " + [
                v1.constructor.name
            ]);
        };
    };
};
var $795e171a0788c8e1$export$b6d8713d53419d4c = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $h2xUu.Just(new $9aSRU.NonEmpty(a, v.value1));
            if ($iQTlW.otherwise) return $795e171a0788c8e1$var$map(function($193) {
                return $fZenR.NonEmptyList(function(v1) {
                    return new $9aSRU.NonEmpty(v.value0, v1);
                }($193));
            })($5krR0.updateAt(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 198, column 1 - line 198, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $795e171a0788c8e1$export$23c8d3f8757cab88 = function(ts) {
    return new $7O0Q4.Tuple($795e171a0788c8e1$var$map1($7O0Q4.fst)(ts), $795e171a0788c8e1$var$map1($7O0Q4.snd)(ts));
};
var $795e171a0788c8e1$export$712962e076096ed4 = function(v) {
    var v1 = $5krR0.unsnoc(v.value1);
    if (v1 instanceof $h2xUu.Nothing) return {
        init: $fZenR.Nil.value,
        last: v.value0
    };
    if (v1 instanceof $h2xUu.Just) return {
        init: new $fZenR.Cons(v.value0, v1.value0.init),
        last: v1.value0.last
    };
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 160, column 35 - line 162, column 50): " + [
        v1.constructor.name
    ]);
};
var $795e171a0788c8e1$export$ef1d06dc4d91d507 = /* #__PURE__ */ function() {
    var $194 = $795e171a0788c8e1$var$wrappedOperation2("unionBy");
    return function($195) {
        return $194($5krR0.unionBy($195));
    };
}();
var $795e171a0788c8e1$export$971dd5b0dfd021b6 = function(dictEq) {
    return $795e171a0788c8e1$var$wrappedOperation2("union")($5krR0.union(dictEq));
};
var $795e171a0788c8e1$export$b446f6baa3bb1430 = function(v) {
    return {
        head: v.value0,
        tail: v.value1
    };
};
var $795e171a0788c8e1$export$effcdbd76139450 = function(v) {
    return new $fZenR.Cons(v.value0, v.value1);
};
var $795e171a0788c8e1$export$823be24f8766da23 = function(dictUnfoldable) {
    var $196 = $goKHx.unfoldr(dictUnfoldable)(function(xs) {
        return $795e171a0788c8e1$var$map(function(rec) {
            return new $7O0Q4.Tuple(rec.head, rec.tail);
        })($5krR0.uncons(xs));
    });
    return function($197) {
        return $196($795e171a0788c8e1$export$effcdbd76139450($197));
    };
};
var $795e171a0788c8e1$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $795e171a0788c8e1$export$b035e44d7bb4278f = /* #__PURE__ */ function() {
    var $198 = $795e171a0788c8e1$var$wrappedOperation("sortBy");
    return function($199) {
        return $198($5krR0.sortBy($199));
    };
}();
var $795e171a0788c8e1$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $gwBF5.compare(dictOrd);
    return function(xs) {
        return $795e171a0788c8e1$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $795e171a0788c8e1$export$c40cf5aab899f397 = function(v) {
    return function(y) {
        return new $9aSRU.NonEmpty(v.value0, $5krR0.snoc(v.value1)(y));
    };
};
var $795e171a0788c8e1$export$439306a4dcaafbb9 = /* #__PURE__ */ function() {
    var $200 = $9aSRU.singleton($fZenR.plusList);
    return function($201) {
        return $fZenR.NonEmptyList($200($201));
    };
}();
var $795e171a0788c8e1$export$5b6d1d165591a48c = function(v) {
    return function(v1) {
        if (v instanceof $fZenR.Cons) return new $9aSRU.NonEmpty(v.value0, $5krR0.snoc(v.value1)(v1));
        if (v instanceof $fZenR.Nil) return $795e171a0788c8e1$export$439306a4dcaafbb9(v1);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 140, column 1 - line 140, column 51): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $795e171a0788c8e1$export$66c1ae025e96b4bc = /* #__PURE__ */ $795e171a0788c8e1$var$wrappedOperation("reverse")($5krR0.reverse);
var $795e171a0788c8e1$export$edce5881c815871 = function(dictEq) {
    return $795e171a0788c8e1$var$wrappedOperation("nubEq")($5krR0.nubEq(dictEq));
};
var $795e171a0788c8e1$export$45273896c792ff3b = /* #__PURE__ */ function() {
    var $202 = $795e171a0788c8e1$var$wrappedOperation("nubByEq");
    return function($203) {
        return $202($5krR0.nubByEq($203));
    };
}();
var $795e171a0788c8e1$export$18f77a3bafa759b9 = /* #__PURE__ */ function() {
    var $204 = $795e171a0788c8e1$var$wrappedOperation("nubBy");
    return function($205) {
        return $204($5krR0.nubBy($205));
    };
}();
var $795e171a0788c8e1$export$94f4066a75b10404 = function(dictOrd) {
    return $795e171a0788c8e1$var$wrappedOperation("nub")($5krR0.nub(dictOrd));
};
var $795e171a0788c8e1$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(v) {
            if (i === 0) return new $h2xUu.Just(new $9aSRU.NonEmpty(f(v.value0), v.value1));
            if ($iQTlW.otherwise) return $795e171a0788c8e1$var$map(function($206) {
                return $fZenR.NonEmptyList(function(v1) {
                    return new $9aSRU.NonEmpty(v.value0, v1);
                }($206));
            })($5krR0.modifyAt(i - 1 | 0)(f)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 203, column 1 - line 203, column 82): " + [
                i.constructor.name,
                f.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $795e171a0788c8e1$var$lift = function(f) {
    return function(v) {
        return f(new $fZenR.Cons(v.value0, v.value1));
    };
};
var $795e171a0788c8e1$export$e70771d2e7e590a = function($207) {
    return $795e171a0788c8e1$var$lift($5krR0.mapMaybe($207));
};
var $795e171a0788c8e1$export$b29f828819edca8d = function($208) {
    return $795e171a0788c8e1$var$lift($5krR0.partition($208));
};
var $795e171a0788c8e1$export$afc1bfabebaf28a2 = function($209) {
    return $795e171a0788c8e1$var$lift($5krR0.span($209));
};
var $795e171a0788c8e1$export$b7df5d561049483a = function($210) {
    return $795e171a0788c8e1$var$lift($5krR0.take($210));
};
var $795e171a0788c8e1$export$9384c7afe4015e42 = function($211) {
    return $795e171a0788c8e1$var$lift($5krR0.takeWhile($211));
};
var $795e171a0788c8e1$export$f24224f1c91d8156 = function(v) {
    return 1 + $5krR0.length(v.value1) | 0;
};
var $795e171a0788c8e1$export$4c7897fafd92b108 = function(v) {
    return $h2xUu.fromMaybe(v.value0)($5krR0.last(v.value1));
};
var $795e171a0788c8e1$export$f161f39e9c06ab2d = /* #__PURE__ */ function() {
    var $212 = $795e171a0788c8e1$var$wrappedOperation2("intersectBy");
    return function($213) {
        return $212($5krR0.intersectBy($213));
    };
}();
var $795e171a0788c8e1$export$1f4807a235930d45 = function(dictEq) {
    return $795e171a0788c8e1$var$wrappedOperation2("intersect")($5krR0.intersect(dictEq));
};
var $795e171a0788c8e1$export$9f200c4466975173 = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $h2xUu.Just(new $9aSRU.NonEmpty(a, new $fZenR.Cons(v.value0, v.value1)));
            if ($iQTlW.otherwise) return $795e171a0788c8e1$var$map(function($214) {
                return $fZenR.NonEmptyList(function(v1) {
                    return new $9aSRU.NonEmpty(v.value0, v1);
                }($214));
            })($5krR0.insertAt(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 193, column 1 - line 193, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $795e171a0788c8e1$export$2cd8252107eb640b = function(v) {
    return $h2xUu.maybe($fZenR.Nil.value)(function(v1) {
        return new $fZenR.Cons(v.value0, v1);
    })($5krR0.init(v.value1));
};
var $795e171a0788c8e1$export$b610b8812bbcded9 = function(v) {
    return function(i) {
        if (i === 0) return new $h2xUu.Just(v.value0);
        if ($iQTlW.otherwise) return $5krR0.index(v.value1)(i - 1 | 0);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 167, column 1 - line 167, column 52): " + [
            v.constructor.name,
            i.constructor.name
        ]);
    };
};
var $795e171a0788c8e1$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $795e171a0788c8e1$export$3f063810d7bf01bd = /* #__PURE__ */ function() {
    var $215 = $795e171a0788c8e1$var$wrappedOperation("groupBy");
    return function($216) {
        return $215($5krR0.groupBy($216));
    };
}();
var $795e171a0788c8e1$export$1f7a5bf12caafbd = /* #__PURE__ */ function() {
    var $217 = $795e171a0788c8e1$var$wrappedOperation("groupAllBy");
    return function($218) {
        return $217($5krR0.groupAllBy($218));
    };
}();
var $795e171a0788c8e1$export$361434b95a7d965 = function(dictOrd) {
    return $795e171a0788c8e1$var$wrappedOperation("groupAll")($5krR0.groupAll(dictOrd));
};
var $795e171a0788c8e1$export$e5e25fbcc1f7affe = function(dictEq) {
    return $795e171a0788c8e1$var$wrappedOperation("group")($5krR0.group(dictEq));
};
var $795e171a0788c8e1$export$88e0dae599377b39 = function(v) {
    if (v instanceof $fZenR.Nil) return $h2xUu.Nothing.value;
    if (v instanceof $fZenR.Cons) return new $h2xUu.Just(new $9aSRU.NonEmpty(v.value0, v.value1));
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 121, column 1 - line 121, column 57): " + [
        v.constructor.name
    ]);
};
var $795e171a0788c8e1$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var $219 = $5krR0.fromFoldable(dictFoldable);
    return function($220) {
        return $795e171a0788c8e1$export$88e0dae599377b39($219($220));
    };
};
var $795e171a0788c8e1$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $cADnC.bind(dictMonad.Bind1());
    var foldM1 = $5krR0.foldM(dictMonad);
    return function(f) {
        return function(b) {
            return function(v) {
                return bind1(f(b)(v.value0))(function(b$prime) {
                    return foldM1(f)(b$prime)(v.value1);
                });
            };
        };
    };
};
var $795e171a0788c8e1$export$8855a8be7bd3e9f8 = function(f) {
    return function(v) {
        var v1 = $5krR0.findLastIndex(f)(v.value1);
        if (v1 instanceof $h2xUu.Just) return new $h2xUu.Just(v1.value0 + 1 | 0);
        if (v1 instanceof $h2xUu.Nothing) {
            if (f(v.value0)) return new $h2xUu.Just(0);
            if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
        }
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 187, column 3 - line 191, column 29): " + [
            v1.constructor.name
        ]);
    };
};
var $795e171a0788c8e1$export$de3a4d4a0d731119 = function(f) {
    return function(v) {
        if (f(v.value0)) return new $h2xUu.Just(0);
        if ($iQTlW.otherwise) return $795e171a0788c8e1$var$map(function(v1) {
            return v1 + 1 | 0;
        })($5krR0.findIndex(f)(v.value1));
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 180, column 1 - line 180, column 69): " + [
            f.constructor.name,
            v.constructor.name
        ]);
    };
};
var $795e171a0788c8e1$export$20098ecb074a31e6 = function(dictMonad) {
    var $221 = $5krR0.filterM(dictMonad);
    return function($222) {
        return $795e171a0788c8e1$var$lift($221($222));
    };
};
var $795e171a0788c8e1$export$3dea766d36a8935f = function($223) {
    return $795e171a0788c8e1$var$lift($5krR0.filter($223));
};
var $795e171a0788c8e1$export$c19d79386f4ed99a = function(dictEq) {
    var eq1 = $aJhEx.eq(dictEq);
    return function(x) {
        return $795e171a0788c8e1$export$8855a8be7bd3e9f8(function(v) {
            return eq1(v)(x);
        });
    };
};
var $795e171a0788c8e1$export$f444781b0adb7e4d = function(dictEq) {
    var eq1 = $aJhEx.eq(dictEq);
    return function(x) {
        return $795e171a0788c8e1$export$de3a4d4a0d731119(function(v) {
            return eq1(v)(x);
        });
    };
};
var $795e171a0788c8e1$export$533af5c8cd6afa16 = function($224) {
    return $795e171a0788c8e1$var$lift($5krR0.dropWhile($224));
};
var $795e171a0788c8e1$export$663103110d94aac9 = function($225) {
    return $795e171a0788c8e1$var$lift($5krR0.drop($225));
};
var $795e171a0788c8e1$export$cc3b5f3f66225fbe = function(x) {
    return function(xs) {
        return new $9aSRU.NonEmpty(x, xs);
    };
};
var $795e171a0788c8e1$export$8327ebbef2a0ba76 = function(y) {
    return function(v) {
        return new $9aSRU.NonEmpty(y, new $fZenR.Cons(v.value0, v.value1));
    };
};
var $795e171a0788c8e1$export$c28c8388be0ab31a = /* #__PURE__ */ $jhsiw.flip($795e171a0788c8e1$var$bind);
var $795e171a0788c8e1$export$ee1b3e54f0441b22 = function(v) {
    return $795e171a0788c8e1$var$bind(v)($795e171a0788c8e1$var$identity);
};
var $795e171a0788c8e1$export$986c2bbe7a34be0b = /* #__PURE__ */ $795e171a0788c8e1$var$lift($5krR0.catMaybes);
var $795e171a0788c8e1$export$89c5a0ebe497f8c7 = function(dictFoldable) {
    var fromFoldable1 = $5krR0.fromFoldable(dictFoldable);
    return function(v) {
        return function(ys) {
            return new $9aSRU.NonEmpty(v.value0, $795e171a0788c8e1$var$append1(v.value1)(fromFoldable1(ys)));
        };
    };
};



var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $2XxiF = parcelRequire("2XxiF");

var $4Fu8m = parcelRequire("4Fu8m");

var $k2DSm = parcelRequire("k2DSm");
var $3159c1316ac7a043$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showString);
var $3159c1316ac7a043$var$show1 = /* #__PURE__ */ $2XxiF.show($2XxiF.showInt);
var $3159c1316ac7a043$var$pure = /* #__PURE__ */ $bQdkN.pure($beQI1.applicativeEither);
var $3159c1316ac7a043$var$compare = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordString);
var $3159c1316ac7a043$var$compare1 = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordInt);
var $3159c1316ac7a043$export$f6a37cc43a8b8898 = /* #__PURE__ */ function() {
    function ForeignError(value0) {
        this.value0 = value0;
    }
    ForeignError.create = function(value0) {
        return new ForeignError(value0);
    };
    return ForeignError;
}();
var $3159c1316ac7a043$export$168e2d3b16829a = /* #__PURE__ */ function() {
    function TypeMismatch(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TypeMismatch.create = function(value0) {
        return function(value1) {
            return new TypeMismatch(value0, value1);
        };
    };
    return TypeMismatch;
}();
var $3159c1316ac7a043$export$20d9a5af040a79f1 = /* #__PURE__ */ function() {
    function ErrorAtIndex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtIndex.create = function(value0) {
        return function(value1) {
            return new ErrorAtIndex(value0, value1);
        };
    };
    return ErrorAtIndex;
}();
var $3159c1316ac7a043$export$92e5795aa905bd26 = /* #__PURE__ */ function() {
    function ErrorAtProperty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtProperty.create = function(value0) {
        return function(value1) {
            return new ErrorAtProperty(value0, value1);
        };
    };
    return ErrorAtProperty;
}();
var $3159c1316ac7a043$export$9d82982d31d9d171 = $k2DSm.unsafeCoerce;
var $3159c1316ac7a043$export$19df04dfac508e15 = $k2DSm.unsafeCoerce;
var $3159c1316ac7a043$export$ca110433ecb89bbf = {
    show: function(v) {
        if (v instanceof $3159c1316ac7a043$export$f6a37cc43a8b8898) return "(ForeignError " + ($3159c1316ac7a043$var$show(v.value0) + ")");
        if (v instanceof $3159c1316ac7a043$export$20d9a5af040a79f1) return "(ErrorAtIndex " + ($3159c1316ac7a043$var$show1(v.value0) + (" " + ($2XxiF.show($3159c1316ac7a043$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $3159c1316ac7a043$export$92e5795aa905bd26) return "(ErrorAtProperty " + ($3159c1316ac7a043$var$show(v.value0) + (" " + ($2XxiF.show($3159c1316ac7a043$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $3159c1316ac7a043$export$168e2d3b16829a) return "(TypeMismatch " + ($3159c1316ac7a043$var$show(v.value0) + (" " + ($3159c1316ac7a043$var$show(v.value1) + ")")));
        throw new Error("Failed pattern match at Foreign (line 69, column 1 - line 73, column 89): " + [
            v.constructor.name
        ]);
    }
};
var $3159c1316ac7a043$export$a2293656e769bd56 = function(v) {
    if (v instanceof $3159c1316ac7a043$export$f6a37cc43a8b8898) return v.value0;
    if (v instanceof $3159c1316ac7a043$export$20d9a5af040a79f1) return "Error at array index " + ($3159c1316ac7a043$var$show1(v.value0) + (": " + $3159c1316ac7a043$export$a2293656e769bd56(v.value1)));
    if (v instanceof $3159c1316ac7a043$export$92e5795aa905bd26) return "Error at property " + ($3159c1316ac7a043$var$show(v.value0) + (": " + $3159c1316ac7a043$export$a2293656e769bd56(v.value1)));
    if (v instanceof $3159c1316ac7a043$export$168e2d3b16829a) return "Type mismatch: expected " + (v.value0 + (", found " + v.value1));
    throw new Error("Failed pattern match at Foreign (line 78, column 1 - line 78, column 45): " + [
        v.constructor.name
    ]);
};
var $3159c1316ac7a043$export$4e0f52105ee4b19b = function(dictMonad) {
    var pure1 = $bQdkN.pure($2603701dab447006$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($bbd1c096e2c7f227$export$fce6876652108ab(value)) return pure1($h2xUu.Nothing.value);
        if ($iQTlW.otherwise) return pure1(new $h2xUu.Just(value));
        throw new Error("Failed pattern match at Foreign (line 174, column 1 - line 174, column 103): " + [
            value.constructor.name
        ]);
    };
};
var $3159c1316ac7a043$export$a540325489296c24 = function(dictMonad) {
    var pure1 = $bQdkN.pure($2603701dab447006$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($bbd1c096e2c7f227$export$630801d484da15df(value) || $bbd1c096e2c7f227$export$fce6876652108ab(value)) return pure1($h2xUu.Nothing.value);
        if ($iQTlW.otherwise) return pure1(new $h2xUu.Just(value));
        throw new Error("Failed pattern match at Foreign (line 179, column 1 - line 179, column 109): " + [
            value.constructor.name
        ]);
    };
};
var $3159c1316ac7a043$export$62e87727fba30d8d = function(dictMonad) {
    var pure1 = $bQdkN.pure($2603701dab447006$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($bbd1c096e2c7f227$export$630801d484da15df(value)) return pure1($h2xUu.Nothing.value);
        if ($iQTlW.otherwise) return pure1(new $h2xUu.Just(value));
        throw new Error("Failed pattern match at Foreign (line 169, column 1 - line 169, column 98): " + [
            value.constructor.name
        ]);
    };
};
var $3159c1316ac7a043$export$2b62a06a9fee979c = function(dictMonad) {
    var $153 = $693a27a8782d8e71$export$8bf7aba4a9e09055($2603701dab447006$export$75f89ba5e7a712b0(dictMonad));
    return function($154) {
        return $153($795e171a0788c8e1$export$439306a4dcaafbb9($154));
    };
};
var $3159c1316ac7a043$export$d3f4ca0e55363719 = function(dictMonad) {
    var pure1 = $bQdkN.pure($2603701dab447006$export$963960a96c103d2f(dictMonad));
    var fail1 = $3159c1316ac7a043$export$2b62a06a9fee979c(dictMonad);
    return function(value) {
        if ($bbd1c096e2c7f227$export$43bee75e5e14138e(value)) return pure1($3159c1316ac7a043$export$19df04dfac508e15(value));
        if ($iQTlW.otherwise) return fail1(new $3159c1316ac7a043$export$168e2d3b16829a("array", $bbd1c096e2c7f227$export$348caad1e8d41c5f(value)));
        throw new Error("Failed pattern match at Foreign (line 164, column 1 - line 164, column 99): " + [
            value.constructor.name
        ]);
    };
};
var $3159c1316ac7a043$export$6190f2182377b437 = function(dictMonad) {
    var pure1 = $bQdkN.pure($2603701dab447006$export$963960a96c103d2f(dictMonad));
    var fail1 = $3159c1316ac7a043$export$2b62a06a9fee979c(dictMonad);
    return function(tag) {
        return function(value) {
            if ($bbd1c096e2c7f227$export$348caad1e8d41c5f(value) === tag) return pure1($3159c1316ac7a043$export$19df04dfac508e15(value));
            if ($iQTlW.otherwise) return fail1(new $3159c1316ac7a043$export$168e2d3b16829a(tag, $bbd1c096e2c7f227$export$348caad1e8d41c5f(value)));
            throw new Error("Failed pattern match at Foreign (line 123, column 1 - line 123, column 104): " + [
                tag.constructor.name,
                value.constructor.name
            ]);
        };
    };
};
var $3159c1316ac7a043$export$f9a84177eae95ed5 = function(dictMonad) {
    return $3159c1316ac7a043$export$6190f2182377b437(dictMonad)("Boolean");
};
var $3159c1316ac7a043$export$347fd215c36b10be = function(dictMonad) {
    return $3159c1316ac7a043$export$6190f2182377b437(dictMonad)("Number");
};
var $3159c1316ac7a043$export$ac3747cb00139c63 = function(dictMonad) {
    var map = $7FzSN.map(dictMonad.Bind1().Apply0().Functor0());
    var readNumber1 = $3159c1316ac7a043$export$347fd215c36b10be(dictMonad);
    return function(value) {
        var error = new $beQI1.Left($795e171a0788c8e1$export$439306a4dcaafbb9(new $3159c1316ac7a043$export$168e2d3b16829a("Int", $bbd1c096e2c7f227$export$348caad1e8d41c5f(value))));
        var fromNumber = function() {
            var $155 = $h2xUu.maybe(error)($3159c1316ac7a043$var$pure);
            return function($156) {
                return $155($hCjGZ.fromNumber($156));
            };
        }();
        return $2603701dab447006$export$34cbd9fbda5c1fb2(map($beQI1.either($jhsiw.const(error))(fromNumber)))(readNumber1(value));
    };
};
var $3159c1316ac7a043$export$dda73877cb166cd3 = function(dictMonad) {
    return $3159c1316ac7a043$export$6190f2182377b437(dictMonad)("String");
};
var $3159c1316ac7a043$export$85b98eeba3f0a3b4 = function(dictMonad) {
    var map = $7FzSN.map(dictMonad.Bind1().Apply0().Functor0());
    var readString1 = $3159c1316ac7a043$export$dda73877cb166cd3(dictMonad);
    return function(value) {
        var error = new $beQI1.Left($795e171a0788c8e1$export$439306a4dcaafbb9(new $3159c1316ac7a043$export$168e2d3b16829a("Char", $bbd1c096e2c7f227$export$348caad1e8d41c5f(value))));
        var fromString = function() {
            var $157 = $h2xUu.maybe(error)($3159c1316ac7a043$var$pure);
            return function($158) {
                return $157($4Fu8m.toChar($158));
            };
        }();
        return $2603701dab447006$export$34cbd9fbda5c1fb2(map($beQI1.either($jhsiw.const(error))(fromString)))(readString1(value));
    };
};
var $3159c1316ac7a043$export$29dc7ef345289543 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $3159c1316ac7a043$export$f6a37cc43a8b8898 && y instanceof $3159c1316ac7a043$export$f6a37cc43a8b8898) return x.value0 === y.value0;
            if (x instanceof $3159c1316ac7a043$export$168e2d3b16829a && y instanceof $3159c1316ac7a043$export$168e2d3b16829a) return x.value0 === y.value0 && x.value1 === y.value1;
            if (x instanceof $3159c1316ac7a043$export$20d9a5af040a79f1 && y instanceof $3159c1316ac7a043$export$20d9a5af040a79f1) return x.value0 === y.value0 && $aJhEx.eq($3159c1316ac7a043$export$29dc7ef345289543)(x.value1)(y.value1);
            if (x instanceof $3159c1316ac7a043$export$92e5795aa905bd26 && y instanceof $3159c1316ac7a043$export$92e5795aa905bd26) return x.value0 === y.value0 && $aJhEx.eq($3159c1316ac7a043$export$29dc7ef345289543)(x.value1)(y.value1);
            return false;
        };
    }
};
var $3159c1316ac7a043$export$661e78eef4f027af = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $3159c1316ac7a043$export$f6a37cc43a8b8898 && y instanceof $3159c1316ac7a043$export$f6a37cc43a8b8898) return $3159c1316ac7a043$var$compare(x.value0)(y.value0);
            if (x instanceof $3159c1316ac7a043$export$f6a37cc43a8b8898) return $ibsD5.LT.value;
            if (y instanceof $3159c1316ac7a043$export$f6a37cc43a8b8898) return $ibsD5.GT.value;
            if (x instanceof $3159c1316ac7a043$export$168e2d3b16829a && y instanceof $3159c1316ac7a043$export$168e2d3b16829a) {
                var v = $3159c1316ac7a043$var$compare(x.value0)(y.value0);
                if (v instanceof $ibsD5.LT) return $ibsD5.LT.value;
                if (v instanceof $ibsD5.GT) return $ibsD5.GT.value;
                return $3159c1316ac7a043$var$compare(x.value1)(y.value1);
            }
            if (x instanceof $3159c1316ac7a043$export$168e2d3b16829a) return $ibsD5.LT.value;
            if (y instanceof $3159c1316ac7a043$export$168e2d3b16829a) return $ibsD5.GT.value;
            if (x instanceof $3159c1316ac7a043$export$20d9a5af040a79f1 && y instanceof $3159c1316ac7a043$export$20d9a5af040a79f1) {
                var v = $3159c1316ac7a043$var$compare1(x.value0)(y.value0);
                if (v instanceof $ibsD5.LT) return $ibsD5.LT.value;
                if (v instanceof $ibsD5.GT) return $ibsD5.GT.value;
                return $gwBF5.compare($3159c1316ac7a043$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            if (x instanceof $3159c1316ac7a043$export$20d9a5af040a79f1) return $ibsD5.LT.value;
            if (y instanceof $3159c1316ac7a043$export$20d9a5af040a79f1) return $ibsD5.GT.value;
            if (x instanceof $3159c1316ac7a043$export$92e5795aa905bd26 && y instanceof $3159c1316ac7a043$export$92e5795aa905bd26) {
                var v = $3159c1316ac7a043$var$compare(x.value0)(y.value0);
                if (v instanceof $ibsD5.LT) return $ibsD5.LT.value;
                if (v instanceof $ibsD5.GT) return $ibsD5.GT.value;
                return $gwBF5.compare($3159c1316ac7a043$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            throw new Error("Failed pattern match at Foreign (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $3159c1316ac7a043$export$29dc7ef345289543;
    }
};


// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");


var $beQI1 = parcelRequire("beQI1");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");



// Generated by purs version 0.15.16
var $3377ad3d314af44e$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
const $3377ad3d314af44e$export$bacb5cc5a11aef16 = $3377ad3d314af44e$var$getEffProp("children");
const $3377ad3d314af44e$export$52f4bb9f897f1dda = $3377ad3d314af44e$var$getEffProp("firstElementChild");
const $3377ad3d314af44e$export$b58800d9b8f19191 = $3377ad3d314af44e$var$getEffProp("lastElementChild");
const $3377ad3d314af44e$export$f89766fb54dff747 = $3377ad3d314af44e$var$getEffProp("childElementCount");
function $3377ad3d314af44e$export$242934abc2863db9(selector) {
    return function(node) {
        return function() {
            return node.querySelector(selector);
        };
    };
}
function $3377ad3d314af44e$export$2e83b5c43fb7af7b(selector) {
    return function(node) {
        return function() {
            return node.querySelectorAll(selector);
        };
    };
}



var $aJhEx = parcelRequire("aJhEx");

var $7FzSN = parcelRequire("7FzSN");
// Generated by purs version 0.15.16
/* eslint-disable no-eq-null, eqeqeq */ const $b3b92e17f8115510$export$7b1b591b262c240 = null;
function $b3b92e17f8115510$export$133fc36489ac9add(a, r, f) {
    return a == null ? r : f(a);
}
function $b3b92e17f8115510$export$9b7835891cf7097a(x) {
    return x;
}



var $aJhEx = parcelRequire("aJhEx");

var $jhsiw = parcelRequire("jhsiw");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $2XxiF = parcelRequire("2XxiF");
var $ae4217dcc85a7c03$export$b187f57ee1822bc5 = /* #__PURE__ */ $h2xUu.maybe($b3b92e17f8115510$export$7b1b591b262c240)($b3b92e17f8115510$export$9b7835891cf7097a);
var $ae4217dcc85a7c03$export$1ba013b88f4f21f3 = function(n) {
    return $b3b92e17f8115510$export$133fc36489ac9add(n, $h2xUu.Nothing.value, $h2xUu.Just.create);
};
var $ae4217dcc85a7c03$export$643760463fdd14c1 = function(dictShow) {
    return {
        show: function() {
            var $17 = $h2xUu.maybe("null")($2XxiF.show(dictShow));
            return function($18) {
                return $17($ae4217dcc85a7c03$export$1ba013b88f4f21f3($18));
            };
        }()
    };
};
var $ae4217dcc85a7c03$export$1d97b52fc2e07cdc = function(dictEq) {
    return {
        eq: $jhsiw.on($aJhEx.eq($h2xUu.eqMaybe(dictEq)))($ae4217dcc85a7c03$export$1ba013b88f4f21f3)
    };
};
var $ae4217dcc85a7c03$export$4fb7d8da662af215 = function(dictOrd) {
    var eqNullable1 = $ae4217dcc85a7c03$export$1d97b52fc2e07cdc(dictOrd.Eq0());
    return {
        compare: $jhsiw.on($gwBF5.compare($h2xUu.ordMaybe(dictOrd)))($ae4217dcc85a7c03$export$1ba013b88f4f21f3),
        Eq0: function() {
            return eqNullable1;
        }
    };
};
var $ae4217dcc85a7c03$export$1b7ecac9aff49fbc = {
    eq1: function(dictEq) {
        return $aJhEx.eq($ae4217dcc85a7c03$export$1d97b52fc2e07cdc(dictEq));
    }
};
var $ae4217dcc85a7c03$export$46a371b99e80ea42 = {
    compare1: function(dictOrd) {
        return $gwBF5.compare($ae4217dcc85a7c03$export$4fb7d8da662af215(dictOrd));
    },
    Eq10: function() {
        return $ae4217dcc85a7c03$export$1b7ecac9aff49fbc;
    }
};



var $gwBF5 = parcelRequire("gwBF5");

var $1rTTn = parcelRequire("1rTTn");
var $272e5e67d54dabbd$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $272e5e67d54dabbd$export$fe9de06a57e74a75 = function(x) {
    return x;
};
var $272e5e67d54dabbd$export$78fb49a702cc1f2 = function(qs) {
    var $2 = $272e5e67d54dabbd$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    var $3 = $3377ad3d314af44e$export$242934abc2863db9(qs);
    return function($4) {
        return $2($3($4));
    };
};
var $272e5e67d54dabbd$export$52785ae9e93eaaf8 = $gwBF5.ordString;
var $272e5e67d54dabbd$export$ed55255aef9f10db = {
    Coercible0: function() {
        return undefined;
    }
};
var $272e5e67d54dabbd$export$80cfcf47c97f2a3 = /* #__PURE__ */ function() {
    var $5 = $272e5e67d54dabbd$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($6) {
        return $5($3377ad3d314af44e$export$b58800d9b8f19191($6));
    };
}();
var $272e5e67d54dabbd$export$ef511da7c0e45881 = /* #__PURE__ */ function() {
    var $7 = $272e5e67d54dabbd$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($8) {
        return $7($3377ad3d314af44e$export$52f4bb9f897f1dda($8));
    };
}();
var $272e5e67d54dabbd$export$d5769763ca9e4d49 = $aJhEx.eqString;


// Generated by purs version 0.15.16
function $d8dd8b0292692afb$export$f5cdf3809b4587f3(fn) {
    return function() {
        return function(event) {
            return fn(event)();
        };
    };
}
function $d8dd8b0292692afb$export$d5d038f71f8391de(type) {
    return function(listener) {
        return function(options) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, options);
                };
            };
        };
    };
}
function $d8dd8b0292692afb$export$3f65cefe8380dbea(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $d8dd8b0292692afb$export$8ff9f68337b520c0(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.removeEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $d8dd8b0292692afb$export$716a11175c03fb4e(event) {
    return function(target) {
        return function() {
            return target.dispatchEvent(event);
        };
    };
}


// Generated by purs version 0.15.16




// Generated by purs version 0.15.16
const $df82538a253b5856$export$8291e5b88f90ce4 = function() {
    return window;
};


// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $gwBF5 = parcelRequire("gwBF5");
var $cd914e87d8df7dcd$export$212382f8c1a1154e = function(x) {
    return x;
};
var $cd914e87d8df7dcd$export$880a60b2adf28011 = function(x) {
    return x;
};
var $cd914e87d8df7dcd$export$ede06c734afe650b = function(x) {
    return x;
};
var $cd914e87d8df7dcd$export$95abab3275973ab6 = $gwBF5.ordString;
var $cd914e87d8df7dcd$export$c58d7d69adf07268 = $gwBF5.ordString;
var $cd914e87d8df7dcd$export$6d81548222f15a9a = $gwBF5.ordString;
var $cd914e87d8df7dcd$export$e2c5e238f46c1980 = {
    Coercible0: function() {
        return undefined;
    }
};
var $cd914e87d8df7dcd$export$a0bcd3a016e5808d = {
    Coercible0: function() {
        return undefined;
    }
};
var $cd914e87d8df7dcd$export$7e4243c3c9480b2b = {
    Coercible0: function() {
        return undefined;
    }
};
var $cd914e87d8df7dcd$export$24a4aa0a132c9555 = $aJhEx.eqString;
var $cd914e87d8df7dcd$export$b50b66d86c8b8bf = $aJhEx.eqString;
var $cd914e87d8df7dcd$export$10c76280137f9306 = $aJhEx.eqString;


// Generated by purs version 0.15.16
function $3bbd2542d6337140$export$44271b4f0c6a3563(a) {
    return function() {
        return a.target;
    };
}
function $3bbd2542d6337140$export$1f61c53461aff4a5(target) {
    return function(a) {
        return function() {
            a.target = target;
        };
    };
}
function $3bbd2542d6337140$export$24422be91ad4011f(a) {
    return function() {
        return a.download;
    };
}
function $3bbd2542d6337140$export$4c9843daef742201(download) {
    return function(a) {
        return function() {
            a.download = download;
        };
    };
}
function $3bbd2542d6337140$export$bad408f43b005bc8(a) {
    return function() {
        return a.rel;
    };
}
function $3bbd2542d6337140$export$9e86d1af7d63c52c(rel) {
    return function(a) {
        return function() {
            a.rel = rel;
        };
    };
}
function $3bbd2542d6337140$export$edb1c8e715f3944e(a) {
    return function() {
        return a.rev;
    };
}
function $3bbd2542d6337140$export$671b41179a9f15fb(rev) {
    return function(a) {
        return function() {
            a.rev = rev;
        };
    };
}
function $3bbd2542d6337140$export$5884a0b424dd5ef2(a) {
    return function() {
        return a.relList;
    };
}
function $3bbd2542d6337140$export$4bf4138386d6b8cc(a) {
    return function() {
        return a.hreflang;
    };
}
function $3bbd2542d6337140$export$17b5334c80252e15(hreflang) {
    return function(a) {
        return function() {
            a.hreflang = hreflang;
        };
    };
}
function $3bbd2542d6337140$export$d4a6a4db5b31e621(a) {
    return function() {
        return a.type;
    };
}
function $3bbd2542d6337140$export$1bf7f05044e9c5cb(type) {
    return function(a) {
        return function() {
            a.type = type;
        };
    };
}
function $3bbd2542d6337140$export$6f093cfa640b7166(a) {
    return function() {
        return a.text;
    };
}
function $3bbd2542d6337140$export$cbe0d99836e1498f(text) {
    return function(a) {
        return function() {
            a.text = text;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");
// Generated by purs version 0.15.16
function $43dde9141ddc9ef3$export$5235d6e581ca586e(nothing, just, name, value) {
    if (typeof window !== "undefined") {
        var ty = window[name];
        if (ty != null && value instanceof ty) return just(value);
    }
    var obj = value;
    while(obj != null){
        var proto = Object.getPrototypeOf(obj);
        var constructorName = proto.constructor.name;
        if (constructorName === name) return just(value);
        else if (constructorName === "Object") return nothing;
        obj = proto;
    }
    return nothing;
}



var $h2xUu = parcelRequire("h2xUu");
var $567433c702f2bfe3$export$e3dc45f84eae905c = function(name) {
    return function(value) {
        return $43dde9141ddc9ef3$export$5235d6e581ca586e($h2xUu.Nothing.value, $h2xUu.Just.create, name, value);
    };
};


var $2aa5dea6048395be$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $2aa5dea6048395be$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $2aa5dea6048395be$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $2aa5dea6048395be$export$9da26c0441db8b03 = $k2DSm.unsafeCoerce;
var $2aa5dea6048395be$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $2aa5dea6048395be$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $2aa5dea6048395be$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $2aa5dea6048395be$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $2aa5dea6048395be$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAnchorElement");
var $2aa5dea6048395be$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAnchorElement");
var $2aa5dea6048395be$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAnchorElement");
var $2aa5dea6048395be$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAnchorElement");
var $2aa5dea6048395be$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAnchorElement");
var $2aa5dea6048395be$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAnchorElement");
var $2aa5dea6048395be$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAnchorElement");


// Generated by purs version 0.15.16
function $92d3c91c8cba9b19$export$228be17d80722ab(area) {
    return function() {
        return area.alt;
    };
}
function $92d3c91c8cba9b19$export$14a0e7c2e6152665(alt) {
    return function(area) {
        return function() {
            area.alt = alt;
        };
    };
}
function $92d3c91c8cba9b19$export$5bf93b4680474bd(area) {
    return function() {
        return area.coords;
    };
}
function $92d3c91c8cba9b19$export$d03eafa2070fb6d7(coords) {
    return function(area) {
        return function() {
            area.coords = coords;
        };
    };
}
function $92d3c91c8cba9b19$export$98bada23690e67eb(area) {
    return function() {
        return area.shape;
    };
}
function $92d3c91c8cba9b19$export$89565ec41213f41c(shape) {
    return function(area) {
        return function() {
            area.shape = shape;
        };
    };
}
function $92d3c91c8cba9b19$export$44271b4f0c6a3563(area) {
    return function() {
        return area.target;
    };
}
function $92d3c91c8cba9b19$export$1f61c53461aff4a5(target) {
    return function(area) {
        return function() {
            area.target = target;
        };
    };
}
function $92d3c91c8cba9b19$export$24422be91ad4011f(area) {
    return function() {
        return area.download;
    };
}
function $92d3c91c8cba9b19$export$4c9843daef742201(download) {
    return function(area) {
        return function() {
            area.download = download;
        };
    };
}
function $92d3c91c8cba9b19$export$bad408f43b005bc8(area) {
    return function() {
        return area.rel;
    };
}
function $92d3c91c8cba9b19$export$9e86d1af7d63c52c(rel) {
    return function(area) {
        return function() {
            area.rel = rel;
        };
    };
}
function $92d3c91c8cba9b19$export$5884a0b424dd5ef2(area) {
    return function() {
        return area.relList;
    };
}
function $92d3c91c8cba9b19$export$4bf4138386d6b8cc(area) {
    return function() {
        return area.hreflang;
    };
}
function $92d3c91c8cba9b19$export$17b5334c80252e15(hreflang) {
    return function(area) {
        return function() {
            area.hreflang = hreflang;
        };
    };
}
function $92d3c91c8cba9b19$export$d4a6a4db5b31e621(area) {
    return function() {
        return area.type;
    };
}
function $92d3c91c8cba9b19$export$1bf7f05044e9c5cb(type) {
    return function(area) {
        return function() {
            area.type = type;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $eb7974a7d19f38b3$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $eb7974a7d19f38b3$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $eb7974a7d19f38b3$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $eb7974a7d19f38b3$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $eb7974a7d19f38b3$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $eb7974a7d19f38b3$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $eb7974a7d19f38b3$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $eb7974a7d19f38b3$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAreaElement");
var $eb7974a7d19f38b3$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAreaElement");
var $eb7974a7d19f38b3$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAreaElement");
var $eb7974a7d19f38b3$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAreaElement");
var $eb7974a7d19f38b3$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAreaElement");
var $eb7974a7d19f38b3$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAreaElement");
var $eb7974a7d19f38b3$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAreaElement");


// Generated by purs version 0.15.16
function $12da591e5358c278$export$185802fd694ee1f5() {
    return new Audio();
}
function $12da591e5358c278$export$2faa2f53d87c7f7e(url) {
    return function() {
        return new Audio(url);
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $e3c1d5e1a8ff6c64$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $e3c1d5e1a8ff6c64$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $e3c1d5e1a8ff6c64$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $e3c1d5e1a8ff6c64$export$fd26055f9731f4b9 = $k2DSm.unsafeCoerce;
var $e3c1d5e1a8ff6c64$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $e3c1d5e1a8ff6c64$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $e3c1d5e1a8ff6c64$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $e3c1d5e1a8ff6c64$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $e3c1d5e1a8ff6c64$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAudioElement");
var $e3c1d5e1a8ff6c64$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAudioElement");
var $e3c1d5e1a8ff6c64$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAudioElement");
var $e3c1d5e1a8ff6c64$export$cdb626e247ef0ce5 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAudioElement");
var $e3c1d5e1a8ff6c64$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAudioElement");
var $e3c1d5e1a8ff6c64$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAudioElement");
var $e3c1d5e1a8ff6c64$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAudioElement");
var $e3c1d5e1a8ff6c64$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLAudioElement");
var $e3c1d5e1a8ff6c64$export$20f9c2173df486a8 = $12da591e5358c278$export$2faa2f53d87c7f7e;


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $6313e6b63b135961$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $6313e6b63b135961$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $6313e6b63b135961$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $6313e6b63b135961$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $6313e6b63b135961$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $6313e6b63b135961$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $6313e6b63b135961$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $6313e6b63b135961$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBRElement");
var $6313e6b63b135961$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBRElement");
var $6313e6b63b135961$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBRElement");
var $6313e6b63b135961$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBRElement");
var $6313e6b63b135961$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBRElement");
var $6313e6b63b135961$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBRElement");
var $6313e6b63b135961$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBRElement");


// Generated by purs version 0.15.16
function $481880fe87bd7542$export$8f51af5840e0602a(base) {
    return function() {
        return base.href;
    };
}
function $481880fe87bd7542$export$428f6e77b5a5a669(href) {
    return function(base) {
        return function() {
            base.href = href;
        };
    };
}
function $481880fe87bd7542$export$44271b4f0c6a3563(base) {
    return function() {
        return base.target;
    };
}
function $481880fe87bd7542$export$1f61c53461aff4a5(target) {
    return function(base) {
        return function() {
            base.target = target;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $028a662d0956fd00$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $028a662d0956fd00$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $028a662d0956fd00$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $028a662d0956fd00$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $028a662d0956fd00$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $028a662d0956fd00$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $028a662d0956fd00$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $028a662d0956fd00$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBaseElement");
var $028a662d0956fd00$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBaseElement");
var $028a662d0956fd00$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBaseElement");
var $028a662d0956fd00$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBaseElement");
var $028a662d0956fd00$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBaseElement");
var $028a662d0956fd00$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBaseElement");
var $028a662d0956fd00$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBaseElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $dff077894fa572cb$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $dff077894fa572cb$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $dff077894fa572cb$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $dff077894fa572cb$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $dff077894fa572cb$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $dff077894fa572cb$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $dff077894fa572cb$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $dff077894fa572cb$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBodyElement");
var $dff077894fa572cb$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBodyElement");
var $dff077894fa572cb$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBodyElement");
var $dff077894fa572cb$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBodyElement");
var $dff077894fa572cb$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBodyElement");
var $dff077894fa572cb$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBodyElement");
var $dff077894fa572cb$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLBodyElement");


// Generated by purs version 0.15.16
function $85a54f5f577916ed$export$4c47992fc278c9a0(button) {
    return function() {
        return button.autofocus;
    };
}
function $85a54f5f577916ed$export$db2bbdcbda3d335e(autofocus) {
    return function(button) {
        return function() {
            button.autofocus = autofocus;
        };
    };
}
function $85a54f5f577916ed$export$683472f6198a076e(button) {
    return function() {
        return button.disabled;
    };
}
function $85a54f5f577916ed$export$4532d31cef66d703(disabled) {
    return function(button) {
        return function() {
            button.disabled = disabled;
        };
    };
}
function $85a54f5f577916ed$export$242c63e9758836c2(button) {
    return function() {
        return button.form;
    };
}
function $85a54f5f577916ed$export$7e4d70bab1b5c4a0(button) {
    return function() {
        return button.formAction;
    };
}
function $85a54f5f577916ed$export$577bb1d64e4c83b9(formAction) {
    return function(button) {
        return function() {
            button.formAction = formAction;
        };
    };
}
function $85a54f5f577916ed$export$21f1c8008acfa9c0(button) {
    return function() {
        return button.formEnctype;
    };
}
function $85a54f5f577916ed$export$346989dcff4ba18b(formEnctype) {
    return function(button) {
        return function() {
            button.formEnctype = formEnctype;
        };
    };
}
function $85a54f5f577916ed$export$3f1ffee261a00124(button) {
    return function() {
        return button.formMethod;
    };
}
function $85a54f5f577916ed$export$c38a1a871bb0e145(formMethod) {
    return function(button) {
        return function() {
            button.formMethod = formMethod;
        };
    };
}
function $85a54f5f577916ed$export$87c857905fcc4a84(button) {
    return function() {
        return button.formNoValidate;
    };
}
function $85a54f5f577916ed$export$ad9ff32d0af51586(formNoValidate) {
    return function(button) {
        return function() {
            button.formNoValidate = formNoValidate;
        };
    };
}
function $85a54f5f577916ed$export$497949a0ae76184f(button) {
    return function() {
        return button.formTarget;
    };
}
function $85a54f5f577916ed$export$4c7e983548149eb5(formTarget) {
    return function(button) {
        return function() {
            button.formTarget = formTarget;
        };
    };
}
function $85a54f5f577916ed$export$a8ff84c12d48cfa6(button) {
    return function() {
        return button.name;
    };
}
function $85a54f5f577916ed$export$6cf3d710d3a367e5(name) {
    return function(button) {
        return function() {
            button.name = name;
        };
    };
}
function $85a54f5f577916ed$export$d4a6a4db5b31e621(button) {
    return function() {
        return button.type;
    };
}
function $85a54f5f577916ed$export$1bf7f05044e9c5cb(type) {
    return function(button) {
        return function() {
            button.type = type;
        };
    };
}
function $85a54f5f577916ed$export$2ab9a8f9f1186f14(button) {
    return function() {
        return button.value;
    };
}
function $85a54f5f577916ed$export$80746c6bc6142fc8(value) {
    return function(button) {
        return function() {
            button.value = value;
        };
    };
}
function $85a54f5f577916ed$export$5e55a9e709e8e020(button) {
    return function() {
        return button.willValidate;
    };
}
function $85a54f5f577916ed$export$1bdd3f9a89b22594(button) {
    return function() {
        return button.validity;
    };
}
function $85a54f5f577916ed$export$6ee4201e37a931e2(button) {
    return function() {
        return button.validationMessage;
    };
}
function $85a54f5f577916ed$export$50d70f8cedc54453(button) {
    return function() {
        return button.checkValidity();
    };
}
function $85a54f5f577916ed$export$b962d864c477cc49(button) {
    return function() {
        return button.reportValidity();
    };
}
function $85a54f5f577916ed$export$6f569cb704992105(value) {
    return function(button) {
        return function() {
            button.setCustomValidity(value);
        };
    };
}
function $85a54f5f577916ed$export$a238cb463698c900(button) {
    return function() {
        return button.labels;
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $790dd0171ccfb25f$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $790dd0171ccfb25f$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $790dd0171ccfb25f$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $790dd0171ccfb25f$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $790dd0171ccfb25f$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $790dd0171ccfb25f$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $790dd0171ccfb25f$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $790dd0171ccfb25f$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLButtonElement");
var $790dd0171ccfb25f$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLButtonElement");
var $790dd0171ccfb25f$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLButtonElement");
var $790dd0171ccfb25f$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLButtonElement");
var $790dd0171ccfb25f$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLButtonElement");
var $790dd0171ccfb25f$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLButtonElement");
var $790dd0171ccfb25f$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLButtonElement");
var $790dd0171ccfb25f$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $7FzSN.map($1rTTn.functorEffect)($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($85a54f5f577916ed$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $85aebf346d79799d$export$7e3df82ee760448c(canvas) {
    return function() {
        return canvas.width;
    };
}
function $85aebf346d79799d$export$67f48e0594af05d(width) {
    return function(canvas) {
        return function() {
            canvas.width = width;
        };
    };
}
function $85aebf346d79799d$export$ac607276a8fe9f0a(canvas) {
    return function() {
        return canvas.height;
    };
}
function $85aebf346d79799d$export$3f31360357be44e4(height) {
    return function(canvas) {
        return function() {
            canvas.height = height;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $d60fe5c89f0ee870$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $d60fe5c89f0ee870$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $d60fe5c89f0ee870$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $d60fe5c89f0ee870$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $d60fe5c89f0ee870$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $d60fe5c89f0ee870$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $d60fe5c89f0ee870$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $d60fe5c89f0ee870$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLCanvasElement");
var $d60fe5c89f0ee870$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLCanvasElement");
var $d60fe5c89f0ee870$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLCanvasElement");
var $d60fe5c89f0ee870$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLCanvasElement");
var $d60fe5c89f0ee870$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLCanvasElement");
var $d60fe5c89f0ee870$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLCanvasElement");
var $d60fe5c89f0ee870$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLCanvasElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $5f1940027c9abb5f$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $5f1940027c9abb5f$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $5f1940027c9abb5f$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $5f1940027c9abb5f$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $5f1940027c9abb5f$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $5f1940027c9abb5f$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $5f1940027c9abb5f$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $5f1940027c9abb5f$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDListElement");
var $5f1940027c9abb5f$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDListElement");
var $5f1940027c9abb5f$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDListElement");
var $5f1940027c9abb5f$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDListElement");
var $5f1940027c9abb5f$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDListElement");
var $5f1940027c9abb5f$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDListElement");
var $5f1940027c9abb5f$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDListElement");


// Generated by purs version 0.15.16
function $a859a6920cd8ea62$export$2ab9a8f9f1186f14(data) {
    return function() {
        return data.value;
    };
}
function $a859a6920cd8ea62$export$80746c6bc6142fc8(value) {
    return function(data) {
        return function() {
            data.value = value;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $4bdb1f5f5663563c$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $4bdb1f5f5663563c$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $4bdb1f5f5663563c$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $4bdb1f5f5663563c$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $4bdb1f5f5663563c$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $4bdb1f5f5663563c$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $4bdb1f5f5663563c$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $4bdb1f5f5663563c$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataElement");
var $4bdb1f5f5663563c$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataElement");
var $4bdb1f5f5663563c$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataElement");
var $4bdb1f5f5663563c$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataElement");
var $4bdb1f5f5663563c$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataElement");
var $4bdb1f5f5663563c$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataElement");
var $4bdb1f5f5663563c$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataElement");


// Generated by purs version 0.15.16
function $5d75ae47e32d881d$export$41c562ebe57d11e2(dle) {
    return function() {
        return dle.options;
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $26b854861d7ea616$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $26b854861d7ea616$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $26b854861d7ea616$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $26b854861d7ea616$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $26b854861d7ea616$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $26b854861d7ea616$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $26b854861d7ea616$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $26b854861d7ea616$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataListElement");
var $26b854861d7ea616$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataListElement");
var $26b854861d7ea616$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataListElement");
var $26b854861d7ea616$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataListElement");
var $26b854861d7ea616$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataListElement");
var $26b854861d7ea616$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataListElement");
var $26b854861d7ea616$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDataListElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $17ffe01aae19aa7c$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $17ffe01aae19aa7c$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $17ffe01aae19aa7c$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $17ffe01aae19aa7c$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $17ffe01aae19aa7c$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $17ffe01aae19aa7c$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $17ffe01aae19aa7c$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $17ffe01aae19aa7c$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDivElement");
var $17ffe01aae19aa7c$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDivElement");
var $17ffe01aae19aa7c$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDivElement");
var $17ffe01aae19aa7c$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDivElement");
var $17ffe01aae19aa7c$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDivElement");
var $17ffe01aae19aa7c$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDivElement");
var $17ffe01aae19aa7c$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDivElement");


// Generated by purs version 0.15.16
function $b1dce2b932e7fe5c$export$445a11d197c0312(doc) {
    return doc.documentElement;
}
function $b1dce2b932e7fe5c$export$327008c45899d79e(doc) {
    return doc.head;
}
function $b1dce2b932e7fe5c$export$773bb8dac55dfce8(doc) {
    return doc.body;
}
function $b1dce2b932e7fe5c$export$4bf8a366db6a678b(doc) {
    return doc.readyState;
}
function $b1dce2b932e7fe5c$export$5a15a2f945550a96(doc) {
    return doc.readyState;
}
function $b1dce2b932e7fe5c$export$6282f43d08fc4121(doc) {
    return doc.activeElement;
}
function $b1dce2b932e7fe5c$export$f0905ed0c7a5fd27(doc) {
    return doc.currentScript;
}
function $b1dce2b932e7fe5c$export$6392ea9cea2135f3(doc) {
    return doc.referrer;
}
function $b1dce2b932e7fe5c$export$a80dcad378414f77(doc) {
    return doc.title;
}
function $b1dce2b932e7fe5c$export$485b6f1fe8b035f3(title, doc) {
    doc.title = title;
}



var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");
// Generated by purs version 0.15.16

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97 = /* #__PURE__ */ function() {
    function Interactive() {}
    Interactive.value = new Interactive();
    return Interactive;
}();
var $fb9a6cc7ad7a78b1$export$37474717eef9e2a4 = /* #__PURE__ */ function() {
    function Complete() {}
    Complete.value = new Complete();
    return Complete;
}();
var $fb9a6cc7ad7a78b1$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97) return "Interactive";
        if (v instanceof $fb9a6cc7ad7a78b1$export$37474717eef9e2a4) return "Complete";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $fb9a6cc7ad7a78b1$export$c2d084dc44961371 = function(v) {
    if (v instanceof $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf) return "loading";
    if (v instanceof $fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97) return "interactive";
    if (v instanceof $fb9a6cc7ad7a78b1$export$37474717eef9e2a4) return "complete";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 22, column 9 - line 25, column 25): " + [
        v.constructor.name
    ]);
};
var $fb9a6cc7ad7a78b1$export$98e6a39c04603d36 = function(v) {
    if (v === "loading") return new $h2xUu.Just($fb9a6cc7ad7a78b1$export$669f6ea7d267feaf.value);
    if (v === "interactive") return new $h2xUu.Just($fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97.value);
    if (v === "complete") return new $h2xUu.Just($fb9a6cc7ad7a78b1$export$37474717eef9e2a4.value);
    return $h2xUu.Nothing.value;
};
var $fb9a6cc7ad7a78b1$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf && y instanceof $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf) return true;
            if (x instanceof $fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97 && y instanceof $fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97) return true;
            if (x instanceof $fb9a6cc7ad7a78b1$export$37474717eef9e2a4 && y instanceof $fb9a6cc7ad7a78b1$export$37474717eef9e2a4) return true;
            return false;
        };
    }
};
var $fb9a6cc7ad7a78b1$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf && y instanceof $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf) return $ibsD5.EQ.value;
            if (x instanceof $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf) return $ibsD5.LT.value;
            if (y instanceof $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf) return $ibsD5.GT.value;
            if (x instanceof $fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97 && y instanceof $fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97) return $ibsD5.EQ.value;
            if (x instanceof $fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97) return $ibsD5.LT.value;
            if (y instanceof $fb9a6cc7ad7a78b1$export$43d8ad7b9c99dd97) return $ibsD5.GT.value;
            if (x instanceof $fb9a6cc7ad7a78b1$export$37474717eef9e2a4 && y instanceof $fb9a6cc7ad7a78b1$export$37474717eef9e2a4) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $fb9a6cc7ad7a78b1$export$c71e02dcc13f94a6;
    }
};


// Generated by purs version 0.15.16

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $e9f640970f9ef9b2$export$3824c08153b44726 = /* #__PURE__ */ function() {
    function Visible() {}
    Visible.value = new Visible();
    return Visible;
}();
var $e9f640970f9ef9b2$export$8dc98ba7eadeaa56 = /* #__PURE__ */ function() {
    function Hidden() {}
    Hidden.value = new Hidden();
    return Hidden;
}();
var $e9f640970f9ef9b2$export$d2d17f8156d66f42 = {
    show: function(v) {
        if (v instanceof $e9f640970f9ef9b2$export$3824c08153b44726) return "Visible";
        if (v instanceof $e9f640970f9ef9b2$export$8dc98ba7eadeaa56) return "Hidden";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 15, column 10 - line 17, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $e9f640970f9ef9b2$export$c2d084dc44961371 = function(v) {
    if (v instanceof $e9f640970f9ef9b2$export$3824c08153b44726) return "visible";
    if (v instanceof $e9f640970f9ef9b2$export$8dc98ba7eadeaa56) return "hidden";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 20, column 9 - line 22, column 21): " + [
        v.constructor.name
    ]);
};
var $e9f640970f9ef9b2$export$98e6a39c04603d36 = function(v) {
    if (v === "visible") return new $h2xUu.Just($e9f640970f9ef9b2$export$3824c08153b44726.value);
    if (v === "hidden") return new $h2xUu.Just($e9f640970f9ef9b2$export$8dc98ba7eadeaa56.value);
    return $h2xUu.Nothing.value;
};
var $e9f640970f9ef9b2$export$e4139843c5cdd239 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e9f640970f9ef9b2$export$3824c08153b44726 && y instanceof $e9f640970f9ef9b2$export$3824c08153b44726) return true;
            if (x instanceof $e9f640970f9ef9b2$export$8dc98ba7eadeaa56 && y instanceof $e9f640970f9ef9b2$export$8dc98ba7eadeaa56) return true;
            return false;
        };
    }
};
var $e9f640970f9ef9b2$export$712b05ab3ead9d93 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e9f640970f9ef9b2$export$3824c08153b44726 && y instanceof $e9f640970f9ef9b2$export$3824c08153b44726) return $ibsD5.EQ.value;
            if (x instanceof $e9f640970f9ef9b2$export$3824c08153b44726) return $ibsD5.LT.value;
            if (y instanceof $e9f640970f9ef9b2$export$3824c08153b44726) return $ibsD5.GT.value;
            if (x instanceof $e9f640970f9ef9b2$export$8dc98ba7eadeaa56 && y instanceof $e9f640970f9ef9b2$export$8dc98ba7eadeaa56) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e9f640970f9ef9b2$export$e4139843c5cdd239;
    }
};



var $5551ee6cfcdc9d35$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $5551ee6cfcdc9d35$export$3d0d3483832deb8e = function(doc) {
    return $5551ee6cfcdc9d35$var$map(function() {
        var $2 = $h2xUu.fromMaybe($e9f640970f9ef9b2$export$3824c08153b44726.value);
        return function($3) {
            return $2($e9f640970f9ef9b2$export$98e6a39c04603d36($3));
        };
    }())(function() {
        return $b1dce2b932e7fe5c$export$5a15a2f945550a96(doc);
    });
};
var $5551ee6cfcdc9d35$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $5551ee6cfcdc9d35$export$d8d5f203c133934 = $k2DSm.unsafeCoerce;
var $5551ee6cfcdc9d35$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $5551ee6cfcdc9d35$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $5551ee6cfcdc9d35$export$ce0e204f587740c3 = $k2DSm.unsafeCoerce;
var $5551ee6cfcdc9d35$export$fb184b623420d9be = function(doc) {
    return function() {
        return $b1dce2b932e7fe5c$export$a80dcad378414f77(doc);
    };
};
var $5551ee6cfcdc9d35$export$420a7f2fd9cad6f6 = function(newTitle) {
    return function(doc) {
        return function() {
            return $b1dce2b932e7fe5c$export$485b6f1fe8b035f3(newTitle, doc);
        };
    };
};
var $5551ee6cfcdc9d35$export$a0c6a011d8b20057 = function(doc) {
    return function() {
        return $b1dce2b932e7fe5c$export$6392ea9cea2135f3(doc);
    };
};
var $5551ee6cfcdc9d35$export$1ae2b664eea77b7e = function(doc) {
    return $5551ee6cfcdc9d35$var$map(function() {
        var $4 = $h2xUu.fromMaybe($fb9a6cc7ad7a78b1$export$669f6ea7d267feaf.value);
        return function($5) {
            return $4($fb9a6cc7ad7a78b1$export$98e6a39c04603d36($5));
        };
    }())(function() {
        return $b1dce2b932e7fe5c$export$4bf8a366db6a678b(doc);
    });
};
var $5551ee6cfcdc9d35$export$5fd5031fecdacec3 = function(doc) {
    return $5551ee6cfcdc9d35$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)(function() {
        return $b1dce2b932e7fe5c$export$327008c45899d79e(doc);
    });
};
var $5551ee6cfcdc9d35$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDocument");
var $5551ee6cfcdc9d35$export$45b532d2a1c7642b = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDocument");
var $5551ee6cfcdc9d35$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDocument");
var $5551ee6cfcdc9d35$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDocument");
var $5551ee6cfcdc9d35$export$cb6b1c55e7404aef = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLDocument");
var $5551ee6cfcdc9d35$export$170c446b87804fad = function(doc) {
    return $5551ee6cfcdc9d35$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)(function() {
        return $b1dce2b932e7fe5c$export$445a11d197c0312(doc);
    });
};
var $5551ee6cfcdc9d35$export$7aca2fdfd0625e3a = function(doc) {
    return $5551ee6cfcdc9d35$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)(function() {
        return $b1dce2b932e7fe5c$export$f0905ed0c7a5fd27(doc);
    });
};
var $5551ee6cfcdc9d35$export$32180ef41b15b513 = function(doc) {
    return $5551ee6cfcdc9d35$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)(function() {
        return $b1dce2b932e7fe5c$export$773bb8dac55dfce8(doc);
    });
};
var $5551ee6cfcdc9d35$export$da980962bd2147a4 = function(doc) {
    return $5551ee6cfcdc9d35$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)(function() {
        return $b1dce2b932e7fe5c$export$6282f43d08fc4121(doc);
    });
};


// Generated by purs version 0.15.16
function $e69331db816d146f$export$b2a016fb14adc1e4(nothing, just, value) {
    var tag = Object.prototype.toString.call(value);
    if (tag.indexOf("[object HTML") === 0 && tag.indexOf("Element]") === tag.length - 8) return just(value);
    else return nothing;
}
function $e69331db816d146f$export$fb184b623420d9be(elt) {
    return function() {
        return elt.title;
    };
}
function $e69331db816d146f$export$420a7f2fd9cad6f6(title) {
    return function(elt) {
        return function() {
            elt.title = title;
        };
    };
}
function $e69331db816d146f$export$9a771d6906431624(elt) {
    return function() {
        return elt.lang;
    };
}
function $e69331db816d146f$export$a3665b844fbc095d(lang) {
    return function(elt) {
        return function() {
            elt.lang = lang;
        };
    };
}
function $e69331db816d146f$export$147ec2801e896265(elt) {
    return function() {
        return elt.dir;
    };
}
function $e69331db816d146f$export$5d00cbe77a0f4da4(dir) {
    return function(elt) {
        return function() {
            elt.dir = dir;
        };
    };
}
function $e69331db816d146f$export$73920f18ca706874(elt) {
    return function() {
        return elt.hidden;
    };
}
function $e69331db816d146f$export$306a681a1fc87013(hidden) {
    return function(elt) {
        return function() {
            elt.hidden = hidden;
        };
    };
}
function $e69331db816d146f$export$9a625f9de50bf0b7(elt) {
    return function() {
        return elt.tabIndex;
    };
}
function $e69331db816d146f$export$de72581b19a869cc(tabIndex) {
    return function(elt) {
        return function() {
            elt.tabIndex = tabIndex;
        };
    };
}
function $e69331db816d146f$export$c746a5152d4ba26c(elt) {
    return function() {
        return elt.draggable;
    };
}
function $e69331db816d146f$export$b681bd05c45bbdd7(draggable) {
    return function(elt) {
        return function() {
            elt.draggable = draggable;
        };
    };
}
function $e69331db816d146f$export$d9d317b4285c34e7(elt) {
    return function() {
        return elt.contentEditable;
    };
}
function $e69331db816d146f$export$91a56ab73e46c5d4(contentEditable) {
    return function(elt) {
        return function() {
            elt.contentEditable = contentEditable;
        };
    };
}
function $e69331db816d146f$export$3453cc819780f652(elt) {
    return function() {
        return elt.isContentEditable;
    };
}
function $e69331db816d146f$export$afbe3196582d9f14(elt) {
    return function() {
        return elt.spellcheck;
    };
}
function $e69331db816d146f$export$f5c89d87509db2c2(spellcheck) {
    return function(elt) {
        return function() {
            elt.spellcheck = spellcheck;
        };
    };
}
function $e69331db816d146f$export$64ef1bee2b9504c1(elt) {
    return function() {
        return elt.click();
    };
}
function $e69331db816d146f$export$d7ddd398f22d79ef(elt) {
    return function() {
        return elt.focus();
    };
}
function $e69331db816d146f$export$2cc7ff91bcacba5e(elt) {
    return function() {
        return elt.blur();
    };
}
function $e69331db816d146f$export$351f7ed5e1f4cbfb(el) {
    return function() {
        return el.offsetParent;
    };
}
function $e69331db816d146f$export$9051df5ff5b6ece8(el) {
    return function() {
        return el.offsetTop;
    };
}
function $e69331db816d146f$export$4ad6bc00a859a01c(el) {
    return function() {
        return el.offsetLeft;
    };
}
function $e69331db816d146f$export$abda199d6e675d54(el) {
    return function() {
        return el.offsetWidth;
    };
}
function $e69331db816d146f$export$720e3813341eb9b(el) {
    return function() {
        return el.offsetHeight;
    };
}



var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");
var $13d4e6882f9a916b$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $13d4e6882f9a916b$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $13d4e6882f9a916b$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $13d4e6882f9a916b$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $13d4e6882f9a916b$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $13d4e6882f9a916b$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $13d4e6882f9a916b$export$759f2a42fd33dfde = /* #__PURE__ */ function() {
    var $2 = $7FzSN.map($1rTTn.functorEffect)($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($e69331db816d146f$export$351f7ed5e1f4cbfb($3));
    };
}();
var $13d4e6882f9a916b$export$7039ba397093f069 = function(x) {
    return $e69331db816d146f$export$b2a016fb14adc1e4($h2xUu.Nothing.value, $h2xUu.Just.create, x);
};
var $13d4e6882f9a916b$export$66db07be43ecb0c3 = function(x) {
    return $e69331db816d146f$export$b2a016fb14adc1e4($h2xUu.Nothing.value, $h2xUu.Just.create, x);
};
var $13d4e6882f9a916b$export$a7f097b65af8aa04 = function(x) {
    return $e69331db816d146f$export$b2a016fb14adc1e4($h2xUu.Nothing.value, $h2xUu.Just.create, x);
};
var $13d4e6882f9a916b$export$a0a0bf09b44710c9 = function(x) {
    return $e69331db816d146f$export$b2a016fb14adc1e4($h2xUu.Nothing.value, $h2xUu.Just.create, x);
};
var $13d4e6882f9a916b$export$c56654a6d0e3bd48 = function(x) {
    return $e69331db816d146f$export$b2a016fb14adc1e4($h2xUu.Nothing.value, $h2xUu.Just.create, x);
};
var $13d4e6882f9a916b$export$31942037104a4a20 = function(x) {
    return $e69331db816d146f$export$b2a016fb14adc1e4($h2xUu.Nothing.value, $h2xUu.Just.create, x);
};


// Generated by purs version 0.15.16
function $092e13320e650029$export$2e40c9e35e9506f4(embed) {
    return function() {
        return embed.src;
    };
}
function $092e13320e650029$export$5771e3a4c80da7df(src) {
    return function(embed) {
        return function() {
            embed.src = src;
        };
    };
}
function $092e13320e650029$export$d4a6a4db5b31e621(embed) {
    return function() {
        return embed.type;
    };
}
function $092e13320e650029$export$1bf7f05044e9c5cb(type) {
    return function(embed) {
        return function() {
            embed.type = type;
        };
    };
}
function $092e13320e650029$export$7e3df82ee760448c(embed) {
    return function() {
        return embed.width;
    };
}
function $092e13320e650029$export$67f48e0594af05d(width) {
    return function(embed) {
        return function() {
            embed.width = width;
        };
    };
}
function $092e13320e650029$export$ac607276a8fe9f0a(embed) {
    return function() {
        return embed.height;
    };
}
function $092e13320e650029$export$3f31360357be44e4(height) {
    return function(embed) {
        return function() {
            embed.height = height;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $9da917c49c7e155e$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $9da917c49c7e155e$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $9da917c49c7e155e$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $9da917c49c7e155e$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $9da917c49c7e155e$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $9da917c49c7e155e$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $9da917c49c7e155e$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $9da917c49c7e155e$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLEmbedElement");
var $9da917c49c7e155e$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLEmbedElement");
var $9da917c49c7e155e$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLEmbedElement");
var $9da917c49c7e155e$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLEmbedElement");
var $9da917c49c7e155e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLEmbedElement");
var $9da917c49c7e155e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLEmbedElement");
var $9da917c49c7e155e$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLEmbedElement");


// Generated by purs version 0.15.16
function $65aab6b333e17b2a$export$683472f6198a076e(fieldset) {
    return function() {
        return fieldset.disabled;
    };
}
function $65aab6b333e17b2a$export$4532d31cef66d703(disabled) {
    return function(fieldset) {
        return function() {
            fieldset.disabled = disabled;
        };
    };
}
function $65aab6b333e17b2a$export$242c63e9758836c2(fieldset) {
    return function() {
        return fieldset.form;
    };
}
function $65aab6b333e17b2a$export$a8ff84c12d48cfa6(fieldset) {
    return function() {
        return fieldset.name;
    };
}
function $65aab6b333e17b2a$export$6cf3d710d3a367e5(name) {
    return function(fieldset) {
        return function() {
            fieldset.name = name;
        };
    };
}
function $65aab6b333e17b2a$export$d4a6a4db5b31e621(fieldset) {
    return function() {
        return fieldset.type;
    };
}
function $65aab6b333e17b2a$export$1bf7f05044e9c5cb(type) {
    return function(fieldset) {
        return function() {
            fieldset.type = type;
        };
    };
}
function $65aab6b333e17b2a$export$5e55a9e709e8e020(fieldset) {
    return function() {
        return fieldset.willValidate;
    };
}
function $65aab6b333e17b2a$export$1bdd3f9a89b22594(fieldset) {
    return function() {
        return fieldset.validity;
    };
}
function $65aab6b333e17b2a$export$6ee4201e37a931e2(fieldset) {
    return function() {
        return fieldset.validationMessage;
    };
}
function $65aab6b333e17b2a$export$50d70f8cedc54453(fieldset) {
    return function() {
        return fieldset.checkValidity();
    };
}
function $65aab6b333e17b2a$export$b962d864c477cc49(fieldset) {
    return function() {
        return fieldset.reportValidity();
    };
}
function $65aab6b333e17b2a$export$6f569cb704992105(value) {
    return function(fieldset) {
        return function() {
            fieldset.setCustomValidity(value);
        };
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $05defd935bfc8a94$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $05defd935bfc8a94$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $05defd935bfc8a94$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $05defd935bfc8a94$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $05defd935bfc8a94$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $05defd935bfc8a94$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $05defd935bfc8a94$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $05defd935bfc8a94$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $05defd935bfc8a94$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $05defd935bfc8a94$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $05defd935bfc8a94$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $05defd935bfc8a94$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $05defd935bfc8a94$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $05defd935bfc8a94$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $05defd935bfc8a94$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $7FzSN.map($1rTTn.functorEffect)($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($65aab6b333e17b2a$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $926094acf252c3ad$export$7e2eca70ed294fb(form) {
    return function() {
        return form.acceptCharset;
    };
}
function $926094acf252c3ad$export$9ec8703ca0dc2663(acceptCharset) {
    return function(form) {
        return function() {
            form.acceptCharset = acceptCharset;
        };
    };
}
function $926094acf252c3ad$export$31eb53bd5b582a97(form) {
    return function() {
        return form.action;
    };
}
function $926094acf252c3ad$export$a0c65badd8d09883(action) {
    return function(form) {
        return function() {
            form.action = action;
        };
    };
}
function $926094acf252c3ad$export$485ded5f26ebe08d(form) {
    return function() {
        return form.autocomplete;
    };
}
function $926094acf252c3ad$export$5fb7c729919301a5(autocomplete) {
    return function(form) {
        return function() {
            form.autocomplete = autocomplete;
        };
    };
}
function $926094acf252c3ad$export$9fc5d082ec250407(form) {
    return function() {
        return form.enctype;
    };
}
function $926094acf252c3ad$export$71f7bac871e6ce1b(enctype) {
    return function(form) {
        return function() {
            form.enctype = enctype;
        };
    };
}
function $926094acf252c3ad$export$d8738670c721d955(form) {
    return function() {
        return form.encoding;
    };
}
function $926094acf252c3ad$export$11699ce243a224fd(encoding) {
    return function(form) {
        return function() {
            form.encoding = encoding;
        };
    };
}
function $926094acf252c3ad$export$26f73335cc2e7868(form) {
    return function() {
        return form.method;
    };
}
function $926094acf252c3ad$export$8c6ecab5174b959(method) {
    return function(form) {
        return function() {
            form.method = method;
        };
    };
}
function $926094acf252c3ad$export$a8ff84c12d48cfa6(form) {
    return function() {
        return form.name;
    };
}
function $926094acf252c3ad$export$6cf3d710d3a367e5(name) {
    return function(form) {
        return function() {
            form.name = name;
        };
    };
}
function $926094acf252c3ad$export$f50297589147f25e(form) {
    return function() {
        return form.noValidate;
    };
}
function $926094acf252c3ad$export$2271539dcccd0a8a(noValidate) {
    return function(form) {
        return function() {
            form.noValidate = noValidate;
        };
    };
}
function $926094acf252c3ad$export$44271b4f0c6a3563(form) {
    return function() {
        return form.target;
    };
}
function $926094acf252c3ad$export$1f61c53461aff4a5(target) {
    return function(form) {
        return function() {
            form.target = target;
        };
    };
}
function $926094acf252c3ad$export$f24224f1c91d8156(form) {
    return function() {
        return form.length;
    };
}
function $926094acf252c3ad$export$853c27de4ce0f746(form) {
    return function() {
        form.submit();
    };
}
function $926094acf252c3ad$export$aad8462122ac592b(form) {
    return function() {
        form.reset();
    };
}
function $926094acf252c3ad$export$50d70f8cedc54453(form) {
    return function() {
        return form.checkValidity();
    };
}
function $926094acf252c3ad$export$b962d864c477cc49(form) {
    return function() {
        return form.reportValidity();
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $9d3dbaf566472b65$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $9d3dbaf566472b65$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $9d3dbaf566472b65$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $9d3dbaf566472b65$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $9d3dbaf566472b65$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $9d3dbaf566472b65$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $9d3dbaf566472b65$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $9d3dbaf566472b65$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFormElement");
var $9d3dbaf566472b65$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFormElement");
var $9d3dbaf566472b65$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFormElement");
var $9d3dbaf566472b65$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFormElement");
var $9d3dbaf566472b65$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFormElement");
var $9d3dbaf566472b65$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFormElement");
var $9d3dbaf566472b65$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLFormElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $511d4580c930b874$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $511d4580c930b874$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $511d4580c930b874$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $511d4580c930b874$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $511d4580c930b874$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $511d4580c930b874$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $511d4580c930b874$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $511d4580c930b874$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHRElement");
var $511d4580c930b874$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHRElement");
var $511d4580c930b874$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHRElement");
var $511d4580c930b874$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHRElement");
var $511d4580c930b874$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHRElement");
var $511d4580c930b874$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHRElement");
var $511d4580c930b874$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHRElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $abdd95b1a71696bd$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $abdd95b1a71696bd$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $abdd95b1a71696bd$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $abdd95b1a71696bd$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $abdd95b1a71696bd$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $abdd95b1a71696bd$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $abdd95b1a71696bd$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $abdd95b1a71696bd$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadElement");
var $abdd95b1a71696bd$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadElement");
var $abdd95b1a71696bd$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadElement");
var $abdd95b1a71696bd$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadElement");
var $abdd95b1a71696bd$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadElement");
var $abdd95b1a71696bd$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadElement");
var $abdd95b1a71696bd$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $40063170240a088c$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $40063170240a088c$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $40063170240a088c$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $40063170240a088c$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $40063170240a088c$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $40063170240a088c$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $40063170240a088c$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $40063170240a088c$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadingElement");
var $40063170240a088c$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadingElement");
var $40063170240a088c$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadingElement");
var $40063170240a088c$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadingElement");
var $40063170240a088c$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadingElement");
var $40063170240a088c$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadingElement");
var $40063170240a088c$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLHeadingElement");


// Generated by purs version 0.15.16
function $9a0fb1be4527006a$export$2e40c9e35e9506f4(iframe) {
    return function() {
        return iframe.src;
    };
}
function $9a0fb1be4527006a$export$5771e3a4c80da7df(src) {
    return function(iframe) {
        return function() {
            iframe.src = src;
        };
    };
}
function $9a0fb1be4527006a$export$7be70892c9d4d10e(iframe) {
    return function() {
        return iframe.srcdoc;
    };
}
function $9a0fb1be4527006a$export$8a11fa357d4cbbc0(srcdoc) {
    return function(iframe) {
        return function() {
            iframe.srcdoc = srcdoc;
        };
    };
}
function $9a0fb1be4527006a$export$a8ff84c12d48cfa6(iframe) {
    return function() {
        return iframe.name;
    };
}
function $9a0fb1be4527006a$export$6cf3d710d3a367e5(name) {
    return function(iframe) {
        return function() {
            iframe.name = name;
        };
    };
}
function $9a0fb1be4527006a$export$7e3df82ee760448c(iframe) {
    return function() {
        return iframe.width;
    };
}
function $9a0fb1be4527006a$export$67f48e0594af05d(width) {
    return function(iframe) {
        return function() {
            iframe.width = width;
        };
    };
}
function $9a0fb1be4527006a$export$ac607276a8fe9f0a(iframe) {
    return function() {
        return iframe.height;
    };
}
function $9a0fb1be4527006a$export$3f31360357be44e4(height) {
    return function(iframe) {
        return function() {
            iframe.height = height;
        };
    };
}
function $9a0fb1be4527006a$export$a51825c89fe24f94(iframe) {
    return function() {
        return iframe.contentDocument;
    };
}
function $9a0fb1be4527006a$export$688aae7b7ac35f92(iframe) {
    return function() {
        return iframe.contentWindow;
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $3a3653b0d1aa792b$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $3a3653b0d1aa792b$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $3a3653b0d1aa792b$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $3a3653b0d1aa792b$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $3a3653b0d1aa792b$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $3a3653b0d1aa792b$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $3a3653b0d1aa792b$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $3a3653b0d1aa792b$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $3a3653b0d1aa792b$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLIFrameElement");
var $3a3653b0d1aa792b$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLIFrameElement");
var $3a3653b0d1aa792b$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLIFrameElement");
var $3a3653b0d1aa792b$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLIFrameElement");
var $3a3653b0d1aa792b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLIFrameElement");
var $3a3653b0d1aa792b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLIFrameElement");
var $3a3653b0d1aa792b$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLIFrameElement");
var $3a3653b0d1aa792b$export$6677e9b58554b15d = /* #__PURE__ */ function() {
    var $2 = $3a3653b0d1aa792b$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($9a0fb1be4527006a$export$688aae7b7ac35f92($3));
    };
}();
var $3a3653b0d1aa792b$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $3a3653b0d1aa792b$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($9a0fb1be4527006a$export$a51825c89fe24f94($5));
    };
}();


// Generated by purs version 0.15.16
function $e28b921d783a29a0$export$185802fd694ee1f5() {
    return new Image();
}
function $e28b921d783a29a0$export$11b6d15e47fb61cf(width) {
    return function(height) {
        return function() {
            return new Image(width, height);
        };
    };
}
function $e28b921d783a29a0$export$228be17d80722ab(image) {
    return function() {
        return image.alt;
    };
}
function $e28b921d783a29a0$export$14a0e7c2e6152665(alt) {
    return function(image) {
        return function() {
            image.alt = alt;
        };
    };
}
function $e28b921d783a29a0$export$2e40c9e35e9506f4(image) {
    return function() {
        return image.src;
    };
}
function $e28b921d783a29a0$export$5771e3a4c80da7df(src) {
    return function(image) {
        return function() {
            image.src = src;
        };
    };
}
function $e28b921d783a29a0$export$c2507fd1cd56d483(image) {
    return function() {
        return image.srcset;
    };
}
function $e28b921d783a29a0$export$c95fa5d268267aa4(srcset) {
    return function(image) {
        return function() {
            image.srcset = srcset;
        };
    };
}
function $e28b921d783a29a0$export$c647cb0ee6e282fe(image) {
    return function() {
        return image.sizes;
    };
}
function $e28b921d783a29a0$export$2652819f9fe6d59b(sizes) {
    return function(image) {
        return function() {
            image.sizes = sizes;
        };
    };
}
function $e28b921d783a29a0$export$22e7408040d24cb8(image) {
    return function() {
        return image.currentSrc;
    };
}
function $e28b921d783a29a0$export$2a95876eedf9defd(image) {
    return image.crossOrigin;
}
function $e28b921d783a29a0$export$15671bab5b2a825c(crossOrigin, image) {
    image.crossOrigin = crossOrigin;
}
function $e28b921d783a29a0$export$86f8f9f08863e403(image) {
    return function() {
        return image.useMap;
    };
}
function $e28b921d783a29a0$export$ab416bdbb887640e(useMap) {
    return function(image) {
        return function() {
            image.useMap = useMap;
        };
    };
}
function $e28b921d783a29a0$export$5c90113a285f2241(image) {
    return function() {
        return image.isMap;
    };
}
function $e28b921d783a29a0$export$e634cf4c55ef6324(isMap) {
    return function(image) {
        return function() {
            image.isMap = isMap;
        };
    };
}
function $e28b921d783a29a0$export$7e3df82ee760448c(image) {
    return function() {
        return image.width;
    };
}
function $e28b921d783a29a0$export$67f48e0594af05d(width) {
    return function(image) {
        return function() {
            image.width = width;
        };
    };
}
function $e28b921d783a29a0$export$ac607276a8fe9f0a(image) {
    return function() {
        return image.height;
    };
}
function $e28b921d783a29a0$export$3f31360357be44e4(height) {
    return function(image) {
        return function() {
            image.height = height;
        };
    };
}
function $e28b921d783a29a0$export$c32e50dfb9f4ec89(image) {
    return function() {
        return image.naturalWidth;
    };
}
function $e28b921d783a29a0$export$6a4b566b54dc81c0(image) {
    return function() {
        return image.naturalHeight;
    };
}
function $e28b921d783a29a0$export$8b29ef2611187a5f(image) {
    return function() {
        return image.referrerPolicy;
    };
}
function $e28b921d783a29a0$export$c73d54db5b3c6ed4(referrerPolicy) {
    return function(image) {
        return function() {
            image.referrerPolicy = referrerPolicy;
        };
    };
}
function $e28b921d783a29a0$export$8774eb0dcbbe3146(image) {
    return image.decoding;
}
function $e28b921d783a29a0$export$533597f26ad51793(decoding, image) {
    image.decoding = decoding;
}
function $e28b921d783a29a0$export$c1978f45d5c8c1fd(image) {
    return image.loading;
}
function $e28b921d783a29a0$export$820843123ac3b9d(loading, image) {
    image.loading = loading;
}
function $e28b921d783a29a0$export$b1bc8081da8c9e77(image) {
    return function() {
        return image.complete;
    };
}



var $cADnC = parcelRequire("cADnC");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");


var $1rTTn = parcelRequire("1rTTn");
// Generated by purs version 0.15.16
const $263689cbadcb63ad$export$33e695b1da6bf8ce = function mkEffectFn1(fn) {
    return function(x) {
        return fn(x)();
    };
};
const $263689cbadcb63ad$export$d349e7010d9e4f18 = function mkEffectFn2(fn) {
    return function(a, b) {
        return fn(a)(b)();
    };
};
const $263689cbadcb63ad$export$1329fa30c595aae1 = function mkEffectFn3(fn) {
    return function(a, b, c) {
        return fn(a)(b)(c)();
    };
};
const $263689cbadcb63ad$export$745d51d1abc5cd82 = function mkEffectFn4(fn) {
    return function(a, b, c, d) {
        return fn(a)(b)(c)(d)();
    };
};
const $263689cbadcb63ad$export$b3413456c3617180 = function mkEffectFn5(fn) {
    return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e)();
    };
};
const $263689cbadcb63ad$export$becea21a68009b07 = function mkEffectFn6(fn) {
    return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f)();
    };
};
const $263689cbadcb63ad$export$83674e2607660e0f = function mkEffectFn7(fn) {
    return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g)();
    };
};
const $263689cbadcb63ad$export$c7f26c65f1b8e3 = function mkEffectFn8(fn) {
    return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)();
    };
};
const $263689cbadcb63ad$export$5d4846e0dbe026fa = function mkEffectFn9(fn) {
    return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)();
    };
};
const $263689cbadcb63ad$export$ac08820aca1c1ebc = function mkEffectFn10(fn) {
    return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)();
    };
};
const $263689cbadcb63ad$export$84baa7a1ea5377fd = function runEffectFn1(fn) {
    return function(a) {
        return function() {
            return fn(a);
        };
    };
};
const $263689cbadcb63ad$export$6a301f847372dca1 = function runEffectFn2(fn) {
    return function(a) {
        return function(b) {
            return function() {
                return fn(a, b);
            };
        };
    };
};
const $263689cbadcb63ad$export$40df0ea470e346f0 = function runEffectFn3(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function() {
                    return fn(a, b, c);
                };
            };
        };
    };
};
const $263689cbadcb63ad$export$ec3c5c8caae58867 = function runEffectFn4(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function() {
                        return fn(a, b, c, d);
                    };
                };
            };
        };
    };
};
const $263689cbadcb63ad$export$5b882d1088aa8dc9 = function runEffectFn5(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function() {
                            return fn(a, b, c, d, e);
                        };
                    };
                };
            };
        };
    };
};
const $263689cbadcb63ad$export$53e477d88d18e854 = function runEffectFn6(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function() {
                                return fn(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $263689cbadcb63ad$export$2d0fb35e82261b8d = function runEffectFn7(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function() {
                                    return fn(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $263689cbadcb63ad$export$801a85b4a2b405ac = function runEffectFn8(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function() {
                                        return fn(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $263689cbadcb63ad$export$326863f2889caa23 = function runEffectFn9(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function() {
                                            return fn(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $263689cbadcb63ad$export$8fc2053a354b81aa = function runEffectFn10(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return function() {
                                                return fn(a, b, c, d, e, f, g, h, i, j);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};



var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $1rTTn = parcelRequire("1rTTn");
var $dd41da6ad991db06$export$6b33adf3a8e3f704 = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$5d4846e0dbe026fa(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return append($263689cbadcb63ad$export$326863f2889caa23(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i))($263689cbadcb63ad$export$326863f2889caa23(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$1b434506fc11421 = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$c7f26c65f1b8e3(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return append($263689cbadcb63ad$export$801a85b4a2b405ac(f1)(a)(b)(c)(d)(e)(f)(g)(h))($263689cbadcb63ad$export$801a85b4a2b405ac(f2)(a)(b)(c)(d)(e)(f)(g)(h));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$f9d62e28920765a6 = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$83674e2607660e0f(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return append($263689cbadcb63ad$export$2d0fb35e82261b8d(f1)(a)(b)(c)(d)(e)(f)(g))($263689cbadcb63ad$export$2d0fb35e82261b8d(f2)(a)(b)(c)(d)(e)(f)(g));
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$1cdb6e5a843aefe2 = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$becea21a68009b07(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return append($263689cbadcb63ad$export$53e477d88d18e854(f1)(a)(b)(c)(d)(e)(f))($263689cbadcb63ad$export$53e477d88d18e854(f2)(a)(b)(c)(d)(e)(f));
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$99aa837ed31887aa = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$b3413456c3617180(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return append($263689cbadcb63ad$export$5b882d1088aa8dc9(f1)(a)(b)(c)(d)(e))($263689cbadcb63ad$export$5b882d1088aa8dc9(f2)(a)(b)(c)(d)(e));
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$8cb019b91258e3b9 = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$745d51d1abc5cd82(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return append($263689cbadcb63ad$export$ec3c5c8caae58867(f1)(a)(b)(c)(d))($263689cbadcb63ad$export$ec3c5c8caae58867(f2)(a)(b)(c)(d));
                            };
                        };
                    };
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$fb0bdf58ff0a6426 = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$1329fa30c595aae1(function(a) {
                    return function(b) {
                        return function(c) {
                            return append($263689cbadcb63ad$export$40df0ea470e346f0(f1)(a)(b)(c))($263689cbadcb63ad$export$40df0ea470e346f0(f2)(a)(b)(c));
                        };
                    };
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$9bf195cde6bca966 = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$d349e7010d9e4f18(function(a) {
                    return function(b) {
                        return append($263689cbadcb63ad$export$6a301f847372dca1(f1)(a)(b))($263689cbadcb63ad$export$6a301f847372dca1(f2)(a)(b));
                    };
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$39f0bfa3de9c8ca1 = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$ac08820aca1c1ebc(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return function(j) {
                                                        return append($263689cbadcb63ad$export$8fc2053a354b81aa(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j))($263689cbadcb63ad$export$8fc2053a354b81aa(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j));
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$d15c5b9160f5bf5 = function(dictSemigroup) {
    var append = $d5vvq.append($1rTTn.semigroupEffect(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $263689cbadcb63ad$export$33e695b1da6bf8ce(function(a) {
                    return append($263689cbadcb63ad$export$84baa7a1ea5377fd(f1)(a))($263689cbadcb63ad$export$84baa7a1ea5377fd(f2)(a));
                });
            };
        }
    };
};
var $dd41da6ad991db06$export$951567719e338e25 = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn91 = $dd41da6ad991db06$export$6b33adf3a8e3f704(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$5d4846e0dbe026fa(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return mempty;
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn91;
        }
    };
};
var $dd41da6ad991db06$export$60b4106c40599be6 = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn81 = $dd41da6ad991db06$export$1b434506fc11421(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$c7f26c65f1b8e3(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return mempty;
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn81;
        }
    };
};
var $dd41da6ad991db06$export$63d6254dd5b47db1 = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn71 = $dd41da6ad991db06$export$f9d62e28920765a6(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$83674e2607660e0f(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return mempty;
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn71;
        }
    };
};
var $dd41da6ad991db06$export$80d58e93d1dd53e4 = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn61 = $dd41da6ad991db06$export$1cdb6e5a843aefe2(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$becea21a68009b07(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return mempty;
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn61;
        }
    };
};
var $dd41da6ad991db06$export$c346a9c2957c12e8 = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn51 = $dd41da6ad991db06$export$99aa837ed31887aa(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$b3413456c3617180(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return mempty;
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn51;
        }
    };
};
var $dd41da6ad991db06$export$fd6b07fef28d22de = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn41 = $dd41da6ad991db06$export$8cb019b91258e3b9(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$745d51d1abc5cd82(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return mempty;
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn41;
        }
    };
};
var $dd41da6ad991db06$export$f091af598ee150a6 = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn31 = $dd41da6ad991db06$export$fb0bdf58ff0a6426(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$1329fa30c595aae1(function(v) {
            return function(v1) {
                return function(v2) {
                    return mempty;
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn31;
        }
    };
};
var $dd41da6ad991db06$export$6294c3a3ece87949 = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn21 = $dd41da6ad991db06$export$9bf195cde6bca966(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$d349e7010d9e4f18(function(v) {
            return function(v1) {
                return mempty;
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn21;
        }
    };
};
var $dd41da6ad991db06$export$c62e1ced10b8c8b0 = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn101 = $dd41da6ad991db06$export$39f0bfa3de9c8ca1(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$ac08820aca1c1ebc(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return function(v9) {
                                                return mempty;
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn101;
        }
    };
};
var $dd41da6ad991db06$export$333b269eda63e7a7 = function(dictMonoid) {
    var mempty = $3aOYV.mempty($1rTTn.monoidEffect(dictMonoid));
    var semigroupEffectFn11 = $dd41da6ad991db06$export$d15c5b9160f5bf5(dictMonoid.Semigroup0());
    return {
        mempty: $263689cbadcb63ad$export$33e695b1da6bf8ce(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupEffectFn11;
        }
    };
};



var $k2DSm = parcelRequire("k2DSm");
// Generated by purs version 0.15.16

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $daec2fce38c492c8$export$e1bb774e9664e700 = /* #__PURE__ */ function() {
    function Anonymous() {}
    Anonymous.value = new Anonymous();
    return Anonymous;
}();
var $daec2fce38c492c8$export$bf6fef082af5a2d3 = /* #__PURE__ */ function() {
    function UseCredentials() {}
    UseCredentials.value = new UseCredentials();
    return UseCredentials;
}();
var $daec2fce38c492c8$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $daec2fce38c492c8$export$e1bb774e9664e700) return "Anonymous";
        if (v instanceof $daec2fce38c492c8$export$bf6fef082af5a2d3) return "UseCredentials";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 18, column 10 - line 20, column 39): " + [
            v.constructor.name
        ]);
    }
};
var $daec2fce38c492c8$export$c2d084dc44961371 = function(v) {
    if (v instanceof $daec2fce38c492c8$export$e1bb774e9664e700) return "anonymous";
    if (v instanceof $daec2fce38c492c8$export$bf6fef082af5a2d3) return "use-credentials";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 30, column 9 - line 32, column 38): " + [
        v.constructor.name
    ]);
};
var $daec2fce38c492c8$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $h2xUu.Just($daec2fce38c492c8$export$e1bb774e9664e700.value);
    if (v === "anonymous") return new $h2xUu.Just($daec2fce38c492c8$export$e1bb774e9664e700.value);
    if (v === "use-credentials") return new $h2xUu.Just($daec2fce38c492c8$export$bf6fef082af5a2d3.value);
    return $h2xUu.Nothing.value;
};
var $daec2fce38c492c8$export$8a8a93ce7ed989f9 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $daec2fce38c492c8$export$e1bb774e9664e700 && y instanceof $daec2fce38c492c8$export$e1bb774e9664e700) return true;
            if (x instanceof $daec2fce38c492c8$export$bf6fef082af5a2d3 && y instanceof $daec2fce38c492c8$export$bf6fef082af5a2d3) return true;
            return false;
        };
    }
};
var $daec2fce38c492c8$export$4877633354812171 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $daec2fce38c492c8$export$e1bb774e9664e700 && y instanceof $daec2fce38c492c8$export$e1bb774e9664e700) return $ibsD5.EQ.value;
            if (x instanceof $daec2fce38c492c8$export$e1bb774e9664e700) return $ibsD5.LT.value;
            if (y instanceof $daec2fce38c492c8$export$e1bb774e9664e700) return $ibsD5.GT.value;
            if (x instanceof $daec2fce38c492c8$export$bf6fef082af5a2d3 && y instanceof $daec2fce38c492c8$export$bf6fef082af5a2d3) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $daec2fce38c492c8$export$8a8a93ce7ed989f9;
    }
};


// Generated by purs version 0.15.16

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $187ab4077f31fb27$export$2ae15352e0a80063 = /* #__PURE__ */ function() {
    function Sync() {}
    Sync.value = new Sync();
    return Sync;
}();
var $187ab4077f31fb27$export$4d3c597da532240f = /* #__PURE__ */ function() {
    function Async() {}
    Async.value = new Async();
    return Async;
}();
var $187ab4077f31fb27$export$6cc2e70440926d44 = /* #__PURE__ */ function() {
    function Auto() {}
    Auto.value = new Auto();
    return Auto;
}();
var $187ab4077f31fb27$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $187ab4077f31fb27$export$2ae15352e0a80063) return "Sync";
        if (v instanceof $187ab4077f31fb27$export$4d3c597da532240f) return "Async";
        if (v instanceof $187ab4077f31fb27$export$6cc2e70440926d44) return "Auto";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 19, column 10 - line 22, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $187ab4077f31fb27$export$c2d084dc44961371 = function(v) {
    if (v instanceof $187ab4077f31fb27$export$2ae15352e0a80063) return "sync";
    if (v instanceof $187ab4077f31fb27$export$4d3c597da532240f) return "async";
    if (v instanceof $187ab4077f31fb27$export$6cc2e70440926d44) return "auto";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 33, column 9 - line 36, column 17): " + [
        v.constructor.name
    ]);
};
var $187ab4077f31fb27$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $h2xUu.Just($187ab4077f31fb27$export$6cc2e70440926d44.value);
    if (v === "sync") return new $h2xUu.Just($187ab4077f31fb27$export$2ae15352e0a80063.value);
    if (v === "async") return new $h2xUu.Just($187ab4077f31fb27$export$4d3c597da532240f.value);
    if (v === "auto") return new $h2xUu.Just($187ab4077f31fb27$export$6cc2e70440926d44.value);
    return $h2xUu.Nothing.value;
};
var $187ab4077f31fb27$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $187ab4077f31fb27$export$2ae15352e0a80063 && y instanceof $187ab4077f31fb27$export$2ae15352e0a80063) return true;
            if (x instanceof $187ab4077f31fb27$export$4d3c597da532240f && y instanceof $187ab4077f31fb27$export$4d3c597da532240f) return true;
            if (x instanceof $187ab4077f31fb27$export$6cc2e70440926d44 && y instanceof $187ab4077f31fb27$export$6cc2e70440926d44) return true;
            return false;
        };
    }
};
var $187ab4077f31fb27$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $187ab4077f31fb27$export$2ae15352e0a80063 && y instanceof $187ab4077f31fb27$export$2ae15352e0a80063) return $ibsD5.EQ.value;
            if (x instanceof $187ab4077f31fb27$export$2ae15352e0a80063) return $ibsD5.LT.value;
            if (y instanceof $187ab4077f31fb27$export$2ae15352e0a80063) return $ibsD5.GT.value;
            if (x instanceof $187ab4077f31fb27$export$4d3c597da532240f && y instanceof $187ab4077f31fb27$export$4d3c597da532240f) return $ibsD5.EQ.value;
            if (x instanceof $187ab4077f31fb27$export$4d3c597da532240f) return $ibsD5.LT.value;
            if (y instanceof $187ab4077f31fb27$export$4d3c597da532240f) return $ibsD5.GT.value;
            if (x instanceof $187ab4077f31fb27$export$6cc2e70440926d44 && y instanceof $187ab4077f31fb27$export$6cc2e70440926d44) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $187ab4077f31fb27$export$e32bcfaf2cb99de5;
    }
};


// Generated by purs version 0.15.16

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $ca45a7c651f4f081$export$a4acc175556f6dbc = /* #__PURE__ */ function() {
    function Eager() {}
    Eager.value = new Eager();
    return Eager;
}();
var $ca45a7c651f4f081$export$b624eff549462981 = /* #__PURE__ */ function() {
    function Lazy() {}
    Lazy.value = new Lazy();
    return Lazy;
}();
var $ca45a7c651f4f081$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $ca45a7c651f4f081$export$a4acc175556f6dbc) return "Eager";
        if (v instanceof $ca45a7c651f4f081$export$b624eff549462981) return "Lazy";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 18, column 10 - line 20, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $ca45a7c651f4f081$export$c2d084dc44961371 = function(v) {
    if (v instanceof $ca45a7c651f4f081$export$a4acc175556f6dbc) return "eager";
    if (v instanceof $ca45a7c651f4f081$export$b624eff549462981) return "lazy";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 30, column 9 - line 32, column 17): " + [
        v.constructor.name
    ]);
};
var $ca45a7c651f4f081$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $h2xUu.Just($ca45a7c651f4f081$export$a4acc175556f6dbc.value);
    if (v === "eager") return new $h2xUu.Just($ca45a7c651f4f081$export$a4acc175556f6dbc.value);
    if (v === "lazy") return new $h2xUu.Just($ca45a7c651f4f081$export$b624eff549462981.value);
    return $h2xUu.Nothing.value;
};
var $ca45a7c651f4f081$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ca45a7c651f4f081$export$a4acc175556f6dbc && y instanceof $ca45a7c651f4f081$export$a4acc175556f6dbc) return true;
            if (x instanceof $ca45a7c651f4f081$export$b624eff549462981 && y instanceof $ca45a7c651f4f081$export$b624eff549462981) return true;
            return false;
        };
    }
};
var $ca45a7c651f4f081$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ca45a7c651f4f081$export$a4acc175556f6dbc && y instanceof $ca45a7c651f4f081$export$a4acc175556f6dbc) return $ibsD5.EQ.value;
            if (x instanceof $ca45a7c651f4f081$export$a4acc175556f6dbc) return $ibsD5.LT.value;
            if (y instanceof $ca45a7c651f4f081$export$a4acc175556f6dbc) return $ibsD5.GT.value;
            if (x instanceof $ca45a7c651f4f081$export$b624eff549462981 && y instanceof $ca45a7c651f4f081$export$b624eff549462981) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ca45a7c651f4f081$export$e32bcfaf2cb99de5;
    }
};



var $60b97838fcbdafe4$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $60b97838fcbdafe4$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $60b97838fcbdafe4$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $60b97838fcbdafe4$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $60b97838fcbdafe4$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $60b97838fcbdafe4$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $60b97838fcbdafe4$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $60b97838fcbdafe4$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $60b97838fcbdafe4$export$3ac708362c1f96eb = function(laziness) {
    return $263689cbadcb63ad$export$6a301f847372dca1($e28b921d783a29a0$export$820843123ac3b9d)($ca45a7c651f4f081$export$c2d084dc44961371(laziness));
};
var $60b97838fcbdafe4$export$fe0b2eeb59b63d00 = function(hint) {
    return $263689cbadcb63ad$export$6a301f847372dca1($e28b921d783a29a0$export$533597f26ad51793)($187ab4077f31fb27$export$c2d084dc44961371(hint));
};
var $60b97838fcbdafe4$export$e7fd69f64f92856 = function(mode) {
    return $263689cbadcb63ad$export$6a301f847372dca1($e28b921d783a29a0$export$15671bab5b2a825c)($daec2fce38c492c8$export$c2d084dc44961371(mode));
};
var $60b97838fcbdafe4$export$46c1c92549715335 = /* #__PURE__ */ function() {
    var $3 = $60b97838fcbdafe4$var$map(function() {
        var $6 = $h2xUu.fromMaybe($ca45a7c651f4f081$export$a4acc175556f6dbc.value);
        return function($7) {
            return $6($ca45a7c651f4f081$export$98e6a39c04603d36($7));
        };
    }());
    var $4 = $263689cbadcb63ad$export$84baa7a1ea5377fd($e28b921d783a29a0$export$c1978f45d5c8c1fd);
    return function($5) {
        return $3($4($5));
    };
}();
var $60b97838fcbdafe4$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLImageElement");
var $60b97838fcbdafe4$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLImageElement");
var $60b97838fcbdafe4$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLImageElement");
var $60b97838fcbdafe4$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLImageElement");
var $60b97838fcbdafe4$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLImageElement");
var $60b97838fcbdafe4$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLImageElement");
var $60b97838fcbdafe4$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLImageElement");
var $60b97838fcbdafe4$export$7b9cc1601c0b9c78 = /* #__PURE__ */ function() {
    var $8 = $60b97838fcbdafe4$var$map(function() {
        var $11 = $h2xUu.fromMaybe($187ab4077f31fb27$export$6cc2e70440926d44.value);
        return function($12) {
            return $11($187ab4077f31fb27$export$98e6a39c04603d36($12));
        };
    }());
    var $9 = $263689cbadcb63ad$export$84baa7a1ea5377fd($e28b921d783a29a0$export$8774eb0dcbbe3146);
    return function($10) {
        return $8($9($10));
    };
}();
var $60b97838fcbdafe4$export$c47cb7c63271266e = /* #__PURE__ */ function() {
    var $13 = $60b97838fcbdafe4$var$map($cADnC.composeKleisliFlipped($h2xUu.bindMaybe)($daec2fce38c492c8$export$98e6a39c04603d36)($ae4217dcc85a7c03$export$1ba013b88f4f21f3));
    var $14 = $263689cbadcb63ad$export$84baa7a1ea5377fd($e28b921d783a29a0$export$2a95876eedf9defd);
    return function($15) {
        return $13($14($15));
    };
}();
var $60b97838fcbdafe4$export$20f9c2173df486a8 = $e28b921d783a29a0$export$11b6d15e47fb61cf;


// Generated by purs version 0.15.16
function $24bc8fe162c89d19$export$73f57eecff448cc8(input) {
    return function() {
        return input.accept;
    };
}
function $24bc8fe162c89d19$export$b20dfae471de8dc1(accept) {
    return function(input) {
        return function() {
            input.accept = accept;
        };
    };
}
function $24bc8fe162c89d19$export$228be17d80722ab(input) {
    return function() {
        return input.alt;
    };
}
function $24bc8fe162c89d19$export$14a0e7c2e6152665(alt) {
    return function(input) {
        return function() {
            input.alt = alt;
        };
    };
}
function $24bc8fe162c89d19$export$485ded5f26ebe08d(input) {
    return function() {
        return input.autocomplete;
    };
}
function $24bc8fe162c89d19$export$5fb7c729919301a5(autocomplete) {
    return function(input) {
        return function() {
            input.autocomplete = autocomplete;
        };
    };
}
function $24bc8fe162c89d19$export$4c47992fc278c9a0(input) {
    return function() {
        return input.autofocus;
    };
}
function $24bc8fe162c89d19$export$db2bbdcbda3d335e(autofocus) {
    return function(input) {
        return function() {
            input.autofocus = autofocus;
        };
    };
}
function $24bc8fe162c89d19$export$8f49a7e9e3141ccc(input) {
    return function() {
        return input.defaultChecked;
    };
}
function $24bc8fe162c89d19$export$63092561e9c9bec4(defaultChecked) {
    return function(input) {
        return function() {
            input.defaultChecked = defaultChecked;
        };
    };
}
function $24bc8fe162c89d19$export$b96bb35bc88d6fa(input) {
    return function() {
        return input.checked;
    };
}
function $24bc8fe162c89d19$export$d2270ed72c00a9b2(checked) {
    return function(input) {
        return function() {
            input.checked = checked;
        };
    };
}
function $24bc8fe162c89d19$export$9ebb36ddc946da55(input) {
    return function() {
        return input.dirName;
    };
}
function $24bc8fe162c89d19$export$e2460e55089b163d(dirName) {
    return function(input) {
        return function() {
            input.dirName = dirName;
        };
    };
}
function $24bc8fe162c89d19$export$683472f6198a076e(input) {
    return function() {
        return input.disabled;
    };
}
function $24bc8fe162c89d19$export$4532d31cef66d703(disabled) {
    return function(input) {
        return function() {
            input.disabled = disabled;
        };
    };
}
function $24bc8fe162c89d19$export$242c63e9758836c2(input) {
    return function() {
        return input.form;
    };
}
function $24bc8fe162c89d19$export$92d18e9db2d4e896(input) {
    return function() {
        return input.files;
    };
}
function $24bc8fe162c89d19$export$7e4d70bab1b5c4a0(input) {
    return function() {
        return input.formAction;
    };
}
function $24bc8fe162c89d19$export$577bb1d64e4c83b9(formAction) {
    return function(input) {
        return function() {
            input.formAction = formAction;
        };
    };
}
function $24bc8fe162c89d19$export$21f1c8008acfa9c0(input) {
    return function() {
        return input.formEnctype;
    };
}
function $24bc8fe162c89d19$export$346989dcff4ba18b(formEnctype) {
    return function(input) {
        return function() {
            input.formEnctype = formEnctype;
        };
    };
}
function $24bc8fe162c89d19$export$3f1ffee261a00124(input) {
    return function() {
        return input.formMethod;
    };
}
function $24bc8fe162c89d19$export$c38a1a871bb0e145(formMethod) {
    return function(input) {
        return function() {
            input.formMethod = formMethod;
        };
    };
}
function $24bc8fe162c89d19$export$87c857905fcc4a84(input) {
    return function() {
        return input.formNoValidate;
    };
}
function $24bc8fe162c89d19$export$ad9ff32d0af51586(formNoValidate) {
    return function(input) {
        return function() {
            input.formNoValidate = formNoValidate;
        };
    };
}
function $24bc8fe162c89d19$export$497949a0ae76184f(input) {
    return function() {
        return input.formTarget;
    };
}
function $24bc8fe162c89d19$export$4c7e983548149eb5(formTarget) {
    return function(input) {
        return function() {
            input.formTarget = formTarget;
        };
    };
}
function $24bc8fe162c89d19$export$ac607276a8fe9f0a(input) {
    return function() {
        return input.height;
    };
}
function $24bc8fe162c89d19$export$3f31360357be44e4(height) {
    return function(input) {
        return function() {
            input.height = height;
        };
    };
}
function $24bc8fe162c89d19$export$5a1fde3dfe3b3c2a(input) {
    return function() {
        return input.indeterminate;
    };
}
function $24bc8fe162c89d19$export$52735f1bbb810b6(indeterminate) {
    return function(input) {
        return function() {
            input.indeterminate = indeterminate;
        };
    };
}
function $24bc8fe162c89d19$export$8932efb87fe83757(input) {
    return function() {
        return input.list;
    };
}
function $24bc8fe162c89d19$export$8960430cfd85939f(input) {
    return function() {
        return input.max;
    };
}
function $24bc8fe162c89d19$export$b03015b7eb8a4a0d(max) {
    return function(input) {
        return function() {
            input.max = max;
        };
    };
}
function $24bc8fe162c89d19$export$c9f461152c658a8b(input) {
    return function() {
        return input.maxLength;
    };
}
function $24bc8fe162c89d19$export$45077a575ddd961f(maxLength) {
    return function(input) {
        return function() {
            input.maxLength = maxLength;
        };
    };
}
function $24bc8fe162c89d19$export$96ec731ed4dcb222(input) {
    return function() {
        return input.min;
    };
}
function $24bc8fe162c89d19$export$46d199234e678744(min) {
    return function(input) {
        return function() {
            input.min = min;
        };
    };
}
function $24bc8fe162c89d19$export$8fe860a115a1e636(input) {
    return function() {
        return input.minLength;
    };
}
function $24bc8fe162c89d19$export$2b867239766ba1e3(minLength) {
    return function(input) {
        return function() {
            input.minLength = minLength;
        };
    };
}
function $24bc8fe162c89d19$export$939ddaa3205df08e(input) {
    return function() {
        return input.multiple;
    };
}
function $24bc8fe162c89d19$export$be7c7381b31f2269(multiple) {
    return function(input) {
        return function() {
            input.multiple = multiple;
        };
    };
}
function $24bc8fe162c89d19$export$a8ff84c12d48cfa6(input) {
    return function() {
        return input.name;
    };
}
function $24bc8fe162c89d19$export$6cf3d710d3a367e5(name) {
    return function(input) {
        return function() {
            input.name = name;
        };
    };
}
function $24bc8fe162c89d19$export$24f82734ea047e6f(input) {
    return function() {
        return input.pattern;
    };
}
function $24bc8fe162c89d19$export$faed90dbedc3b6d5(pattern) {
    return function(input) {
        return function() {
            input.pattern = pattern;
        };
    };
}
function $24bc8fe162c89d19$export$c7187bbd1a7a9244(input) {
    return function() {
        return input.placeholder;
    };
}
function $24bc8fe162c89d19$export$645bf5697adfa088(placeholder) {
    return function(input) {
        return function() {
            input.placeholder = placeholder;
        };
    };
}
function $24bc8fe162c89d19$export$b2cbc93d4da94977(input) {
    return function() {
        return input.readOnly;
    };
}
function $24bc8fe162c89d19$export$62311ce54ddfc862(readOnly) {
    return function(input) {
        return function() {
            input.readOnly = readOnly;
        };
    };
}
function $24bc8fe162c89d19$export$a7a0278c004aac3f(input) {
    return function() {
        return input.required;
    };
}
function $24bc8fe162c89d19$export$47f9362469f346c4(required) {
    return function(input) {
        return function() {
            input.required = required;
        };
    };
}
function $24bc8fe162c89d19$export$346677f925de839c(input) {
    return function() {
        return input.size;
    };
}
function $24bc8fe162c89d19$export$1c70a6cc12bc0366(size) {
    return function(input) {
        return function() {
            input.size = size;
        };
    };
}
function $24bc8fe162c89d19$export$2e40c9e35e9506f4(input) {
    return function() {
        return input.src;
    };
}
function $24bc8fe162c89d19$export$5771e3a4c80da7df(src) {
    return function(input) {
        return function() {
            input.src = src;
        };
    };
}
function $24bc8fe162c89d19$export$35d34bc0ed591a92(input) {
    return function() {
        return input.step;
    };
}
function $24bc8fe162c89d19$export$5305615f76bbd5b5(step) {
    return function(input) {
        return function() {
            input.step = step;
        };
    };
}
function $24bc8fe162c89d19$export$d4a6a4db5b31e621(input) {
    return function() {
        return input.type;
    };
}
function $24bc8fe162c89d19$export$1bf7f05044e9c5cb(type) {
    return function(input) {
        return function() {
            input.type = type;
        };
    };
}
function $24bc8fe162c89d19$export$1a01ae0705bafd37(input) {
    return function() {
        return input.defaultValue;
    };
}
function $24bc8fe162c89d19$export$d8becbd7468e206f(defaultValue) {
    return function(input) {
        return function() {
            input.defaultValue = defaultValue;
        };
    };
}
function $24bc8fe162c89d19$export$2ab9a8f9f1186f14(input) {
    return function() {
        return input.value;
    };
}
function $24bc8fe162c89d19$export$80746c6bc6142fc8(value) {
    return function(input) {
        return function() {
            input.value = value;
        };
    };
}
function $24bc8fe162c89d19$export$f0d0381422fe3a76(input) {
    return function() {
        return input.valueAsDate;
    };
}
function $24bc8fe162c89d19$export$8dfa787857729211(valueAsDate) {
    return function(input) {
        return function() {
            input.valueAsDate = valueAsDate;
        };
    };
}
function $24bc8fe162c89d19$export$3e66e4a199ac841d(input) {
    return function() {
        return input.valueAsNumber;
    };
}
function $24bc8fe162c89d19$export$4f64bca7327fe0dc(valueAsNumber) {
    return function(input) {
        return function() {
            input.valueAsNumber = valueAsNumber;
        };
    };
}
function $24bc8fe162c89d19$export$7e3df82ee760448c(input) {
    return function() {
        return input.width;
    };
}
function $24bc8fe162c89d19$export$67f48e0594af05d(width) {
    return function(input) {
        return function() {
            input.width = width;
        };
    };
}
function $24bc8fe162c89d19$export$801b713d5ecf6e3f(n) {
    return function(input) {
        return function() {
            input.stepUp(n);
        };
    };
}
function $24bc8fe162c89d19$export$228be912dbc8075f(n) {
    return function(input) {
        return function() {
            input.stepDown(n);
        };
    };
}
function $24bc8fe162c89d19$export$5e55a9e709e8e020(input) {
    return function() {
        return input.willValidate;
    };
}
function $24bc8fe162c89d19$export$1bdd3f9a89b22594(input) {
    return function() {
        return input.validity;
    };
}
function $24bc8fe162c89d19$export$6ee4201e37a931e2(input) {
    return function() {
        return input.validationMessage;
    };
}
function $24bc8fe162c89d19$export$50d70f8cedc54453(input) {
    return function() {
        return input.checkValidity();
    };
}
function $24bc8fe162c89d19$export$b962d864c477cc49(input) {
    return function() {
        return input.reportValidity();
    };
}
function $24bc8fe162c89d19$export$6f569cb704992105(value) {
    return function(input) {
        return function() {
            input.setCustomValidity(value);
        };
    };
}
function $24bc8fe162c89d19$export$a238cb463698c900(input) {
    return function() {
        return input.labels;
    };
}
function $24bc8fe162c89d19$export$2e6c959c16ff56b8(input) {
    return function() {
        input.select();
    };
}
function $24bc8fe162c89d19$export$5e2f617ae845fb63(input) {
    return function() {
        return input.selectionStart;
    };
}
function $24bc8fe162c89d19$export$47b9c21811f199bd(selectionStart) {
    return function(input) {
        return function() {
            input.selectionStart = selectionStart;
        };
    };
}
function $24bc8fe162c89d19$export$1028be563f1155b2(input) {
    return function() {
        return input.selectionEnd;
    };
}
function $24bc8fe162c89d19$export$15d012c6be3c352(selectionEnd) {
    return function(input) {
        return function() {
            input.selectionEnd = selectionEnd;
        };
    };
}
function $24bc8fe162c89d19$export$b4e8aad052258154(input) {
    return function() {
        return input.selectionDirection;
    };
}
function $24bc8fe162c89d19$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(input) {
        return function() {
            input.selectionDirection = selectionDirection;
        };
    };
}
function $24bc8fe162c89d19$export$2add2a46d1c1d557(replacement) {
    return function(input) {
        return function() {
            input.setRangeText(replacement);
        };
    };
}
function $24bc8fe162c89d19$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $24bc8fe162c89d19$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(input) {
                return function() {
                    input.setSelectionRange(start, end, direction, input);
                };
            };
        };
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");
// Generated by purs version 0.15.16

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $8bc3da0ac9f8818e$export$8163af2a41fbee7 = /* #__PURE__ */ function() {
    function Preserve() {}
    Preserve.value = new Preserve();
    return Preserve;
}();
var $8bc3da0ac9f8818e$export$ef9b1a59e592288f = /* #__PURE__ */ function() {
    function Select() {}
    Select.value = new Select();
    return Select;
}();
var $8bc3da0ac9f8818e$export$568b89e600fc77eb = /* #__PURE__ */ function() {
    function Start() {}
    Start.value = new Start();
    return Start;
}();
var $8bc3da0ac9f8818e$export$290d774e6bd35c9a = /* #__PURE__ */ function() {
    function End() {}
    End.value = new End();
    return End;
}();
var $8bc3da0ac9f8818e$export$7e20bbef4bce8df9 = {
    show: function(v) {
        if (v instanceof $8bc3da0ac9f8818e$export$8163af2a41fbee7) return "Preserve";
        if (v instanceof $8bc3da0ac9f8818e$export$ef9b1a59e592288f) return "Select";
        if (v instanceof $8bc3da0ac9f8818e$export$568b89e600fc77eb) return "Start";
        if (v instanceof $8bc3da0ac9f8818e$export$290d774e6bd35c9a) return "End";
        throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 17, column 10 - line 21, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $8bc3da0ac9f8818e$export$c2d084dc44961371 = function(v) {
    if (v instanceof $8bc3da0ac9f8818e$export$8163af2a41fbee7) return "preserve";
    if (v instanceof $8bc3da0ac9f8818e$export$ef9b1a59e592288f) return "select";
    if (v instanceof $8bc3da0ac9f8818e$export$568b89e600fc77eb) return "start";
    if (v instanceof $8bc3da0ac9f8818e$export$290d774e6bd35c9a) return "end";
    throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 32, column 9 - line 36, column 15): " + [
        v.constructor.name
    ]);
};
var $8bc3da0ac9f8818e$export$98e6a39c04603d36 = function(v) {
    if (v === "preserve") return new $h2xUu.Just($8bc3da0ac9f8818e$export$8163af2a41fbee7.value);
    if (v === "select") return new $h2xUu.Just($8bc3da0ac9f8818e$export$ef9b1a59e592288f.value);
    if (v === "start") return new $h2xUu.Just($8bc3da0ac9f8818e$export$568b89e600fc77eb.value);
    if (v === "end") return new $h2xUu.Just($8bc3da0ac9f8818e$export$290d774e6bd35c9a.value);
    return $h2xUu.Nothing.value;
};
var $8bc3da0ac9f8818e$export$b299fa6c3cca1ee7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $8bc3da0ac9f8818e$export$8163af2a41fbee7 && y instanceof $8bc3da0ac9f8818e$export$8163af2a41fbee7) return true;
            if (x instanceof $8bc3da0ac9f8818e$export$ef9b1a59e592288f && y instanceof $8bc3da0ac9f8818e$export$ef9b1a59e592288f) return true;
            if (x instanceof $8bc3da0ac9f8818e$export$568b89e600fc77eb && y instanceof $8bc3da0ac9f8818e$export$568b89e600fc77eb) return true;
            if (x instanceof $8bc3da0ac9f8818e$export$290d774e6bd35c9a && y instanceof $8bc3da0ac9f8818e$export$290d774e6bd35c9a) return true;
            return false;
        };
    }
};
var $8bc3da0ac9f8818e$export$81b0e65721ff4cca = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $8bc3da0ac9f8818e$export$8163af2a41fbee7 && y instanceof $8bc3da0ac9f8818e$export$8163af2a41fbee7) return $ibsD5.EQ.value;
            if (x instanceof $8bc3da0ac9f8818e$export$8163af2a41fbee7) return $ibsD5.LT.value;
            if (y instanceof $8bc3da0ac9f8818e$export$8163af2a41fbee7) return $ibsD5.GT.value;
            if (x instanceof $8bc3da0ac9f8818e$export$ef9b1a59e592288f && y instanceof $8bc3da0ac9f8818e$export$ef9b1a59e592288f) return $ibsD5.EQ.value;
            if (x instanceof $8bc3da0ac9f8818e$export$ef9b1a59e592288f) return $ibsD5.LT.value;
            if (y instanceof $8bc3da0ac9f8818e$export$ef9b1a59e592288f) return $ibsD5.GT.value;
            if (x instanceof $8bc3da0ac9f8818e$export$568b89e600fc77eb && y instanceof $8bc3da0ac9f8818e$export$568b89e600fc77eb) return $ibsD5.EQ.value;
            if (x instanceof $8bc3da0ac9f8818e$export$568b89e600fc77eb) return $ibsD5.LT.value;
            if (y instanceof $8bc3da0ac9f8818e$export$568b89e600fc77eb) return $ibsD5.GT.value;
            if (x instanceof $8bc3da0ac9f8818e$export$290d774e6bd35c9a && y instanceof $8bc3da0ac9f8818e$export$290d774e6bd35c9a) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $8bc3da0ac9f8818e$export$b299fa6c3cca1ee7;
    }
};



var $99a3508e76c01689$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $99a3508e76c01689$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $99a3508e76c01689$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $99a3508e76c01689$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $99a3508e76c01689$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $99a3508e76c01689$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $99a3508e76c01689$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $99a3508e76c01689$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $99a3508e76c01689$export$daa292563bc4c5ef = $24bc8fe162c89d19$export$801b713d5ecf6e3f;
var $99a3508e76c01689$export$218b3ebffb5cc7e4 = /* #__PURE__ */ $99a3508e76c01689$export$daa292563bc4c5ef(1);
var $99a3508e76c01689$export$6dd86ef1ac84105c = $24bc8fe162c89d19$export$228be912dbc8075f;
var $99a3508e76c01689$export$d45ac0df5909f3e5 = /* #__PURE__ */ $99a3508e76c01689$export$6dd86ef1ac84105c(1);
var $99a3508e76c01689$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $24bc8fe162c89d19$export$309b5632e9b49193(rpl, s, e, $8bc3da0ac9f8818e$export$c2d084dc44961371(mode), area);
                    };
                };
            };
        };
    };
};
var $99a3508e76c01689$export$8837f4fc672e936d = /* #__PURE__ */ function() {
    var $2 = $99a3508e76c01689$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($24bc8fe162c89d19$export$8932efb87fe83757($3));
    };
}();
var $99a3508e76c01689$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLInputElement");
var $99a3508e76c01689$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLInputElement");
var $99a3508e76c01689$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLInputElement");
var $99a3508e76c01689$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLInputElement");
var $99a3508e76c01689$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLInputElement");
var $99a3508e76c01689$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLInputElement");
var $99a3508e76c01689$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLInputElement");
var $99a3508e76c01689$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $4 = $99a3508e76c01689$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($24bc8fe162c89d19$export$242c63e9758836c2($5));
    };
}();
var $99a3508e76c01689$export$3a444357c5f65f65 = /* #__PURE__ */ function() {
    var $6 = $99a3508e76c01689$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($7) {
        return $6($24bc8fe162c89d19$export$92d18e9db2d4e896($7));
    };
}();


// Generated by purs version 0.15.16
function $12393db78100a28f$export$4c47992fc278c9a0(keygen) {
    return function() {
        return keygen.autofocus;
    };
}
function $12393db78100a28f$export$db2bbdcbda3d335e(autofocus) {
    return function(keygen) {
        return function() {
            keygen.autofocus = autofocus;
        };
    };
}
function $12393db78100a28f$export$1cb6aab4c63c6c51(keygen) {
    return function() {
        return keygen.challenge;
    };
}
function $12393db78100a28f$export$e4ab94f6a56193a3(challenge) {
    return function(keygen) {
        return function() {
            keygen.challenge = challenge;
        };
    };
}
function $12393db78100a28f$export$683472f6198a076e(keygen) {
    return function() {
        return keygen.disabled;
    };
}
function $12393db78100a28f$export$4532d31cef66d703(disabled) {
    return function(keygen) {
        return function() {
            keygen.disabled = disabled;
        };
    };
}
function $12393db78100a28f$export$242c63e9758836c2(keygen) {
    return function() {
        return keygen.form;
    };
}
function $12393db78100a28f$export$63e1099bcd6b827d(keygen) {
    return function() {
        return keygen.keytype;
    };
}
function $12393db78100a28f$export$d04d7126b9e1b9(keytype) {
    return function(keygen) {
        return function() {
            keygen.keytype = keytype;
        };
    };
}
function $12393db78100a28f$export$a8ff84c12d48cfa6(keygen) {
    return function() {
        return keygen.name;
    };
}
function $12393db78100a28f$export$6cf3d710d3a367e5(name) {
    return function(keygen) {
        return function() {
            keygen.name = name;
        };
    };
}
function $12393db78100a28f$export$d4a6a4db5b31e621(keygen) {
    return function() {
        return keygen.type;
    };
}
function $12393db78100a28f$export$5e55a9e709e8e020(keygen) {
    return function() {
        return keygen.willValidate;
    };
}
function $12393db78100a28f$export$1bdd3f9a89b22594(keygen) {
    return function() {
        return keygen.validity;
    };
}
function $12393db78100a28f$export$6ee4201e37a931e2(keygen) {
    return function() {
        return keygen.validationMessage;
    };
}
function $12393db78100a28f$export$50d70f8cedc54453(keygen) {
    return function() {
        return keygen.checkValidity();
    };
}
function $12393db78100a28f$export$b962d864c477cc49(keygen) {
    return function() {
        return keygen.reportValidity();
    };
}
function $12393db78100a28f$export$6f569cb704992105(value) {
    return function(keygen) {
        return function() {
            keygen.setCustomValidity(value);
        };
    };
}
function $12393db78100a28f$export$a238cb463698c900(keygen) {
    return function() {
        return keygen.labels;
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $8bfd2c50d6501f1f$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $8bfd2c50d6501f1f$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $8bfd2c50d6501f1f$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $8bfd2c50d6501f1f$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $8bfd2c50d6501f1f$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $8bfd2c50d6501f1f$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $8bfd2c50d6501f1f$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $8bfd2c50d6501f1f$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLKeygenElement");
var $8bfd2c50d6501f1f$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLKeygenElement");
var $8bfd2c50d6501f1f$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLKeygenElement");
var $8bfd2c50d6501f1f$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLKeygenElement");
var $8bfd2c50d6501f1f$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLKeygenElement");
var $8bfd2c50d6501f1f$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLKeygenElement");
var $8bfd2c50d6501f1f$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLKeygenElement");
var $8bfd2c50d6501f1f$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $7FzSN.map($1rTTn.functorEffect)($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($12393db78100a28f$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $c8056220f546674d$export$2ab9a8f9f1186f14(li) {
    return function() {
        return li.value;
    };
}
function $c8056220f546674d$export$80746c6bc6142fc8(value) {
    return function(li) {
        return function() {
            li.value = value;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $d96bd78caefd3c87$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $d96bd78caefd3c87$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $d96bd78caefd3c87$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $d96bd78caefd3c87$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $d96bd78caefd3c87$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $d96bd78caefd3c87$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $d96bd78caefd3c87$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $d96bd78caefd3c87$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLIElement");
var $d96bd78caefd3c87$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLIElement");
var $d96bd78caefd3c87$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLIElement");
var $d96bd78caefd3c87$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLIElement");
var $d96bd78caefd3c87$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLIElement");
var $d96bd78caefd3c87$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLIElement");
var $d96bd78caefd3c87$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLIElement");


// Generated by purs version 0.15.16
function $454e9d8878422b2e$export$242c63e9758836c2(label) {
    return function() {
        return label.form;
    };
}
function $454e9d8878422b2e$export$35d9e1c947946090(label) {
    return function() {
        return label.htmlFor;
    };
}
function $454e9d8878422b2e$export$a6c638cfae205843(htmlFor) {
    return function(label) {
        return function() {
            label.htmlFor = htmlFor;
        };
    };
}
function $454e9d8878422b2e$export$317fb27ad464e186(label) {
    return function() {
        return label.control;
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $9d86ca6f8f81b3e6$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $9d86ca6f8f81b3e6$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $9d86ca6f8f81b3e6$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $9d86ca6f8f81b3e6$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $9d86ca6f8f81b3e6$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $9d86ca6f8f81b3e6$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $9d86ca6f8f81b3e6$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $9d86ca6f8f81b3e6$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $9d86ca6f8f81b3e6$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLabelElement");
var $9d86ca6f8f81b3e6$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLabelElement");
var $9d86ca6f8f81b3e6$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLabelElement");
var $9d86ca6f8f81b3e6$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLabelElement");
var $9d86ca6f8f81b3e6$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLabelElement");
var $9d86ca6f8f81b3e6$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLabelElement");
var $9d86ca6f8f81b3e6$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLabelElement");
var $9d86ca6f8f81b3e6$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $9d86ca6f8f81b3e6$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($454e9d8878422b2e$export$242c63e9758836c2($3));
    };
}();
var $9d86ca6f8f81b3e6$export$b5cde1de278b4330 = /* #__PURE__ */ function() {
    var $4 = $9d86ca6f8f81b3e6$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($454e9d8878422b2e$export$317fb27ad464e186($5));
    };
}();


// Generated by purs version 0.15.16
function $584efb3ab60f06c0$export$242c63e9758836c2(le) {
    return function() {
        return le.form;
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $418bb93f692a41c6$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $418bb93f692a41c6$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $418bb93f692a41c6$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $418bb93f692a41c6$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $418bb93f692a41c6$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $418bb93f692a41c6$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $418bb93f692a41c6$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $418bb93f692a41c6$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLegendElement");
var $418bb93f692a41c6$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLegendElement");
var $418bb93f692a41c6$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLegendElement");
var $418bb93f692a41c6$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLegendElement");
var $418bb93f692a41c6$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLegendElement");
var $418bb93f692a41c6$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLegendElement");
var $418bb93f692a41c6$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLegendElement");
var $418bb93f692a41c6$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $7FzSN.map($1rTTn.functorEffect)($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($584efb3ab60f06c0$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $93c5f0a5c805f101$export$683472f6198a076e(link) {
    return function() {
        return link.disabled;
    };
}
function $93c5f0a5c805f101$export$4532d31cef66d703(disabled) {
    return function(link) {
        return function() {
            link.disabled = disabled;
        };
    };
}
function $93c5f0a5c805f101$export$8f51af5840e0602a(link) {
    return function() {
        return link.href;
    };
}
function $93c5f0a5c805f101$export$428f6e77b5a5a669(href) {
    return function(link) {
        return function() {
            link.href = href;
        };
    };
}
function $93c5f0a5c805f101$export$c47cb7c63271266e(link) {
    return function() {
        return link.crossOrigin;
    };
}
function $93c5f0a5c805f101$export$e7fd69f64f92856(crossOrigin) {
    return function(link) {
        return function() {
            link.crossOrigin = crossOrigin;
        };
    };
}
function $93c5f0a5c805f101$export$bad408f43b005bc8(link) {
    return function() {
        return link.rel;
    };
}
function $93c5f0a5c805f101$export$9e86d1af7d63c52c(rel) {
    return function(link) {
        return function() {
            link.rel = rel;
        };
    };
}
function $93c5f0a5c805f101$export$edb1c8e715f3944e(link) {
    return function() {
        return link.rev;
    };
}
function $93c5f0a5c805f101$export$671b41179a9f15fb(rev) {
    return function(link) {
        return function() {
            link.rev = rev;
        };
    };
}
function $93c5f0a5c805f101$export$5884a0b424dd5ef2(link) {
    return function() {
        return link.relList;
    };
}
function $93c5f0a5c805f101$export$987d49ffe1b0900f(link) {
    return function() {
        return link.media;
    };
}
function $93c5f0a5c805f101$export$5c1855deea651e41(media) {
    return function(link) {
        return function() {
            link.media = media;
        };
    };
}
function $93c5f0a5c805f101$export$4bf4138386d6b8cc(link) {
    return function() {
        return link.hreflang;
    };
}
function $93c5f0a5c805f101$export$17b5334c80252e15(hreflang) {
    return function(link) {
        return function() {
            link.hreflang = hreflang;
        };
    };
}
function $93c5f0a5c805f101$export$d4a6a4db5b31e621(link) {
    return function() {
        return link.type;
    };
}
function $93c5f0a5c805f101$export$1bf7f05044e9c5cb(type) {
    return function(link) {
        return function() {
            link.type = type;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $bc849009f1c623ac$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $bc849009f1c623ac$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $bc849009f1c623ac$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $bc849009f1c623ac$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $bc849009f1c623ac$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $bc849009f1c623ac$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $bc849009f1c623ac$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $bc849009f1c623ac$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLinkElement");
var $bc849009f1c623ac$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLinkElement");
var $bc849009f1c623ac$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLinkElement");
var $bc849009f1c623ac$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLinkElement");
var $bc849009f1c623ac$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLinkElement");
var $bc849009f1c623ac$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLinkElement");
var $bc849009f1c623ac$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLLinkElement");


// Generated by purs version 0.15.16
function $0126a8aa5e3b9455$export$a8ff84c12d48cfa6(map) {
    return function() {
        return map.name;
    };
}
function $0126a8aa5e3b9455$export$6cf3d710d3a367e5(name) {
    return function(map) {
        return function() {
            map.name = name;
        };
    };
}
function $0126a8aa5e3b9455$export$4bdc600e2ccf60d6(map) {
    return function() {
        return map.areas;
    };
}
function $0126a8aa5e3b9455$export$6c746a5570b8b35c(map) {
    return function() {
        return map.images;
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $4b1a343b66146b42$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $4b1a343b66146b42$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $4b1a343b66146b42$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $4b1a343b66146b42$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $4b1a343b66146b42$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $4b1a343b66146b42$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $4b1a343b66146b42$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $4b1a343b66146b42$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMapElement");
var $4b1a343b66146b42$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMapElement");
var $4b1a343b66146b42$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMapElement");
var $4b1a343b66146b42$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMapElement");
var $4b1a343b66146b42$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMapElement");
var $4b1a343b66146b42$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMapElement");
var $4b1a343b66146b42$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMapElement");


// Generated by purs version 0.15.16
function $c28b71f04cc4a90b$export$2e40c9e35e9506f4(media) {
    return function() {
        return media.src;
    };
}
function $c28b71f04cc4a90b$export$5771e3a4c80da7df(src) {
    return function(media) {
        return function() {
            media.src = src;
        };
    };
}
function $c28b71f04cc4a90b$export$22e7408040d24cb8(media) {
    return function() {
        return media.currentSrc;
    };
}
function $c28b71f04cc4a90b$export$c47cb7c63271266e(media) {
    return function() {
        return media.crossOrigin;
    };
}
function $c28b71f04cc4a90b$export$e7fd69f64f92856(crossOrigin) {
    return function(media) {
        return function() {
            media.crossOrigin = crossOrigin;
        };
    };
}
function $c28b71f04cc4a90b$export$145bdcc6d8d4a53d(media) {
    return media.networkState;
}
function $c28b71f04cc4a90b$export$513ccb98c53b8039(media) {
    return function() {
        return media.preload;
    };
}
function $c28b71f04cc4a90b$export$f6b3982121e869a(preload) {
    return function(media) {
        return function() {
            media.preload = preload;
        };
    };
}
function $c28b71f04cc4a90b$export$11e63f7b0f3d9900(media) {
    return function() {
        return media.load();
    };
}
function $c28b71f04cc4a90b$export$1a796126c2303a8(type, media) {
    return media.canPlayType(type);
}
function $c28b71f04cc4a90b$export$4bf8a366db6a678b(media) {
    return media.readyState;
}
function $c28b71f04cc4a90b$export$c8243f3943339030(media) {
    return function() {
        return media.seeking;
    };
}
function $c28b71f04cc4a90b$export$283f641d6ed1ac80(media) {
    return function() {
        return media.currentTime;
    };
}
function $c28b71f04cc4a90b$export$428d94eac67f5311(currentTime) {
    return function(media) {
        return function() {
            media.currentTime = currentTime;
        };
    };
}
function $c28b71f04cc4a90b$export$1f34108aa9eb96ab(media) {
    return function() {
        return media.duration;
    };
}
function $c28b71f04cc4a90b$export$3ee8fbdbeceaef0e(media) {
    return function() {
        return media.getStartDate();
    };
}
function $c28b71f04cc4a90b$export$cd215b91700bbebc(media) {
    return function() {
        return media.paused;
    };
}
function $c28b71f04cc4a90b$export$388da195c50bfd17(media) {
    return function() {
        return media.defaultPlaybackRate;
    };
}
function $c28b71f04cc4a90b$export$6fa34934a59a9a1(defaultPlaybackRate) {
    return function(media) {
        return function() {
            media.defaultPlaybackRate = defaultPlaybackRate;
        };
    };
}
function $c28b71f04cc4a90b$export$6d7f3930b8041bc4(media) {
    return function() {
        return media.playbackRate;
    };
}
function $c28b71f04cc4a90b$export$3f48445a0d32edb0(playbackRate) {
    return function(media) {
        return function() {
            media.playbackRate = playbackRate;
        };
    };
}
function $c28b71f04cc4a90b$export$999b7b72c79021f2(media) {
    return function() {
        return media.ended;
    };
}
function $c28b71f04cc4a90b$export$b243096046abd58(media) {
    return function() {
        return media.autoplay;
    };
}
function $c28b71f04cc4a90b$export$7a98ea7b6e6b2d36(autoplay) {
    return function(media) {
        return function() {
            media.autoplay = autoplay;
        };
    };
}
function $c28b71f04cc4a90b$export$f9ef67375ddc185(media) {
    return function() {
        return media.loop;
    };
}
function $c28b71f04cc4a90b$export$cf50c2db8dc11f8e(loop) {
    return function(media) {
        return function() {
            media.loop = loop;
        };
    };
}
function $c28b71f04cc4a90b$export$899fbdb5fa08b653(media) {
    return function() {
        media.play();
    };
}
function $c28b71f04cc4a90b$export$229c72e5fdee233b(media) {
    return function() {
        media.pause();
    };
}
function $c28b71f04cc4a90b$export$2855e964765eac9(media) {
    return function() {
        return media.mediaGroup;
    };
}
function $c28b71f04cc4a90b$export$2c8be4634a501ac1(mediaGroup) {
    return function(media) {
        return function() {
            media.mediaGroup = mediaGroup;
        };
    };
}
function $c28b71f04cc4a90b$export$cc1adf6fb659c762(media) {
    return function() {
        return media.controls;
    };
}
function $c28b71f04cc4a90b$export$891f55ce9f9e8605(controls) {
    return function(media) {
        return function() {
            media.controls = controls;
        };
    };
}
function $c28b71f04cc4a90b$export$7714b48ed08b13f2(media) {
    return function() {
        return media.volume;
    };
}
function $c28b71f04cc4a90b$export$246e658b67178cb0(volume) {
    return function(media) {
        return function() {
            media.volume = volume;
        };
    };
}
function $c28b71f04cc4a90b$export$987a4e3838aef8c6(media) {
    return function() {
        return media.muted;
    };
}
function $c28b71f04cc4a90b$export$a1680ba91cc9be33(muted) {
    return function(media) {
        return function() {
            media.muted = muted;
        };
    };
}
function $c28b71f04cc4a90b$export$4c9bd91015e50a76(media) {
    return function() {
        return media.defaultMuted;
    };
}
function $c28b71f04cc4a90b$export$a203b6be5128443d(defaultMuted) {
    return function(media) {
        return function() {
            media.defaultMuted = defaultMuted;
        };
    };
}



var $dIXGo = parcelRequire("dIXGo");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");
// Generated by purs version 0.15.16

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $1043e1434b803847$export$fadaed88e803a5ce = /* #__PURE__ */ function() {
    function Unspecified() {}
    Unspecified.value = new Unspecified();
    return Unspecified;
}();
var $1043e1434b803847$export$ad3bd6e4e1ec5d06 = /* #__PURE__ */ function() {
    function Maybe() {}
    Maybe.value = new Maybe();
    return Maybe;
}();
var $1043e1434b803847$export$1fa2c133480c0d67 = /* #__PURE__ */ function() {
    function Probably() {}
    Probably.value = new Probably();
    return Probably;
}();
var $1043e1434b803847$export$639d66421832ff11 = {
    show: function(v) {
        if (v instanceof $1043e1434b803847$export$fadaed88e803a5ce) return "Unspecified";
        if (v instanceof $1043e1434b803847$export$ad3bd6e4e1ec5d06) return "Maybe";
        if (v instanceof $1043e1434b803847$export$1fa2c133480c0d67) return "Probably";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $1043e1434b803847$export$c2d084dc44961371 = function(v) {
    if (v instanceof $1043e1434b803847$export$fadaed88e803a5ce) return "";
    if (v instanceof $1043e1434b803847$export$ad3bd6e4e1ec5d06) return "maybe";
    if (v instanceof $1043e1434b803847$export$1fa2c133480c0d67) return "probably";
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 29, column 9 - line 32, column 25): " + [
        v.constructor.name
    ]);
};
var $1043e1434b803847$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $h2xUu.Just($1043e1434b803847$export$fadaed88e803a5ce.value);
    if (v === "maybe") return new $h2xUu.Just($1043e1434b803847$export$ad3bd6e4e1ec5d06.value);
    if (v === "probably") return new $h2xUu.Just($1043e1434b803847$export$1fa2c133480c0d67.value);
    return $h2xUu.Nothing.value;
};
var $1043e1434b803847$export$34fdecd70907479d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $1043e1434b803847$export$fadaed88e803a5ce && y instanceof $1043e1434b803847$export$fadaed88e803a5ce) return true;
            if (x instanceof $1043e1434b803847$export$ad3bd6e4e1ec5d06 && y instanceof $1043e1434b803847$export$ad3bd6e4e1ec5d06) return true;
            if (x instanceof $1043e1434b803847$export$1fa2c133480c0d67 && y instanceof $1043e1434b803847$export$1fa2c133480c0d67) return true;
            return false;
        };
    }
};
var $1043e1434b803847$export$dbc9bfdb74d43b21 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $1043e1434b803847$export$fadaed88e803a5ce && y instanceof $1043e1434b803847$export$fadaed88e803a5ce) return $ibsD5.EQ.value;
            if (x instanceof $1043e1434b803847$export$fadaed88e803a5ce) return $ibsD5.LT.value;
            if (y instanceof $1043e1434b803847$export$fadaed88e803a5ce) return $ibsD5.GT.value;
            if (x instanceof $1043e1434b803847$export$ad3bd6e4e1ec5d06 && y instanceof $1043e1434b803847$export$ad3bd6e4e1ec5d06) return $ibsD5.EQ.value;
            if (x instanceof $1043e1434b803847$export$ad3bd6e4e1ec5d06) return $ibsD5.LT.value;
            if (y instanceof $1043e1434b803847$export$ad3bd6e4e1ec5d06) return $ibsD5.GT.value;
            if (x instanceof $1043e1434b803847$export$1fa2c133480c0d67 && y instanceof $1043e1434b803847$export$1fa2c133480c0d67) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $1043e1434b803847$export$34fdecd70907479d;
    }
};


// Generated by purs version 0.15.16

var $dIXGo = parcelRequire("dIXGo");

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $7c0ca64d7941564a$export$1f74963c34e8bfec = /* #__PURE__ */ function() {
    function Empty() {}
    Empty.value = new Empty();
    return Empty;
}();
var $7c0ca64d7941564a$export$5407f8fd4e62a93 = /* #__PURE__ */ function() {
    function Idle() {}
    Idle.value = new Idle();
    return Idle;
}();
var $7c0ca64d7941564a$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $7c0ca64d7941564a$export$9f99d34709abd9bc = /* #__PURE__ */ function() {
    function NoSource() {}
    NoSource.value = new NoSource();
    return NoSource;
}();
var $7c0ca64d7941564a$var$toEnumNetworkState = function(v) {
    if (v === 0) return new $h2xUu.Just($7c0ca64d7941564a$export$1f74963c34e8bfec.value);
    if (v === 1) return new $h2xUu.Just($7c0ca64d7941564a$export$5407f8fd4e62a93.value);
    if (v === 2) return new $h2xUu.Just($7c0ca64d7941564a$export$669f6ea7d267feaf.value);
    if (v === 3) return new $h2xUu.Just($7c0ca64d7941564a$export$9f99d34709abd9bc.value);
    return $h2xUu.Nothing.value;
};
var $7c0ca64d7941564a$export$6dde42aa2c503bde = {
    show: function(v) {
        if (v instanceof $7c0ca64d7941564a$export$1f74963c34e8bfec) return "Empty";
        if (v instanceof $7c0ca64d7941564a$export$5407f8fd4e62a93) return "Idle";
        if (v instanceof $7c0ca64d7941564a$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $7c0ca64d7941564a$export$9f99d34709abd9bc) return "NoSource";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 30, column 1 - line 34, column 29): " + [
            v.constructor.name
        ]);
    }
};
var $7c0ca64d7941564a$var$fromEnumNetworkState = function(v) {
    if (v instanceof $7c0ca64d7941564a$export$1f74963c34e8bfec) return 0;
    if (v instanceof $7c0ca64d7941564a$export$5407f8fd4e62a93) return 1;
    if (v instanceof $7c0ca64d7941564a$export$669f6ea7d267feaf) return 2;
    if (v instanceof $7c0ca64d7941564a$export$9f99d34709abd9bc) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 47, column 3 - line 51, column 18): " + [
        v.constructor.name
    ]);
};
var $7c0ca64d7941564a$export$a2cfa34e78ccc2f5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $7c0ca64d7941564a$export$1f74963c34e8bfec && y instanceof $7c0ca64d7941564a$export$1f74963c34e8bfec) return true;
            if (x instanceof $7c0ca64d7941564a$export$5407f8fd4e62a93 && y instanceof $7c0ca64d7941564a$export$5407f8fd4e62a93) return true;
            if (x instanceof $7c0ca64d7941564a$export$669f6ea7d267feaf && y instanceof $7c0ca64d7941564a$export$669f6ea7d267feaf) return true;
            if (x instanceof $7c0ca64d7941564a$export$9f99d34709abd9bc && y instanceof $7c0ca64d7941564a$export$9f99d34709abd9bc) return true;
            return false;
        };
    }
};
var $7c0ca64d7941564a$export$dd5f9f1c18c12839 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $7c0ca64d7941564a$export$1f74963c34e8bfec && y instanceof $7c0ca64d7941564a$export$1f74963c34e8bfec) return $ibsD5.EQ.value;
            if (x instanceof $7c0ca64d7941564a$export$1f74963c34e8bfec) return $ibsD5.LT.value;
            if (y instanceof $7c0ca64d7941564a$export$1f74963c34e8bfec) return $ibsD5.GT.value;
            if (x instanceof $7c0ca64d7941564a$export$5407f8fd4e62a93 && y instanceof $7c0ca64d7941564a$export$5407f8fd4e62a93) return $ibsD5.EQ.value;
            if (x instanceof $7c0ca64d7941564a$export$5407f8fd4e62a93) return $ibsD5.LT.value;
            if (y instanceof $7c0ca64d7941564a$export$5407f8fd4e62a93) return $ibsD5.GT.value;
            if (x instanceof $7c0ca64d7941564a$export$669f6ea7d267feaf && y instanceof $7c0ca64d7941564a$export$669f6ea7d267feaf) return $ibsD5.EQ.value;
            if (x instanceof $7c0ca64d7941564a$export$669f6ea7d267feaf) return $ibsD5.LT.value;
            if (y instanceof $7c0ca64d7941564a$export$669f6ea7d267feaf) return $ibsD5.GT.value;
            if (x instanceof $7c0ca64d7941564a$export$9f99d34709abd9bc && y instanceof $7c0ca64d7941564a$export$9f99d34709abd9bc) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $7c0ca64d7941564a$export$a2cfa34e78ccc2f5;
    }
};
var $7c0ca64d7941564a$export$e6f607f3cddfb3c1 = {
    succ: /* #__PURE__ */ $dIXGo.defaultSucc($7c0ca64d7941564a$var$toEnumNetworkState)($7c0ca64d7941564a$var$fromEnumNetworkState),
    pred: /* #__PURE__ */ $dIXGo.defaultPred($7c0ca64d7941564a$var$toEnumNetworkState)($7c0ca64d7941564a$var$fromEnumNetworkState),
    Ord0: function() {
        return $7c0ca64d7941564a$export$dd5f9f1c18c12839;
    }
};
var $7c0ca64d7941564a$export$63a4f766ab578d95 = /* #__PURE__ */ function() {
    return {
        bottom: $7c0ca64d7941564a$export$1f74963c34e8bfec.value,
        top: $7c0ca64d7941564a$export$9f99d34709abd9bc.value,
        Ord0: function() {
            return $7c0ca64d7941564a$export$dd5f9f1c18c12839;
        }
    };
}();
var $7c0ca64d7941564a$export$19d342d9da2ba7a3 = {
    cardinality: 4,
    toEnum: $7c0ca64d7941564a$var$toEnumNetworkState,
    fromEnum: $7c0ca64d7941564a$var$fromEnumNetworkState,
    Bounded0: function() {
        return $7c0ca64d7941564a$export$63a4f766ab578d95;
    },
    Enum1: function() {
        return $7c0ca64d7941564a$export$e6f607f3cddfb3c1;
    }
};


// Generated by purs version 0.15.16

var $dIXGo = parcelRequire("dIXGo");

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $cc7ec38a3f763cf5$export$aeb73cf127af2fad = /* #__PURE__ */ function() {
    function HaveNothing() {}
    HaveNothing.value = new HaveNothing();
    return HaveNothing;
}();
var $cc7ec38a3f763cf5$export$e96d91cd125cf5ba = /* #__PURE__ */ function() {
    function HaveMetadata() {}
    HaveMetadata.value = new HaveMetadata();
    return HaveMetadata;
}();
var $cc7ec38a3f763cf5$export$c416983dd5609b6e = /* #__PURE__ */ function() {
    function HaveCurrentData() {}
    HaveCurrentData.value = new HaveCurrentData();
    return HaveCurrentData;
}();
var $cc7ec38a3f763cf5$export$3c862393aec03c72 = /* #__PURE__ */ function() {
    function HaveFutureData() {}
    HaveFutureData.value = new HaveFutureData();
    return HaveFutureData;
}();
var $cc7ec38a3f763cf5$export$c0fee25792a80051 = /* #__PURE__ */ function() {
    function HaveEnoughData() {}
    HaveEnoughData.value = new HaveEnoughData();
    return HaveEnoughData;
}();
var $cc7ec38a3f763cf5$var$toEnumReadyState = function(v) {
    if (v === 0) return new $h2xUu.Just($cc7ec38a3f763cf5$export$aeb73cf127af2fad.value);
    if (v === 1) return new $h2xUu.Just($cc7ec38a3f763cf5$export$e96d91cd125cf5ba.value);
    if (v === 2) return new $h2xUu.Just($cc7ec38a3f763cf5$export$c416983dd5609b6e.value);
    if (v === 3) return new $h2xUu.Just($cc7ec38a3f763cf5$export$3c862393aec03c72.value);
    if (v === 4) return new $h2xUu.Just($cc7ec38a3f763cf5$export$c0fee25792a80051.value);
    return $h2xUu.Nothing.value;
};
var $cc7ec38a3f763cf5$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $cc7ec38a3f763cf5$export$aeb73cf127af2fad) return "HaveNothing";
        if (v instanceof $cc7ec38a3f763cf5$export$e96d91cd125cf5ba) return "HaveMetadata";
        if (v instanceof $cc7ec38a3f763cf5$export$c416983dd5609b6e) return "HaveCurrentData";
        if (v instanceof $cc7ec38a3f763cf5$export$3c862393aec03c72) return "HaveFutureData";
        if (v instanceof $cc7ec38a3f763cf5$export$c0fee25792a80051) return "HaveEnoughData";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 31, column 1 - line 36, column 41): " + [
            v.constructor.name
        ]);
    }
};
var $cc7ec38a3f763cf5$var$fromEnumReadyState = function(v) {
    if (v instanceof $cc7ec38a3f763cf5$export$aeb73cf127af2fad) return 0;
    if (v instanceof $cc7ec38a3f763cf5$export$e96d91cd125cf5ba) return 1;
    if (v instanceof $cc7ec38a3f763cf5$export$c416983dd5609b6e) return 2;
    if (v instanceof $cc7ec38a3f763cf5$export$3c862393aec03c72) return 3;
    if (v instanceof $cc7ec38a3f763cf5$export$c0fee25792a80051) return 4;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 50, column 3 - line 55, column 24): " + [
        v.constructor.name
    ]);
};
var $cc7ec38a3f763cf5$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $cc7ec38a3f763cf5$export$aeb73cf127af2fad && y instanceof $cc7ec38a3f763cf5$export$aeb73cf127af2fad) return true;
            if (x instanceof $cc7ec38a3f763cf5$export$e96d91cd125cf5ba && y instanceof $cc7ec38a3f763cf5$export$e96d91cd125cf5ba) return true;
            if (x instanceof $cc7ec38a3f763cf5$export$c416983dd5609b6e && y instanceof $cc7ec38a3f763cf5$export$c416983dd5609b6e) return true;
            if (x instanceof $cc7ec38a3f763cf5$export$3c862393aec03c72 && y instanceof $cc7ec38a3f763cf5$export$3c862393aec03c72) return true;
            if (x instanceof $cc7ec38a3f763cf5$export$c0fee25792a80051 && y instanceof $cc7ec38a3f763cf5$export$c0fee25792a80051) return true;
            return false;
        };
    }
};
var $cc7ec38a3f763cf5$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $cc7ec38a3f763cf5$export$aeb73cf127af2fad && y instanceof $cc7ec38a3f763cf5$export$aeb73cf127af2fad) return $ibsD5.EQ.value;
            if (x instanceof $cc7ec38a3f763cf5$export$aeb73cf127af2fad) return $ibsD5.LT.value;
            if (y instanceof $cc7ec38a3f763cf5$export$aeb73cf127af2fad) return $ibsD5.GT.value;
            if (x instanceof $cc7ec38a3f763cf5$export$e96d91cd125cf5ba && y instanceof $cc7ec38a3f763cf5$export$e96d91cd125cf5ba) return $ibsD5.EQ.value;
            if (x instanceof $cc7ec38a3f763cf5$export$e96d91cd125cf5ba) return $ibsD5.LT.value;
            if (y instanceof $cc7ec38a3f763cf5$export$e96d91cd125cf5ba) return $ibsD5.GT.value;
            if (x instanceof $cc7ec38a3f763cf5$export$c416983dd5609b6e && y instanceof $cc7ec38a3f763cf5$export$c416983dd5609b6e) return $ibsD5.EQ.value;
            if (x instanceof $cc7ec38a3f763cf5$export$c416983dd5609b6e) return $ibsD5.LT.value;
            if (y instanceof $cc7ec38a3f763cf5$export$c416983dd5609b6e) return $ibsD5.GT.value;
            if (x instanceof $cc7ec38a3f763cf5$export$3c862393aec03c72 && y instanceof $cc7ec38a3f763cf5$export$3c862393aec03c72) return $ibsD5.EQ.value;
            if (x instanceof $cc7ec38a3f763cf5$export$3c862393aec03c72) return $ibsD5.LT.value;
            if (y instanceof $cc7ec38a3f763cf5$export$3c862393aec03c72) return $ibsD5.GT.value;
            if (x instanceof $cc7ec38a3f763cf5$export$c0fee25792a80051 && y instanceof $cc7ec38a3f763cf5$export$c0fee25792a80051) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $cc7ec38a3f763cf5$export$c71e02dcc13f94a6;
    }
};
var $cc7ec38a3f763cf5$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $dIXGo.defaultSucc($cc7ec38a3f763cf5$var$toEnumReadyState)($cc7ec38a3f763cf5$var$fromEnumReadyState),
    pred: /* #__PURE__ */ $dIXGo.defaultPred($cc7ec38a3f763cf5$var$toEnumReadyState)($cc7ec38a3f763cf5$var$fromEnumReadyState),
    Ord0: function() {
        return $cc7ec38a3f763cf5$export$6557947d538c3b81;
    }
};
var $cc7ec38a3f763cf5$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $cc7ec38a3f763cf5$export$aeb73cf127af2fad.value,
        top: $cc7ec38a3f763cf5$export$c0fee25792a80051.value,
        Ord0: function() {
            return $cc7ec38a3f763cf5$export$6557947d538c3b81;
        }
    };
}();
var $cc7ec38a3f763cf5$export$94a641e970e969f9 = {
    cardinality: 5,
    toEnum: $cc7ec38a3f763cf5$var$toEnumReadyState,
    fromEnum: $cc7ec38a3f763cf5$var$fromEnumReadyState,
    Bounded0: function() {
        return $cc7ec38a3f763cf5$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $cc7ec38a3f763cf5$export$f705a14e9e99c6f0;
    }
};



var $2175c8810b1047a0$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $2175c8810b1047a0$var$toEnum = /* #__PURE__ */ $dIXGo.toEnum($cc7ec38a3f763cf5$export$94a641e970e969f9);
var $2175c8810b1047a0$var$toEnum1 = /* #__PURE__ */ $dIXGo.toEnum($7c0ca64d7941564a$export$19d342d9da2ba7a3);
var $2175c8810b1047a0$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $2175c8810b1047a0$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $2175c8810b1047a0$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $2175c8810b1047a0$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $2175c8810b1047a0$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $2175c8810b1047a0$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $2175c8810b1047a0$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $2175c8810b1047a0$export$1ae2b664eea77b7e = function(el) {
    return $2175c8810b1047a0$var$map(function() {
        var $4 = $h2xUu.fromMaybe($cc7ec38a3f763cf5$export$aeb73cf127af2fad.value);
        return function($5) {
            return $4($2175c8810b1047a0$var$toEnum($5));
        };
    }())(function() {
        return $c28b71f04cc4a90b$export$4bf8a366db6a678b(el);
    });
};
var $2175c8810b1047a0$export$8ee3aa19592dce0d = function(el) {
    return $2175c8810b1047a0$var$map(function() {
        var $6 = $h2xUu.fromMaybe($7c0ca64d7941564a$export$1f74963c34e8bfec.value);
        return function($7) {
            return $6($2175c8810b1047a0$var$toEnum1($7));
        };
    }())(function() {
        return $c28b71f04cc4a90b$export$145bdcc6d8d4a53d(el);
    });
};
var $2175c8810b1047a0$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMediaElement");
var $2175c8810b1047a0$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMediaElement");
var $2175c8810b1047a0$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMediaElement");
var $2175c8810b1047a0$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMediaElement");
var $2175c8810b1047a0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMediaElement");
var $2175c8810b1047a0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMediaElement");
var $2175c8810b1047a0$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMediaElement");
var $2175c8810b1047a0$export$2b5874dc653b656c = function(ty) {
    return function(el) {
        return $2175c8810b1047a0$var$map(function() {
            var $8 = $h2xUu.fromMaybe($1043e1434b803847$export$fadaed88e803a5ce.value);
            return function($9) {
                return $8($1043e1434b803847$export$98e6a39c04603d36($9));
            };
        }())(function() {
            return $c28b71f04cc4a90b$export$1a796126c2303a8(ty, el);
        });
    };
};


// Generated by purs version 0.15.16
function $7ed6385cd28353f5$export$a8ff84c12d48cfa6(meta) {
    return function() {
        return meta.name;
    };
}
function $7ed6385cd28353f5$export$6cf3d710d3a367e5(name) {
    return function(meta) {
        return function() {
            meta.name = name;
        };
    };
}
function $7ed6385cd28353f5$export$725a8790b31857c5(meta) {
    return function() {
        return meta.httpEquiv;
    };
}
function $7ed6385cd28353f5$export$253f18aa71ab8120(httpEquiv) {
    return function(meta) {
        return function() {
            meta.httpEquiv = httpEquiv;
        };
    };
}
function $7ed6385cd28353f5$export$a7db06668cad9adb(meta) {
    return function() {
        return meta.content;
    };
}
function $7ed6385cd28353f5$export$431313f2afd011e2(content) {
    return function(meta) {
        return function() {
            meta.content = content;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $4b137fc4d75885ca$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $4b137fc4d75885ca$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $4b137fc4d75885ca$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $4b137fc4d75885ca$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $4b137fc4d75885ca$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $4b137fc4d75885ca$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $4b137fc4d75885ca$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $4b137fc4d75885ca$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMetaElement");
var $4b137fc4d75885ca$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMetaElement");
var $4b137fc4d75885ca$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMetaElement");
var $4b137fc4d75885ca$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMetaElement");
var $4b137fc4d75885ca$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMetaElement");
var $4b137fc4d75885ca$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMetaElement");
var $4b137fc4d75885ca$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMetaElement");


// Generated by purs version 0.15.16
function $1251605201a7d56b$export$2ab9a8f9f1186f14(meter) {
    return function() {
        return meter.value;
    };
}
function $1251605201a7d56b$export$80746c6bc6142fc8(value) {
    return function(meter) {
        return function() {
            meter.value = value;
        };
    };
}
function $1251605201a7d56b$export$96ec731ed4dcb222(meter) {
    return function() {
        return meter.min;
    };
}
function $1251605201a7d56b$export$46d199234e678744(min) {
    return function(meter) {
        return function() {
            meter.min = min;
        };
    };
}
function $1251605201a7d56b$export$8960430cfd85939f(meter) {
    return function() {
        return meter.max;
    };
}
function $1251605201a7d56b$export$b03015b7eb8a4a0d(max) {
    return function(meter) {
        return function() {
            meter.max = max;
        };
    };
}
function $1251605201a7d56b$export$e81601c80b4e876e(meter) {
    return function() {
        return meter.low;
    };
}
function $1251605201a7d56b$export$8b78ab0b9863288b(low) {
    return function(meter) {
        return function() {
            meter.low = low;
        };
    };
}
function $1251605201a7d56b$export$7cb505ef3217a5c4(meter) {
    return function() {
        return meter.high;
    };
}
function $1251605201a7d56b$export$f4a8cfe80ee4d275(high) {
    return function(meter) {
        return function() {
            meter.high = high;
        };
    };
}
function $1251605201a7d56b$export$49f2954c623150dd(meter) {
    return function() {
        return meter.optimum;
    };
}
function $1251605201a7d56b$export$47b0039e9987ccc5(optimum) {
    return function(meter) {
        return function() {
            meter.optimum = optimum;
        };
    };
}
function $1251605201a7d56b$export$a238cb463698c900(meter) {
    return function() {
        return meter.labels;
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $6d0f518bb14a90d3$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $6d0f518bb14a90d3$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $6d0f518bb14a90d3$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $6d0f518bb14a90d3$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $6d0f518bb14a90d3$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $6d0f518bb14a90d3$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $6d0f518bb14a90d3$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $6d0f518bb14a90d3$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMeterElement");
var $6d0f518bb14a90d3$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMeterElement");
var $6d0f518bb14a90d3$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMeterElement");
var $6d0f518bb14a90d3$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMeterElement");
var $6d0f518bb14a90d3$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMeterElement");
var $6d0f518bb14a90d3$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMeterElement");
var $6d0f518bb14a90d3$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLMeterElement");


// Generated by purs version 0.15.16
function $2e4a39f81112cbbc$export$3035df57df42c31a(mod) {
    return function() {
        return mod.cite;
    };
}
function $2e4a39f81112cbbc$export$86262a2b9f03fae3(cite) {
    return function(mod) {
        return function() {
            mod.cite = cite;
        };
    };
}
function $2e4a39f81112cbbc$export$3a17bddce263fba0(mod) {
    return function() {
        return mod.dateTime;
    };
}
function $2e4a39f81112cbbc$export$3a84b9eda98e95dc(dateTime) {
    return function(mod) {
        return function() {
            mod.dateTime = dateTime;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $6af367a8f8641cee$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $6af367a8f8641cee$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $6af367a8f8641cee$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $6af367a8f8641cee$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $6af367a8f8641cee$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $6af367a8f8641cee$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $6af367a8f8641cee$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $6af367a8f8641cee$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLModElement");
var $6af367a8f8641cee$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLModElement");
var $6af367a8f8641cee$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLModElement");
var $6af367a8f8641cee$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLModElement");
var $6af367a8f8641cee$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLModElement");
var $6af367a8f8641cee$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLModElement");
var $6af367a8f8641cee$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLModElement");


// Generated by purs version 0.15.16
function $3b3250cec9f2e215$export$e2239770db970295(ol) {
    return function() {
        return ol.reversed;
    };
}
function $3b3250cec9f2e215$export$9c908e987b6cb694(reversed) {
    return function(ol) {
        return function() {
            ol.reversed = reversed;
        };
    };
}
function $3b3250cec9f2e215$export$b3571188c770cc5a(ol) {
    return function() {
        return ol.start;
    };
}
function $3b3250cec9f2e215$export$b61b8b027b966010(start) {
    return function(ol) {
        return function() {
            ol.start = start;
        };
    };
}
function $3b3250cec9f2e215$export$d4a6a4db5b31e621(ol) {
    return function() {
        return ol.type;
    };
}
function $3b3250cec9f2e215$export$1bf7f05044e9c5cb(type) {
    return function(ol) {
        return function() {
            ol.type = type;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $e0ca6c403ecd27aa$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $e0ca6c403ecd27aa$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $e0ca6c403ecd27aa$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $e0ca6c403ecd27aa$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $e0ca6c403ecd27aa$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $e0ca6c403ecd27aa$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $e0ca6c403ecd27aa$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $e0ca6c403ecd27aa$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOListElement");
var $e0ca6c403ecd27aa$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOListElement");
var $e0ca6c403ecd27aa$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOListElement");
var $e0ca6c403ecd27aa$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOListElement");
var $e0ca6c403ecd27aa$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOListElement");
var $e0ca6c403ecd27aa$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOListElement");
var $e0ca6c403ecd27aa$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOListElement");


// Generated by purs version 0.15.16
function $9cb1784f60603b0a$export$70ac1efc5b13b551(object) {
    return function() {
        return object.data;
    };
}
function $9cb1784f60603b0a$export$3a6802af14bf5fa6(data) {
    return function(object) {
        return function() {
            object.data = data;
        };
    };
}
function $9cb1784f60603b0a$export$d4a6a4db5b31e621(object) {
    return function() {
        return object.type;
    };
}
function $9cb1784f60603b0a$export$1bf7f05044e9c5cb(type) {
    return function(object) {
        return function() {
            object.type = type;
        };
    };
}
function $9cb1784f60603b0a$export$dc0b74bdecf765a4(object) {
    return function() {
        return object.typeMustMatch;
    };
}
function $9cb1784f60603b0a$export$a8ff84c12d48cfa6(object) {
    return function() {
        return object.name;
    };
}
function $9cb1784f60603b0a$export$6cf3d710d3a367e5(name) {
    return function(object) {
        return function() {
            object.name = name;
        };
    };
}
function $9cb1784f60603b0a$export$86f8f9f08863e403(object) {
    return function() {
        return object.useMap;
    };
}
function $9cb1784f60603b0a$export$ab416bdbb887640e(useMap) {
    return function(object) {
        return function() {
            object.useMap = useMap;
        };
    };
}
function $9cb1784f60603b0a$export$242c63e9758836c2(object) {
    return function() {
        return object.form;
    };
}
function $9cb1784f60603b0a$export$7e3df82ee760448c(object) {
    return function() {
        return object.width;
    };
}
function $9cb1784f60603b0a$export$67f48e0594af05d(width) {
    return function(object) {
        return function() {
            object.width = width;
        };
    };
}
function $9cb1784f60603b0a$export$ac607276a8fe9f0a(object) {
    return function() {
        return object.height;
    };
}
function $9cb1784f60603b0a$export$3f31360357be44e4(height) {
    return function(object) {
        return function() {
            object.height = height;
        };
    };
}
function $9cb1784f60603b0a$export$a51825c89fe24f94(object) {
    return function() {
        return object.contentDocument;
    };
}
function $9cb1784f60603b0a$export$5e55a9e709e8e020(object) {
    return function() {
        return object.willValidate;
    };
}
function $9cb1784f60603b0a$export$1bdd3f9a89b22594(object) {
    return function() {
        return object.validity;
    };
}
function $9cb1784f60603b0a$export$6ee4201e37a931e2(object) {
    return function() {
        return object.validationMessage;
    };
}
function $9cb1784f60603b0a$export$50d70f8cedc54453(object) {
    return function() {
        return object.checkValidity();
    };
}
function $9cb1784f60603b0a$export$b962d864c477cc49(object) {
    return function() {
        return object.reportValidity();
    };
}
function $9cb1784f60603b0a$export$6f569cb704992105(value) {
    return function(object) {
        return function() {
            object.setCustomValidity(value);
        };
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $2f0197ed971bcaf7$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $2f0197ed971bcaf7$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $2f0197ed971bcaf7$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $2f0197ed971bcaf7$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $2f0197ed971bcaf7$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $2f0197ed971bcaf7$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $2f0197ed971bcaf7$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $2f0197ed971bcaf7$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $2f0197ed971bcaf7$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLObjectElement");
var $2f0197ed971bcaf7$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLObjectElement");
var $2f0197ed971bcaf7$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLObjectElement");
var $2f0197ed971bcaf7$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLObjectElement");
var $2f0197ed971bcaf7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLObjectElement");
var $2f0197ed971bcaf7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLObjectElement");
var $2f0197ed971bcaf7$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLObjectElement");
var $2f0197ed971bcaf7$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $2f0197ed971bcaf7$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($9cb1784f60603b0a$export$242c63e9758836c2($3));
    };
}();
var $2f0197ed971bcaf7$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $2f0197ed971bcaf7$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($9cb1784f60603b0a$export$a51825c89fe24f94($5));
    };
}();


// Generated by purs version 0.15.16
function $c5f7ef2476fdc396$export$683472f6198a076e(optgroup) {
    return function() {
        return optgroup.disabled;
    };
}
function $c5f7ef2476fdc396$export$4532d31cef66d703(disabled) {
    return function(optgroup) {
        return function() {
            optgroup.disabled = disabled;
        };
    };
}
function $c5f7ef2476fdc396$export$1237798dc640739a(optgroup) {
    return function() {
        return optgroup.label;
    };
}
function $c5f7ef2476fdc396$export$4f65e594f6031297(label) {
    return function(optgroup) {
        return function() {
            optgroup.label = label;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $a611e1933c9c221b$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $a611e1933c9c221b$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $a611e1933c9c221b$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $a611e1933c9c221b$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $a611e1933c9c221b$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $a611e1933c9c221b$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $a611e1933c9c221b$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $a611e1933c9c221b$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $a611e1933c9c221b$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $a611e1933c9c221b$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $a611e1933c9c221b$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $a611e1933c9c221b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $a611e1933c9c221b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $a611e1933c9c221b$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptGroupElement");


// Generated by purs version 0.15.16
function $7c1d1215ad6ce188$export$683472f6198a076e(option) {
    return function() {
        return option.disabled;
    };
}
function $7c1d1215ad6ce188$export$4532d31cef66d703(disabled) {
    return function(option) {
        return function() {
            option.disabled = disabled;
        };
    };
}
function $7c1d1215ad6ce188$export$242c63e9758836c2(option) {
    return function() {
        return option.form;
    };
}
function $7c1d1215ad6ce188$export$1237798dc640739a(option) {
    return function() {
        return option.label;
    };
}
function $7c1d1215ad6ce188$export$4f65e594f6031297(label) {
    return function(option) {
        return function() {
            option.label = label;
        };
    };
}
function $7c1d1215ad6ce188$export$63db087985f790e3(option) {
    return function() {
        return option.defaultSelected;
    };
}
function $7c1d1215ad6ce188$export$83d19b461d3b2ee7(defaultSelected) {
    return function(option) {
        return function() {
            option.defaultSelected = defaultSelected;
        };
    };
}
function $7c1d1215ad6ce188$export$d90250155de6d7e7(option) {
    return function() {
        return option.selected;
    };
}
function $7c1d1215ad6ce188$export$5a4818cec1656a71(selected) {
    return function(option) {
        return function() {
            option.selected = selected;
        };
    };
}
function $7c1d1215ad6ce188$export$2ab9a8f9f1186f14(option) {
    return function() {
        return option.value;
    };
}
function $7c1d1215ad6ce188$export$80746c6bc6142fc8(value) {
    return function(option) {
        return function() {
            option.value = value;
        };
    };
}
function $7c1d1215ad6ce188$export$6f093cfa640b7166(option) {
    return function() {
        return option.text;
    };
}
function $7c1d1215ad6ce188$export$cbe0d99836e1498f(text) {
    return function(option) {
        return function() {
            option.text = text;
        };
    };
}
function $7c1d1215ad6ce188$export$b610b8812bbcded9(option) {
    return function() {
        return option.index;
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $cb9622ff3a43c953$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $cb9622ff3a43c953$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $cb9622ff3a43c953$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $cb9622ff3a43c953$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $cb9622ff3a43c953$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $cb9622ff3a43c953$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $cb9622ff3a43c953$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $cb9622ff3a43c953$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptionElement");
var $cb9622ff3a43c953$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptionElement");
var $cb9622ff3a43c953$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptionElement");
var $cb9622ff3a43c953$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptionElement");
var $cb9622ff3a43c953$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptionElement");
var $cb9622ff3a43c953$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptionElement");
var $cb9622ff3a43c953$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOptionElement");
var $cb9622ff3a43c953$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $7FzSN.map($1rTTn.functorEffect)($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($7c1d1215ad6ce188$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $9196179ef50a2b80$export$242c63e9758836c2(output) {
    return function() {
        return output.form;
    };
}
function $9196179ef50a2b80$export$a8ff84c12d48cfa6(output) {
    return function() {
        return output.name;
    };
}
function $9196179ef50a2b80$export$6cf3d710d3a367e5(name) {
    return function(output) {
        return function() {
            output.name = name;
        };
    };
}
function $9196179ef50a2b80$export$d4a6a4db5b31e621(output) {
    return function() {
        return output.type;
    };
}
function $9196179ef50a2b80$export$1a01ae0705bafd37(output) {
    return function() {
        return output.defaultValue;
    };
}
function $9196179ef50a2b80$export$d8becbd7468e206f(defaultValue) {
    return function(output) {
        return function() {
            output.defaultValue = defaultValue;
        };
    };
}
function $9196179ef50a2b80$export$2ab9a8f9f1186f14(output) {
    return function() {
        return output.value;
    };
}
function $9196179ef50a2b80$export$80746c6bc6142fc8(value) {
    return function(output) {
        return function() {
            output.value = value;
        };
    };
}
function $9196179ef50a2b80$export$5e55a9e709e8e020(output) {
    return function() {
        return output.willValidate;
    };
}
function $9196179ef50a2b80$export$1bdd3f9a89b22594(output) {
    return function() {
        return output.validity;
    };
}
function $9196179ef50a2b80$export$6ee4201e37a931e2(output) {
    return function() {
        return output.validationMessage;
    };
}
function $9196179ef50a2b80$export$50d70f8cedc54453(output) {
    return function() {
        return output.checkValidity();
    };
}
function $9196179ef50a2b80$export$b962d864c477cc49(output) {
    return function() {
        return output.reportValidity();
    };
}
function $9196179ef50a2b80$export$6f569cb704992105(value) {
    return function(output) {
        return function() {
            output.setCustomValidity(value);
        };
    };
}
function $9196179ef50a2b80$export$a238cb463698c900(output) {
    return function() {
        return output.labels;
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $b458879ca65c3681$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $b458879ca65c3681$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $b458879ca65c3681$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $b458879ca65c3681$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $b458879ca65c3681$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $b458879ca65c3681$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $b458879ca65c3681$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $b458879ca65c3681$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOutputElement");
var $b458879ca65c3681$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOutputElement");
var $b458879ca65c3681$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOutputElement");
var $b458879ca65c3681$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOutputElement");
var $b458879ca65c3681$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOutputElement");
var $b458879ca65c3681$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOutputElement");
var $b458879ca65c3681$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLOutputElement");
var $b458879ca65c3681$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $7FzSN.map($1rTTn.functorEffect)($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($9196179ef50a2b80$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $c09c6c8f5c5734a0$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $c09c6c8f5c5734a0$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $c09c6c8f5c5734a0$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $c09c6c8f5c5734a0$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $c09c6c8f5c5734a0$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $c09c6c8f5c5734a0$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $c09c6c8f5c5734a0$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $c09c6c8f5c5734a0$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParagraphElement");
var $c09c6c8f5c5734a0$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParagraphElement");
var $c09c6c8f5c5734a0$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParagraphElement");
var $c09c6c8f5c5734a0$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParagraphElement");
var $c09c6c8f5c5734a0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParagraphElement");
var $c09c6c8f5c5734a0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParagraphElement");
var $c09c6c8f5c5734a0$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParagraphElement");


// Generated by purs version 0.15.16
function $de8db4459a0d165a$export$a8ff84c12d48cfa6(param) {
    return function() {
        return param.name;
    };
}
function $de8db4459a0d165a$export$6cf3d710d3a367e5(name) {
    return function(param) {
        return function() {
            param.name = name;
        };
    };
}
function $de8db4459a0d165a$export$2ab9a8f9f1186f14(param) {
    return function() {
        return param.value;
    };
}
function $de8db4459a0d165a$export$80746c6bc6142fc8(value) {
    return function(param) {
        return function() {
            param.value = value;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $dd72bab594515dbc$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $dd72bab594515dbc$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $dd72bab594515dbc$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $dd72bab594515dbc$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $dd72bab594515dbc$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $dd72bab594515dbc$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $dd72bab594515dbc$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $dd72bab594515dbc$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParamElement");
var $dd72bab594515dbc$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParamElement");
var $dd72bab594515dbc$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParamElement");
var $dd72bab594515dbc$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParamElement");
var $dd72bab594515dbc$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParamElement");
var $dd72bab594515dbc$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParamElement");
var $dd72bab594515dbc$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLParamElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $29031bf619a906ee$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $29031bf619a906ee$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $29031bf619a906ee$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $29031bf619a906ee$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $29031bf619a906ee$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $29031bf619a906ee$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $29031bf619a906ee$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $29031bf619a906ee$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLPreElement");
var $29031bf619a906ee$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLPreElement");
var $29031bf619a906ee$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLPreElement");
var $29031bf619a906ee$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLPreElement");
var $29031bf619a906ee$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLPreElement");
var $29031bf619a906ee$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLPreElement");
var $29031bf619a906ee$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLPreElement");


// Generated by purs version 0.15.16
function $d16c63d16029ec3f$export$2ab9a8f9f1186f14(progress) {
    return function() {
        return progress.value;
    };
}
function $d16c63d16029ec3f$export$80746c6bc6142fc8(value) {
    return function(progress) {
        return function() {
            progress.value = value;
        };
    };
}
function $d16c63d16029ec3f$export$8960430cfd85939f(progress) {
    return function() {
        return progress.max;
    };
}
function $d16c63d16029ec3f$export$b03015b7eb8a4a0d(max) {
    return function(progress) {
        return function() {
            progress.max = max;
        };
    };
}
function $d16c63d16029ec3f$export$5880b8b5730aff45(progress) {
    return function() {
        return progress.position;
    };
}
function $d16c63d16029ec3f$export$a238cb463698c900(progress) {
    return function() {
        return progress.labels;
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $9b6dc1cd8f8d5bc0$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $9b6dc1cd8f8d5bc0$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $9b6dc1cd8f8d5bc0$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $9b6dc1cd8f8d5bc0$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $9b6dc1cd8f8d5bc0$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $9b6dc1cd8f8d5bc0$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $9b6dc1cd8f8d5bc0$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $9b6dc1cd8f8d5bc0$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLProgressElement");
var $9b6dc1cd8f8d5bc0$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLProgressElement");
var $9b6dc1cd8f8d5bc0$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLProgressElement");
var $9b6dc1cd8f8d5bc0$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLProgressElement");
var $9b6dc1cd8f8d5bc0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLProgressElement");
var $9b6dc1cd8f8d5bc0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLProgressElement");
var $9b6dc1cd8f8d5bc0$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLProgressElement");


// Generated by purs version 0.15.16
function $e4b272ff651eaa17$export$3035df57df42c31a(quote) {
    return function() {
        return quote.cite;
    };
}
function $e4b272ff651eaa17$export$86262a2b9f03fae3(cite) {
    return function(quote) {
        return function() {
            quote.cite = cite;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $5fd76a5b1661c7b2$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $5fd76a5b1661c7b2$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $5fd76a5b1661c7b2$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $5fd76a5b1661c7b2$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $5fd76a5b1661c7b2$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $5fd76a5b1661c7b2$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $5fd76a5b1661c7b2$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $5fd76a5b1661c7b2$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5fd76a5b1661c7b2$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5fd76a5b1661c7b2$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5fd76a5b1661c7b2$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5fd76a5b1661c7b2$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5fd76a5b1661c7b2$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5fd76a5b1661c7b2$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLQuoteElement");


// Generated by purs version 0.15.16
function $10a29b971316c16e$export$2e40c9e35e9506f4(script) {
    return function() {
        return script.src;
    };
}
function $10a29b971316c16e$export$5771e3a4c80da7df(src) {
    return function(script) {
        return function() {
            script.src = src;
        };
    };
}
function $10a29b971316c16e$export$d4a6a4db5b31e621(script) {
    return function() {
        return script.type;
    };
}
function $10a29b971316c16e$export$1bf7f05044e9c5cb(type) {
    return function(script) {
        return function() {
            script.type = type;
        };
    };
}
function $10a29b971316c16e$export$e4c823724462c3fd(script) {
    return function() {
        return script.charset;
    };
}
function $10a29b971316c16e$export$61ed102e375c8bae(charset) {
    return function(script) {
        return function() {
            script.charset = charset;
        };
    };
}
function $10a29b971316c16e$export$12af436354f1a4f7(script) {
    return function() {
        return script.async;
    };
}
function $10a29b971316c16e$export$8ed1e1e4b75b53c6(async) {
    return function(script) {
        return function() {
            script.async = async;
        };
    };
}
function $10a29b971316c16e$export$260e5c0943f31606(script) {
    return function() {
        return script.defer;
    };
}
function $10a29b971316c16e$export$d440c7f1383ddd12(defer) {
    return function(script) {
        return function() {
            script.defer = defer;
        };
    };
}
function $10a29b971316c16e$export$c47cb7c63271266e(script) {
    return function() {
        return script.crossOrigin;
    };
}
function $10a29b971316c16e$export$e7fd69f64f92856(crossOrigin) {
    return function(script) {
        return function() {
            script.crossOrigin = crossOrigin;
        };
    };
}
function $10a29b971316c16e$export$6f093cfa640b7166(script) {
    return function() {
        return script.text;
    };
}
function $10a29b971316c16e$export$cbe0d99836e1498f(text) {
    return function(script) {
        return function() {
            script.text = text;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $e690794b947cb343$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $e690794b947cb343$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $e690794b947cb343$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $e690794b947cb343$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $e690794b947cb343$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $e690794b947cb343$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $e690794b947cb343$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $e690794b947cb343$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLScriptElement");
var $e690794b947cb343$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLScriptElement");
var $e690794b947cb343$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLScriptElement");
var $e690794b947cb343$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLScriptElement");
var $e690794b947cb343$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLScriptElement");
var $e690794b947cb343$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLScriptElement");
var $e690794b947cb343$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLScriptElement");


// Generated by purs version 0.15.16
function $3962a5907f5c04a9$export$4c47992fc278c9a0(select) {
    return function() {
        return select.autofocus;
    };
}
function $3962a5907f5c04a9$export$db2bbdcbda3d335e(autofocus) {
    return function(select) {
        return function() {
            select.autofocus = autofocus;
        };
    };
}
function $3962a5907f5c04a9$export$683472f6198a076e(select) {
    return function() {
        return select.disabled;
    };
}
function $3962a5907f5c04a9$export$4532d31cef66d703(disabled) {
    return function(select) {
        return function() {
            select.disabled = disabled;
        };
    };
}
function $3962a5907f5c04a9$export$939ddaa3205df08e(select) {
    return function() {
        return select.multiple;
    };
}
function $3962a5907f5c04a9$export$be7c7381b31f2269(multiple) {
    return function(select) {
        return function() {
            select.multiple = multiple;
        };
    };
}
function $3962a5907f5c04a9$export$242c63e9758836c2(select) {
    return function() {
        return select.form;
    };
}
function $3962a5907f5c04a9$export$a8ff84c12d48cfa6(select) {
    return function() {
        return select.name;
    };
}
function $3962a5907f5c04a9$export$6cf3d710d3a367e5(name) {
    return function(select) {
        return function() {
            select.name = name;
        };
    };
}
function $3962a5907f5c04a9$export$a7a0278c004aac3f(select) {
    return function() {
        return select.required;
    };
}
function $3962a5907f5c04a9$export$47f9362469f346c4(required) {
    return function(select) {
        return function() {
            select.required = required;
        };
    };
}
function $3962a5907f5c04a9$export$346677f925de839c(select) {
    return function() {
        return select.size;
    };
}
function $3962a5907f5c04a9$export$1c70a6cc12bc0366(size) {
    return function(select) {
        return function() {
            select.size = size;
        };
    };
}
function $3962a5907f5c04a9$export$d4a6a4db5b31e621(select) {
    return function() {
        return select.type;
    };
}
function $3962a5907f5c04a9$export$f24224f1c91d8156(select) {
    return function() {
        return select.length;
    };
}
function $3962a5907f5c04a9$export$e37a2cb6f0a9cac9(length) {
    return function(select) {
        return function() {
            select.length = length;
        };
    };
}
function $3962a5907f5c04a9$export$b0ea99e7ae5aed6c(select) {
    return function() {
        return select.selectedOptions;
    };
}
function $3962a5907f5c04a9$export$9ea87e299ff6a368(select) {
    return function() {
        return select.selectedIndex;
    };
}
function $3962a5907f5c04a9$export$940820044e1b4923(selectedIndex) {
    return function(select) {
        return function() {
            select.selectedIndex = selectedIndex;
        };
    };
}
function $3962a5907f5c04a9$export$2ab9a8f9f1186f14(select) {
    return function() {
        return select.value;
    };
}
function $3962a5907f5c04a9$export$80746c6bc6142fc8(value) {
    return function(select) {
        return function() {
            select.value = value;
        };
    };
}
function $3962a5907f5c04a9$export$5e55a9e709e8e020(select) {
    return function() {
        return select.willValidate;
    };
}
function $3962a5907f5c04a9$export$1bdd3f9a89b22594(select) {
    return function() {
        return select.validity;
    };
}
function $3962a5907f5c04a9$export$6ee4201e37a931e2(select) {
    return function() {
        return select.validationMessage;
    };
}
function $3962a5907f5c04a9$export$50d70f8cedc54453(select) {
    return function() {
        return select.checkValidity();
    };
}
function $3962a5907f5c04a9$export$b962d864c477cc49(select) {
    return function() {
        return select.reportValidity();
    };
}
function $3962a5907f5c04a9$export$6f569cb704992105(value) {
    return function(select) {
        return function() {
            select.setCustomValidity(value);
        };
    };
}
function $3962a5907f5c04a9$export$a238cb463698c900(select) {
    return function() {
        return select.labels;
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $7accabc18951a097$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $7accabc18951a097$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $7accabc18951a097$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $7accabc18951a097$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $7accabc18951a097$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $7accabc18951a097$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $7accabc18951a097$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $7accabc18951a097$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSelectElement");
var $7accabc18951a097$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSelectElement");
var $7accabc18951a097$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSelectElement");
var $7accabc18951a097$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSelectElement");
var $7accabc18951a097$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSelectElement");
var $7accabc18951a097$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSelectElement");
var $7accabc18951a097$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSelectElement");
var $7accabc18951a097$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $7FzSN.map($1rTTn.functorEffect)($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($3962a5907f5c04a9$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $c275756d6987d92e$export$2e40c9e35e9506f4(source) {
    return function() {
        return source.src;
    };
}
function $c275756d6987d92e$export$5771e3a4c80da7df(src) {
    return function(source) {
        return function() {
            source.src = src;
        };
    };
}
function $c275756d6987d92e$export$d4a6a4db5b31e621(source) {
    return function() {
        return source.type;
    };
}
function $c275756d6987d92e$export$1bf7f05044e9c5cb(type) {
    return function(source) {
        return function() {
            source.type = type;
        };
    };
}
function $c275756d6987d92e$export$987d49ffe1b0900f(source) {
    return function() {
        return source.media;
    };
}
function $c275756d6987d92e$export$5c1855deea651e41(media) {
    return function(source) {
        return function() {
            source.media = media;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $3aaebef85a946a45$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $3aaebef85a946a45$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $3aaebef85a946a45$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $3aaebef85a946a45$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $3aaebef85a946a45$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $3aaebef85a946a45$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $3aaebef85a946a45$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $3aaebef85a946a45$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSourceElement");
var $3aaebef85a946a45$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSourceElement");
var $3aaebef85a946a45$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSourceElement");
var $3aaebef85a946a45$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSourceElement");
var $3aaebef85a946a45$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSourceElement");
var $3aaebef85a946a45$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSourceElement");
var $3aaebef85a946a45$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSourceElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $8f3268f902847de8$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $8f3268f902847de8$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $8f3268f902847de8$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $8f3268f902847de8$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $8f3268f902847de8$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $8f3268f902847de8$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $8f3268f902847de8$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $8f3268f902847de8$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSpanElement");
var $8f3268f902847de8$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSpanElement");
var $8f3268f902847de8$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSpanElement");
var $8f3268f902847de8$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSpanElement");
var $8f3268f902847de8$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSpanElement");
var $8f3268f902847de8$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSpanElement");
var $8f3268f902847de8$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLSpanElement");


// Generated by purs version 0.15.16
function $eaa855c131dc34e2$export$987d49ffe1b0900f(style) {
    return function() {
        return style.media;
    };
}
function $eaa855c131dc34e2$export$5c1855deea651e41(media) {
    return function(style) {
        return function() {
            style.media = media;
        };
    };
}
function $eaa855c131dc34e2$export$d4a6a4db5b31e621(style) {
    return function() {
        return style.type;
    };
}
function $eaa855c131dc34e2$export$1bf7f05044e9c5cb(type) {
    return function(style) {
        return function() {
            style.type = type;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $2fa29a549ae25bfd$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $2fa29a549ae25bfd$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $2fa29a549ae25bfd$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $2fa29a549ae25bfd$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $2fa29a549ae25bfd$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $2fa29a549ae25bfd$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $2fa29a549ae25bfd$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $2fa29a549ae25bfd$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLStyleElement");
var $2fa29a549ae25bfd$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLStyleElement");
var $2fa29a549ae25bfd$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLStyleElement");
var $2fa29a549ae25bfd$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLStyleElement");
var $2fa29a549ae25bfd$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLStyleElement");
var $2fa29a549ae25bfd$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLStyleElement");
var $2fa29a549ae25bfd$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLStyleElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $0aa48e2545166111$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $0aa48e2545166111$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $0aa48e2545166111$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $0aa48e2545166111$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $0aa48e2545166111$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $0aa48e2545166111$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $0aa48e2545166111$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $0aa48e2545166111$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $0aa48e2545166111$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $0aa48e2545166111$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $0aa48e2545166111$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $0aa48e2545166111$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $0aa48e2545166111$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $0aa48e2545166111$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCaptionElement");


// Generated by purs version 0.15.16
function $7e50c30ab24574e2$export$47be69ffacd0da98(cell) {
    return function() {
        return cell.colSpan;
    };
}
function $7e50c30ab24574e2$export$41feea65f12f6ad6(colSpan) {
    return function(cell) {
        return function() {
            cell.colSpan = colSpan;
        };
    };
}
function $7e50c30ab24574e2$export$a5ce0649174d616e(cell) {
    return function() {
        return cell.rowSpan;
    };
}
function $7e50c30ab24574e2$export$1f37716400d14942(rowSpan) {
    return function(cell) {
        return function() {
            cell.rowSpan = rowSpan;
        };
    };
}
function $7e50c30ab24574e2$export$b507ffb2fd978043(cell) {
    return function() {
        return cell.cellIndex;
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $d1e0f145595e75e1$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $d1e0f145595e75e1$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $d1e0f145595e75e1$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $d1e0f145595e75e1$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $d1e0f145595e75e1$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $d1e0f145595e75e1$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $d1e0f145595e75e1$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $d1e0f145595e75e1$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCellElement");
var $d1e0f145595e75e1$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCellElement");
var $d1e0f145595e75e1$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCellElement");
var $d1e0f145595e75e1$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCellElement");
var $d1e0f145595e75e1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCellElement");
var $d1e0f145595e75e1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCellElement");
var $d1e0f145595e75e1$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableCellElement");


// Generated by purs version 0.15.16
function $a59bfcb3648da5c9$export$afc1bfabebaf28a2(col) {
    return function() {
        return col.span;
    };
}
function $a59bfcb3648da5c9$export$8ab2f2e6ee8ed0a8(span) {
    return function(col) {
        return function() {
            col.span = span;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $068bbd0b3c05c4b0$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $068bbd0b3c05c4b0$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $068bbd0b3c05c4b0$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $068bbd0b3c05c4b0$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $068bbd0b3c05c4b0$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $068bbd0b3c05c4b0$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $068bbd0b3c05c4b0$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $068bbd0b3c05c4b0$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableColElement");
var $068bbd0b3c05c4b0$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableColElement");
var $068bbd0b3c05c4b0$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableColElement");
var $068bbd0b3c05c4b0$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableColElement");
var $068bbd0b3c05c4b0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableColElement");
var $068bbd0b3c05c4b0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableColElement");
var $068bbd0b3c05c4b0$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableColElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $c12f0870c106e173$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $c12f0870c106e173$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $c12f0870c106e173$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $c12f0870c106e173$export$619123619593c03d = $k2DSm.unsafeCoerce;
var $c12f0870c106e173$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $c12f0870c106e173$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $c12f0870c106e173$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $c12f0870c106e173$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $c12f0870c106e173$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $c12f0870c106e173$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $c12f0870c106e173$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $c12f0870c106e173$export$7b01868159b235fe = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $c12f0870c106e173$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $c12f0870c106e173$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $c12f0870c106e173$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $c12f0870c106e173$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableDataCellElement");


// Generated by purs version 0.15.16
function $7c0e243fda664936$export$b815d8b2ae8b8a8f(table) {
    return function() {
        return table.caption;
    };
}
function $7c0e243fda664936$export$c1cd099bccef98fe(caption) {
    return function(table) {
        return function() {
            table.caption = caption;
        };
    };
}
function $7c0e243fda664936$export$690474d079e8aee0(table) {
    return function() {
        return table.createCaption();
    };
}
function $7c0e243fda664936$export$2f169497140e8e8c(table) {
    return function() {
        table.deleteCaption();
    };
}
function $7c0e243fda664936$export$75d2083daf0d4c8(table) {
    return function() {
        return table.tHead;
    };
}
function $7c0e243fda664936$export$accedb93377ebcb2(tHead) {
    return function(table) {
        return function() {
            table.tHead = tHead;
        };
    };
}
function $7c0e243fda664936$export$8e9dedfded1540ee(table) {
    return function() {
        return table.createTHead();
    };
}
function $7c0e243fda664936$export$c28532ed8fc4a976(table) {
    return function() {
        table.deleteTHead();
    };
}
function $7c0e243fda664936$export$6c9b4fbde50fbc0f(table) {
    return function() {
        return table.tFoot;
    };
}
function $7c0e243fda664936$export$10a8938b95fbdb4(tFoot) {
    return function(table) {
        return function() {
            table.tFoot = tFoot;
        };
    };
}
function $7c0e243fda664936$export$ab9f248e0049bb9d(table) {
    return function() {
        return table.createTFoot();
    };
}
function $7c0e243fda664936$export$3c3cb2a6af70fe52(table) {
    return function() {
        table.deleteTFoot();
    };
}
function $7c0e243fda664936$export$c63586cd99d53eee(table) {
    return function() {
        return table.tBodies;
    };
}
function $7c0e243fda664936$export$76a5bd1e5d516e91(table) {
    return function() {
        return table.createTBody();
    };
}
function $7c0e243fda664936$export$2dd197b55cf13440(table) {
    return function() {
        return table.rows;
    };
}
function $7c0e243fda664936$export$281b3c86eeab738f(index) {
    return function(table) {
        return function() {
            return table.insertRow(index);
        };
    };
}
function $7c0e243fda664936$export$2ef39e5ffdaff9ed(index) {
    return function(table) {
        return function() {
            table.deleteRow(index);
        };
    };
}
function $7c0e243fda664936$export$1edee58a52776cd9(table) {
    return function() {
        return table.border;
    };
}
function $7c0e243fda664936$export$df6de19f3e6baa52(border) {
    return function(table) {
        return function() {
            table.border = border;
        };
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $44358050f2bb010a$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $44358050f2bb010a$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $44358050f2bb010a$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $44358050f2bb010a$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $44358050f2bb010a$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $44358050f2bb010a$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $44358050f2bb010a$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $44358050f2bb010a$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $44358050f2bb010a$export$8ffb9307dee41683 = /* #__PURE__ */ function() {
    var $3 = $44358050f2bb010a$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($4) {
        return $3($7c0e243fda664936$export$75d2083daf0d4c8($4));
    };
}();
var $44358050f2bb010a$export$4ce044d081650b4 = /* #__PURE__ */ function() {
    var $5 = $44358050f2bb010a$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($6) {
        return $5($7c0e243fda664936$export$6c9b4fbde50fbc0f($6));
    };
}();
var $44358050f2bb010a$export$73c0abfa2c0e52e4 = function($7) {
    return $7c0e243fda664936$export$accedb93377ebcb2($ae4217dcc85a7c03$export$b187f57ee1822bc5($7));
};
var $44358050f2bb010a$export$1350b3df0623f8d7 = function($8) {
    return $7c0e243fda664936$export$10a8938b95fbdb4($ae4217dcc85a7c03$export$b187f57ee1822bc5($8));
};
var $44358050f2bb010a$export$c972b85f531b9f41 = function($9) {
    return $7c0e243fda664936$export$c1cd099bccef98fe($ae4217dcc85a7c03$export$b187f57ee1822bc5($9));
};
var $44358050f2bb010a$export$6f91cb21ef21b608 = $7c0e243fda664936$export$281b3c86eeab738f;
var $44358050f2bb010a$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $44358050f2bb010a$export$6f91cb21ef21b608(-1);
}();
var $44358050f2bb010a$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableElement");
var $44358050f2bb010a$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableElement");
var $44358050f2bb010a$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableElement");
var $44358050f2bb010a$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableElement");
var $44358050f2bb010a$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableElement");
var $44358050f2bb010a$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableElement");
var $44358050f2bb010a$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableElement");
var $44358050f2bb010a$export$8e3c2dfdc4f0453d = /* #__PURE__ */ function() {
    var $10 = $44358050f2bb010a$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($11) {
        return $10($7c0e243fda664936$export$b815d8b2ae8b8a8f($11));
    };
}();


// Generated by purs version 0.15.16
function $19b39728b715942b$export$5cff813ca8e50db9(cell) {
    return function() {
        return cell.scope;
    };
}
function $19b39728b715942b$export$d9e5239df8f952de(scope) {
    return function(cell) {
        return function() {
            cell.scope = scope;
        };
    };
}
function $19b39728b715942b$export$2bcb785951133fe5(cell) {
    return function() {
        return cell.abbr;
    };
}
function $19b39728b715942b$export$4b75111ed99261c8(abbr) {
    return function(cell) {
        return function() {
            cell.abbr = abbr;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $b98e088de73bcf40$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $b98e088de73bcf40$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $b98e088de73bcf40$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $b98e088de73bcf40$export$619123619593c03d = $k2DSm.unsafeCoerce;
var $b98e088de73bcf40$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $b98e088de73bcf40$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $b98e088de73bcf40$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $b98e088de73bcf40$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $b98e088de73bcf40$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $b98e088de73bcf40$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $b98e088de73bcf40$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $b98e088de73bcf40$export$7b01868159b235fe = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $b98e088de73bcf40$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $b98e088de73bcf40$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $b98e088de73bcf40$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $b98e088de73bcf40$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");


// Generated by purs version 0.15.16
function $b2d6b302fed1b7a9$export$f6e5b2c929a2f19d(row) {
    return function() {
        return row.rowIndex;
    };
}
function $b2d6b302fed1b7a9$export$11d8b50a98496a38(row) {
    return function() {
        return row.sectionRowIndex;
    };
}
function $b2d6b302fed1b7a9$export$57ba6370ea0e47f8(row) {
    return function() {
        return row.cells;
    };
}
function $b2d6b302fed1b7a9$export$96a7dd0d30a5e7fe(index) {
    return function(row) {
        return function() {
            return row.insertCell(index);
        };
    };
}
function $b2d6b302fed1b7a9$export$6e37d353cc5629c9(index) {
    return function(row) {
        return function() {
            row.deleteCell(index);
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $a45d07797626cde2$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $a45d07797626cde2$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $a45d07797626cde2$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $a45d07797626cde2$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $a45d07797626cde2$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $a45d07797626cde2$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $a45d07797626cde2$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $a45d07797626cde2$export$27b66c5ce67ee025 = $b2d6b302fed1b7a9$export$96a7dd0d30a5e7fe;
var $a45d07797626cde2$export$51965e0a3b80eb5c = /* #__PURE__ */ function() {
    return $a45d07797626cde2$export$27b66c5ce67ee025(-1);
}();
var $a45d07797626cde2$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableRowElement");
var $a45d07797626cde2$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableRowElement");
var $a45d07797626cde2$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableRowElement");
var $a45d07797626cde2$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableRowElement");
var $a45d07797626cde2$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableRowElement");
var $a45d07797626cde2$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableRowElement");
var $a45d07797626cde2$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableRowElement");


// Generated by purs version 0.15.16
function $1fda0beed57c33e7$export$2dd197b55cf13440(section) {
    return function() {
        return section.rows;
    };
}
function $1fda0beed57c33e7$export$281b3c86eeab738f(index) {
    return function(section) {
        return function() {
            return section.insertRow(index);
        };
    };
}
function $1fda0beed57c33e7$export$2ef39e5ffdaff9ed(index) {
    return function(section) {
        return function() {
            section.deleteRow(index);
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $2165f93b5413fb0b$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $2165f93b5413fb0b$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $2165f93b5413fb0b$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $2165f93b5413fb0b$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $2165f93b5413fb0b$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $2165f93b5413fb0b$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $2165f93b5413fb0b$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $2165f93b5413fb0b$export$6f91cb21ef21b608 = $1fda0beed57c33e7$export$281b3c86eeab738f;
var $2165f93b5413fb0b$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $2165f93b5413fb0b$export$6f91cb21ef21b608(-1);
}();
var $2165f93b5413fb0b$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $2165f93b5413fb0b$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $2165f93b5413fb0b$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $2165f93b5413fb0b$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $2165f93b5413fb0b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $2165f93b5413fb0b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $2165f93b5413fb0b$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTableSectionElement");


// Generated by purs version 0.15.16
function $879c7f4c69452bb9$export$a7db06668cad9adb(template) {
    return function() {
        return template.content;
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $79a1cd91426153c7$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $79a1cd91426153c7$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $79a1cd91426153c7$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $79a1cd91426153c7$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $79a1cd91426153c7$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $79a1cd91426153c7$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $79a1cd91426153c7$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $79a1cd91426153c7$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTemplateElement");
var $79a1cd91426153c7$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTemplateElement");
var $79a1cd91426153c7$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTemplateElement");
var $79a1cd91426153c7$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTemplateElement");
var $79a1cd91426153c7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTemplateElement");
var $79a1cd91426153c7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTemplateElement");
var $79a1cd91426153c7$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTemplateElement");


// Generated by purs version 0.15.16
function $9493373e93916322$export$485ded5f26ebe08d(textarea) {
    return function() {
        return textarea.autocomplete;
    };
}
function $9493373e93916322$export$5fb7c729919301a5(autocomplete) {
    return function(textarea) {
        return function() {
            textarea.autocomplete = autocomplete;
        };
    };
}
function $9493373e93916322$export$4c47992fc278c9a0(textarea) {
    return function() {
        return textarea.autofocus;
    };
}
function $9493373e93916322$export$db2bbdcbda3d335e(autofocus) {
    return function(textarea) {
        return function() {
            textarea.autofocus = autofocus;
        };
    };
}
function $9493373e93916322$export$1eebcb1e706ab348(textarea) {
    return function() {
        return textarea.cols;
    };
}
function $9493373e93916322$export$3df203352cd8517(cols) {
    return function(textarea) {
        return function() {
            textarea.cols = cols;
        };
    };
}
function $9493373e93916322$export$9ebb36ddc946da55(textarea) {
    return function() {
        return textarea.dirName;
    };
}
function $9493373e93916322$export$e2460e55089b163d(dirName) {
    return function(textarea) {
        return function() {
            textarea.dirName = dirName;
        };
    };
}
function $9493373e93916322$export$683472f6198a076e(textarea) {
    return function() {
        return textarea.disabled;
    };
}
function $9493373e93916322$export$4532d31cef66d703(disabled) {
    return function(textarea) {
        return function() {
            textarea.disabled = disabled;
        };
    };
}
function $9493373e93916322$export$242c63e9758836c2(textarea) {
    return function() {
        return textarea.form;
    };
}
function $9493373e93916322$export$c9f461152c658a8b(textarea) {
    return function() {
        return textarea.maxLength;
    };
}
function $9493373e93916322$export$45077a575ddd961f(maxLength) {
    return function(textarea) {
        return function() {
            textarea.maxLength = maxLength;
        };
    };
}
function $9493373e93916322$export$8fe860a115a1e636(textarea) {
    return function() {
        return textarea.minLength;
    };
}
function $9493373e93916322$export$2b867239766ba1e3(minLength) {
    return function(textarea) {
        return function() {
            textarea.minLength = minLength;
        };
    };
}
function $9493373e93916322$export$a8ff84c12d48cfa6(textarea) {
    return function() {
        return textarea.name;
    };
}
function $9493373e93916322$export$6cf3d710d3a367e5(name) {
    return function(textarea) {
        return function() {
            textarea.name = name;
        };
    };
}
function $9493373e93916322$export$c7187bbd1a7a9244(textarea) {
    return function() {
        return textarea.placeholder;
    };
}
function $9493373e93916322$export$645bf5697adfa088(placeholder) {
    return function(textarea) {
        return function() {
            textarea.placeholder = placeholder;
        };
    };
}
function $9493373e93916322$export$b2cbc93d4da94977(textarea) {
    return function() {
        return textarea.readOnly;
    };
}
function $9493373e93916322$export$62311ce54ddfc862(readOnly) {
    return function(textarea) {
        return function() {
            textarea.readOnly = readOnly;
        };
    };
}
function $9493373e93916322$export$a7a0278c004aac3f(textarea) {
    return function() {
        return textarea.required;
    };
}
function $9493373e93916322$export$47f9362469f346c4(required) {
    return function(textarea) {
        return function() {
            textarea.required = required;
        };
    };
}
function $9493373e93916322$export$2dd197b55cf13440(textarea) {
    return function() {
        return textarea.rows;
    };
}
function $9493373e93916322$export$f2d998961118057a(rows) {
    return function(textarea) {
        return function() {
            textarea.rows = rows;
        };
    };
}
function $9493373e93916322$export$4997ffc0176396a6(textarea) {
    return function() {
        return textarea.wrap;
    };
}
function $9493373e93916322$export$696447b714acda6d(wrap) {
    return function(textarea) {
        return function() {
            textarea.wrap = wrap;
        };
    };
}
function $9493373e93916322$export$d4a6a4db5b31e621(textarea) {
    return function() {
        return textarea.type;
    };
}
function $9493373e93916322$export$1a01ae0705bafd37(textarea) {
    return function() {
        return textarea.defaultValue;
    };
}
function $9493373e93916322$export$d8becbd7468e206f(defaultValue) {
    return function(textarea) {
        return function() {
            textarea.defaultValue = defaultValue;
        };
    };
}
function $9493373e93916322$export$2ab9a8f9f1186f14(textarea) {
    return function() {
        return textarea.value;
    };
}
function $9493373e93916322$export$80746c6bc6142fc8(value) {
    return function(textarea) {
        return function() {
            textarea.value = value;
        };
    };
}
function $9493373e93916322$export$6f846043e306f02c(textarea) {
    return function() {
        return textarea.textLength;
    };
}
function $9493373e93916322$export$5e55a9e709e8e020(textarea) {
    return function() {
        return textarea.willValidate;
    };
}
function $9493373e93916322$export$1bdd3f9a89b22594(textarea) {
    return function() {
        return textarea.validity;
    };
}
function $9493373e93916322$export$6ee4201e37a931e2(textarea) {
    return function() {
        return textarea.validationMessage;
    };
}
function $9493373e93916322$export$50d70f8cedc54453(textarea) {
    return function() {
        return textarea.checkValidity();
    };
}
function $9493373e93916322$export$b962d864c477cc49(textarea) {
    return function() {
        return textarea.reportValidity();
    };
}
function $9493373e93916322$export$6f569cb704992105(value) {
    return function(textarea) {
        return function() {
            textarea.setCustomValidity(value);
        };
    };
}
function $9493373e93916322$export$a238cb463698c900(textarea) {
    return function() {
        return textarea.labels;
    };
}
function $9493373e93916322$export$2e6c959c16ff56b8(textarea) {
    return function() {
        textarea.select();
    };
}
function $9493373e93916322$export$5e2f617ae845fb63(textarea) {
    return function() {
        return textarea.selectionStart;
    };
}
function $9493373e93916322$export$47b9c21811f199bd(selectionStart) {
    return function(textarea) {
        return function() {
            textarea.selectionStart = selectionStart;
        };
    };
}
function $9493373e93916322$export$1028be563f1155b2(textarea) {
    return function() {
        return textarea.selectionEnd;
    };
}
function $9493373e93916322$export$15d012c6be3c352(selectionEnd) {
    return function(textarea) {
        return function() {
            textarea.selectionEnd = selectionEnd;
        };
    };
}
function $9493373e93916322$export$b4e8aad052258154(textarea) {
    return function() {
        return textarea.selectionDirection;
    };
}
function $9493373e93916322$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(textarea) {
        return function() {
            textarea.selectionDirection = selectionDirection;
        };
    };
}
function $9493373e93916322$export$2add2a46d1c1d557(replacement) {
    return function(textarea) {
        return function() {
            textarea.setRangeText(replacement);
        };
    };
}
function $9493373e93916322$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $9493373e93916322$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(textarea) {
                return function() {
                    textarea.setSelectionRange(start, end, direction);
                };
            };
        };
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");


var $0f26efd986a90d92$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $0f26efd986a90d92$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $0f26efd986a90d92$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $0f26efd986a90d92$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $0f26efd986a90d92$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $0f26efd986a90d92$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $0f26efd986a90d92$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $0f26efd986a90d92$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $9493373e93916322$export$309b5632e9b49193(rpl, s, e, $8bc3da0ac9f8818e$export$c2d084dc44961371(mode), area);
                    };
                };
            };
        };
    };
};
var $0f26efd986a90d92$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $0f26efd986a90d92$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $0f26efd986a90d92$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $0f26efd986a90d92$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $0f26efd986a90d92$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $0f26efd986a90d92$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $0f26efd986a90d92$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $0f26efd986a90d92$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $7FzSN.map($1rTTn.functorEffect)($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($9493373e93916322$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $f36a7555966ddbda$export$3a17bddce263fba0(time) {
    return function() {
        return time.dateTime;
    };
}
function $f36a7555966ddbda$export$3a84b9eda98e95dc(dateTime) {
    return function(time) {
        return function() {
            time.dateTime = dateTime;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $f0019546fcff0eea$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $f0019546fcff0eea$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $f0019546fcff0eea$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $f0019546fcff0eea$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $f0019546fcff0eea$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $f0019546fcff0eea$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $f0019546fcff0eea$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $f0019546fcff0eea$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTimeElement");
var $f0019546fcff0eea$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTimeElement");
var $f0019546fcff0eea$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTimeElement");
var $f0019546fcff0eea$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTimeElement");
var $f0019546fcff0eea$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTimeElement");
var $f0019546fcff0eea$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTimeElement");
var $f0019546fcff0eea$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTimeElement");


// Generated by purs version 0.15.16
function $92f7b293b3d22858$export$6f093cfa640b7166(title) {
    return function() {
        return title.text;
    };
}
function $92f7b293b3d22858$export$cbe0d99836e1498f(text) {
    return function(title) {
        return function() {
            title.text = text;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $bee7380d3758c451$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $bee7380d3758c451$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $bee7380d3758c451$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $bee7380d3758c451$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $bee7380d3758c451$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $bee7380d3758c451$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $bee7380d3758c451$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $bee7380d3758c451$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTitleElement");
var $bee7380d3758c451$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTitleElement");
var $bee7380d3758c451$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTitleElement");
var $bee7380d3758c451$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTitleElement");
var $bee7380d3758c451$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTitleElement");
var $bee7380d3758c451$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTitleElement");
var $bee7380d3758c451$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTitleElement");


// Generated by purs version 0.15.16
function $f193c00384567e07$export$78062f36b16ed2f8(track) {
    return function() {
        return track.kind;
    };
}
function $f193c00384567e07$export$8f76af250dd43cf6(kind) {
    return function(track) {
        return function() {
            track.kind = kind;
        };
    };
}
function $f193c00384567e07$export$2e40c9e35e9506f4(track) {
    return function() {
        return track.src;
    };
}
function $f193c00384567e07$export$5771e3a4c80da7df(src) {
    return function(track) {
        return function() {
            track.src = src;
        };
    };
}
function $f193c00384567e07$export$4be5a609db5ad788(track) {
    return function() {
        return track.srclang;
    };
}
function $f193c00384567e07$export$5406412834bff708(srclang) {
    return function(track) {
        return function() {
            track.srclang = srclang;
        };
    };
}
function $f193c00384567e07$export$1237798dc640739a(track) {
    return function() {
        return track.label;
    };
}
function $f193c00384567e07$export$4f65e594f6031297(label) {
    return function(track) {
        return function() {
            track.label = label;
        };
    };
}
// ----------------------------------------------------------------------------
const $f193c00384567e07$export$2e2bcd8739ae039 = function(track) {
    return function() {
        return track["default"];
    };
};
function $f193c00384567e07$export$d590af038dd015bd(def) {
    return function(track) {
        return function() {
            track["default"] = def;
        };
    };
}
function $f193c00384567e07$export$4bf8a366db6a678b(track) {
    return track.readyState;
}



var $dIXGo = parcelRequire("dIXGo");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");
// Generated by purs version 0.15.16

var $dIXGo = parcelRequire("dIXGo");

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $b8606ab7a303fd78$export$57ca7e07b341709d = /* #__PURE__ */ function() {
    function None() {}
    None.value = new None();
    return None;
}();
var $b8606ab7a303fd78$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $b8606ab7a303fd78$export$b6517d5bdd20170e = /* #__PURE__ */ function() {
    function Loaded() {}
    Loaded.value = new Loaded();
    return Loaded;
}();
var $b8606ab7a303fd78$export$edf27be85e5f6da0 = /* #__PURE__ */ function() {
    function $$Error() {}
    $$Error.value = new $$Error();
    return $$Error;
}();
var $b8606ab7a303fd78$export$dc807b9f83d61e2e = function(v) {
    if (v === 0) return new $h2xUu.Just($b8606ab7a303fd78$export$57ca7e07b341709d.value);
    if (v === 1) return new $h2xUu.Just($b8606ab7a303fd78$export$669f6ea7d267feaf.value);
    if (v === 2) return new $h2xUu.Just($b8606ab7a303fd78$export$b6517d5bdd20170e.value);
    if (v === 3) return new $h2xUu.Just($b8606ab7a303fd78$export$edf27be85e5f6da0.value);
    return $h2xUu.Nothing.value;
};
var $b8606ab7a303fd78$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $b8606ab7a303fd78$export$57ca7e07b341709d) return "None";
        if (v instanceof $b8606ab7a303fd78$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $b8606ab7a303fd78$export$b6517d5bdd20170e) return "Loaded";
        if (v instanceof $b8606ab7a303fd78$export$edf27be85e5f6da0) return "Error";
        throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 30, column 1 - line 34, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $b8606ab7a303fd78$export$9974ae2c28acb3c9 = function(v) {
    if (v instanceof $b8606ab7a303fd78$export$57ca7e07b341709d) return 0;
    if (v instanceof $b8606ab7a303fd78$export$669f6ea7d267feaf) return 1;
    if (v instanceof $b8606ab7a303fd78$export$b6517d5bdd20170e) return 2;
    if (v instanceof $b8606ab7a303fd78$export$edf27be85e5f6da0) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 47, column 3 - line 51, column 15): " + [
        v.constructor.name
    ]);
};
var $b8606ab7a303fd78$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $b8606ab7a303fd78$export$57ca7e07b341709d && y instanceof $b8606ab7a303fd78$export$57ca7e07b341709d) return true;
            if (x instanceof $b8606ab7a303fd78$export$669f6ea7d267feaf && y instanceof $b8606ab7a303fd78$export$669f6ea7d267feaf) return true;
            if (x instanceof $b8606ab7a303fd78$export$b6517d5bdd20170e && y instanceof $b8606ab7a303fd78$export$b6517d5bdd20170e) return true;
            if (x instanceof $b8606ab7a303fd78$export$edf27be85e5f6da0 && y instanceof $b8606ab7a303fd78$export$edf27be85e5f6da0) return true;
            return false;
        };
    }
};
var $b8606ab7a303fd78$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $b8606ab7a303fd78$export$57ca7e07b341709d && y instanceof $b8606ab7a303fd78$export$57ca7e07b341709d) return $ibsD5.EQ.value;
            if (x instanceof $b8606ab7a303fd78$export$57ca7e07b341709d) return $ibsD5.LT.value;
            if (y instanceof $b8606ab7a303fd78$export$57ca7e07b341709d) return $ibsD5.GT.value;
            if (x instanceof $b8606ab7a303fd78$export$669f6ea7d267feaf && y instanceof $b8606ab7a303fd78$export$669f6ea7d267feaf) return $ibsD5.EQ.value;
            if (x instanceof $b8606ab7a303fd78$export$669f6ea7d267feaf) return $ibsD5.LT.value;
            if (y instanceof $b8606ab7a303fd78$export$669f6ea7d267feaf) return $ibsD5.GT.value;
            if (x instanceof $b8606ab7a303fd78$export$b6517d5bdd20170e && y instanceof $b8606ab7a303fd78$export$b6517d5bdd20170e) return $ibsD5.EQ.value;
            if (x instanceof $b8606ab7a303fd78$export$b6517d5bdd20170e) return $ibsD5.LT.value;
            if (y instanceof $b8606ab7a303fd78$export$b6517d5bdd20170e) return $ibsD5.GT.value;
            if (x instanceof $b8606ab7a303fd78$export$edf27be85e5f6da0 && y instanceof $b8606ab7a303fd78$export$edf27be85e5f6da0) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $b8606ab7a303fd78$export$c71e02dcc13f94a6;
    }
};
var $b8606ab7a303fd78$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $dIXGo.defaultSucc($b8606ab7a303fd78$export$dc807b9f83d61e2e)($b8606ab7a303fd78$export$9974ae2c28acb3c9),
    pred: /* #__PURE__ */ $dIXGo.defaultPred($b8606ab7a303fd78$export$dc807b9f83d61e2e)($b8606ab7a303fd78$export$9974ae2c28acb3c9),
    Ord0: function() {
        return $b8606ab7a303fd78$export$6557947d538c3b81;
    }
};
var $b8606ab7a303fd78$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $b8606ab7a303fd78$export$57ca7e07b341709d.value,
        top: $b8606ab7a303fd78$export$edf27be85e5f6da0.value,
        Ord0: function() {
            return $b8606ab7a303fd78$export$6557947d538c3b81;
        }
    };
}();
var $b8606ab7a303fd78$export$94a641e970e969f9 = {
    cardinality: 4,
    toEnum: $b8606ab7a303fd78$export$dc807b9f83d61e2e,
    fromEnum: $b8606ab7a303fd78$export$9974ae2c28acb3c9,
    Bounded0: function() {
        return $b8606ab7a303fd78$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $b8606ab7a303fd78$export$f705a14e9e99c6f0;
    }
};



var $ac347576db1abfdc$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $ac347576db1abfdc$var$toEnum = /* #__PURE__ */ $dIXGo.toEnum($b8606ab7a303fd78$export$94a641e970e969f9);
var $ac347576db1abfdc$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $ac347576db1abfdc$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $ac347576db1abfdc$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $ac347576db1abfdc$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $ac347576db1abfdc$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $ac347576db1abfdc$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $ac347576db1abfdc$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $ac347576db1abfdc$export$1ae2b664eea77b7e = function(el) {
    return $ac347576db1abfdc$var$map(function() {
        var $3 = $h2xUu.fromMaybe($b8606ab7a303fd78$export$57ca7e07b341709d.value);
        return function($4) {
            return $3($ac347576db1abfdc$var$toEnum($4));
        };
    }())(function() {
        return $f193c00384567e07$export$4bf8a366db6a678b(el);
    });
};
var $ac347576db1abfdc$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTrackElement");
var $ac347576db1abfdc$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTrackElement");
var $ac347576db1abfdc$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTrackElement");
var $ac347576db1abfdc$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTrackElement");
var $ac347576db1abfdc$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTrackElement");
var $ac347576db1abfdc$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTrackElement");
var $ac347576db1abfdc$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLTrackElement");


// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");

var $66455a94415e57e5$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $66455a94415e57e5$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $66455a94415e57e5$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $66455a94415e57e5$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $66455a94415e57e5$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $66455a94415e57e5$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $66455a94415e57e5$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $66455a94415e57e5$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLUListElement");
var $66455a94415e57e5$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLUListElement");
var $66455a94415e57e5$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLUListElement");
var $66455a94415e57e5$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLUListElement");
var $66455a94415e57e5$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLUListElement");
var $66455a94415e57e5$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLUListElement");
var $66455a94415e57e5$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLUListElement");


// Generated by purs version 0.15.16
// ----------------------------------------------------------------------------
function $f3437f8b993f03d9$export$7e3df82ee760448c(video) {
    return function() {
        return video.width;
    };
}
function $f3437f8b993f03d9$export$67f48e0594af05d(width) {
    return function(video) {
        return function() {
            video.width = width;
        };
    };
}
function $f3437f8b993f03d9$export$ac607276a8fe9f0a(video) {
    return function() {
        return video.height;
    };
}
function $f3437f8b993f03d9$export$3f31360357be44e4(height) {
    return function(video) {
        return function() {
            video.height = height;
        };
    };
}
function $f3437f8b993f03d9$export$dbb4894ced044525(video) {
    return function() {
        return video.videoWidth;
    };
}
function $f3437f8b993f03d9$export$848581bdb4a7943d(video) {
    return function() {
        return video.videoHeight;
    };
}
function $f3437f8b993f03d9$export$b840e55573b2d2e7(video) {
    return function() {
        return video.poster;
    };
}
function $f3437f8b993f03d9$export$2c8117e8f5cb8138(poster) {
    return function(video) {
        return function() {
            video.poster = poster;
        };
    };
}



var $k2DSm = parcelRequire("k2DSm");

var $21d5a16aa379ca29$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $21d5a16aa379ca29$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $21d5a16aa379ca29$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $21d5a16aa379ca29$export$fd26055f9731f4b9 = $k2DSm.unsafeCoerce;
var $21d5a16aa379ca29$export$3667cdd4f3a5105e = $k2DSm.unsafeCoerce;
var $21d5a16aa379ca29$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $21d5a16aa379ca29$export$8d51e3db1a844094 = $k2DSm.unsafeCoerce;
var $21d5a16aa379ca29$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $21d5a16aa379ca29$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLVideoElement");
var $21d5a16aa379ca29$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLVideoElement");
var $21d5a16aa379ca29$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLVideoElement");
var $21d5a16aa379ca29$export$cdb626e247ef0ce5 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLVideoElement");
var $21d5a16aa379ca29$export$f9471d229cb6cb3f = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLVideoElement");
var $21d5a16aa379ca29$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLVideoElement");
var $21d5a16aa379ca29$export$c56654a6d0e3bd48 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLVideoElement");
var $21d5a16aa379ca29$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("HTMLVideoElement");


// Generated by purs version 0.15.16
function $ec30226392c3a36d$export$7c341cb16fc91138(history) {
    return function() {
        return history.back();
    };
}
function $ec30226392c3a36d$export$174bb771924e7eb1(history) {
    return function() {
        return history.forward();
    };
}
function $ec30226392c3a36d$export$93bb224d05b3906d(delta) {
    return function(history) {
        return function() {
            return history.go(delta);
        };
    };
}
function $ec30226392c3a36d$export$ba0fd82af7b4fe6e(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.pushState(a, docTitle, url);
                };
            };
        };
    };
}
function $ec30226392c3a36d$export$e68dd4d2e7e08394(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.replaceState(a, docTitle, url);
                };
            };
        };
    };
}
function $ec30226392c3a36d$export$ca000e230c0caa3e(history) {
    return function() {
        return history.state;
    };
}



var $gwBF5 = parcelRequire("gwBF5");
var $8eb384e568a5af81$var$compare = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordString);
var $8eb384e568a5af81$var$compare1 = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordInt);
var $8eb384e568a5af81$export$61abde59b50deb8e = function(x) {
    return x;
};
var $8eb384e568a5af81$export$dd5ad0b65cf665da = function(x) {
    return x;
};
var $8eb384e568a5af81$export$1f333647865369bf = function(x) {
    return x;
};
var $8eb384e568a5af81$export$e587774857b65d31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $8eb384e568a5af81$export$2cdd79be0aa3bb07 = {
    Coercible0: function() {
        return undefined;
    }
};
var $8eb384e568a5af81$export$3c3105bc6097b846 = {
    Coercible0: function() {
        return undefined;
    }
};
var $8eb384e568a5af81$export$214a01057915d716 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $8eb384e568a5af81$export$dbc0939544a3624 = {
    compare: function(x) {
        return function(y) {
            return $8eb384e568a5af81$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $8eb384e568a5af81$export$214a01057915d716;
    }
};
var $8eb384e568a5af81$export$28be1498e824b653 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $8eb384e568a5af81$export$7c3d39f0cf320c7b = {
    compare: function(x) {
        return function(y) {
            return $8eb384e568a5af81$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $8eb384e568a5af81$export$28be1498e824b653;
    }
};
var $8eb384e568a5af81$export$3e1b8005eb6f3d68 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $8eb384e568a5af81$export$4ef0c953a661f864 = {
    compare: function(x) {
        return function(y) {
            return $8eb384e568a5af81$var$compare1(x)(y);
        };
    },
    Eq0: function() {
        return $8eb384e568a5af81$export$3e1b8005eb6f3d68;
    }
};


// Generated by purs version 0.15.16
function $6f67113cfd3e1757$export$d6af199866bfb566(location) {
    return function() {
        return location.hash;
    };
}
function $6f67113cfd3e1757$export$42c3f3255a992e7(hash) {
    return function(location) {
        return function() {
            location.hash = hash;
        };
    };
}
function $6f67113cfd3e1757$export$5e032988b71f6158(location) {
    return function() {
        return location.host;
    };
}
function $6f67113cfd3e1757$export$db0724f89fd14c87(host) {
    return function(location) {
        return function() {
            location.host = host;
        };
    };
}
function $6f67113cfd3e1757$export$640106f6dc7d2706(location) {
    return function() {
        return location.hostname;
    };
}
function $6f67113cfd3e1757$export$d120c0a46ba2e633(hostname) {
    return function(location) {
        return function() {
            location.hostname = hostname;
        };
    };
}
function $6f67113cfd3e1757$export$8f51af5840e0602a(location) {
    return function() {
        return location.href;
    };
}
function $6f67113cfd3e1757$export$428f6e77b5a5a669(href) {
    return function(location) {
        return function() {
            location.href = href;
        };
    };
}
function $6f67113cfd3e1757$export$f710a83a91838a36(location) {
    return function() {
        return location.origin;
    };
}
function $6f67113cfd3e1757$export$717aaa4b4fe61ebd(origin) {
    return function(location) {
        return function() {
            location.origin = origin;
        };
    };
}
function $6f67113cfd3e1757$export$7333db99aa99d383(location) {
    return function() {
        return location.pathname;
    };
}
function $6f67113cfd3e1757$export$8c7da94d5c72705a(pathname) {
    return function(location) {
        return function() {
            location.pathname = pathname;
        };
    };
}
function $6f67113cfd3e1757$export$2433da7bd3cc7af7(location) {
    return function() {
        return location.port;
    };
}
function $6f67113cfd3e1757$export$b0effcd3879eb064(port) {
    return function(location) {
        return function() {
            location.port = port;
        };
    };
}
function $6f67113cfd3e1757$export$a51d6b395ff4c65a(location) {
    return function() {
        return location.protocol;
    };
}
function $6f67113cfd3e1757$export$caabdac475e4f216(protocol) {
    return function(location) {
        return function() {
            location.protocol = protocol;
        };
    };
}
function $6f67113cfd3e1757$export$d76128d007d19019(location) {
    return function() {
        return location.search;
    };
}
function $6f67113cfd3e1757$export$f96d8961b67fb6df(search) {
    return function(location) {
        return function() {
            location.search = search;
        };
    };
}
function $6f67113cfd3e1757$export$e6e34fd1f2686227(url) {
    return function(location) {
        return function() {
            location.assign(url);
        };
    };
}
function $6f67113cfd3e1757$export$77ad94ebf1c2b9ed(url) {
    return function(location) {
        return function() {
            location.replace(url);
        };
    };
}
function $6f67113cfd3e1757$export$32da5b5043dcd88c(location) {
    return function() {
        location.reload();
    };
}




// Generated by purs version 0.15.16
function $205874860eea973a$export$789c912f57fe164c(navigator) {
    return function() {
        return navigator.language;
    };
}
function $205874860eea973a$export$d0d68bb9ed2c643d(navigator) {
    return function() {
        return navigator.languages;
    };
}
function $205874860eea973a$export$c65ce66152f1cb9d(navigator) {
    return function() {
        return navigator.onLine;
    };
}
function $205874860eea973a$export$722a64dea1b767dc(navigator) {
    return function() {
        return navigator.platform;
    };
}
function $205874860eea973a$export$3dcce53a3755dc8c(navigator) {
    return function() {
        return navigator.userAgent;
    };
}




// Generated by purs version 0.15.16
function $6bfa62c8b92a1e7d$export$5a7bfc01df82fcd1(window) {
    return function() {
        return window.document;
    };
}
function $6bfa62c8b92a1e7d$export$ec7c8efa7f5790ae(window) {
    return function() {
        return window.navigator;
    };
}
function $6bfa62c8b92a1e7d$export$17b07c660794dc13(window) {
    return function() {
        return window.location;
    };
}
function $6bfa62c8b92a1e7d$export$55abd4691b317664(window) {
    return function() {
        return window.history;
    };
}
function $6bfa62c8b92a1e7d$export$d23fbaf1a2e7133c(window) {
    return function() {
        return window.innerWidth;
    };
}
function $6bfa62c8b92a1e7d$export$d3ad305c42af1069(window) {
    return function() {
        return window.innerHeight;
    };
}
function $6bfa62c8b92a1e7d$export$5ea928c9faf85bd3(str) {
    return function(window) {
        return function() {
            window.alert(str);
        };
    };
}
function $6bfa62c8b92a1e7d$export$715f9d76bb8c1fea(str) {
    return function(window) {
        return function() {
            return window.confirm(str);
        };
    };
}
function $6bfa62c8b92a1e7d$export$7290db243fe4f181(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.moveBy(xDelta, yDelta);
            };
        };
    };
}
function $6bfa62c8b92a1e7d$export$75f1ccd6dc32e80a(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.moveTo(width, height);
            };
        };
    };
}
function $6bfa62c8b92a1e7d$export$f4b9acba9659afe8(url) {
    return function(name) {
        return function(features) {
            return function(window) {
                return function() {
                    return window.open(url, name, features);
                };
            };
        };
    };
}
function $6bfa62c8b92a1e7d$export$8360e631d277ea4d(window) {
    return function() {
        return window.close();
    };
}
function $6bfa62c8b92a1e7d$export$fc5b8aac72846d1e(window) {
    return function() {
        return window.outerHeight;
    };
}
function $6bfa62c8b92a1e7d$export$e823f88e4111159a(window) {
    return function() {
        return window.outerWidth;
    };
}
function $6bfa62c8b92a1e7d$export$c2d084dc44961371(window) {
    return function() {
        window.print();
    };
}
function $6bfa62c8b92a1e7d$export$ce783d49a08713a7(str) {
    return function(defaultText) {
        return function(window) {
            return function() {
                return window.prompt(str, defaultText);
            };
        };
    };
}
function $6bfa62c8b92a1e7d$export$5f72b7db69802ea0(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.resizeBy(xDelta, yDelta);
            };
        };
    };
}
function $6bfa62c8b92a1e7d$export$663d9c149a16f84d(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.resizeTo(width, height);
            };
        };
    };
}
function $6bfa62c8b92a1e7d$export$daeacaab2dbcebdc(window) {
    return function() {
        return window.screenX;
    };
}
function $6bfa62c8b92a1e7d$export$51b695a8750464db(window) {
    return function() {
        return window.screenY;
    };
}
function $6bfa62c8b92a1e7d$export$209876d7b1ac8f3(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scroll(xCoord, yCoord);
            };
        };
    };
}
function $6bfa62c8b92a1e7d$export$19a39865fecdb343(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scrollBy(xCoord, yCoord);
            };
        };
    };
}
function $6bfa62c8b92a1e7d$export$5320ec237fcf13b2(window) {
    return function() {
        return window.scrollX;
    };
}
function $6bfa62c8b92a1e7d$export$2dd824eca41ca48d(window) {
    return function() {
        return window.scrollY;
    };
}
function $6bfa62c8b92a1e7d$export$c2ed3351cac403d1(window) {
    return function() {
        return window.localStorage;
    };
}
function $6bfa62c8b92a1e7d$export$f119d83aa936d634(window) {
    return function() {
        return window.sessionStorage;
    };
}
function $6bfa62c8b92a1e7d$export$6cb2c4c0a22909c0(fn) {
    return function(window) {
        return function() {
            return window.requestAnimationFrame(fn);
        };
    };
}
function $6bfa62c8b92a1e7d$export$e00521de187a817a(id) {
    return function(window) {
        return function() {
            return window.cancelAnimationFrame(id);
        };
    };
}
function $6bfa62c8b92a1e7d$export$9288a5d956b3efbe(opts) {
    return function(fn) {
        return function(window) {
            return function() {
                return window.requestIdleCallback(fn, opts);
            };
        };
    };
}
function $6bfa62c8b92a1e7d$export$bf0a62c3939e5933(id) {
    return function(window) {
        return function() {
            return window.cancelIdleCallback(id);
        };
    };
}
function $6bfa62c8b92a1e7d$export$91124bb58bc04465(window) {
    return function() {
        return window.parent;
    };
}
function $6bfa62c8b92a1e7d$export$b161e74f44e020b9(window) {
    return function() {
        return window.opener;
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $gwBF5 = parcelRequire("gwBF5");

var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

var $fb7c5d2f8f53ba15$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $fb7c5d2f8f53ba15$var$compare = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordInt);
var $fb7c5d2f8f53ba15$var$RequestIdleCallbackId = function(x) {
    return x;
};
var $fb7c5d2f8f53ba15$var$RequestAnimationFrameId = function(x) {
    return x;
};
var $fb7c5d2f8f53ba15$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $fb7c5d2f8f53ba15$export$20682ad686515a40 = function(msg) {
    return function(defaultText) {
        return function(window) {
            return $fb7c5d2f8f53ba15$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)($6bfa62c8b92a1e7d$export$ce783d49a08713a7(msg)(defaultText)(window));
        };
    };
};
var $fb7c5d2f8f53ba15$export$195ba6d62321b933 = function(msg) {
    return function(window) {
        return $fb7c5d2f8f53ba15$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)($6bfa62c8b92a1e7d$export$ce783d49a08713a7(msg)("")(window));
    };
};
var $fb7c5d2f8f53ba15$export$1828d3c48a8aa004 = function(window) {
    return $fb7c5d2f8f53ba15$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)($6bfa62c8b92a1e7d$export$b161e74f44e020b9(window));
};
var $fb7c5d2f8f53ba15$export$3ce6949f20cea765 = function(url$prime) {
    return function(name) {
        return function(features) {
            return function(window) {
                return $fb7c5d2f8f53ba15$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)($6bfa62c8b92a1e7d$export$f4b9acba9659afe8(url$prime)(name)(features)(window));
            };
        };
    };
};
var $fb7c5d2f8f53ba15$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("Window");
var $fb7c5d2f8f53ba15$export$5e61711963baf8b7 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $fb7c5d2f8f53ba15$export$2a5c622a4a2ca36d = {
    compare: function(x) {
        return function(y) {
            return $fb7c5d2f8f53ba15$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $fb7c5d2f8f53ba15$export$5e61711963baf8b7;
    }
};
var $fb7c5d2f8f53ba15$export$c27c49a6c01c4337 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $fb7c5d2f8f53ba15$export$5ec63fa26beb11f3 = {
    compare: function(x) {
        return function(y) {
            return $fb7c5d2f8f53ba15$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $fb7c5d2f8f53ba15$export$c27c49a6c01c4337;
    }
};




// Generated by purs version 0.15.16
var $c4fc5073d9256368$export$117f7ddab482d006 = "unload";
var $c4fc5073d9256368$export$e03c1c3201ee8bb7 = "toggle";
var $c4fc5073d9256368$export$853c27de4ce0f746 = "submit";
var $c4fc5073d9256368$export$ddcffe0146c8f882 = "storage";
var $c4fc5073d9256368$export$2e6c959c16ff56b8 = "select";
var $c4fc5073d9256368$export$aad8462122ac592b = "reset";
var $c4fc5073d9256368$export$1427eba79b2ae340 = "readystatechange";
var $c4fc5073d9256368$export$504d7abb21fa8c9 = "progress";
var $c4fc5073d9256368$export$9b6706c8686cfc8e = "paste";
var $c4fc5073d9256368$export$6dd222fd9e8d7968 = "online";
var $c4fc5073d9256368$export$3b16d2a27b22a87a = "offline";
var $c4fc5073d9256368$export$a8ecead220dd38a6 = "message";
var $c4fc5073d9256368$export$dca0cefb631ec861 = "loadstart";
var $c4fc5073d9256368$export$ddc39cda6f909ee1 = "loadend";
var $c4fc5073d9256368$export$11e63f7b0f3d9900 = "load";
var $c4fc5073d9256368$export$8d5b9ac6cde54772 = "languagechange";
var $c4fc5073d9256368$export$9f85add0327f687e = "invalid";
var $c4fc5073d9256368$export$b7e3ae3d7c15e42e = "input";
var $c4fc5073d9256368$export$d7ddd398f22d79ef = "focus";
var $c4fc5073d9256368$export$a3bc9b8ed74fc = "error";
var $c4fc5073d9256368$export$ead50553077ff635 = "DOMContentLoaded";
var $c4fc5073d9256368$export$af2a99f971a346e6 = "cut";
var $c4fc5073d9256368$export$784d13d8ee351f07 = "copy";
var $c4fc5073d9256368$export$8360e631d277ea4d = "close";
var $c4fc5073d9256368$export$64ef1bee2b9504c1 = "click";
var $c4fc5073d9256368$export$d8a7b8f475ec0161 = "change";
var $c4fc5073d9256368$export$70b61ad426ddbe54 = "cancel";
var $c4fc5073d9256368$export$2cc7ff91bcacba5e = "blur";
var $c4fc5073d9256368$export$26ecb34e09d46df7 = "beforescriptexecute";
var $c4fc5073d9256368$export$ad2ab82a6fc787c7 = "beforeprint";
var $c4fc5073d9256368$export$7af6a91a06bd66bd = "afterscriptexecute";
var $c4fc5073d9256368$export$56890049c3283011 = "afterprint";
var $c4fc5073d9256368$export$5def58af4fd46132 = "abort";






var $27881bd5d2efdfe8$var$bind = /* #__PURE__ */ $cADnC.bind($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $27881bd5d2efdfe8$var$liftEffect = /* #__PURE__ */ $54d5aa8d31ad5798$export$34255e15eb56d2b3($7244ec56ae5630bd$export$666a030cecdf96c);
var $27881bd5d2efdfe8$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($1rTTn.bindEffect);
var $27881bd5d2efdfe8$var$composeKleisliFlipped = /* #__PURE__ */ $cADnC.composeKleisliFlipped($1rTTn.bindEffect);
var $27881bd5d2efdfe8$var$pure = /* #__PURE__ */ $bQdkN.pure($7244ec56ae5630bd$export$9dc0454a98607988);
var $27881bd5d2efdfe8$var$bindFlipped1 = /* #__PURE__ */ $cADnC.bindFlipped($h2xUu.bindMaybe);
var $27881bd5d2efdfe8$var$pure1 = /* #__PURE__ */ $bQdkN.pure($1rTTn.applicativeEffect);
var $27881bd5d2efdfe8$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $27881bd5d2efdfe8$var$discard = /* #__PURE__ */ $cADnC.discard($cADnC.discardUnit);
var $27881bd5d2efdfe8$var$throwError = /* #__PURE__ */ $693a27a8782d8e71$export$8bf7aba4a9e09055($7244ec56ae5630bd$export$37a9b80154c7d256);
var $27881bd5d2efdfe8$export$895e5c0dd54cd456 = function(query) {
    return $27881bd5d2efdfe8$var$bind($27881bd5d2efdfe8$var$liftEffect($27881bd5d2efdfe8$var$bindFlipped($27881bd5d2efdfe8$var$composeKleisliFlipped(function() {
        var $16 = $272e5e67d54dabbd$export$78fb49a702cc1f2(query);
        return function($17) {
            return $16($5551ee6cfcdc9d35$export$c8b651b897da2de($17));
        };
    }())($6bfa62c8b92a1e7d$export$5a7bfc01df82fcd1))($df82538a253b5856$export$8291e5b88f90ce4)))(function(mel) {
        return $27881bd5d2efdfe8$var$pure($27881bd5d2efdfe8$var$bindFlipped1($13d4e6882f9a916b$export$c56654a6d0e3bd48)(mel));
    });
};
var $27881bd5d2efdfe8$export$1b79e4d7fc8e4817 = /* #__PURE__ */ $7244ec56ae5630bd$export$ef62257e6f8a5f8c(/* #__PURE__ */ $beQI1.either($f58bea5e58d54301$export$de0c4a986b439e52)(/* #__PURE__ */ $jhsiw.const(/* #__PURE__ */ $27881bd5d2efdfe8$var$pure1($2jM6U.unit))));
var $27881bd5d2efdfe8$export$11dc33decdfc25c9 = /* #__PURE__ */ $c88db571692c73b3$export$49d5975414e0a979(function(callback) {
    return function __do() {
        var rs = $27881bd5d2efdfe8$var$bindFlipped($5551ee6cfcdc9d35$export$1ae2b664eea77b7e)($27881bd5d2efdfe8$var$bindFlipped($6bfa62c8b92a1e7d$export$5a7bfc01df82fcd1)($df82538a253b5856$export$8291e5b88f90ce4))();
        if (rs instanceof $fb9a6cc7ad7a78b1$export$669f6ea7d267feaf) {
            var et = $27881bd5d2efdfe8$var$map($fb7c5d2f8f53ba15$export$55c9526d22b9f8e6)($df82538a253b5856$export$8291e5b88f90ce4)();
            var listener = $d8dd8b0292692afb$export$f5cdf3809b4587f3(function(v) {
                return callback(new $beQI1.Right($2jM6U.unit));
            })();
            $d8dd8b0292692afb$export$3f65cefe8380dbea($c4fc5073d9256368$export$ead50553077ff635)(listener)(false)(et)();
            return $7244ec56ae5630bd$export$952106a975f35ae2($d8dd8b0292692afb$export$8ff9f68337b520c0($c4fc5073d9256368$export$ead50553077ff635)(listener)(false)(et));
        }
        callback(new $beQI1.Right($2jM6U.unit))();
        return $7244ec56ae5630bd$export$8deb6e154ce67af6;
    };
});
var $27881bd5d2efdfe8$export$f79c83a36c9670be = /* #__PURE__ */ $27881bd5d2efdfe8$var$discard($7244ec56ae5630bd$export$f885f489dcf38a2d)($27881bd5d2efdfe8$export$11dc33decdfc25c9)(function() {
    return $27881bd5d2efdfe8$var$bind($27881bd5d2efdfe8$export$895e5c0dd54cd456("body"))(function(body) {
        return $h2xUu.maybe($27881bd5d2efdfe8$var$throwError($f58bea5e58d54301$export$a3bc9b8ed74fc("Could not find body")))($27881bd5d2efdfe8$var$pure)(body);
    });
});


// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $5ZwWo = parcelRequire("5ZwWo");
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $49WxQ = parcelRequire("49WxQ");

var $eJa4O = parcelRequire("eJa4O");

var $j7FrY = parcelRequire("j7FrY");


var $aJhEx = parcelRequire("aJhEx");
// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");
var $93856f78c484fce2$export$49a1dce2f81a97d6 = $k2DSm.unsafeCoerce;
var $93856f78c484fce2$export$7488c940d035302c = $k2DSm.unsafeCoerce;



var $dNwPt = parcelRequire("dNwPt");

var $7FzSN = parcelRequire("7FzSN");

var $7nwca = parcelRequire("7nwca");

var $gwBF5 = parcelRequire("gwBF5");

var $kAvps = parcelRequire("kAvps");

var $6ywL5 = parcelRequire("6ywL5");

var $9OOYG = parcelRequire("9OOYG");
var $6ceb47448afaefc1$var$CoyonedaF = /* #__PURE__ */ function() {
    function CoyonedaF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CoyonedaF.create = function(value0) {
        return function(value1) {
            return new CoyonedaF(value0, value1);
        };
    };
    return CoyonedaF;
}();
var $6ceb47448afaefc1$export$518a6adb5ee0288f = function(x) {
    return x;
};
var $6ceb47448afaefc1$export$1088317934ed5679 = function(f) {
    return function(v) {
        return $93856f78c484fce2$export$49a1dce2f81a97d6(function(v1) {
            return f(v1.value0)(v1.value1);
        })(v);
    };
};
var $6ceb47448afaefc1$export$36cf4525d9d7ca3c = function(dictFunctor) {
    return $6ceb47448afaefc1$export$1088317934ed5679($7FzSN.map(dictFunctor));
};
var $6ceb47448afaefc1$export$e10932df6e0657f1 = function(dictFoldable) {
    var foldr = $dNwPt.foldr(dictFoldable);
    var foldl = $dNwPt.foldl(dictFoldable);
    var foldMap = $dNwPt.foldMap(dictFoldable);
    return {
        foldr: function(f) {
            return function(z) {
                return $6ceb47448afaefc1$export$1088317934ed5679(function(k) {
                    return foldr(function($175) {
                        return f(k($175));
                    })(z);
                });
            };
        },
        foldl: function(f) {
            return function(z) {
                return $6ceb47448afaefc1$export$1088317934ed5679(function(k) {
                    return foldl(function(x) {
                        var $176 = f(x);
                        return function($177) {
                            return $176(k($177));
                        };
                    })(z);
                });
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                return $6ceb47448afaefc1$export$1088317934ed5679(function(k) {
                    return foldMap1(function($178) {
                        return f(k($178));
                    });
                });
            };
        }
    };
};
var $6ceb47448afaefc1$export$bd381ac72ce00e4e = function(dictFoldable1) {
    var foldMap1 = $kAvps.foldMap1(dictFoldable1);
    var foldableCoyoneda1 = $6ceb47448afaefc1$export$e10932df6e0657f1(dictFoldable1.Foldable0());
    return {
        foldMap1: function(dictSemigroup) {
            var foldMap11 = foldMap1(dictSemigroup);
            return function(f) {
                return $6ceb47448afaefc1$export$1088317934ed5679(function(k) {
                    return foldMap11(function($179) {
                        return f(k($179));
                    });
                });
            };
        },
        foldr1: $kAvps.foldr1Default($6ceb47448afaefc1$export$bd381ac72ce00e4e(dictFoldable1)),
        foldl1: $kAvps.foldl1Default($6ceb47448afaefc1$export$bd381ac72ce00e4e(dictFoldable1)),
        Foldable0: function() {
            return foldableCoyoneda1;
        }
    };
};
var $6ceb47448afaefc1$export$4c17598ac057c221 = function(dictFunctor) {
    var lowerCoyoneda1 = $6ceb47448afaefc1$export$36cf4525d9d7ca3c(dictFunctor);
    return function(dictEq1) {
        var eq1 = $aJhEx.eq1(dictEq1);
        return function(dictEq) {
            var eq11 = eq1(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        return eq11(lowerCoyoneda1(x))(lowerCoyoneda1(y));
                    };
                }
            };
        };
    };
};
var $6ceb47448afaefc1$export$e3d23e83f1d891bb = function(dictFunctor) {
    var lowerCoyoneda1 = $6ceb47448afaefc1$export$36cf4525d9d7ca3c(dictFunctor);
    var eqCoyoneda1 = $6ceb47448afaefc1$export$4c17598ac057c221(dictFunctor);
    return function(dictOrd1) {
        var compare1 = $gwBF5.compare1(dictOrd1);
        var eqCoyoneda2 = eqCoyoneda1(dictOrd1.Eq10());
        return function(dictOrd) {
            var compare11 = compare1(dictOrd);
            var eqCoyoneda3 = eqCoyoneda2(dictOrd.Eq0());
            return {
                compare: function(x) {
                    return function(y) {
                        return compare11(lowerCoyoneda1(x))(lowerCoyoneda1(y));
                    };
                },
                Eq0: function() {
                    return eqCoyoneda3;
                }
            };
        };
    };
};
var $6ceb47448afaefc1$export$8fee22dc2f6f5e8 = function(dictFunctor) {
    var eqCoyoneda1 = $6ceb47448afaefc1$export$4c17598ac057c221(dictFunctor);
    return function(dictEq1) {
        var eqCoyoneda2 = eqCoyoneda1(dictEq1);
        return {
            eq1: function(dictEq) {
                return $aJhEx.eq(eqCoyoneda2(dictEq));
            }
        };
    };
};
var $6ceb47448afaefc1$export$72164df904554716 = function(dictFunctor) {
    var ordCoyoneda1 = $6ceb47448afaefc1$export$e3d23e83f1d891bb(dictFunctor);
    var eq1Coyoneda1 = $6ceb47448afaefc1$export$8fee22dc2f6f5e8(dictFunctor);
    return function(dictOrd1) {
        var ordCoyoneda2 = ordCoyoneda1(dictOrd1);
        var eq1Coyoneda2 = eq1Coyoneda1(dictOrd1.Eq10());
        return {
            compare1: function(dictOrd) {
                return $gwBF5.compare(ordCoyoneda2(dictOrd));
            },
            Eq10: function() {
                return eq1Coyoneda2;
            }
        };
    };
};
var $6ceb47448afaefc1$export$cc61df270d10d232 = function(k) {
    return function(fi) {
        return $93856f78c484fce2$export$7488c940d035302c(new $6ceb47448afaefc1$var$CoyonedaF(k, fi));
    };
};
var $6ceb47448afaefc1$export$bd40aba71422b460 = {
    map: function(f) {
        return function(v) {
            return $93856f78c484fce2$export$49a1dce2f81a97d6(function(v1) {
                return $6ceb47448afaefc1$export$cc61df270d10d232(function($180) {
                    return f(v1.value0($180));
                })(v1.value1);
            })(v);
        };
    }
};
var $6ceb47448afaefc1$export$4b21c9b3969f8a88 = {
    imap: /* #__PURE__ */ $7nwca.imapF($6ceb47448afaefc1$export$bd40aba71422b460)
};
var $6ceb47448afaefc1$export$782bd81bf3515665 = function(nat) {
    return function(v) {
        return $93856f78c484fce2$export$49a1dce2f81a97d6(function(v1) {
            return $6ceb47448afaefc1$export$cc61df270d10d232(v1.value0)(nat(v1.value1));
        })(v);
    };
};
var $6ceb47448afaefc1$export$6320c031d6b6270f = /* #__PURE__ */ $6ceb47448afaefc1$export$cc61df270d10d232(/* #__PURE__ */ $26SV5.identity($26SV5.categoryFn));
var $6ceb47448afaefc1$export$215969f5aee12fc3 = function(dictDistributive) {
    var collect = $04114899412aeb9b$export$bb44f104e3c54dae(dictDistributive);
    var lowerCoyoneda1 = $6ceb47448afaefc1$export$36cf4525d9d7ca3c(dictDistributive.Functor0());
    return {
        collect: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(f) {
                var $181 = collect1(function($183) {
                    return lowerCoyoneda1(f($183));
                });
                return function($182) {
                    return $6ceb47448afaefc1$export$6320c031d6b6270f($181($182));
                };
            };
        },
        distribute: function(dictFunctor) {
            var $184 = collect(dictFunctor)(lowerCoyoneda1);
            return function($185) {
                return $6ceb47448afaefc1$export$6320c031d6b6270f($184($185));
            };
        },
        Functor0: function() {
            return $6ceb47448afaefc1$export$bd40aba71422b460;
        }
    };
};
var $6ceb47448afaefc1$export$946e5a80c258b6f7 = function(dictExtend) {
    var extend = $eJa4O.extend(dictExtend);
    return {
        extend: function(f) {
            return function(v) {
                return $93856f78c484fce2$export$49a1dce2f81a97d6(function(v1) {
                    return $6ceb47448afaefc1$export$6320c031d6b6270f(extend(function() {
                        var $186 = $6ceb47448afaefc1$export$cc61df270d10d232(v1.value0);
                        return function($187) {
                            return f($186($187));
                        };
                    }())(v1.value1));
                })(v);
            };
        },
        Functor0: function() {
            return $6ceb47448afaefc1$export$bd40aba71422b460;
        }
    };
};
var $6ceb47448afaefc1$export$1a78c49d463144db = {
    lift: function(dictMonad) {
        return $6ceb47448afaefc1$export$6320c031d6b6270f;
    }
};
var $6ceb47448afaefc1$export$d249e493735a3666 = function(dictTraversable) {
    var traverse = $9OOYG.traverse(dictTraversable);
    var foldableCoyoneda1 = $6ceb47448afaefc1$export$e10932df6e0657f1(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return $6ceb47448afaefc1$export$1088317934ed5679(function(k) {
                    var $188 = map($6ceb47448afaefc1$export$6320c031d6b6270f);
                    var $189 = traverse1(function($191) {
                        return f(k($191));
                    });
                    return function($190) {
                        return $188($189($190));
                    };
                });
            };
        },
        sequence: function(dictApplicative) {
            var map = $7FzSN.map(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return $6ceb47448afaefc1$export$1088317934ed5679(function(k) {
                var $192 = map($6ceb47448afaefc1$export$6320c031d6b6270f);
                var $193 = traverse1(k);
                return function($194) {
                    return $192($193($194));
                };
            });
        },
        Functor0: function() {
            return $6ceb47448afaefc1$export$bd40aba71422b460;
        },
        Foldable1: function() {
            return foldableCoyoneda1;
        }
    };
};
var $6ceb47448afaefc1$export$592beb634cc81a68 = function(dictTraversable1) {
    var traverse1 = $6ywL5.traverse1(dictTraversable1);
    var sequence1 = $6ywL5.sequence1(dictTraversable1);
    var Traversable1 = dictTraversable1.Traversable1();
    var map = $7FzSN.map(Traversable1.Functor0());
    var foldable1Coyoneda1 = $6ceb47448afaefc1$export$bd381ac72ce00e4e(dictTraversable1.Foldable10());
    var traversableCoyoneda1 = $6ceb47448afaefc1$export$d249e493735a3666(Traversable1);
    return {
        traverse1: function(dictApply) {
            var map1 = $7FzSN.map(dictApply.Functor0());
            var traverse11 = traverse1(dictApply);
            return function(f) {
                return $6ceb47448afaefc1$export$1088317934ed5679(function(k) {
                    var $195 = map1($6ceb47448afaefc1$export$6320c031d6b6270f);
                    var $196 = traverse11(function($198) {
                        return f(k($198));
                    });
                    return function($197) {
                        return $195($196($197));
                    };
                });
            };
        },
        sequence1: function(dictApply) {
            var map1 = $7FzSN.map(dictApply.Functor0());
            var sequence11 = sequence1(dictApply);
            return $6ceb47448afaefc1$export$1088317934ed5679(function(k) {
                var $199 = map1($6ceb47448afaefc1$export$6320c031d6b6270f);
                var $200 = map(k);
                return function($201) {
                    return $199(sequence11($200($201)));
                };
            });
        },
        Foldable10: function() {
            return foldable1Coyoneda1;
        },
        Traversable1: function() {
            return traversableCoyoneda1;
        }
    };
};
var $6ceb47448afaefc1$export$3a5b6268908c7242 = function(dictComonad) {
    var extract = $49WxQ.extract(dictComonad);
    var extendCoyoneda1 = $6ceb47448afaefc1$export$946e5a80c258b6f7(dictComonad.Extend0());
    return {
        extract: function(v) {
            return $93856f78c484fce2$export$49a1dce2f81a97d6(function(v1) {
                return v1.value0(extract(v1.value1));
            })(v);
        },
        Extend0: function() {
            return extendCoyoneda1;
        }
    };
};
var $6ceb47448afaefc1$export$96fda80da8742a6b = function(dictApply) {
    var apply = $26ZCq.apply(dictApply);
    var lowerCoyoneda1 = $6ceb47448afaefc1$export$36cf4525d9d7ca3c(dictApply.Functor0());
    return {
        apply: function(f) {
            return function(g) {
                return $6ceb47448afaefc1$export$6320c031d6b6270f(apply(lowerCoyoneda1(f))(lowerCoyoneda1(g)));
            };
        },
        Functor0: function() {
            return $6ceb47448afaefc1$export$bd40aba71422b460;
        }
    };
};
var $6ceb47448afaefc1$export$ef5b465291a6417e = function(dictBind) {
    var bindFlipped = $cADnC.bindFlipped(dictBind);
    var Apply0 = dictBind.Apply0();
    var lowerCoyoneda1 = $6ceb47448afaefc1$export$36cf4525d9d7ca3c(Apply0.Functor0());
    var applyCoyoneda1 = $6ceb47448afaefc1$export$96fda80da8742a6b(Apply0);
    return {
        bind: function(v) {
            return function(f) {
                return $6ceb47448afaefc1$export$6320c031d6b6270f($93856f78c484fce2$export$49a1dce2f81a97d6(function(v1) {
                    return bindFlipped(function($202) {
                        return lowerCoyoneda1(f(v1.value0($202)));
                    })(v1.value1);
                })(v));
            };
        },
        Apply0: function() {
            return applyCoyoneda1;
        }
    };
};
var $6ceb47448afaefc1$export$d337c8e043437698 = function(dictApplicative) {
    var applyCoyoneda1 = $6ceb47448afaefc1$export$96fda80da8742a6b(dictApplicative.Apply0());
    return {
        pure: function() {
            var $203 = $bQdkN.pure(dictApplicative);
            return function($204) {
                return $6ceb47448afaefc1$export$6320c031d6b6270f($203($204));
            };
        }(),
        Apply0: function() {
            return applyCoyoneda1;
        }
    };
};
var $6ceb47448afaefc1$export$dfa10a61f5e8217c = function(dictMonad) {
    var applicativeCoyoneda1 = $6ceb47448afaefc1$export$d337c8e043437698(dictMonad.Applicative0());
    var bindCoyoneda1 = $6ceb47448afaefc1$export$ef5b465291a6417e(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeCoyoneda1;
        },
        Bind1: function() {
            return bindCoyoneda1;
        }
    };
};
var $6ceb47448afaefc1$export$daa4182a46d81e3 = function(dictAlt) {
    var alt = $56VjJ.alt(dictAlt);
    var lowerCoyoneda1 = $6ceb47448afaefc1$export$36cf4525d9d7ca3c(dictAlt.Functor0());
    return {
        alt: function(x) {
            return function(y) {
                return $6ceb47448afaefc1$export$6320c031d6b6270f(alt(lowerCoyoneda1(x))(lowerCoyoneda1(y)));
            };
        },
        Functor0: function() {
            return $6ceb47448afaefc1$export$bd40aba71422b460;
        }
    };
};
var $6ceb47448afaefc1$export$f434c65db07c2e04 = function(dictPlus) {
    var altCoyoneda1 = $6ceb47448afaefc1$export$daa4182a46d81e3(dictPlus.Alt0());
    return {
        empty: $6ceb47448afaefc1$export$6320c031d6b6270f($j7FrY.empty(dictPlus)),
        Alt0: function() {
            return altCoyoneda1;
        }
    };
};
var $6ceb47448afaefc1$export$15bae6aadce01350 = function(dictAlternative) {
    var applicativeCoyoneda1 = $6ceb47448afaefc1$export$d337c8e043437698(dictAlternative.Applicative0());
    var plusCoyoneda1 = $6ceb47448afaefc1$export$f434c65db07c2e04(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeCoyoneda1;
        },
        Plus1: function() {
            return plusCoyoneda1;
        }
    };
};
var $6ceb47448afaefc1$export$e819965db94a810a = function(dictMonadPlus) {
    var monadCoyoneda1 = $6ceb47448afaefc1$export$dfa10a61f5e8217c(dictMonadPlus.Monad0());
    var alternativeCoyoneda1 = $6ceb47448afaefc1$export$15bae6aadce01350(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadCoyoneda1;
        },
        Alternative1: function() {
            return alternativeCoyoneda1;
        }
    };
};



var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $2jM6U = parcelRequire("2jM6U");
// Generated by purs version 0.15.16

var $iQTlW = parcelRequire("iQTlW");

var $dNwPt = parcelRequire("dNwPt");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");
// Generated by purs version 0.15.16

var $56VjJ = parcelRequire("56VjJ");

var $j7FrY = parcelRequire("j7FrY");

var $2XxiF = parcelRequire("2XxiF");
var $6549dcfedb2ef443$export$f120638069846a46 = function(x) {
    return x;
};
var $6549dcfedb2ef443$export$f0a5727b2ca16d5e = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            return "(Alternate " + (show(v) + ")");
        }
    };
};
var $6549dcfedb2ef443$export$74ec47bea0d6428d = function(dictAlt) {
    var alt = $56VjJ.alt(dictAlt);
    return {
        append: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        }
    };
};
var $6549dcfedb2ef443$export$aa34ebff6fae0aee = function(dictPlus) {
    return dictPlus;
};
var $6549dcfedb2ef443$export$19a135ecc0f14c10 = function(dictOrd) {
    return dictOrd;
};
var $6549dcfedb2ef443$export$48cb8ce12ac615c3 = function(dictOrd1) {
    return dictOrd1;
};
var $6549dcfedb2ef443$export$bbb1334b7c1198d0 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6549dcfedb2ef443$export$6e373ee97dbd5f68 = function(dictPlus) {
    var semigroupAlternate1 = $6549dcfedb2ef443$export$74ec47bea0d6428d(dictPlus.Alt0());
    return {
        mempty: $j7FrY.empty(dictPlus),
        Semigroup0: function() {
            return semigroupAlternate1;
        }
    };
};
var $6549dcfedb2ef443$export$748db8accd45ad60 = function(dictMonad) {
    return dictMonad;
};
var $6549dcfedb2ef443$export$912ca5da2b71dd9f = function(dictFunctor) {
    return dictFunctor;
};
var $6549dcfedb2ef443$export$45877b7cfa857b08 = function(dictExtend) {
    return dictExtend;
};
var $6549dcfedb2ef443$export$744ff834b4c5965c = function(dictEq) {
    return dictEq;
};
var $6549dcfedb2ef443$export$d92024b57d6b2a3c = function(dictEq1) {
    return dictEq1;
};
var $6549dcfedb2ef443$export$eecf6e094270f0ca = function(dictComonad) {
    return dictComonad;
};
var $6549dcfedb2ef443$export$d72d6cfff25c7246 = function(dictBounded) {
    return dictBounded;
};
var $6549dcfedb2ef443$export$8c4b2dd7bc59a54a = function(dictBind) {
    return dictBind;
};
var $6549dcfedb2ef443$export$cddaca6aae5306c4 = function(dictApply) {
    return dictApply;
};
var $6549dcfedb2ef443$export$3655a3e6b92e2b2a = function(dictApplicative) {
    return dictApplicative;
};
var $6549dcfedb2ef443$export$a428b63860a2744 = function(dictAlternative) {
    return dictAlternative;
};
var $6549dcfedb2ef443$export$ca414a3aae651090 = function(dictAlt) {
    return dictAlt;
};



var $46y1S = parcelRequire("46y1S");

var $gwBF5 = parcelRequire("gwBF5");

var $3Xcli = parcelRequire("3Xcli");

var $7O0Q4 = parcelRequire("7O0Q4");
// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $gwBF5 = parcelRequire("gwBF5");
var $d086fc2b8a6f60eb$var$OrdBox = /* #__PURE__ */ function() {
    function OrdBox(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    OrdBox.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new OrdBox(value0, value1, value2);
            };
        };
    };
    return OrdBox;
}();
var $d086fc2b8a6f60eb$export$6a3ff69c92a20cd2 = function(v) {
    return v.value2;
};
var $d086fc2b8a6f60eb$export$c2a88327b4ac50f8 = function(dictOrd) {
    return $d086fc2b8a6f60eb$var$OrdBox.create($aJhEx.eq(dictOrd.Eq0()))($gwBF5.compare(dictOrd));
};
var $d086fc2b8a6f60eb$export$1aabb6943cc59794 = {
    eq: function(v) {
        return function(v1) {
            return v.value0(v.value2)(v1.value2);
        };
    }
};
var $d086fc2b8a6f60eb$export$a4fa2470ead172bd = {
    compare: function(v) {
        return function(v1) {
            return v.value1(v.value2)(v1.value2);
        };
    },
    Eq0: function() {
        return $d086fc2b8a6f60eb$export$1aabb6943cc59794;
    }
};


var $b10d220e1d5af382$var$un = /* #__PURE__ */ $46y1S.un();
var $b10d220e1d5af382$var$ordTuple = /* #__PURE__ */ $7O0Q4.ordTuple($gwBF5.ordString)($d086fc2b8a6f60eb$export$a4fa2470ead172bd);
var $b10d220e1d5af382$var$foldSubmap = /* #__PURE__ */ $aHmxC.foldSubmap($b10d220e1d5af382$var$ordTuple);
var $b10d220e1d5af382$var$pop1 = /* #__PURE__ */ $aHmxC.pop($b10d220e1d5af382$var$ordTuple);
var $b10d220e1d5af382$var$lookup1 = /* #__PURE__ */ $aHmxC.lookup($b10d220e1d5af382$var$ordTuple);
var $b10d220e1d5af382$var$insert1 = /* #__PURE__ */ $aHmxC.insert($b10d220e1d5af382$var$ordTuple);
var $b10d220e1d5af382$var$SlotStorage = function(x) {
    return x;
};
var $b10d220e1d5af382$export$bbd679b9fab4c947 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var foldSubmap1 = $b10d220e1d5af382$var$foldSubmap($6549dcfedb2ef443$export$6e373ee97dbd5f68($aHmxC.plusMap(dictOrd)));
            return function(sym) {
                return function(v) {
                    var key = reflectSymbol(sym);
                    var go = function(v1) {
                        return function(val) {
                            if (key === v1.value0) return $aHmxC.singleton($d086fc2b8a6f60eb$export$6a3ff69c92a20cd2(v1.value1))(val);
                            if ($iQTlW.otherwise) return $aHmxC.empty;
                            throw new Error("Failed pattern match at Halogen.Data.Slot (line 121, column 3 - line 123, column 38): " + [
                                v1.constructor.name,
                                val.constructor.name
                            ]);
                        };
                    };
                    return $b10d220e1d5af382$var$un($6549dcfedb2ef443$export$f120638069846a46)(foldSubmap1($h2xUu.Nothing.value)($h2xUu.Nothing.value)(go)(v));
                };
            };
        };
    };
};
var $b10d220e1d5af382$export$3e41007ebfff0e64 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $d086fc2b8a6f60eb$export$c2a88327b4ac50f8(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(v) {
                        return $b10d220e1d5af382$var$pop1(new $7O0Q4.Tuple(reflectSymbol(sym), mkOrdBox(key)))(v);
                    };
                };
            };
        };
    };
};
var $b10d220e1d5af382$export$dfc7155ac0343b8 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $d086fc2b8a6f60eb$export$c2a88327b4ac50f8(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(v) {
                        return $b10d220e1d5af382$var$lookup1(new $7O0Q4.Tuple(reflectSymbol(sym), mkOrdBox(key)))(v);
                    };
                };
            };
        };
    };
};
var $b10d220e1d5af382$export$21a5ca8aa77d35ff = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $3Xcli.reflectSymbol(dictIsSymbol);
        return function(dictOrd) {
            var mkOrdBox = $d086fc2b8a6f60eb$export$c2a88327b4ac50f8(dictOrd);
            return function(sym) {
                return function(key) {
                    return function(val) {
                        return function(v) {
                            return $b10d220e1d5af382$var$insert1(new $7O0Q4.Tuple(reflectSymbol(sym), mkOrdBox(key)))(val)(v);
                        };
                    };
                };
            };
        };
    };
};
var $b10d220e1d5af382$export$91dbfdfb14db6990 = function(dictApplicative) {
    var traverse_ = $dNwPt.traverse_(dictApplicative)($aHmxC.foldableMap);
    return function(v) {
        return function(k) {
            return traverse_(function($54) {
                return k($54);
            })(v);
        };
    };
};
var $b10d220e1d5af382$export$6e22c362a0406a2c = $aHmxC.empty;


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $ecaed3b9c37d7b87$export$7ba2b3d677b0db1c = /* #__PURE__ */ function() {
    function AutocompleteOff() {}
    AutocompleteOff.value = new AutocompleteOff();
    return AutocompleteOff;
}();
var $ecaed3b9c37d7b87$export$1ef0df3f3e6a4dab = /* #__PURE__ */ function() {
    function AutocompleteOn() {}
    AutocompleteOn.value = new AutocompleteOn();
    return AutocompleteOn;
}();
var $ecaed3b9c37d7b87$export$4da01cb598a0d97e = /* #__PURE__ */ function() {
    function AutocompleteName() {}
    AutocompleteName.value = new AutocompleteName();
    return AutocompleteName;
}();
var $ecaed3b9c37d7b87$export$ccb63fd7a749a381 = /* #__PURE__ */ function() {
    function AutocompleteHonorificPrefix() {}
    AutocompleteHonorificPrefix.value = new AutocompleteHonorificPrefix();
    return AutocompleteHonorificPrefix;
}();
var $ecaed3b9c37d7b87$export$a2e3a2bb787472eb = /* #__PURE__ */ function() {
    function AutocompleteGivenName() {}
    AutocompleteGivenName.value = new AutocompleteGivenName();
    return AutocompleteGivenName;
}();
var $ecaed3b9c37d7b87$export$c2899da73c95f826 = /* #__PURE__ */ function() {
    function AutocompleteAdditionalName() {}
    AutocompleteAdditionalName.value = new AutocompleteAdditionalName();
    return AutocompleteAdditionalName;
}();
var $ecaed3b9c37d7b87$export$b189863462ae27fe = /* #__PURE__ */ function() {
    function AutocompleteFamilyName() {}
    AutocompleteFamilyName.value = new AutocompleteFamilyName();
    return AutocompleteFamilyName;
}();
var $ecaed3b9c37d7b87$export$5481c9b080fac1ad = /* #__PURE__ */ function() {
    function AutocompleteHonorificSuffix() {}
    AutocompleteHonorificSuffix.value = new AutocompleteHonorificSuffix();
    return AutocompleteHonorificSuffix;
}();
var $ecaed3b9c37d7b87$export$ed6c67e3f00c02f7 = /* #__PURE__ */ function() {
    function AutocompleteNickname() {}
    AutocompleteNickname.value = new AutocompleteNickname();
    return AutocompleteNickname;
}();
var $ecaed3b9c37d7b87$export$3f2abff6b2574d28 = /* #__PURE__ */ function() {
    function AutocompleteEmail() {}
    AutocompleteEmail.value = new AutocompleteEmail();
    return AutocompleteEmail;
}();
var $ecaed3b9c37d7b87$export$8ef7db4a55783560 = /* #__PURE__ */ function() {
    function AutocompleteUsername() {}
    AutocompleteUsername.value = new AutocompleteUsername();
    return AutocompleteUsername;
}();
var $ecaed3b9c37d7b87$export$2aec4081bfc982fb = /* #__PURE__ */ function() {
    function AutocompleteNewPassword() {}
    AutocompleteNewPassword.value = new AutocompleteNewPassword();
    return AutocompleteNewPassword;
}();
var $ecaed3b9c37d7b87$export$8ee6fb6ac028afda = /* #__PURE__ */ function() {
    function AutocompleteCurrentPassword() {}
    AutocompleteCurrentPassword.value = new AutocompleteCurrentPassword();
    return AutocompleteCurrentPassword;
}();
var $ecaed3b9c37d7b87$export$6f27218568808639 = /* #__PURE__ */ function() {
    function AutocompleteOneTimeCode() {}
    AutocompleteOneTimeCode.value = new AutocompleteOneTimeCode();
    return AutocompleteOneTimeCode;
}();
var $ecaed3b9c37d7b87$export$9748581da6bbbe4e = /* #__PURE__ */ function() {
    function AutocompleteOrganizationTitle() {}
    AutocompleteOrganizationTitle.value = new AutocompleteOrganizationTitle();
    return AutocompleteOrganizationTitle;
}();
var $ecaed3b9c37d7b87$export$5fd9f780846e028b = /* #__PURE__ */ function() {
    function AutocompleteOrganization() {}
    AutocompleteOrganization.value = new AutocompleteOrganization();
    return AutocompleteOrganization;
}();
var $ecaed3b9c37d7b87$export$499720fb85152dfe = /* #__PURE__ */ function() {
    function AutocompleteStreetAddress() {}
    AutocompleteStreetAddress.value = new AutocompleteStreetAddress();
    return AutocompleteStreetAddress;
}();
var $ecaed3b9c37d7b87$export$6b6488e90da63d6 = /* #__PURE__ */ function() {
    function AutocompleteAddressLine1() {}
    AutocompleteAddressLine1.value = new AutocompleteAddressLine1();
    return AutocompleteAddressLine1;
}();
var $ecaed3b9c37d7b87$export$92dfe98bc9dbafde = /* #__PURE__ */ function() {
    function AutocompleteAddressLine2() {}
    AutocompleteAddressLine2.value = new AutocompleteAddressLine2();
    return AutocompleteAddressLine2;
}();
var $ecaed3b9c37d7b87$export$ea74132c1bd19261 = /* #__PURE__ */ function() {
    function AutocompleteAddressLine3() {}
    AutocompleteAddressLine3.value = new AutocompleteAddressLine3();
    return AutocompleteAddressLine3;
}();
var $ecaed3b9c37d7b87$export$e5454c7695ddbd5c = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel1() {}
    AutocompleteAddressLevel1.value = new AutocompleteAddressLevel1();
    return AutocompleteAddressLevel1;
}();
var $ecaed3b9c37d7b87$export$af0e2cc0795570d9 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel2() {}
    AutocompleteAddressLevel2.value = new AutocompleteAddressLevel2();
    return AutocompleteAddressLevel2;
}();
var $ecaed3b9c37d7b87$export$f76ce82784afe674 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel3() {}
    AutocompleteAddressLevel3.value = new AutocompleteAddressLevel3();
    return AutocompleteAddressLevel3;
}();
var $ecaed3b9c37d7b87$export$5f9c079ff6708773 = /* #__PURE__ */ function() {
    function AutocompleteAddressLevel4() {}
    AutocompleteAddressLevel4.value = new AutocompleteAddressLevel4();
    return AutocompleteAddressLevel4;
}();
var $ecaed3b9c37d7b87$export$44c5bb026cbe6e37 = /* #__PURE__ */ function() {
    function AutocompleteCountry() {}
    AutocompleteCountry.value = new AutocompleteCountry();
    return AutocompleteCountry;
}();
var $ecaed3b9c37d7b87$export$e259ef3995a99fd4 = /* #__PURE__ */ function() {
    function AutocompleteCountryName() {}
    AutocompleteCountryName.value = new AutocompleteCountryName();
    return AutocompleteCountryName;
}();
var $ecaed3b9c37d7b87$export$f95f909e01aa4cb3 = /* #__PURE__ */ function() {
    function AutocompletePostalCode() {}
    AutocompletePostalCode.value = new AutocompletePostalCode();
    return AutocompletePostalCode;
}();
var $ecaed3b9c37d7b87$export$67ade628725afe90 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardName() {}
    AutocompleteCreditCardName.value = new AutocompleteCreditCardName();
    return AutocompleteCreditCardName;
}();
var $ecaed3b9c37d7b87$export$f03ef3c27a8e4a4b = /* #__PURE__ */ function() {
    function AutocompleteCreditCardGivenName() {}
    AutocompleteCreditCardGivenName.value = new AutocompleteCreditCardGivenName();
    return AutocompleteCreditCardGivenName;
}();
var $ecaed3b9c37d7b87$export$1b45801580e5182f = /* #__PURE__ */ function() {
    function AutocompleteCreditCardAdditionalName() {}
    AutocompleteCreditCardAdditionalName.value = new AutocompleteCreditCardAdditionalName();
    return AutocompleteCreditCardAdditionalName;
}();
var $ecaed3b9c37d7b87$export$d906c17550f3b6f1 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardFamilyName() {}
    AutocompleteCreditCardFamilyName.value = new AutocompleteCreditCardFamilyName();
    return AutocompleteCreditCardFamilyName;
}();
var $ecaed3b9c37d7b87$export$267a9616c09f33fa = /* #__PURE__ */ function() {
    function AutocompleteCreditCardNumber() {}
    AutocompleteCreditCardNumber.value = new AutocompleteCreditCardNumber();
    return AutocompleteCreditCardNumber;
}();
var $ecaed3b9c37d7b87$export$4ac537c498251bbf = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpiration() {}
    AutocompleteCreditCardExpiration.value = new AutocompleteCreditCardExpiration();
    return AutocompleteCreditCardExpiration;
}();
var $ecaed3b9c37d7b87$export$2e15cf96bd811454 = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpirationMonth() {}
    AutocompleteCreditCardExpirationMonth.value = new AutocompleteCreditCardExpirationMonth();
    return AutocompleteCreditCardExpirationMonth;
}();
var $ecaed3b9c37d7b87$export$7c4efb1d2d0a7d5d = /* #__PURE__ */ function() {
    function AutocompleteCreditCardExpirationYear() {}
    AutocompleteCreditCardExpirationYear.value = new AutocompleteCreditCardExpirationYear();
    return AutocompleteCreditCardExpirationYear;
}();
var $ecaed3b9c37d7b87$export$42f27b71e570e84c = /* #__PURE__ */ function() {
    function AutocompleteCreditCardSecurityCode() {}
    AutocompleteCreditCardSecurityCode.value = new AutocompleteCreditCardSecurityCode();
    return AutocompleteCreditCardSecurityCode;
}();
var $ecaed3b9c37d7b87$export$7dd055ac3e2d902c = /* #__PURE__ */ function() {
    function AutocompleteCreditCardType() {}
    AutocompleteCreditCardType.value = new AutocompleteCreditCardType();
    return AutocompleteCreditCardType;
}();
var $ecaed3b9c37d7b87$export$918eb55efc9f2e5c = /* #__PURE__ */ function() {
    function AutocompleteTransactionCurrency() {}
    AutocompleteTransactionCurrency.value = new AutocompleteTransactionCurrency();
    return AutocompleteTransactionCurrency;
}();
var $ecaed3b9c37d7b87$export$9d4a96b43ef247de = /* #__PURE__ */ function() {
    function AutocompleteTransactionAmount() {}
    AutocompleteTransactionAmount.value = new AutocompleteTransactionAmount();
    return AutocompleteTransactionAmount;
}();
var $ecaed3b9c37d7b87$export$f69bc69473d6d1fa = /* #__PURE__ */ function() {
    function AutocompleteLanguage() {}
    AutocompleteLanguage.value = new AutocompleteLanguage();
    return AutocompleteLanguage;
}();
var $ecaed3b9c37d7b87$export$db103677e4262f74 = /* #__PURE__ */ function() {
    function AutocompleteBirthday() {}
    AutocompleteBirthday.value = new AutocompleteBirthday();
    return AutocompleteBirthday;
}();
var $ecaed3b9c37d7b87$export$976267f1375fd072 = /* #__PURE__ */ function() {
    function AutocompleteBirthdayDay() {}
    AutocompleteBirthdayDay.value = new AutocompleteBirthdayDay();
    return AutocompleteBirthdayDay;
}();
var $ecaed3b9c37d7b87$export$345017daa9311763 = /* #__PURE__ */ function() {
    function AutocompleteBirthdayMonth() {}
    AutocompleteBirthdayMonth.value = new AutocompleteBirthdayMonth();
    return AutocompleteBirthdayMonth;
}();
var $ecaed3b9c37d7b87$export$a58218c48fdc359f = /* #__PURE__ */ function() {
    function AutocompleteBirthdayYear() {}
    AutocompleteBirthdayYear.value = new AutocompleteBirthdayYear();
    return AutocompleteBirthdayYear;
}();
var $ecaed3b9c37d7b87$export$41a3d5735ecfd56f = /* #__PURE__ */ function() {
    function AutocompleteSex() {}
    AutocompleteSex.value = new AutocompleteSex();
    return AutocompleteSex;
}();
var $ecaed3b9c37d7b87$export$dc25bbd279bd7147 = /* #__PURE__ */ function() {
    function AutocompleteTelephone() {}
    AutocompleteTelephone.value = new AutocompleteTelephone();
    return AutocompleteTelephone;
}();
var $ecaed3b9c37d7b87$export$f37489576ac4e3f5 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneCountryCode() {}
    AutocompleteTelephoneCountryCode.value = new AutocompleteTelephoneCountryCode();
    return AutocompleteTelephoneCountryCode;
}();
var $ecaed3b9c37d7b87$export$85265d7dd09c0246 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneNational() {}
    AutocompleteTelephoneNational.value = new AutocompleteTelephoneNational();
    return AutocompleteTelephoneNational;
}();
var $ecaed3b9c37d7b87$export$fb4e6d66ca842722 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneAreaCode() {}
    AutocompleteTelephoneAreaCode.value = new AutocompleteTelephoneAreaCode();
    return AutocompleteTelephoneAreaCode;
}();
var $ecaed3b9c37d7b87$export$149dc202c94ba771 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocal() {}
    AutocompleteTelephoneLocal.value = new AutocompleteTelephoneLocal();
    return AutocompleteTelephoneLocal;
}();
var $ecaed3b9c37d7b87$export$c3fb770456fc7a2e = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocalPrefix() {}
    AutocompleteTelephoneLocalPrefix.value = new AutocompleteTelephoneLocalPrefix();
    return AutocompleteTelephoneLocalPrefix;
}();
var $ecaed3b9c37d7b87$export$97df2b5615a1b054 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneLocalSuffix() {}
    AutocompleteTelephoneLocalSuffix.value = new AutocompleteTelephoneLocalSuffix();
    return AutocompleteTelephoneLocalSuffix;
}();
var $ecaed3b9c37d7b87$export$7aa0294a80b301d4 = /* #__PURE__ */ function() {
    function AutocompleteTelephoneExtension() {}
    AutocompleteTelephoneExtension.value = new AutocompleteTelephoneExtension();
    return AutocompleteTelephoneExtension;
}();
var $ecaed3b9c37d7b87$export$1294e96da410451d = /* #__PURE__ */ function() {
    function AutocompleteIMPP() {}
    AutocompleteIMPP.value = new AutocompleteIMPP();
    return AutocompleteIMPP;
}();
var $ecaed3b9c37d7b87$export$acf71e1d98edce93 = /* #__PURE__ */ function() {
    function AutocompleteURL() {}
    AutocompleteURL.value = new AutocompleteURL();
    return AutocompleteURL;
}();
var $ecaed3b9c37d7b87$export$7a4045fb80d6a5eb = /* #__PURE__ */ function() {
    function AutocompletePhoto() {}
    AutocompletePhoto.value = new AutocompletePhoto();
    return AutocompletePhoto;
}();
var $ecaed3b9c37d7b87$export$9b8eae2964bb4cd5 = function(v) {
    if (v instanceof $ecaed3b9c37d7b87$export$7ba2b3d677b0db1c) return "off";
    if (v instanceof $ecaed3b9c37d7b87$export$1ef0df3f3e6a4dab) return "on";
    if (v instanceof $ecaed3b9c37d7b87$export$4da01cb598a0d97e) return "name";
    if (v instanceof $ecaed3b9c37d7b87$export$ccb63fd7a749a381) return "honorific-prefix";
    if (v instanceof $ecaed3b9c37d7b87$export$a2e3a2bb787472eb) return "given-name";
    if (v instanceof $ecaed3b9c37d7b87$export$c2899da73c95f826) return "additional-name";
    if (v instanceof $ecaed3b9c37d7b87$export$b189863462ae27fe) return "family-name";
    if (v instanceof $ecaed3b9c37d7b87$export$5481c9b080fac1ad) return "honorific-suffix";
    if (v instanceof $ecaed3b9c37d7b87$export$ed6c67e3f00c02f7) return "nickname";
    if (v instanceof $ecaed3b9c37d7b87$export$3f2abff6b2574d28) return "email";
    if (v instanceof $ecaed3b9c37d7b87$export$8ef7db4a55783560) return "username";
    if (v instanceof $ecaed3b9c37d7b87$export$2aec4081bfc982fb) return "new-password";
    if (v instanceof $ecaed3b9c37d7b87$export$8ee6fb6ac028afda) return "current-password";
    if (v instanceof $ecaed3b9c37d7b87$export$6f27218568808639) return "one-time-code";
    if (v instanceof $ecaed3b9c37d7b87$export$9748581da6bbbe4e) return "organization-title";
    if (v instanceof $ecaed3b9c37d7b87$export$5fd9f780846e028b) return "organization";
    if (v instanceof $ecaed3b9c37d7b87$export$499720fb85152dfe) return "street-address";
    if (v instanceof $ecaed3b9c37d7b87$export$6b6488e90da63d6) return "address-line1";
    if (v instanceof $ecaed3b9c37d7b87$export$92dfe98bc9dbafde) return "address-line2";
    if (v instanceof $ecaed3b9c37d7b87$export$ea74132c1bd19261) return "address-line3";
    if (v instanceof $ecaed3b9c37d7b87$export$e5454c7695ddbd5c) return "address-level1";
    if (v instanceof $ecaed3b9c37d7b87$export$af0e2cc0795570d9) return "address-level2";
    if (v instanceof $ecaed3b9c37d7b87$export$f76ce82784afe674) return "address-level3";
    if (v instanceof $ecaed3b9c37d7b87$export$5f9c079ff6708773) return "address-level4";
    if (v instanceof $ecaed3b9c37d7b87$export$44c5bb026cbe6e37) return "country";
    if (v instanceof $ecaed3b9c37d7b87$export$e259ef3995a99fd4) return "country-name";
    if (v instanceof $ecaed3b9c37d7b87$export$f95f909e01aa4cb3) return "postal-code";
    if (v instanceof $ecaed3b9c37d7b87$export$67ade628725afe90) return "cc-name";
    if (v instanceof $ecaed3b9c37d7b87$export$f03ef3c27a8e4a4b) return "cc-given-name";
    if (v instanceof $ecaed3b9c37d7b87$export$1b45801580e5182f) return "cc-additional-name";
    if (v instanceof $ecaed3b9c37d7b87$export$d906c17550f3b6f1) return "cc-family-name";
    if (v instanceof $ecaed3b9c37d7b87$export$267a9616c09f33fa) return "cc-number";
    if (v instanceof $ecaed3b9c37d7b87$export$4ac537c498251bbf) return "cc-exp";
    if (v instanceof $ecaed3b9c37d7b87$export$2e15cf96bd811454) return "cc-exp-month";
    if (v instanceof $ecaed3b9c37d7b87$export$7c4efb1d2d0a7d5d) return "cc-exp-year";
    if (v instanceof $ecaed3b9c37d7b87$export$42f27b71e570e84c) return "cc-csc";
    if (v instanceof $ecaed3b9c37d7b87$export$7dd055ac3e2d902c) return "cc-type";
    if (v instanceof $ecaed3b9c37d7b87$export$918eb55efc9f2e5c) return "transaction-currency";
    if (v instanceof $ecaed3b9c37d7b87$export$9d4a96b43ef247de) return "transaction-amount";
    if (v instanceof $ecaed3b9c37d7b87$export$f69bc69473d6d1fa) return "language";
    if (v instanceof $ecaed3b9c37d7b87$export$db103677e4262f74) return "bday";
    if (v instanceof $ecaed3b9c37d7b87$export$976267f1375fd072) return "bday-day";
    if (v instanceof $ecaed3b9c37d7b87$export$345017daa9311763) return "bday-month";
    if (v instanceof $ecaed3b9c37d7b87$export$a58218c48fdc359f) return "bday-year";
    if (v instanceof $ecaed3b9c37d7b87$export$41a3d5735ecfd56f) return "sex";
    if (v instanceof $ecaed3b9c37d7b87$export$dc25bbd279bd7147) return "tel";
    if (v instanceof $ecaed3b9c37d7b87$export$f37489576ac4e3f5) return "tel-country-code";
    if (v instanceof $ecaed3b9c37d7b87$export$85265d7dd09c0246) return "tel-national";
    if (v instanceof $ecaed3b9c37d7b87$export$fb4e6d66ca842722) return "telarea-code";
    if (v instanceof $ecaed3b9c37d7b87$export$149dc202c94ba771) return "tel-local";
    if (v instanceof $ecaed3b9c37d7b87$export$c3fb770456fc7a2e) return "tel-local-prefix";
    if (v instanceof $ecaed3b9c37d7b87$export$97df2b5615a1b054) return "tel-local-suffix";
    if (v instanceof $ecaed3b9c37d7b87$export$7aa0294a80b301d4) return "tel-extension";
    if (v instanceof $ecaed3b9c37d7b87$export$1294e96da410451d) return "impp";
    if (v instanceof $ecaed3b9c37d7b87$export$acf71e1d98edce93) return "url";
    if (v instanceof $ecaed3b9c37d7b87$export$7a4045fb80d6a5eb) return "photo";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.AutocompleteType (line 67, column 26 - line 123, column 31): " + [
        v.constructor.name
    ]);
};
var $ecaed3b9c37d7b87$export$51a22934b9cdbac4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ecaed3b9c37d7b87$export$7ba2b3d677b0db1c && y instanceof $ecaed3b9c37d7b87$export$7ba2b3d677b0db1c) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$1ef0df3f3e6a4dab && y instanceof $ecaed3b9c37d7b87$export$1ef0df3f3e6a4dab) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$4da01cb598a0d97e && y instanceof $ecaed3b9c37d7b87$export$4da01cb598a0d97e) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$ccb63fd7a749a381 && y instanceof $ecaed3b9c37d7b87$export$ccb63fd7a749a381) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$a2e3a2bb787472eb && y instanceof $ecaed3b9c37d7b87$export$a2e3a2bb787472eb) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$c2899da73c95f826 && y instanceof $ecaed3b9c37d7b87$export$c2899da73c95f826) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$b189863462ae27fe && y instanceof $ecaed3b9c37d7b87$export$b189863462ae27fe) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$5481c9b080fac1ad && y instanceof $ecaed3b9c37d7b87$export$5481c9b080fac1ad) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$ed6c67e3f00c02f7 && y instanceof $ecaed3b9c37d7b87$export$ed6c67e3f00c02f7) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$3f2abff6b2574d28 && y instanceof $ecaed3b9c37d7b87$export$3f2abff6b2574d28) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$8ef7db4a55783560 && y instanceof $ecaed3b9c37d7b87$export$8ef7db4a55783560) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$2aec4081bfc982fb && y instanceof $ecaed3b9c37d7b87$export$2aec4081bfc982fb) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$8ee6fb6ac028afda && y instanceof $ecaed3b9c37d7b87$export$8ee6fb6ac028afda) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$6f27218568808639 && y instanceof $ecaed3b9c37d7b87$export$6f27218568808639) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$9748581da6bbbe4e && y instanceof $ecaed3b9c37d7b87$export$9748581da6bbbe4e) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$5fd9f780846e028b && y instanceof $ecaed3b9c37d7b87$export$5fd9f780846e028b) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$499720fb85152dfe && y instanceof $ecaed3b9c37d7b87$export$499720fb85152dfe) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$6b6488e90da63d6 && y instanceof $ecaed3b9c37d7b87$export$6b6488e90da63d6) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$92dfe98bc9dbafde && y instanceof $ecaed3b9c37d7b87$export$92dfe98bc9dbafde) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$ea74132c1bd19261 && y instanceof $ecaed3b9c37d7b87$export$ea74132c1bd19261) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$e5454c7695ddbd5c && y instanceof $ecaed3b9c37d7b87$export$e5454c7695ddbd5c) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$af0e2cc0795570d9 && y instanceof $ecaed3b9c37d7b87$export$af0e2cc0795570d9) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$f76ce82784afe674 && y instanceof $ecaed3b9c37d7b87$export$f76ce82784afe674) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$5f9c079ff6708773 && y instanceof $ecaed3b9c37d7b87$export$5f9c079ff6708773) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$44c5bb026cbe6e37 && y instanceof $ecaed3b9c37d7b87$export$44c5bb026cbe6e37) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$e259ef3995a99fd4 && y instanceof $ecaed3b9c37d7b87$export$e259ef3995a99fd4) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$f95f909e01aa4cb3 && y instanceof $ecaed3b9c37d7b87$export$f95f909e01aa4cb3) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$67ade628725afe90 && y instanceof $ecaed3b9c37d7b87$export$67ade628725afe90) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$f03ef3c27a8e4a4b && y instanceof $ecaed3b9c37d7b87$export$f03ef3c27a8e4a4b) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$1b45801580e5182f && y instanceof $ecaed3b9c37d7b87$export$1b45801580e5182f) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$d906c17550f3b6f1 && y instanceof $ecaed3b9c37d7b87$export$d906c17550f3b6f1) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$267a9616c09f33fa && y instanceof $ecaed3b9c37d7b87$export$267a9616c09f33fa) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$4ac537c498251bbf && y instanceof $ecaed3b9c37d7b87$export$4ac537c498251bbf) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$2e15cf96bd811454 && y instanceof $ecaed3b9c37d7b87$export$2e15cf96bd811454) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$7c4efb1d2d0a7d5d && y instanceof $ecaed3b9c37d7b87$export$7c4efb1d2d0a7d5d) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$42f27b71e570e84c && y instanceof $ecaed3b9c37d7b87$export$42f27b71e570e84c) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$7dd055ac3e2d902c && y instanceof $ecaed3b9c37d7b87$export$7dd055ac3e2d902c) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$918eb55efc9f2e5c && y instanceof $ecaed3b9c37d7b87$export$918eb55efc9f2e5c) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$9d4a96b43ef247de && y instanceof $ecaed3b9c37d7b87$export$9d4a96b43ef247de) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$f69bc69473d6d1fa && y instanceof $ecaed3b9c37d7b87$export$f69bc69473d6d1fa) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$db103677e4262f74 && y instanceof $ecaed3b9c37d7b87$export$db103677e4262f74) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$976267f1375fd072 && y instanceof $ecaed3b9c37d7b87$export$976267f1375fd072) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$345017daa9311763 && y instanceof $ecaed3b9c37d7b87$export$345017daa9311763) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$a58218c48fdc359f && y instanceof $ecaed3b9c37d7b87$export$a58218c48fdc359f) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$41a3d5735ecfd56f && y instanceof $ecaed3b9c37d7b87$export$41a3d5735ecfd56f) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$dc25bbd279bd7147 && y instanceof $ecaed3b9c37d7b87$export$dc25bbd279bd7147) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$f37489576ac4e3f5 && y instanceof $ecaed3b9c37d7b87$export$f37489576ac4e3f5) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$85265d7dd09c0246 && y instanceof $ecaed3b9c37d7b87$export$85265d7dd09c0246) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$fb4e6d66ca842722 && y instanceof $ecaed3b9c37d7b87$export$fb4e6d66ca842722) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$149dc202c94ba771 && y instanceof $ecaed3b9c37d7b87$export$149dc202c94ba771) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$c3fb770456fc7a2e && y instanceof $ecaed3b9c37d7b87$export$c3fb770456fc7a2e) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$97df2b5615a1b054 && y instanceof $ecaed3b9c37d7b87$export$97df2b5615a1b054) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$7aa0294a80b301d4 && y instanceof $ecaed3b9c37d7b87$export$7aa0294a80b301d4) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$1294e96da410451d && y instanceof $ecaed3b9c37d7b87$export$1294e96da410451d) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$acf71e1d98edce93 && y instanceof $ecaed3b9c37d7b87$export$acf71e1d98edce93) return true;
            if (x instanceof $ecaed3b9c37d7b87$export$7a4045fb80d6a5eb && y instanceof $ecaed3b9c37d7b87$export$7a4045fb80d6a5eb) return true;
            return false;
        };
    }
};
var $ecaed3b9c37d7b87$export$72232ffdb2635391 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ecaed3b9c37d7b87$export$7ba2b3d677b0db1c && y instanceof $ecaed3b9c37d7b87$export$7ba2b3d677b0db1c) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$7ba2b3d677b0db1c) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$7ba2b3d677b0db1c) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$1ef0df3f3e6a4dab && y instanceof $ecaed3b9c37d7b87$export$1ef0df3f3e6a4dab) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$1ef0df3f3e6a4dab) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$1ef0df3f3e6a4dab) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$4da01cb598a0d97e && y instanceof $ecaed3b9c37d7b87$export$4da01cb598a0d97e) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$4da01cb598a0d97e) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$4da01cb598a0d97e) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$ccb63fd7a749a381 && y instanceof $ecaed3b9c37d7b87$export$ccb63fd7a749a381) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$ccb63fd7a749a381) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$ccb63fd7a749a381) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$a2e3a2bb787472eb && y instanceof $ecaed3b9c37d7b87$export$a2e3a2bb787472eb) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$a2e3a2bb787472eb) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$a2e3a2bb787472eb) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$c2899da73c95f826 && y instanceof $ecaed3b9c37d7b87$export$c2899da73c95f826) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$c2899da73c95f826) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$c2899da73c95f826) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$b189863462ae27fe && y instanceof $ecaed3b9c37d7b87$export$b189863462ae27fe) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$b189863462ae27fe) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$b189863462ae27fe) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$5481c9b080fac1ad && y instanceof $ecaed3b9c37d7b87$export$5481c9b080fac1ad) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$5481c9b080fac1ad) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$5481c9b080fac1ad) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$ed6c67e3f00c02f7 && y instanceof $ecaed3b9c37d7b87$export$ed6c67e3f00c02f7) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$ed6c67e3f00c02f7) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$ed6c67e3f00c02f7) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$3f2abff6b2574d28 && y instanceof $ecaed3b9c37d7b87$export$3f2abff6b2574d28) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$3f2abff6b2574d28) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$3f2abff6b2574d28) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$8ef7db4a55783560 && y instanceof $ecaed3b9c37d7b87$export$8ef7db4a55783560) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$8ef7db4a55783560) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$8ef7db4a55783560) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$2aec4081bfc982fb && y instanceof $ecaed3b9c37d7b87$export$2aec4081bfc982fb) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$2aec4081bfc982fb) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$2aec4081bfc982fb) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$8ee6fb6ac028afda && y instanceof $ecaed3b9c37d7b87$export$8ee6fb6ac028afda) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$8ee6fb6ac028afda) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$8ee6fb6ac028afda) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$6f27218568808639 && y instanceof $ecaed3b9c37d7b87$export$6f27218568808639) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$6f27218568808639) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$6f27218568808639) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$9748581da6bbbe4e && y instanceof $ecaed3b9c37d7b87$export$9748581da6bbbe4e) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$9748581da6bbbe4e) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$9748581da6bbbe4e) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$5fd9f780846e028b && y instanceof $ecaed3b9c37d7b87$export$5fd9f780846e028b) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$5fd9f780846e028b) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$5fd9f780846e028b) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$499720fb85152dfe && y instanceof $ecaed3b9c37d7b87$export$499720fb85152dfe) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$499720fb85152dfe) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$499720fb85152dfe) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$6b6488e90da63d6 && y instanceof $ecaed3b9c37d7b87$export$6b6488e90da63d6) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$6b6488e90da63d6) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$6b6488e90da63d6) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$92dfe98bc9dbafde && y instanceof $ecaed3b9c37d7b87$export$92dfe98bc9dbafde) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$92dfe98bc9dbafde) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$92dfe98bc9dbafde) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$ea74132c1bd19261 && y instanceof $ecaed3b9c37d7b87$export$ea74132c1bd19261) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$ea74132c1bd19261) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$ea74132c1bd19261) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$e5454c7695ddbd5c && y instanceof $ecaed3b9c37d7b87$export$e5454c7695ddbd5c) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$e5454c7695ddbd5c) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$e5454c7695ddbd5c) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$af0e2cc0795570d9 && y instanceof $ecaed3b9c37d7b87$export$af0e2cc0795570d9) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$af0e2cc0795570d9) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$af0e2cc0795570d9) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f76ce82784afe674 && y instanceof $ecaed3b9c37d7b87$export$f76ce82784afe674) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f76ce82784afe674) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$f76ce82784afe674) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$5f9c079ff6708773 && y instanceof $ecaed3b9c37d7b87$export$5f9c079ff6708773) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$5f9c079ff6708773) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$5f9c079ff6708773) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$44c5bb026cbe6e37 && y instanceof $ecaed3b9c37d7b87$export$44c5bb026cbe6e37) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$44c5bb026cbe6e37) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$44c5bb026cbe6e37) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$e259ef3995a99fd4 && y instanceof $ecaed3b9c37d7b87$export$e259ef3995a99fd4) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$e259ef3995a99fd4) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$e259ef3995a99fd4) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f95f909e01aa4cb3 && y instanceof $ecaed3b9c37d7b87$export$f95f909e01aa4cb3) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f95f909e01aa4cb3) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$f95f909e01aa4cb3) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$67ade628725afe90 && y instanceof $ecaed3b9c37d7b87$export$67ade628725afe90) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$67ade628725afe90) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$67ade628725afe90) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f03ef3c27a8e4a4b && y instanceof $ecaed3b9c37d7b87$export$f03ef3c27a8e4a4b) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f03ef3c27a8e4a4b) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$f03ef3c27a8e4a4b) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$1b45801580e5182f && y instanceof $ecaed3b9c37d7b87$export$1b45801580e5182f) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$1b45801580e5182f) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$1b45801580e5182f) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$d906c17550f3b6f1 && y instanceof $ecaed3b9c37d7b87$export$d906c17550f3b6f1) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$d906c17550f3b6f1) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$d906c17550f3b6f1) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$267a9616c09f33fa && y instanceof $ecaed3b9c37d7b87$export$267a9616c09f33fa) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$267a9616c09f33fa) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$267a9616c09f33fa) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$4ac537c498251bbf && y instanceof $ecaed3b9c37d7b87$export$4ac537c498251bbf) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$4ac537c498251bbf) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$4ac537c498251bbf) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$2e15cf96bd811454 && y instanceof $ecaed3b9c37d7b87$export$2e15cf96bd811454) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$2e15cf96bd811454) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$2e15cf96bd811454) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$7c4efb1d2d0a7d5d && y instanceof $ecaed3b9c37d7b87$export$7c4efb1d2d0a7d5d) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$7c4efb1d2d0a7d5d) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$7c4efb1d2d0a7d5d) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$42f27b71e570e84c && y instanceof $ecaed3b9c37d7b87$export$42f27b71e570e84c) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$42f27b71e570e84c) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$42f27b71e570e84c) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$7dd055ac3e2d902c && y instanceof $ecaed3b9c37d7b87$export$7dd055ac3e2d902c) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$7dd055ac3e2d902c) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$7dd055ac3e2d902c) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$918eb55efc9f2e5c && y instanceof $ecaed3b9c37d7b87$export$918eb55efc9f2e5c) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$918eb55efc9f2e5c) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$918eb55efc9f2e5c) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$9d4a96b43ef247de && y instanceof $ecaed3b9c37d7b87$export$9d4a96b43ef247de) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$9d4a96b43ef247de) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$9d4a96b43ef247de) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f69bc69473d6d1fa && y instanceof $ecaed3b9c37d7b87$export$f69bc69473d6d1fa) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f69bc69473d6d1fa) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$f69bc69473d6d1fa) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$db103677e4262f74 && y instanceof $ecaed3b9c37d7b87$export$db103677e4262f74) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$db103677e4262f74) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$db103677e4262f74) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$976267f1375fd072 && y instanceof $ecaed3b9c37d7b87$export$976267f1375fd072) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$976267f1375fd072) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$976267f1375fd072) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$345017daa9311763 && y instanceof $ecaed3b9c37d7b87$export$345017daa9311763) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$345017daa9311763) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$345017daa9311763) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$a58218c48fdc359f && y instanceof $ecaed3b9c37d7b87$export$a58218c48fdc359f) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$a58218c48fdc359f) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$a58218c48fdc359f) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$41a3d5735ecfd56f && y instanceof $ecaed3b9c37d7b87$export$41a3d5735ecfd56f) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$41a3d5735ecfd56f) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$41a3d5735ecfd56f) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$dc25bbd279bd7147 && y instanceof $ecaed3b9c37d7b87$export$dc25bbd279bd7147) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$dc25bbd279bd7147) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$dc25bbd279bd7147) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f37489576ac4e3f5 && y instanceof $ecaed3b9c37d7b87$export$f37489576ac4e3f5) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$f37489576ac4e3f5) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$f37489576ac4e3f5) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$85265d7dd09c0246 && y instanceof $ecaed3b9c37d7b87$export$85265d7dd09c0246) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$85265d7dd09c0246) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$85265d7dd09c0246) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$fb4e6d66ca842722 && y instanceof $ecaed3b9c37d7b87$export$fb4e6d66ca842722) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$fb4e6d66ca842722) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$fb4e6d66ca842722) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$149dc202c94ba771 && y instanceof $ecaed3b9c37d7b87$export$149dc202c94ba771) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$149dc202c94ba771) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$149dc202c94ba771) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$c3fb770456fc7a2e && y instanceof $ecaed3b9c37d7b87$export$c3fb770456fc7a2e) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$c3fb770456fc7a2e) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$c3fb770456fc7a2e) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$97df2b5615a1b054 && y instanceof $ecaed3b9c37d7b87$export$97df2b5615a1b054) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$97df2b5615a1b054) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$97df2b5615a1b054) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$7aa0294a80b301d4 && y instanceof $ecaed3b9c37d7b87$export$7aa0294a80b301d4) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$7aa0294a80b301d4) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$7aa0294a80b301d4) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$1294e96da410451d && y instanceof $ecaed3b9c37d7b87$export$1294e96da410451d) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$1294e96da410451d) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$1294e96da410451d) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$acf71e1d98edce93 && y instanceof $ecaed3b9c37d7b87$export$acf71e1d98edce93) return $ibsD5.EQ.value;
            if (x instanceof $ecaed3b9c37d7b87$export$acf71e1d98edce93) return $ibsD5.LT.value;
            if (y instanceof $ecaed3b9c37d7b87$export$acf71e1d98edce93) return $ibsD5.GT.value;
            if (x instanceof $ecaed3b9c37d7b87$export$7a4045fb80d6a5eb && y instanceof $ecaed3b9c37d7b87$export$7a4045fb80d6a5eb) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.AutocompleteType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ecaed3b9c37d7b87$export$51a22934b9cdbac4;
    }
};



// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $55e71b046fd5f7fc$export$e1bb774e9664e700 = /* #__PURE__ */ function() {
    function Anonymous() {}
    Anonymous.value = new Anonymous();
    return Anonymous;
}();
var $55e71b046fd5f7fc$export$bf6fef082af5a2d3 = /* #__PURE__ */ function() {
    function UseCredentials() {}
    UseCredentials.value = new UseCredentials();
    return UseCredentials;
}();
var $55e71b046fd5f7fc$export$8cede0459d8015c9 = function(v) {
    if (v instanceof $55e71b046fd5f7fc$export$e1bb774e9664e700) return "anonymous";
    if (v instanceof $55e71b046fd5f7fc$export$bf6fef082af5a2d3) return "use-credentials";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.CrossOriginValue (line 13, column 26 - line 15, column 38): " + [
        v.constructor.name
    ]);
};
var $55e71b046fd5f7fc$export$63add5f8c2317041 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $55e71b046fd5f7fc$export$e1bb774e9664e700 && y instanceof $55e71b046fd5f7fc$export$e1bb774e9664e700) return true;
            if (x instanceof $55e71b046fd5f7fc$export$bf6fef082af5a2d3 && y instanceof $55e71b046fd5f7fc$export$bf6fef082af5a2d3) return true;
            return false;
        };
    }
};
var $55e71b046fd5f7fc$export$8999465764c5da85 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $55e71b046fd5f7fc$export$e1bb774e9664e700 && y instanceof $55e71b046fd5f7fc$export$e1bb774e9664e700) return $ibsD5.EQ.value;
            if (x instanceof $55e71b046fd5f7fc$export$e1bb774e9664e700) return $ibsD5.LT.value;
            if (y instanceof $55e71b046fd5f7fc$export$e1bb774e9664e700) return $ibsD5.GT.value;
            if (x instanceof $55e71b046fd5f7fc$export$bf6fef082af5a2d3 && y instanceof $55e71b046fd5f7fc$export$bf6fef082af5a2d3) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.CrossOriginValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $55e71b046fd5f7fc$export$63add5f8c2317041;
    }
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $28ec2569ef82cc78$export$c75f22af8298685 = /* #__PURE__ */ function() {
    function DirLTR() {}
    DirLTR.value = new DirLTR();
    return DirLTR;
}();
var $28ec2569ef82cc78$export$f3ecd00e2fcb9ec1 = /* #__PURE__ */ function() {
    function DirRTL() {}
    DirRTL.value = new DirRTL();
    return DirRTL;
}();
var $28ec2569ef82cc78$export$db0b550dbafe50c7 = /* #__PURE__ */ function() {
    function DirAuto() {}
    DirAuto.value = new DirAuto();
    return DirAuto;
}();
var $28ec2569ef82cc78$export$5f8a4393c9c60d1a = function(v) {
    if (v instanceof $28ec2569ef82cc78$export$c75f22af8298685) return "ltr";
    if (v instanceof $28ec2569ef82cc78$export$f3ecd00e2fcb9ec1) return "rtl";
    if (v instanceof $28ec2569ef82cc78$export$db0b550dbafe50c7) return "auto";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.DirValue (line 14, column 18 - line 17, column 20): " + [
        v.constructor.name
    ]);
};
var $28ec2569ef82cc78$export$c646568b5e94d926 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $28ec2569ef82cc78$export$c75f22af8298685 && y instanceof $28ec2569ef82cc78$export$c75f22af8298685) return true;
            if (x instanceof $28ec2569ef82cc78$export$f3ecd00e2fcb9ec1 && y instanceof $28ec2569ef82cc78$export$f3ecd00e2fcb9ec1) return true;
            if (x instanceof $28ec2569ef82cc78$export$db0b550dbafe50c7 && y instanceof $28ec2569ef82cc78$export$db0b550dbafe50c7) return true;
            return false;
        };
    }
};
var $28ec2569ef82cc78$export$e1551c9d6a26f7f3 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $28ec2569ef82cc78$export$c75f22af8298685 && y instanceof $28ec2569ef82cc78$export$c75f22af8298685) return $ibsD5.EQ.value;
            if (x instanceof $28ec2569ef82cc78$export$c75f22af8298685) return $ibsD5.LT.value;
            if (y instanceof $28ec2569ef82cc78$export$c75f22af8298685) return $ibsD5.GT.value;
            if (x instanceof $28ec2569ef82cc78$export$f3ecd00e2fcb9ec1 && y instanceof $28ec2569ef82cc78$export$f3ecd00e2fcb9ec1) return $ibsD5.EQ.value;
            if (x instanceof $28ec2569ef82cc78$export$f3ecd00e2fcb9ec1) return $ibsD5.LT.value;
            if (y instanceof $28ec2569ef82cc78$export$f3ecd00e2fcb9ec1) return $ibsD5.GT.value;
            if (x instanceof $28ec2569ef82cc78$export$db0b550dbafe50c7 && y instanceof $28ec2569ef82cc78$export$db0b550dbafe50c7) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.DirValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $28ec2569ef82cc78$export$c646568b5e94d926;
    }
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $b220419bc3acd04a$export$484f3009c2ee32ad = /* #__PURE__ */ function() {
    function POST() {}
    POST.value = new POST();
    return POST;
}();
var $b220419bc3acd04a$export$1bb358554aac31c1 = /* #__PURE__ */ function() {
    function GET() {}
    GET.value = new GET();
    return GET;
}();
var $b220419bc3acd04a$export$ac1e6270deebeb79 = function(v) {
    if (v instanceof $b220419bc3acd04a$export$484f3009c2ee32ad) return "post";
    if (v instanceof $b220419bc3acd04a$export$1bb358554aac31c1) return "get";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.FormMethod (line 13, column 20 - line 15, column 15): " + [
        v.constructor.name
    ]);
};
var $b220419bc3acd04a$export$f6f118a39bdefe44 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $b220419bc3acd04a$export$484f3009c2ee32ad && y instanceof $b220419bc3acd04a$export$484f3009c2ee32ad) return true;
            if (x instanceof $b220419bc3acd04a$export$1bb358554aac31c1 && y instanceof $b220419bc3acd04a$export$1bb358554aac31c1) return true;
            return false;
        };
    }
};
var $b220419bc3acd04a$export$5fa44f1be85134a1 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $b220419bc3acd04a$export$484f3009c2ee32ad && y instanceof $b220419bc3acd04a$export$484f3009c2ee32ad) return $ibsD5.EQ.value;
            if (x instanceof $b220419bc3acd04a$export$484f3009c2ee32ad) return $ibsD5.LT.value;
            if (y instanceof $b220419bc3acd04a$export$484f3009c2ee32ad) return $ibsD5.GT.value;
            if (x instanceof $b220419bc3acd04a$export$1bb358554aac31c1 && y instanceof $b220419bc3acd04a$export$1bb358554aac31c1) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.FormMethod (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $b220419bc3acd04a$export$f6f118a39bdefe44;
    }
};


// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $7FzSN = parcelRequire("7FzSN");
// Generated by purs version 0.15.16

var $gwBF5 = parcelRequire("gwBF5");

var $2XxiF = parcelRequire("2XxiF");
var $75290274442c9237$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showString);
var $75290274442c9237$var$compare = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordString);
var $75290274442c9237$export$483c11740a902fcd = function(x) {
    return x;
};
var $75290274442c9237$export$74c0afb45691d798 = {
    show: function(v) {
        return "(MediaType " + ($75290274442c9237$var$show(v) + ")");
    }
};
var $75290274442c9237$export$37246347bfd87552 = {
    Coercible0: function() {
        return undefined;
    }
};
var $75290274442c9237$export$2fed9e13b0c7effc = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $75290274442c9237$export$11071179e210ac75 = {
    compare: function(x) {
        return function(y) {
            return $75290274442c9237$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $75290274442c9237$export$2fed9e13b0c7effc;
    }
};



var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $d8ahy = parcelRequire("d8ahy");
var $b0c33aace9a56bb2$var$append = /* #__PURE__ */ $d5vvq.append($d5vvq.semigroupArray);
var $b0c33aace9a56bb2$var$map = /* #__PURE__ */ $7FzSN.map($7FzSN.functorArray);
var $b0c33aace9a56bb2$var$eq = /* #__PURE__ */ $aJhEx.eq($75290274442c9237$export$2fed9e13b0c7effc);
var $b0c33aace9a56bb2$var$compare = /* #__PURE__ */ $gwBF5.compare($75290274442c9237$export$11071179e210ac75);
var $b0c33aace9a56bb2$var$compare1 = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordString);
var $b0c33aace9a56bb2$export$8e926b7ab266774b = /* #__PURE__ */ function() {
    function AcceptMediaType(value0) {
        this.value0 = value0;
    }
    AcceptMediaType.create = function(value0) {
        return new AcceptMediaType(value0);
    };
    return AcceptMediaType;
}();
var $b0c33aace9a56bb2$export$f7dfb125ffc1f9b2 = /* #__PURE__ */ function() {
    function AcceptFileExtension(value0) {
        this.value0 = value0;
    }
    AcceptFileExtension.create = function(value0) {
        return new AcceptFileExtension(value0);
    };
    return AcceptFileExtension;
}();
var $b0c33aace9a56bb2$export$cdbf5a093552f797 = function(x) {
    return x;
};
var $b0c33aace9a56bb2$export$335b3365a1f7dcb5 = {
    append: function(v) {
        return function(v1) {
            return $b0c33aace9a56bb2$var$append(v)(v1);
        };
    }
};
var $b0c33aace9a56bb2$export$ef578e44d5d087ca = function(v) {
    if (v instanceof $b0c33aace9a56bb2$export$8e926b7ab266774b) return v.value0;
    if (v instanceof $b0c33aace9a56bb2$export$f7dfb125ffc1f9b2) return v.value0;
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputAcceptType (line 34, column 29 - line 36, column 33): " + [
        v.constructor.name
    ]);
};
var $b0c33aace9a56bb2$export$67347a102a60396a = function(v) {
    return $d8ahy.joinWith(",")($b0c33aace9a56bb2$var$map($b0c33aace9a56bb2$export$ef578e44d5d087ca)(v));
};
var $b0c33aace9a56bb2$export$48e9de57e04e82db = function(mt) {
    return [
        new $b0c33aace9a56bb2$export$8e926b7ab266774b(mt)
    ];
};
var $b0c33aace9a56bb2$export$1b45514b112dd749 = function(ext) {
    return [
        new $b0c33aace9a56bb2$export$f7dfb125ffc1f9b2(ext)
    ];
};
var $b0c33aace9a56bb2$export$d6146bb235b883d4 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $b0c33aace9a56bb2$export$8e926b7ab266774b && y instanceof $b0c33aace9a56bb2$export$8e926b7ab266774b) return $b0c33aace9a56bb2$var$eq(x.value0)(y.value0);
            if (x instanceof $b0c33aace9a56bb2$export$f7dfb125ffc1f9b2 && y instanceof $b0c33aace9a56bb2$export$f7dfb125ffc1f9b2) return x.value0 === y.value0;
            return false;
        };
    }
};
var $b0c33aace9a56bb2$var$eq2 = /* #__PURE__ */ $aJhEx.eq(/* #__PURE__ */ $aJhEx.eqArray($b0c33aace9a56bb2$export$d6146bb235b883d4));
var $b0c33aace9a56bb2$export$56a1e1f55aab9839 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $b0c33aace9a56bb2$export$8e926b7ab266774b && y instanceof $b0c33aace9a56bb2$export$8e926b7ab266774b) return $b0c33aace9a56bb2$var$compare(x.value0)(y.value0);
            if (x instanceof $b0c33aace9a56bb2$export$8e926b7ab266774b) return $ibsD5.LT.value;
            if (y instanceof $b0c33aace9a56bb2$export$8e926b7ab266774b) return $ibsD5.GT.value;
            if (x instanceof $b0c33aace9a56bb2$export$f7dfb125ffc1f9b2 && y instanceof $b0c33aace9a56bb2$export$f7dfb125ffc1f9b2) return $b0c33aace9a56bb2$var$compare1(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.InputAcceptType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $b0c33aace9a56bb2$export$d6146bb235b883d4;
    }
};
var $b0c33aace9a56bb2$var$compare2 = /* #__PURE__ */ $gwBF5.compare(/* #__PURE__ */ $gwBF5.ordArray($b0c33aace9a56bb2$export$56a1e1f55aab9839));
var $b0c33aace9a56bb2$export$6683b104f83faddd = {
    eq: function(x) {
        return function(y) {
            return $b0c33aace9a56bb2$var$eq2(x)(y);
        };
    }
};
var $b0c33aace9a56bb2$export$5822e39e3fdf7b = {
    compare: function(x) {
        return function(y) {
            return $b0c33aace9a56bb2$var$compare2(x)(y);
        };
    },
    Eq0: function() {
        return $b0c33aace9a56bb2$export$6683b104f83faddd;
    }
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $bc2fcd8e3e5ce229$export$80f44e7a00b6023f = /* #__PURE__ */ function() {
    function InputButton() {}
    InputButton.value = new InputButton();
    return InputButton;
}();
var $bc2fcd8e3e5ce229$export$fa1253a65a9e747d = /* #__PURE__ */ function() {
    function InputCheckbox() {}
    InputCheckbox.value = new InputCheckbox();
    return InputCheckbox;
}();
var $bc2fcd8e3e5ce229$export$c860ea55e361ded9 = /* #__PURE__ */ function() {
    function InputColor() {}
    InputColor.value = new InputColor();
    return InputColor;
}();
var $bc2fcd8e3e5ce229$export$7ac9d04ce3f22c96 = /* #__PURE__ */ function() {
    function InputDate() {}
    InputDate.value = new InputDate();
    return InputDate;
}();
var $bc2fcd8e3e5ce229$export$6a70bbf20f9e4d15 = /* #__PURE__ */ function() {
    function InputDatetimeLocal() {}
    InputDatetimeLocal.value = new InputDatetimeLocal();
    return InputDatetimeLocal;
}();
var $bc2fcd8e3e5ce229$export$497a6aaf7dad75ee = /* #__PURE__ */ function() {
    function InputEmail() {}
    InputEmail.value = new InputEmail();
    return InputEmail;
}();
var $bc2fcd8e3e5ce229$export$688bf7bc8f9a8891 = /* #__PURE__ */ function() {
    function InputFile() {}
    InputFile.value = new InputFile();
    return InputFile;
}();
var $bc2fcd8e3e5ce229$export$f953fc739c1a72e8 = /* #__PURE__ */ function() {
    function InputHidden() {}
    InputHidden.value = new InputHidden();
    return InputHidden;
}();
var $bc2fcd8e3e5ce229$export$94c7ee1e602c3016 = /* #__PURE__ */ function() {
    function InputImage() {}
    InputImage.value = new InputImage();
    return InputImage;
}();
var $bc2fcd8e3e5ce229$export$e3f21b3e5e110727 = /* #__PURE__ */ function() {
    function InputMonth() {}
    InputMonth.value = new InputMonth();
    return InputMonth;
}();
var $bc2fcd8e3e5ce229$export$cf9581d419a141cf = /* #__PURE__ */ function() {
    function InputNumber() {}
    InputNumber.value = new InputNumber();
    return InputNumber;
}();
var $bc2fcd8e3e5ce229$export$66ebaee5e192c141 = /* #__PURE__ */ function() {
    function InputPassword() {}
    InputPassword.value = new InputPassword();
    return InputPassword;
}();
var $bc2fcd8e3e5ce229$export$324f219e224c2ba4 = /* #__PURE__ */ function() {
    function InputRadio() {}
    InputRadio.value = new InputRadio();
    return InputRadio;
}();
var $bc2fcd8e3e5ce229$export$7fd9b60c3e71d3cc = /* #__PURE__ */ function() {
    function InputRange() {}
    InputRange.value = new InputRange();
    return InputRange;
}();
var $bc2fcd8e3e5ce229$export$e5f0f61dd2ad15f5 = /* #__PURE__ */ function() {
    function InputReset() {}
    InputReset.value = new InputReset();
    return InputReset;
}();
var $bc2fcd8e3e5ce229$export$28044d9a5dbb104e = /* #__PURE__ */ function() {
    function InputSearch() {}
    InputSearch.value = new InputSearch();
    return InputSearch;
}();
var $bc2fcd8e3e5ce229$export$41cafe4e2581754d = /* #__PURE__ */ function() {
    function InputSubmit() {}
    InputSubmit.value = new InputSubmit();
    return InputSubmit;
}();
var $bc2fcd8e3e5ce229$export$5a51e0eecea5d8bd = /* #__PURE__ */ function() {
    function InputTel() {}
    InputTel.value = new InputTel();
    return InputTel;
}();
var $bc2fcd8e3e5ce229$export$7034fcb7d6351061 = /* #__PURE__ */ function() {
    function InputText() {}
    InputText.value = new InputText();
    return InputText;
}();
var $bc2fcd8e3e5ce229$export$d62c52bf2c44ba6f = /* #__PURE__ */ function() {
    function InputTime() {}
    InputTime.value = new InputTime();
    return InputTime;
}();
var $bc2fcd8e3e5ce229$export$dfe56e1f58ed5cb2 = /* #__PURE__ */ function() {
    function InputUrl() {}
    InputUrl.value = new InputUrl();
    return InputUrl;
}();
var $bc2fcd8e3e5ce229$export$8e8a9e74dfcf346a = /* #__PURE__ */ function() {
    function InputWeek() {}
    InputWeek.value = new InputWeek();
    return InputWeek;
}();
var $bc2fcd8e3e5ce229$export$349063a07c8ae46b = function(v) {
    if (v instanceof $bc2fcd8e3e5ce229$export$80f44e7a00b6023f) return "button";
    if (v instanceof $bc2fcd8e3e5ce229$export$fa1253a65a9e747d) return "checkbox";
    if (v instanceof $bc2fcd8e3e5ce229$export$c860ea55e361ded9) return "color";
    if (v instanceof $bc2fcd8e3e5ce229$export$7ac9d04ce3f22c96) return "date";
    if (v instanceof $bc2fcd8e3e5ce229$export$6a70bbf20f9e4d15) return "datetime-local";
    if (v instanceof $bc2fcd8e3e5ce229$export$497a6aaf7dad75ee) return "email";
    if (v instanceof $bc2fcd8e3e5ce229$export$688bf7bc8f9a8891) return "file";
    if (v instanceof $bc2fcd8e3e5ce229$export$f953fc739c1a72e8) return "hidden";
    if (v instanceof $bc2fcd8e3e5ce229$export$94c7ee1e602c3016) return "image";
    if (v instanceof $bc2fcd8e3e5ce229$export$e3f21b3e5e110727) return "month";
    if (v instanceof $bc2fcd8e3e5ce229$export$cf9581d419a141cf) return "number";
    if (v instanceof $bc2fcd8e3e5ce229$export$66ebaee5e192c141) return "password";
    if (v instanceof $bc2fcd8e3e5ce229$export$324f219e224c2ba4) return "radio";
    if (v instanceof $bc2fcd8e3e5ce229$export$7fd9b60c3e71d3cc) return "range";
    if (v instanceof $bc2fcd8e3e5ce229$export$e5f0f61dd2ad15f5) return "reset";
    if (v instanceof $bc2fcd8e3e5ce229$export$28044d9a5dbb104e) return "search";
    if (v instanceof $bc2fcd8e3e5ce229$export$41cafe4e2581754d) return "submit";
    if (v instanceof $bc2fcd8e3e5ce229$export$5a51e0eecea5d8bd) return "tel";
    if (v instanceof $bc2fcd8e3e5ce229$export$7034fcb7d6351061) return "text";
    if (v instanceof $bc2fcd8e3e5ce229$export$d62c52bf2c44ba6f) return "time";
    if (v instanceof $bc2fcd8e3e5ce229$export$dfe56e1f58ed5cb2) return "url";
    if (v instanceof $bc2fcd8e3e5ce229$export$8e8a9e74dfcf346a) return "week";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 33, column 19 - line 55, column 22): " + [
        v.constructor.name
    ]);
};
var $bc2fcd8e3e5ce229$export$417491cbf879eb77 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $bc2fcd8e3e5ce229$export$80f44e7a00b6023f && y instanceof $bc2fcd8e3e5ce229$export$80f44e7a00b6023f) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$fa1253a65a9e747d && y instanceof $bc2fcd8e3e5ce229$export$fa1253a65a9e747d) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$c860ea55e361ded9 && y instanceof $bc2fcd8e3e5ce229$export$c860ea55e361ded9) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$7ac9d04ce3f22c96 && y instanceof $bc2fcd8e3e5ce229$export$7ac9d04ce3f22c96) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$6a70bbf20f9e4d15 && y instanceof $bc2fcd8e3e5ce229$export$6a70bbf20f9e4d15) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$497a6aaf7dad75ee && y instanceof $bc2fcd8e3e5ce229$export$497a6aaf7dad75ee) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$688bf7bc8f9a8891 && y instanceof $bc2fcd8e3e5ce229$export$688bf7bc8f9a8891) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$f953fc739c1a72e8 && y instanceof $bc2fcd8e3e5ce229$export$f953fc739c1a72e8) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$94c7ee1e602c3016 && y instanceof $bc2fcd8e3e5ce229$export$94c7ee1e602c3016) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$e3f21b3e5e110727 && y instanceof $bc2fcd8e3e5ce229$export$e3f21b3e5e110727) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$cf9581d419a141cf && y instanceof $bc2fcd8e3e5ce229$export$cf9581d419a141cf) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$66ebaee5e192c141 && y instanceof $bc2fcd8e3e5ce229$export$66ebaee5e192c141) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$324f219e224c2ba4 && y instanceof $bc2fcd8e3e5ce229$export$324f219e224c2ba4) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$7fd9b60c3e71d3cc && y instanceof $bc2fcd8e3e5ce229$export$7fd9b60c3e71d3cc) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$e5f0f61dd2ad15f5 && y instanceof $bc2fcd8e3e5ce229$export$e5f0f61dd2ad15f5) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$28044d9a5dbb104e && y instanceof $bc2fcd8e3e5ce229$export$28044d9a5dbb104e) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$41cafe4e2581754d && y instanceof $bc2fcd8e3e5ce229$export$41cafe4e2581754d) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$5a51e0eecea5d8bd && y instanceof $bc2fcd8e3e5ce229$export$5a51e0eecea5d8bd) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$7034fcb7d6351061 && y instanceof $bc2fcd8e3e5ce229$export$7034fcb7d6351061) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$d62c52bf2c44ba6f && y instanceof $bc2fcd8e3e5ce229$export$d62c52bf2c44ba6f) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$dfe56e1f58ed5cb2 && y instanceof $bc2fcd8e3e5ce229$export$dfe56e1f58ed5cb2) return true;
            if (x instanceof $bc2fcd8e3e5ce229$export$8e8a9e74dfcf346a && y instanceof $bc2fcd8e3e5ce229$export$8e8a9e74dfcf346a) return true;
            return false;
        };
    }
};
var $bc2fcd8e3e5ce229$export$6dd7322953dee4dc = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $bc2fcd8e3e5ce229$export$80f44e7a00b6023f && y instanceof $bc2fcd8e3e5ce229$export$80f44e7a00b6023f) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$80f44e7a00b6023f) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$80f44e7a00b6023f) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$fa1253a65a9e747d && y instanceof $bc2fcd8e3e5ce229$export$fa1253a65a9e747d) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$fa1253a65a9e747d) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$fa1253a65a9e747d) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$c860ea55e361ded9 && y instanceof $bc2fcd8e3e5ce229$export$c860ea55e361ded9) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$c860ea55e361ded9) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$c860ea55e361ded9) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$7ac9d04ce3f22c96 && y instanceof $bc2fcd8e3e5ce229$export$7ac9d04ce3f22c96) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$7ac9d04ce3f22c96) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$7ac9d04ce3f22c96) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$6a70bbf20f9e4d15 && y instanceof $bc2fcd8e3e5ce229$export$6a70bbf20f9e4d15) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$6a70bbf20f9e4d15) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$6a70bbf20f9e4d15) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$497a6aaf7dad75ee && y instanceof $bc2fcd8e3e5ce229$export$497a6aaf7dad75ee) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$497a6aaf7dad75ee) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$497a6aaf7dad75ee) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$688bf7bc8f9a8891 && y instanceof $bc2fcd8e3e5ce229$export$688bf7bc8f9a8891) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$688bf7bc8f9a8891) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$688bf7bc8f9a8891) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$f953fc739c1a72e8 && y instanceof $bc2fcd8e3e5ce229$export$f953fc739c1a72e8) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$f953fc739c1a72e8) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$f953fc739c1a72e8) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$94c7ee1e602c3016 && y instanceof $bc2fcd8e3e5ce229$export$94c7ee1e602c3016) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$94c7ee1e602c3016) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$94c7ee1e602c3016) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$e3f21b3e5e110727 && y instanceof $bc2fcd8e3e5ce229$export$e3f21b3e5e110727) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$e3f21b3e5e110727) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$e3f21b3e5e110727) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$cf9581d419a141cf && y instanceof $bc2fcd8e3e5ce229$export$cf9581d419a141cf) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$cf9581d419a141cf) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$cf9581d419a141cf) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$66ebaee5e192c141 && y instanceof $bc2fcd8e3e5ce229$export$66ebaee5e192c141) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$66ebaee5e192c141) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$66ebaee5e192c141) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$324f219e224c2ba4 && y instanceof $bc2fcd8e3e5ce229$export$324f219e224c2ba4) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$324f219e224c2ba4) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$324f219e224c2ba4) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$7fd9b60c3e71d3cc && y instanceof $bc2fcd8e3e5ce229$export$7fd9b60c3e71d3cc) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$7fd9b60c3e71d3cc) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$7fd9b60c3e71d3cc) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$e5f0f61dd2ad15f5 && y instanceof $bc2fcd8e3e5ce229$export$e5f0f61dd2ad15f5) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$e5f0f61dd2ad15f5) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$e5f0f61dd2ad15f5) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$28044d9a5dbb104e && y instanceof $bc2fcd8e3e5ce229$export$28044d9a5dbb104e) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$28044d9a5dbb104e) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$28044d9a5dbb104e) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$41cafe4e2581754d && y instanceof $bc2fcd8e3e5ce229$export$41cafe4e2581754d) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$41cafe4e2581754d) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$41cafe4e2581754d) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$5a51e0eecea5d8bd && y instanceof $bc2fcd8e3e5ce229$export$5a51e0eecea5d8bd) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$5a51e0eecea5d8bd) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$5a51e0eecea5d8bd) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$7034fcb7d6351061 && y instanceof $bc2fcd8e3e5ce229$export$7034fcb7d6351061) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$7034fcb7d6351061) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$7034fcb7d6351061) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$d62c52bf2c44ba6f && y instanceof $bc2fcd8e3e5ce229$export$d62c52bf2c44ba6f) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$d62c52bf2c44ba6f) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$d62c52bf2c44ba6f) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$dfe56e1f58ed5cb2 && y instanceof $bc2fcd8e3e5ce229$export$dfe56e1f58ed5cb2) return $ibsD5.EQ.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$dfe56e1f58ed5cb2) return $ibsD5.LT.value;
            if (y instanceof $bc2fcd8e3e5ce229$export$dfe56e1f58ed5cb2) return $ibsD5.GT.value;
            if (x instanceof $bc2fcd8e3e5ce229$export$8e8a9e74dfcf346a && y instanceof $bc2fcd8e3e5ce229$export$8e8a9e74dfcf346a) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $bc2fcd8e3e5ce229$export$417491cbf879eb77;
    }
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $bbbf0f4eb77b3e37$export$35c6296c72c0b98 = /* #__PURE__ */ function() {
    function KindSubtitles() {}
    KindSubtitles.value = new KindSubtitles();
    return KindSubtitles;
}();
var $bbbf0f4eb77b3e37$export$57c7f27d38c9b1fa = /* #__PURE__ */ function() {
    function KindCaptions() {}
    KindCaptions.value = new KindCaptions();
    return KindCaptions;
}();
var $bbbf0f4eb77b3e37$export$ed9577fa4e97a113 = /* #__PURE__ */ function() {
    function KindDescriptions() {}
    KindDescriptions.value = new KindDescriptions();
    return KindDescriptions;
}();
var $bbbf0f4eb77b3e37$export$6b7135087206d174 = /* #__PURE__ */ function() {
    function KindChapters() {}
    KindChapters.value = new KindChapters();
    return KindChapters;
}();
var $bbbf0f4eb77b3e37$export$a2734ee0406012d8 = /* #__PURE__ */ function() {
    function KindMetadata() {}
    KindMetadata.value = new KindMetadata();
    return KindMetadata;
}();
var $bbbf0f4eb77b3e37$export$8d81b1ec6c8c1d53 = function(v) {
    if (v instanceof $bbbf0f4eb77b3e37$export$35c6296c72c0b98) return "subtitles";
    if (v instanceof $bbbf0f4eb77b3e37$export$57c7f27d38c9b1fa) return "captions";
    if (v instanceof $bbbf0f4eb77b3e37$export$ed9577fa4e97a113) return "descriptions";
    if (v instanceof $bbbf0f4eb77b3e37$export$6b7135087206d174) return "chapters";
    if (v instanceof $bbbf0f4eb77b3e37$export$a2734ee0406012d8) return "metadata";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.KindValue (line 16, column 19 - line 21, column 29): " + [
        v.constructor.name
    ]);
};
var $bbbf0f4eb77b3e37$export$4037dad5bbd136 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $bbbf0f4eb77b3e37$export$35c6296c72c0b98 && y instanceof $bbbf0f4eb77b3e37$export$35c6296c72c0b98) return true;
            if (x instanceof $bbbf0f4eb77b3e37$export$57c7f27d38c9b1fa && y instanceof $bbbf0f4eb77b3e37$export$57c7f27d38c9b1fa) return true;
            if (x instanceof $bbbf0f4eb77b3e37$export$ed9577fa4e97a113 && y instanceof $bbbf0f4eb77b3e37$export$ed9577fa4e97a113) return true;
            if (x instanceof $bbbf0f4eb77b3e37$export$6b7135087206d174 && y instanceof $bbbf0f4eb77b3e37$export$6b7135087206d174) return true;
            if (x instanceof $bbbf0f4eb77b3e37$export$a2734ee0406012d8 && y instanceof $bbbf0f4eb77b3e37$export$a2734ee0406012d8) return true;
            return false;
        };
    }
};
var $bbbf0f4eb77b3e37$export$70ddb214b8742e4 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $bbbf0f4eb77b3e37$export$35c6296c72c0b98 && y instanceof $bbbf0f4eb77b3e37$export$35c6296c72c0b98) return $ibsD5.EQ.value;
            if (x instanceof $bbbf0f4eb77b3e37$export$35c6296c72c0b98) return $ibsD5.LT.value;
            if (y instanceof $bbbf0f4eb77b3e37$export$35c6296c72c0b98) return $ibsD5.GT.value;
            if (x instanceof $bbbf0f4eb77b3e37$export$57c7f27d38c9b1fa && y instanceof $bbbf0f4eb77b3e37$export$57c7f27d38c9b1fa) return $ibsD5.EQ.value;
            if (x instanceof $bbbf0f4eb77b3e37$export$57c7f27d38c9b1fa) return $ibsD5.LT.value;
            if (y instanceof $bbbf0f4eb77b3e37$export$57c7f27d38c9b1fa) return $ibsD5.GT.value;
            if (x instanceof $bbbf0f4eb77b3e37$export$ed9577fa4e97a113 && y instanceof $bbbf0f4eb77b3e37$export$ed9577fa4e97a113) return $ibsD5.EQ.value;
            if (x instanceof $bbbf0f4eb77b3e37$export$ed9577fa4e97a113) return $ibsD5.LT.value;
            if (y instanceof $bbbf0f4eb77b3e37$export$ed9577fa4e97a113) return $ibsD5.GT.value;
            if (x instanceof $bbbf0f4eb77b3e37$export$6b7135087206d174 && y instanceof $bbbf0f4eb77b3e37$export$6b7135087206d174) return $ibsD5.EQ.value;
            if (x instanceof $bbbf0f4eb77b3e37$export$6b7135087206d174) return $ibsD5.LT.value;
            if (y instanceof $bbbf0f4eb77b3e37$export$6b7135087206d174) return $ibsD5.GT.value;
            if (x instanceof $bbbf0f4eb77b3e37$export$a2734ee0406012d8 && y instanceof $bbbf0f4eb77b3e37$export$a2734ee0406012d8) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.KindValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $bbbf0f4eb77b3e37$export$4037dad5bbd136;
    }
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $bbe1e53af35dc2cd$export$d4c4e98c5044dc8 = /* #__PURE__ */ function() {
    function MenuList() {}
    MenuList.value = new MenuList();
    return MenuList;
}();
var $bbe1e53af35dc2cd$export$c7e742effb1c51e2 = /* #__PURE__ */ function() {
    function MenuContext() {}
    MenuContext.value = new MenuContext();
    return MenuContext;
}();
var $bbe1e53af35dc2cd$export$5ed3d899d0b4c46b = /* #__PURE__ */ function() {
    function MenuToolbar() {}
    MenuToolbar.value = new MenuToolbar();
    return MenuToolbar;
}();
var $bbe1e53af35dc2cd$export$1746677a19c76ca = function(v) {
    if (v instanceof $bbe1e53af35dc2cd$export$d4c4e98c5044dc8) return "list";
    if (v instanceof $bbe1e53af35dc2cd$export$c7e742effb1c51e2) return "context";
    if (v instanceof $bbe1e53af35dc2cd$export$5ed3d899d0b4c46b) return "toolbar";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuType (line 14, column 18 - line 17, column 27): " + [
        v.constructor.name
    ]);
};
var $bbe1e53af35dc2cd$export$fb82239a3dd454ef = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $bbe1e53af35dc2cd$export$d4c4e98c5044dc8 && y instanceof $bbe1e53af35dc2cd$export$d4c4e98c5044dc8) return true;
            if (x instanceof $bbe1e53af35dc2cd$export$c7e742effb1c51e2 && y instanceof $bbe1e53af35dc2cd$export$c7e742effb1c51e2) return true;
            if (x instanceof $bbe1e53af35dc2cd$export$5ed3d899d0b4c46b && y instanceof $bbe1e53af35dc2cd$export$5ed3d899d0b4c46b) return true;
            return false;
        };
    }
};
var $bbe1e53af35dc2cd$export$93b0f2b60788283e = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $bbe1e53af35dc2cd$export$d4c4e98c5044dc8 && y instanceof $bbe1e53af35dc2cd$export$d4c4e98c5044dc8) return $ibsD5.EQ.value;
            if (x instanceof $bbe1e53af35dc2cd$export$d4c4e98c5044dc8) return $ibsD5.LT.value;
            if (y instanceof $bbe1e53af35dc2cd$export$d4c4e98c5044dc8) return $ibsD5.GT.value;
            if (x instanceof $bbe1e53af35dc2cd$export$c7e742effb1c51e2 && y instanceof $bbe1e53af35dc2cd$export$c7e742effb1c51e2) return $ibsD5.EQ.value;
            if (x instanceof $bbe1e53af35dc2cd$export$c7e742effb1c51e2) return $ibsD5.LT.value;
            if (y instanceof $bbe1e53af35dc2cd$export$c7e742effb1c51e2) return $ibsD5.GT.value;
            if (x instanceof $bbe1e53af35dc2cd$export$5ed3d899d0b4c46b && y instanceof $bbe1e53af35dc2cd$export$5ed3d899d0b4c46b) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $bbe1e53af35dc2cd$export$fb82239a3dd454ef;
    }
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $0ec4581ec7f50b7b$export$45504f2104ec46b9 = /* #__PURE__ */ function() {
    function MenuitemCommand() {}
    MenuitemCommand.value = new MenuitemCommand();
    return MenuitemCommand;
}();
var $0ec4581ec7f50b7b$export$eea2e5b7a15a4e39 = /* #__PURE__ */ function() {
    function MenuitemCheckbox() {}
    MenuitemCheckbox.value = new MenuitemCheckbox();
    return MenuitemCheckbox;
}();
var $0ec4581ec7f50b7b$export$d4d65a7e83785e4a = /* #__PURE__ */ function() {
    function MenuitemRadio() {}
    MenuitemRadio.value = new MenuitemRadio();
    return MenuitemRadio;
}();
var $0ec4581ec7f50b7b$export$3e035bf7a26d866f = function(v) {
    if (v instanceof $0ec4581ec7f50b7b$export$45504f2104ec46b9) return "command";
    if (v instanceof $0ec4581ec7f50b7b$export$eea2e5b7a15a4e39) return "checkbox";
    if (v instanceof $0ec4581ec7f50b7b$export$d4d65a7e83785e4a) return "radio";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuitemType (line 14, column 22 - line 17, column 27): " + [
        v.constructor.name
    ]);
};
var $0ec4581ec7f50b7b$export$e73111b8eb7b1a2f = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0ec4581ec7f50b7b$export$45504f2104ec46b9 && y instanceof $0ec4581ec7f50b7b$export$45504f2104ec46b9) return true;
            if (x instanceof $0ec4581ec7f50b7b$export$eea2e5b7a15a4e39 && y instanceof $0ec4581ec7f50b7b$export$eea2e5b7a15a4e39) return true;
            if (x instanceof $0ec4581ec7f50b7b$export$d4d65a7e83785e4a && y instanceof $0ec4581ec7f50b7b$export$d4d65a7e83785e4a) return true;
            return false;
        };
    }
};
var $0ec4581ec7f50b7b$export$67edf3145dec517a = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0ec4581ec7f50b7b$export$45504f2104ec46b9 && y instanceof $0ec4581ec7f50b7b$export$45504f2104ec46b9) return $ibsD5.EQ.value;
            if (x instanceof $0ec4581ec7f50b7b$export$45504f2104ec46b9) return $ibsD5.LT.value;
            if (y instanceof $0ec4581ec7f50b7b$export$45504f2104ec46b9) return $ibsD5.GT.value;
            if (x instanceof $0ec4581ec7f50b7b$export$eea2e5b7a15a4e39 && y instanceof $0ec4581ec7f50b7b$export$eea2e5b7a15a4e39) return $ibsD5.EQ.value;
            if (x instanceof $0ec4581ec7f50b7b$export$eea2e5b7a15a4e39) return $ibsD5.LT.value;
            if (y instanceof $0ec4581ec7f50b7b$export$eea2e5b7a15a4e39) return $ibsD5.GT.value;
            if (x instanceof $0ec4581ec7f50b7b$export$d4d65a7e83785e4a && y instanceof $0ec4581ec7f50b7b$export$d4d65a7e83785e4a) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.MenuitemType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0ec4581ec7f50b7b$export$e73111b8eb7b1a2f;
    }
};


// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");
var $acd8cd9d754420dd$export$44ce537f0c9df246 = /* #__PURE__ */ function() {
    function Uppercase() {}
    Uppercase.value = new Uppercase();
    return Uppercase;
}();
var $acd8cd9d754420dd$export$83336b6c62a5a6d9 = /* #__PURE__ */ function() {
    function Lowercase() {}
    Lowercase.value = new Lowercase();
    return Lowercase;
}();
var $acd8cd9d754420dd$export$4ae8afa1ef3b3b36 = /* #__PURE__ */ function() {
    function NumeralDecimal() {}
    NumeralDecimal.value = new NumeralDecimal();
    return NumeralDecimal;
}();
var $acd8cd9d754420dd$export$d7365b08e0f1de3f = /* #__PURE__ */ function() {
    function NumeralRoman(value0) {
        this.value0 = value0;
    }
    NumeralRoman.create = function(value0) {
        return new NumeralRoman(value0);
    };
    return NumeralRoman;
}();
var $acd8cd9d754420dd$export$d3365947fb5d3bc = /* #__PURE__ */ function() {
    function OrderedListNumeric(value0) {
        this.value0 = value0;
    }
    OrderedListNumeric.create = function(value0) {
        return new OrderedListNumeric(value0);
    };
    return OrderedListNumeric;
}();
var $acd8cd9d754420dd$export$6f21557799b70c7b = /* #__PURE__ */ function() {
    function OrderedListAlphabetic(value0) {
        this.value0 = value0;
    }
    OrderedListAlphabetic.create = function(value0) {
        return new OrderedListAlphabetic(value0);
    };
    return OrderedListAlphabetic;
}();
var $acd8cd9d754420dd$export$a347b8fb4fdf4d6c = function(v) {
    if (v instanceof $acd8cd9d754420dd$export$d3365947fb5d3bc && v.value0 instanceof $acd8cd9d754420dd$export$4ae8afa1ef3b3b36) return "1";
    if (v instanceof $acd8cd9d754420dd$export$d3365947fb5d3bc && v.value0 instanceof $acd8cd9d754420dd$export$d7365b08e0f1de3f && v.value0.value0 instanceof $acd8cd9d754420dd$export$83336b6c62a5a6d9) return "i";
    if (v instanceof $acd8cd9d754420dd$export$d3365947fb5d3bc && v.value0 instanceof $acd8cd9d754420dd$export$d7365b08e0f1de3f && v.value0.value0 instanceof $acd8cd9d754420dd$export$44ce537f0c9df246) return "I";
    if (v instanceof $acd8cd9d754420dd$export$6f21557799b70c7b && v.value0 instanceof $acd8cd9d754420dd$export$83336b6c62a5a6d9) return "a";
    if (v instanceof $acd8cd9d754420dd$export$6f21557799b70c7b && v.value0 instanceof $acd8cd9d754420dd$export$44ce537f0c9df246) return "A";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 27, column 25 - line 32, column 41): " + [
        v.constructor.name
    ]);
};
var $acd8cd9d754420dd$export$9fb147ac07d57455 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $acd8cd9d754420dd$export$44ce537f0c9df246 && y instanceof $acd8cd9d754420dd$export$44ce537f0c9df246) return true;
            if (x instanceof $acd8cd9d754420dd$export$83336b6c62a5a6d9 && y instanceof $acd8cd9d754420dd$export$83336b6c62a5a6d9) return true;
            return false;
        };
    }
};
var $acd8cd9d754420dd$var$eq = /* #__PURE__ */ $aJhEx.eq($acd8cd9d754420dd$export$9fb147ac07d57455);
var $acd8cd9d754420dd$export$7549aa54c7bac647 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $acd8cd9d754420dd$export$4ae8afa1ef3b3b36 && y instanceof $acd8cd9d754420dd$export$4ae8afa1ef3b3b36) return true;
            if (x instanceof $acd8cd9d754420dd$export$d7365b08e0f1de3f && y instanceof $acd8cd9d754420dd$export$d7365b08e0f1de3f) return $acd8cd9d754420dd$var$eq(x.value0)(y.value0);
            return false;
        };
    }
};
var $acd8cd9d754420dd$var$eq1 = /* #__PURE__ */ $aJhEx.eq($acd8cd9d754420dd$export$7549aa54c7bac647);
var $acd8cd9d754420dd$export$e819e2655e0fcc28 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $acd8cd9d754420dd$export$d3365947fb5d3bc && y instanceof $acd8cd9d754420dd$export$d3365947fb5d3bc) return $acd8cd9d754420dd$var$eq1(x.value0)(y.value0);
            if (x instanceof $acd8cd9d754420dd$export$6f21557799b70c7b && y instanceof $acd8cd9d754420dd$export$6f21557799b70c7b) return $acd8cd9d754420dd$var$eq(x.value0)(y.value0);
            return false;
        };
    }
};
var $acd8cd9d754420dd$export$1bd622e0e5e4efb1 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $acd8cd9d754420dd$export$44ce537f0c9df246 && y instanceof $acd8cd9d754420dd$export$44ce537f0c9df246) return $ibsD5.EQ.value;
            if (x instanceof $acd8cd9d754420dd$export$44ce537f0c9df246) return $ibsD5.LT.value;
            if (y instanceof $acd8cd9d754420dd$export$44ce537f0c9df246) return $ibsD5.GT.value;
            if (x instanceof $acd8cd9d754420dd$export$83336b6c62a5a6d9 && y instanceof $acd8cd9d754420dd$export$83336b6c62a5a6d9) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $acd8cd9d754420dd$export$9fb147ac07d57455;
    }
};
var $acd8cd9d754420dd$var$compare = /* #__PURE__ */ $gwBF5.compare($acd8cd9d754420dd$export$1bd622e0e5e4efb1);
var $acd8cd9d754420dd$export$cd9389dd72b9960d = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $acd8cd9d754420dd$export$4ae8afa1ef3b3b36 && y instanceof $acd8cd9d754420dd$export$4ae8afa1ef3b3b36) return $ibsD5.EQ.value;
            if (x instanceof $acd8cd9d754420dd$export$4ae8afa1ef3b3b36) return $ibsD5.LT.value;
            if (y instanceof $acd8cd9d754420dd$export$4ae8afa1ef3b3b36) return $ibsD5.GT.value;
            if (x instanceof $acd8cd9d754420dd$export$d7365b08e0f1de3f && y instanceof $acd8cd9d754420dd$export$d7365b08e0f1de3f) return $acd8cd9d754420dd$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $acd8cd9d754420dd$export$7549aa54c7bac647;
    }
};
var $acd8cd9d754420dd$var$compare1 = /* #__PURE__ */ $gwBF5.compare($acd8cd9d754420dd$export$cd9389dd72b9960d);
var $acd8cd9d754420dd$export$8c507121dc4e4ea6 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $acd8cd9d754420dd$export$d3365947fb5d3bc && y instanceof $acd8cd9d754420dd$export$d3365947fb5d3bc) return $acd8cd9d754420dd$var$compare1(x.value0)(y.value0);
            if (x instanceof $acd8cd9d754420dd$export$d3365947fb5d3bc) return $ibsD5.LT.value;
            if (y instanceof $acd8cd9d754420dd$export$d3365947fb5d3bc) return $ibsD5.GT.value;
            if (x instanceof $acd8cd9d754420dd$export$6f21557799b70c7b && y instanceof $acd8cd9d754420dd$export$6f21557799b70c7b) return $acd8cd9d754420dd$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.OrderedListType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $acd8cd9d754420dd$export$e819e2655e0fcc28;
    }
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $b6c13023d17ecb85$export$c9ce58abf53417e5 = /* #__PURE__ */ function() {
    function PreloadNone() {}
    PreloadNone.value = new PreloadNone();
    return PreloadNone;
}();
var $b6c13023d17ecb85$export$5e05b189d974313d = /* #__PURE__ */ function() {
    function PreloadAuto() {}
    PreloadAuto.value = new PreloadAuto();
    return PreloadAuto;
}();
var $b6c13023d17ecb85$export$177dbf7da98d3f0a = /* #__PURE__ */ function() {
    function PreloadMetadata() {}
    PreloadMetadata.value = new PreloadMetadata();
    return PreloadMetadata;
}();
var $b6c13023d17ecb85$export$d6626656355d8e39 = function(v) {
    if (v instanceof $b6c13023d17ecb85$export$c9ce58abf53417e5) return "none";
    if (v instanceof $b6c13023d17ecb85$export$5e05b189d974313d) return "auto";
    if (v instanceof $b6c13023d17ecb85$export$177dbf7da98d3f0a) return "metadata";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.PreloadValue (line 14, column 22 - line 17, column 32): " + [
        v.constructor.name
    ]);
};
var $b6c13023d17ecb85$export$2dcc86def1e5568e = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $b6c13023d17ecb85$export$c9ce58abf53417e5 && y instanceof $b6c13023d17ecb85$export$c9ce58abf53417e5) return true;
            if (x instanceof $b6c13023d17ecb85$export$5e05b189d974313d && y instanceof $b6c13023d17ecb85$export$5e05b189d974313d) return true;
            if (x instanceof $b6c13023d17ecb85$export$177dbf7da98d3f0a && y instanceof $b6c13023d17ecb85$export$177dbf7da98d3f0a) return true;
            return false;
        };
    }
};
var $b6c13023d17ecb85$export$c419e612a877bba3 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $b6c13023d17ecb85$export$c9ce58abf53417e5 && y instanceof $b6c13023d17ecb85$export$c9ce58abf53417e5) return $ibsD5.EQ.value;
            if (x instanceof $b6c13023d17ecb85$export$c9ce58abf53417e5) return $ibsD5.LT.value;
            if (y instanceof $b6c13023d17ecb85$export$c9ce58abf53417e5) return $ibsD5.GT.value;
            if (x instanceof $b6c13023d17ecb85$export$5e05b189d974313d && y instanceof $b6c13023d17ecb85$export$5e05b189d974313d) return $ibsD5.EQ.value;
            if (x instanceof $b6c13023d17ecb85$export$5e05b189d974313d) return $ibsD5.LT.value;
            if (y instanceof $b6c13023d17ecb85$export$5e05b189d974313d) return $ibsD5.GT.value;
            if (x instanceof $b6c13023d17ecb85$export$177dbf7da98d3f0a && y instanceof $b6c13023d17ecb85$export$177dbf7da98d3f0a) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.PreloadValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $b6c13023d17ecb85$export$2dcc86def1e5568e;
    }
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $af922821253503df$export$85b4c654d12206aa = /* #__PURE__ */ function() {
    function ScopeRow() {}
    ScopeRow.value = new ScopeRow();
    return ScopeRow;
}();
var $af922821253503df$export$bf0d11cf8bd9f5de = /* #__PURE__ */ function() {
    function ScopeCol() {}
    ScopeCol.value = new ScopeCol();
    return ScopeCol;
}();
var $af922821253503df$export$5910a17af6f76381 = /* #__PURE__ */ function() {
    function ScopeRowGroup() {}
    ScopeRowGroup.value = new ScopeRowGroup();
    return ScopeRowGroup;
}();
var $af922821253503df$export$6ce944503089dadd = /* #__PURE__ */ function() {
    function ScopeColGroup() {}
    ScopeColGroup.value = new ScopeColGroup();
    return ScopeColGroup;
}();
var $af922821253503df$export$5663b51bd1c6c084 = /* #__PURE__ */ function() {
    function ScopeAuto() {}
    ScopeAuto.value = new ScopeAuto();
    return ScopeAuto;
}();
var $af922821253503df$export$ce228bdd501ce63 = function(v) {
    if (v instanceof $af922821253503df$export$85b4c654d12206aa) return "row";
    if (v instanceof $af922821253503df$export$bf0d11cf8bd9f5de) return "col";
    if (v instanceof $af922821253503df$export$5910a17af6f76381) return "rowgroup";
    if (v instanceof $af922821253503df$export$6ce944503089dadd) return "colgroup";
    if (v instanceof $af922821253503df$export$5663b51bd1c6c084) return "auto";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.ScopeValue (line 16, column 20 - line 21, column 22): " + [
        v.constructor.name
    ]);
};
var $af922821253503df$export$118ba639ca4f9d14 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $af922821253503df$export$85b4c654d12206aa && y instanceof $af922821253503df$export$85b4c654d12206aa) return true;
            if (x instanceof $af922821253503df$export$bf0d11cf8bd9f5de && y instanceof $af922821253503df$export$bf0d11cf8bd9f5de) return true;
            if (x instanceof $af922821253503df$export$5910a17af6f76381 && y instanceof $af922821253503df$export$5910a17af6f76381) return true;
            if (x instanceof $af922821253503df$export$6ce944503089dadd && y instanceof $af922821253503df$export$6ce944503089dadd) return true;
            if (x instanceof $af922821253503df$export$5663b51bd1c6c084 && y instanceof $af922821253503df$export$5663b51bd1c6c084) return true;
            return false;
        };
    }
};
var $af922821253503df$export$4afeaf27b056d536 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $af922821253503df$export$85b4c654d12206aa && y instanceof $af922821253503df$export$85b4c654d12206aa) return $ibsD5.EQ.value;
            if (x instanceof $af922821253503df$export$85b4c654d12206aa) return $ibsD5.LT.value;
            if (y instanceof $af922821253503df$export$85b4c654d12206aa) return $ibsD5.GT.value;
            if (x instanceof $af922821253503df$export$bf0d11cf8bd9f5de && y instanceof $af922821253503df$export$bf0d11cf8bd9f5de) return $ibsD5.EQ.value;
            if (x instanceof $af922821253503df$export$bf0d11cf8bd9f5de) return $ibsD5.LT.value;
            if (y instanceof $af922821253503df$export$bf0d11cf8bd9f5de) return $ibsD5.GT.value;
            if (x instanceof $af922821253503df$export$5910a17af6f76381 && y instanceof $af922821253503df$export$5910a17af6f76381) return $ibsD5.EQ.value;
            if (x instanceof $af922821253503df$export$5910a17af6f76381) return $ibsD5.LT.value;
            if (y instanceof $af922821253503df$export$5910a17af6f76381) return $ibsD5.GT.value;
            if (x instanceof $af922821253503df$export$6ce944503089dadd && y instanceof $af922821253503df$export$6ce944503089dadd) return $ibsD5.EQ.value;
            if (x instanceof $af922821253503df$export$6ce944503089dadd) return $ibsD5.LT.value;
            if (y instanceof $af922821253503df$export$6ce944503089dadd) return $ibsD5.GT.value;
            if (x instanceof $af922821253503df$export$5663b51bd1c6c084 && y instanceof $af922821253503df$export$5663b51bd1c6c084) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.ScopeValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $af922821253503df$export$118ba639ca4f9d14;
    }
};


// Generated by purs version 0.15.16

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $2XxiF = parcelRequire("2XxiF");
var $353ecae9a7c600b2$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showNumber);
var $353ecae9a7c600b2$var$compare = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordNumber);
var $353ecae9a7c600b2$export$b24b633b1364b94b = /* #__PURE__ */ function() {
    function Any() {}
    Any.value = new Any();
    return Any;
}();
var $353ecae9a7c600b2$export$fd55ce593607084a = /* #__PURE__ */ function() {
    function Step(value0) {
        this.value0 = value0;
    }
    Step.create = function(value0) {
        return new Step(value0);
    };
    return Step;
}();
var $353ecae9a7c600b2$export$eb5efa61a2272b57 = function(v) {
    if (v instanceof $353ecae9a7c600b2$export$b24b633b1364b94b) return "any";
    if (v instanceof $353ecae9a7c600b2$export$fd55ce593607084a) return $353ecae9a7c600b2$var$show(v.value0);
    throw new Error("Failed pattern match at DOM.HTML.Indexed.StepValue (line 13, column 19 - line 15, column 19): " + [
        v.constructor.name
    ]);
};
var $353ecae9a7c600b2$export$8db64ca9ca089cac = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $353ecae9a7c600b2$export$b24b633b1364b94b && y instanceof $353ecae9a7c600b2$export$b24b633b1364b94b) return true;
            if (x instanceof $353ecae9a7c600b2$export$fd55ce593607084a && y instanceof $353ecae9a7c600b2$export$fd55ce593607084a) return x.value0 === y.value0;
            return false;
        };
    }
};
var $353ecae9a7c600b2$export$848021523941663f = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $353ecae9a7c600b2$export$b24b633b1364b94b && y instanceof $353ecae9a7c600b2$export$b24b633b1364b94b) return $ibsD5.EQ.value;
            if (x instanceof $353ecae9a7c600b2$export$b24b633b1364b94b) return $ibsD5.LT.value;
            if (y instanceof $353ecae9a7c600b2$export$b24b633b1364b94b) return $ibsD5.GT.value;
            if (x instanceof $353ecae9a7c600b2$export$fd55ce593607084a && y instanceof $353ecae9a7c600b2$export$fd55ce593607084a) return $353ecae9a7c600b2$var$compare(x.value0)(y.value0);
            throw new Error("Failed pattern match at DOM.HTML.Indexed.StepValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $353ecae9a7c600b2$export$8db64ca9ca089cac;
    }
};


// Generated by purs version 0.15.16

var $ibsD5 = parcelRequire("ibsD5");
var $e5d14cbe7a37aad0$export$a12ca0aab327cfc7 = /* #__PURE__ */ function() {
    function Hard() {}
    Hard.value = new Hard();
    return Hard;
}();
var $e5d14cbe7a37aad0$export$f8ab8e157e94ef80 = /* #__PURE__ */ function() {
    function Soft() {}
    Soft.value = new Soft();
    return Soft;
}();
var $e5d14cbe7a37aad0$export$a763fdfe677a0aa9 = function(v) {
    if (v instanceof $e5d14cbe7a37aad0$export$a12ca0aab327cfc7) return "hard";
    if (v instanceof $e5d14cbe7a37aad0$export$f8ab8e157e94ef80) return "soft";
    throw new Error("Failed pattern match at DOM.HTML.Indexed.WrapValue (line 13, column 19 - line 15, column 17): " + [
        v.constructor.name
    ]);
};
var $e5d14cbe7a37aad0$export$2ca5a4c778c64452 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e5d14cbe7a37aad0$export$a12ca0aab327cfc7 && y instanceof $e5d14cbe7a37aad0$export$a12ca0aab327cfc7) return true;
            if (x instanceof $e5d14cbe7a37aad0$export$f8ab8e157e94ef80 && y instanceof $e5d14cbe7a37aad0$export$f8ab8e157e94ef80) return true;
            return false;
        };
    }
};
var $e5d14cbe7a37aad0$export$7166197b77e6499a = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e5d14cbe7a37aad0$export$a12ca0aab327cfc7 && y instanceof $e5d14cbe7a37aad0$export$a12ca0aab327cfc7) return $ibsD5.EQ.value;
            if (x instanceof $e5d14cbe7a37aad0$export$a12ca0aab327cfc7) return $ibsD5.LT.value;
            if (y instanceof $e5d14cbe7a37aad0$export$a12ca0aab327cfc7) return $ibsD5.GT.value;
            if (x instanceof $e5d14cbe7a37aad0$export$f8ab8e157e94ef80 && y instanceof $e5d14cbe7a37aad0$export$f8ab8e157e94ef80) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at DOM.HTML.Indexed.WrapValue (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e5d14cbe7a37aad0$export$2ca5a4c778c64452;
    }
};



var $5ZwWo = parcelRequire("5ZwWo");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $46y1S = parcelRequire("46y1S");
// Generated by purs version 0.15.16

var $aJhEx = parcelRequire("aJhEx");

var $gwBF5 = parcelRequire("gwBF5");
var $e7ddcc4e56dd1e0b$export$37de0cf0f2f21d21 = function(x) {
    return x;
};
var $e7ddcc4e56dd1e0b$export$f4c20fd541e0bbe4 = /* #__PURE__ */ function() {
    function RefUpdate(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RefUpdate.create = function(value0) {
        return function(value1) {
            return new RefUpdate(value0, value1);
        };
    };
    return RefUpdate;
}();
var $e7ddcc4e56dd1e0b$export$e19cd5f9376f8cee = /* #__PURE__ */ function() {
    function Action(value0) {
        this.value0 = value0;
    }
    Action.create = function(value0) {
        return new Action(value0);
    };
    return Action;
}();
var $e7ddcc4e56dd1e0b$export$e4f50b41777b2135 = $gwBF5.ordString;
var $e7ddcc4e56dd1e0b$export$f406a712694a6a92 = {
    Coercible0: function() {
        return undefined;
    }
};
var $e7ddcc4e56dd1e0b$export$5158bce98a089317 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $e7ddcc4e56dd1e0b$export$f4c20fd541e0bbe4) return new $e7ddcc4e56dd1e0b$export$f4c20fd541e0bbe4(m.value0, m.value1);
            if (m instanceof $e7ddcc4e56dd1e0b$export$e19cd5f9376f8cee) return new $e7ddcc4e56dd1e0b$export$e19cd5f9376f8cee(f(m.value0));
            throw new Error("Failed pattern match at Halogen.Query.Input (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $e7ddcc4e56dd1e0b$export$9947dab6e2c9dd9d = $aJhEx.eqString;


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16

var $brrpF = parcelRequire("brrpF");

var $iQTlW = parcelRequire("iQTlW");

var $h2xUu = parcelRequire("h2xUu");


var $7O0Q4 = parcelRequire("7O0Q4");
// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");
var $c7f8bb6dcedfcaf7$export$fd55ce593607084a = /* #__PURE__ */ function() {
    function Step(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Step.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Step(value0, value1, value2, value3);
                };
            };
        };
    };
    return Step;
}();
var $c7f8bb6dcedfcaf7$export$4f45170fb98a7886 = $k2DSm.unsafeCoerce;
var $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92 = function(v, a) {
    return v.value2(v.value1, a);
};
var $c7f8bb6dcedfcaf7$export$dc52c2e07163a142 = $k2DSm.unsafeCoerce;
var $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de = function(v) {
    return v.value3(v.value1);
};
var $c7f8bb6dcedfcaf7$export$f9380c9a627682d3 = /* #__PURE__ */ $c7f8bb6dcedfcaf7$export$4f45170fb98a7886(function(v) {
    return v.value0;
});


// Generated by purs version 0.15.16

var $26SV5 = parcelRequire("26SV5");

var $5ZwWo = parcelRequire("5ZwWo");

var $aJhEx = parcelRequire("aJhEx");

var $7FzSN = parcelRequire("7FzSN");

var $gwBF5 = parcelRequire("gwBF5");

var $7O0Q4 = parcelRequire("7O0Q4");

var $k2DSm = parcelRequire("k2DSm");
var $ee7eb0766a1d7549$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $ee7eb0766a1d7549$var$map = /* #__PURE__ */ $7FzSN.map($7FzSN.functorArray);
var $ee7eb0766a1d7549$var$map1 = /* #__PURE__ */ $7FzSN.map($7O0Q4.functorTuple);
var $ee7eb0766a1d7549$export$f89ac22183df46e9 = function(x) {
    return x;
};
var $ee7eb0766a1d7549$export$4d8ac795221d227 = function(x) {
    return x;
};
var $ee7eb0766a1d7549$export$5f1af8db9871e1d6 = /* #__PURE__ */ function() {
    function Text(value0) {
        this.value0 = value0;
    }
    Text.create = function(value0) {
        return new Text(value0);
    };
    return Text;
}();
var $ee7eb0766a1d7549$export$cc2832fafe367c5e = /* #__PURE__ */ function() {
    function Elem(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Elem.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Elem(value0, value1, value2, value3);
                };
            };
        };
    };
    return Elem;
}();
var $ee7eb0766a1d7549$export$bade370ab89110b = /* #__PURE__ */ function() {
    function Keyed(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Keyed.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Keyed(value0, value1, value2, value3);
                };
            };
        };
    };
    return Keyed;
}();
var $ee7eb0766a1d7549$export$a829527ff4e4114a = /* #__PURE__ */ function() {
    function Widget(value0) {
        this.value0 = value0;
    }
    Widget.create = function(value0) {
        return new Widget(value0);
    };
    return Widget;
}();
var $ee7eb0766a1d7549$export$b73d5241bf90e3b6 = /* #__PURE__ */ function() {
    function Grafted(value0) {
        this.value0 = value0;
    }
    Grafted.create = function(value0) {
        return new Grafted(value0);
    };
    return Grafted;
}();
var $ee7eb0766a1d7549$export$8ac9228c788aaa24 = /* #__PURE__ */ function() {
    function Graft(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Graft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Graft(value0, value1, value2);
            };
        };
    };
    return Graft;
}();
var $ee7eb0766a1d7549$export$c0694dcc5ceec5fe = function(f) {
    return function($61) {
        return f($61);
    };
};
var $ee7eb0766a1d7549$export$1b27a95e780e7371 = $gwBF5.ordString;
var $ee7eb0766a1d7549$export$2de60fdae46e330f = $gwBF5.ordString;
var $ee7eb0766a1d7549$export$15ad108a4eed29f5 = {
    Coercible0: function() {
        return undefined;
    }
};
var $ee7eb0766a1d7549$export$79c9400ffffba296 = {
    Coercible0: function() {
        return undefined;
    }
};
var $ee7eb0766a1d7549$export$9bae923d92949c2f = $k2DSm.unsafeCoerce;
var $ee7eb0766a1d7549$export$d77f48fa96824602 = {
    map: function(g) {
        return $ee7eb0766a1d7549$export$c0694dcc5ceec5fe(function(v) {
            return $ee7eb0766a1d7549$export$9bae923d92949c2f(new $ee7eb0766a1d7549$export$8ac9228c788aaa24(v.value0, function($62) {
                return g(v.value1($62));
            }, v.value2));
        });
    }
};
var $ee7eb0766a1d7549$var$map2 = /* #__PURE__ */ $7FzSN.map($ee7eb0766a1d7549$export$d77f48fa96824602);
var $ee7eb0766a1d7549$export$1654609171f4374f = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $ee7eb0766a1d7549$export$5f1af8db9871e1d6) return new $ee7eb0766a1d7549$export$5f1af8db9871e1d6(v1.value0);
            if (v1 instanceof $ee7eb0766a1d7549$export$b73d5241bf90e3b6) return new $ee7eb0766a1d7549$export$b73d5241bf90e3b6($ee7eb0766a1d7549$var$map2(v)(v1.value0));
            return new $ee7eb0766a1d7549$export$b73d5241bf90e3b6($ee7eb0766a1d7549$export$9bae923d92949c2f(new $ee7eb0766a1d7549$export$8ac9228c788aaa24($ee7eb0766a1d7549$var$identity, v, v1)));
        };
    }
};
var $ee7eb0766a1d7549$export$520c9b3bf6c7d33a = $aJhEx.eqString;
var $ee7eb0766a1d7549$export$23ec092d74ce9fd = $aJhEx.eqString;
var $ee7eb0766a1d7549$export$45ea1942547d2591 = {
    bimap: function(f) {
        return function(g) {
            return $ee7eb0766a1d7549$export$c0694dcc5ceec5fe(function(v) {
                return $ee7eb0766a1d7549$export$9bae923d92949c2f(new $ee7eb0766a1d7549$export$8ac9228c788aaa24(function($63) {
                    return f(v.value0($63));
                }, function($64) {
                    return g(v.value1($64));
                }, v.value2));
            });
        };
    }
};
var $ee7eb0766a1d7549$var$bimap = /* #__PURE__ */ $5ZwWo.bimap($ee7eb0766a1d7549$export$45ea1942547d2591);
var $ee7eb0766a1d7549$export$cb4b70c26113b373 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $ee7eb0766a1d7549$export$5f1af8db9871e1d6) return new $ee7eb0766a1d7549$export$5f1af8db9871e1d6(v2.value0);
                if (v2 instanceof $ee7eb0766a1d7549$export$b73d5241bf90e3b6) return new $ee7eb0766a1d7549$export$b73d5241bf90e3b6($ee7eb0766a1d7549$var$bimap(v)(v1)(v2.value0));
                return new $ee7eb0766a1d7549$export$b73d5241bf90e3b6($ee7eb0766a1d7549$export$9bae923d92949c2f(new $ee7eb0766a1d7549$export$8ac9228c788aaa24(v, v1, v2)));
            };
        };
    }
};
var $ee7eb0766a1d7549$export$355e219ccdea0aec = /* #__PURE__ */ $ee7eb0766a1d7549$export$c0694dcc5ceec5fe(function(v) {
    var go = function(v2) {
        if (v2 instanceof $ee7eb0766a1d7549$export$5f1af8db9871e1d6) return new $ee7eb0766a1d7549$export$5f1af8db9871e1d6(v2.value0);
        if (v2 instanceof $ee7eb0766a1d7549$export$cc2832fafe367c5e) return new $ee7eb0766a1d7549$export$cc2832fafe367c5e(v2.value0, v2.value1, v.value0(v2.value2), $ee7eb0766a1d7549$var$map(go)(v2.value3));
        if (v2 instanceof $ee7eb0766a1d7549$export$bade370ab89110b) return new $ee7eb0766a1d7549$export$bade370ab89110b(v2.value0, v2.value1, v.value0(v2.value2), $ee7eb0766a1d7549$var$map($ee7eb0766a1d7549$var$map1(go))(v2.value3));
        if (v2 instanceof $ee7eb0766a1d7549$export$a829527ff4e4114a) return new $ee7eb0766a1d7549$export$a829527ff4e4114a(v.value1(v2.value0));
        if (v2 instanceof $ee7eb0766a1d7549$export$b73d5241bf90e3b6) return new $ee7eb0766a1d7549$export$b73d5241bf90e3b6($ee7eb0766a1d7549$var$bimap(v.value0)(v.value1)(v2.value0));
        throw new Error("Failed pattern match at Halogen.VDom.Types (line 86, column 7 - line 86, column 27): " + [
            v2.constructor.name
        ]);
    };
    return go(v.value2);
});
var $ee7eb0766a1d7549$export$8b4d9aa5702dece6 = function(f) {
    return function(g) {
        return function(v) {
            if (v instanceof $ee7eb0766a1d7549$export$5f1af8db9871e1d6) return new $ee7eb0766a1d7549$export$5f1af8db9871e1d6(v.value0);
            if (v instanceof $ee7eb0766a1d7549$export$cc2832fafe367c5e) return new $ee7eb0766a1d7549$export$cc2832fafe367c5e(v.value0, v.value1, f(v.value2), $ee7eb0766a1d7549$var$map($ee7eb0766a1d7549$export$8b4d9aa5702dece6(f)(g))(v.value3));
            if (v instanceof $ee7eb0766a1d7549$export$bade370ab89110b) return new $ee7eb0766a1d7549$export$bade370ab89110b(v.value0, v.value1, f(v.value2), $ee7eb0766a1d7549$var$map($ee7eb0766a1d7549$var$map1($ee7eb0766a1d7549$export$8b4d9aa5702dece6(f)(g)))(v.value3));
            if (v instanceof $ee7eb0766a1d7549$export$a829527ff4e4114a) return g(v.value0);
            if (v instanceof $ee7eb0766a1d7549$export$b73d5241bf90e3b6) return $ee7eb0766a1d7549$export$8b4d9aa5702dece6(f)(g)($ee7eb0766a1d7549$export$355e219ccdea0aec(v.value0));
            throw new Error("Failed pattern match at Halogen.VDom.Types (line 48, column 20 - line 53, column 48): " + [
                v.constructor.name
            ]);
        };
    };
};


// Generated by purs version 0.15.16
"use strict";
function $4fef3a56afd3fa03$export$e21bd765865a4e96(key, obj) {
    return obj[key];
}
function $4fef3a56afd3fa03$export$2d12e28667eef122(key, obj) {
    return obj.hasOwnProperty(key);
}
function $4fef3a56afd3fa03$export$eecc4ddbfda9d798(key, val, obj) {
    obj[key] = val;
}
function $4fef3a56afd3fa03$export$97784d9c47ea0c18(key, obj) {
    delete obj[key];
}
function $4fef3a56afd3fa03$export$3dfbdd78bf0090db(a, f) {
    var b = [];
    for(var i = 0; i < a.length; i++)b.push(f(i, a[i]));
    return b;
}
function $4fef3a56afd3fa03$export$b658ad92e4f7ae19(a, f) {
    for(var i = 0; i < a.length; i++)f(a[i]);
}
function $4fef3a56afd3fa03$export$2da2a225d7cdb301(o, f) {
    var ks = Object.keys(o);
    for(var i = 0; i < ks.length; i++){
        var k = ks[i];
        f(k, o[k]);
    }
}
function $4fef3a56afd3fa03$export$eb8acc503e07b694(n, f) {
    for(var i = 0; i < n; i++)f();
}
function $4fef3a56afd3fa03$export$2422518e1f611f3f(a1, a2, f1, f2, f3) {
    var a3 = [];
    var l1 = a1.length;
    var l2 = a2.length;
    var i = 0;
    while(true){
        if (i < l1) {
            if (i < l2) a3.push(f1(i, a1[i], a2[i]));
            else f2(i, a1[i]);
        } else if (i < l2) a3.push(f3(i, a2[i]));
        else break;
        i++;
    }
    return a3;
}
function $4fef3a56afd3fa03$export$e766566cf460084(as, fk, f) {
    var o = {};
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        var k = fk(a);
        o[k] = f(k, i, a);
    }
    return o;
}
function $4fef3a56afd3fa03$export$ca7590ccd55f275f(o1, as, fk, f1, f2, f3) {
    var o2 = {};
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        var k = fk(a);
        if (o1.hasOwnProperty(k)) o2[k] = f1(k, i, o1[k], a);
        else o2[k] = f3(k, i, a);
    }
    for(var k in o1){
        if (k in o2) continue;
        f2(k, o1[k]);
    }
    return o2;
}
function $4fef3a56afd3fa03$export$9bc2d847a861e3d8(a, b) {
    return a === b;
}
function $4fef3a56afd3fa03$export$b2ce9ad90858ed7a(s, doc) {
    return doc.createTextNode(s);
}
function $4fef3a56afd3fa03$export$94b0296cab6203e(s, n) {
    n.textContent = s;
}
function $4fef3a56afd3fa03$export$c8a8987d4410bf2d(ns, name, doc) {
    if (ns != null) return doc.createElementNS(ns, name);
    else return doc.createElement(name);
}
function $4fef3a56afd3fa03$export$11c1557a40268f0f(i, a, b) {
    var n = b.childNodes.item(i) || null;
    if (n !== a) b.insertBefore(a, n);
}
function $4fef3a56afd3fa03$export$7ae609f7af59e4f7(a, b) {
    if (b && a.parentNode === b) b.removeChild(a);
}
function $4fef3a56afd3fa03$export$b54be7ce267a037b(a) {
    return a.parentNode;
}
function $4fef3a56afd3fa03$export$9fec4d97f1922e0b(ns, attr, val, el) {
    if (ns != null) el.setAttributeNS(ns, attr, val);
    else el.setAttribute(attr, val);
}
function $4fef3a56afd3fa03$export$6399f3bb52316b2c(ns, attr, el) {
    if (ns != null) el.removeAttributeNS(ns, attr);
    else el.removeAttribute(attr);
}
function $4fef3a56afd3fa03$export$7895096fcdde5712(ns, attr, el) {
    if (ns != null) return el.hasAttributeNS(ns, attr);
    else return el.hasAttribute(attr);
}
function $4fef3a56afd3fa03$export$3f65cefe8380dbea(ev, listener, el) {
    el.addEventListener(ev, listener, false);
}
function $4fef3a56afd3fa03$export$8ff9f68337b520c0(ev, listener, el) {
    el.removeEventListener(ev, listener, false);
}
var $4fef3a56afd3fa03$export$1e4bb18162c9f619 = void 0;


// Generated by purs version 0.15.16
const $b9f228271a7c74b6$export$b8cb59497041ffe4 = function() {
    return {};
};
function $b9f228271a7c74b6$export$6dc5f95d8548a16a(just) {
    return function(nothing) {
        return function(k) {
            return function(m) {
                return function() {
                    return ({}).hasOwnProperty.call(m, k) ? just(m[k]) : nothing;
                };
            };
        };
    };
}
function $b9f228271a7c74b6$export$dc13bdd74c909d26(k) {
    return function(v) {
        return function(m) {
            return function() {
                m[k] = v;
                return m;
            };
        };
    };
}
const $b9f228271a7c74b6$export$1822828d790e23ee = function(k) {
    return function(m) {
        return function() {
            delete m[k];
            return m;
        };
    };
};



var $h2xUu = parcelRequire("h2xUu");
var $67b4b834348448e4$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $b9f228271a7c74b6$export$6dc5f95d8548a16a($h2xUu.Just.create)($h2xUu.Nothing.value);
}();



var $k2DSm = parcelRequire("k2DSm");
var $5e207c75f3b373f8$export$7ff190aa1ea44157 = $4fef3a56afd3fa03$export$e21bd765865a4e96;
var $5e207c75f3b373f8$export$7c850c5af9b9983e = $k2DSm.unsafeCoerce;
var $5e207c75f3b373f8$export$fcec48ff7d1e433f = $4fef3a56afd3fa03$export$eecc4ddbfda9d798;
var $5e207c75f3b373f8$export$af208d62fa81d7e9 = $b9f228271a7c74b6$export$b8cb59497041ffe4;
var $5e207c75f3b373f8$export$60e478053f1f2ade = $4fef3a56afd3fa03$export$97784d9c47ea0c18;


// Generated by purs version 0.15.16
var $11edb9cba59d3069$var$getProp = function(name) {
    return function(doctype) {
        return doctype[name];
    };
};
const $11edb9cba59d3069$export$3c44083a252eeb14 = $11edb9cba59d3069$var$getProp("namespaceURI");
const $11edb9cba59d3069$export$6ae22f6d74087c1a = $11edb9cba59d3069$var$getProp("prefix");
const $11edb9cba59d3069$export$cbef64f03c7768af = $11edb9cba59d3069$var$getProp("localName");
const $11edb9cba59d3069$export$45e0b80f1e500bd4 = $11edb9cba59d3069$var$getProp("tagName");
function $11edb9cba59d3069$export$d560c7e4a29451c2(node) {
    return function() {
        return node.id;
    };
}
function $11edb9cba59d3069$export$5fd54ffb744fa241(id) {
    return function(node) {
        return function() {
            node.id = id;
        };
    };
}
function $11edb9cba59d3069$export$2913c0c0b5623090(node) {
    return function() {
        return node.className;
    };
}
function $11edb9cba59d3069$export$11c615ce16f87241(element) {
    return function() {
        return element.classList;
    };
}
function $11edb9cba59d3069$export$826e926e0c74f2b8(className) {
    return function(node) {
        return function() {
            node.className = className;
        };
    };
}
function $11edb9cba59d3069$export$af941c3c7c3b40f5(localName) {
    return function(doc) {
        return function() {
            return doc.getElementsByTagName(localName);
        };
    };
}
function $11edb9cba59d3069$export$83374683e5723893(ns) {
    return function(localName) {
        return function(doc) {
            return function() {
                return doc.getElementsByTagNameNS(ns, localName);
            };
        };
    };
}
function $11edb9cba59d3069$export$764e2797d3aa1cff(classNames) {
    return function(doc) {
        return function() {
            return doc.getElementsByClassName(classNames);
        };
    };
}
function $11edb9cba59d3069$export$9fec4d97f1922e0b(name) {
    return function(value) {
        return function(element) {
            return function() {
                element.setAttribute(name, value);
            };
        };
    };
}
function $11edb9cba59d3069$export$2dc9d886be7724ad(name) {
    return function(element) {
        return function() {
            return element.getAttribute(name);
        };
    };
}
function $11edb9cba59d3069$export$7895096fcdde5712(name) {
    return function(element) {
        return function() {
            return element.hasAttribute(name);
        };
    };
}
function $11edb9cba59d3069$export$6399f3bb52316b2c(name) {
    return function(element) {
        return function() {
            element.removeAttribute(name);
        };
    };
}
function $11edb9cba59d3069$export$de994efd351b291c(selector) {
    return function(element) {
        return function() {
            return element.matches(selector);
        };
    };
}
function $11edb9cba59d3069$export$15ddd5fd0edb3555(selector) {
    return function(element) {
        return function() {
            return element.closest(selector);
        };
    };
}
function $11edb9cba59d3069$export$3e0c8fa3b5e4b3b9(node) {
    return function() {
        return node.scrollTop;
    };
}
function $11edb9cba59d3069$export$38a81aac5c9c320d(scrollTop) {
    return function(node) {
        return function() {
            node.scrollTop = scrollTop;
        };
    };
}
function $11edb9cba59d3069$export$6eddf9bc7f2b7d80(node) {
    return function() {
        return node.scrollLeft;
    };
}
function $11edb9cba59d3069$export$ed5fd5ffe5ab0ac(scrollLeft) {
    return function(node) {
        return function() {
            node.scrollLeft = scrollLeft;
        };
    };
}
function $11edb9cba59d3069$export$dc81048565b75a98(el) {
    return function() {
        return el.scrollWidth;
    };
}
function $11edb9cba59d3069$export$5a0845c0f7cb1511(el) {
    return function() {
        return el.scrollHeight;
    };
}
function $11edb9cba59d3069$export$b570871c7d022cff(el) {
    return function() {
        return el.clientTop;
    };
}
function $11edb9cba59d3069$export$6af8701396d90b51(el) {
    return function() {
        return el.clientLeft;
    };
}
function $11edb9cba59d3069$export$f451d61d633bfdbe(el) {
    return function() {
        return el.clientWidth;
    };
}
function $11edb9cba59d3069$export$1ceecc078aa19b72(el) {
    return function() {
        return el.clientHeight;
    };
}
function $11edb9cba59d3069$export$84fe60b31769e95f(el) {
    return function() {
        var rect = el.getBoundingClientRect();
        return {
            top: rect.top,
            right: rect.right,
            bottom: rect.bottom,
            left: rect.left,
            width: rect.width,
            height: rect.height,
            x: rect.x,
            y: rect.y
        };
    };
}
function $11edb9cba59d3069$export$4afda0764643aba3(props) {
    return function(el) {
        return function() {
            return el.attachShadow(props);
        };
    };
}



var $7FzSN = parcelRequire("7FzSN");


var $2XxiF = parcelRequire("2XxiF");

var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");
// Generated by purs version 0.15.16



// Generated by purs version 0.15.16
function $7b68aab7b91faa10$export$fe54a26f58202d85(el) {
    return el.mode;
}
function $7b68aab7b91faa10$export$5e032988b71f6158(el) {
    return function() {
        return el.host;
    };
}



var $h2xUu = parcelRequire("h2xUu");

var $k2DSm = parcelRequire("k2DSm");
var $14e11788751c10aa$export$779aeef03935e9f3 = /* #__PURE__ */ function() {
    function Open() {}
    Open.value = new Open();
    return Open;
}();
var $14e11788751c10aa$export$b6448e3d47beddf0 = /* #__PURE__ */ function() {
    function Closed() {}
    Closed.value = new Closed();
    return Closed;
}();
var $14e11788751c10aa$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $14e11788751c10aa$export$2197b54dae41dfe4 = {
    show: function(v) {
        if (v instanceof $14e11788751c10aa$export$779aeef03935e9f3) return "open";
        if (v instanceof $14e11788751c10aa$export$b6448e3d47beddf0) return "closed";
        throw new Error("Failed pattern match at Web.DOM.ShadowRoot (line 22, column 1 - line 24, column 25): " + [
            v.constructor.name
        ]);
    }
};
var $14e11788751c10aa$export$549ff81930776885 = /* #__PURE__ */ function() {
    var modeFromString = function(v) {
        if (v === "open") return new $h2xUu.Just($14e11788751c10aa$export$779aeef03935e9f3.value);
        if (v === "closed") return new $h2xUu.Just($14e11788751c10aa$export$b6448e3d47beddf0.value);
        return $h2xUu.Nothing.value;
    };
    return function($5) {
        return modeFromString($7b68aab7b91faa10$export$fe54a26f58202d85($5));
    };
}();



var $3c90ea386e13bdf9$var$show = /* #__PURE__ */ $2XxiF.show($14e11788751c10aa$export$2197b54dae41dfe4);
var $3c90ea386e13bdf9$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $3c90ea386e13bdf9$export$c8b651b897da2de = $k2DSm.unsafeCoerce;
var $3c90ea386e13bdf9$export$f8671ec463598929 = $k2DSm.unsafeCoerce;
var $3c90ea386e13bdf9$export$83a0de4644f1fbc4 = $k2DSm.unsafeCoerce;
var $3c90ea386e13bdf9$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $3c90ea386e13bdf9$export$8ff7c34974173077 = $k2DSm.unsafeCoerce;
var $3c90ea386e13bdf9$export$82e9f45cca5ba907 = function($3) {
    return $ae4217dcc85a7c03$export$1ba013b88f4f21f3($11edb9cba59d3069$export$6ae22f6d74087c1a($3));
};
var $3c90ea386e13bdf9$export$4bb31c815825375a = function($4) {
    return $ae4217dcc85a7c03$export$1ba013b88f4f21f3($11edb9cba59d3069$export$3c44083a252eeb14($4));
};
var $3c90ea386e13bdf9$var$initToProps = function(init) {
    return {
        mode: $3c90ea386e13bdf9$var$show(init.mode),
        delegatesFocus: init.delegatesFocus
    };
};
var $3c90ea386e13bdf9$export$5c5bb02a2f64596a = function($5) {
    return $11edb9cba59d3069$export$83374683e5723893($ae4217dcc85a7c03$export$b187f57ee1822bc5($5));
};
var $3c90ea386e13bdf9$export$735ee1799fd02602 = function(attr) {
    var $6 = $3c90ea386e13bdf9$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    var $7 = $11edb9cba59d3069$export$2dc9d886be7724ad(attr);
    return function($8) {
        return $6($7($8));
    };
};
var $3c90ea386e13bdf9$export$7039ba397093f069 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("Element");
var $3c90ea386e13bdf9$export$66db07be43ecb0c3 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("Element");
var $3c90ea386e13bdf9$export$a7f097b65af8aa04 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("Element");
var $3c90ea386e13bdf9$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("Element");
var $3c90ea386e13bdf9$export$31942037104a4a20 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("Element");
var $3c90ea386e13bdf9$export$ff7f7c97cdce86e = function(qs) {
    var $9 = $3c90ea386e13bdf9$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    var $10 = $11edb9cba59d3069$export$15ddd5fd0edb3555(qs);
    return function($11) {
        return $9($10($11));
    };
};
var $3c90ea386e13bdf9$export$c9f3f5ba3dfbdf61 = function($12) {
    return $11edb9cba59d3069$export$4afda0764643aba3($3c90ea386e13bdf9$var$initToProps($12));
};


var $2bb7f7bd8b4c6f39$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $2bb7f7bd8b4c6f39$export$db317447723f2845 = function(x) {
    return x;
};
var $2bb7f7bd8b4c6f39$var$haltWidget = function(v) {
    return $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de(v.widget);
};
var $2bb7f7bd8b4c6f39$var$$lazy_patchWidget = /* #__PURE__ */ $2bb7f7bd8b4c6f39$var$$runtime_lazy("patchWidget", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $ee7eb0766a1d7549$export$b73d5241bf90e3b6) return $2bb7f7bd8b4c6f39$var$$lazy_patchWidget(291)(state, $ee7eb0766a1d7549$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $ee7eb0766a1d7549$export$a829527ff4e4114a) {
            var res = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(state.widget, vdom.value0);
            var res$prime = $c7f8bb6dcedfcaf7$export$4f45170fb98a7886(function(v) {
                return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(v.value0, {
                    build: state.build,
                    widget: res
                }, $2bb7f7bd8b4c6f39$var$$lazy_patchWidget(296), $2bb7f7bd8b4c6f39$var$haltWidget));
            })(res);
            return res$prime;
        }
        $2bb7f7bd8b4c6f39$var$haltWidget(state);
        return state.build(vdom);
    };
});
var $2bb7f7bd8b4c6f39$var$patchWidget = /* #__PURE__ */ $2bb7f7bd8b4c6f39$var$$lazy_patchWidget(286);
var $2bb7f7bd8b4c6f39$var$haltText = function(v) {
    var parent = $4fef3a56afd3fa03$export$b54be7ce267a037b(v.node);
    return $4fef3a56afd3fa03$export$7ae609f7af59e4f7(v.node, parent);
};
var $2bb7f7bd8b4c6f39$var$$lazy_patchText = /* #__PURE__ */ $2bb7f7bd8b4c6f39$var$$runtime_lazy("patchText", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $ee7eb0766a1d7549$export$b73d5241bf90e3b6) return $2bb7f7bd8b4c6f39$var$$lazy_patchText(82)(state, $ee7eb0766a1d7549$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $ee7eb0766a1d7549$export$5f1af8db9871e1d6) {
            if (state.value === vdom.value0) return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(state.node, state, $2bb7f7bd8b4c6f39$var$$lazy_patchText(85), $2bb7f7bd8b4c6f39$var$haltText));
            if ($iQTlW.otherwise) {
                var nextState = {
                    build: state.build,
                    node: state.node,
                    value: vdom.value0
                };
                $4fef3a56afd3fa03$export$94b0296cab6203e(vdom.value0, state.node);
                return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(state.node, nextState, $2bb7f7bd8b4c6f39$var$$lazy_patchText(89), $2bb7f7bd8b4c6f39$var$haltText));
            }
        }
        $2bb7f7bd8b4c6f39$var$haltText(state);
        return state.build(vdom);
    };
});
var $2bb7f7bd8b4c6f39$var$patchText = /* #__PURE__ */ $2bb7f7bd8b4c6f39$var$$lazy_patchText(77);
var $2bb7f7bd8b4c6f39$var$haltKeyed = function(v) {
    var parent = $4fef3a56afd3fa03$export$b54be7ce267a037b(v.node);
    $4fef3a56afd3fa03$export$7ae609f7af59e4f7(v.node, parent);
    $4fef3a56afd3fa03$export$2da2a225d7cdb301(v.children, function(v1, s) {
        return $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de(s);
    });
    return $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de(v.attrs);
};
var $2bb7f7bd8b4c6f39$var$haltElem = function(v) {
    var parent = $4fef3a56afd3fa03$export$b54be7ce267a037b(v.node);
    $4fef3a56afd3fa03$export$7ae609f7af59e4f7(v.node, parent);
    $4fef3a56afd3fa03$export$b658ad92e4f7ae19(v.children, $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de);
    return $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de(v.attrs);
};
var $2bb7f7bd8b4c6f39$var$eqElemSpec = function(ns1, v, ns2, v1) {
    var $63 = v === v1;
    if ($63) {
        if (ns1 instanceof $h2xUu.Just && ns2 instanceof $h2xUu.Just && ns1.value0 === ns2.value0) return true;
        if (ns1 instanceof $h2xUu.Nothing && ns2 instanceof $h2xUu.Nothing) return true;
        return false;
    }
    return false;
};
var $2bb7f7bd8b4c6f39$var$$lazy_patchElem = /* #__PURE__ */ $2bb7f7bd8b4c6f39$var$$runtime_lazy("patchElem", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $ee7eb0766a1d7549$export$b73d5241bf90e3b6) return $2bb7f7bd8b4c6f39$var$$lazy_patchElem(135)(state, $ee7eb0766a1d7549$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $ee7eb0766a1d7549$export$cc2832fafe367c5e && $2bb7f7bd8b4c6f39$var$eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
            var v = $brrpF.length(vdom.value3);
            var v1 = $brrpF.length(state.children);
            if (v1 === 0 && v === 0) {
                var attrs2 = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(state.attrs, vdom.value2);
                var nextState = {
                    build: state.build,
                    node: state.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state.children
                };
                return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(state.node, nextState, $2bb7f7bd8b4c6f39$var$$lazy_patchElem(149), $2bb7f7bd8b4c6f39$var$haltElem));
            }
            var onThis = function(v2, s) {
                return $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de(s);
            };
            var onThese = function(ix, s, v2) {
                var res = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(s, v2);
                $4fef3a56afd3fa03$export$11c1557a40268f0f(ix, $c7f8bb6dcedfcaf7$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var onThat = function(ix, v2) {
                var res = state.build(v2);
                $4fef3a56afd3fa03$export$11c1557a40268f0f(ix, $c7f8bb6dcedfcaf7$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var children2 = $4fef3a56afd3fa03$export$2422518e1f611f3f(state.children, vdom.value3, onThese, onThis, onThat);
            var attrs2 = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(state.attrs, vdom.value2);
            var nextState = {
                build: state.build,
                node: state.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2
            };
            return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(state.node, nextState, $2bb7f7bd8b4c6f39$var$$lazy_patchElem(172), $2bb7f7bd8b4c6f39$var$haltElem));
        }
        $2bb7f7bd8b4c6f39$var$haltElem(state);
        return state.build(vdom);
    };
});
var $2bb7f7bd8b4c6f39$var$patchElem = /* #__PURE__ */ $2bb7f7bd8b4c6f39$var$$lazy_patchElem(130);
var $2bb7f7bd8b4c6f39$var$$lazy_patchKeyed = /* #__PURE__ */ $2bb7f7bd8b4c6f39$var$$runtime_lazy("patchKeyed", "Halogen.VDom.DOM", function() {
    return function(state, vdom) {
        if (vdom instanceof $ee7eb0766a1d7549$export$b73d5241bf90e3b6) return $2bb7f7bd8b4c6f39$var$$lazy_patchKeyed(222)(state, $ee7eb0766a1d7549$export$355e219ccdea0aec(vdom.value0));
        if (vdom instanceof $ee7eb0766a1d7549$export$bade370ab89110b && $2bb7f7bd8b4c6f39$var$eqElemSpec(state.ns, state.name, vdom.value0, vdom.value1)) {
            var v = $brrpF.length(vdom.value3);
            if (state.length === 0 && v === 0) {
                var attrs2 = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(state.attrs, vdom.value2);
                var nextState = {
                    build: state.build,
                    node: state.node,
                    attrs: attrs2,
                    ns: vdom.value0,
                    name: vdom.value1,
                    children: state.children,
                    length: 0
                };
                return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(state.node, nextState, $2bb7f7bd8b4c6f39$var$$lazy_patchKeyed(237), $2bb7f7bd8b4c6f39$var$haltKeyed));
            }
            var onThis = function(v2, s) {
                return $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de(s);
            };
            var onThese = function(v2, ix$prime, s, v3) {
                var res = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(s, v3.value1);
                $4fef3a56afd3fa03$export$11c1557a40268f0f(ix$prime, $c7f8bb6dcedfcaf7$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var onThat = function(v2, ix, v3) {
                var res = state.build(v3.value1);
                $4fef3a56afd3fa03$export$11c1557a40268f0f(ix, $c7f8bb6dcedfcaf7$export$f9380c9a627682d3(res), state.node);
                return res;
            };
            var children2 = $4fef3a56afd3fa03$export$ca7590ccd55f275f(state.children, vdom.value3, $7O0Q4.fst, onThese, onThis, onThat);
            var attrs2 = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(state.attrs, vdom.value2);
            var nextState = {
                build: state.build,
                node: state.node,
                attrs: attrs2,
                ns: vdom.value0,
                name: vdom.value1,
                children: children2,
                length: v
            };
            return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(state.node, nextState, $2bb7f7bd8b4c6f39$var$$lazy_patchKeyed(261), $2bb7f7bd8b4c6f39$var$haltKeyed));
        }
        $2bb7f7bd8b4c6f39$var$haltKeyed(state);
        return state.build(vdom);
    };
});
var $2bb7f7bd8b4c6f39$var$patchKeyed = /* #__PURE__ */ $2bb7f7bd8b4c6f39$var$$lazy_patchKeyed(217);
var $2bb7f7bd8b4c6f39$export$150cc32b4adaaae = function(v, build, w) {
    var res = v.buildWidget(v)(w);
    var res$prime = $c7f8bb6dcedfcaf7$export$4f45170fb98a7886(function(v1) {
        return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(v1.value0, {
            build: build,
            widget: res
        }, $2bb7f7bd8b4c6f39$var$patchWidget, $2bb7f7bd8b4c6f39$var$haltWidget));
    })(res);
    return res$prime;
};
var $2bb7f7bd8b4c6f39$export$97ed363902aee1ba = function(v, build, s) {
    var node = $4fef3a56afd3fa03$export$b2ce9ad90858ed7a(s, v.document);
    var state = {
        build: build,
        node: node,
        value: s
    };
    return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(node, state, $2bb7f7bd8b4c6f39$var$patchText, $2bb7f7bd8b4c6f39$var$haltText));
};
var $2bb7f7bd8b4c6f39$export$198573fdc68576c0 = function(v, build, ns1, name1, as1, ch1) {
    var el = $4fef3a56afd3fa03$export$c8a8987d4410bf2d($ae4217dcc85a7c03$export$b187f57ee1822bc5(ns1), name1, v.document);
    var node = $3c90ea386e13bdf9$export$83a0de4644f1fbc4(el);
    var onChild = function(v1, ix, v2) {
        var res = build(v2.value1);
        $4fef3a56afd3fa03$export$11c1557a40268f0f(ix, $c7f8bb6dcedfcaf7$export$f9380c9a627682d3(res), node);
        return res;
    };
    var children = $4fef3a56afd3fa03$export$e766566cf460084(ch1, $7O0Q4.fst, onChild);
    var attrs = v.buildAttributes(el)(as1);
    var state = {
        build: build,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children,
        length: $brrpF.length(ch1)
    };
    return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(node, state, $2bb7f7bd8b4c6f39$var$patchKeyed, $2bb7f7bd8b4c6f39$var$haltKeyed));
};
var $2bb7f7bd8b4c6f39$export$88209766f38bf9bf = function(v, build, ns1, name1, as1, ch1) {
    var el = $4fef3a56afd3fa03$export$c8a8987d4410bf2d($ae4217dcc85a7c03$export$b187f57ee1822bc5(ns1), name1, v.document);
    var node = $3c90ea386e13bdf9$export$83a0de4644f1fbc4(el);
    var onChild = function(ix, child) {
        var res = build(child);
        $4fef3a56afd3fa03$export$11c1557a40268f0f(ix, $c7f8bb6dcedfcaf7$export$f9380c9a627682d3(res), node);
        return res;
    };
    var children = $4fef3a56afd3fa03$export$3dfbdd78bf0090db(ch1, onChild);
    var attrs = v.buildAttributes(el)(as1);
    var state = {
        build: build,
        node: node,
        attrs: attrs,
        ns: ns1,
        name: name1,
        children: children
    };
    return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(node, state, $2bb7f7bd8b4c6f39$var$patchElem, $2bb7f7bd8b4c6f39$var$haltElem));
};
var $2bb7f7bd8b4c6f39$export$7d13c0f6790d0505 = function(spec) {
    var $lazy_build = $2bb7f7bd8b4c6f39$var$$runtime_lazy("build", "Halogen.VDom.DOM", function() {
        return function(v) {
            if (v instanceof $ee7eb0766a1d7549$export$5f1af8db9871e1d6) return $2bb7f7bd8b4c6f39$export$97ed363902aee1ba(spec, $lazy_build(59), v.value0);
            if (v instanceof $ee7eb0766a1d7549$export$cc2832fafe367c5e) return $2bb7f7bd8b4c6f39$export$88209766f38bf9bf(spec, $lazy_build(60), v.value0, v.value1, v.value2, v.value3);
            if (v instanceof $ee7eb0766a1d7549$export$bade370ab89110b) return $2bb7f7bd8b4c6f39$export$198573fdc68576c0(spec, $lazy_build(61), v.value0, v.value1, v.value2, v.value3);
            if (v instanceof $ee7eb0766a1d7549$export$a829527ff4e4114a) return $2bb7f7bd8b4c6f39$export$150cc32b4adaaae(spec, $lazy_build(62), v.value0);
            if (v instanceof $ee7eb0766a1d7549$export$b73d5241bf90e3b6) return $lazy_build(63)($ee7eb0766a1d7549$export$355e219ccdea0aec(v.value0));
            throw new Error("Failed pattern match at Halogen.VDom.DOM (line 58, column 27 - line 63, column 52): " + [
                v.constructor.name
            ]);
        };
    });
    var build = $lazy_build(58);
    return build;
};






// Generated by purs version 0.15.16

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");


var $7O0Q4 = parcelRequire("7O0Q4");

var $2jM6U = parcelRequire("2jM6U");

var $7fHqi = parcelRequire("7fHqi");

// Generated by purs version 0.15.16
function $17a9b28f555ce710$export$86b08f6436aa565c(m) {
    return function() {
        var r = {};
        for(var k in m)if (hasOwnProperty.call(m, k)) r[k] = m[k];
        return r;
    };
}
const $17a9b28f555ce710$export$6e22c362a0406a2c = {};
function $17a9b28f555ce710$export$c764c4f4747e1972(f) {
    return f();
}
function $17a9b28f555ce710$export$7c3aa937ffdd4482(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(m0[k]);
    return m;
}
function $17a9b28f555ce710$export$b583322487d15176(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(k)(m0[k]);
    return m;
}
function $17a9b28f555ce710$export$882f367473bfeff9(bind) {
    return function(f) {
        return function(mz) {
            return function(m) {
                var acc = mz;
                function g(k) {
                    return function(z) {
                        return f(z)(k)(m[k]);
                    };
                }
                for(var k in m)if (hasOwnProperty.call(m, k)) acc = bind(acc)(g(k));
                return acc;
            };
        };
    };
}
function $17a9b28f555ce710$export$b807e7b34437e8a6(m, z, f, fromMaybe) {
    var acc = z;
    for(var k in m)if (hasOwnProperty.call(m, k)) {
        var maybeR = f(acc)(k)(m[k]);
        var r = fromMaybe(null)(maybeR);
        if (r === null) return acc;
        else acc = r;
    }
    return acc;
}
function $17a9b28f555ce710$export$84bf76cd7afc7469(f) {
    return function(m) {
        for(var k in m){
            if (hasOwnProperty.call(m, k) && !f(k)(m[k])) return false;
        }
        return true;
    };
}
function $17a9b28f555ce710$export$346677f925de839c(m) {
    var s = 0;
    for(var k in m)if (hasOwnProperty.call(m, k)) ++s;
    return s;
}
function $17a9b28f555ce710$export$75b750e7d0325364(no, yes, k, m) {
    return k in m ? yes(m[k]) : no;
}
function $17a9b28f555ce710$export$d947399a194fcef2(no, yes, k, m) {
    return function() {
        return k in m ? yes(m[k]) : no;
    };
}
function $17a9b28f555ce710$export$4b1360bff9337362(f) {
    return function(m) {
        var r = [];
        for(var k in m)if (hasOwnProperty.call(m, k)) r.push(f(k)(m[k]));
        return r;
    };
}
const $17a9b28f555ce710$export$ed97f33186d4b816 = Object.keys || $17a9b28f555ce710$export$4b1360bff9337362(function(k) {
    return function() {
        return k;
    };
});



var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $k1We4 = parcelRequire("k1We4");

var $brrpF = parcelRequire("brrpF");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $7vxKS = parcelRequire("7vxKS");

var $jhsiw = parcelRequire("jhsiw");
// Generated by purs version 0.15.16
// module Data.Function.Uncurried
const $f9965fb2b3fd917d$export$c12d67bac152a4ed = function(fn) {
    return function() {
        return fn();
    };
};
const $f9965fb2b3fd917d$export$b12d5f1f5e196716 = function(fn) {
    /* jshint maxparams: 2 */ return function(a, b) {
        return fn(a)(b);
    };
};
const $f9965fb2b3fd917d$export$7c6645ed044f896a = function(fn) {
    /* jshint maxparams: 3 */ return function(a, b, c) {
        return fn(a)(b)(c);
    };
};
const $f9965fb2b3fd917d$export$f9fcbfb8cc9a5d08 = function(fn) {
    /* jshint maxparams: 4 */ return function(a, b, c, d) {
        return fn(a)(b)(c)(d);
    };
};
const $f9965fb2b3fd917d$export$253781be9f84fbc = function(fn) {
    /* jshint maxparams: 5 */ return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e);
    };
};
const $f9965fb2b3fd917d$export$5a7e13c76f011743 = function(fn) {
    /* jshint maxparams: 6 */ return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f);
    };
};
const $f9965fb2b3fd917d$export$72dc4a47844c2067 = function(fn) {
    /* jshint maxparams: 7 */ return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g);
    };
};
const $f9965fb2b3fd917d$export$f3e23d6db0ceb902 = function(fn) {
    /* jshint maxparams: 8 */ return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h);
    };
};
const $f9965fb2b3fd917d$export$d6fc3733d257ba4b = function(fn) {
    /* jshint maxparams: 9 */ return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i);
    };
};
const $f9965fb2b3fd917d$export$55270393dfa2c83f = function(fn) {
    /* jshint maxparams: 10 */ return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j);
    };
};
const $f9965fb2b3fd917d$export$6114565cacc4a539 = function(fn) {
    return fn();
};
const $f9965fb2b3fd917d$export$b3f66664347b6e8d = function(fn) {
    return function(a) {
        return function(b) {
            return fn(a, b);
        };
    };
};
const $f9965fb2b3fd917d$export$dd8987cb9f63b77e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return fn(a, b, c);
            };
        };
    };
};
const $f9965fb2b3fd917d$export$c4d34fab9eba1901 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return fn(a, b, c, d);
                };
            };
        };
    };
};
const $f9965fb2b3fd917d$export$ce6386a175247406 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return fn(a, b, c, d, e);
                    };
                };
            };
        };
    };
};
const $f9965fb2b3fd917d$export$6764cfc4c1bcc63e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return fn(a, b, c, d, e, f);
                        };
                    };
                };
            };
        };
    };
};
const $f9965fb2b3fd917d$export$27ec8d6a229d5fae = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return fn(a, b, c, d, e, f, g);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $f9965fb2b3fd917d$export$8a7620e07ee87dd2 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return fn(a, b, c, d, e, f, g, h);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $f9965fb2b3fd917d$export$a68eb29a6e51700a = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return fn(a, b, c, d, e, f, g, h, i);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $f9965fb2b3fd917d$export$182286db78b54e73 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return fn(a, b, c, d, e, f, g, h, i, j);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};


var $9258f235a01c0e08$export$44d12d4204be2f8c = function(f) {
    return f;
};
var $9258f235a01c0e08$export$31aab8bc8543af98 = function(f) {
    return f;
};



var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $gwBF5 = parcelRequire("gwBF5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $bijFl = parcelRequire("bijFl");

var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");


var $k2DSm = parcelRequire("k2DSm");
var $94c850e455dcdaf0$var$sortWith = /* #__PURE__ */ $brrpF.sortWith($gwBF5.ordString);
var $94c850e455dcdaf0$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($k1We4.bindST);
var $94c850e455dcdaf0$var$showTuple = /* #__PURE__ */ $7O0Q4.showTuple($2XxiF.showString);
var $94c850e455dcdaf0$var$pure = /* #__PURE__ */ $bQdkN.pure($k1We4.applicativeST);
var $94c850e455dcdaf0$var$forWithIndex_ = /* #__PURE__ */ $7vxKS.forWithIndex_($k1We4.applicativeST);
var $94c850e455dcdaf0$var$for_ = /* #__PURE__ */ $dNwPt.for_($k1We4.applicativeST);
var $94c850e455dcdaf0$var$$$void = /* #__PURE__ */ $7FzSN.void($k1We4.functorST);
var $94c850e455dcdaf0$var$foldr = /* #__PURE__ */ $dNwPt.foldr($dNwPt.foldableArray);
var $94c850e455dcdaf0$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $94c850e455dcdaf0$var$ordTuple = /* #__PURE__ */ $7O0Q4.ordTuple($gwBF5.ordString);
var $94c850e455dcdaf0$var$mapFlipped = /* #__PURE__ */ $7FzSN.mapFlipped($h2xUu.functorMaybe);
var $94c850e455dcdaf0$export$68c286be0e7e55b7 = /* #__PURE__ */ $17a9b28f555ce710$export$4b1360bff9337362(function(v) {
    return function(v1) {
        return v1;
    };
});
var $94c850e455dcdaf0$export$823be24f8766da23 = function(dictUnfoldable) {
    var $89 = $brrpF.toUnfoldable(dictUnfoldable);
    var $90 = $17a9b28f555ce710$export$4b1360bff9337362($7O0Q4.Tuple.create);
    return function($91) {
        return $89($90($91));
    };
};
var $94c850e455dcdaf0$export$930399be55d0753b = function(dictUnfoldable) {
    var $92 = $brrpF.toUnfoldable(dictUnfoldable);
    var $93 = $94c850e455dcdaf0$var$sortWith($7O0Q4.fst);
    var $94 = $17a9b28f555ce710$export$4b1360bff9337362($7O0Q4.Tuple.create);
    return function($95) {
        return $92($93($94($95)));
    };
};
var $94c850e455dcdaf0$var$toAscArray = /* #__PURE__ */ $94c850e455dcdaf0$export$930399be55d0753b($goKHx.unfoldableArray);
var $94c850e455dcdaf0$var$toArray = /* #__PURE__ */ function() {
    return $17a9b28f555ce710$export$4b1360bff9337362($7O0Q4.Tuple.create);
}();
var $94c850e455dcdaf0$export$170df9728335f27d = $17a9b28f555ce710$export$86b08f6436aa565c;
var $94c850e455dcdaf0$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return $17a9b28f555ce710$export$c764c4f4747e1972($94c850e455dcdaf0$var$bindFlipped($b9f228271a7c74b6$export$dc13bdd74c909d26(k)(v))($b9f228271a7c74b6$export$b8cb59497041ffe4));
    };
};
var $94c850e455dcdaf0$export$4cfa48b10b7cd72d = function(dictShow) {
    var show = $2XxiF.show($2XxiF.showArray($94c850e455dcdaf0$var$showTuple(dictShow)));
    return {
        show: function(m) {
            return "(fromFoldable " + (show($94c850e455dcdaf0$var$toArray(m)) + ")");
        }
    };
};
var $94c850e455dcdaf0$var$mutate = function(f) {
    return function(m) {
        return $17a9b28f555ce710$export$c764c4f4747e1972(function __do() {
            var s = $94c850e455dcdaf0$export$170df9728335f27d(m)();
            f(s)();
            return s;
        });
    };
};
var $94c850e455dcdaf0$export$6a0d13241802fe80 = /* #__PURE__ */ $f9965fb2b3fd917d$export$c4d34fab9eba1901($17a9b28f555ce710$export$75b750e7d0325364)(false)(/* #__PURE__ */ $jhsiw.const(true));
var $94c850e455dcdaf0$export$1292458786b96e98 = function(f) {
    return function(m) {
        return $17a9b28f555ce710$export$b583322487d15176(m, f);
    };
};
var $94c850e455dcdaf0$export$dfc7155ac0343b8 = /* #__PURE__ */ function() {
    return $f9965fb2b3fd917d$export$c4d34fab9eba1901($17a9b28f555ce710$export$75b750e7d0325364)($h2xUu.Nothing.value)($h2xUu.Just.create);
}();
var $94c850e455dcdaf0$export$35d0420a84c5d3ae = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return function(m1) {
        return function(m2) {
            var f = function(k) {
                return function(v) {
                    return $17a9b28f555ce710$export$75b750e7d0325364(false, eq(v), k, m2);
                };
            };
            return $17a9b28f555ce710$export$84bf76cd7afc7469(f)(m1);
        };
    };
};
var $94c850e455dcdaf0$export$dd1bc94b04021eeb = /* #__PURE__ */ $17a9b28f555ce710$export$84bf76cd7afc7469(function(v) {
    return function(v1) {
        return false;
    };
});
var $94c850e455dcdaf0$export$21a5ca8aa77d35ff = function(k) {
    return function(v) {
        return $94c850e455dcdaf0$var$mutate($b9f228271a7c74b6$export$dc13bdd74c909d26(k)(v));
    };
};
var $94c850e455dcdaf0$export$b7bb4265e2e489e0 = {
    map: function(f) {
        return function(m) {
            return $17a9b28f555ce710$export$7c3aa937ffdd4482(m, f);
        };
    }
};
var $94c850e455dcdaf0$export$9c938d99ebec5017 = {
    mapWithIndex: $94c850e455dcdaf0$export$1292458786b96e98,
    Functor0: function() {
        return $94c850e455dcdaf0$export$b7bb4265e2e489e0;
    }
};
var $94c850e455dcdaf0$export$a47a4d0fc4d6b25 = function() {
    return $k2DSm.unsafeCoerce;
};
var $94c850e455dcdaf0$export$78cfe3464e7eb77b = function(dictFoldableWithIndex) {
    var forWithIndex_1 = $94c850e455dcdaf0$var$forWithIndex_(dictFoldableWithIndex);
    return function(l) {
        return $17a9b28f555ce710$export$c764c4f4747e1972(function __do() {
            var s = $b9f228271a7c74b6$export$b8cb59497041ffe4();
            forWithIndex_1(l)(function(k) {
                return function(v) {
                    return $b9f228271a7c74b6$export$dc13bdd74c909d26(k)(v)(s);
                };
            })();
            return s;
        });
    };
};
var $94c850e455dcdaf0$export$690be49d504fc7f = function(dictFoldable) {
    var for_1 = $94c850e455dcdaf0$var$for_(dictFoldable);
    return function(f) {
        return function(l) {
            return $17a9b28f555ce710$export$c764c4f4747e1972(function __do() {
                var s = $b9f228271a7c74b6$export$b8cb59497041ffe4();
                for_1(l)(function(v) {
                    return function __do() {
                        var v$prime = $17a9b28f555ce710$export$d947399a194fcef2(v.value1, f(v.value1), v.value0, s)();
                        return $b9f228271a7c74b6$export$dc13bdd74c909d26(v.value0)(v$prime)(s)();
                    };
                })();
                return s;
            });
        };
    };
};
var $94c850e455dcdaf0$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var fromFoldable1 = $brrpF.fromFoldable(dictFoldable);
    return function(l) {
        return $17a9b28f555ce710$export$c764c4f4747e1972(function __do() {
            var s = $b9f228271a7c74b6$export$b8cb59497041ffe4();
            $k1We4.foreach(fromFoldable1(l))(function(v) {
                return $94c850e455dcdaf0$var$$$void($b9f228271a7c74b6$export$dc13bdd74c909d26(v.value0)(v.value1)(s));
            })();
            return s;
        });
    };
};
var $94c850e455dcdaf0$export$a153ee4522d3545b = $17a9b28f555ce710$export$86b08f6436aa565c;
var $94c850e455dcdaf0$export$a769d86e5b325bcf = function(f) {
    return function(z) {
        return function(m) {
            return $17a9b28f555ce710$export$b807e7b34437e8a6(m, z, f, $h2xUu.fromMaybe);
        };
    };
};
var $94c850e455dcdaf0$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $cADnC.bind(dictMonad.Bind1());
    var pure1 = $bQdkN.pure(dictMonad.Applicative0());
    return function(f) {
        return function(z) {
            return $17a9b28f555ce710$export$882f367473bfeff9(bind1)(f)(pure1(z));
        };
    };
};
var $94c850e455dcdaf0$var$foldM1 = /* #__PURE__ */ $94c850e455dcdaf0$export$7a067f9280ad8af0($k1We4.monadST);
var $94c850e455dcdaf0$export$971dd5b0dfd021b6 = function(m) {
    return $94c850e455dcdaf0$var$mutate(function(s) {
        return $94c850e455dcdaf0$var$foldM1(function(s$prime) {
            return function(k) {
                return function(v) {
                    return $b9f228271a7c74b6$export$dc13bdd74c909d26(k)(v)(s$prime);
                };
            };
        })(s)(m);
    });
};
var $94c850e455dcdaf0$export$30b2db2f7030f6cf = function(dictFoldable) {
    return $dNwPt.foldl(dictFoldable)($94c850e455dcdaf0$export$971dd5b0dfd021b6)($17a9b28f555ce710$export$6e22c362a0406a2c);
};
var $94c850e455dcdaf0$export$ed1b4f34a0e8b0cc = function(f) {
    return function(m1) {
        return function(m2) {
            return $94c850e455dcdaf0$var$mutate(function(s1) {
                return $94c850e455dcdaf0$var$foldM1(function(s2) {
                    return function(k) {
                        return function(v1) {
                            return $b9f228271a7c74b6$export$dc13bdd74c909d26(k)($17a9b28f555ce710$export$75b750e7d0325364(v1, function(v2) {
                                return f(v1)(v2);
                            }, k, m2))(s2);
                        };
                    };
                })(s1)(m1);
            })(m2);
        };
    };
};
var $94c850e455dcdaf0$export$7d0c6e9c5931d4de = function(dictSemigroup) {
    return {
        append: $94c850e455dcdaf0$export$ed1b4f34a0e8b0cc($d5vvq.append(dictSemigroup))
    };
};
var $94c850e455dcdaf0$export$cd8dd1e1b4d46833 = function(dictSemigroup) {
    var semigroupObject1 = $94c850e455dcdaf0$export$7d0c6e9c5931d4de(dictSemigroup);
    return {
        mempty: $17a9b28f555ce710$export$6e22c362a0406a2c,
        Semigroup0: function() {
            return semigroupObject1;
        }
    };
};
var $94c850e455dcdaf0$export$93e2b83da34ff82a = /* #__PURE__ */ $17a9b28f555ce710$export$882f367473bfeff9($jhsiw.applyFlipped);
var $94c850e455dcdaf0$export$b66cdc0497d8a99a = function(dictMonoid) {
    var append1 = $d5vvq.append(dictMonoid.Semigroup0());
    var mempty = $3aOYV.mempty(dictMonoid);
    return function(f) {
        return $94c850e455dcdaf0$export$93e2b83da34ff82a(function(acc) {
            return function(k) {
                return function(v) {
                    return append1(acc)(f(k)(v));
                };
            };
        })(mempty);
    };
};
var $94c850e455dcdaf0$export$fb5657e12344d3bf = {
    foldl: function(f) {
        return $94c850e455dcdaf0$export$93e2b83da34ff82a(function(z) {
            return function(v) {
                return f(z);
            };
        });
    },
    foldr: function(f) {
        return function(z) {
            return function(m) {
                return $94c850e455dcdaf0$var$foldr(f)(z)($94c850e455dcdaf0$export$68c286be0e7e55b7(m));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap1 = $94c850e455dcdaf0$export$b66cdc0497d8a99a(dictMonoid);
        return function(f) {
            return foldMap1($jhsiw.const(f));
        };
    }
};
var $94c850e455dcdaf0$export$341deb6f42c48978 = {
    foldlWithIndex: function(f) {
        return $94c850e455dcdaf0$export$93e2b83da34ff82a($jhsiw.flip(f));
    },
    foldrWithIndex: function(f) {
        return function(z) {
            return function(m) {
                return $94c850e455dcdaf0$var$foldr($7O0Q4.uncurry(f))(z)($17a9b28f555ce710$export$4b1360bff9337362($7O0Q4.Tuple.create)(m));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $94c850e455dcdaf0$export$b66cdc0497d8a99a(dictMonoid);
    },
    Foldable0: function() {
        return $94c850e455dcdaf0$export$fb5657e12344d3bf;
    }
};
var $94c850e455dcdaf0$export$cffdb9059fc42749 = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $26ZCq.apply(Apply0);
        var map = $7FzSN.map(Apply0.Functor0());
        var pure1 = $bQdkN.pure(dictApplicative);
        return function(f) {
            return function(ms) {
                return $94c850e455dcdaf0$export$93e2b83da34ff82a(function(acc) {
                    return function(k) {
                        return function(v) {
                            return apply(map($jhsiw.flip($94c850e455dcdaf0$export$21a5ca8aa77d35ff(k)))(acc))(f(k)(v));
                        };
                    };
                })(pure1($17a9b28f555ce710$export$6e22c362a0406a2c))(ms);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $94c850e455dcdaf0$export$9c938d99ebec5017;
    },
    FoldableWithIndex1: function() {
        return $94c850e455dcdaf0$export$341deb6f42c48978;
    },
    Traversable2: function() {
        return $94c850e455dcdaf0$export$aeab5e284d2f12ed;
    }
};
var $94c850e455dcdaf0$export$aeab5e284d2f12ed = {
    traverse: function(dictApplicative) {
        var $96 = $bijFl.traverseWithIndex($94c850e455dcdaf0$export$cffdb9059fc42749)(dictApplicative);
        return function($97) {
            return $96($jhsiw.const($97));
        };
    },
    sequence: function(dictApplicative) {
        return $9OOYG.traverse($94c850e455dcdaf0$export$aeab5e284d2f12ed)(dictApplicative)($94c850e455dcdaf0$var$identity);
    },
    Functor0: function() {
        return $94c850e455dcdaf0$export$b7bb4265e2e489e0;
    },
    Foldable1: function() {
        return $94c850e455dcdaf0$export$fb5657e12344d3bf;
    }
};
var $94c850e455dcdaf0$export$d7a60370122a9ab0 = function(predicate) {
    return function(m) {
        var go = function() {
            var step = function(acc) {
                return function(k) {
                    return function(v) {
                        var $86 = predicate(k)(v);
                        if ($86) return $b9f228271a7c74b6$export$dc13bdd74c909d26(k)(v)(acc);
                        return $94c850e455dcdaf0$var$pure(acc);
                    };
                };
            };
            return function __do() {
                var m$prime = $b9f228271a7c74b6$export$b8cb59497041ffe4();
                return $94c850e455dcdaf0$var$foldM1(step)(m$prime)(m)();
            };
        }();
        return $17a9b28f555ce710$export$c764c4f4747e1972(go);
    };
};
var $94c850e455dcdaf0$export$151f9a87a7fd5652 = function(predicate) {
    return $94c850e455dcdaf0$export$d7a60370122a9ab0(function($98) {
        return $jhsiw.const(predicate($98));
    });
};
var $94c850e455dcdaf0$export$3dea766d36a8935f = function(predicate) {
    return $94c850e455dcdaf0$export$d7a60370122a9ab0($jhsiw.const(predicate));
};
var $94c850e455dcdaf0$export$fddc1e6ca29dc4b4 = function(dictEq) {
    var isSubmap1 = $94c850e455dcdaf0$export$35d0420a84c5d3ae(dictEq);
    return {
        eq: function(m1) {
            return function(m2) {
                return isSubmap1(m1)(m2) && isSubmap1(m2)(m1);
            };
        }
    };
};
var $94c850e455dcdaf0$export$6393680ec5f1a42e = function(dictOrd) {
    var compare = $gwBF5.compare($gwBF5.ordArray($94c850e455dcdaf0$var$ordTuple(dictOrd)));
    var eqObject1 = $94c850e455dcdaf0$export$fddc1e6ca29dc4b4(dictOrd.Eq0());
    return {
        compare: function(m1) {
            return function(m2) {
                return compare($94c850e455dcdaf0$var$toAscArray(m1))($94c850e455dcdaf0$var$toAscArray(m2));
            };
        },
        Eq0: function() {
            return eqObject1;
        }
    };
};
var $94c850e455dcdaf0$export$11e732c5af6e2d9f = {
    eq1: function(dictEq) {
        return $aJhEx.eq($94c850e455dcdaf0$export$fddc1e6ca29dc4b4(dictEq));
    }
};
var $94c850e455dcdaf0$export$1822828d790e23ee = function(k) {
    return $94c850e455dcdaf0$var$mutate($b9f228271a7c74b6$export$1822828d790e23ee(k));
};
var $94c850e455dcdaf0$export$3e41007ebfff0e64 = function(k) {
    return function(m) {
        return $94c850e455dcdaf0$var$mapFlipped($94c850e455dcdaf0$export$dfc7155ac0343b8(k)(m))(function(a) {
            return new $7O0Q4.Tuple(a, $94c850e455dcdaf0$export$1822828d790e23ee(k)(m));
        });
    };
};
var $94c850e455dcdaf0$export$22a7378e1d3307a4 = function(f) {
    return function(k) {
        return function(m) {
            var v = f($94c850e455dcdaf0$export$dfc7155ac0343b8(k)(m));
            if (v instanceof $h2xUu.Nothing) return $94c850e455dcdaf0$export$1822828d790e23ee(k)(m);
            if (v instanceof $h2xUu.Just) return $94c850e455dcdaf0$export$21a5ca8aa77d35ff(k)(v.value0)(m);
            throw new Error("Failed pattern match at Foreign.Object (line 210, column 15 - line 212, column 25): " + [
                v.constructor.name
            ]);
        };
    };
};
var $94c850e455dcdaf0$export$722fbec263ad908a = function(f) {
    return function(k) {
        return function(m) {
            return $94c850e455dcdaf0$export$22a7378e1d3307a4($h2xUu.maybe($h2xUu.Nothing.value)(f))(k)(m);
        };
    };
};





var $k2DSm = parcelRequire("k2DSm");

var $639bdac132f2bf25$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $639bdac132f2bf25$var$map = /* #__PURE__ */ $7FzSN.map($7FzSN.functorFn);
var $639bdac132f2bf25$var$map1 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $639bdac132f2bf25$export$f880a2f905254b02 = /* #__PURE__ */ function() {
    function Created(value0) {
        this.value0 = value0;
    }
    Created.create = function(value0) {
        return new Created(value0);
    };
    return Created;
}();
var $639bdac132f2bf25$export$bf3e0e645ed29ea3 = /* #__PURE__ */ function() {
    function Removed(value0) {
        this.value0 = value0;
    }
    Removed.create = function(value0) {
        return new Removed(value0);
    };
    return Removed;
}();
var $639bdac132f2bf25$export$ab9c25261cd8c720 = /* #__PURE__ */ function() {
    function Attribute(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Attribute.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Attribute(value0, value1, value2);
            };
        };
    };
    return Attribute;
}();
var $639bdac132f2bf25$export$41b04b3a73e7216d = /* #__PURE__ */ function() {
    function Property(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Property.create = function(value0) {
        return function(value1) {
            return new Property(value0, value1);
        };
    };
    return Property;
}();
var $639bdac132f2bf25$export$a428cd33b25d5283 = /* #__PURE__ */ function() {
    function Handler(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Handler.create = function(value0) {
        return function(value1) {
            return new Handler(value0, value1);
        };
    };
    return Handler;
}();
var $639bdac132f2bf25$export$9bcc32033bdd12aa = /* #__PURE__ */ function() {
    function Ref(value0) {
        this.value0 = value0;
    }
    Ref.create = function(value0) {
        return new Ref(value0);
    };
    return Ref;
}();
var $639bdac132f2bf25$var$unsafeGetProperty = $4fef3a56afd3fa03$export$e21bd765865a4e96;
var $639bdac132f2bf25$var$setProperty = $4fef3a56afd3fa03$export$eecc4ddbfda9d798;
var $639bdac132f2bf25$var$removeProperty = function(key, el) {
    var v = $4fef3a56afd3fa03$export$7895096fcdde5712($b3b92e17f8115510$export$7b1b591b262c240, key, el);
    if (v) return $4fef3a56afd3fa03$export$6399f3bb52316b2c($b3b92e17f8115510$export$7b1b591b262c240, key, el);
    var v1 = $bbd1c096e2c7f227$export$f5bbd400c2f4426f($4fef3a56afd3fa03$export$e21bd765865a4e96(key, el));
    if (v1 === "string") return $4fef3a56afd3fa03$export$eecc4ddbfda9d798(key, "", el);
    if (key === "rowSpan") return $4fef3a56afd3fa03$export$eecc4ddbfda9d798(key, 1, el);
    if (key === "colSpan") return $4fef3a56afd3fa03$export$eecc4ddbfda9d798(key, 1, el);
    return $4fef3a56afd3fa03$export$eecc4ddbfda9d798(key, $4fef3a56afd3fa03$export$1e4bb18162c9f619, el);
};
var $639bdac132f2bf25$var$propToStrKey = function(v) {
    if (v instanceof $639bdac132f2bf25$export$ab9c25261cd8c720 && v.value0 instanceof $h2xUu.Just) return "attr/" + (v.value0.value0 + (":" + v.value1));
    if (v instanceof $639bdac132f2bf25$export$ab9c25261cd8c720) return "attr/:" + v.value1;
    if (v instanceof $639bdac132f2bf25$export$41b04b3a73e7216d) return "prop/" + v.value0;
    if (v instanceof $639bdac132f2bf25$export$a428cd33b25d5283) return "handler/" + v.value0;
    if (v instanceof $639bdac132f2bf25$export$9bcc32033bdd12aa) return "ref";
    throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 182, column 16 - line 187, column 16): " + [
        v.constructor.name
    ]);
};
var $639bdac132f2bf25$export$681fbf510ccdea38 = $k2DSm.unsafeCoerce;
var $639bdac132f2bf25$export$c90971b081d8b87e = $k2DSm.unsafeCoerce;
var $639bdac132f2bf25$export$e6c76fe186213c01 = $k2DSm.unsafeCoerce;
var $639bdac132f2bf25$export$cb9950a5a4987d69 = $k2DSm.unsafeCoerce;
var $639bdac132f2bf25$export$537b40a6761b64a = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $639bdac132f2bf25$export$a428cd33b25d5283) return new $639bdac132f2bf25$export$a428cd33b25d5283(v1.value0, $639bdac132f2bf25$var$map($639bdac132f2bf25$var$map1(v))(v1.value1));
            if (v1 instanceof $639bdac132f2bf25$export$9bcc32033bdd12aa) return new $639bdac132f2bf25$export$9bcc32033bdd12aa($639bdac132f2bf25$var$map($639bdac132f2bf25$var$map1(v))(v1.value0));
            return v1;
        };
    }
};
var $639bdac132f2bf25$export$14e000ba7a516325 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $639bdac132f2bf25$export$f880a2f905254b02) return new $639bdac132f2bf25$export$f880a2f905254b02(v(v1.value0));
            if (v1 instanceof $639bdac132f2bf25$export$bf3e0e645ed29ea3) return new $639bdac132f2bf25$export$bf3e0e645ed29ea3(v(v1.value0));
            throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 49, column 1 - line 51, column 36): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $639bdac132f2bf25$export$ff441cf2113a23d9 = function(emit) {
    return function(el) {
        var removeProp = function(prevEvents) {
            return function(v, v1) {
                if (v1 instanceof $639bdac132f2bf25$export$ab9c25261cd8c720) return $4fef3a56afd3fa03$export$6399f3bb52316b2c($ae4217dcc85a7c03$export$b187f57ee1822bc5(v1.value0), v1.value1, el);
                if (v1 instanceof $639bdac132f2bf25$export$41b04b3a73e7216d) return $639bdac132f2bf25$var$removeProperty(v1.value0, el);
                if (v1 instanceof $639bdac132f2bf25$export$a428cd33b25d5283) {
                    var handler = $5e207c75f3b373f8$export$7ff190aa1ea44157(v1.value0, prevEvents);
                    return $4fef3a56afd3fa03$export$8ff9f68337b520c0(v1.value0, $7O0Q4.fst(handler), el);
                }
                if (v1 instanceof $639bdac132f2bf25$export$9bcc32033bdd12aa) return $2jM6U.unit;
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 169, column 5 - line 179, column 18): " + [
                    v1.constructor.name
                ]);
            };
        };
        var mbEmit = function(v) {
            if (v instanceof $h2xUu.Just) return emit(v.value0)();
            return $2jM6U.unit;
        };
        var haltProp = function(state) {
            var v = $94c850e455dcdaf0$export$dfc7155ac0343b8("ref")(state.props);
            if (v instanceof $h2xUu.Just && v.value0 instanceof $639bdac132f2bf25$export$9bcc32033bdd12aa) return mbEmit(v.value0.value0(new $639bdac132f2bf25$export$bf3e0e645ed29ea3(el)));
            return $2jM6U.unit;
        };
        var diffProp = function(prevEvents, events) {
            return function(v, v1, v11, v2) {
                if (v11 instanceof $639bdac132f2bf25$export$ab9c25261cd8c720 && v2 instanceof $639bdac132f2bf25$export$ab9c25261cd8c720) {
                    var $66 = v11.value2 === v2.value2;
                    if ($66) return v2;
                    $4fef3a56afd3fa03$export$9fec4d97f1922e0b($ae4217dcc85a7c03$export$b187f57ee1822bc5(v2.value0), v2.value1, v2.value2, el);
                    return v2;
                }
                if (v11 instanceof $639bdac132f2bf25$export$41b04b3a73e7216d && v2 instanceof $639bdac132f2bf25$export$41b04b3a73e7216d) {
                    var v4 = $4fef3a56afd3fa03$export$9bc2d847a861e3d8(v11.value1, v2.value1);
                    if (v4) return v2;
                    if (v2.value0 === "value") {
                        var elVal = $639bdac132f2bf25$var$unsafeGetProperty("value", el);
                        var $75 = $4fef3a56afd3fa03$export$9bc2d847a861e3d8(elVal, v2.value1);
                        if ($75) return v2;
                        $639bdac132f2bf25$var$setProperty(v2.value0, v2.value1, el);
                        return v2;
                    }
                    $639bdac132f2bf25$var$setProperty(v2.value0, v2.value1, el);
                    return v2;
                }
                if (v11 instanceof $639bdac132f2bf25$export$a428cd33b25d5283 && v2 instanceof $639bdac132f2bf25$export$a428cd33b25d5283) {
                    var handler = $5e207c75f3b373f8$export$7ff190aa1ea44157(v2.value0, prevEvents);
                    $7fHqi.write(v2.value1)($7O0Q4.snd(handler))();
                    $5e207c75f3b373f8$export$fcec48ff7d1e433f(v2.value0, handler, events);
                    return v2;
                }
                return v2;
            };
        };
        var applyProp = function(events) {
            return function(v, v1, v2) {
                if (v2 instanceof $639bdac132f2bf25$export$ab9c25261cd8c720) {
                    $4fef3a56afd3fa03$export$9fec4d97f1922e0b($ae4217dcc85a7c03$export$b187f57ee1822bc5(v2.value0), v2.value1, v2.value2, el);
                    return v2;
                }
                if (v2 instanceof $639bdac132f2bf25$export$41b04b3a73e7216d) {
                    $639bdac132f2bf25$var$setProperty(v2.value0, v2.value1, el);
                    return v2;
                }
                if (v2 instanceof $639bdac132f2bf25$export$a428cd33b25d5283) {
                    var v3 = $4fef3a56afd3fa03$export$e21bd765865a4e96(v2.value0, events);
                    if ($4fef3a56afd3fa03$export$2d12e28667eef122(v2.value0, events)) {
                        $7fHqi.write(v2.value1)($7O0Q4.snd(v3))();
                        return v2;
                    }
                    var ref = $7fHqi.new(v2.value1)();
                    var listener = $d8dd8b0292692afb$export$f5cdf3809b4587f3(function(ev) {
                        return function __do() {
                            var f$prime = $7fHqi.read(ref)();
                            return mbEmit(f$prime(ev));
                        };
                    })();
                    $5e207c75f3b373f8$export$fcec48ff7d1e433f(v2.value0, new $7O0Q4.Tuple(listener, ref), events);
                    $4fef3a56afd3fa03$export$3f65cefe8380dbea(v2.value0, listener, el);
                    return v2;
                }
                if (v2 instanceof $639bdac132f2bf25$export$9bcc32033bdd12aa) {
                    mbEmit(v2.value0(new $639bdac132f2bf25$export$f880a2f905254b02(el)));
                    return v2;
                }
                throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 113, column 5 - line 135, column 15): " + [
                    v2.constructor.name
                ]);
            };
        };
        var $lazy_patchProp = $639bdac132f2bf25$var$$runtime_lazy("patchProp", "Halogen.VDom.DOM.Prop", function() {
            return function(state, ps2) {
                var events = $5e207c75f3b373f8$export$af208d62fa81d7e9();
                var onThis = removeProp(state.events);
                var onThese = diffProp(state.events, events);
                var onThat = applyProp(events);
                var props = $4fef3a56afd3fa03$export$ca7590ccd55f275f(state.props, ps2, $639bdac132f2bf25$var$propToStrKey, onThese, onThis, onThat);
                var nextState = {
                    events: $5e207c75f3b373f8$export$7c850c5af9b9983e(events),
                    props: props
                };
                return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a($2jM6U.unit, nextState, $lazy_patchProp(100), haltProp));
            };
        });
        var patchProp = $lazy_patchProp(87);
        var renderProp = function(ps1) {
            var events = $5e207c75f3b373f8$export$af208d62fa81d7e9();
            var ps1$prime = $4fef3a56afd3fa03$export$e766566cf460084(ps1, $639bdac132f2bf25$var$propToStrKey, applyProp(events));
            var state = {
                events: $5e207c75f3b373f8$export$7c850c5af9b9983e(events),
                props: ps1$prime
            };
            return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a($2jM6U.unit, state, patchProp, haltProp));
        };
        return renderProp;
    };
};




var $9aad5dc74ea3040c$var$map = /* #__PURE__ */ $7FzSN.map($7FzSN.functorArray);
var $9aad5dc74ea3040c$var$map1 = /* #__PURE__ */ $7FzSN.map($639bdac132f2bf25$export$537b40a6761b64a);
var $9aad5dc74ea3040c$var$map2 = /* #__PURE__ */ $7FzSN.map($e7ddcc4e56dd1e0b$export$5158bce98a089317);
var $9aad5dc74ea3040c$var$un = /* #__PURE__ */ $46y1S.un();
var $9aad5dc74ea3040c$var$bimap = /* #__PURE__ */ $5ZwWo.bimap($ee7eb0766a1d7549$export$cb4b70c26113b373);
var $9aad5dc74ea3040c$export$9dcd2b1ca4768128 = function(x) {
    return x;
};
var $9aad5dc74ea3040c$export$f0c5cfb390964b78 = function($28) {
    return $9aad5dc74ea3040c$export$9dcd2b1ca4768128($ee7eb0766a1d7549$export$a829527ff4e4114a.create($28));
};
var $9aad5dc74ea3040c$export$ccd8a7ec14afc6c9 = function(dict) {
    return dict.toPropValue;
};
var $9aad5dc74ea3040c$export$6f093cfa640b7166 = function($29) {
    return $9aad5dc74ea3040c$export$9dcd2b1ca4768128($ee7eb0766a1d7549$export$5f1af8db9871e1d6.create($29));
};
var $9aad5dc74ea3040c$export$eff4d24c3ff7876e = function(f) {
    return new $639bdac132f2bf25$export$9bcc32033bdd12aa(function($30) {
        return f(function(v) {
            if (v instanceof $639bdac132f2bf25$export$f880a2f905254b02) return new $h2xUu.Just(v.value0);
            if (v instanceof $639bdac132f2bf25$export$bf3e0e645ed29ea3) return $h2xUu.Nothing.value;
            throw new Error("Failed pattern match at Halogen.HTML.Core (line 109, column 21 - line 111, column 23): " + [
                v.constructor.name
            ]);
        }($30));
    });
};
var $9aad5dc74ea3040c$export$977f3f6a9323c0f6 = function(dictIsProp) {
    var toPropValue1 = $9aad5dc74ea3040c$export$ccd8a7ec14afc6c9(dictIsProp);
    return function(v) {
        var $31 = $639bdac132f2bf25$export$41b04b3a73e7216d.create(v);
        return function($32) {
            return $31(toPropValue1($32));
        };
    };
};
var $9aad5dc74ea3040c$export$3313fed09a42a979 = {
    Coercible0: function() {
        return undefined;
    }
};
var $9aad5dc74ea3040c$export$8b4d9aa5702dece6 = function(f) {
    return function(g) {
        return function(v) {
            return $ee7eb0766a1d7549$export$8b4d9aa5702dece6($9aad5dc74ea3040c$var$map($9aad5dc74ea3040c$var$map1($9aad5dc74ea3040c$var$map2(f))))(function() {
                var $33 = $9aad5dc74ea3040c$var$un($9aad5dc74ea3040c$export$9dcd2b1ca4768128);
                return function($34) {
                    return $33(g($34));
                };
            }())(v);
        };
    };
};
var $9aad5dc74ea3040c$export$8dbf9c790527241e = function(ns) {
    return function(name) {
        return function(props) {
            return function(children) {
                return new $ee7eb0766a1d7549$export$bade370ab89110b(ns, name, props, children);
            };
        };
    };
};
var $9aad5dc74ea3040c$export$78da172345adb805 = {
    toPropValue: function($35) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($e5d14cbe7a37aad0$export$a763fdfe677a0aa9($35));
    }
};
var $9aad5dc74ea3040c$export$32e0d8bef35d3088 = {
    toPropValue: $639bdac132f2bf25$export$681fbf510ccdea38
};
var $9aad5dc74ea3040c$export$a77e3c7f90d13c3c = {
    toPropValue: function($36) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($353ecae9a7c600b2$export$eb5efa61a2272b57($36));
    }
};
var $9aad5dc74ea3040c$export$cf79af8281015ccd = {
    toPropValue: function($37) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($af922821253503df$export$ce228bdd501ce63($37));
    }
};
var $9aad5dc74ea3040c$export$1cf8b1fb41618835 = {
    toPropValue: function($38) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($b6c13023d17ecb85$export$d6626656355d8e39($38));
    }
};
var $9aad5dc74ea3040c$export$93423863175829d3 = {
    toPropValue: function($39) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($acd8cd9d754420dd$export$a347b8fb4fdf4d6c($39));
    }
};
var $9aad5dc74ea3040c$export$6b61652c1897c1a = {
    toPropValue: $639bdac132f2bf25$export$c90971b081d8b87e
};
var $9aad5dc74ea3040c$export$4a37bd3810743b12 = {
    toPropValue: function($40) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($0ec4581ec7f50b7b$export$3e035bf7a26d866f($40));
    }
};
var $9aad5dc74ea3040c$export$4111c2fa23eef626 = {
    toPropValue: function($41) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($bbe1e53af35dc2cd$export$1746677a19c76ca($41));
    }
};
var $9aad5dc74ea3040c$export$7bd1d02eb87275db = {
    toPropValue: /* #__PURE__ */ function() {
        var $42 = $46y1S.unwrap();
        return function($43) {
            return $639bdac132f2bf25$export$681fbf510ccdea38($42($43));
        };
    }()
};
var $9aad5dc74ea3040c$export$f017ebe0bff0b5df = {
    toPropValue: function($44) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($bbbf0f4eb77b3e37$export$8d81b1ec6c8c1d53($44));
    }
};
var $9aad5dc74ea3040c$export$4c390c75bcc39428 = {
    toPropValue: $639bdac132f2bf25$export$e6c76fe186213c01
};
var $9aad5dc74ea3040c$export$7333503111bf9adf = {
    toPropValue: function($45) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($bc2fcd8e3e5ce229$export$349063a07c8ae46b($45));
    }
};
var $9aad5dc74ea3040c$export$27dc712f9cde9a29 = {
    toPropValue: function($46) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($b0c33aace9a56bb2$export$67347a102a60396a($46));
    }
};
var $9aad5dc74ea3040c$export$efe5d718899194d9 = {
    toPropValue: function($47) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($b220419bc3acd04a$export$ac1e6270deebeb79($47));
    }
};
var $9aad5dc74ea3040c$export$60997a3274b6da18 = {
    toPropValue: function($48) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($28ec2569ef82cc78$export$5f8a4393c9c60d1a($48));
    }
};
var $9aad5dc74ea3040c$export$56ccba9272e74ac2 = {
    toPropValue: function($49) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($55e71b046fd5f7fc$export$8cede0459d8015c9($49));
    }
};
var $9aad5dc74ea3040c$export$d48eb3d89026ef9 = {
    toPropValue: function($50) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($d71a736f4ee3881a$export$354e79e7f4fdf8f9($50));
    }
};
var $9aad5dc74ea3040c$export$4e3e21220a22c900 = {
    toPropValue: $639bdac132f2bf25$export$cb9950a5a4987d69
};
var $9aad5dc74ea3040c$export$a538daf4c6392dcf = {
    toPropValue: function($51) {
        return $639bdac132f2bf25$export$681fbf510ccdea38($ecaed3b9c37d7b87$export$9b8eae2964bb4cd5($51));
    }
};
var $9aad5dc74ea3040c$export$c3c52e219617878 = /* #__PURE__ */ function() {
    return $639bdac132f2bf25$export$a428cd33b25d5283.create;
}();
var $9aad5dc74ea3040c$export$8454457683f90105 = function(ns) {
    return function(name) {
        return function(props) {
            return function(children) {
                return new $ee7eb0766a1d7549$export$cc2832fafe367c5e(ns, name, props, children);
            };
        };
    };
};
var $9aad5dc74ea3040c$export$a671de4661736606 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                return $9aad5dc74ea3040c$var$bimap($9aad5dc74ea3040c$var$map($9aad5dc74ea3040c$var$map1($9aad5dc74ea3040c$var$map2(g))))(f)(v);
            };
        };
    }
};
var $9aad5dc74ea3040c$export$a02e13c6b9f001c6 = {
    map: /* #__PURE__ */ $5ZwWo.rmap($9aad5dc74ea3040c$export$a671de4661736606)
};
var $9aad5dc74ea3040c$export$7aabe8b3a840d2fd = function(ns) {
    return function(v) {
        return $639bdac132f2bf25$export$ab9c25261cd8c720.create(ns)(v);
    };
};


// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $26SV5 = parcelRequire("26SV5");

var $x1jCe = parcelRequire("x1jCe");

var $beQI1 = parcelRequire("beQI1");


var $fZenR = parcelRequire("fZenR");

var $46y1S = parcelRequire("46y1S");

var $9aSRU = parcelRequire("9aSRU");

var $7O0Q4 = parcelRequire("7O0Q4");
var $d274f7fabe85b746$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $d274f7fabe85b746$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $d274f7fabe85b746$var$Pure = /* #__PURE__ */ function() {
    function Pure(value0) {
        this.value0 = value0;
    }
    Pure.create = function(value0) {
        return new Pure(value0);
    };
    return Pure;
}();
var $d274f7fabe85b746$var$Lift = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $d274f7fabe85b746$var$Ap = /* #__PURE__ */ function() {
    function Ap(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Ap.create = function(value0) {
        return function(value1) {
            return new Ap(value0, value1);
        };
    };
    return Ap;
}();
var $d274f7fabe85b746$var$mkAp = function(fba) {
    return function(fb) {
        return new $d274f7fabe85b746$var$Ap(fba, fb);
    };
};
var $d274f7fabe85b746$export$9f6cb61afbf051fa = /* #__PURE__ */ function() {
    return $d274f7fabe85b746$var$Lift.create;
}();
var $d274f7fabe85b746$var$goLeft = function(dictApplicative) {
    var pure = $bQdkN.pure(dictApplicative);
    return function(fStack) {
        return function(valStack) {
            return function(nat) {
                return function(func) {
                    return function(count) {
                        if (func instanceof $d274f7fabe85b746$var$Pure) return new $7O0Q4.Tuple(new $fZenR.Cons({
                            func: pure(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $d274f7fabe85b746$var$Lift) return new $7O0Q4.Tuple(new $fZenR.Cons({
                            func: nat(func.value0),
                            count: count
                        }, fStack), valStack);
                        if (func instanceof $d274f7fabe85b746$var$Ap) return $d274f7fabe85b746$var$goLeft(dictApplicative)(fStack)($795e171a0788c8e1$export$8327ebbef2a0ba76(func.value1)(valStack))(nat)(func.value0)(count + 1 | 0);
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 102, column 41 - line 105, column 81): " + [
                            func.constructor.name
                        ]);
                    };
                };
            };
        };
    };
};
var $d274f7fabe85b746$var$goApply = function(dictApplicative) {
    var apply = $26ZCq.apply(dictApplicative.Apply0());
    return function(fStack) {
        return function(vals) {
            return function(gVal) {
                if (fStack instanceof $fZenR.Nil) return new $beQI1.Left(gVal);
                if (fStack instanceof $fZenR.Cons) {
                    var gRes = apply(fStack.value0.func)(gVal);
                    var $31 = fStack.value0.count === 1;
                    if ($31) {
                        if (fStack.value1 instanceof $fZenR.Nil) return new $beQI1.Left(gRes);
                        return $d274f7fabe85b746$var$goApply(dictApplicative)(fStack.value1)(vals)(gRes);
                    }
                    if (vals instanceof $fZenR.Nil) return new $beQI1.Left(gRes);
                    if (vals instanceof $fZenR.Cons) return new $beQI1.Right(new $7O0Q4.Tuple(new $fZenR.Cons({
                        func: gRes,
                        count: fStack.value0.count - 1 | 0
                    }, fStack.value1), new $9aSRU.NonEmpty(vals.value0, vals.value1)));
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 83, column 11 - line 88, column 50): " + [
                        vals.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Control.Applicative.Free (line 72, column 3 - line 88, column 50): " + [
                    fStack.constructor.name
                ]);
            };
        };
    };
};
var $d274f7fabe85b746$export$a37c0cfb408cb5d9 = {
    map: function(f) {
        return function(x) {
            return $d274f7fabe85b746$var$mkAp(new $d274f7fabe85b746$var$Pure(f))(x);
        };
    }
};
var $d274f7fabe85b746$export$952b32e119338067 = function(dictApplicative) {
    var goApply1 = $d274f7fabe85b746$var$goApply(dictApplicative);
    var pure = $bQdkN.pure(dictApplicative);
    var goLeft1 = $d274f7fabe85b746$var$goLeft(dictApplicative);
    return function(nat) {
        return function(z) {
            var go = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v) {
                    if (v.value1.value0 instanceof $d274f7fabe85b746$var$Pure) {
                        var v1 = goApply1(v.value0)(v.value1.value1)(pure(v.value1.value0.value0));
                        if (v1 instanceof $beQI1.Left) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $beQI1.Right) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 54, column 17 - line 56, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v.value1.value0 instanceof $d274f7fabe85b746$var$Lift) {
                        var v1 = goApply1(v.value0)(v.value1.value1)(nat(v.value1.value0.value0));
                        if (v1 instanceof $beQI1.Left) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if (v1 instanceof $beQI1.Right) {
                            $copy_v = v1.value0;
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 57, column 17 - line 59, column 24): " + [
                            v1.constructor.name
                        ]);
                    }
                    if (v.value1.value0 instanceof $d274f7fabe85b746$var$Ap) {
                        var nextVals = new $9aSRU.NonEmpty(v.value1.value0.value1, v.value1.value1);
                        $copy_v = goLeft1(v.value0)(nextVals)(nat)(v.value1.value0.value0)(1);
                        return;
                    }
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 53, column 5 - line 62, column 47): " + [
                        v.value1.value0.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go(new $7O0Q4.Tuple($fZenR.Nil.value, $795e171a0788c8e1$export$439306a4dcaafbb9(z)));
        };
    };
};
var $d274f7fabe85b746$export$ab82a8987829bde0 = function(dictApplicative) {
    return $d274f7fabe85b746$export$952b32e119338067(dictApplicative)($d274f7fabe85b746$var$identity);
};
var $d274f7fabe85b746$export$6b0545b2ed7e7da2 = {
    apply: function(fba) {
        return function(fb) {
            return $d274f7fabe85b746$var$mkAp(fba)(fb);
        };
    },
    Functor0: function() {
        return $d274f7fabe85b746$export$a37c0cfb408cb5d9;
    }
};
var $d274f7fabe85b746$export$b8278c4ac41154ad = /* #__PURE__ */ function() {
    return {
        pure: $d274f7fabe85b746$var$Pure.create,
        Apply0: function() {
            return $d274f7fabe85b746$export$6b0545b2ed7e7da2;
        }
    };
}();
var $d274f7fabe85b746$var$foldFreeAp1 = /* #__PURE__ */ $d274f7fabe85b746$export$952b32e119338067($d274f7fabe85b746$export$b8278c4ac41154ad);
var $d274f7fabe85b746$export$2a17b194dc6daf5e = function(f) {
    return $d274f7fabe85b746$var$foldFreeAp1(function($54) {
        return $d274f7fabe85b746$export$9f6cb61afbf051fa(f($54));
    });
};
var $d274f7fabe85b746$export$1d298f88ddccfbbf = function(dictMonoid) {
    var foldFreeAp2 = $d274f7fabe85b746$export$952b32e119338067($x1jCe.applicativeConst(dictMonoid));
    return function(k) {
        var $55 = foldFreeAp2(function($57) {
            return $x1jCe.Const(k($57));
        });
        return function($56) {
            return $d274f7fabe85b746$var$unwrap($55($56));
        };
    };
};



var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $kkdfo = parcelRequire("kkdfo");

var $bcJ05 = parcelRequire("bcJ05");
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $kkdfo = parcelRequire("kkdfo");
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $kkdfo = parcelRequire("kkdfo");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $5krR0 = parcelRequire("5krR0");

var $fZenR = parcelRequire("fZenR");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");
var $7bf88c405a4617c4$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $7bf88c405a4617c4$var$map = /* #__PURE__ */ $7FzSN.map($fZenR.functorList);
var $7bf88c405a4617c4$export$a9e3236c55b65445 = /* #__PURE__ */ function() {
    function CatQueue(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatQueue.create = function(value0) {
        return function(value1) {
            return new CatQueue(value0, value1);
        };
    };
    return CatQueue;
}();
var $7bf88c405a4617c4$export$712962e076096ed4 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value1 instanceof $fZenR.Cons) {
            $tco_done = true;
            return new $h2xUu.Just(new $7O0Q4.Tuple(v.value1.value0, new $7bf88c405a4617c4$export$a9e3236c55b65445(v.value0, v.value1.value1)));
        }
        if (v.value0 instanceof $fZenR.Nil && v.value1 instanceof $fZenR.Nil) {
            $tco_done = true;
            return $h2xUu.Nothing.value;
        }
        if (v.value1 instanceof $fZenR.Nil) {
            $copy_v = new $7bf88c405a4617c4$export$a9e3236c55b65445($fZenR.Nil.value, $5krR0.reverse(v.value0));
            return;
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 92, column 1 - line 92, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $7bf88c405a4617c4$export$b446f6baa3bb1430 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value0 instanceof $fZenR.Nil && v.value1 instanceof $fZenR.Nil) {
            $tco_done = true;
            return $h2xUu.Nothing.value;
        }
        if (v.value0 instanceof $fZenR.Nil) {
            $copy_v = new $7bf88c405a4617c4$export$a9e3236c55b65445($5krR0.reverse(v.value1), $fZenR.Nil.value);
            return;
        }
        if (v.value0 instanceof $fZenR.Cons) {
            $tco_done = true;
            return new $h2xUu.Just(new $7O0Q4.Tuple(v.value0.value0, new $7bf88c405a4617c4$export$a9e3236c55b65445(v.value0.value1, v.value1)));
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 82, column 1 - line 82, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $7bf88c405a4617c4$export$c40cf5aab899f397 = function(v) {
    return function(a) {
        return new $7bf88c405a4617c4$export$a9e3236c55b65445(v.value0, new $fZenR.Cons(a, v.value1));
    };
};
var $7bf88c405a4617c4$export$76888aafd695b76f = function(dictShow) {
    var show = $2XxiF.show($fZenR.showList(dictShow));
    return {
        show: function(v) {
            return "(CatQueue " + (show(v.value0) + (" " + (show(v.value1) + ")")));
        }
    };
};
var $7bf88c405a4617c4$export$7b1b591b262c240 = function(v) {
    if (v.value0 instanceof $fZenR.Nil && v.value1 instanceof $fZenR.Nil) return true;
    return false;
};
var $7bf88c405a4617c4$export$f24224f1c91d8156 = function(v) {
    return $5krR0.length(v.value0) + $5krR0.length(v.value1) | 0;
};
var $7bf88c405a4617c4$export$cd9df59029b2f7f5 = {
    map: function(f) {
        return function(v) {
            return new $7bf88c405a4617c4$export$a9e3236c55b65445($7bf88c405a4617c4$var$map(f)(v.value0), $7bf88c405a4617c4$var$map(f)(v.value1));
        };
    }
};
var $7bf88c405a4617c4$export$2411eb790d3ef577 = {
    foldMap: function(dictMonoid) {
        return $dNwPt.foldMapDefaultL($7bf88c405a4617c4$export$2411eb790d3ef577)(dictMonoid);
    },
    foldr: function(f) {
        return $dNwPt.foldrDefault($7bf88c405a4617c4$export$2411eb790d3ef577)(f);
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $7bf88c405a4617c4$export$b446f6baa3bb1430(q);
                    if (v instanceof $h2xUu.Just) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $h2xUu.Nothing) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatQueue (line 147, column 16 - line 149, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $7bf88c405a4617c4$var$foldl = /* #__PURE__ */ $dNwPt.foldl($7bf88c405a4617c4$export$2411eb790d3ef577);
var $7bf88c405a4617c4$export$12a82fa16f3fa685 = {
    append: /* #__PURE__ */ $7bf88c405a4617c4$var$foldl($7bf88c405a4617c4$export$c40cf5aab899f397)
};
var $7bf88c405a4617c4$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return new $7bf88c405a4617c4$export$a9e3236c55b65445($fZenR.Nil.value, $fZenR.Nil.value);
}();
var $7bf88c405a4617c4$export$82bbee97f7dffc83 = {
    mempty: $7bf88c405a4617c4$export$6e22c362a0406a2c,
    Semigroup0: function() {
        return $7bf88c405a4617c4$export$12a82fa16f3fa685;
    }
};
var $7bf88c405a4617c4$export$439306a4dcaafbb9 = /* #__PURE__ */ $7bf88c405a4617c4$export$c40cf5aab899f397($7bf88c405a4617c4$export$6e22c362a0406a2c);
var $7bf88c405a4617c4$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap = $dNwPt.foldMap(dictFoldable)($7bf88c405a4617c4$export$82bbee97f7dffc83);
    return function(f) {
        return foldMap($7bf88c405a4617c4$export$439306a4dcaafbb9)(f);
    };
};
var $7bf88c405a4617c4$export$402e17453440564b = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $7FzSN.map(Apply0.Functor0());
        var lift2 = $26ZCq.lift2(Apply0);
        var pure = $bQdkN.pure(dictApplicative);
        return function(f) {
            var $123 = map1($7bf88c405a4617c4$var$foldl($7bf88c405a4617c4$export$c40cf5aab899f397)($7bf88c405a4617c4$export$6e22c362a0406a2c));
            var $124 = $7bf88c405a4617c4$var$foldl(function(acc) {
                var $126 = lift2($7bf88c405a4617c4$export$c40cf5aab899f397)(acc);
                return function($127) {
                    return $126(f($127));
                };
            })(pure($7bf88c405a4617c4$export$6e22c362a0406a2c));
            return function($125) {
                return $123($124($125));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $9OOYG.sequenceDefault($7bf88c405a4617c4$export$402e17453440564b)(dictApplicative);
    },
    Functor0: function() {
        return $7bf88c405a4617c4$export$cd9df59029b2f7f5;
    },
    Foldable1: function() {
        return $7bf88c405a4617c4$export$2411eb790d3ef577;
    }
};
var $7bf88c405a4617c4$export$4d02617d29cfe99c = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $h2xUu.Nothing) {
                            $tco_done = true;
                            return $7bf88c405a4617c4$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $h2xUu.Just) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $7bf88c405a4617c4$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 154, column 24 - line 156, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($7bf88c405a4617c4$export$6e22c362a0406a2c);
        };
    }
};
var $7bf88c405a4617c4$export$7536d90e702d15a6 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $h2xUu.Nothing) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $h2xUu.Just) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $7bf88c405a4617c4$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 161, column 24 - line 163, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($7bf88c405a4617c4$export$6e22c362a0406a2c);
        };
    },
    Unfoldable10: function() {
        return $7bf88c405a4617c4$export$4d02617d29cfe99c;
    }
};
var $7bf88c405a4617c4$var$cqEq = function(dictEq) {
    var elemEq = $aJhEx.eq(dictEq);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $7bf88c405a4617c4$export$b446f6baa3bb1430(ys);
                var v1 = $7bf88c405a4617c4$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $h2xUu.Just && v instanceof $h2xUu.Just && elemEq(v1.value0.value0)(v.value0.value0)) {
                    $tco_var_xs = v1.value0.value1;
                    $copy_ys = v.value0.value1;
                    return;
                }
                if (v1 instanceof $h2xUu.Nothing && v instanceof $h2xUu.Nothing) {
                    $tco_done = true;
                    return true;
                }
                $tco_done = true;
                return false;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $7bf88c405a4617c4$export$8d0b86d96cb644e8 = function(dictEq) {
    return {
        eq: $7bf88c405a4617c4$var$cqEq(dictEq)
    };
};
var $7bf88c405a4617c4$var$cqCompare = function(dictOrd) {
    var elemCompare = $gwBF5.compare(dictOrd);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $7bf88c405a4617c4$export$b446f6baa3bb1430(ys);
                var v1 = $7bf88c405a4617c4$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $h2xUu.Just && v instanceof $h2xUu.Just) {
                    var v2 = elemCompare(v1.value0.value0)(v.value0.value0);
                    if (v2 instanceof $ibsD5.EQ) {
                        $tco_var_xs = v1.value0.value1;
                        $copy_ys = v.value0.value1;
                        return;
                    }
                    $tco_done = true;
                    return v2;
                }
                if (v1 instanceof $h2xUu.Just && v instanceof $h2xUu.Nothing) {
                    $tco_done = true;
                    return $ibsD5.GT.value;
                }
                if (v1 instanceof $h2xUu.Nothing && v instanceof $h2xUu.Just) {
                    $tco_done = true;
                    return $ibsD5.LT.value;
                }
                if (v1 instanceof $h2xUu.Nothing && v instanceof $h2xUu.Nothing) {
                    $tco_done = true;
                    return $ibsD5.EQ.value;
                }
                throw new Error("Failed pattern match at Data.CatQueue (line 117, column 16 - line 124, column 30): " + [
                    v1.constructor.name,
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $7bf88c405a4617c4$export$cce3b6ca8e6b304d = function(dictOrd) {
    var eqCatQueue1 = $7bf88c405a4617c4$export$8d0b86d96cb644e8(dictOrd.Eq0());
    return {
        compare: $7bf88c405a4617c4$var$cqCompare(dictOrd),
        Eq0: function() {
            return eqCatQueue1;
        }
    };
};
var $7bf88c405a4617c4$export$8327ebbef2a0ba76 = function(a) {
    return function(v) {
        return new $7bf88c405a4617c4$export$a9e3236c55b65445(new $fZenR.Cons(a, v.value0), v.value1);
    };
};
var $7bf88c405a4617c4$export$64857ab1e7904bd4 = {
    Applicative0: function() {
        return $7bf88c405a4617c4$export$6d9d1867ada2692e;
    },
    Bind1: function() {
        return $7bf88c405a4617c4$export$5f82bc311535f1fb;
    }
};
var $7bf88c405a4617c4$export$5f82bc311535f1fb = {
    bind: /* #__PURE__ */ $jhsiw.flip(/* #__PURE__ */ $dNwPt.foldMap($7bf88c405a4617c4$export$2411eb790d3ef577)($7bf88c405a4617c4$export$82bbee97f7dffc83)),
    Apply0: function() {
        return $7bf88c405a4617c4$var$$lazy_applyCatQueue(0);
    }
};
var $7bf88c405a4617c4$export$6d9d1867ada2692e = {
    pure: $7bf88c405a4617c4$export$439306a4dcaafbb9,
    Apply0: function() {
        return $7bf88c405a4617c4$var$$lazy_applyCatQueue(0);
    }
};
var $7bf88c405a4617c4$var$$lazy_applyCatQueue = /* #__PURE__ */ $7bf88c405a4617c4$var$$runtime_lazy("applyCatQueue", "Data.CatQueue", function() {
    return {
        apply: $kkdfo.ap($7bf88c405a4617c4$export$64857ab1e7904bd4),
        Functor0: function() {
            return $7bf88c405a4617c4$export$cd9df59029b2f7f5;
        }
    };
});
var $7bf88c405a4617c4$export$b30f70c26a58b039 = /* #__PURE__ */ $7bf88c405a4617c4$var$$lazy_applyCatQueue(174);
var $7bf88c405a4617c4$export$ece98441a77a02d = {
    alt: /* #__PURE__ */ $d5vvq.append($7bf88c405a4617c4$export$12a82fa16f3fa685),
    Functor0: function() {
        return $7bf88c405a4617c4$export$cd9df59029b2f7f5;
    }
};
var $7bf88c405a4617c4$export$f14c1a5864c2efe5 = {
    empty: $7bf88c405a4617c4$export$6e22c362a0406a2c,
    Alt0: function() {
        return $7bf88c405a4617c4$export$ece98441a77a02d;
    }
};
var $7bf88c405a4617c4$export$6613cb99fa5f98f9 = {
    Applicative0: function() {
        return $7bf88c405a4617c4$export$6d9d1867ada2692e;
    },
    Plus1: function() {
        return $7bf88c405a4617c4$export$f14c1a5864c2efe5;
    }
};
var $7bf88c405a4617c4$export$3e8f97b430646754 = {
    Monad0: function() {
        return $7bf88c405a4617c4$export$64857ab1e7904bd4;
    },
    Alternative1: function() {
        return $7bf88c405a4617c4$export$6613cb99fa5f98f9;
    }
};



var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $fZenR = parcelRequire("fZenR");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $iVjQa = parcelRequire("iVjQa");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");
var $14d8c100cf0cb82e$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $14d8c100cf0cb82e$export$7475bf8196f095ad = /* #__PURE__ */ function() {
    function CatNil() {}
    CatNil.value = new CatNil();
    return CatNil;
}();
var $14d8c100cf0cb82e$export$4cc9fe8c7ead393e = /* #__PURE__ */ function() {
    function CatCons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatCons.create = function(value0) {
        return function(value1) {
            return new CatCons(value0, value1);
        };
    };
    return CatCons;
}();
var $14d8c100cf0cb82e$export$eb80e9167e4f6b99 = function(dictShow) {
    var show = $2XxiF.show(dictShow);
    return {
        show: function(v) {
            if (v instanceof $14d8c100cf0cb82e$export$7475bf8196f095ad) return "CatNil";
            if (v instanceof $14d8c100cf0cb82e$export$4cc9fe8c7ead393e) return "(CatList " + (show(v.value0) + (" " + ($2XxiF.show($7bf88c405a4617c4$export$76888aafd695b76f($14d8c100cf0cb82e$export$eb80e9167e4f6b99(dictShow)))(v.value1) + ")")));
            throw new Error("Failed pattern match at Data.CatList (line 147, column 1 - line 149, column 71): " + [
                v.constructor.name
            ]);
        }
    };
};
var $14d8c100cf0cb82e$export$7b1b591b262c240 = function(v) {
    if (v instanceof $14d8c100cf0cb82e$export$7475bf8196f095ad) return true;
    return false;
};
var $14d8c100cf0cb82e$var$link = function(v) {
    return function(v1) {
        if (v instanceof $14d8c100cf0cb82e$export$7475bf8196f095ad) return v1;
        if (v1 instanceof $14d8c100cf0cb82e$export$7475bf8196f095ad) return v;
        if (v instanceof $14d8c100cf0cb82e$export$4cc9fe8c7ead393e) return new $14d8c100cf0cb82e$export$4cc9fe8c7ead393e(v.value0, $7bf88c405a4617c4$export$c40cf5aab899f397(v.value1)(v1));
        throw new Error("Failed pattern match at Data.CatList (line 108, column 1 - line 108, column 54): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $14d8c100cf0cb82e$var$foldr = function(k) {
    return function(b) {
        return function(q) {
            var foldl = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v2 instanceof $fZenR.Nil) {
                                $tco_done = true;
                                return v1;
                            }
                            if (v2 instanceof $fZenR.Cons) {
                                $tco_var_v = v;
                                $tco_var_v1 = v(v1)(v2.value0);
                                $copy_v2 = v2.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.CatList (line 124, column 3 - line 124, column 59): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            var go = function($copy_xs) {
                return function($copy_ys) {
                    var $tco_var_xs = $copy_xs;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(xs, ys) {
                        var v = $7bf88c405a4617c4$export$b446f6baa3bb1430(xs);
                        if (v instanceof $h2xUu.Nothing) {
                            $tco_done1 = true;
                            return foldl(function(x) {
                                return function(i) {
                                    return i(x);
                                };
                            })(b)(ys);
                        }
                        if (v instanceof $h2xUu.Just) {
                            $tco_var_xs = v.value0.value1;
                            $copy_ys = new $fZenR.Cons(k(v.value0.value0), ys);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 120, column 14 - line 122, column 67): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
                    return $tco_result;
                };
            };
            return go(q)($fZenR.Nil.value);
        };
    };
};
var $14d8c100cf0cb82e$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $14d8c100cf0cb82e$export$7475bf8196f095ad) return $h2xUu.Nothing.value;
    if (v instanceof $14d8c100cf0cb82e$export$4cc9fe8c7ead393e) return new $h2xUu.Just(new $7O0Q4.Tuple(v.value0, function() {
        var $66 = $7bf88c405a4617c4$export$7b1b591b262c240(v.value1);
        if ($66) return $14d8c100cf0cb82e$export$7475bf8196f095ad.value;
        return $14d8c100cf0cb82e$var$foldr($14d8c100cf0cb82e$var$link)($14d8c100cf0cb82e$export$7475bf8196f095ad.value)(v.value1);
    }()));
    throw new Error("Failed pattern match at Data.CatList (line 99, column 1 - line 99, column 61): " + [
        v.constructor.name
    ]);
};
var $14d8c100cf0cb82e$export$9dc212839863b867 = {
    foldMap: function(dictMonoid) {
        return $dNwPt.foldMapDefaultL($14d8c100cf0cb82e$export$9dc212839863b867)(dictMonoid);
    },
    foldr: function(f) {
        return function(s) {
            return function(l) {
                return $dNwPt.foldrDefault($14d8c100cf0cb82e$export$9dc212839863b867)(f)(s)(l);
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $14d8c100cf0cb82e$export$b446f6baa3bb1430(q);
                    if (v instanceof $h2xUu.Just) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $h2xUu.Nothing) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatList (line 156, column 16 - line 158, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $14d8c100cf0cb82e$export$f24224f1c91d8156 = /* #__PURE__ */ $dNwPt.length($14d8c100cf0cb82e$export$9dc212839863b867)($iVjQa.semiringInt);
var $14d8c100cf0cb82e$var$foldMap = function(dictMonoid) {
    var mempty = $3aOYV.mempty(dictMonoid);
    var append2 = $d5vvq.append(dictMonoid.Semigroup0());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $14d8c100cf0cb82e$export$7475bf8196f095ad) return mempty;
            if (v1 instanceof $14d8c100cf0cb82e$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $75 = $7bf88c405a4617c4$export$7b1b591b262c240(v1.value1);
                    if ($75) return $14d8c100cf0cb82e$export$7475bf8196f095ad.value;
                    return $14d8c100cf0cb82e$var$foldr($14d8c100cf0cb82e$var$link)($14d8c100cf0cb82e$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return append2(v(v1.value0))($14d8c100cf0cb82e$var$foldMap(dictMonoid)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 134, column 1 - line 134, column 62): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $14d8c100cf0cb82e$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $14d8c100cf0cb82e$export$7475bf8196f095ad.value;
}();
var $14d8c100cf0cb82e$export$10d8903dec122b9d = $14d8c100cf0cb82e$var$link;
var $14d8c100cf0cb82e$export$8327ebbef2a0ba76 = function(a) {
    return function(cat) {
        return $14d8c100cf0cb82e$export$10d8903dec122b9d(new $14d8c100cf0cb82e$export$4cc9fe8c7ead393e(a, $7bf88c405a4617c4$export$6e22c362a0406a2c))(cat);
    };
};
var $14d8c100cf0cb82e$export$2fa88228892893e6 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $14d8c100cf0cb82e$export$7475bf8196f095ad) return $14d8c100cf0cb82e$export$7475bf8196f095ad.value;
            if (v1 instanceof $14d8c100cf0cb82e$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $80 = $7bf88c405a4617c4$export$7b1b591b262c240(v1.value1);
                    if ($80) return $14d8c100cf0cb82e$export$7475bf8196f095ad.value;
                    return $14d8c100cf0cb82e$var$foldr($14d8c100cf0cb82e$var$link)($14d8c100cf0cb82e$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return $14d8c100cf0cb82e$export$8327ebbef2a0ba76(v(v1.value0))($7FzSN.map($14d8c100cf0cb82e$export$2fa88228892893e6)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 184, column 1 - line 188, column 26): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $14d8c100cf0cb82e$export$439306a4dcaafbb9 = function(a) {
    return $14d8c100cf0cb82e$export$8327ebbef2a0ba76(a)($14d8c100cf0cb82e$export$7475bf8196f095ad.value);
};
var $14d8c100cf0cb82e$export$e0c854626a3eddb8 = {
    traverse: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $26ZCq.apply(Apply0);
        var map = $7FzSN.map(Apply0.Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $14d8c100cf0cb82e$export$7475bf8196f095ad) return pure($14d8c100cf0cb82e$export$7475bf8196f095ad.value);
                if (v1 instanceof $14d8c100cf0cb82e$export$4cc9fe8c7ead393e) {
                    var d = function() {
                        var $85 = $7bf88c405a4617c4$export$7b1b591b262c240(v1.value1);
                        if ($85) return $14d8c100cf0cb82e$export$7475bf8196f095ad.value;
                        return $14d8c100cf0cb82e$var$foldr($14d8c100cf0cb82e$var$link)($14d8c100cf0cb82e$export$7475bf8196f095ad.value)(v1.value1);
                    }();
                    return apply(map($14d8c100cf0cb82e$export$8327ebbef2a0ba76)(v(v1.value0)))($9OOYG.traverse($14d8c100cf0cb82e$export$e0c854626a3eddb8)(dictApplicative)(v)(d));
                }
                throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $bQdkN.pure(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $26ZCq.apply(Apply0);
        var map = $7FzSN.map(Apply0.Functor0());
        return function(v) {
            if (v instanceof $14d8c100cf0cb82e$export$7475bf8196f095ad) return pure($14d8c100cf0cb82e$export$7475bf8196f095ad.value);
            if (v instanceof $14d8c100cf0cb82e$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $89 = $7bf88c405a4617c4$export$7b1b591b262c240(v.value1);
                    if ($89) return $14d8c100cf0cb82e$export$7475bf8196f095ad.value;
                    return $14d8c100cf0cb82e$var$foldr($14d8c100cf0cb82e$var$link)($14d8c100cf0cb82e$export$7475bf8196f095ad.value)(v.value1);
                }();
                return apply(map($14d8c100cf0cb82e$export$8327ebbef2a0ba76)(v.value0))($9OOYG.sequence($14d8c100cf0cb82e$export$e0c854626a3eddb8)(dictApplicative)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $14d8c100cf0cb82e$export$2fa88228892893e6;
    },
    Foldable1: function() {
        return $14d8c100cf0cb82e$export$9dc212839863b867;
    }
};
var $14d8c100cf0cb82e$export$da599a1924f5bf13 = {
    append: $14d8c100cf0cb82e$export$10d8903dec122b9d
};
var $14d8c100cf0cb82e$export$f4b77959e4023828 = /* #__PURE__ */ function() {
    return {
        mempty: $14d8c100cf0cb82e$export$7475bf8196f095ad.value,
        Semigroup0: function() {
            return $14d8c100cf0cb82e$export$da599a1924f5bf13;
        }
    };
}();
var $14d8c100cf0cb82e$export$607c251688bb5f73 = {
    Applicative0: function() {
        return $14d8c100cf0cb82e$export$360f55d5496233b2;
    },
    Bind1: function() {
        return $14d8c100cf0cb82e$export$23e6c815e87cdf22;
    }
};
var $14d8c100cf0cb82e$export$23e6c815e87cdf22 = {
    bind: /* #__PURE__ */ $jhsiw.flip(/* #__PURE__ */ $14d8c100cf0cb82e$var$foldMap($14d8c100cf0cb82e$export$f4b77959e4023828)),
    Apply0: function() {
        return $14d8c100cf0cb82e$var$$lazy_applyCatList(0);
    }
};
var $14d8c100cf0cb82e$export$360f55d5496233b2 = {
    pure: $14d8c100cf0cb82e$export$439306a4dcaafbb9,
    Apply0: function() {
        return $14d8c100cf0cb82e$var$$lazy_applyCatList(0);
    }
};
var $14d8c100cf0cb82e$var$$lazy_applyCatList = /* #__PURE__ */ $14d8c100cf0cb82e$var$$runtime_lazy("applyCatList", "Data.CatList", function() {
    return {
        apply: $kkdfo.ap($14d8c100cf0cb82e$export$607c251688bb5f73),
        Functor0: function() {
            return $14d8c100cf0cb82e$export$2fa88228892893e6;
        }
    };
});
var $14d8c100cf0cb82e$export$6c3a453d31b3c12e = /* #__PURE__ */ $14d8c100cf0cb82e$var$$lazy_applyCatList(190);
var $14d8c100cf0cb82e$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap1 = $dNwPt.foldMap(dictFoldable)($14d8c100cf0cb82e$export$f4b77959e4023828);
    return function(f) {
        return foldMap1($14d8c100cf0cb82e$export$439306a4dcaafbb9)(f);
    };
};
var $14d8c100cf0cb82e$export$c40cf5aab899f397 = function(cat) {
    return function(a) {
        return $14d8c100cf0cb82e$export$10d8903dec122b9d(cat)(new $14d8c100cf0cb82e$export$4cc9fe8c7ead393e(a, $7bf88c405a4617c4$export$6e22c362a0406a2c));
    };
};
var $14d8c100cf0cb82e$export$bc32e6f55ceec345 = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $h2xUu.Nothing) {
                            $tco_done = true;
                            return $14d8c100cf0cb82e$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $h2xUu.Just) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $14d8c100cf0cb82e$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 170, column 24 - line 172, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($14d8c100cf0cb82e$export$7475bf8196f095ad.value);
        };
    }
};
var $14d8c100cf0cb82e$export$6cb6a5647a60bec3 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $h2xUu.Nothing) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $h2xUu.Just) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $14d8c100cf0cb82e$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 163, column 24 - line 165, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($14d8c100cf0cb82e$export$7475bf8196f095ad.value);
        };
    },
    Unfoldable10: function() {
        return $14d8c100cf0cb82e$export$bc32e6f55ceec345;
    }
};
var $14d8c100cf0cb82e$export$c5b7cf0f3fda96ad = {
    alt: $14d8c100cf0cb82e$export$10d8903dec122b9d,
    Functor0: function() {
        return $14d8c100cf0cb82e$export$2fa88228892893e6;
    }
};
var $14d8c100cf0cb82e$export$7790c39ae1bfafa2 = {
    empty: $14d8c100cf0cb82e$export$6e22c362a0406a2c,
    Alt0: function() {
        return $14d8c100cf0cb82e$export$c5b7cf0f3fda96ad;
    }
};
var $14d8c100cf0cb82e$export$37a37f49d0feb489 = {
    Applicative0: function() {
        return $14d8c100cf0cb82e$export$360f55d5496233b2;
    },
    Plus1: function() {
        return $14d8c100cf0cb82e$export$7790c39ae1bfafa2;
    }
};
var $14d8c100cf0cb82e$export$2074eaaf9933bfe1 = {
    Monad0: function() {
        return $14d8c100cf0cb82e$export$607c251688bb5f73;
    },
    Alternative1: function() {
        return $14d8c100cf0cb82e$export$37a37f49d0feb489;
    }
};



var $beQI1 = parcelRequire("beQI1");

var $aJhEx = parcelRequire("aJhEx");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $gwBF5 = parcelRequire("gwBF5");

var $ibsD5 = parcelRequire("ibsD5");

var $d5vvq = parcelRequire("d5vvq");

var $9OOYG = parcelRequire("9OOYG");

var $k2DSm = parcelRequire("k2DSm");
var $f846b50afc5ec5d5$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $f846b50afc5ec5d5$var$append = /* #__PURE__ */ $d5vvq.append($14d8c100cf0cb82e$export$da599a1924f5bf13);
var $f846b50afc5ec5d5$var$map = /* #__PURE__ */ $7FzSN.map($7FzSN.functorFn);
var $f846b50afc5ec5d5$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $f846b50afc5ec5d5$var$ExpF = function(x) {
    return x;
};
var $f846b50afc5ec5d5$var$Free = /* #__PURE__ */ function() {
    function Free(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Free.create = function(value0) {
        return function(value1) {
            return new Free(value0, value1);
        };
    };
    return Free;
}();
var $f846b50afc5ec5d5$var$Return = /* #__PURE__ */ function() {
    function Return(value0) {
        this.value0 = value0;
    }
    Return.create = function(value0) {
        return new Return(value0);
    };
    return Return;
}();
var $f846b50afc5ec5d5$var$Bind = /* #__PURE__ */ function() {
    function Bind(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Bind.create = function(value0) {
        return function(value1) {
            return new Bind(value0, value1);
        };
    };
    return Bind;
}();
var $f846b50afc5ec5d5$var$toView = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        var runExpF = function(v2) {
            return v2;
        };
        var concatF = function(v2) {
            return function(r) {
                return new $f846b50afc5ec5d5$var$Free(v2.value0, $f846b50afc5ec5d5$var$append(v2.value1)(r));
            };
        };
        if (v.value0 instanceof $f846b50afc5ec5d5$var$Return) {
            var v2 = $14d8c100cf0cb82e$export$b446f6baa3bb1430(v.value1);
            if (v2 instanceof $h2xUu.Nothing) {
                $tco_done = true;
                return new $f846b50afc5ec5d5$var$Return(v.value0.value0);
            }
            if (v2 instanceof $h2xUu.Just) {
                $copy_v = concatF(runExpF(v2.value0.value0)(v.value0.value0))(v2.value0.value1);
                return;
            }
            throw new Error("Failed pattern match at Control.Monad.Free (line 227, column 7 - line 231, column 64): " + [
                v2.constructor.name
            ]);
        }
        if (v.value0 instanceof $f846b50afc5ec5d5$var$Bind) {
            $tco_done = true;
            return new $f846b50afc5ec5d5$var$Bind(v.value0.value0, function(a) {
                return concatF(v.value0.value1(a))(v.value1);
            });
        }
        throw new Error("Failed pattern match at Control.Monad.Free (line 225, column 3 - line 233, column 56): " + [
            v.value0.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $f846b50afc5ec5d5$export$2bd79f4d19aaa2f7 = function(dictFunctor) {
    var map1 = $7FzSN.map(dictFunctor);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var map2 = $7FzSN.map(Monad0.Bind1().Apply0().Functor0());
        var pure1 = $bQdkN.pure(Monad0.Applicative0());
        var tailRecM = $bcJ05.tailRecM(dictMonadRec);
        return function(k) {
            var go = function(f) {
                var v = $f846b50afc5ec5d5$var$toView(f);
                if (v instanceof $f846b50afc5ec5d5$var$Return) return map2($bcJ05.Done.create)(pure1(v.value0));
                if (v instanceof $f846b50afc5ec5d5$var$Bind) return map2($bcJ05.Loop.create)(k(map1(v.value1)(v.value0)));
                throw new Error("Failed pattern match at Control.Monad.Free (line 194, column 10 - line 196, column 37): " + [
                    v.constructor.name
                ]);
            };
            return tailRecM(go);
        };
    };
};
var $f846b50afc5ec5d5$export$39b8ebacf8133f4f = function(dictFunctor) {
    var map1 = $7FzSN.map(dictFunctor);
    return function(k) {
        var go = function($copy_f) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(f) {
                var v = $f846b50afc5ec5d5$var$toView(f);
                if (v instanceof $f846b50afc5ec5d5$var$Return) {
                    $tco_done = true;
                    return v.value0;
                }
                if (v instanceof $f846b50afc5ec5d5$var$Bind) {
                    $copy_f = k(map1(v.value1)(v.value0));
                    return;
                }
                throw new Error("Failed pattern match at Control.Monad.Free (line 178, column 10 - line 180, column 33): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_f);
            return $tco_result;
        };
        return go;
    };
};
var $f846b50afc5ec5d5$export$a7b5be099b56a644 = function(k) {
    return function(j) {
        return function(f) {
            var v = $f846b50afc5ec5d5$var$toView(f);
            if (v instanceof $f846b50afc5ec5d5$var$Return) return j(v.value0);
            if (v instanceof $f846b50afc5ec5d5$var$Bind) return k(v.value0)(v.value1);
            throw new Error("Failed pattern match at Control.Monad.Free (line 213, column 17 - line 215, column 20): " + [
                v.constructor.name
            ]);
        };
    };
};
var $f846b50afc5ec5d5$export$fbb4d68fe60c1629 = function(dictFunctor) {
    var map1 = $7FzSN.map(dictFunctor);
    return $f846b50afc5ec5d5$export$a7b5be099b56a644(function(g) {
        return function(i) {
            return new $beQI1.Left(map1(i)(g));
        };
    })($beQI1.Right.create);
};
var $f846b50afc5ec5d5$var$fromView = function(f) {
    return new $f846b50afc5ec5d5$var$Free(f, $14d8c100cf0cb82e$export$6e22c362a0406a2c);
};
var $f846b50afc5ec5d5$export$4997ffc0176396a6 = function(f) {
    return $f846b50afc5ec5d5$var$fromView(new $f846b50afc5ec5d5$var$Bind(f, $k2DSm.unsafeCoerce));
};
var $f846b50afc5ec5d5$export$7c20f42c1b2b8c79 = function(dictApplicative) {
    var pure1 = $bQdkN.pure(dictApplicative);
    return function(f) {
        return $f846b50afc5ec5d5$export$4997ffc0176396a6(pure1(f));
    };
};
var $f846b50afc5ec5d5$export$25ad06f1eebea5a0 = {
    Applicative0: function() {
        return $f846b50afc5ec5d5$export$b9ce46e7f510eb18;
    },
    Bind1: function() {
        return $f846b50afc5ec5d5$export$39486fc5c75854c8;
    }
};
var $f846b50afc5ec5d5$export$245cefec95375d9a = {
    map: function(k) {
        return function(f) {
            return $cADnC.bindFlipped($f846b50afc5ec5d5$export$39486fc5c75854c8)(function() {
                var $189 = $bQdkN.pure($f846b50afc5ec5d5$export$b9ce46e7f510eb18);
                return function($190) {
                    return $189(k($190));
                };
            }())(f);
        };
    }
};
var $f846b50afc5ec5d5$export$39486fc5c75854c8 = {
    bind: function(v) {
        return function(k) {
            return new $f846b50afc5ec5d5$var$Free(v.value0, $14d8c100cf0cb82e$export$c40cf5aab899f397(v.value1)(k));
        };
    },
    Apply0: function() {
        return $f846b50afc5ec5d5$var$$lazy_freeApply(0);
    }
};
var $f846b50afc5ec5d5$export$b9ce46e7f510eb18 = {
    pure: function($191) {
        return $f846b50afc5ec5d5$var$fromView($f846b50afc5ec5d5$var$Return.create($191));
    },
    Apply0: function() {
        return $f846b50afc5ec5d5$var$$lazy_freeApply(0);
    }
};
var $f846b50afc5ec5d5$var$$lazy_freeApply = /* #__PURE__ */ $f846b50afc5ec5d5$var$$runtime_lazy("freeApply", "Control.Monad.Free", function() {
    return {
        apply: $kkdfo.ap($f846b50afc5ec5d5$export$25ad06f1eebea5a0),
        Functor0: function() {
            return $f846b50afc5ec5d5$export$245cefec95375d9a;
        }
    };
});
var $f846b50afc5ec5d5$export$2d6a2fb8bce0f112 = /* #__PURE__ */ $f846b50afc5ec5d5$var$$lazy_freeApply(77);
var $f846b50afc5ec5d5$var$lift2 = /* #__PURE__ */ $26ZCq.lift2($f846b50afc5ec5d5$export$2d6a2fb8bce0f112);
var $f846b50afc5ec5d5$var$bind = /* #__PURE__ */ $cADnC.bind($f846b50afc5ec5d5$export$39486fc5c75854c8);
var $f846b50afc5ec5d5$var$pure = /* #__PURE__ */ $bQdkN.pure($f846b50afc5ec5d5$export$b9ce46e7f510eb18);
var $f846b50afc5ec5d5$var$join = /* #__PURE__ */ $cADnC.join($f846b50afc5ec5d5$export$39486fc5c75854c8);
var $f846b50afc5ec5d5$export$d68567ac4fd5624d = function(dictSemigroup) {
    return {
        append: $f846b50afc5ec5d5$var$lift2($d5vvq.append(dictSemigroup))
    };
};
var $f846b50afc5ec5d5$export$b3d357ba4a1dabd2 = {
    tailRecM: function(k) {
        return function(a) {
            return $f846b50afc5ec5d5$var$bind(k(a))(function(v) {
                if (v instanceof $bcJ05.Loop) return $bcJ05.tailRecM($f846b50afc5ec5d5$export$b3d357ba4a1dabd2)(k)(v.value0);
                if (v instanceof $bcJ05.Done) return $f846b50afc5ec5d5$var$pure(v.value0);
                throw new Error("Failed pattern match at Control.Monad.Free (line 86, column 26 - line 88, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $f846b50afc5ec5d5$export$25ad06f1eebea5a0;
    }
};
var $f846b50afc5ec5d5$export$8040756fd4c77395 = function(f) {
    return $f846b50afc5ec5d5$var$fromView(new $f846b50afc5ec5d5$var$Bind(f, function($192) {
        return $f846b50afc5ec5d5$var$pure($192);
    }));
};
var $f846b50afc5ec5d5$export$5eeb2de8b5f5121f = {
    lift: function(dictMonad) {
        return $f846b50afc5ec5d5$export$8040756fd4c77395;
    }
};
var $f846b50afc5ec5d5$export$cb3638ab887278d6 = function(dictMonoid) {
    var semigroupFree1 = $f846b50afc5ec5d5$export$d68567ac4fd5624d(dictMonoid.Semigroup0());
    return {
        mempty: $f846b50afc5ec5d5$var$pure($3aOYV.mempty(dictMonoid)),
        Semigroup0: function() {
            return semigroupFree1;
        }
    };
};
var $f846b50afc5ec5d5$export$d6dbe5e3073f84e = function(k) {
    var go = function(f) {
        var v = $f846b50afc5ec5d5$var$toView(f);
        if (v instanceof $f846b50afc5ec5d5$var$Return) return $f846b50afc5ec5d5$var$pure(v.value0);
        if (v instanceof $f846b50afc5ec5d5$var$Bind) return $f846b50afc5ec5d5$var$bind(k(v.value0))($f846b50afc5ec5d5$var$map(go)(v.value1));
        throw new Error("Failed pattern match at Control.Monad.Free (line 168, column 10 - line 170, column 33): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $f846b50afc5ec5d5$export$9624ed458578c422 = function(k) {
    return $f846b50afc5ec5d5$export$d6dbe5e3073f84e(function($193) {
        return $f846b50afc5ec5d5$export$8040756fd4c77395(k($193));
    });
};
var $f846b50afc5ec5d5$export$7bf6537c73f09eab = function(dictFunctor) {
    var resume1 = $f846b50afc5ec5d5$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictFoldable) {
        var foldMap = $dNwPt.foldMap(dictFoldable);
        var foldl = $dNwPt.foldl(dictFoldable);
        var foldr = $dNwPt.foldr(dictFoldable);
        return {
            foldMap: function(dictMonoid) {
                var foldMap1 = foldMap(dictMonoid);
                return function(f) {
                    var $lazy_go = $f846b50afc5ec5d5$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                        return function($194) {
                            return function(v) {
                                if (v instanceof $beQI1.Left) return foldMap1($lazy_go(94))(v.value0);
                                if (v instanceof $beQI1.Right) return f(v.value0);
                                throw new Error("Failed pattern match at Control.Monad.Free (line 93, column 21 - line 95, column 21): " + [
                                    v.constructor.name
                                ]);
                            }(resume1($194));
                        };
                    });
                    var go = $lazy_go(93);
                    return go;
                };
            },
            foldl: function(f) {
                var go = function(r) {
                    return function($195) {
                        return function(v) {
                            if (v instanceof $beQI1.Left) return foldl(go)(r)(v.value0);
                            if (v instanceof $beQI1.Right) return f(r)(v.value0);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 98, column 23 - line 100, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($195));
                    };
                };
                return go;
            },
            foldr: function(f) {
                var go = function(r) {
                    return function($196) {
                        return function(v) {
                            if (v instanceof $beQI1.Left) return foldr($jhsiw.flip(go))(r)(v.value0);
                            if (v instanceof $beQI1.Right) return f(v.value0)(r);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 103, column 23 - line 105, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($196));
                    };
                };
                return go;
            }
        };
    };
};
var $f846b50afc5ec5d5$export$816b93e586e4c75c = function(dictTraversable) {
    var Functor0 = dictTraversable.Functor0();
    var resume1 = $f846b50afc5ec5d5$export$fbb4d68fe60c1629(Functor0);
    var traverse = $9OOYG.traverse(dictTraversable);
    var foldableFree1 = $f846b50afc5ec5d5$export$7bf6537c73f09eab(Functor0)(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map1 = $7FzSN.map(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                var $lazy_go = $f846b50afc5ec5d5$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                    return function($197) {
                        return function(v) {
                            if (v instanceof $beQI1.Left) return map1(function($198) {
                                return $f846b50afc5ec5d5$var$join($f846b50afc5ec5d5$export$8040756fd4c77395($198));
                            })(traverse1($lazy_go(111))(v.value0));
                            if (v instanceof $beQI1.Right) return map1($f846b50afc5ec5d5$var$pure)(f(v.value0));
                            throw new Error("Failed pattern match at Control.Monad.Free (line 110, column 21 - line 112, column 30): " + [
                                v.constructor.name
                            ]);
                        }(resume1($197));
                    };
                });
                var go = $lazy_go(110);
                return go;
            };
        },
        sequence: function(dictApplicative) {
            return function(tma) {
                return $9OOYG.traverse($f846b50afc5ec5d5$export$816b93e586e4c75c(dictTraversable))(dictApplicative)($f846b50afc5ec5d5$var$identity)(tma);
            };
        },
        Functor0: function() {
            return $f846b50afc5ec5d5$export$245cefec95375d9a;
        },
        Foldable1: function() {
            return foldableFree1;
        }
    };
};
var $f846b50afc5ec5d5$export$eb0e66a9104d4874 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var map1 = $7FzSN.map(Monad0.Bind1().Apply0().Functor0());
    var pure1 = $bQdkN.pure(Monad0.Applicative0());
    var tailRecM = $bcJ05.tailRecM(dictMonadRec);
    return function(k) {
        var go = function(f) {
            var v = $f846b50afc5ec5d5$var$toView(f);
            if (v instanceof $f846b50afc5ec5d5$var$Return) return map1($bcJ05.Done.create)(pure1(v.value0));
            if (v instanceof $f846b50afc5ec5d5$var$Bind) return map1(function($199) {
                return $bcJ05.Loop.create(v.value1($199));
            })(k(v.value0));
            throw new Error("Failed pattern match at Control.Monad.Free (line 158, column 10 - line 160, column 37): " + [
                v.constructor.name
            ]);
        };
        return tailRecM(go);
    };
};
var $f846b50afc5ec5d5$export$14742287b71545dd = function(dictFunctor) {
    var resume1 = $f846b50afc5ec5d5$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictEq1) {
        var eq1 = $aJhEx.eq1(dictEq1);
        return function(dictEq) {
            var eq = $aJhEx.eq(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $beQI1.Left && v instanceof $beQI1.Left) return eq1($f846b50afc5ec5d5$export$14742287b71545dd(dictFunctor)(dictEq1)(dictEq))(v1.value0)(v.value0);
                        if (v1 instanceof $beQI1.Right && v instanceof $beQI1.Right) return eq(v1.value0)(v.value0);
                        return false;
                    };
                }
            };
        };
    };
};
var $f846b50afc5ec5d5$export$10be470239ca56c7 = function(dictFunctor) {
    var resume1 = $f846b50afc5ec5d5$export$fbb4d68fe60c1629(dictFunctor);
    var eqFree1 = $f846b50afc5ec5d5$export$14742287b71545dd(dictFunctor);
    return function(dictOrd1) {
        var compare1 = $gwBF5.compare1(dictOrd1);
        var eqFree2 = eqFree1(dictOrd1.Eq10());
        return function(dictOrd) {
            var compare = $gwBF5.compare(dictOrd);
            var eqFree3 = eqFree2(dictOrd.Eq0());
            return {
                compare: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $beQI1.Left && v instanceof $beQI1.Left) return compare1($f846b50afc5ec5d5$export$10be470239ca56c7(dictFunctor)(dictOrd1)(dictOrd))(v1.value0)(v.value0);
                        if (v1 instanceof $beQI1.Left) return $ibsD5.LT.value;
                        if (v instanceof $beQI1.Left) return $ibsD5.GT.value;
                        if (v1 instanceof $beQI1.Right && v instanceof $beQI1.Right) return compare(v1.value0)(v.value0);
                        throw new Error("Failed pattern match at Control.Monad.Free (line 56, column 17 - line 60, column 36): " + [
                            v1.constructor.name,
                            v.constructor.name
                        ]);
                    };
                },
                Eq0: function() {
                    return eqFree3;
                }
            };
        };
    };
};
var $f846b50afc5ec5d5$export$269c49b8f4785316 = function(dictFunctor) {
    var eqFree1 = $f846b50afc5ec5d5$export$14742287b71545dd(dictFunctor);
    return function(dictEq1) {
        var eqFree2 = eqFree1(dictEq1);
        return {
            eq1: function(dictEq) {
                return $aJhEx.eq(eqFree2(dictEq));
            }
        };
    };
};
var $f846b50afc5ec5d5$export$915c63020dce06b2 = function(dictFunctor) {
    var ordFree1 = $f846b50afc5ec5d5$export$10be470239ca56c7(dictFunctor);
    var eq1Free1 = $f846b50afc5ec5d5$export$269c49b8f4785316(dictFunctor);
    return function(dictOrd1) {
        var ordFree2 = ordFree1(dictOrd1);
        var eq1Free2 = eq1Free1(dictOrd1.Eq10());
        return {
            compare1: function(dictOrd) {
                return $gwBF5.compare(ordFree2(dictOrd));
            },
            Eq10: function() {
                return eq1Free2;
            }
        };
    };
};




var $bcJ05 = parcelRequire("bcJ05");


var $5ZwWo = parcelRequire("5ZwWo");

var $aJhEx = parcelRequire("aJhEx");

var $7vxKS = parcelRequire("7vxKS");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");

var $46y1S = parcelRequire("46y1S");

var $gwBF5 = parcelRequire("gwBF5");

var $9OOYG = parcelRequire("9OOYG");

var $7O0Q4 = parcelRequire("7O0Q4");

var $2jM6U = parcelRequire("2jM6U");



// Generated by purs version 0.15.16

var $k2DSm = parcelRequire("k2DSm");
var $409d32e8760027b2$export$c9e0c97aebb96176 = /* #__PURE__ */ function() {
    function ChildQuery(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    ChildQuery.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new ChildQuery(value0, value1, value2);
            };
        };
    };
    return ChildQuery;
}();
var $409d32e8760027b2$export$183d7a788d583d00 = $k2DSm.unsafeCoerce;
var $409d32e8760027b2$export$edf7909ca53834c6 = $k2DSm.unsafeCoerce;
var $409d32e8760027b2$export$22f9ac696d7058c1 = {
    map: function(f) {
        return $409d32e8760027b2$export$183d7a788d583d00(function(v) {
            return $409d32e8760027b2$export$edf7909ca53834c6(new $409d32e8760027b2$export$c9e0c97aebb96176(function(dictApplicative) {
                return v.value0(dictApplicative);
            }, v.value1, function($8) {
                return f(v.value2($8));
            }));
        });
    }
};


// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $26ZCq = parcelRequire("26ZCq");

var $cADnC = parcelRequire("cADnC");

var $brrpF = parcelRequire("brrpF");

var $dNwPt = parcelRequire("dNwPt");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $3aOYV = parcelRequire("3aOYV");

var $d5vvq = parcelRequire("d5vvq");

var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");

var $7fHqi = parcelRequire("7fHqi");


var $8ln3P = parcelRequire("8ln3P");
// Generated by purs version 0.15.16
function $809eef826baf5f99$export$2230c7466f27d38a(a) {
    return function(b) {
        return a === b;
    };
}



var $aJhEx = parcelRequire("aJhEx");
var $369b9f59978cbcde$export$4fd25d6ead33df13 = function(x) {
    return x;
};
var $369b9f59978cbcde$export$50f4602e25613a3e = function(x) {
    return x;
};
var $369b9f59978cbcde$export$54d9901699893a6 = $809eef826baf5f99$export$2230c7466f27d38a;
var $369b9f59978cbcde$export$139829c37543f0b8 = function(dictEq) {
    var eq = $aJhEx.eq(dictEq);
    return {
        eq: function(v) {
            return function(v1) {
                return $369b9f59978cbcde$export$54d9901699893a6(v)(v1) || eq(v)(v1);
            };
        }
    };
};
var $369b9f59978cbcde$export$32e537f465b3365f = {
    eq: function(v) {
        return function(v1) {
            return $369b9f59978cbcde$export$54d9901699893a6(v)(v1);
        };
    }
};


var $ae794effd2a529f9$var$$$void = /* #__PURE__ */ $7FzSN.void($1rTTn.functorEffect);
var $ae794effd2a529f9$var$coerce = /* #__PURE__ */ $8ln3P.coerce();
var $ae794effd2a529f9$var$bind = /* #__PURE__ */ $cADnC.bind($1rTTn.bindEffect);
var $ae794effd2a529f9$var$pure = /* #__PURE__ */ $bQdkN.pure($1rTTn.applicativeEffect);
var $ae794effd2a529f9$var$append = /* #__PURE__ */ $d5vvq.append($d5vvq.semigroupArray);
var $ae794effd2a529f9$var$traverse_ = /* #__PURE__ */ $dNwPt.traverse_($1rTTn.applicativeEffect);
var $ae794effd2a529f9$var$traverse_1 = /* #__PURE__ */ $ae794effd2a529f9$var$traverse_($dNwPt.foldableArray);
var $ae794effd2a529f9$var$applySecond = /* #__PURE__ */ $26ZCq.applySecond($1rTTn.applyEffect);
var $ae794effd2a529f9$var$traverse_2 = /* #__PURE__ */ $ae794effd2a529f9$var$traverse_($dNwPt.foldableMaybe);
var $ae794effd2a529f9$var$Subscription = function(x) {
    return x;
};
var $ae794effd2a529f9$var$Listener = function(x) {
    return x;
};
var $ae794effd2a529f9$var$Emitter = function(x) {
    return x;
};
var $ae794effd2a529f9$export$f500693cef883ffd = function(v) {
    return v;
};
var $ae794effd2a529f9$export$ec068583843480e7 = function(v) {
    return function(k) {
        return v(function($76) {
            return $ae794effd2a529f9$var$$$void(k($76));
        });
    };
};
var $ae794effd2a529f9$export$7251a5ca64435ded = /* #__PURE__ */ $1rTTn.semigroupEffect($d5vvq.semigroupUnit);
var $ae794effd2a529f9$export$5e14cdade93d6f7b = function(v) {
    return function(a) {
        return v(a);
    };
};
var $ae794effd2a529f9$export$f78eaf36ddcc5627 = /* #__PURE__ */ $1rTTn.monoidEffect($3aOYV.monoidUnit);
var $ae794effd2a529f9$var$mempty = /* #__PURE__ */ $3aOYV.mempty(/* #__PURE__ */ $3aOYV.monoidFn(/* #__PURE__ */ $1rTTn.monoidEffect($ae794effd2a529f9$export$f78eaf36ddcc5627)));
var $ae794effd2a529f9$export$59cc8049ccd39a18 = $ae794effd2a529f9$var$coerce;
var $ae794effd2a529f9$export$8fdc462d887e88b6 = {
    map: function(f) {
        return function(v) {
            return function(k) {
                return v(function($77) {
                    return k(f($77));
                });
            };
        };
    }
};
var $ae794effd2a529f9$export$93e2b83da34ff82a = function(f) {
    return function(v) {
        return function(b) {
            return function(k) {
                return function __do() {
                    var result = $7fHqi.new(b)();
                    return v(function(a) {
                        return $ae794effd2a529f9$var$bind($7fHqi.modify(f(a))(result))(k);
                    })();
                };
            };
        };
    };
};
var $ae794effd2a529f9$export$3dea766d36a8935f = function(p) {
    return function(v) {
        return function(k) {
            return v(function(a) {
                var $57 = p(a);
                if ($57) return k(a);
                return $ae794effd2a529f9$var$pure($2jM6U.unit);
            });
        };
    };
};
var $ae794effd2a529f9$export$185802fd694ee1f5 = function __do() {
    var subscribers = $7fHqi.new([])();
    return {
        emitter: function(k) {
            return function __do() {
                $7fHqi.modify_(function(v) {
                    return $ae794effd2a529f9$var$append(v)([
                        k
                    ]);
                })(subscribers)();
                return $7fHqi.modify_($brrpF.deleteBy($369b9f59978cbcde$export$54d9901699893a6)(k))(subscribers);
            };
        },
        listener: function(a) {
            return $ae794effd2a529f9$var$bind($7fHqi.read(subscribers))($ae794effd2a529f9$var$traverse_1(function(k) {
                return k(a);
            }));
        }
    };
};
var $ae794effd2a529f9$export$d838837eb5b184e3 = function(f) {
    var v = $b81e9b4392e02a01$export$c62839628b30a695($ae794effd2a529f9$export$185802fd694ee1f5);
    var v1 = f(v.emitter);
    return function(k) {
        return function __do() {
            var v2 = $ae794effd2a529f9$export$ec068583843480e7(v1.input)($ae794effd2a529f9$export$5e14cdade93d6f7b(v.listener))();
            var v3 = $ae794effd2a529f9$export$ec068583843480e7(v1.output)(k)();
            return $ae794effd2a529f9$var$applySecond(v2)(v3);
        };
    };
};
var $ae794effd2a529f9$export$98d7d43cbbc38ca1 = {
    cmap: function(f) {
        return function(v) {
            return $ae794effd2a529f9$var$coerce(function($78) {
                return v(f($78));
            });
        };
    }
};
var $ae794effd2a529f9$export$641721d49e3b53db = {
    apply: function(v) {
        return function(v1) {
            return function(k) {
                return function __do() {
                    var latestA = $7fHqi.new($h2xUu.Nothing.value)();
                    var latestB = $7fHqi.new($h2xUu.Nothing.value)();
                    var v2 = v(function(a) {
                        return function __do() {
                            $7fHqi.write(new $h2xUu.Just(a))(latestA)();
                            return $ae794effd2a529f9$var$bind($7fHqi.read(latestB))($ae794effd2a529f9$var$traverse_2(function($79) {
                                return k(a($79));
                            }))();
                        };
                    })();
                    var v3 = v1(function(b) {
                        return function __do() {
                            $7fHqi.write(new $h2xUu.Just(b))(latestB)();
                            return $ae794effd2a529f9$var$bind($7fHqi.read(latestA))($ae794effd2a529f9$var$traverse_2(function($80) {
                                return k(function(v3) {
                                    return v3(b);
                                }($80));
                            }))();
                        };
                    })();
                    return $ae794effd2a529f9$var$applySecond(v2)(v3);
                };
            };
        };
    },
    Functor0: function() {
        return $ae794effd2a529f9$export$8fdc462d887e88b6;
    }
};
var $ae794effd2a529f9$var$lift2 = /* #__PURE__ */ $26ZCq.lift2($ae794effd2a529f9$export$641721d49e3b53db);
var $ae794effd2a529f9$export$1096768271b079ef = function(dictSemigroup) {
    return {
        append: $ae794effd2a529f9$var$lift2($d5vvq.append(dictSemigroup))
    };
};
var $ae794effd2a529f9$export$3b69707d5efd35bb = function(dictMonoid) {
    var semigroupEmitter1 = $ae794effd2a529f9$export$1096768271b079ef(dictMonoid.Semigroup0());
    return {
        mempty: $ae794effd2a529f9$var$mempty,
        Semigroup0: function() {
            return semigroupEmitter1;
        }
    };
};
var $ae794effd2a529f9$export$b87fc96b41f99504 = {
    pure: function(a) {
        return function(k) {
            return function __do() {
                k(a)();
                return $ae794effd2a529f9$var$pure($2jM6U.unit);
            };
        };
    },
    Apply0: function() {
        return $ae794effd2a529f9$export$641721d49e3b53db;
    }
};
var $ae794effd2a529f9$export$e54eec101f91650d = {
    alt: function(v) {
        return function(v1) {
            return function(k) {
                return function __do() {
                    var v2 = v(k)();
                    var v3 = v1(k)();
                    return $ae794effd2a529f9$var$applySecond(v2)(v3);
                };
            };
        };
    },
    Functor0: function() {
        return $ae794effd2a529f9$export$8fdc462d887e88b6;
    }
};
var $ae794effd2a529f9$export$18c97e2c4a95b65b = {
    empty: function(v) {
        return $ae794effd2a529f9$var$pure($ae794effd2a529f9$var$pure($2jM6U.unit));
    },
    Alt0: function() {
        return $ae794effd2a529f9$export$e54eec101f91650d;
    }
};
var $ae794effd2a529f9$export$9afcd97a0eb7b5aa = {
    Applicative0: function() {
        return $ae794effd2a529f9$export$b87fc96b41f99504;
    },
    Plus1: function() {
        return $ae794effd2a529f9$export$18c97e2c4a95b65b;
    }
};


var $497deb56c643077e$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $497deb56c643077e$var$foldrWithIndex = /* #__PURE__ */ $7vxKS.foldrWithIndex($aHmxC.foldableWithIndexMap);
var $497deb56c643077e$var$traverse = /* #__PURE__ */ $9OOYG.traverse($aHmxC.traversableMap);
var $497deb56c643077e$var$slots = /* #__PURE__ */ $b10d220e1d5af382$export$bbd679b9fab4c947();
var $497deb56c643077e$var$lookup = /* #__PURE__ */ $b10d220e1d5af382$export$dfc7155ac0343b8();
var $497deb56c643077e$var$over = /* #__PURE__ */ $46y1S.over()();
var $497deb56c643077e$var$map = /* #__PURE__ */ $7FzSN.map($ae794effd2a529f9$export$8fdc462d887e88b6);
var $497deb56c643077e$var$map1 = /* #__PURE__ */ $7FzSN.map($7O0Q4.functorTuple);
var $497deb56c643077e$var$lmap = /* #__PURE__ */ $5ZwWo.lmap($5ZwWo.bifunctorTuple);
var $497deb56c643077e$var$map2 = /* #__PURE__ */ $7FzSN.map($409d32e8760027b2$export$22f9ac696d7058c1);
var $497deb56c643077e$export$f3ce0030ce21b322 = function(x) {
    return x;
};
var $497deb56c643077e$export$77e8fa738093aa8c = function(x) {
    return x;
};
var $497deb56c643077e$export$7254cc27399e90bd = /* #__PURE__ */ function() {
    function State(value0) {
        this.value0 = value0;
    }
    State.create = function(value0) {
        return new State(value0);
    };
    return State;
}();
var $497deb56c643077e$export$b5b6bb8bb5273115 = /* #__PURE__ */ function() {
    function Subscribe(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Subscribe.create = function(value0) {
        return function(value1) {
            return new Subscribe(value0, value1);
        };
    };
    return Subscribe;
}();
var $497deb56c643077e$export$cf424b9d16eab6b0 = /* #__PURE__ */ function() {
    function Unsubscribe(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Unsubscribe.create = function(value0) {
        return function(value1) {
            return new Unsubscribe(value0, value1);
        };
    };
    return Unsubscribe;
}();
var $497deb56c643077e$export$5ba9ac88cb4a4c17 = /* #__PURE__ */ function() {
    function Lift(value0) {
        this.value0 = value0;
    }
    Lift.create = function(value0) {
        return new Lift(value0);
    };
    return Lift;
}();
var $497deb56c643077e$export$c9e0c97aebb96176 = /* #__PURE__ */ function() {
    function ChildQuery(value0) {
        this.value0 = value0;
    }
    ChildQuery.create = function(value0) {
        return new ChildQuery(value0);
    };
    return ChildQuery;
}();
var $497deb56c643077e$export$c97bcbb53b4e15e4 = /* #__PURE__ */ function() {
    function Raise(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Raise.create = function(value0) {
        return function(value1) {
            return new Raise(value0, value1);
        };
    };
    return Raise;
}();
var $497deb56c643077e$export$6e7e621f508eff66 = /* #__PURE__ */ function() {
    function Par(value0) {
        this.value0 = value0;
    }
    Par.create = function(value0) {
        return new Par(value0);
    };
    return Par;
}();
var $497deb56c643077e$export$8cdfc2927e464854 = /* #__PURE__ */ function() {
    function Fork(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Fork.create = function(value0) {
        return function(value1) {
            return new Fork(value0, value1);
        };
    };
    return Fork;
}();
var $497deb56c643077e$export$26aa7833c998c5d3 = /* #__PURE__ */ function() {
    function Join(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Join.create = function(value0) {
        return function(value1) {
            return new Join(value0, value1);
        };
    };
    return Join;
}();
var $497deb56c643077e$export$25e269b2a286b4be = /* #__PURE__ */ function() {
    function Kill(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Kill.create = function(value0) {
        return function(value1) {
            return new Kill(value0, value1);
        };
    };
    return Kill;
}();
var $497deb56c643077e$export$c2ea277386f73da0 = /* #__PURE__ */ function() {
    function GetRef(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    GetRef.create = function(value0) {
        return function(value1) {
            return new GetRef(value0, value1);
        };
    };
    return GetRef;
}();
var $497deb56c643077e$export$a719947860ecc9c1 = function(x) {
    return x;
};
var $497deb56c643077e$export$9599f158307d5f79 = function(x) {
    return x;
};
var $497deb56c643077e$export$f500693cef883ffd = function(sid) {
    return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$cf424b9d16eab6b0(sid, $2jM6U.unit));
};
var $497deb56c643077e$export$614bd1e27186eef8 = function(esc) {
    return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$b5b6bb8bb5273115(esc, $jhsiw.const($2jM6U.unit)));
};
var $497deb56c643077e$export$ec068583843480e7 = function(es) {
    return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$b5b6bb8bb5273115(function(v) {
        return es;
    }, $497deb56c643077e$var$identity));
};
var $497deb56c643077e$export$24cfcc8b33bdb8e8 = function(dictSemigroup) {
    return $f846b50afc5ec5d5$export$d68567ac4fd5624d(dictSemigroup);
};
var $497deb56c643077e$export$66313c302b2ea154 = function(o) {
    return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$c97bcbb53b4e15e4(o, $2jM6U.unit));
};
var $497deb56c643077e$export$dcd0d083aa86c355 = function() {
    return function(dictIsSymbol) {
        var slots1 = $497deb56c643077e$var$slots(dictIsSymbol);
        return function(dictOrd) {
            var slots2 = slots1(dictOrd);
            return function(label) {
                return function(q) {
                    var catMapMaybes = function(dictOrd1) {
                        var insert = $aHmxC.insert(dictOrd1);
                        return $497deb56c643077e$var$foldrWithIndex(function(k) {
                            return function(v) {
                                return function(acc) {
                                    return $h2xUu.maybe(acc)($jhsiw.flip(insert(k))(acc))(v);
                                };
                            };
                        })($aHmxC.empty);
                    };
                    var catMapMaybes1 = catMapMaybes(dictOrd);
                    return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$c9e0c97aebb96176($409d32e8760027b2$export$edf7909ca53834c6(new $409d32e8760027b2$export$c9e0c97aebb96176(function(dictApplicative) {
                        var map4 = $7FzSN.map(dictApplicative.Apply0().Functor0());
                        var traverse1 = $497deb56c643077e$var$traverse(dictApplicative);
                        return function(k) {
                            var $173 = map4(catMapMaybes1);
                            var $174 = traverse1(k);
                            var $175 = slots2(label);
                            return function($176) {
                                return $173($174($175($176)));
                            };
                        };
                    }, q, $497deb56c643077e$var$identity))));
                };
            };
        };
    };
};
var $497deb56c643077e$export$2fa187e846a241c4 = function() {
    return function(dictIsSymbol) {
        var lookup1 = $497deb56c643077e$var$lookup(dictIsSymbol);
        return function(dictOrd) {
            var lookup2 = lookup1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(q) {
                        return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$c9e0c97aebb96176($409d32e8760027b2$export$edf7909ca53834c6(new $409d32e8760027b2$export$c9e0c97aebb96176(function(dictApplicative) {
                            var pure1 = $bQdkN.pure(dictApplicative);
                            return function(k) {
                                var $177 = $h2xUu.maybe(pure1($h2xUu.Nothing.value))(k);
                                var $178 = lookup2(label)(p);
                                return function($179) {
                                    return $177($178($179));
                                };
                            };
                        }, q, $497deb56c643077e$var$identity))));
                    };
                };
            };
        };
    };
};
var $497deb56c643077e$export$2a9fc99fce80131a = $gwBF5.ordInt;
var $497deb56c643077e$export$7e953d51c2b3343e = $gwBF5.ordInt;
var $497deb56c643077e$export$e0bae42e641783be = {
    Coercible0: function() {
        return undefined;
    }
};
var $497deb56c643077e$export$2b4680b78d507e0e = function(dictMonoid) {
    return $f846b50afc5ec5d5$export$cb3638ab887278d6(dictMonoid);
};
var $497deb56c643077e$export$a19097d0708c88b2 = {
    lift: function(dictMonad) {
        return function($180) {
            return $497deb56c643077e$export$9599f158307d5f79($f846b50afc5ec5d5$export$8040756fd4c77395($497deb56c643077e$export$5ba9ac88cb4a4c17.create($180)));
        };
    }
};
var $497deb56c643077e$export$a558113f6f2e3f2d = $f846b50afc5ec5d5$export$25ad06f1eebea5a0;
var $497deb56c643077e$export$87bf621137788b28 = {
    state: function($181) {
        return $497deb56c643077e$export$9599f158307d5f79($f846b50afc5ec5d5$export$8040756fd4c77395($497deb56c643077e$export$7254cc27399e90bd.create($181)));
    },
    Monad0: function() {
        return $497deb56c643077e$export$a558113f6f2e3f2d;
    }
};
var $497deb56c643077e$export$cf461d6710b3adc = function(dictMonadTell) {
    var Semigroup0 = dictMonadTell.Semigroup0();
    return {
        tell: function() {
            var $182 = $1ef973452f9b4285$export$de3113ed932c61ab(dictMonadTell);
            return function($183) {
                return $497deb56c643077e$export$9599f158307d5f79($f846b50afc5ec5d5$export$8040756fd4c77395($497deb56c643077e$export$5ba9ac88cb4a4c17.create($182($183))));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return $497deb56c643077e$export$a558113f6f2e3f2d;
        }
    };
};
var $497deb56c643077e$export$4671b1f72e4f4ad4 = function(dictMonadThrow) {
    return {
        throwError: function() {
            var $184 = $693a27a8782d8e71$export$8bf7aba4a9e09055(dictMonadThrow);
            return function($185) {
                return $497deb56c643077e$export$9599f158307d5f79($f846b50afc5ec5d5$export$8040756fd4c77395($497deb56c643077e$export$5ba9ac88cb4a4c17.create($184($185))));
            };
        }(),
        Monad0: function() {
            return $497deb56c643077e$export$a558113f6f2e3f2d;
        }
    };
};
var $497deb56c643077e$export$aecceb0bc1bf10d9 = function(dictMonadEffect) {
    return {
        liftEffect: function() {
            var $186 = $54d5aa8d31ad5798$export$34255e15eb56d2b3(dictMonadEffect);
            return function($187) {
                return $497deb56c643077e$export$9599f158307d5f79($f846b50afc5ec5d5$export$8040756fd4c77395($497deb56c643077e$export$5ba9ac88cb4a4c17.create($186($187))));
            };
        }(),
        Monad0: function() {
            return $497deb56c643077e$export$a558113f6f2e3f2d;
        }
    };
};
var $497deb56c643077e$export$8feaa16df4090813 = function(dictMonadAsk) {
    return {
        ask: $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$5ba9ac88cb4a4c17($ce0fad135b75d1f6$export$1b4aee0b51c3def8(dictMonadAsk))),
        Monad0: function() {
            return $497deb56c643077e$export$a558113f6f2e3f2d;
        }
    };
};
var $497deb56c643077e$export$6f4dec227404555 = function(dictMonadAff) {
    var monadEffectHalogenM1 = $497deb56c643077e$export$aecceb0bc1bf10d9(dictMonadAff.MonadEffect0());
    return {
        liftAff: function() {
            var $188 = $ec5cc86f53a11c6b$export$37f61af225938e0f(dictMonadAff);
            return function($189) {
                return $497deb56c643077e$export$9599f158307d5f79($f846b50afc5ec5d5$export$8040756fd4c77395($497deb56c643077e$export$5ba9ac88cb4a4c17.create($188($189))));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectHalogenM1;
        }
    };
};
var $497deb56c643077e$export$88e5a30f85fcd860 = function(f) {
    return function(v) {
        var go = function(v1) {
            if (v1 instanceof $497deb56c643077e$export$7254cc27399e90bd) return new $497deb56c643077e$export$7254cc27399e90bd(v1.value0);
            if (v1 instanceof $497deb56c643077e$export$b5b6bb8bb5273115) return new $497deb56c643077e$export$b5b6bb8bb5273115(v1.value0, v1.value1);
            if (v1 instanceof $497deb56c643077e$export$cf424b9d16eab6b0) return new $497deb56c643077e$export$cf424b9d16eab6b0(v1.value0, v1.value1);
            if (v1 instanceof $497deb56c643077e$export$5ba9ac88cb4a4c17) return new $497deb56c643077e$export$5ba9ac88cb4a4c17(v1.value0);
            if (v1 instanceof $497deb56c643077e$export$c9e0c97aebb96176) return new $497deb56c643077e$export$c9e0c97aebb96176(v1.value0);
            if (v1 instanceof $497deb56c643077e$export$c97bcbb53b4e15e4) return new $497deb56c643077e$export$c97bcbb53b4e15e4(f(v1.value0), v1.value1);
            if (v1 instanceof $497deb56c643077e$export$6e7e621f508eff66) return new $497deb56c643077e$export$6e7e621f508eff66($497deb56c643077e$var$over($497deb56c643077e$export$a719947860ecc9c1)($d274f7fabe85b746$export$2a17b194dc6daf5e($497deb56c643077e$export$88e5a30f85fcd860(f)))(v1.value0));
            if (v1 instanceof $497deb56c643077e$export$8cdfc2927e464854) return new $497deb56c643077e$export$8cdfc2927e464854($497deb56c643077e$export$88e5a30f85fcd860(f)(v1.value0), v1.value1);
            if (v1 instanceof $497deb56c643077e$export$26aa7833c998c5d3) return new $497deb56c643077e$export$26aa7833c998c5d3(v1.value0, v1.value1);
            if (v1 instanceof $497deb56c643077e$export$25e269b2a286b4be) return new $497deb56c643077e$export$25e269b2a286b4be(v1.value0, v1.value1);
            if (v1 instanceof $497deb56c643077e$export$c2ea277386f73da0) return new $497deb56c643077e$export$c2ea277386f73da0(v1.value0, v1.value1);
            throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 290, column 8 - line 301, column 29): " + [
                v1.constructor.name
            ]);
        };
        return $f846b50afc5ec5d5$export$9624ed458578c422(go)(v);
    };
};
var $497deb56c643077e$export$77c80fee367384a1 = function(dictFunctor) {
    return function(f) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $497deb56c643077e$export$7254cc27399e90bd) return new $497deb56c643077e$export$7254cc27399e90bd(v1.value0);
                if (v1 instanceof $497deb56c643077e$export$b5b6bb8bb5273115) return new $497deb56c643077e$export$b5b6bb8bb5273115(function() {
                    var $190 = $497deb56c643077e$var$map(f);
                    return function($191) {
                        return $190(v1.value0($191));
                    };
                }(), v1.value1);
                if (v1 instanceof $497deb56c643077e$export$cf424b9d16eab6b0) return new $497deb56c643077e$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$5ba9ac88cb4a4c17) return new $497deb56c643077e$export$5ba9ac88cb4a4c17(v1.value0);
                if (v1 instanceof $497deb56c643077e$export$c9e0c97aebb96176) return new $497deb56c643077e$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $497deb56c643077e$export$c97bcbb53b4e15e4) return new $497deb56c643077e$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$6e7e621f508eff66) return new $497deb56c643077e$export$6e7e621f508eff66($497deb56c643077e$var$over($497deb56c643077e$export$a719947860ecc9c1)($d274f7fabe85b746$export$2a17b194dc6daf5e($497deb56c643077e$export$77c80fee367384a1(dictFunctor)(f)))(v1.value0));
                if (v1 instanceof $497deb56c643077e$export$8cdfc2927e464854) return new $497deb56c643077e$export$8cdfc2927e464854($497deb56c643077e$export$77c80fee367384a1(dictFunctor)(f)(v1.value0), v1.value1);
                if (v1 instanceof $497deb56c643077e$export$26aa7833c998c5d3) return new $497deb56c643077e$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$25e269b2a286b4be) return new $497deb56c643077e$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$c2ea277386f73da0) return new $497deb56c643077e$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 269, column 8 - line 280, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $f846b50afc5ec5d5$export$9624ed458578c422(go)(v);
        };
    };
};
var $497deb56c643077e$export$dfdb508572caf3d7 = function(fid) {
    return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$25e269b2a286b4be(fid, $2jM6U.unit));
};
var $497deb56c643077e$export$f7e2c8231c57a8bd = function(fid) {
    return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$26aa7833c998c5d3(fid, $2jM6U.unit));
};
var $497deb56c643077e$export$d4721e7c31d91ccb = function(f) {
    return function(f$prime) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $497deb56c643077e$export$7254cc27399e90bd) return new $497deb56c643077e$export$7254cc27399e90bd(function() {
                    var $192 = $497deb56c643077e$var$map1(f);
                    return function($193) {
                        return $192(v1.value0(f$prime($193)));
                    };
                }());
                if (v1 instanceof $497deb56c643077e$export$b5b6bb8bb5273115) return new $497deb56c643077e$export$b5b6bb8bb5273115(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$cf424b9d16eab6b0) return new $497deb56c643077e$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$5ba9ac88cb4a4c17) return new $497deb56c643077e$export$5ba9ac88cb4a4c17(v1.value0);
                if (v1 instanceof $497deb56c643077e$export$c9e0c97aebb96176) return new $497deb56c643077e$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $497deb56c643077e$export$c97bcbb53b4e15e4) return new $497deb56c643077e$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$6e7e621f508eff66) return new $497deb56c643077e$export$6e7e621f508eff66($497deb56c643077e$var$over($497deb56c643077e$export$a719947860ecc9c1)($d274f7fabe85b746$export$2a17b194dc6daf5e($497deb56c643077e$export$d4721e7c31d91ccb(f)(f$prime)))(v1.value0));
                if (v1 instanceof $497deb56c643077e$export$8cdfc2927e464854) return new $497deb56c643077e$export$8cdfc2927e464854($497deb56c643077e$export$d4721e7c31d91ccb(f)(f$prime)(v1.value0), v1.value1);
                if (v1 instanceof $497deb56c643077e$export$26aa7833c998c5d3) return new $497deb56c643077e$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$25e269b2a286b4be) return new $497deb56c643077e$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$c2ea277386f73da0) return new $497deb56c643077e$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 247, column 8 - line 258, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $f846b50afc5ec5d5$export$9624ed458578c422(go)(v);
        };
    };
};
var $497deb56c643077e$export$b2cccb4e0928a3a6 = function(dictFunctor) {
    return function(nat) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $497deb56c643077e$export$7254cc27399e90bd) return new $497deb56c643077e$export$7254cc27399e90bd(v1.value0);
                if (v1 instanceof $497deb56c643077e$export$b5b6bb8bb5273115) return new $497deb56c643077e$export$b5b6bb8bb5273115(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$cf424b9d16eab6b0) return new $497deb56c643077e$export$cf424b9d16eab6b0(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$5ba9ac88cb4a4c17) return new $497deb56c643077e$export$5ba9ac88cb4a4c17(nat(v1.value0));
                if (v1 instanceof $497deb56c643077e$export$c9e0c97aebb96176) return new $497deb56c643077e$export$c9e0c97aebb96176(v1.value0);
                if (v1 instanceof $497deb56c643077e$export$c97bcbb53b4e15e4) return new $497deb56c643077e$export$c97bcbb53b4e15e4(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$6e7e621f508eff66) return new $497deb56c643077e$export$6e7e621f508eff66($497deb56c643077e$var$over($497deb56c643077e$export$a719947860ecc9c1)($d274f7fabe85b746$export$2a17b194dc6daf5e($497deb56c643077e$export$b2cccb4e0928a3a6(dictFunctor)(nat)))(v1.value0));
                if (v1 instanceof $497deb56c643077e$export$8cdfc2927e464854) return new $497deb56c643077e$export$8cdfc2927e464854($497deb56c643077e$export$b2cccb4e0928a3a6(dictFunctor)(nat)(v1.value0), v1.value1);
                if (v1 instanceof $497deb56c643077e$export$26aa7833c998c5d3) return new $497deb56c643077e$export$26aa7833c998c5d3(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$25e269b2a286b4be) return new $497deb56c643077e$export$25e269b2a286b4be(v1.value0, v1.value1);
                if (v1 instanceof $497deb56c643077e$export$c2ea277386f73da0) return new $497deb56c643077e$export$c2ea277386f73da0(v1.value0, v1.value1);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 312, column 8 - line 323, column 29): " + [
                    v1.constructor.name
                ]);
            };
            return $f846b50afc5ec5d5$export$9624ed458578c422(go)(v);
        };
    };
};
var $497deb56c643077e$export$f0c653cfd7dea798 = function(p) {
    return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$c2ea277386f73da0(p, $497deb56c643077e$var$identity));
};
var $497deb56c643077e$export$bf09f5de576f9cf1 = $f846b50afc5ec5d5$export$245cefec95375d9a;
var $497deb56c643077e$export$e670701c689a627c = $d274f7fabe85b746$export$a37c0cfb408cb5d9;
var $497deb56c643077e$var$map3 = /* #__PURE__ */ $7FzSN.map($497deb56c643077e$export$e670701c689a627c);
var $497deb56c643077e$export$12e8711db3d90a36 = function(dictFunctor) {
    var map4 = $7FzSN.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                if (v instanceof $497deb56c643077e$export$7254cc27399e90bd) return new $497deb56c643077e$export$7254cc27399e90bd(function() {
                    var $194 = $497deb56c643077e$var$lmap(f);
                    return function($195) {
                        return $194(v.value0($195));
                    };
                }());
                if (v instanceof $497deb56c643077e$export$b5b6bb8bb5273115) return new $497deb56c643077e$export$b5b6bb8bb5273115(v.value0, function($196) {
                    return f(v.value1($196));
                });
                if (v instanceof $497deb56c643077e$export$cf424b9d16eab6b0) return new $497deb56c643077e$export$cf424b9d16eab6b0(v.value0, f(v.value1));
                if (v instanceof $497deb56c643077e$export$5ba9ac88cb4a4c17) return new $497deb56c643077e$export$5ba9ac88cb4a4c17(map4(f)(v.value0));
                if (v instanceof $497deb56c643077e$export$c9e0c97aebb96176) return new $497deb56c643077e$export$c9e0c97aebb96176($497deb56c643077e$var$map2(f)(v.value0));
                if (v instanceof $497deb56c643077e$export$c97bcbb53b4e15e4) return new $497deb56c643077e$export$c97bcbb53b4e15e4(v.value0, f(v.value1));
                if (v instanceof $497deb56c643077e$export$6e7e621f508eff66) return new $497deb56c643077e$export$6e7e621f508eff66($497deb56c643077e$var$map3(f)(v.value0));
                if (v instanceof $497deb56c643077e$export$8cdfc2927e464854) return new $497deb56c643077e$export$8cdfc2927e464854(v.value0, function($197) {
                    return f(v.value1($197));
                });
                if (v instanceof $497deb56c643077e$export$26aa7833c998c5d3) return new $497deb56c643077e$export$26aa7833c998c5d3(v.value0, f(v.value1));
                if (v instanceof $497deb56c643077e$export$25e269b2a286b4be) return new $497deb56c643077e$export$25e269b2a286b4be(v.value0, f(v.value1));
                if (v instanceof $497deb56c643077e$export$c2ea277386f73da0) return new $497deb56c643077e$export$c2ea277386f73da0(v.value0, function($198) {
                    return f(v.value1($198));
                });
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 57, column 11 - line 68, column 37): " + [
                    v.constructor.name
                ]);
            };
        }
    };
};
var $497deb56c643077e$export$7a5058c6b79333e0 = function(hmu) {
    return $f846b50afc5ec5d5$export$8040756fd4c77395(new $497deb56c643077e$export$8cdfc2927e464854(hmu, $497deb56c643077e$var$identity));
};
var $497deb56c643077e$export$5e41ee1c67709c46 = $aJhEx.eqInt;
var $497deb56c643077e$export$5d7b8e78e43e2e55 = $aJhEx.eqInt;
var $497deb56c643077e$export$172cc2b2b4e6467a = $f846b50afc5ec5d5$export$39486fc5c75854c8;
var $497deb56c643077e$var$bind = /* #__PURE__ */ $cADnC.bind($497deb56c643077e$export$172cc2b2b4e6467a);
var $497deb56c643077e$export$728fdd75cbe6b202 = $f846b50afc5ec5d5$export$2d6a2fb8bce0f112;
var $497deb56c643077e$export$86681bd6e5a32e67 = $d274f7fabe85b746$export$6b0545b2ed7e7da2;
var $497deb56c643077e$export$be2318e898dcc68 = $f846b50afc5ec5d5$export$b9ce46e7f510eb18;
var $497deb56c643077e$var$pure = /* #__PURE__ */ $bQdkN.pure($497deb56c643077e$export$be2318e898dcc68);
var $497deb56c643077e$export$5cb2ea25322ba73e = {
    tailRecM: function(k) {
        return function(a) {
            return $497deb56c643077e$var$bind(k(a))(function(v) {
                if (v instanceof $bcJ05.Loop) return $bcJ05.tailRecM($497deb56c643077e$export$5cb2ea25322ba73e)(k)(v.value0);
                if (v instanceof $bcJ05.Done) return $497deb56c643077e$var$pure(v.value0);
                throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 105, column 26 - line 107, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $497deb56c643077e$export$a558113f6f2e3f2d;
    }
};
var $497deb56c643077e$export$a8dcf11c663b5a8c = $d274f7fabe85b746$export$b8278c4ac41154ad;
var $497deb56c643077e$export$c43a5691f7e31126 = {
    parallel: function($199) {
        return $497deb56c643077e$export$a719947860ecc9c1($d274f7fabe85b746$export$9f6cb61afbf051fa($199));
    },
    sequential: function($200) {
        return $497deb56c643077e$export$9599f158307d5f79($f846b50afc5ec5d5$export$8040756fd4c77395($497deb56c643077e$export$6e7e621f508eff66.create($200)));
    },
    Monad0: function() {
        return $497deb56c643077e$export$a558113f6f2e3f2d;
    },
    Applicative1: function() {
        return $497deb56c643077e$export$a8dcf11c663b5a8c;
    }
};


// Generated by purs version 0.15.16


var $7FzSN = parcelRequire("7FzSN");
var $5573693fd45dda6e$var$map = /* #__PURE__ */ $7FzSN.map($6ceb47448afaefc1$export$bd40aba71422b460);
var $5573693fd45dda6e$var$map1 = /* #__PURE__ */ $7FzSN.map($7FzSN.functorFn);
var $5573693fd45dda6e$export$b03b1c699c90a9b4 = /* #__PURE__ */ function() {
    function Initialize(value0) {
        this.value0 = value0;
    }
    Initialize.create = function(value0) {
        return new Initialize(value0);
    };
    return Initialize;
}();
var $5573693fd45dda6e$export$29defdae7b3f3a01 = /* #__PURE__ */ function() {
    function Finalize(value0) {
        this.value0 = value0;
    }
    Finalize.create = function(value0) {
        return new Finalize(value0);
    };
    return Finalize;
}();
var $5573693fd45dda6e$export$fc713a64b8ca1b7a = /* #__PURE__ */ function() {
    function Receive(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Receive.create = function(value0) {
        return function(value1) {
            return new Receive(value0, value1);
        };
    };
    return Receive;
}();
var $5573693fd45dda6e$export$e19cd5f9376f8cee = /* #__PURE__ */ function() {
    function Action(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Action.create = function(value0) {
        return function(value1) {
            return new Action(value0, value1);
        };
    };
    return Action;
}();
var $5573693fd45dda6e$export$62297b13309008b2 = /* #__PURE__ */ function() {
    function Query(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Query.create = function(value0) {
        return function(value1) {
            return new Query(value0, value1);
        };
    };
    return Query;
}();
var $5573693fd45dda6e$export$dc697e7b72225166 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $5573693fd45dda6e$export$b03b1c699c90a9b4) return new $5573693fd45dda6e$export$b03b1c699c90a9b4(f(m.value0));
            if (m instanceof $5573693fd45dda6e$export$29defdae7b3f3a01) return new $5573693fd45dda6e$export$29defdae7b3f3a01(f(m.value0));
            if (m instanceof $5573693fd45dda6e$export$fc713a64b8ca1b7a) return new $5573693fd45dda6e$export$fc713a64b8ca1b7a(m.value0, f(m.value1));
            if (m instanceof $5573693fd45dda6e$export$e19cd5f9376f8cee) return new $5573693fd45dda6e$export$e19cd5f9376f8cee(m.value0, f(m.value1));
            if (m instanceof $5573693fd45dda6e$export$62297b13309008b2) return new $5573693fd45dda6e$export$62297b13309008b2($5573693fd45dda6e$var$map(f)(m.value0), $5573693fd45dda6e$var$map1(f)(m.value1));
            throw new Error("Failed pattern match at Halogen.Query.HalogenQ (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $5573693fd45dda6e$export$211dae0362bd77c6 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                if (v instanceof $5573693fd45dda6e$export$b03b1c699c90a9b4) return new $5573693fd45dda6e$export$b03b1c699c90a9b4(g(v.value0));
                if (v instanceof $5573693fd45dda6e$export$29defdae7b3f3a01) return new $5573693fd45dda6e$export$29defdae7b3f3a01(g(v.value0));
                if (v instanceof $5573693fd45dda6e$export$fc713a64b8ca1b7a) return new $5573693fd45dda6e$export$fc713a64b8ca1b7a(f(v.value0), g(v.value1));
                if (v instanceof $5573693fd45dda6e$export$e19cd5f9376f8cee) return new $5573693fd45dda6e$export$e19cd5f9376f8cee(v.value0, g(v.value1));
                if (v instanceof $5573693fd45dda6e$export$62297b13309008b2) return new $5573693fd45dda6e$export$62297b13309008b2($5573693fd45dda6e$var$map(g)(v.value0), $5573693fd45dda6e$var$map1(g)(v.value1));
                throw new Error("Failed pattern match at Halogen.Query.HalogenQ (line 16, column 15 - line 21, column 45): " + [
                    v.constructor.name
                ]);
            };
        };
    }
};


// Generated by purs version 0.15.16


var $7FzSN = parcelRequire("7FzSN");




var $k2DSm = parcelRequire("k2DSm");
var $ea9a396fdac62c85$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $ea9a396fdac62c85$var$Thunk = /* #__PURE__ */ function() {
    function Thunk(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Thunk.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Thunk(value0, value1, value2, value3);
                };
            };
        };
    };
    return Thunk;
}();
var $ea9a396fdac62c85$var$unsafeThunkId = $k2DSm.unsafeCoerce;
var $ea9a396fdac62c85$var$unsafeEqThunk = function(v, v1) {
    return $4fef3a56afd3fa03$export$9bc2d847a861e3d8(v.value0, v1.value0) && $4fef3a56afd3fa03$export$9bc2d847a861e3d8(v.value1, v1.value1) && v.value1(v.value3, v1.value3);
};
var $ea9a396fdac62c85$var$thunk = function(tid, eqFn, f, a) {
    return new $ea9a396fdac62c85$var$Thunk(tid, eqFn, f, a);
};
var $ea9a396fdac62c85$export$c6666e7f0d2efc62 = function(f, a) {
    return $ea9a396fdac62c85$var$thunk($ea9a396fdac62c85$var$unsafeThunkId(f), $4fef3a56afd3fa03$export$9bc2d847a861e3d8, f, a);
};
var $ea9a396fdac62c85$export$8a29159161b2b8a6 = /* #__PURE__ */ function() {
    var eqFn = function(a, b) {
        return $4fef3a56afd3fa03$export$9bc2d847a861e3d8(a["_1"], b["_1"]) && $4fef3a56afd3fa03$export$9bc2d847a861e3d8(a["_2"], b["_2"]);
    };
    return function(f, a, b) {
        return $ea9a396fdac62c85$var$thunk($ea9a396fdac62c85$var$unsafeThunkId(f), eqFn, function(v) {
            return f(v["_1"])(v["_2"]);
        }, {
            "_1": a,
            "_2": b
        });
    };
}();
var $ea9a396fdac62c85$export$7f0ccf52046143dd = /* #__PURE__ */ function() {
    var eqFn = function(a, b) {
        return $4fef3a56afd3fa03$export$9bc2d847a861e3d8(a["_1"], b["_1"]) && $4fef3a56afd3fa03$export$9bc2d847a861e3d8(a["_2"], b["_2"]) && $4fef3a56afd3fa03$export$9bc2d847a861e3d8(a["_3"], b["_3"]);
    };
    return function(f, a, b, c) {
        return $ea9a396fdac62c85$var$thunk($ea9a396fdac62c85$var$unsafeThunkId(f), eqFn, function(v) {
            return f(v["_1"])(v["_2"])(v["_3"]);
        }, {
            "_1": a,
            "_2": b,
            "_3": c
        });
    };
}();
var $ea9a396fdac62c85$export$6fa757c467a343e = function(eqFn) {
    return function(f) {
        var tid = $ea9a396fdac62c85$var$unsafeThunkId({
            f: f
        });
        var eqFn$prime = $f9965fb2b3fd917d$export$b12d5f1f5e196716(eqFn);
        return function(a) {
            return $ea9a396fdac62c85$var$thunk(tid, eqFn$prime, f, a);
        };
    };
};
var $ea9a396fdac62c85$export$1a6f8a190b47b840 = function(v) {
    return v.value2(v.value3);
};
var $ea9a396fdac62c85$export$ad7ceecc341abc7e = function(k) {
    return function(v) {
        return new $ea9a396fdac62c85$var$Thunk(v.value0, v.value1, function($51) {
            return k(v.value2($51));
        }, v.value3);
    };
};
var $ea9a396fdac62c85$export$b2cccb4e0928a3a6 = $ea9a396fdac62c85$export$ad7ceecc341abc7e;
var $ea9a396fdac62c85$export$2d03ed83ba31f127 = function(dictFunctor) {
    var map = $7FzSN.map(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return new $ea9a396fdac62c85$var$Thunk(v.value0, v.value1, function() {
                    var $52 = map(f);
                    return function($53) {
                        return $52(v.value2($53));
                    };
                }(), v.value3);
            };
        }
    };
};
var $ea9a396fdac62c85$export$d46b23c375182cf8 = function(toVDom) {
    var haltThunk = function(state) {
        return $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de(state.vdom);
    };
    var $lazy_patchThunk = $ea9a396fdac62c85$var$$runtime_lazy("patchThunk", "Halogen.VDom.Thunk", function() {
        return function(state, t2) {
            var $48 = $ea9a396fdac62c85$var$unsafeEqThunk(state.thunk, t2);
            if ($48) return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a($c7f8bb6dcedfcaf7$export$f9380c9a627682d3(state.vdom), state, $lazy_patchThunk(112), haltThunk));
            var vdom = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(state.vdom, toVDom($ea9a396fdac62c85$export$1a6f8a190b47b840(t2)));
            return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a($c7f8bb6dcedfcaf7$export$f9380c9a627682d3(vdom), {
                vdom: vdom,
                thunk: t2
            }, $lazy_patchThunk(115), haltThunk));
        };
    });
    var patchThunk = $lazy_patchThunk(108);
    var renderThunk = function(spec) {
        return function(t) {
            var vdom = $2bb7f7bd8b4c6f39$export$7d13c0f6790d0505(spec)(toVDom($ea9a396fdac62c85$export$1a6f8a190b47b840(t)));
            return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a($c7f8bb6dcedfcaf7$export$f9380c9a627682d3(vdom), {
                thunk: t,
                vdom: vdom
            }, patchThunk, haltThunk));
        };
    };
    return renderThunk;
};



var $k2DSm = parcelRequire("k2DSm");
var $02809249bead6832$var$voidLeft = /* #__PURE__ */ $7FzSN.voidLeft($497deb56c643077e$export$bf09f5de576f9cf1);
var $02809249bead6832$var$traverse_ = /* #__PURE__ */ $dNwPt.traverse_($497deb56c643077e$export$be2318e898dcc68)($dNwPt.foldableMaybe);
var $02809249bead6832$var$map = /* #__PURE__ */ $7FzSN.map($497deb56c643077e$export$bf09f5de576f9cf1);
var $02809249bead6832$var$lmap = /* #__PURE__ */ $5ZwWo.lmap($9aad5dc74ea3040c$export$a671de4661736606);
var $02809249bead6832$var$map1 = /* #__PURE__ */ $7FzSN.map($7FzSN.functorFn);
var $02809249bead6832$var$map2 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $02809249bead6832$var$bimap = /* #__PURE__ */ $5ZwWo.bimap($9aad5dc74ea3040c$export$a671de4661736606);
var $02809249bead6832$var$pure = /* #__PURE__ */ $bQdkN.pure($497deb56c643077e$export$be2318e898dcc68);
var $02809249bead6832$var$lookup = /* #__PURE__ */ $b10d220e1d5af382$export$dfc7155ac0343b8();
var $02809249bead6832$var$pop = /* #__PURE__ */ $b10d220e1d5af382$export$3e41007ebfff0e64();
var $02809249bead6832$var$insert = /* #__PURE__ */ $b10d220e1d5af382$export$21a5ca8aa77d35ff();
var $02809249bead6832$export$bbf8b056cc92e88d = /* #__PURE__ */ function() {
    function ComponentSlot(value0) {
        this.value0 = value0;
    }
    ComponentSlot.create = function(value0) {
        return new ComponentSlot(value0);
    };
    return ComponentSlot;
}();
var $02809249bead6832$export$5e46cfa5e835a582 = /* #__PURE__ */ function() {
    function ThunkSlot(value0) {
        this.value0 = value0;
    }
    ThunkSlot.create = function(value0) {
        return new ThunkSlot(value0);
    };
    return ThunkSlot;
}();
var $02809249bead6832$export$48f0293959eb16ec = $k2DSm.unsafeCoerce;
var $02809249bead6832$export$802c6b8ce0f42195 = $k2DSm.unsafeCoerce;
var $02809249bead6832$export$9eef9effff68b10a = function(args) {
    return function(v) {
        if (v instanceof $5573693fd45dda6e$export$b03b1c699c90a9b4) return $02809249bead6832$var$voidLeft($02809249bead6832$var$traverse_(args.handleAction)(args.initialize))(v.value0);
        if (v instanceof $5573693fd45dda6e$export$29defdae7b3f3a01) return $02809249bead6832$var$voidLeft($02809249bead6832$var$traverse_(args.handleAction)(args.finalize))(v.value0);
        if (v instanceof $5573693fd45dda6e$export$fc713a64b8ca1b7a) return $02809249bead6832$var$voidLeft($02809249bead6832$var$traverse_(args.handleAction)(args.receive(v.value0)))(v.value1);
        if (v instanceof $5573693fd45dda6e$export$e19cd5f9376f8cee) return $02809249bead6832$var$voidLeft(args.handleAction(v.value0))(v.value1);
        if (v instanceof $5573693fd45dda6e$export$62297b13309008b2) return $6ceb47448afaefc1$export$1088317934ed5679(function(g) {
            var $45 = $02809249bead6832$var$map($h2xUu.maybe(v.value1($2jM6U.unit))(g));
            return function($46) {
                return $45(args.handleQuery($46));
            };
        })(v.value0);
        throw new Error("Failed pattern match at Halogen.Component (line 182, column 15 - line 192, column 71): " + [
            v.constructor.name
        ]);
    };
};
var $02809249bead6832$export$89c807d7ece13702 = $k2DSm.unsafeCoerce;
var $02809249bead6832$export$3bb93a8213d3ef21 = $k2DSm.unsafeCoerce;
var $02809249bead6832$export$6294a7576a4b06c3 = function(dictFunctor) {
    return function(nat) {
        return function(v) {
            if (v instanceof $02809249bead6832$export$bbf8b056cc92e88d) return $02809249bead6832$export$48f0293959eb16ec(function(slot) {
                return new $02809249bead6832$export$bbf8b056cc92e88d($02809249bead6832$export$89c807d7ece13702({
                    get: slot.get,
                    pop: slot.pop,
                    set: slot.set,
                    input: slot.input,
                    output: slot.output,
                    component: $02809249bead6832$export$b2cccb4e0928a3a6(dictFunctor)(nat)(slot.component)
                }));
            })(v.value0);
            if (v instanceof $02809249bead6832$export$5e46cfa5e835a582) return new $02809249bead6832$export$5e46cfa5e835a582($ea9a396fdac62c85$export$b2cccb4e0928a3a6($02809249bead6832$var$lmap($02809249bead6832$export$6294a7576a4b06c3(dictFunctor)(nat)))(v.value0));
            throw new Error("Failed pattern match at Halogen.Component (line 279, column 17 - line 284, column 53): " + [
                v.constructor.name
            ]);
        };
    };
};
var $02809249bead6832$export$b2cccb4e0928a3a6 = function(dictFunctor) {
    var hoist1 = $497deb56c643077e$export$b2cccb4e0928a3a6(dictFunctor);
    return function(nat) {
        return $02809249bead6832$export$802c6b8ce0f42195(function(c) {
            return $02809249bead6832$export$3bb93a8213d3ef21({
                initialState: c.initialState,
                render: function() {
                    var $47 = $02809249bead6832$var$lmap($02809249bead6832$export$6294a7576a4b06c3(dictFunctor)(nat));
                    return function($48) {
                        return $47(c.render($48));
                    };
                }(),
                "eval": function() {
                    var $49 = hoist1(nat);
                    return function($50) {
                        return $49(c["eval"]($50));
                    };
                }()
            });
        });
    };
};
var $02809249bead6832$export$ed5606d1e76f4b8b = {
    map: function(f) {
        return $02809249bead6832$export$48f0293959eb16ec(function(slot) {
            return $02809249bead6832$export$89c807d7ece13702({
                get: slot.get,
                pop: slot.pop,
                set: slot.set,
                component: slot.component,
                input: slot.input,
                output: $02809249bead6832$var$map1($02809249bead6832$var$map2(f))(slot.output)
            });
        });
    }
};
var $02809249bead6832$var$map3 = /* #__PURE__ */ $7FzSN.map($02809249bead6832$export$ed5606d1e76f4b8b);
var $02809249bead6832$export$e299aa0f47209936 = {
    map: function(f) {
        return function(v) {
            if (v instanceof $02809249bead6832$export$bbf8b056cc92e88d) return new $02809249bead6832$export$bbf8b056cc92e88d($02809249bead6832$var$map3(f)(v.value0));
            if (v instanceof $02809249bead6832$export$5e46cfa5e835a582) return new $02809249bead6832$export$5e46cfa5e835a582($ea9a396fdac62c85$export$ad7ceecc341abc7e($02809249bead6832$var$bimap($7FzSN.map($02809249bead6832$export$e299aa0f47209936)(f))(f))(v.value0));
            throw new Error("Failed pattern match at Halogen.Component (line 209, column 11 - line 211, column 74): " + [
                v.constructor.name
            ]);
        };
    }
};
var $02809249bead6832$export$cb95887a94082d64 = /* #__PURE__ */ function() {
    return {
        handleAction: $jhsiw.const($02809249bead6832$var$pure($2jM6U.unit)),
        handleQuery: $jhsiw.const($02809249bead6832$var$pure($h2xUu.Nothing.value)),
        receive: $jhsiw.const($h2xUu.Nothing.value),
        initialize: $h2xUu.Nothing.value,
        finalize: $h2xUu.Nothing.value
    };
}();
var $02809249bead6832$export$f7e7e2efed606f4a = function() {
    return function(dictIsSymbol) {
        var lookup1 = $02809249bead6832$var$lookup(dictIsSymbol);
        var pop1 = $02809249bead6832$var$pop(dictIsSymbol);
        var insert1 = $02809249bead6832$var$insert(dictIsSymbol);
        return function(dictOrd) {
            var lookup2 = lookup1(dictOrd);
            var pop2 = pop1(dictOrd);
            var insert2 = insert1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(comp) {
                        return function(input) {
                            return function(output) {
                                return $02809249bead6832$export$89c807d7ece13702({
                                    get: lookup2(label)(p),
                                    pop: pop2(label)(p),
                                    set: insert2(label)(p),
                                    component: comp,
                                    input: input,
                                    output: output
                                });
                            };
                        };
                    };
                };
            };
        };
    };
};



// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $h2xUu = parcelRequire("h2xUu");


var $1c3406d2030e9515$var$pure = /* #__PURE__ */ $bQdkN.pure($h2xUu.applicativeMaybe);
var $1c3406d2030e9515$export$f4752d802d3c730b = function(ctor) {
    return function(children) {
        var v = ctor([]);
        if (v instanceof $ee7eb0766a1d7549$export$cc2832fafe367c5e) return new $ee7eb0766a1d7549$export$bade370ab89110b(v.value0, v.value1, v.value2, children);
        return v;
    };
};
var $1c3406d2030e9515$export$f691a8759658f782 = function(ctor) {
    return function(props) {
        return function(children) {
            var v = ctor(props)([]);
            if (v instanceof $ee7eb0766a1d7549$export$cc2832fafe367c5e) return new $ee7eb0766a1d7549$export$bade370ab89110b(v.value0, v.value1, v.value2, children);
            return v;
        };
    };
};
var $1c3406d2030e9515$export$8a24d5472c669cc1 = function($14) {
    return $9aad5dc74ea3040c$export$8dbf9c790527241e($1c3406d2030e9515$var$pure($14));
};
var $1c3406d2030e9515$export$8dbf9c790527241e = /* #__PURE__ */ function() {
    return $9aad5dc74ea3040c$export$8dbf9c790527241e($h2xUu.Nothing.value);
}();
var $1c3406d2030e9515$export$cba2bb7f1b8927c4 = function($15) {
    return $9aad5dc74ea3040c$export$8454457683f90105($1c3406d2030e9515$var$pure($15));
};
var $1c3406d2030e9515$export$8454457683f90105 = /* #__PURE__ */ function() {
    return $9aad5dc74ea3040c$export$8454457683f90105($h2xUu.Nothing.value);
}();
var $1c3406d2030e9515$export$c63c6f932822f543 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("em");
var $1c3406d2030e9515$export$a5c38c2752f1223a = /* #__PURE__ */ $1c3406d2030e9515$export$c63c6f932822f543([]);
var $1c3406d2030e9515$export$2be46bb7e96db87f = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("embed");
var $1c3406d2030e9515$export$b53e7b77250f04f9 = /* #__PURE__ */ $1c3406d2030e9515$export$2be46bb7e96db87f([]);
var $1c3406d2030e9515$export$a38812d1aa1302d9 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("fieldset");
var $1c3406d2030e9515$export$2dc1b8d0924efe56 = /* #__PURE__ */ $1c3406d2030e9515$export$a38812d1aa1302d9([]);
var $1c3406d2030e9515$export$b75acb72a9c69c26 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("figcaption");
var $1c3406d2030e9515$export$60dfbef68b872a19 = /* #__PURE__ */ $1c3406d2030e9515$export$b75acb72a9c69c26([]);
var $1c3406d2030e9515$export$991dc94f816a1d48 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("figure");
var $1c3406d2030e9515$export$e3500458218031e0 = /* #__PURE__ */ $1c3406d2030e9515$export$991dc94f816a1d48([]);
var $1c3406d2030e9515$export$adb608be33961c98 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("footer");
var $1c3406d2030e9515$export$70a8ff4564bfd029 = /* #__PURE__ */ $1c3406d2030e9515$export$adb608be33961c98([]);
var $1c3406d2030e9515$export$6210fa4921d2a466 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("form");
var $1c3406d2030e9515$export$1df82cba65ddbdc7 = /* #__PURE__ */ $1c3406d2030e9515$export$6210fa4921d2a466([]);
var $1c3406d2030e9515$export$448e4850cad7c7b0 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("h1");
var $1c3406d2030e9515$export$762b01c17cd5ef84 = /* #__PURE__ */ $1c3406d2030e9515$export$448e4850cad7c7b0([]);
var $1c3406d2030e9515$export$a943aa9a0fca3f0b = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("h2");
var $1c3406d2030e9515$export$fb9cd428790d91ac = /* #__PURE__ */ $1c3406d2030e9515$export$a943aa9a0fca3f0b([]);
var $1c3406d2030e9515$export$7edd4a21fac8ce55 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("h3");
var $1c3406d2030e9515$export$d3f2bf86163ce5b1 = /* #__PURE__ */ $1c3406d2030e9515$export$7edd4a21fac8ce55([]);
var $1c3406d2030e9515$export$51a85cc1b68f452c = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("h4");
var $1c3406d2030e9515$export$44266b9d6c80e925 = /* #__PURE__ */ $1c3406d2030e9515$export$51a85cc1b68f452c([]);
var $1c3406d2030e9515$export$f44841a11990acb2 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("h5");
var $1c3406d2030e9515$export$29e7034271223ef2 = /* #__PURE__ */ $1c3406d2030e9515$export$f44841a11990acb2([]);
var $1c3406d2030e9515$export$c9ccd321d64f47e3 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("h6");
var $1c3406d2030e9515$export$454ef0c5c33a2870 = /* #__PURE__ */ $1c3406d2030e9515$export$c9ccd321d64f47e3([]);
var $1c3406d2030e9515$export$5fd5031fecdacec3 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("head");
var $1c3406d2030e9515$export$1139b773e3687c26 = /* #__PURE__ */ $1c3406d2030e9515$export$5fd5031fecdacec3([]);
var $1c3406d2030e9515$export$38e42c68cf43b5d4 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("header");
var $1c3406d2030e9515$export$8bf7349458487350 = /* #__PURE__ */ $1c3406d2030e9515$export$38e42c68cf43b5d4([]);
var $1c3406d2030e9515$export$b4adb3f464574dcf = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("hr")(props)([]);
};
var $1c3406d2030e9515$export$d5ef68f9e25856a2 = /* #__PURE__ */ $1c3406d2030e9515$export$b4adb3f464574dcf([]);
var $1c3406d2030e9515$export$c0bb0b647f701bb5 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("html");
var $1c3406d2030e9515$export$435678c2016b20e2 = /* #__PURE__ */ $1c3406d2030e9515$export$c0bb0b647f701bb5([]);
var $1c3406d2030e9515$export$23f2a1d2818174ef = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("i");
var $1c3406d2030e9515$export$3d4cba5f342e903e = /* #__PURE__ */ $1c3406d2030e9515$export$23f2a1d2818174ef([]);
var $1c3406d2030e9515$export$8cde213409fd6377 = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("iframe")(props)([]);
};
var $1c3406d2030e9515$export$463b44d9bf3628be = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("img")(props)([]);
};
var $1c3406d2030e9515$export$b7e3ae3d7c15e42e = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("input")(props)([]);
};
var $1c3406d2030e9515$export$27a48efc044c200a = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("ins");
var $1c3406d2030e9515$export$be13014404ffcf2b = /* #__PURE__ */ $1c3406d2030e9515$export$27a48efc044c200a([]);
var $1c3406d2030e9515$export$1ed45b69d23c052b = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("kbd");
var $1c3406d2030e9515$export$4a6534c938817498 = /* #__PURE__ */ $1c3406d2030e9515$export$1ed45b69d23c052b([]);
var $1c3406d2030e9515$export$1237798dc640739a = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("label");
var $1c3406d2030e9515$export$71f1ceb3290c95d7 = /* #__PURE__ */ $1c3406d2030e9515$export$1237798dc640739a([]);
var $1c3406d2030e9515$export$9a9b59e08de24cef = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("legend");
var $1c3406d2030e9515$export$d57b7c1bdf9a3bfc = /* #__PURE__ */ $1c3406d2030e9515$export$9a9b59e08de24cef([]);
var $1c3406d2030e9515$export$19caeaf7d9d84644 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("li");
var $1c3406d2030e9515$export$867ad32b190d58af = /* #__PURE__ */ $1c3406d2030e9515$export$19caeaf7d9d84644([]);
var $1c3406d2030e9515$export$9c30223ca0a664fb = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("link")(props)([]);
};
var $1c3406d2030e9515$export$f22da7240b7add18 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("main");
var $1c3406d2030e9515$export$88d8d81b07aa78ac = /* #__PURE__ */ $1c3406d2030e9515$export$f22da7240b7add18([]);
var $1c3406d2030e9515$export$871de8747c9eaa88 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("map");
var $1c3406d2030e9515$export$aca8cce159e578de = /* #__PURE__ */ $1c3406d2030e9515$export$871de8747c9eaa88([]);
var $1c3406d2030e9515$export$bf7f2fce5c1cf636 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("mark");
var $1c3406d2030e9515$export$8e88f701cd5c1522 = /* #__PURE__ */ $1c3406d2030e9515$export$bf7f2fce5c1cf636([]);
var $1c3406d2030e9515$export$b1e5508a851be14d = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("menu");
var $1c3406d2030e9515$export$d18229b57986002 = /* #__PURE__ */ $1c3406d2030e9515$export$b1e5508a851be14d([]);
var $1c3406d2030e9515$export$f68e44d881264486 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("menuitem");
var $1c3406d2030e9515$export$e25e9f3e172962c6 = /* #__PURE__ */ $1c3406d2030e9515$export$f68e44d881264486([]);
var $1c3406d2030e9515$export$6990040ee07315 = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("meta")(props)([]);
};
var $1c3406d2030e9515$export$82334bbdfcebb57 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("meter");
var $1c3406d2030e9515$export$86fa78168c2ac21a = /* #__PURE__ */ $1c3406d2030e9515$export$82334bbdfcebb57([]);
var $1c3406d2030e9515$export$80e4b313e5e6b30d = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("nav");
var $1c3406d2030e9515$export$5c8b9c326353f574 = /* #__PURE__ */ $1c3406d2030e9515$export$80e4b313e5e6b30d([]);
var $1c3406d2030e9515$export$528ba0e6da49e146 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("noscript");
var $1c3406d2030e9515$export$6d2a3f75abf3cf2f = /* #__PURE__ */ $1c3406d2030e9515$export$528ba0e6da49e146([]);
var $1c3406d2030e9515$export$be5493f9613cbbe = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("object");
var $1c3406d2030e9515$export$5486b676036981c0 = /* #__PURE__ */ $1c3406d2030e9515$export$be5493f9613cbbe([]);
var $1c3406d2030e9515$export$b2235297ee22a6fe = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("ol");
var $1c3406d2030e9515$export$ccd58f56d982d30 = /* #__PURE__ */ $1c3406d2030e9515$export$b2235297ee22a6fe([]);
var $1c3406d2030e9515$export$b9d336f245a516e8 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("optgroup");
var $1c3406d2030e9515$export$5e41220970d85779 = /* #__PURE__ */ $1c3406d2030e9515$export$b9d336f245a516e8([]);
var $1c3406d2030e9515$export$a75d1723e6bda2ec = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("option");
var $1c3406d2030e9515$export$32e31af4e5fb3144 = /* #__PURE__ */ $1c3406d2030e9515$export$a75d1723e6bda2ec([]);
var $1c3406d2030e9515$export$c789db2c85949867 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("output");
var $1c3406d2030e9515$export$8874a395de964196 = /* #__PURE__ */ $1c3406d2030e9515$export$c789db2c85949867([]);
var $1c3406d2030e9515$export$ffb5f4729a158638 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("p");
var $1c3406d2030e9515$export$3950a0ab4293f4c0 = /* #__PURE__ */ $1c3406d2030e9515$export$ffb5f4729a158638([]);
var $1c3406d2030e9515$export$6f7d1d9d04558207 = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("param")(props)([]);
};
var $1c3406d2030e9515$export$2af2ac64526e2aa9 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("pre");
var $1c3406d2030e9515$export$40eb7481a9b1d565 = /* #__PURE__ */ $1c3406d2030e9515$export$2af2ac64526e2aa9([]);
var $1c3406d2030e9515$export$504d7abb21fa8c9 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("progress");
var $1c3406d2030e9515$export$c56c869b2fd24a27 = /* #__PURE__ */ $1c3406d2030e9515$export$504d7abb21fa8c9([]);
var $1c3406d2030e9515$export$9e5f44173e64f162 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("q");
var $1c3406d2030e9515$export$cfeebac18d15c854 = /* #__PURE__ */ $1c3406d2030e9515$export$9e5f44173e64f162([]);
var $1c3406d2030e9515$export$6d4c73e3ddf8818b = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("rp");
var $1c3406d2030e9515$export$16adec6ab929083f = /* #__PURE__ */ $1c3406d2030e9515$export$6d4c73e3ddf8818b([]);
var $1c3406d2030e9515$export$f08282231bb71285 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("rt");
var $1c3406d2030e9515$export$512c1f41f1ce606b = /* #__PURE__ */ $1c3406d2030e9515$export$f08282231bb71285([]);
var $1c3406d2030e9515$export$f2b283820b448b35 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("ruby");
var $1c3406d2030e9515$export$8e70c3d96e82daa8 = /* #__PURE__ */ $1c3406d2030e9515$export$f2b283820b448b35([]);
var $1c3406d2030e9515$export$8c1cb8fb6818c292 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("samp");
var $1c3406d2030e9515$export$6d135438f4b2f058 = /* #__PURE__ */ $1c3406d2030e9515$export$8c1cb8fb6818c292([]);
var $1c3406d2030e9515$export$bc237d627614fc48 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("script");
var $1c3406d2030e9515$export$dc29c33250ef6a12 = /* #__PURE__ */ $1c3406d2030e9515$export$bc237d627614fc48([]);
var $1c3406d2030e9515$export$fe2e36411d703b3d = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("section");
var $1c3406d2030e9515$export$23973f3de41ad862 = /* #__PURE__ */ $1c3406d2030e9515$export$fe2e36411d703b3d([]);
var $1c3406d2030e9515$export$2e6c959c16ff56b8 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("select");
var $1c3406d2030e9515$export$626530082bbb6846 = /* #__PURE__ */ $1c3406d2030e9515$export$2e6c959c16ff56b8([]);
var $1c3406d2030e9515$export$3c17b0e969a90510 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("small");
var $1c3406d2030e9515$export$7c956911267b1bca = /* #__PURE__ */ $1c3406d2030e9515$export$3c17b0e969a90510([]);
var $1c3406d2030e9515$export$b4d5da5f34fb77ad = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("source")(props)([]);
};
var $1c3406d2030e9515$export$afc1bfabebaf28a2 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("span");
var $1c3406d2030e9515$export$727654ffe296bd78 = /* #__PURE__ */ $1c3406d2030e9515$export$afc1bfabebaf28a2([]);
var $1c3406d2030e9515$export$59ae2c325a998f89 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("strong");
var $1c3406d2030e9515$export$e4a9f9f4befb34d3 = /* #__PURE__ */ $1c3406d2030e9515$export$59ae2c325a998f89([]);
var $1c3406d2030e9515$export$1d567c320f4763bc = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("style");
var $1c3406d2030e9515$export$91f114121fd8ef96 = /* #__PURE__ */ $1c3406d2030e9515$export$1d567c320f4763bc([]);
var $1c3406d2030e9515$export$f93b5905241a7cca = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("sub");
var $1c3406d2030e9515$export$1b578d76e1a8b229 = /* #__PURE__ */ $1c3406d2030e9515$export$f93b5905241a7cca([]);
var $1c3406d2030e9515$export$9a2dbef7a17e2e58 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("summary");
var $1c3406d2030e9515$export$2107ebccf1a0ff3d = /* #__PURE__ */ $1c3406d2030e9515$export$9a2dbef7a17e2e58([]);
var $1c3406d2030e9515$export$abe1cd54efe9b9cd = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("sup");
var $1c3406d2030e9515$export$2ed99a076908dcca = /* #__PURE__ */ $1c3406d2030e9515$export$abe1cd54efe9b9cd([]);
var $1c3406d2030e9515$export$9852986a3ec5f6a0 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("table");
var $1c3406d2030e9515$export$67d0d859a50d84a3 = /* #__PURE__ */ $1c3406d2030e9515$export$9852986a3ec5f6a0([]);
var $1c3406d2030e9515$export$7cdd536eaa8f163c = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("tbody");
var $1c3406d2030e9515$export$a78509387f11524c = /* #__PURE__ */ $1c3406d2030e9515$export$7cdd536eaa8f163c([]);
var $1c3406d2030e9515$export$2beef8af2014e5c6 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("td");
var $1c3406d2030e9515$export$bf83c8517c04b4f6 = /* #__PURE__ */ $1c3406d2030e9515$export$2beef8af2014e5c6([]);
var $1c3406d2030e9515$export$a3574df893ffa88d = function(es) {
    return $1c3406d2030e9515$export$8454457683f90105("textarea")(es)([]);
};
var $1c3406d2030e9515$export$9396b2f97a03ad14 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("tfoot");
var $1c3406d2030e9515$export$7f741d66040a80c8 = /* #__PURE__ */ $1c3406d2030e9515$export$9396b2f97a03ad14([]);
var $1c3406d2030e9515$export$d657bc098992a431 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("th");
var $1c3406d2030e9515$export$5e18a33d145a9a4c = /* #__PURE__ */ $1c3406d2030e9515$export$d657bc098992a431([]);
var $1c3406d2030e9515$export$e3f32a5920890b82 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("thead");
var $1c3406d2030e9515$export$e607565248beba15 = /* #__PURE__ */ $1c3406d2030e9515$export$e3f32a5920890b82([]);
var $1c3406d2030e9515$export$2da9be4cfdb689b1 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("time");
var $1c3406d2030e9515$export$cf828072303f47a1 = /* #__PURE__ */ $1c3406d2030e9515$export$2da9be4cfdb689b1([]);
var $1c3406d2030e9515$export$fb184b623420d9be = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("title");
var $1c3406d2030e9515$export$913d7d8b8f172930 = /* #__PURE__ */ $1c3406d2030e9515$export$fb184b623420d9be([]);
var $1c3406d2030e9515$export$72451b88a72ad9c2 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("tr");
var $1c3406d2030e9515$export$6645783692722b88 = /* #__PURE__ */ $1c3406d2030e9515$export$72451b88a72ad9c2([]);
var $1c3406d2030e9515$export$6b2a7d5132615086 = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("track")(props)([]);
};
var $1c3406d2030e9515$export$3b14a55fb2447963 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("u");
var $1c3406d2030e9515$export$cea9ae7324478a0a = /* #__PURE__ */ $1c3406d2030e9515$export$3b14a55fb2447963([]);
var $1c3406d2030e9515$export$b5023c870cb34848 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("ul");
var $1c3406d2030e9515$export$995bef5d59d32608 = /* #__PURE__ */ $1c3406d2030e9515$export$b5023c870cb34848([]);
var $1c3406d2030e9515$export$4732baac96d948aa = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("var");
var $1c3406d2030e9515$export$f6567ad6eb928d58 = /* #__PURE__ */ $1c3406d2030e9515$export$4732baac96d948aa([]);
var $1c3406d2030e9515$export$5f8d3589eb8441ca = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("video");
var $1c3406d2030e9515$export$aeb4f4e4f36fb9d9 = /* #__PURE__ */ $1c3406d2030e9515$export$5f8d3589eb8441ca([]);
var $1c3406d2030e9515$export$ee8f8f9447a35bdc = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("wbr")(props)([]);
};
var $1c3406d2030e9515$export$9198f9466fc833e = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("dt");
var $1c3406d2030e9515$export$eaec8774df2ce75c = /* #__PURE__ */ $1c3406d2030e9515$export$9198f9466fc833e([]);
var $1c3406d2030e9515$export$53d26b7a9a23d594 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("dl");
var $1c3406d2030e9515$export$e8817a08353617fb = /* #__PURE__ */ $1c3406d2030e9515$export$53d26b7a9a23d594([]);
var $1c3406d2030e9515$export$159d9494db57879b = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("div");
var $1c3406d2030e9515$export$3327f90baeaa2cb3 = /* #__PURE__ */ $1c3406d2030e9515$export$159d9494db57879b([]);
var $1c3406d2030e9515$export$518824cf31321346 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("dialog");
var $1c3406d2030e9515$export$95cd7f04cb5b4aa5 = /* #__PURE__ */ $1c3406d2030e9515$export$518824cf31321346([]);
var $1c3406d2030e9515$export$771f54d1a902afc9 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("dfn");
var $1c3406d2030e9515$export$afe13c5e7d9b4a7 = /* #__PURE__ */ $1c3406d2030e9515$export$771f54d1a902afc9([]);
var $1c3406d2030e9515$export$41ee12f6f6f05843 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("details");
var $1c3406d2030e9515$export$a47bcbad56ffd401 = /* #__PURE__ */ $1c3406d2030e9515$export$41ee12f6f6f05843([]);
var $1c3406d2030e9515$export$1d2f21e549771e67 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("del");
var $1c3406d2030e9515$export$965d9e1c56547986 = /* #__PURE__ */ $1c3406d2030e9515$export$1d2f21e549771e67([]);
var $1c3406d2030e9515$export$eaaeafa904fe3ddf = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("dd");
var $1c3406d2030e9515$export$333318a39958213e = /* #__PURE__ */ $1c3406d2030e9515$export$eaaeafa904fe3ddf([]);
var $1c3406d2030e9515$export$d6956b5f6d5ee87d = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("datalist");
var $1c3406d2030e9515$export$4479caebc8699400 = /* #__PURE__ */ $1c3406d2030e9515$export$d6956b5f6d5ee87d([]);
var $1c3406d2030e9515$export$ae50443ffc990749 = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("command")(props)([]);
};
var $1c3406d2030e9515$export$3db318dd257cd653 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("colgroup");
var $1c3406d2030e9515$export$4d89c25fc3dc3ce6 = /* #__PURE__ */ $1c3406d2030e9515$export$3db318dd257cd653([]);
var $1c3406d2030e9515$export$aba86695643891f5 = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("col")(props)([]);
};
var $1c3406d2030e9515$export$6565f9f03506010b = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("code");
var $1c3406d2030e9515$export$a82e8ec18d45f1e3 = /* #__PURE__ */ $1c3406d2030e9515$export$6565f9f03506010b([]);
var $1c3406d2030e9515$export$3035df57df42c31a = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("cite");
var $1c3406d2030e9515$export$4371c8153c03edbd = /* #__PURE__ */ $1c3406d2030e9515$export$3035df57df42c31a([]);
var $1c3406d2030e9515$export$8e3c2dfdc4f0453d = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("caption");
var $1c3406d2030e9515$export$63f9754c9b1fac36 = /* #__PURE__ */ $1c3406d2030e9515$export$8e3c2dfdc4f0453d([]);
var $1c3406d2030e9515$export$67ea982130081db = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("canvas")(props)([]);
};
var $1c3406d2030e9515$export$2ba01fb71ed41cb6 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("button");
var $1c3406d2030e9515$export$ff362f92cc25e36a = /* #__PURE__ */ $1c3406d2030e9515$export$2ba01fb71ed41cb6([]);
var $1c3406d2030e9515$export$479ac0420f53ed26 = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("br")(props)([]);
};
var $1c3406d2030e9515$export$73cdcb65e5517a4b = /* #__PURE__ */ $1c3406d2030e9515$export$479ac0420f53ed26([]);
var $1c3406d2030e9515$export$32180ef41b15b513 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("body");
var $1c3406d2030e9515$export$72fbd758d159fe4b = /* #__PURE__ */ $1c3406d2030e9515$export$32180ef41b15b513([]);
var $1c3406d2030e9515$export$67dc04e652a298ca = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("blockquote");
var $1c3406d2030e9515$export$3b176ffafe2ecb0b = /* #__PURE__ */ $1c3406d2030e9515$export$67dc04e652a298ca([]);
var $1c3406d2030e9515$export$fae0db89ef70aab2 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("bdo");
var $1c3406d2030e9515$export$e57ac2b1cb1a62e1 = /* #__PURE__ */ $1c3406d2030e9515$export$fae0db89ef70aab2([]);
var $1c3406d2030e9515$export$2d20a4e9df674436 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("bdi");
var $1c3406d2030e9515$export$f5459c7588d93378 = /* #__PURE__ */ $1c3406d2030e9515$export$2d20a4e9df674436([]);
var $1c3406d2030e9515$export$e2253033e6e1df16 = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("base")(props)([]);
};
var $1c3406d2030e9515$export$8b22cf2602fb60ce = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("b");
var $1c3406d2030e9515$export$c69d65aa55814164 = /* #__PURE__ */ $1c3406d2030e9515$export$8b22cf2602fb60ce([]);
var $1c3406d2030e9515$export$592b77e6034db746 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("audio");
var $1c3406d2030e9515$export$610b618347792e57 = /* #__PURE__ */ $1c3406d2030e9515$export$592b77e6034db746([]);
var $1c3406d2030e9515$export$64a02cd6422b91be = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("aside");
var $1c3406d2030e9515$export$a3ab01131aa7ecca = /* #__PURE__ */ $1c3406d2030e9515$export$64a02cd6422b91be([]);
var $1c3406d2030e9515$export$bba2aacf8566461b = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("article");
var $1c3406d2030e9515$export$1cb8fa25968bee4e = /* #__PURE__ */ $1c3406d2030e9515$export$bba2aacf8566461b([]);
var $1c3406d2030e9515$export$bb3edc44842b5f2e = function(props) {
    return $1c3406d2030e9515$export$8454457683f90105("area")(props)([]);
};
var $1c3406d2030e9515$export$f7d3c097ceca6c15 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("address");
var $1c3406d2030e9515$export$acfbe12b190f4a67 = /* #__PURE__ */ $1c3406d2030e9515$export$f7d3c097ceca6c15([]);
var $1c3406d2030e9515$export$2bcb785951133fe5 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("abbr");
var $1c3406d2030e9515$export$b4f279e367d2ba24 = /* #__PURE__ */ $1c3406d2030e9515$export$2bcb785951133fe5([]);
var $1c3406d2030e9515$export$407448d2b89b1813 = /* #__PURE__ */ $1c3406d2030e9515$export$8454457683f90105("a");
var $1c3406d2030e9515$export$a17c37559e1db147 = /* #__PURE__ */ $1c3406d2030e9515$export$407448d2b89b1813([]);


// Generated by purs version 0.15.16

var $cADnC = parcelRequire("cADnC");
// Generated by purs version 0.15.16



var $8pkky = parcelRequire("8pkky");

var $46y1S = parcelRequire("46y1S");
var $4abdadcc053fc40e$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $4abdadcc053fc40e$export$64f3cd24d850d401 = /* #__PURE__ */ $2603701dab447006$export$998a9a780731dd5b($8pkky.functorIdentity);
var $4abdadcc053fc40e$export$a25b8a8a37f2d1cd = function($3) {
    return $4abdadcc053fc40e$var$unwrap($2603701dab447006$export$8291c2122093ac93($3));
};
var $4abdadcc053fc40e$export$8e638b2c22277c65 = function(f) {
    return $2603701dab447006$export$34cbd9fbda5c1fb2(function($4) {
        return $8pkky.Identity(f($4abdadcc053fc40e$var$unwrap($4)));
    });
};




var $beQI1 = parcelRequire("beQI1");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $8pkky = parcelRequire("8pkky");

var $h2xUu = parcelRequire("h2xUu");

var $goKHx = parcelRequire("goKHx");


// Generated by purs version 0.15.16
function $5b97d432603a031f$export$209a9e76e7f1bdd5(f, s, key, value) {
    return value == null ? f : s(value[key]);
}
function $5b97d432603a031f$export$2c522840c892e8a(prop, value) {
    return Object.prototype.hasOwnProperty.call(value, prop);
}
function $5b97d432603a031f$export$c3f84ec7467d28a0(prop, value) {
    return prop in value;
}



var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");


var $jhsiw = parcelRequire("jhsiw");

var $cb11cd860858d6db$var$unsafeReadProp = function(dictMonad) {
    var fail = $3159c1316ac7a043$export$2b62a06a9fee979c(dictMonad);
    var pure = $bQdkN.pure($2603701dab447006$export$963960a96c103d2f(dictMonad));
    return function(k) {
        return function(value) {
            return $5b97d432603a031f$export$209a9e76e7f1bdd5(fail(new $3159c1316ac7a043$export$168e2d3b16829a("object", $bbd1c096e2c7f227$export$f5bbd400c2f4426f(value))), pure, k, value);
        };
    };
};
var $cb11cd860858d6db$export$d133c026d013828b = function(dictMonad) {
    return $cb11cd860858d6db$var$unsafeReadProp(dictMonad);
};
var $cb11cd860858d6db$export$49ec5109fafd7888 = function(dictMonad) {
    return $cb11cd860858d6db$var$unsafeReadProp(dictMonad);
};
var $cb11cd860858d6db$export$bc3518d3f65cefd1 = function(dict) {
    return dict.ix;
};
var $cb11cd860858d6db$export$b610b8812bbcded9 = function(dict) {
    return dict.index;
};
var $cb11cd860858d6db$export$8e083630a1c429e2 = function(dictMonad) {
    var bindFlipped = $cADnC.bindFlipped($2603701dab447006$export$a8cbc0f84e8b069b(dictMonad));
    return {
        ix: function(dictIndex) {
            var index1 = $cb11cd860858d6db$export$b610b8812bbcded9(dictIndex);
            return function(f) {
                return function(i) {
                    return bindFlipped($jhsiw.flip(index1)(i))(f);
                };
            };
        }
    };
};
var $cb11cd860858d6db$export$5603d6456559ad27 = function(dictMonad) {
    return {
        ix: function(dictIndex) {
            return $cb11cd860858d6db$export$b610b8812bbcded9(dictIndex);
        }
    };
};
var $cb11cd860858d6db$var$hasPropertyImpl = function(v) {
    return function(v1) {
        if ($bbd1c096e2c7f227$export$630801d484da15df(v1)) return false;
        if ($bbd1c096e2c7f227$export$fce6876652108ab(v1)) return false;
        if ($bbd1c096e2c7f227$export$f5bbd400c2f4426f(v1) === "object" || $bbd1c096e2c7f227$export$f5bbd400c2f4426f(v1) === "function") return $5b97d432603a031f$export$c3f84ec7467d28a0(v, v1);
        return false;
    };
};
var $cb11cd860858d6db$export$bf9617eaf5d2451 = function(dict) {
    return dict.hasProperty;
};
var $cb11cd860858d6db$var$hasOwnPropertyImpl = function(v) {
    return function(v1) {
        if ($bbd1c096e2c7f227$export$630801d484da15df(v1)) return false;
        if ($bbd1c096e2c7f227$export$fce6876652108ab(v1)) return false;
        if ($bbd1c096e2c7f227$export$f5bbd400c2f4426f(v1) === "object" || $bbd1c096e2c7f227$export$f5bbd400c2f4426f(v1) === "function") return $5b97d432603a031f$export$2c522840c892e8a(v, v1);
        return false;
    };
};
var $cb11cd860858d6db$export$27e041b47b0d7594 = function(dictMonad) {
    return {
        index: $jhsiw.flip($cb11cd860858d6db$export$49ec5109fafd7888(dictMonad)),
        hasProperty: $cb11cd860858d6db$var$hasPropertyImpl,
        hasOwnProperty: $cb11cd860858d6db$var$hasOwnPropertyImpl,
        errorAt: $3159c1316ac7a043$export$20d9a5af040a79f1.create
    };
};
var $cb11cd860858d6db$export$d60c33947aba4299 = function(dictMonad) {
    return {
        index: $jhsiw.flip($cb11cd860858d6db$export$d133c026d013828b(dictMonad)),
        hasProperty: $cb11cd860858d6db$var$hasPropertyImpl,
        hasOwnProperty: $cb11cd860858d6db$var$hasOwnPropertyImpl,
        errorAt: $3159c1316ac7a043$export$92e5795aa905bd26.create
    };
};
var $cb11cd860858d6db$export$5a15a386532a5ea4 = function(dict) {
    return dict.hasOwnProperty;
};
var $cb11cd860858d6db$export$6917a1a7c5a9c9cc = function(dict) {
    return dict.errorAt;
};





var $k2DSm = parcelRequire("k2DSm");
// Generated by purs version 0.15.16
var $9013c55960c128a5$export$9b6706c8686cfc8e = "paste";
var $9013c55960c128a5$export$af2a99f971a346e6 = "cut";
var $9013c55960c128a5$export$784d13d8ee351f07 = "copy";
var $9013c55960c128a5$export$82e583f9eee21106 = "clipboardchange";


// Generated by purs version 0.15.16
function $504de085a7e19c80$export$a0e54c3daa7db493(e) {
    return e.bubbles;
}
function $504de085a7e19c80$export$95ff25b64c2b7c9d(e) {
    return e.cancelable;
}
function $504de085a7e19c80$export$c2cb7a6607e209d9(e) {
    return e.currentTarget;
}
function $504de085a7e19c80$export$6add31d873bb7f97(e) {
    return function() {
        return e.defaultPrevented;
    };
}
function $504de085a7e19c80$export$751396ee394cb35f(e) {
    return e.eventPhase;
}
function $504de085a7e19c80$export$e2c9f5456eee864(e) {
    return e.target;
}
function $504de085a7e19c80$export$c0dbb1ea68a069d3(e) {
    return e.timeStamp;
}
function $504de085a7e19c80$export$d4a6a4db5b31e621(e) {
    return e.type;
}
function $504de085a7e19c80$export$fa3b29edae795ef4(e) {
    return function() {
        return e.preventDefault();
    };
}
function $504de085a7e19c80$export$d5cb5f1c8a62fdf1(e) {
    return function() {
        return e.stopImmediatePropagation();
    };
}
function $504de085a7e19c80$export$51134cce184326b9(e) {
    return function() {
        return e.stopPropagation();
    };
}



var $dIXGo = parcelRequire("dIXGo");

var $aJhEx = parcelRequire("aJhEx");

var $h2xUu = parcelRequire("h2xUu");


var $gwBF5 = parcelRequire("gwBF5");
// Generated by purs version 0.15.16

var $dIXGo = parcelRequire("dIXGo");

var $h2xUu = parcelRequire("h2xUu");

var $ibsD5 = parcelRequire("ibsD5");
var $aa6f1f33e251d8ec$export$57ca7e07b341709d = /* #__PURE__ */ function() {
    function None() {}
    None.value = new None();
    return None;
}();
var $aa6f1f33e251d8ec$export$7c1f271456e9da5c = /* #__PURE__ */ function() {
    function Capturing() {}
    Capturing.value = new Capturing();
    return Capturing;
}();
var $aa6f1f33e251d8ec$export$c9dfa296ffa718f3 = /* #__PURE__ */ function() {
    function AtTarget() {}
    AtTarget.value = new AtTarget();
    return AtTarget;
}();
var $aa6f1f33e251d8ec$export$afda6610fd3be704 = /* #__PURE__ */ function() {
    function Bubbling() {}
    Bubbling.value = new Bubbling();
    return Bubbling;
}();
var $aa6f1f33e251d8ec$export$87e393cb260cfe35 = function(v) {
    if (v === 0) return new $h2xUu.Just($aa6f1f33e251d8ec$export$57ca7e07b341709d.value);
    if (v === 1) return new $h2xUu.Just($aa6f1f33e251d8ec$export$7c1f271456e9da5c.value);
    if (v === 2) return new $h2xUu.Just($aa6f1f33e251d8ec$export$c9dfa296ffa718f3.value);
    if (v === 3) return new $h2xUu.Just($aa6f1f33e251d8ec$export$afda6610fd3be704.value);
    return $h2xUu.Nothing.value;
};
var $aa6f1f33e251d8ec$export$bf52d9629dd54342 = function(v) {
    if (v instanceof $aa6f1f33e251d8ec$export$57ca7e07b341709d) return 0;
    if (v instanceof $aa6f1f33e251d8ec$export$7c1f271456e9da5c) return 1;
    if (v instanceof $aa6f1f33e251d8ec$export$c9dfa296ffa718f3) return 2;
    if (v instanceof $aa6f1f33e251d8ec$export$afda6610fd3be704) return 3;
    throw new Error("Failed pattern match at Web.Event.EventPhase (line 40, column 3 - line 44, column 18): " + [
        v.constructor.name
    ]);
};
var $aa6f1f33e251d8ec$export$e7849b249d968c7d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $aa6f1f33e251d8ec$export$57ca7e07b341709d && y instanceof $aa6f1f33e251d8ec$export$57ca7e07b341709d) return true;
            if (x instanceof $aa6f1f33e251d8ec$export$7c1f271456e9da5c && y instanceof $aa6f1f33e251d8ec$export$7c1f271456e9da5c) return true;
            if (x instanceof $aa6f1f33e251d8ec$export$c9dfa296ffa718f3 && y instanceof $aa6f1f33e251d8ec$export$c9dfa296ffa718f3) return true;
            if (x instanceof $aa6f1f33e251d8ec$export$afda6610fd3be704 && y instanceof $aa6f1f33e251d8ec$export$afda6610fd3be704) return true;
            return false;
        };
    }
};
var $aa6f1f33e251d8ec$export$2dff6326408f563 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $aa6f1f33e251d8ec$export$57ca7e07b341709d && y instanceof $aa6f1f33e251d8ec$export$57ca7e07b341709d) return $ibsD5.EQ.value;
            if (x instanceof $aa6f1f33e251d8ec$export$57ca7e07b341709d) return $ibsD5.LT.value;
            if (y instanceof $aa6f1f33e251d8ec$export$57ca7e07b341709d) return $ibsD5.GT.value;
            if (x instanceof $aa6f1f33e251d8ec$export$7c1f271456e9da5c && y instanceof $aa6f1f33e251d8ec$export$7c1f271456e9da5c) return $ibsD5.EQ.value;
            if (x instanceof $aa6f1f33e251d8ec$export$7c1f271456e9da5c) return $ibsD5.LT.value;
            if (y instanceof $aa6f1f33e251d8ec$export$7c1f271456e9da5c) return $ibsD5.GT.value;
            if (x instanceof $aa6f1f33e251d8ec$export$c9dfa296ffa718f3 && y instanceof $aa6f1f33e251d8ec$export$c9dfa296ffa718f3) return $ibsD5.EQ.value;
            if (x instanceof $aa6f1f33e251d8ec$export$c9dfa296ffa718f3) return $ibsD5.LT.value;
            if (y instanceof $aa6f1f33e251d8ec$export$c9dfa296ffa718f3) return $ibsD5.GT.value;
            if (x instanceof $aa6f1f33e251d8ec$export$afda6610fd3be704 && y instanceof $aa6f1f33e251d8ec$export$afda6610fd3be704) return $ibsD5.EQ.value;
            throw new Error("Failed pattern match at Web.Event.EventPhase (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $aa6f1f33e251d8ec$export$e7849b249d968c7d;
    }
};
var $aa6f1f33e251d8ec$export$1961ce3762a1f623 = {
    succ: /* #__PURE__ */ $dIXGo.defaultSucc($aa6f1f33e251d8ec$export$87e393cb260cfe35)($aa6f1f33e251d8ec$export$bf52d9629dd54342),
    pred: /* #__PURE__ */ $dIXGo.defaultPred($aa6f1f33e251d8ec$export$87e393cb260cfe35)($aa6f1f33e251d8ec$export$bf52d9629dd54342),
    Ord0: function() {
        return $aa6f1f33e251d8ec$export$2dff6326408f563;
    }
};
var $aa6f1f33e251d8ec$export$2c5501f89051a84e = /* #__PURE__ */ function() {
    return {
        bottom: $aa6f1f33e251d8ec$export$57ca7e07b341709d.value,
        top: $aa6f1f33e251d8ec$export$afda6610fd3be704.value,
        Ord0: function() {
            return $aa6f1f33e251d8ec$export$2dff6326408f563;
        }
    };
}();
var $aa6f1f33e251d8ec$export$9171e0cf0644640e = {
    cardinality: 4,
    toEnum: $aa6f1f33e251d8ec$export$87e393cb260cfe35,
    fromEnum: $aa6f1f33e251d8ec$export$bf52d9629dd54342,
    Bounded0: function() {
        return $aa6f1f33e251d8ec$export$2c5501f89051a84e;
    },
    Enum1: function() {
        return $aa6f1f33e251d8ec$export$1961ce3762a1f623;
    }
};



var $c0c6f03b458e5467$var$fromJust = /* #__PURE__ */ $h2xUu.fromJust();
var $c0c6f03b458e5467$var$toEnum = /* #__PURE__ */ $dIXGo.toEnum($aa6f1f33e251d8ec$export$9171e0cf0644640e);
var $c0c6f03b458e5467$export$3d7865934588d77e = function(x) {
    return x;
};
var $c0c6f03b458e5467$export$44271b4f0c6a3563 = function($3) {
    return $ae4217dcc85a7c03$export$1ba013b88f4f21f3($504de085a7e19c80$export$e2c9f5456eee864($3));
};
var $c0c6f03b458e5467$export$5c9c459b1e542b91 = $gwBF5.ordString;
var $c0c6f03b458e5467$export$bbde49cc37df068e = {
    Coercible0: function() {
        return undefined;
    }
};
var $c0c6f03b458e5467$export$adaf9bfc2029072d = function() {
    return function($4) {
        return $c0c6f03b458e5467$var$fromJust($c0c6f03b458e5467$var$toEnum($504de085a7e19c80$export$751396ee394cb35f($4)));
    };
};
var $c0c6f03b458e5467$export$521449dd33bc9b79 = $aJhEx.eqString;
var $c0c6f03b458e5467$export$28b27b1605aa05ad = function($5) {
    return $ae4217dcc85a7c03$export$1ba013b88f4f21f3($504de085a7e19c80$export$c2cb7a6607e209d9($5));
};


// Generated by purs version 0.15.16
function $aab52c07a8c57a68$export$f24224f1c91d8156(fileList) {
    return fileList.length;
}
function $aab52c07a8c57a68$export$613ce04884e90507(index) {
    return function(fileList) {
        return fileList.item(index);
    };
}



var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");


var $7O0Q4 = parcelRequire("7O0Q4");

var $goKHx = parcelRequire("goKHx");
var $cda3658848bcad16$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $cda3658848bcad16$export$7061c75fc5af8b7e = function(i) {
    var $5 = $aab52c07a8c57a68$export$613ce04884e90507(i);
    return function($6) {
        return $ae4217dcc85a7c03$export$1ba013b88f4f21f3($5($6));
    };
};
var $cda3658848bcad16$export$17a1664ed1fb5d6f = function(dictUnfoldable) {
    var unfoldr = $goKHx.unfoldr(dictUnfoldable);
    return function(fl) {
        return unfoldr(function(i) {
            return $cda3658848bcad16$var$map($jhsiw.flip($7O0Q4.Tuple.create)(i + 1 | 0))($cda3658848bcad16$export$7061c75fc5af8b7e(i)(fl));
        })(0);
    };
};


// Generated by purs version 0.15.16
var $efe52ca31e7b6d25$export$663103110d94aac9 = "drop";
var $efe52ca31e7b6d25$export$dc0badfde684823c = "dragstart";
var $efe52ca31e7b6d25$export$ced0a5bb82ba6aee = "dragover";
var $efe52ca31e7b6d25$export$f58195b0ad38aa36 = "dragleave";
var $efe52ca31e7b6d25$export$ddffa9b7b4c3e300 = "dragexit";
var $efe52ca31e7b6d25$export$bf1ba5dda238dc20 = "dragenter";
var $efe52ca31e7b6d25$export$26ae3c90d367ea9a = "dragend";
var $efe52ca31e7b6d25$export$d7d5d435647ed5a0 = "drag";




// Generated by purs version 0.15.16
var $ba69b19862258c3d$export$d0dc5134b51e78ad = "focusout";
var $ba69b19862258c3d$export$e7fa4ea7f1bfcb53 = "focusin";
var $ba69b19862258c3d$export$d7ddd398f22d79ef = "focus";
var $ba69b19862258c3d$export$2cc7ff91bcacba5e = "blur";


// Generated by purs version 0.15.16
var $c4a383d98fa96b18$export$d26052c770f81a55 = "keyup";
var $c4a383d98fa96b18$export$e65a0c4970da3025 = "keydown";


// Generated by purs version 0.15.16
var $40c699bfb3129585$export$c367b5bd9b361db9 = "mouseup";
var $40c699bfb3129585$export$41b161f130dc7f9 = "mouseover";
var $40c699bfb3129585$export$c3a736a37c400eb8 = "mouseout";
var $40c699bfb3129585$export$6d0a9e0f4f73830a = "mousemove";
var $40c699bfb3129585$export$996a190879e3098b = "mouseleave";
var $40c699bfb3129585$export$474cd8abd87e2f89 = "mouseenter";
var $40c699bfb3129585$export$8b0cb8993e7a9391 = "mousedown";
var $40c699bfb3129585$export$efb8dd8d61939266 = "dblclick";
var $40c699bfb3129585$export$64ef1bee2b9504c1 = "click";
var $40c699bfb3129585$export$2991dd47f111a03b = "auxclick";


// Generated by purs version 0.15.16
var $e09a75ec184a12b9$export$d3028820ea014224 = "wheel";


var $915100f592e460a1$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $915100f592e460a1$var$composeKleisli = /* #__PURE__ */ $cADnC.composeKleisli($h2xUu.bindMaybe);
var $915100f592e460a1$var$composeKleisliFlipped = /* #__PURE__ */ $cADnC.composeKleisliFlipped(/* #__PURE__ */ $2603701dab447006$export$a8cbc0f84e8b069b($8pkky.monadIdentity));
var $915100f592e460a1$var$readProp = /* #__PURE__ */ $cb11cd860858d6db$export$d133c026d013828b($8pkky.monadIdentity);
var $915100f592e460a1$var$readString = /* #__PURE__ */ $3159c1316ac7a043$export$dda73877cb166cd3($8pkky.monadIdentity);
var $915100f592e460a1$var$wheelHandler = $k2DSm.unsafeCoerce;
var $915100f592e460a1$var$touchHandler = $k2DSm.unsafeCoerce;
var $915100f592e460a1$var$mouseHandler = $k2DSm.unsafeCoerce;
var $915100f592e460a1$var$keyHandler = $k2DSm.unsafeCoerce;
var $915100f592e460a1$export$6b8360dd6fa5f18d = function(et) {
    return function(f) {
        return $9aad5dc74ea3040c$export$c3c52e219617878(et)(function(ev) {
            return $915100f592e460a1$var$map($e7ddcc4e56dd1e0b$export$e19cd5f9376f8cee.create)(f(ev));
        });
    };
};
var $915100f592e460a1$export$c3c52e219617878 = function(et) {
    return function(f) {
        return $9aad5dc74ea3040c$export$c3c52e219617878(et)(function(ev) {
            return new $h2xUu.Just(new $e7ddcc4e56dd1e0b$export$e19cd5f9376f8cee(f(ev)));
        });
    };
};
var $915100f592e460a1$export$d36091e57812e07 = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878("abort");
var $915100f592e460a1$export$81738f2b2c64902d = /* #__PURE__ */ function() {
    var $13 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$2991dd47f111a03b);
    return function($14) {
        return $13($915100f592e460a1$var$mouseHandler($14));
    };
}();
var $915100f592e460a1$export$bd913411069e59d3 = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878($c4fc5073d9256368$export$d8a7b8f475ec0161);
var $915100f592e460a1$export$1d5a917feb871989 = /* #__PURE__ */ function() {
    var $15 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$64ef1bee2b9504c1);
    return function($16) {
        return $15($915100f592e460a1$var$mouseHandler($16));
    };
}();
var $915100f592e460a1$export$12204e800775a4e0 = /* #__PURE__ */ function() {
    var $17 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$efb8dd8d61939266);
    return function($18) {
        return $17($915100f592e460a1$var$mouseHandler($18));
    };
}();
var $915100f592e460a1$export$2288787135a8f66e = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878($c4fc5073d9256368$export$a3bc9b8ed74fc);
var $915100f592e460a1$export$83b89249c82cb32b = function(dictUnfoldable) {
    var none = $goKHx.none(dictUnfoldable);
    var items = $cda3658848bcad16$export$17a1664ed1fb5d6f(dictUnfoldable);
    return function(f) {
        return $915100f592e460a1$export$c3c52e219617878($c4fc5073d9256368$export$d8a7b8f475ec0161)(function() {
            var $19 = $h2xUu.maybe(none)(items);
            var $20 = $915100f592e460a1$var$composeKleisli($c0c6f03b458e5467$export$44271b4f0c6a3563)($915100f592e460a1$var$composeKleisli($99a3508e76c01689$export$a0a0bf09b44710c9)(function($22) {
                return $b81e9b4392e02a01$export$c62839628b30a695($99a3508e76c01689$export$3a444357c5f65f65($22));
            }));
            return function($21) {
                return f($19($20($21)));
            };
        }());
    };
};
var $915100f592e460a1$export$7fbc06d7c1beb512 = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878($c4fc5073d9256368$export$b7e3ae3d7c15e42e);
var $915100f592e460a1$export$ea9576bc99d1b7dd = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878($c4fc5073d9256368$export$9f85add0327f687e);
var $915100f592e460a1$export$de8e1b1372cdb41b = /* #__PURE__ */ function() {
    var $23 = $915100f592e460a1$export$c3c52e219617878($c4a383d98fa96b18$export$e65a0c4970da3025);
    return function($24) {
        return $23($915100f592e460a1$var$keyHandler($24));
    };
}();
var $915100f592e460a1$export$f144bbb6e186b14b = /* #__PURE__ */ function() {
    var $25 = $915100f592e460a1$export$c3c52e219617878($c4a383d98fa96b18$export$d26052c770f81a55);
    return function($26) {
        return $25($915100f592e460a1$var$keyHandler($26));
    };
}();
var $915100f592e460a1$export$4e4d8b287d028b6b = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878($c4fc5073d9256368$export$11e63f7b0f3d9900);
var $915100f592e460a1$export$6b09a96aed3f5178 = /* #__PURE__ */ function() {
    var $27 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$8b0cb8993e7a9391);
    return function($28) {
        return $27($915100f592e460a1$var$mouseHandler($28));
    };
}();
var $915100f592e460a1$export$7c562fbb06b8dec3 = /* #__PURE__ */ function() {
    var $29 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$474cd8abd87e2f89);
    return function($30) {
        return $29($915100f592e460a1$var$mouseHandler($30));
    };
}();
var $915100f592e460a1$export$f06e70624327ed63 = /* #__PURE__ */ function() {
    var $31 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$996a190879e3098b);
    return function($32) {
        return $31($915100f592e460a1$var$mouseHandler($32));
    };
}();
var $915100f592e460a1$export$4e8e585ca96adf5d = /* #__PURE__ */ function() {
    var $33 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$6d0a9e0f4f73830a);
    return function($34) {
        return $33($915100f592e460a1$var$mouseHandler($34));
    };
}();
var $915100f592e460a1$export$65a11040da641544 = /* #__PURE__ */ function() {
    var $35 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$c3a736a37c400eb8);
    return function($36) {
        return $35($915100f592e460a1$var$mouseHandler($36));
    };
}();
var $915100f592e460a1$export$afc474fdab5e8a8e = /* #__PURE__ */ function() {
    var $37 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$41b161f130dc7f9);
    return function($38) {
        return $37($915100f592e460a1$var$mouseHandler($38));
    };
}();
var $915100f592e460a1$export$3df825bff4f0a835 = /* #__PURE__ */ function() {
    var $39 = $915100f592e460a1$export$c3c52e219617878($40c699bfb3129585$export$c367b5bd9b361db9);
    return function($40) {
        return $39($915100f592e460a1$var$mouseHandler($40));
    };
}();
var $915100f592e460a1$export$79fcb145cc53473e = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878("reset");
var $915100f592e460a1$export$45b39e67d4ce4921 = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878("resize");
var $915100f592e460a1$export$d4d89fd61e5416ee = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878("scroll");
var $915100f592e460a1$export$2cc8197d6ae5570 = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878($c4fc5073d9256368$export$2e6c959c16ff56b8);
var $915100f592e460a1$export$307d29742c654737 = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878("submit");
var $915100f592e460a1$export$931f312019b226f2 = /* #__PURE__ */ function() {
    var $41 = $915100f592e460a1$export$c3c52e219617878("touchcancel");
    return function($42) {
        return $41($915100f592e460a1$var$touchHandler($42));
    };
}();
var $915100f592e460a1$export$79b4bc20f2630414 = /* #__PURE__ */ function() {
    var $43 = $915100f592e460a1$export$c3c52e219617878("touchend");
    return function($44) {
        return $43($915100f592e460a1$var$touchHandler($44));
    };
}();
var $915100f592e460a1$export$e1ee796ca0d1f5fd = /* #__PURE__ */ function() {
    var $45 = $915100f592e460a1$export$c3c52e219617878("touchenter");
    return function($46) {
        return $45($915100f592e460a1$var$touchHandler($46));
    };
}();
var $915100f592e460a1$export$a8fb1c034c732052 = /* #__PURE__ */ function() {
    var $47 = $915100f592e460a1$export$c3c52e219617878("touchleave");
    return function($48) {
        return $47($915100f592e460a1$var$touchHandler($48));
    };
}();
var $915100f592e460a1$export$42c53271760d4595 = /* #__PURE__ */ function() {
    var $49 = $915100f592e460a1$export$c3c52e219617878("touchmove");
    return function($50) {
        return $49($915100f592e460a1$var$touchHandler($50));
    };
}();
var $915100f592e460a1$export$37cbf11924865552 = /* #__PURE__ */ function() {
    var $51 = $915100f592e460a1$export$c3c52e219617878("touchstart");
    return function($52) {
        return $51($915100f592e460a1$var$touchHandler($52));
    };
}();
var $915100f592e460a1$export$e967ac7bdb3c237c = /* #__PURE__ */ $915100f592e460a1$export$c3c52e219617878("transitionend");
var $915100f592e460a1$export$65ea24ac132a9be9 = /* #__PURE__ */ function() {
    var $53 = $915100f592e460a1$export$c3c52e219617878($e09a75ec184a12b9$export$d3028820ea014224);
    return function($54) {
        return $53($915100f592e460a1$var$wheelHandler($54));
    };
}();
var $915100f592e460a1$var$focusHandler = $k2DSm.unsafeCoerce;
var $915100f592e460a1$export$5e446bc31724fca4 = /* #__PURE__ */ function() {
    var $55 = $915100f592e460a1$export$c3c52e219617878($c4fc5073d9256368$export$2cc7ff91bcacba5e);
    return function($56) {
        return $55($915100f592e460a1$var$focusHandler($56));
    };
}();
var $915100f592e460a1$export$ecf9bf35ad97eb74 = /* #__PURE__ */ function() {
    var $57 = $915100f592e460a1$export$c3c52e219617878($ba69b19862258c3d$export$d7ddd398f22d79ef);
    return function($58) {
        return $57($915100f592e460a1$var$focusHandler($58));
    };
}();
var $915100f592e460a1$export$e9c0af77f352888d = /* #__PURE__ */ function() {
    var $59 = $915100f592e460a1$export$c3c52e219617878($ba69b19862258c3d$export$e7fa4ea7f1bfcb53);
    return function($60) {
        return $59($915100f592e460a1$var$focusHandler($60));
    };
}();
var $915100f592e460a1$export$299df4cb415b3de7 = /* #__PURE__ */ function() {
    var $61 = $915100f592e460a1$export$c3c52e219617878($ba69b19862258c3d$export$d0dc5134b51e78ad);
    return function($62) {
        return $61($915100f592e460a1$var$focusHandler($62));
    };
}();
var $915100f592e460a1$var$dragHandler = $k2DSm.unsafeCoerce;
var $915100f592e460a1$export$11a07b18d6f8f6d2 = /* #__PURE__ */ function() {
    var $63 = $915100f592e460a1$export$c3c52e219617878($efe52ca31e7b6d25$export$d7d5d435647ed5a0);
    return function($64) {
        return $63($915100f592e460a1$var$dragHandler($64));
    };
}();
var $915100f592e460a1$export$8566066e92caa8a = /* #__PURE__ */ function() {
    var $65 = $915100f592e460a1$export$c3c52e219617878($efe52ca31e7b6d25$export$26ae3c90d367ea9a);
    return function($66) {
        return $65($915100f592e460a1$var$dragHandler($66));
    };
}();
var $915100f592e460a1$export$e2ce2d097d95a991 = /* #__PURE__ */ function() {
    var $67 = $915100f592e460a1$export$c3c52e219617878($efe52ca31e7b6d25$export$bf1ba5dda238dc20);
    return function($68) {
        return $67($915100f592e460a1$var$dragHandler($68));
    };
}();
var $915100f592e460a1$export$5d99689eba023667 = /* #__PURE__ */ function() {
    var $69 = $915100f592e460a1$export$c3c52e219617878($efe52ca31e7b6d25$export$ddffa9b7b4c3e300);
    return function($70) {
        return $69($915100f592e460a1$var$dragHandler($70));
    };
}();
var $915100f592e460a1$export$5280b1a9a538737a = /* #__PURE__ */ function() {
    var $71 = $915100f592e460a1$export$c3c52e219617878($efe52ca31e7b6d25$export$f58195b0ad38aa36);
    return function($72) {
        return $71($915100f592e460a1$var$dragHandler($72));
    };
}();
var $915100f592e460a1$export$caca362e3b7795bf = /* #__PURE__ */ function() {
    var $73 = $915100f592e460a1$export$c3c52e219617878($efe52ca31e7b6d25$export$ced0a5bb82ba6aee);
    return function($74) {
        return $73($915100f592e460a1$var$dragHandler($74));
    };
}();
var $915100f592e460a1$export$b00174fdb6a6ab8f = /* #__PURE__ */ function() {
    var $75 = $915100f592e460a1$export$c3c52e219617878($efe52ca31e7b6d25$export$dc0badfde684823c);
    return function($76) {
        return $75($915100f592e460a1$var$dragHandler($76));
    };
}();
var $915100f592e460a1$export$c052d596304c05ec = /* #__PURE__ */ function() {
    var $77 = $915100f592e460a1$export$c3c52e219617878($efe52ca31e7b6d25$export$663103110d94aac9);
    return function($78) {
        return $77($915100f592e460a1$var$dragHandler($78));
    };
}();
var $915100f592e460a1$var$clipboardHandler = $k2DSm.unsafeCoerce;
var $915100f592e460a1$export$f7fe233856e3c643 = /* #__PURE__ */ function() {
    var $79 = $915100f592e460a1$export$c3c52e219617878($9013c55960c128a5$export$784d13d8ee351f07);
    return function($80) {
        return $79($915100f592e460a1$var$clipboardHandler($80));
    };
}();
var $915100f592e460a1$export$330ca67a316b532c = /* #__PURE__ */ function() {
    var $81 = $915100f592e460a1$export$c3c52e219617878($9013c55960c128a5$export$af2a99f971a346e6);
    return function($82) {
        return $81($915100f592e460a1$var$clipboardHandler($82));
    };
}();
var $915100f592e460a1$export$48aae1120b60938a = /* #__PURE__ */ function() {
    var $83 = $915100f592e460a1$export$c3c52e219617878($9013c55960c128a5$export$9b6706c8686cfc8e);
    return function($84) {
        return $83($915100f592e460a1$var$clipboardHandler($84));
    };
}();
var $915100f592e460a1$var$addForeignPropHandler = function(key) {
    return function(prop) {
        return function(reader) {
            return function(f) {
                var go = function(a) {
                    return $915100f592e460a1$var$composeKleisliFlipped(reader)($915100f592e460a1$var$readProp(prop))($3159c1316ac7a043$export$9d82982d31d9d171(a));
                };
                return $915100f592e460a1$export$6b8360dd6fa5f18d(key)($915100f592e460a1$var$composeKleisli($c0c6f03b458e5467$export$28b27b1605aa05ad)(function(e) {
                    return $beQI1.either($jhsiw.const($h2xUu.Nothing.value))(function($85) {
                        return $h2xUu.Just.create(f($85));
                    })($4abdadcc053fc40e$export$a25b8a8a37f2d1cd(go(e)));
                }));
            };
        };
    };
};
var $915100f592e460a1$export$1706e2dd89331370 = /* #__PURE__ */ $915100f592e460a1$var$addForeignPropHandler($c4fc5073d9256368$export$d8a7b8f475ec0161)("checked")(/* #__PURE__ */ $3159c1316ac7a043$export$f9a84177eae95ed5($8pkky.monadIdentity));
var $915100f592e460a1$export$4a70483021db3500 = /* #__PURE__ */ $915100f592e460a1$var$addForeignPropHandler($c4fc5073d9256368$export$d8a7b8f475ec0161)("selectedIndex")(/* #__PURE__ */ $3159c1316ac7a043$export$ac3747cb00139c63($8pkky.monadIdentity));
var $915100f592e460a1$export$faef864395e27f71 = /* #__PURE__ */ $915100f592e460a1$var$addForeignPropHandler($c4fc5073d9256368$export$d8a7b8f475ec0161)("value")($915100f592e460a1$var$readString);
var $915100f592e460a1$export$4b31b9659da30fc9 = /* #__PURE__ */ $915100f592e460a1$var$addForeignPropHandler($c4fc5073d9256368$export$b7e3ae3d7c15e42e)("value")($915100f592e460a1$var$readString);


// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");
// Generated by purs version 0.15.16














var $7FzSN = parcelRequire("7FzSN");

var $IhyKA = parcelRequire("IhyKA");

var $h2xUu = parcelRequire("h2xUu");

var $46y1S = parcelRequire("46y1S");

var $d8ahy = parcelRequire("d8ahy");




var $k2DSm = parcelRequire("k2DSm");
var $269e1a26c0466abf$var$map = /* #__PURE__ */ $7FzSN.map($639bdac132f2bf25$export$537b40a6761b64a);
var $269e1a26c0466abf$var$map1 = /* #__PURE__ */ $7FzSN.map($e7ddcc4e56dd1e0b$export$5158bce98a089317);
var $269e1a26c0466abf$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $269e1a26c0466abf$export$4a4574f653808a56 = function(x) {
    return x;
};
var $269e1a26c0466abf$export$eff4d24c3ff7876e = /* #__PURE__ */ function() {
    var go = function(p) {
        return function(mel) {
            return new $h2xUu.Just(new $e7ddcc4e56dd1e0b$export$f4c20fd541e0bbe4(p, mel));
        };
    };
    return function($29) {
        return $9aad5dc74ea3040c$export$eff4d24c3ff7876e(go($29));
    };
}();
var $269e1a26c0466abf$export$977f3f6a9323c0f6 = function(dictIsProp) {
    return $9aad5dc74ea3040c$export$977f3f6a9323c0f6(dictIsProp);
};
var $269e1a26c0466abf$var$prop1 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$4e3e21220a22c900);
var $269e1a26c0466abf$var$prop2 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$32e0d8bef35d3088);
var $269e1a26c0466abf$var$prop3 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$4c390c75bcc39428);
var $269e1a26c0466abf$var$prop4 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$6b61652c1897c1a);
var $269e1a26c0466abf$export$b2cbc93d4da94977 = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("readOnly");
var $269e1a26c0466abf$export$bad408f43b005bc8 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("rel");
var $269e1a26c0466abf$export$a7a0278c004aac3f = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("required");
var $269e1a26c0466abf$export$a5ce0649174d616e = /* #__PURE__ */ $269e1a26c0466abf$var$prop3("rowSpan");
var $269e1a26c0466abf$export$2dd197b55cf13440 = /* #__PURE__ */ $269e1a26c0466abf$var$prop3("rows");
var $269e1a26c0466abf$export$5cff813ca8e50db9 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$cf79af8281015ccd)("scope");
var $269e1a26c0466abf$export$d90250155de6d7e7 = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("selected");
var $269e1a26c0466abf$export$9ea87e299ff6a368 = /* #__PURE__ */ $269e1a26c0466abf$var$prop3("selectedIndex");
var $269e1a26c0466abf$export$afbe3196582d9f14 = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("spellcheck");
var $269e1a26c0466abf$export$2e40c9e35e9506f4 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("src");
var $269e1a26c0466abf$export$1c5fb2289a93dd05 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("srcdoc");
var $269e1a26c0466abf$export$35d34bc0ed591a92 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$a77e3c7f90d13c3c)("step");
var $269e1a26c0466abf$export$9a625f9de50bf0b7 = /* #__PURE__ */ $269e1a26c0466abf$var$prop3("tabIndex");
var $269e1a26c0466abf$export$44271b4f0c6a3563 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("target");
var $269e1a26c0466abf$export$fb184b623420d9be = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("title");
var $269e1a26c0466abf$export$d4a6a4db5b31e621 = function(dictIsProp) {
    return $269e1a26c0466abf$export$977f3f6a9323c0f6(dictIsProp)("type");
};
var $269e1a26c0466abf$export$2ab9a8f9f1186f14 = function(dictIsProp) {
    return $269e1a26c0466abf$export$977f3f6a9323c0f6(dictIsProp)("value");
};
var $269e1a26c0466abf$export$7e3df82ee760448c = /* #__PURE__ */ $269e1a26c0466abf$var$prop3("width");
var $269e1a26c0466abf$export$513ccb98c53b8039 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$1cf8b1fb41618835)("preload");
var $269e1a26c0466abf$export$b840e55573b2d2e7 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("poster");
var $269e1a26c0466abf$export$c7187bbd1a7a9244 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("placeholder");
var $269e1a26c0466abf$export$24f82734ea047e6f = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("pattern");
var $269e1a26c0466abf$export$f50297589147f25e = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("noValidate");
var $269e1a26c0466abf$export$18bca78ee4b12477 = {
    Coercible0: function() {
        return undefined;
    }
};
var $269e1a26c0466abf$export$a8ff84c12d48cfa6 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("name");
var $269e1a26c0466abf$export$987a4e3838aef8c6 = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("muted");
var $269e1a26c0466abf$export$939ddaa3205df08e = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("multiple");
var $269e1a26c0466abf$export$96ec731ed4dcb222 = /* #__PURE__ */ $269e1a26c0466abf$var$prop4("min");
var $269e1a26c0466abf$export$26f73335cc2e7868 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$efe5d718899194d9)("method");
var $269e1a26c0466abf$export$8960430cfd85939f = /* #__PURE__ */ $269e1a26c0466abf$var$prop4("max");
var $269e1a26c0466abf$export$f9ef67375ddc185 = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("loop");
var $269e1a26c0466abf$export$d560c7e4a29451c2 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("id");
var $269e1a26c0466abf$export$8f51af5840e0602a = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("href");
var $269e1a26c0466abf$export$ac607276a8fe9f0a = /* #__PURE__ */ $269e1a26c0466abf$var$prop3("height");
var $269e1a26c0466abf$export$f268b02200c313cd = {
    map: function(f) {
        return function(m) {
            return $269e1a26c0466abf$var$map($269e1a26c0466abf$var$map1(f))(m);
        };
    }
};
var $269e1a26c0466abf$export$f89de2e5bf57e5e6 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("htmlFor");
var $269e1a26c0466abf$export$9f77e0932fb78f72 = function() {
    return $k2DSm.unsafeCoerce;
};
var $269e1a26c0466abf$export$9fc5d082ec250407 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$7bd1d02eb87275db)("enctype");
var $269e1a26c0466abf$export$c746a5152d4ba26c = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("draggable");
var $269e1a26c0466abf$export$24422be91ad4011f = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("download");
var $269e1a26c0466abf$export$683472f6198a076e = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("disabled");
var $269e1a26c0466abf$export$25eaa035e2e3a214 = /* #__PURE__ */ function() {
    var $30 = $IhyKA.not($IhyKA.heytingAlgebraBoolean);
    return function($31) {
        return $269e1a26c0466abf$export$683472f6198a076e($30($31));
    };
}();
var $269e1a26c0466abf$export$cc1adf6fb659c762 = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("controls");
var $269e1a26c0466abf$export$1eebcb1e706ab348 = /* #__PURE__ */ $269e1a26c0466abf$var$prop3("cols");
var $269e1a26c0466abf$export$47be69ffacd0da98 = /* #__PURE__ */ $269e1a26c0466abf$var$prop3("colSpan");
var $269e1a26c0466abf$export$188d75d71883854a = /* #__PURE__ */ function() {
    var $32 = $269e1a26c0466abf$var$prop2("className");
    var $33 = $d8ahy.joinWith(" ");
    var $34 = $7FzSN.map($7FzSN.functorArray)($269e1a26c0466abf$var$unwrap);
    return function($35) {
        return $32($33($34($35)));
    };
}();
var $269e1a26c0466abf$export$dbf49ecbc3d3d264 = /* #__PURE__ */ function() {
    var $36 = $269e1a26c0466abf$var$prop2("className");
    return function($37) {
        return $36($269e1a26c0466abf$var$unwrap($37));
    };
}();
var $269e1a26c0466abf$export$b96bb35bc88d6fa = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("checked");
var $269e1a26c0466abf$export$e4c823724462c3fd = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("charset");
var $269e1a26c0466abf$export$b243096046abd58 = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("autoplay");
var $269e1a26c0466abf$export$4c47992fc278c9a0 = /* #__PURE__ */ $269e1a26c0466abf$var$prop1("autofocus");
var $269e1a26c0466abf$export$485ded5f26ebe08d = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$a538daf4c6392dcf)("autocomplete");
var $269e1a26c0466abf$export$3c95eba0a7ef85d = /* #__PURE__ */ function() {
    var $38 = $bQdkN.pure($h2xUu.applicativeMaybe);
    return function($39) {
        return $9aad5dc74ea3040c$export$7aabe8b3a840d2fd($38($39));
    };
}();
var $269e1a26c0466abf$export$7aabe8b3a840d2fd = /* #__PURE__ */ function() {
    return $9aad5dc74ea3040c$export$7aabe8b3a840d2fd($h2xUu.Nothing.value);
}();
var $269e1a26c0466abf$export$8837f4fc672e936d = /* #__PURE__ */ $269e1a26c0466abf$export$7aabe8b3a840d2fd("list");
var $269e1a26c0466abf$export$1d567c320f4763bc = /* #__PURE__ */ $269e1a26c0466abf$export$7aabe8b3a840d2fd("style");
var $269e1a26c0466abf$export$228be17d80722ab = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("alt");
var $269e1a26c0466abf$export$31eb53bd5b582a97 = /* #__PURE__ */ $269e1a26c0466abf$var$prop2("action");
var $269e1a26c0466abf$export$73f57eecff448cc8 = /* #__PURE__ */ $269e1a26c0466abf$export$977f3f6a9323c0f6($9aad5dc74ea3040c$export$27dc712f9cde9a29)("accept");




// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");

var $dNwPt = parcelRequire("dNwPt");

var $7FzSN = parcelRequire("7FzSN");

var $IhyKA = parcelRequire("IhyKA");

var $h2xUu = parcelRequire("h2xUu");

var $46y1S = parcelRequire("46y1S");

var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");



var $7fHqi = parcelRequire("7fHqi");
// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");
// Generated by purs version 0.15.16



var $779fa8ebd14f687b$var$lift = /* #__PURE__ */ $0db1509836ffbf7e$export$590e8b2c435046d9($024201b10fb9f490$export$95510d0cd7e6e7eb);
var $779fa8ebd14f687b$export$d2a72f000c4be67b = /* #__PURE__ */ function() {
    function Completed(value0) {
        this.value0 = value0;
    }
    Completed.create = function(value0) {
        return new Completed(value0);
    };
    return Completed;
}();
var $779fa8ebd14f687b$export$91ae1e982b7b05d4 = /* #__PURE__ */ function() {
    function Failed(value0) {
        this.value0 = value0;
    }
    Failed.create = function(value0) {
        return new Failed(value0);
    };
    return Failed;
}();
var $779fa8ebd14f687b$export$bc0dd2ad24d78194 = /* #__PURE__ */ function() {
    function Killed(value0) {
        this.value0 = value0;
    }
    Killed.create = function(value0) {
        return new Killed(value0);
    };
    return Killed;
}();
var $779fa8ebd14f687b$export$bb8edd1f55ec0e96 = function(dict) {
    return dict.uninterruptible;
};
var $779fa8ebd14f687b$export$a1428c8f7ba796e8 = function(dict) {
    return dict.suspend;
};
var $779fa8ebd14f687b$export$b3e22bcfd64c1022 = function(dict) {
    return dict.never;
};
var $779fa8ebd14f687b$export$353ec5b900391c5 = {
    suspend: $7244ec56ae5630bd$export$4de6f17bc3dfa03,
    fork: $7244ec56ae5630bd$export$469c8a16c186651e,
    join: $7244ec56ae5630bd$export$f3d782c2b95165ad,
    Monad0: function() {
        return $7244ec56ae5630bd$export$b147a380fa8fdc0e;
    },
    Functor1: function() {
        return $7244ec56ae5630bd$export$29466a041ff3b3e0;
    }
};
var $779fa8ebd14f687b$export$283d19abc99a5706 = {
    kill: $7244ec56ae5630bd$export$c65b2010df1810d,
    MonadFork0: function() {
        return $779fa8ebd14f687b$export$353ec5b900391c5;
    },
    MonadThrow1: function() {
        return $7244ec56ae5630bd$export$37a9b80154c7d256;
    }
};
var $779fa8ebd14f687b$export$f2e13c7c49fc01aa = {
    bracket: function(acquire) {
        return function(release) {
            return function(run) {
                return $c88db571692c73b3$export$9ad792f02752f447(acquire)({
                    completed: function($44) {
                        return release($779fa8ebd14f687b$export$d2a72f000c4be67b.create($44));
                    },
                    failed: function($45) {
                        return release($779fa8ebd14f687b$export$91ae1e982b7b05d4.create($45));
                    },
                    killed: function($46) {
                        return release($779fa8ebd14f687b$export$bc0dd2ad24d78194.create($46));
                    }
                })(run);
            };
        };
    },
    uninterruptible: $7244ec56ae5630bd$export$859f4dae848ac0ae,
    never: $7244ec56ae5630bd$export$b3e22bcfd64c1022,
    MonadKill0: function() {
        return $779fa8ebd14f687b$export$283d19abc99a5706;
    },
    MonadError1: function() {
        return $7244ec56ae5630bd$export$9efce1646e93cba4;
    }
};
var $779fa8ebd14f687b$export$dfdb508572caf3d7 = function(dict) {
    return dict.kill;
};
var $779fa8ebd14f687b$export$f7e2c8231c57a8bd = function(dict) {
    return dict.join;
};
var $779fa8ebd14f687b$export$7a5058c6b79333e0 = function(dict) {
    return dict.fork;
};
var $779fa8ebd14f687b$export$21277a949ab1c87a = function(dictMonadFork) {
    var suspend1 = $779fa8ebd14f687b$export$a1428c8f7ba796e8(dictMonadFork);
    var fork1 = $779fa8ebd14f687b$export$7a5058c6b79333e0(dictMonadFork);
    var Monad0 = dictMonadFork.Monad0();
    var monadReaderT = $024201b10fb9f490$export$6f721f6865c71dd2(Monad0);
    var Functor1 = dictMonadFork.Functor1();
    return {
        suspend: function(v) {
            return function($47) {
                return suspend1(v($47));
            };
        },
        fork: function(v) {
            return function($48) {
                return fork1(v($48));
            };
        },
        join: function() {
            var $49 = $779fa8ebd14f687b$var$lift(Monad0);
            var $50 = $779fa8ebd14f687b$export$f7e2c8231c57a8bd(dictMonadFork);
            return function($51) {
                return $49($50($51));
            };
        }(),
        Monad0: function() {
            return monadReaderT;
        },
        Functor1: function() {
            return Functor1;
        }
    };
};
var $779fa8ebd14f687b$export$b03c2ddf720364a4 = function(dictMonadKill) {
    var MonadThrow1 = dictMonadKill.MonadThrow1();
    var lift1 = $779fa8ebd14f687b$var$lift(MonadThrow1.Monad0());
    var kill1 = $779fa8ebd14f687b$export$dfdb508572caf3d7(dictMonadKill);
    var monadForkReaderT1 = $779fa8ebd14f687b$export$21277a949ab1c87a(dictMonadKill.MonadFork0());
    var monadThrowReaderT = $024201b10fb9f490$export$1b067e2856bff729(MonadThrow1);
    return {
        kill: function(e) {
            var $52 = kill1(e);
            return function($53) {
                return lift1($52($53));
            };
        },
        MonadFork0: function() {
            return monadForkReaderT1;
        },
        MonadThrow1: function() {
            return monadThrowReaderT;
        }
    };
};
var $779fa8ebd14f687b$export$df5598cc12b9c8c = function(dict) {
    return dict.bracket;
};
var $779fa8ebd14f687b$export$746d58fd4800e2fa = function(dictMonadBracket) {
    var bracket1 = $779fa8ebd14f687b$export$df5598cc12b9c8c(dictMonadBracket);
    var uninterruptible1 = $779fa8ebd14f687b$export$bb8edd1f55ec0e96(dictMonadBracket);
    var MonadError1 = dictMonadBracket.MonadError1();
    var monadKillReaderT1 = $779fa8ebd14f687b$export$b03c2ddf720364a4(dictMonadBracket.MonadKill0());
    var monadErrorReaderT = $024201b10fb9f490$export$484cd3c856ffc7(MonadError1);
    return {
        bracket: function(v) {
            return function(release) {
                return function(run) {
                    return function(r) {
                        return bracket1(v(r))(function(c) {
                            return function(a) {
                                return $024201b10fb9f490$export$f356de2c51baae29(release(c)(a))(r);
                            };
                        })(function(a) {
                            return $024201b10fb9f490$export$f356de2c51baae29(run(a))(r);
                        });
                    };
                };
            };
        },
        uninterruptible: function(k) {
            return function(r) {
                return uninterruptible1($024201b10fb9f490$export$f356de2c51baae29(k)(r));
            };
        },
        never: $779fa8ebd14f687b$var$lift(MonadError1.MonadThrow0().Monad0())($779fa8ebd14f687b$export$b3e22bcfd64c1022(dictMonadBracket)),
        MonadKill0: function() {
            return monadKillReaderT1;
        },
        MonadError1: function() {
            return monadErrorReaderT;
        }
    };
};



var $bcJ05 = parcelRequire("bcJ05");


var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $5krR0 = parcelRequire("5krR0");

var $fZenR = parcelRequire("fZenR");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");

var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");





var $7fHqi = parcelRequire("7fHqi");
// Generated by purs version 0.15.16

var $3gIn7 = parcelRequire("3gIn7");


// Generated by purs version 0.15.16

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");






var $k2DSm = parcelRequire("k2DSm");
var $16017b9e0c2dabe6$var$componentSlot = /* #__PURE__ */ $02809249bead6832$export$f7e7e2efed606f4a();
var $16017b9e0c2dabe6$var$map = /* #__PURE__ */ $7FzSN.map($7FzSN.functorFn);
var $16017b9e0c2dabe6$export$76bf64fc47d1f9ce = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $16017b9e0c2dabe6$var$componentSlot(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot2 = componentSlot1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(component) {
                        return function(input) {
                            return $9aad5dc74ea3040c$export$f0c5cfb390964b78(new $02809249bead6832$export$bbf8b056cc92e88d(componentSlot2(label)(p)(component)(input)($jhsiw.const($h2xUu.Nothing.value))));
                        };
                    };
                };
            };
        };
    };
};
var $16017b9e0c2dabe6$export$103b78750979eead = function() {
    return function(dictIsSymbol) {
        var componentSlot1 = $16017b9e0c2dabe6$var$componentSlot(dictIsSymbol);
        return function(dictOrd) {
            var componentSlot2 = componentSlot1(dictOrd);
            return function(label) {
                return function(p) {
                    return function(component) {
                        return function(input) {
                            return function(outputQuery) {
                                return $9aad5dc74ea3040c$export$f0c5cfb390964b78(new $02809249bead6832$export$bbf8b056cc92e88d(componentSlot2(label)(p)(component)(input)(function($11) {
                                    return $h2xUu.Just.create(outputQuery($11));
                                })));
                            };
                        };
                    };
                };
            };
        };
    };
};
var $16017b9e0c2dabe6$export$9756366f7cb6f62b = function(eqFn) {
    return function(f) {
        return $16017b9e0c2dabe6$var$map(function($12) {
            return $9aad5dc74ea3040c$export$f0c5cfb390964b78($02809249bead6832$export$5e46cfa5e835a582.create($12));
        })($ea9a396fdac62c85$export$6fa757c467a343e(eqFn)(f));
    };
};
var $16017b9e0c2dabe6$export$1590e93dfc8f2cb5 = function(f) {
    return function(a) {
        return function(b) {
            return function(c) {
                return $9aad5dc74ea3040c$export$f0c5cfb390964b78(new $02809249bead6832$export$5e46cfa5e835a582($ea9a396fdac62c85$export$7f0ccf52046143dd(f, a, b, c)));
            };
        };
    };
};
var $16017b9e0c2dabe6$export$5a7f8ed0ed0de90f = function(f) {
    return function(a) {
        return function(b) {
            return $9aad5dc74ea3040c$export$f0c5cfb390964b78(new $02809249bead6832$export$5e46cfa5e835a582($ea9a396fdac62c85$export$8a29159161b2b8a6(f, a, b)));
        };
    };
};
var $16017b9e0c2dabe6$export$488013bae63b21da = function(f) {
    return function(a) {
        return $9aad5dc74ea3040c$export$f0c5cfb390964b78(new $02809249bead6832$export$5e46cfa5e835a582($ea9a396fdac62c85$export$c6666e7f0d2efc62(f, a)));
    };
};
var $16017b9e0c2dabe6$export$1fb0fe1b9ee1b1bf = $k2DSm.unsafeCoerce;



// Generated by purs version 0.15.16

var $cADnC = parcelRequire("cADnC");

var $26SV5 = parcelRequire("26SV5");



var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $2jM6U = parcelRequire("2jM6U");






var $66e8dd838e33a687$var$$$void = /* #__PURE__ */ $7FzSN.void($497deb56c643077e$export$bf09f5de576f9cf1);
var $66e8dd838e33a687$var$queryAll = /* #__PURE__ */ $497deb56c643077e$export$dcd0d083aa86c355();
var $66e8dd838e33a687$var$query = /* #__PURE__ */ $497deb56c643077e$export$2fa187e846a241c4();
var $66e8dd838e33a687$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $66e8dd838e33a687$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($h2xUu.bindMaybe);
var $66e8dd838e33a687$export$786cec95229c2a31 = function() {
    return function(dictIsSymbol) {
        var queryAll1 = $66e8dd838e33a687$var$queryAll(dictIsSymbol);
        return function(dictOrd) {
            var queryAll2 = queryAll1(dictOrd);
            return function(label) {
                return function(req) {
                    return $66e8dd838e33a687$var$$$void(queryAll2(label)(req($2jM6U.unit)));
                };
            };
        };
    };
};
var $66e8dd838e33a687$export$de3113ed932c61ab = function() {
    return function(dictIsSymbol) {
        var query1 = $66e8dd838e33a687$var$query(dictIsSymbol);
        return function(dictOrd) {
            var query2 = query1(dictOrd);
            return function(slot) {
                return function(label) {
                    return function(req) {
                        return $66e8dd838e33a687$var$$$void(query2(slot)(label)(req($2jM6U.unit)));
                    };
                };
            };
        };
    };
};
var $66e8dd838e33a687$export$57331aaf6e3ff74d = function() {
    return function(dictIsSymbol) {
        var queryAll1 = $66e8dd838e33a687$var$queryAll(dictIsSymbol);
        return function(dictOrd) {
            var queryAll2 = queryAll1(dictOrd);
            return function(label) {
                return function(req) {
                    return queryAll2(label)(req($66e8dd838e33a687$var$identity));
                };
            };
        };
    };
};
var $66e8dd838e33a687$export$b5fe3f66a567bec0 = function() {
    return function(dictIsSymbol) {
        var query1 = $66e8dd838e33a687$var$query(dictIsSymbol);
        return function(dictOrd) {
            var query2 = query1(dictOrd);
            return function(slot) {
                return function(label) {
                    return function(req) {
                        return query2(slot)(label)(req($66e8dd838e33a687$var$identity));
                    };
                };
            };
        };
    };
};
var $66e8dd838e33a687$export$a39c6a18d03be90d = function(act) {
    return act($2jM6U.unit);
};
var $66e8dd838e33a687$export$377703b067ff01a = function(req) {
    return req($66e8dd838e33a687$var$identity);
};
var $66e8dd838e33a687$export$bd6cf4e30aa8da47 = /* #__PURE__ */ function() {
    var $24 = $7FzSN.map($497deb56c643077e$export$bf09f5de576f9cf1)(function(v) {
        return $66e8dd838e33a687$var$bindFlipped($13d4e6882f9a916b$export$c56654a6d0e3bd48)(v);
    });
    return function($25) {
        return $24($497deb56c643077e$export$f0c653cfd7dea798($25));
    };
}();




// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");


var $cADnC = parcelRequire("cADnC");

var $kkdfo = parcelRequire("kkdfo");





var $iQTlW = parcelRequire("iQTlW");


var $beQI1 = parcelRequire("beQI1");

var $dNwPt = parcelRequire("dNwPt");

var $jhsiw = parcelRequire("jhsiw");

var $7FzSN = parcelRequire("7FzSN");

var $fZenR = parcelRequire("fZenR");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");




var $7fHqi = parcelRequire("7fHqi");
// Generated by purs version 0.15.16

var $dNwPt = parcelRequire("dNwPt");

var $fZenR = parcelRequire("fZenR");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");

var $7fHqi = parcelRequire("7fHqi");


var $k2DSm = parcelRequire("k2DSm");
var $34a3e460273cf155$export$57f9bfb98da0e5b8 = function(x) {
    return x;
};
var $34a3e460273cf155$export$74fd2e01b52646ce = function(x) {
    return x;
};
var $34a3e460273cf155$export$b29cd3b133bc0fa4 = $k2DSm.unsafeCoerce;
var $34a3e460273cf155$export$b325883598264040 = $k2DSm.unsafeCoerce;
var $34a3e460273cf155$export$dcc8908fea536646 = function(dictApplicative) {
    var traverse_ = $dNwPt.traverse_(dictApplicative)($dNwPt.foldableMaybe);
    return function(f) {
        return $34a3e460273cf155$export$b325883598264040(function(st) {
            return traverse_(f)(st.rendering);
        });
    };
};
var $34a3e460273cf155$var$mkRenderStateX = $k2DSm.unsafeCoerce;
var $34a3e460273cf155$export$8a58ffe66c3bbb4d = function(dictFunctor) {
    return function(f) {
        return $34a3e460273cf155$export$b325883598264040(function(st) {
            return $34a3e460273cf155$var$mkRenderStateX(f(st.rendering));
        });
    };
};
var $34a3e460273cf155$export$52c65da2de355775 = $k2DSm.unsafeCoerce;
var $34a3e460273cf155$export$43ced40f2a8d1657 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $34a3e460273cf155$export$2999486de8d3a294 = function(component) {
    return function(input) {
        return function(handler) {
            return function(lchs) {
                return function __do() {
                    var selfRef = $7fHqi.new({})();
                    var childrenIn = $7fHqi.new($b10d220e1d5af382$export$6e22c362a0406a2c)();
                    var childrenOut = $7fHqi.new($b10d220e1d5af382$export$6e22c362a0406a2c)();
                    var handlerRef = $7fHqi.new(handler)();
                    var pendingQueries = $7fHqi.new(new $h2xUu.Just($fZenR.Nil.value))();
                    var pendingOuts = $7fHqi.new(new $h2xUu.Just($fZenR.Nil.value))();
                    var pendingHandlers = $7fHqi.new($h2xUu.Nothing.value)();
                    var fresh = $7fHqi.new(1)();
                    var subscriptions = $7fHqi.new(new $h2xUu.Just($aHmxC.empty))();
                    var forks = $7fHqi.new($aHmxC.empty)();
                    var ds = {
                        component: component,
                        state: component.initialState(input),
                        refs: $aHmxC.empty,
                        children: $b10d220e1d5af382$export$6e22c362a0406a2c,
                        childrenIn: childrenIn,
                        childrenOut: childrenOut,
                        selfRef: selfRef,
                        handlerRef: handlerRef,
                        pendingQueries: pendingQueries,
                        pendingOuts: pendingOuts,
                        pendingHandlers: pendingHandlers,
                        rendering: $h2xUu.Nothing.value,
                        fresh: fresh,
                        subscriptions: subscriptions,
                        forks: forks,
                        lifecycleHandlers: lchs
                    };
                    $7fHqi.write(ds)(selfRef)();
                    return $34a3e460273cf155$export$52c65da2de355775(selfRef);
                };
            };
        };
    };
};








var $5b357b49a3aa55a9$var$traverse_ = /* #__PURE__ */ $dNwPt.traverse_($1rTTn.applicativeEffect)($dNwPt.foldableMaybe);
var $5b357b49a3aa55a9$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($h2xUu.bindMaybe);
var $5b357b49a3aa55a9$var$lookup = /* #__PURE__ */ $aHmxC.lookup($497deb56c643077e$export$2a9fc99fce80131a);
var $5b357b49a3aa55a9$var$bind1 = /* #__PURE__ */ $cADnC.bind($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $5b357b49a3aa55a9$var$liftEffect = /* #__PURE__ */ $54d5aa8d31ad5798$export$34255e15eb56d2b3($7244ec56ae5630bd$export$666a030cecdf96c);
var $5b357b49a3aa55a9$var$discard = /* #__PURE__ */ $cADnC.discard($cADnC.discardUnit);
var $5b357b49a3aa55a9$var$discard1 = /* #__PURE__ */ $5b357b49a3aa55a9$var$discard($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $5b357b49a3aa55a9$var$traverse_1 = /* #__PURE__ */ $dNwPt.traverse_($7244ec56ae5630bd$export$9dc0454a98607988);
var $5b357b49a3aa55a9$var$traverse_2 = /* #__PURE__ */ $5b357b49a3aa55a9$var$traverse_1($fZenR.foldableList);
var $5b357b49a3aa55a9$var$fork = /* #__PURE__ */ $779fa8ebd14f687b$export$7a5058c6b79333e0($779fa8ebd14f687b$export$353ec5b900391c5);
var $5b357b49a3aa55a9$var$parSequence_ = /* #__PURE__ */ $2dd7e3695251593b$export$a907a2b4fd85b16b($7244ec56ae5630bd$export$cb4623454f96d5e0)($fZenR.foldableList);
var $5b357b49a3aa55a9$var$pure = /* #__PURE__ */ $bQdkN.pure($7244ec56ae5630bd$export$9dc0454a98607988);
var $5b357b49a3aa55a9$var$map = /* #__PURE__ */ $7FzSN.map($6ceb47448afaefc1$export$bd40aba71422b460);
var $5b357b49a3aa55a9$var$parallel = /* #__PURE__ */ $ef3bc277abaf9997$export$451942af9381149c($7244ec56ae5630bd$export$cb4623454f96d5e0);
var $5b357b49a3aa55a9$var$map1 = /* #__PURE__ */ $7FzSN.map($7244ec56ae5630bd$export$e8a7d9b8d7dc616a);
var $5b357b49a3aa55a9$var$sequential = /* #__PURE__ */ $ef3bc277abaf9997$export$3c7b24ce1c81e349($7244ec56ae5630bd$export$cb4623454f96d5e0);
var $5b357b49a3aa55a9$var$map2 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $5b357b49a3aa55a9$var$insert = /* #__PURE__ */ $aHmxC.insert($497deb56c643077e$export$2a9fc99fce80131a);
var $5b357b49a3aa55a9$var$retractFreeAp = /* #__PURE__ */ $d274f7fabe85b746$export$ab82a8987829bde0($7244ec56ae5630bd$export$389e6cb252ce112f);
var $5b357b49a3aa55a9$var$$$delete = /* #__PURE__ */ $aHmxC.delete($497deb56c643077e$export$7e953d51c2b3343e);
var $5b357b49a3aa55a9$var$unlessM = /* #__PURE__ */ $kkdfo.unlessM($1rTTn.monadEffect);
var $5b357b49a3aa55a9$var$insert1 = /* #__PURE__ */ $aHmxC.insert($497deb56c643077e$export$7e953d51c2b3343e);
var $5b357b49a3aa55a9$var$traverse_3 = /* #__PURE__ */ $5b357b49a3aa55a9$var$traverse_1($dNwPt.foldableMaybe);
var $5b357b49a3aa55a9$var$lookup1 = /* #__PURE__ */ $aHmxC.lookup($497deb56c643077e$export$7e953d51c2b3343e);
var $5b357b49a3aa55a9$var$lookup2 = /* #__PURE__ */ $aHmxC.lookup($gwBF5.ordString);
var $5b357b49a3aa55a9$var$foldFree = /* #__PURE__ */ $f846b50afc5ec5d5$export$eb0e66a9104d4874($7244ec56ae5630bd$export$974f8db4a62dd716);
var $5b357b49a3aa55a9$var$alter = /* #__PURE__ */ $aHmxC.alter($gwBF5.ordString);
var $5b357b49a3aa55a9$var$unsubscribe = function(sid) {
    return function(ref) {
        return function __do() {
            var v = $7fHqi.read(ref)();
            var subs = $7fHqi.read(v.subscriptions)();
            return $5b357b49a3aa55a9$var$traverse_($ae794effd2a529f9$export$f500693cef883ffd)($5b357b49a3aa55a9$var$bindFlipped($5b357b49a3aa55a9$var$lookup(sid))(subs))();
        };
    };
};
var $5b357b49a3aa55a9$export$2d912d1764c6009b = function(ref) {
    return function(au) {
        return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v) {
            if (v instanceof $h2xUu.Nothing) return au;
            if (v instanceof $h2xUu.Just) return $5b357b49a3aa55a9$var$liftEffect($7fHqi.write(new $h2xUu.Just(new $fZenR.Cons(au, v.value0)))(ref));
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 188, column 33 - line 190, column 57): " + [
                v.constructor.name
            ]);
        });
    };
};
var $5b357b49a3aa55a9$export$b7a8cef929df0d3c = function(lchs) {
    return function(f) {
        return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$var$liftEffect($7fHqi.write({
            initializers: $fZenR.Nil.value,
            finalizers: $fZenR.Nil.value
        })(lchs)))(function() {
            return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect(f))(function(result) {
                return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(lchs)))(function(v) {
                    return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$var$traverse_2($5b357b49a3aa55a9$var$fork)(v.finalizers))(function() {
                        return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$var$parSequence_(v.initializers))(function() {
                            return $5b357b49a3aa55a9$var$pure(result);
                        });
                    });
                });
            });
        });
    };
};
var $5b357b49a3aa55a9$export$c4c41c035efd1fb3 = /* #__PURE__ */ $7244ec56ae5630bd$export$ef62257e6f8a5f8c(/* #__PURE__ */ $beQI1.either($f58bea5e58d54301$export$de0c4a986b439e52)(/* #__PURE__ */ $jhsiw.const(/* #__PURE__ */ $bQdkN.pure($1rTTn.applicativeEffect)($2jM6U.unit))));
var $5b357b49a3aa55a9$var$fresh = function(f) {
    return function(ref) {
        return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v) {
            return $5b357b49a3aa55a9$var$liftEffect($7fHqi.modify$prime(function(i) {
                return {
                    state: i + 1 | 0,
                    value: f(i)
                };
            })(v.fresh));
        });
    };
};
var $5b357b49a3aa55a9$export$f960635a4c7f8a61 = function(render) {
    return function(ref) {
        return function(q) {
            return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v) {
                return $5b357b49a3aa55a9$export$b505393bc8c03d39(render)(ref)(v["component"]["eval"](new $5573693fd45dda6e$export$62297b13309008b2($5b357b49a3aa55a9$var$map($h2xUu.Just.create)($6ceb47448afaefc1$export$6320c031d6b6270f(q)), $jhsiw.const($h2xUu.Nothing.value))));
            });
        };
    };
};
var $5b357b49a3aa55a9$export$b505393bc8c03d39 = function(render) {
    return function(initRef) {
        return function(v) {
            var evalChildQuery = function(ref) {
                return function(cqb) {
                    return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v1) {
                        return $409d32e8760027b2$export$183d7a788d583d00(function(v2) {
                            var evalChild = function(v3) {
                                return $5b357b49a3aa55a9$var$parallel($5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(v3)))(function(dsx) {
                                    return $34a3e460273cf155$export$b325883598264040(function(ds) {
                                        return $5b357b49a3aa55a9$export$f960635a4c7f8a61(render)(ds.selfRef)(v2.value1);
                                    })(dsx);
                                }));
                            };
                            return $5b357b49a3aa55a9$var$map1(v2.value2)($5b357b49a3aa55a9$var$sequential(v2.value0($7244ec56ae5630bd$export$389e6cb252ce112f)(evalChild)(v1.children)));
                        })(cqb);
                    });
                };
            };
            var go = function(ref) {
                return function(v1) {
                    if (v1 instanceof $497deb56c643077e$export$7254cc27399e90bd) return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v2) {
                        var v3 = v1.value0(v2.state);
                        if ($369b9f59978cbcde$export$54d9901699893a6(v2.state)(v3.value1)) return $5b357b49a3aa55a9$var$pure(v3.value0);
                        if ($iQTlW.otherwise) return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$var$liftEffect($7fHqi.write({
                            component: v2.component,
                            refs: v2.refs,
                            children: v2.children,
                            childrenIn: v2.childrenIn,
                            childrenOut: v2.childrenOut,
                            selfRef: v2.selfRef,
                            handlerRef: v2.handlerRef,
                            pendingQueries: v2.pendingQueries,
                            pendingOuts: v2.pendingOuts,
                            pendingHandlers: v2.pendingHandlers,
                            rendering: v2.rendering,
                            fresh: v2.fresh,
                            subscriptions: v2.subscriptions,
                            forks: v2.forks,
                            lifecycleHandlers: v2.lifecycleHandlers,
                            state: v3.value1
                        })(ref)))(function() {
                            return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$export$b7a8cef929df0d3c(v2.lifecycleHandlers)(render(v2.lifecycleHandlers)(ref)))(function() {
                                return $5b357b49a3aa55a9$var$pure(v3.value0);
                            });
                        });
                        throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 86, column 7 - line 92, column 21): " + [
                            v3.constructor.name
                        ]);
                    });
                    if (v1 instanceof $497deb56c643077e$export$b5b6bb8bb5273115) return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$fresh($497deb56c643077e$export$f3ce0030ce21b322)(ref))(function(sid) {
                        return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($ae794effd2a529f9$export$ec068583843480e7(v1.value0(sid))(function(act) {
                            return $5b357b49a3aa55a9$export$c4c41c035efd1fb3($5b357b49a3aa55a9$export$6533955444d826a5(render)(ref)(new $e7ddcc4e56dd1e0b$export$e19cd5f9376f8cee(act)));
                        })))(function(finalize) {
                            return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v2) {
                                return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$var$liftEffect($7fHqi.modify_($5b357b49a3aa55a9$var$map2($5b357b49a3aa55a9$var$insert(sid)(finalize)))(v2.subscriptions)))(function() {
                                    return $5b357b49a3aa55a9$var$pure(v1.value1(sid));
                                });
                            });
                        });
                    });
                    if (v1 instanceof $497deb56c643077e$export$cf424b9d16eab6b0) return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$var$liftEffect($5b357b49a3aa55a9$var$unsubscribe(v1.value0)(ref)))(function() {
                        return $5b357b49a3aa55a9$var$pure(v1.value1);
                    });
                    if (v1 instanceof $497deb56c643077e$export$5ba9ac88cb4a4c17) return v1.value0;
                    if (v1 instanceof $497deb56c643077e$export$c9e0c97aebb96176) return evalChildQuery(ref)(v1.value0);
                    if (v1 instanceof $497deb56c643077e$export$c97bcbb53b4e15e4) return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v2) {
                        return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(v2.handlerRef)))(function(handler) {
                            return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$export$2d912d1764c6009b(v2.pendingOuts)(handler(v1.value0)))(function() {
                                return $5b357b49a3aa55a9$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $497deb56c643077e$export$6e7e621f508eff66) return $5b357b49a3aa55a9$var$sequential($5b357b49a3aa55a9$var$retractFreeAp($d274f7fabe85b746$export$2a17b194dc6daf5e(function() {
                        var $118 = $5b357b49a3aa55a9$export$b505393bc8c03d39(render)(ref);
                        return function($119) {
                            return $5b357b49a3aa55a9$var$parallel($118($119));
                        };
                    }())(v1.value0)));
                    if (v1 instanceof $497deb56c643077e$export$8cdfc2927e464854) return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$fresh($497deb56c643077e$export$77e8fa738093aa8c)(ref))(function(fid) {
                        return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v2) {
                            return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.new(false)))(function(doneRef) {
                                return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$fork($7244ec56ae5630bd$export$7f8bd3bb7f01e042($5b357b49a3aa55a9$var$liftEffect(function __do() {
                                    $7fHqi.modify_($5b357b49a3aa55a9$var$$$delete(fid))(v2.forks)();
                                    return $7fHqi.write(true)(doneRef)();
                                }))($5b357b49a3aa55a9$export$b505393bc8c03d39(render)(ref)(v1.value0))))(function(fiber) {
                                    return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$var$liftEffect($5b357b49a3aa55a9$var$unlessM($7fHqi.read(doneRef))($7fHqi.modify_($5b357b49a3aa55a9$var$insert1(fid)(fiber))(v2.forks))))(function() {
                                        return $5b357b49a3aa55a9$var$pure(v1.value1(fid));
                                    });
                                });
                            });
                        });
                    });
                    if (v1 instanceof $497deb56c643077e$export$26aa7833c998c5d3) return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v2) {
                        return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(v2.forks)))(function(forkMap) {
                            return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$var$traverse_3($7244ec56ae5630bd$export$f3d782c2b95165ad)($5b357b49a3aa55a9$var$lookup1(v1.value0)(forkMap)))(function() {
                                return $5b357b49a3aa55a9$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $497deb56c643077e$export$25e269b2a286b4be) return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v2) {
                        return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(v2.forks)))(function(forkMap) {
                            return $5b357b49a3aa55a9$var$discard1($5b357b49a3aa55a9$var$traverse_3($7244ec56ae5630bd$export$c65b2010df1810d($f58bea5e58d54301$export$a3bc9b8ed74fc("Cancelled")))($5b357b49a3aa55a9$var$lookup1(v1.value0)(forkMap)))(function() {
                                return $5b357b49a3aa55a9$var$pure(v1.value1);
                            });
                        });
                    });
                    if (v1 instanceof $497deb56c643077e$export$c2ea277386f73da0) return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v2) {
                        return $5b357b49a3aa55a9$var$pure(v1.value1($5b357b49a3aa55a9$var$lookup2(v1.value0)(v2.refs)));
                    });
                    throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 83, column 12 - line 139, column 33): " + [
                        v1.constructor.name
                    ]);
                };
            };
            return $5b357b49a3aa55a9$var$foldFree(go(initRef))(v);
        };
    };
};
var $5b357b49a3aa55a9$export$6533955444d826a5 = function(render) {
    return function(ref) {
        return function(v) {
            if (v instanceof $e7ddcc4e56dd1e0b$export$f4c20fd541e0bbe4) return $5b357b49a3aa55a9$var$liftEffect($jhsiw.flip($7fHqi.modify_)(ref)($34a3e460273cf155$export$43ced40f2a8d1657(function(st) {
                return {
                    component: st.component,
                    state: st.state,
                    children: st.children,
                    childrenIn: st.childrenIn,
                    childrenOut: st.childrenOut,
                    selfRef: st.selfRef,
                    handlerRef: st.handlerRef,
                    pendingQueries: st.pendingQueries,
                    pendingOuts: st.pendingOuts,
                    pendingHandlers: st.pendingHandlers,
                    rendering: st.rendering,
                    fresh: st.fresh,
                    subscriptions: st.subscriptions,
                    forks: st.forks,
                    lifecycleHandlers: st.lifecycleHandlers,
                    refs: $5b357b49a3aa55a9$var$alter($jhsiw.const(v.value1))(v.value0)(st.refs)
                };
            })));
            if (v instanceof $e7ddcc4e56dd1e0b$export$e19cd5f9376f8cee) return $5b357b49a3aa55a9$var$bind1($5b357b49a3aa55a9$var$liftEffect($7fHqi.read(ref)))(function(v1) {
                return $5b357b49a3aa55a9$export$b505393bc8c03d39(render)(ref)(v1["component"]["eval"](new $5573693fd45dda6e$export$e19cd5f9376f8cee(v.value0, $2jM6U.unit)));
            });
            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 52, column 20 - line 58, column 62): " + [
                v.constructor.name
            ]);
        };
    };
};








var $61da5bd30f2af257$var$bind = /* #__PURE__ */ $cADnC.bind($1rTTn.bindEffect);
var $61da5bd30f2af257$var$discard = /* #__PURE__ */ $cADnC.discard($cADnC.discardUnit);
var $61da5bd30f2af257$var$for_ = /* #__PURE__ */ $dNwPt.for_($1rTTn.applicativeEffect)($dNwPt.foldableMaybe);
var $61da5bd30f2af257$var$traverse_ = /* #__PURE__ */ $dNwPt.traverse_($7244ec56ae5630bd$export$9dc0454a98607988)($fZenR.foldableList);
var $61da5bd30f2af257$var$fork = /* #__PURE__ */ $779fa8ebd14f687b$export$7a5058c6b79333e0($779fa8ebd14f687b$export$353ec5b900391c5);
var $61da5bd30f2af257$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($1rTTn.bindEffect);
var $61da5bd30f2af257$var$traverse_1 = /* #__PURE__ */ $dNwPt.traverse_($1rTTn.applicativeEffect);
var $61da5bd30f2af257$var$traverse_2 = /* #__PURE__ */ $61da5bd30f2af257$var$traverse_1($dNwPt.foldableMaybe);
var $61da5bd30f2af257$var$traverse_3 = /* #__PURE__ */ $61da5bd30f2af257$var$traverse_1($aHmxC.foldableMap);
var $61da5bd30f2af257$var$discard2 = /* #__PURE__ */ $61da5bd30f2af257$var$discard($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $61da5bd30f2af257$var$parSequence_ = /* #__PURE__ */ $2dd7e3695251593b$export$a907a2b4fd85b16b($7244ec56ae5630bd$export$cb4623454f96d5e0)($fZenR.foldableList);
var $61da5bd30f2af257$var$liftEffect = /* #__PURE__ */ $54d5aa8d31ad5798$export$34255e15eb56d2b3($7244ec56ae5630bd$export$666a030cecdf96c);
var $61da5bd30f2af257$var$pure = /* #__PURE__ */ $bQdkN.pure($1rTTn.applicativeEffect);
var $61da5bd30f2af257$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $61da5bd30f2af257$var$pure1 = /* #__PURE__ */ $bQdkN.pure($7244ec56ae5630bd$export$9dc0454a98607988);
var $61da5bd30f2af257$var$when = /* #__PURE__ */ $bQdkN.when($1rTTn.applicativeEffect);
var $61da5bd30f2af257$var$renderStateX = /* #__PURE__ */ $34a3e460273cf155$export$8a58ffe66c3bbb4d($1rTTn.functorEffect);
var $61da5bd30f2af257$var$$$void = /* #__PURE__ */ $7FzSN.void($7244ec56ae5630bd$export$e8a7d9b8d7dc616a);
var $61da5bd30f2af257$var$foreachSlot = /* #__PURE__ */ $b10d220e1d5af382$export$91dbfdfb14db6990($1rTTn.applicativeEffect);
var $61da5bd30f2af257$var$renderStateX_ = /* #__PURE__ */ $34a3e460273cf155$export$dcc8908fea536646($1rTTn.applicativeEffect);
var $61da5bd30f2af257$var$tailRecM = /* #__PURE__ */ $bcJ05.tailRecM($bcJ05.monadRecEffect);
var $61da5bd30f2af257$var$voidLeft = /* #__PURE__ */ $7FzSN.voidLeft($1rTTn.functorEffect);
var $61da5bd30f2af257$var$bind1 = /* #__PURE__ */ $cADnC.bind($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $61da5bd30f2af257$var$liftEffect1 = /* #__PURE__ */ $54d5aa8d31ad5798$export$34255e15eb56d2b3($54d5aa8d31ad5798$export$86a2e24932ca2aa0);
var $61da5bd30f2af257$var$newLifecycleHandlers = /* #__PURE__ */ function() {
    return $7fHqi.new({
        initializers: $fZenR.Nil.value,
        finalizers: $fZenR.Nil.value
    });
}();
var $61da5bd30f2af257$var$handlePending = function(ref) {
    return function __do() {
        var queue = $7fHqi.read(ref)();
        $7fHqi.write($h2xUu.Nothing.value)(ref)();
        return $61da5bd30f2af257$var$for_(queue)(function() {
            var $58 = $61da5bd30f2af257$var$traverse_($61da5bd30f2af257$var$fork);
            return function($59) {
                return $5b357b49a3aa55a9$export$c4c41c035efd1fb3($58($5krR0.reverse($59)));
            };
        }())();
    };
};
var $61da5bd30f2af257$var$cleanupSubscriptionsAndForks = function(v) {
    return function __do() {
        $61da5bd30f2af257$var$bindFlipped($61da5bd30f2af257$var$traverse_2($61da5bd30f2af257$var$traverse_3($ae794effd2a529f9$export$f500693cef883ffd)))($7fHqi.read(v.subscriptions))();
        $7fHqi.write($h2xUu.Nothing.value)(v.subscriptions)();
        $61da5bd30f2af257$var$bindFlipped($61da5bd30f2af257$var$traverse_3(function() {
            var $60 = $7244ec56ae5630bd$export$c65b2010df1810d($f58bea5e58d54301$export$a3bc9b8ed74fc("finalized"));
            return function($61) {
                return $5b357b49a3aa55a9$export$c4c41c035efd1fb3($60($61));
            };
        }()))($7fHqi.read(v.forks))();
        return $7fHqi.write($aHmxC.empty)(v.forks)();
    };
};
var $61da5bd30f2af257$export$32d31a833a940d1c = function(renderSpec) {
    return function(component) {
        return function(i) {
            var squashChildInitializers = function(lchs) {
                return function(preInits) {
                    return $34a3e460273cf155$export$b325883598264040(function(st) {
                        var parentInitializer = $5b357b49a3aa55a9$export$b505393bc8c03d39(render)(st.selfRef)(st["component"]["eval"](new $5573693fd45dda6e$export$b03b1c699c90a9b4($2jM6U.unit)));
                        return $7fHqi.modify_(function(handlers) {
                            return {
                                initializers: new $fZenR.Cons($61da5bd30f2af257$var$discard2($61da5bd30f2af257$var$parSequence_($5krR0.reverse(handlers.initializers)))(function() {
                                    return $61da5bd30f2af257$var$discard2(parentInitializer)(function() {
                                        return $61da5bd30f2af257$var$liftEffect(function __do() {
                                            $61da5bd30f2af257$var$handlePending(st.pendingQueries)();
                                            return $61da5bd30f2af257$var$handlePending(st.pendingOuts)();
                                        });
                                    });
                                }), preInits),
                                finalizers: handlers.finalizers
                            };
                        })(lchs);
                    });
                };
            };
            var runComponent = function(lchs) {
                return function(handler) {
                    return function(j) {
                        return $02809249bead6832$export$802c6b8ce0f42195(function(c) {
                            return function __do() {
                                var lchs$prime = $61da5bd30f2af257$var$newLifecycleHandlers();
                                var $$var = $34a3e460273cf155$export$2999486de8d3a294(c)(j)(handler)(lchs$prime)();
                                var pre = $7fHqi.read(lchs)();
                                $7fHqi.write({
                                    initializers: $fZenR.Nil.value,
                                    finalizers: pre.finalizers
                                })(lchs)();
                                $61da5bd30f2af257$var$bindFlipped($34a3e460273cf155$export$b325883598264040(function() {
                                    var $62 = render(lchs);
                                    return function($63) {
                                        return $62(function(v) {
                                            return v.selfRef;
                                        }($63));
                                    };
                                }()))($7fHqi.read($$var))();
                                $61da5bd30f2af257$var$bindFlipped(squashChildInitializers(lchs)(pre.initializers))($7fHqi.read($$var))();
                                return $$var;
                            };
                        });
                    };
                };
            };
            var renderChild = function(lchs) {
                return function(handler) {
                    return function(childrenInRef) {
                        return function(childrenOutRef) {
                            return $02809249bead6832$export$48f0293959eb16ec(function(slot) {
                                return function __do() {
                                    var childrenIn = $61da5bd30f2af257$var$map(slot.pop)($7fHqi.read(childrenInRef))();
                                    var $$var = function() {
                                        if (childrenIn instanceof $h2xUu.Just) {
                                            $7fHqi.write(childrenIn.value0.value1)(childrenInRef)();
                                            var dsx = $7fHqi.read(childrenIn.value0.value0)();
                                            $34a3e460273cf155$export$b325883598264040(function(st) {
                                                return function __do() {
                                                    $jhsiw.flip($7fHqi.write)(st.handlerRef)(function() {
                                                        var $64 = $h2xUu.maybe($61da5bd30f2af257$var$pure1($2jM6U.unit))(handler);
                                                        return function($65) {
                                                            return $64(slot.output($65));
                                                        };
                                                    }())();
                                                    return $5b357b49a3aa55a9$export$c4c41c035efd1fb3($5b357b49a3aa55a9$export$b505393bc8c03d39(render)(st.selfRef)(st["component"]["eval"](new $5573693fd45dda6e$export$fc713a64b8ca1b7a(slot.input, $2jM6U.unit))))();
                                                };
                                            })(dsx)();
                                            return childrenIn.value0.value0;
                                        }
                                        if (childrenIn instanceof $h2xUu.Nothing) return runComponent(lchs)(function() {
                                            var $66 = $h2xUu.maybe($61da5bd30f2af257$var$pure1($2jM6U.unit))(handler);
                                            return function($67) {
                                                return $66(slot.output($67));
                                            };
                                        }())(slot.input)(slot.component)();
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 213, column 14 - line 222, column 98): " + [
                                            childrenIn.constructor.name
                                        ]);
                                    }();
                                    var isDuplicate = $61da5bd30f2af257$var$map(function($68) {
                                        return $h2xUu.isJust(slot.get($68));
                                    })($7fHqi.read(childrenOutRef))();
                                    $61da5bd30f2af257$var$when(isDuplicate)($63b30336f9a70767$export$c106dd0671a0fc2d("Halogen: Duplicate slot address was detected during rendering, unexpected results may occur"))();
                                    $7fHqi.modify_(slot.set($$var))(childrenOutRef)();
                                    return $61da5bd30f2af257$var$bind($7fHqi.read($$var))($61da5bd30f2af257$var$renderStateX(function(v) {
                                        if (v instanceof $h2xUu.Nothing) return $0185c1dbbe0f9876$export$7b1a37e4f0fe815("Halogen internal error: child was not initialized in renderChild");
                                        if (v instanceof $h2xUu.Just) return $61da5bd30f2af257$var$pure(renderSpec.renderChild(v.value0));
                                        throw new Error("Failed pattern match at Halogen.Aff.Driver (line 227, column 37 - line 229, column 50): " + [
                                            v.constructor.name
                                        ]);
                                    }))();
                                };
                            });
                        };
                    };
                };
            };
            var render = function(lchs) {
                return function($$var) {
                    return function __do() {
                        var v = $7fHqi.read($$var)();
                        var shouldProcessHandlers = $61da5bd30f2af257$var$map($h2xUu.isNothing)($7fHqi.read(v.pendingHandlers))();
                        $61da5bd30f2af257$var$when(shouldProcessHandlers)($7fHqi.write(new $h2xUu.Just($fZenR.Nil.value))(v.pendingHandlers))();
                        $7fHqi.write($b10d220e1d5af382$export$6e22c362a0406a2c)(v.childrenOut)();
                        $7fHqi.write(v.children)(v.childrenIn)();
                        var handler = function() {
                            var $69 = $5b357b49a3aa55a9$export$2d912d1764c6009b(v.pendingHandlers);
                            var $70 = $5b357b49a3aa55a9$export$6533955444d826a5(render)(v.selfRef);
                            return function($71) {
                                return $69($61da5bd30f2af257$var$$$void($70($71)));
                            };
                        }();
                        var childHandler = function() {
                            var $72 = $5b357b49a3aa55a9$export$2d912d1764c6009b(v.pendingQueries);
                            return function($73) {
                                return $72(handler($e7ddcc4e56dd1e0b$export$e19cd5f9376f8cee.create($73)));
                            };
                        }();
                        var rendering = renderSpec.render(function($74) {
                            return $5b357b49a3aa55a9$export$c4c41c035efd1fb3(handler($74));
                        })(renderChild(lchs)(childHandler)(v.childrenIn)(v.childrenOut))(v.component.render(v.state))(v.rendering)();
                        var children = $7fHqi.read(v.childrenOut)();
                        var childrenIn = $7fHqi.read(v.childrenIn)();
                        $61da5bd30f2af257$var$foreachSlot(childrenIn)(function(v1) {
                            return function __do() {
                                var childDS = $7fHqi.read(v1)();
                                $61da5bd30f2af257$var$renderStateX_(renderSpec.removeChild)(childDS)();
                                return finalize(lchs)(childDS)();
                            };
                        })();
                        $jhsiw.flip($7fHqi.modify_)(v.selfRef)($34a3e460273cf155$export$43ced40f2a8d1657(function(ds$prime) {
                            return {
                                component: ds$prime.component,
                                state: ds$prime.state,
                                refs: ds$prime.refs,
                                childrenIn: ds$prime.childrenIn,
                                childrenOut: ds$prime.childrenOut,
                                selfRef: ds$prime.selfRef,
                                handlerRef: ds$prime.handlerRef,
                                pendingQueries: ds$prime.pendingQueries,
                                pendingOuts: ds$prime.pendingOuts,
                                pendingHandlers: ds$prime.pendingHandlers,
                                fresh: ds$prime.fresh,
                                subscriptions: ds$prime.subscriptions,
                                forks: ds$prime.forks,
                                lifecycleHandlers: ds$prime.lifecycleHandlers,
                                rendering: new $h2xUu.Just(rendering),
                                children: children
                            };
                        }))();
                        return $61da5bd30f2af257$var$when(shouldProcessHandlers)($jhsiw.flip($61da5bd30f2af257$var$tailRecM)($2jM6U.unit)(function(v1) {
                            return function __do() {
                                var handlers = $7fHqi.read(v.pendingHandlers)();
                                $7fHqi.write(new $h2xUu.Just($fZenR.Nil.value))(v.pendingHandlers)();
                                $61da5bd30f2af257$var$traverse_2(function() {
                                    var $75 = $61da5bd30f2af257$var$traverse_($61da5bd30f2af257$var$fork);
                                    return function($76) {
                                        return $5b357b49a3aa55a9$export$c4c41c035efd1fb3($75($5krR0.reverse($76)));
                                    };
                                }())(handlers)();
                                var mmore = $7fHqi.read(v.pendingHandlers)();
                                var $51 = $h2xUu.maybe(false)($5krR0.null)(mmore);
                                if ($51) return $61da5bd30f2af257$var$voidLeft($7fHqi.write($h2xUu.Nothing.value)(v.pendingHandlers))(new $bcJ05.Done($2jM6U.unit))();
                                return new $bcJ05.Loop($2jM6U.unit);
                            };
                        }))();
                    };
                };
            };
            var finalize = function(lchs) {
                return $34a3e460273cf155$export$b325883598264040(function(st) {
                    return function __do() {
                        $61da5bd30f2af257$var$cleanupSubscriptionsAndForks(st)();
                        var f = $5b357b49a3aa55a9$export$b505393bc8c03d39(render)(st.selfRef)(st["component"]["eval"](new $5573693fd45dda6e$export$29defdae7b3f3a01($2jM6U.unit)));
                        $7fHqi.modify_(function(handlers) {
                            return {
                                initializers: handlers.initializers,
                                finalizers: new $fZenR.Cons(f, handlers.finalizers)
                            };
                        })(lchs)();
                        return $61da5bd30f2af257$var$foreachSlot(st.children)(function(v) {
                            return function __do() {
                                var dsx = $7fHqi.read(v)();
                                return finalize(lchs)(dsx)();
                            };
                        })();
                    };
                });
            };
            var evalDriver = function(disposed) {
                return function(ref) {
                    return function(q) {
                        return $61da5bd30f2af257$var$bind1($61da5bd30f2af257$var$liftEffect($7fHqi.read(disposed)))(function(v) {
                            if (v) return $61da5bd30f2af257$var$pure1($h2xUu.Nothing.value);
                            return $5b357b49a3aa55a9$export$f960635a4c7f8a61(render)(ref)(q);
                        });
                    };
                };
            };
            var dispose = function(disposed) {
                return function(lchs) {
                    return function(dsx) {
                        return $5b357b49a3aa55a9$export$b7a8cef929df0d3c(lchs)(function __do() {
                            var v = $7fHqi.read(disposed)();
                            if (v) return $2jM6U.unit;
                            $7fHqi.write(true)(disposed)();
                            finalize(lchs)(dsx)();
                            return $34a3e460273cf155$export$b325883598264040(function(v1) {
                                return function __do() {
                                    var v2 = $61da5bd30f2af257$var$liftEffect1($7fHqi.read(v1.selfRef))();
                                    return $61da5bd30f2af257$var$for_(v2.rendering)(renderSpec.dispose)();
                                };
                            })(dsx)();
                        });
                    };
                };
            };
            return $61da5bd30f2af257$var$bind1($61da5bd30f2af257$var$liftEffect($61da5bd30f2af257$var$newLifecycleHandlers))(function(lchs) {
                return $61da5bd30f2af257$var$bind1($61da5bd30f2af257$var$liftEffect($7fHqi.new(false)))(function(disposed) {
                    return $5b357b49a3aa55a9$export$b7a8cef929df0d3c(lchs)(function __do() {
                        var sio = $ae794effd2a529f9$export$185802fd694ee1f5();
                        var dsx = $61da5bd30f2af257$var$bindFlipped($7fHqi.read)(runComponent(lchs)(function() {
                            var $77 = $ae794effd2a529f9$export$5e14cdade93d6f7b(sio.listener);
                            return function($78) {
                                return $61da5bd30f2af257$var$liftEffect($77($78));
                            };
                        }())(i)(component))();
                        return $34a3e460273cf155$export$b325883598264040(function(st) {
                            return $61da5bd30f2af257$var$pure({
                                query: evalDriver(disposed)(st.selfRef),
                                messages: sio.emitter,
                                dispose: dispose(disposed)(lchs)(dsx)
                            });
                        })(dsx)();
                    });
                });
            });
        };
    };
};









// Generated by purs version 0.15.16
var $edefb1d3abce37c3$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
function $edefb1d3abce37c3$export$c441300b2d51b958(node) {
    return node.nodeType;
}
function $edefb1d3abce37c3$export$860bddf988a8498c(node) {
    return node.nodeName;
}
const $edefb1d3abce37c3$export$74061d4f476da680 = $edefb1d3abce37c3$var$getEffProp("baseURI");
const $edefb1d3abce37c3$export$23cc1b2a9bb6c61a = $edefb1d3abce37c3$var$getEffProp("ownerDocument");
const $edefb1d3abce37c3$export$72030ded560177b6 = $edefb1d3abce37c3$var$getEffProp("parentNode");
const $edefb1d3abce37c3$export$e8e77848f4a9ad40 = $edefb1d3abce37c3$var$getEffProp("parentElement");
function $edefb1d3abce37c3$export$13782f450ac5e09a(node) {
    return function() {
        return node.hasChildNodes();
    };
}
const $edefb1d3abce37c3$export$c9fa23d9ff60a2d1 = $edefb1d3abce37c3$var$getEffProp("childNodes");
const $edefb1d3abce37c3$export$274e0d97326033db = $edefb1d3abce37c3$var$getEffProp("firstChild");
const $edefb1d3abce37c3$export$951f870fb0fe03c3 = $edefb1d3abce37c3$var$getEffProp("lastChild");
const $edefb1d3abce37c3$export$e2e6c080f0f2a76d = $edefb1d3abce37c3$var$getEffProp("previousSibling");
const $edefb1d3abce37c3$export$2eda4366e9b7c29f = $edefb1d3abce37c3$var$getEffProp("nextSibling");
const $edefb1d3abce37c3$export$d6cd495109f5e655 = $edefb1d3abce37c3$var$getEffProp("nodeValue");
function $edefb1d3abce37c3$export$df6212ebae08b450(value) {
    return function(node) {
        return function() {
            node.nodeValue = value;
        };
    };
}
const $edefb1d3abce37c3$export$e0e0794250e9118f = $edefb1d3abce37c3$var$getEffProp("textContent");
function $edefb1d3abce37c3$export$94b0296cab6203e(value) {
    return function(node) {
        return function() {
            node.textContent = value;
        };
    };
}
function $edefb1d3abce37c3$export$a3295358bff77e(node) {
    return function() {
        node.normalize();
    };
}
function $edefb1d3abce37c3$export$9cd59f9826255e47(node) {
    return function() {
        return node.cloneNode(false);
    };
}
function $edefb1d3abce37c3$export$b7d58db314e0ac27(node) {
    return function() {
        return node.cloneNode(true);
    };
}
function $edefb1d3abce37c3$export$55e9b4d3368d84dd(node1) {
    return function(node2) {
        return function() {
            return node1.isEqualNode(node2);
        };
    };
}
function $edefb1d3abce37c3$export$aff35b31398d5fba(node1) {
    return function(node2) {
        return function() {
            return node1.compareDocumentPosition(node2);
        };
    };
}
function $edefb1d3abce37c3$export$2344b14b097df817(node1) {
    return function(node2) {
        return function() {
            return node1.contains(node2);
        };
    };
}
function $edefb1d3abce37c3$export$b9a4e863f082a036(prefix) {
    return function(node) {
        return function() {
            return node.lookupPrefix(prefix);
        };
    };
}
function $edefb1d3abce37c3$export$a79c57bed1c08193(ns) {
    return function(node) {
        return function() {
            return node.lookupNamespaceURI(ns);
        };
    };
}
function $edefb1d3abce37c3$export$61f41c073d810e4f(ns) {
    return function(node) {
        return function() {
            return node.isDefaultNamespace(ns);
        };
    };
}
function $edefb1d3abce37c3$export$86b68c7dbeb53c22(node1) {
    return function(node2) {
        return function(parent) {
            return function() {
                parent.insertBefore(node1, node2);
            };
        };
    };
}
function $edefb1d3abce37c3$export$1b8e57c9ea42f1d2(node) {
    return function(parent) {
        return function() {
            parent.appendChild(node);
        };
    };
}
function $edefb1d3abce37c3$export$46f78da0e790aab7(newChild) {
    return function(oldChild) {
        return function(parent) {
            return function() {
                parent.replaceChild(newChild, oldChild);
            };
        };
    };
}
function $edefb1d3abce37c3$export$7ae609f7af59e4f7(node) {
    return function(parent) {
        return function() {
            parent.removeChild(node);
        };
    };
}



var $dIXGo = parcelRequire("dIXGo");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");


var $1rTTn = parcelRequire("1rTTn");

var $k2DSm = parcelRequire("k2DSm");

// Generated by purs version 0.15.16

var $dIXGo = parcelRequire("dIXGo");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");
var $da7a256bf6b84ed2$var$compare = /* #__PURE__ */ $gwBF5.compare($gwBF5.ordInt);
var $da7a256bf6b84ed2$export$dc064fe9e59310fd = /* #__PURE__ */ function() {
    function ElementNode() {}
    ElementNode.value = new ElementNode();
    return ElementNode;
}();
var $da7a256bf6b84ed2$export$dc88047a888cd46b = /* #__PURE__ */ function() {
    function AttributeNode() {}
    AttributeNode.value = new AttributeNode();
    return AttributeNode;
}();
var $da7a256bf6b84ed2$export$f0a25ea3087686aa = /* #__PURE__ */ function() {
    function TextNode() {}
    TextNode.value = new TextNode();
    return TextNode;
}();
var $da7a256bf6b84ed2$export$28835d60136fdd55 = /* #__PURE__ */ function() {
    function CDATASectionNode() {}
    CDATASectionNode.value = new CDATASectionNode();
    return CDATASectionNode;
}();
var $da7a256bf6b84ed2$export$a4de1a63043e7a6d = /* #__PURE__ */ function() {
    function EntityReferenceNode() {}
    EntityReferenceNode.value = new EntityReferenceNode();
    return EntityReferenceNode;
}();
var $da7a256bf6b84ed2$export$34dac3329b92804f = /* #__PURE__ */ function() {
    function EntityNode() {}
    EntityNode.value = new EntityNode();
    return EntityNode;
}();
var $da7a256bf6b84ed2$export$2458c2a2a9d8a0a8 = /* #__PURE__ */ function() {
    function ProcessingInstructionNode() {}
    ProcessingInstructionNode.value = new ProcessingInstructionNode();
    return ProcessingInstructionNode;
}();
var $da7a256bf6b84ed2$export$dd3132c03c97153e = /* #__PURE__ */ function() {
    function CommentNode() {}
    CommentNode.value = new CommentNode();
    return CommentNode;
}();
var $da7a256bf6b84ed2$export$9da34d55490083d8 = /* #__PURE__ */ function() {
    function DocumentNode() {}
    DocumentNode.value = new DocumentNode();
    return DocumentNode;
}();
var $da7a256bf6b84ed2$export$c4edab6ab3262a44 = /* #__PURE__ */ function() {
    function DocumentTypeNode() {}
    DocumentTypeNode.value = new DocumentTypeNode();
    return DocumentTypeNode;
}();
var $da7a256bf6b84ed2$export$ed75c007fb9b19c0 = /* #__PURE__ */ function() {
    function DocumentFragmentNode() {}
    DocumentFragmentNode.value = new DocumentFragmentNode();
    return DocumentFragmentNode;
}();
var $da7a256bf6b84ed2$export$71dc25271abd047 = /* #__PURE__ */ function() {
    function NotationNode() {}
    NotationNode.value = new NotationNode();
    return NotationNode;
}();
var $da7a256bf6b84ed2$var$toEnumNodeType = function(v) {
    if (v === 1) return new $h2xUu.Just($da7a256bf6b84ed2$export$dc064fe9e59310fd.value);
    if (v === 2) return new $h2xUu.Just($da7a256bf6b84ed2$export$dc88047a888cd46b.value);
    if (v === 3) return new $h2xUu.Just($da7a256bf6b84ed2$export$f0a25ea3087686aa.value);
    if (v === 4) return new $h2xUu.Just($da7a256bf6b84ed2$export$28835d60136fdd55.value);
    if (v === 5) return new $h2xUu.Just($da7a256bf6b84ed2$export$a4de1a63043e7a6d.value);
    if (v === 6) return new $h2xUu.Just($da7a256bf6b84ed2$export$34dac3329b92804f.value);
    if (v === 7) return new $h2xUu.Just($da7a256bf6b84ed2$export$2458c2a2a9d8a0a8.value);
    if (v === 8) return new $h2xUu.Just($da7a256bf6b84ed2$export$dd3132c03c97153e.value);
    if (v === 9) return new $h2xUu.Just($da7a256bf6b84ed2$export$9da34d55490083d8.value);
    if (v === 10) return new $h2xUu.Just($da7a256bf6b84ed2$export$c4edab6ab3262a44.value);
    if (v === 11) return new $h2xUu.Just($da7a256bf6b84ed2$export$ed75c007fb9b19c0.value);
    if (v === 12) return new $h2xUu.Just($da7a256bf6b84ed2$export$71dc25271abd047.value);
    return $h2xUu.Nothing.value;
};
var $da7a256bf6b84ed2$export$eb0d4895a3e15732 = {
    show: function(v) {
        if (v instanceof $da7a256bf6b84ed2$export$dc064fe9e59310fd) return "ElementNode";
        if (v instanceof $da7a256bf6b84ed2$export$dc88047a888cd46b) return "AttributeNode";
        if (v instanceof $da7a256bf6b84ed2$export$f0a25ea3087686aa) return "TextNode";
        if (v instanceof $da7a256bf6b84ed2$export$28835d60136fdd55) return "CDATASectionNode";
        if (v instanceof $da7a256bf6b84ed2$export$a4de1a63043e7a6d) return "EntityReferenceNode";
        if (v instanceof $da7a256bf6b84ed2$export$34dac3329b92804f) return "EntityNode";
        if (v instanceof $da7a256bf6b84ed2$export$2458c2a2a9d8a0a8) return "ProcessingInstructionNode";
        if (v instanceof $da7a256bf6b84ed2$export$dd3132c03c97153e) return "CommentNode";
        if (v instanceof $da7a256bf6b84ed2$export$9da34d55490083d8) return "DocumentNode";
        if (v instanceof $da7a256bf6b84ed2$export$c4edab6ab3262a44) return "DocumentTypeNode";
        if (v instanceof $da7a256bf6b84ed2$export$ed75c007fb9b19c0) return "DocumentFragmentNode";
        if (v instanceof $da7a256bf6b84ed2$export$71dc25271abd047) return "NotationNode";
        throw new Error("Failed pattern match at Web.DOM.NodeType (line 39, column 1 - line 51, column 37): " + [
            v.constructor.name
        ]);
    }
};
var $da7a256bf6b84ed2$var$fromEnumNodeType = function(v) {
    if (v instanceof $da7a256bf6b84ed2$export$dc064fe9e59310fd) return 1;
    if (v instanceof $da7a256bf6b84ed2$export$dc88047a888cd46b) return 2;
    if (v instanceof $da7a256bf6b84ed2$export$f0a25ea3087686aa) return 3;
    if (v instanceof $da7a256bf6b84ed2$export$28835d60136fdd55) return 4;
    if (v instanceof $da7a256bf6b84ed2$export$a4de1a63043e7a6d) return 5;
    if (v instanceof $da7a256bf6b84ed2$export$34dac3329b92804f) return 6;
    if (v instanceof $da7a256bf6b84ed2$export$2458c2a2a9d8a0a8) return 7;
    if (v instanceof $da7a256bf6b84ed2$export$dd3132c03c97153e) return 8;
    if (v instanceof $da7a256bf6b84ed2$export$9da34d55490083d8) return 9;
    if (v instanceof $da7a256bf6b84ed2$export$c4edab6ab3262a44) return 10;
    if (v instanceof $da7a256bf6b84ed2$export$ed75c007fb9b19c0) return 11;
    if (v instanceof $da7a256bf6b84ed2$export$71dc25271abd047) return 12;
    throw new Error("Failed pattern match at Web.DOM.NodeType (line 68, column 1 - line 68, column 36): " + [
        v.constructor.name
    ]);
};
var $da7a256bf6b84ed2$export$88377e09539feb78 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $da7a256bf6b84ed2$export$dc064fe9e59310fd && y instanceof $da7a256bf6b84ed2$export$dc064fe9e59310fd) return true;
            if (x instanceof $da7a256bf6b84ed2$export$dc88047a888cd46b && y instanceof $da7a256bf6b84ed2$export$dc88047a888cd46b) return true;
            if (x instanceof $da7a256bf6b84ed2$export$f0a25ea3087686aa && y instanceof $da7a256bf6b84ed2$export$f0a25ea3087686aa) return true;
            if (x instanceof $da7a256bf6b84ed2$export$28835d60136fdd55 && y instanceof $da7a256bf6b84ed2$export$28835d60136fdd55) return true;
            if (x instanceof $da7a256bf6b84ed2$export$a4de1a63043e7a6d && y instanceof $da7a256bf6b84ed2$export$a4de1a63043e7a6d) return true;
            if (x instanceof $da7a256bf6b84ed2$export$34dac3329b92804f && y instanceof $da7a256bf6b84ed2$export$34dac3329b92804f) return true;
            if (x instanceof $da7a256bf6b84ed2$export$2458c2a2a9d8a0a8 && y instanceof $da7a256bf6b84ed2$export$2458c2a2a9d8a0a8) return true;
            if (x instanceof $da7a256bf6b84ed2$export$dd3132c03c97153e && y instanceof $da7a256bf6b84ed2$export$dd3132c03c97153e) return true;
            if (x instanceof $da7a256bf6b84ed2$export$9da34d55490083d8 && y instanceof $da7a256bf6b84ed2$export$9da34d55490083d8) return true;
            if (x instanceof $da7a256bf6b84ed2$export$c4edab6ab3262a44 && y instanceof $da7a256bf6b84ed2$export$c4edab6ab3262a44) return true;
            if (x instanceof $da7a256bf6b84ed2$export$ed75c007fb9b19c0 && y instanceof $da7a256bf6b84ed2$export$ed75c007fb9b19c0) return true;
            if (x instanceof $da7a256bf6b84ed2$export$71dc25271abd047 && y instanceof $da7a256bf6b84ed2$export$71dc25271abd047) return true;
            return false;
        };
    }
};
var $da7a256bf6b84ed2$export$98741689c6e0b987 = {
    compare: function(x) {
        return function(y) {
            return $da7a256bf6b84ed2$var$compare($da7a256bf6b84ed2$var$fromEnumNodeType(x))($da7a256bf6b84ed2$var$fromEnumNodeType(y));
        };
    },
    Eq0: function() {
        return $da7a256bf6b84ed2$export$88377e09539feb78;
    }
};
var $da7a256bf6b84ed2$export$61b56a5f9f6230cb = {
    succ: /* #__PURE__ */ $dIXGo.defaultSucc($da7a256bf6b84ed2$var$toEnumNodeType)($da7a256bf6b84ed2$var$fromEnumNodeType),
    pred: /* #__PURE__ */ $dIXGo.defaultPred($da7a256bf6b84ed2$var$toEnumNodeType)($da7a256bf6b84ed2$var$fromEnumNodeType),
    Ord0: function() {
        return $da7a256bf6b84ed2$export$98741689c6e0b987;
    }
};
var $da7a256bf6b84ed2$export$5879f3f4738185fd = /* #__PURE__ */ function() {
    return {
        bottom: $da7a256bf6b84ed2$export$dc064fe9e59310fd.value,
        top: $da7a256bf6b84ed2$export$71dc25271abd047.value,
        Ord0: function() {
            return $da7a256bf6b84ed2$export$98741689c6e0b987;
        }
    };
}();
var $da7a256bf6b84ed2$export$db18e9bcd7fea75b = {
    cardinality: 12,
    toEnum: $da7a256bf6b84ed2$var$toEnumNodeType,
    fromEnum: $da7a256bf6b84ed2$var$fromEnumNodeType,
    Bounded0: function() {
        return $da7a256bf6b84ed2$export$5879f3f4738185fd;
    },
    Enum1: function() {
        return $da7a256bf6b84ed2$export$61b56a5f9f6230cb;
    }
};



var $e212d67cebc8c8ed$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $e212d67cebc8c8ed$var$fromJust = /* #__PURE__ */ $h2xUu.fromJust();
var $e212d67cebc8c8ed$var$toEnum = /* #__PURE__ */ $dIXGo.toEnum($da7a256bf6b84ed2$export$db18e9bcd7fea75b);
var $e212d67cebc8c8ed$export$55c9526d22b9f8e6 = $k2DSm.unsafeCoerce;
var $e212d67cebc8c8ed$export$6c33a601ef71fce7 = /* #__PURE__ */ function() {
    var $4 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($edefb1d3abce37c3$export$e2e6c080f0f2a76d($5));
    };
}();
var $e212d67cebc8c8ed$export$b54be7ce267a037b = /* #__PURE__ */ function() {
    var $6 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($7) {
        return $6($edefb1d3abce37c3$export$72030ded560177b6($7));
    };
}();
var $e212d67cebc8c8ed$export$222ab8a52715b4f4 = /* #__PURE__ */ function() {
    var $8 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($9) {
        return $8($edefb1d3abce37c3$export$e8e77848f4a9ad40($9));
    };
}();
var $e212d67cebc8c8ed$export$512a1115db01100d = /* #__PURE__ */ function() {
    var $10 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($11) {
        return $10($edefb1d3abce37c3$export$23cc1b2a9bb6c61a($11));
    };
}();
var $e212d67cebc8c8ed$export$63bfedaececbd5f5 = /* #__PURE__ */ function() {
    var $12 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($13) {
        return $12($edefb1d3abce37c3$export$d6cd495109f5e655($13));
    };
}();
var $e212d67cebc8c8ed$export$4debbe1037afe35e = function() {
    return function($14) {
        return $e212d67cebc8c8ed$var$fromJust($e212d67cebc8c8ed$var$toEnum($edefb1d3abce37c3$export$c441300b2d51b958($14)));
    };
};
var $e212d67cebc8c8ed$export$335219007e689d29 = /* #__PURE__ */ function() {
    var $15 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($16) {
        return $15($edefb1d3abce37c3$export$2eda4366e9b7c29f($16));
    };
}();
var $e212d67cebc8c8ed$export$20ad2ac0440a470d = function(p) {
    var $17 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    var $18 = $edefb1d3abce37c3$export$b9a4e863f082a036(p);
    return function($19) {
        return $17($18($19));
    };
};
var $e212d67cebc8c8ed$export$eca9f13e904be86a = function(ns) {
    var $20 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    var $21 = $edefb1d3abce37c3$export$a79c57bed1c08193(ns);
    return function($22) {
        return $20($21($22));
    };
};
var $e212d67cebc8c8ed$export$86c2694e50e8251b = /* #__PURE__ */ function() {
    var $23 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($24) {
        return $23($edefb1d3abce37c3$export$951f870fb0fe03c3($24));
    };
}();
var $e212d67cebc8c8ed$export$a0a0bf09b44710c9 = /* #__PURE__ */ $567433c702f2bfe3$export$e3dc45f84eae905c("Node");
var $e212d67cebc8c8ed$export$b212a48622cd6ee3 = /* #__PURE__ */ function() {
    var $25 = $e212d67cebc8c8ed$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3);
    return function($26) {
        return $25($edefb1d3abce37c3$export$274e0d97326033db($26));
    };
}();






var $3426187151feb9eb$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $3426187151feb9eb$var$$$void = /* #__PURE__ */ $7FzSN.void($1rTTn.functorEffect);
var $3426187151feb9eb$var$pure = /* #__PURE__ */ $bQdkN.pure($1rTTn.applicativeEffect);
var $3426187151feb9eb$var$traverse_ = /* #__PURE__ */ $dNwPt.traverse_($1rTTn.applicativeEffect)($dNwPt.foldableMaybe);
var $3426187151feb9eb$var$unwrap = /* #__PURE__ */ $46y1S.unwrap();
var $3426187151feb9eb$var$when = /* #__PURE__ */ $bQdkN.when($1rTTn.applicativeEffect);
var $3426187151feb9eb$var$not = /* #__PURE__ */ $IhyKA.not(/* #__PURE__ */ $IhyKA.heytingAlgebraFunction(/* #__PURE__ */ $IhyKA.heytingAlgebraFunction($IhyKA.heytingAlgebraBoolean)));
var $3426187151feb9eb$var$identity = /* #__PURE__ */ $26SV5.identity($26SV5.categoryFn);
var $3426187151feb9eb$var$bind1 = /* #__PURE__ */ $cADnC.bind($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $3426187151feb9eb$var$liftEffect = /* #__PURE__ */ $54d5aa8d31ad5798$export$34255e15eb56d2b3($7244ec56ae5630bd$export$666a030cecdf96c);
var $3426187151feb9eb$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $3426187151feb9eb$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($1rTTn.bindEffect);
var $3426187151feb9eb$var$RenderState = function(x) {
    return x;
};
var $3426187151feb9eb$var$substInParent = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1 instanceof $h2xUu.Just && v2 instanceof $h2xUu.Just) return $3426187151feb9eb$var$$$void($edefb1d3abce37c3$export$86b68c7dbeb53c22(v)(v1.value0)(v2.value0));
            if (v1 instanceof $h2xUu.Nothing && v2 instanceof $h2xUu.Just) return $3426187151feb9eb$var$$$void($edefb1d3abce37c3$export$1b8e57c9ea42f1d2(v)(v2.value0));
            return $3426187151feb9eb$var$pure($2jM6U.unit);
        };
    };
};
var $3426187151feb9eb$var$removeChild = function(v) {
    return function __do() {
        var npn = $e212d67cebc8c8ed$export$b54be7ce267a037b(v.node)();
        return $3426187151feb9eb$var$traverse_(function(pn) {
            return $edefb1d3abce37c3$export$7ae609f7af59e4f7(v.node)(pn);
        })(npn)();
    };
};
var $3426187151feb9eb$var$mkSpec = function(handler) {
    return function(renderChildRef) {
        return function(document) {
            var getNode = $34a3e460273cf155$export$b29cd3b133bc0fa4(function(v) {
                return v.node;
            });
            var done = function(st) {
                if (st instanceof $h2xUu.Just) return $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de(st.value0);
                return $2jM6U.unit;
            };
            var buildWidget = function(spec) {
                var buildThunk = $ea9a396fdac62c85$export$d46b23c375182cf8($3426187151feb9eb$var$unwrap)(spec);
                var $lazy_patch = $3426187151feb9eb$var$$runtime_lazy("patch", "Halogen.VDom.Driver", function() {
                    return function(st, slot) {
                        if (st instanceof $h2xUu.Just) {
                            if (slot instanceof $02809249bead6832$export$bbf8b056cc92e88d) {
                                $c7f8bb6dcedfcaf7$export$ba038fef9cd0a0de(st.value0);
                                return $lazy_renderComponentSlot(100)(slot.value0);
                            }
                            if (slot instanceof $02809249bead6832$export$5e46cfa5e835a582) {
                                var step$prime = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(st.value0, slot.value0);
                                return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a($c7f8bb6dcedfcaf7$export$f9380c9a627682d3(step$prime), new $h2xUu.Just(step$prime), $lazy_patch(103), done));
                            }
                            throw new Error("Failed pattern match at Halogen.VDom.Driver (line 97, column 22 - line 103, column 79): " + [
                                slot.constructor.name
                            ]);
                        }
                        return $lazy_render(104)(slot);
                    };
                });
                var $lazy_render = $3426187151feb9eb$var$$runtime_lazy("render", "Halogen.VDom.Driver", function() {
                    return function(slot) {
                        if (slot instanceof $02809249bead6832$export$bbf8b056cc92e88d) return $lazy_renderComponentSlot(86)(slot.value0);
                        if (slot instanceof $02809249bead6832$export$5e46cfa5e835a582) {
                            var step = buildThunk(slot.value0);
                            return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a($c7f8bb6dcedfcaf7$export$f9380c9a627682d3(step), new $h2xUu.Just(step), $lazy_patch(89), done));
                        }
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 84, column 7 - line 89, column 75): " + [
                            slot.constructor.name
                        ]);
                    };
                });
                var $lazy_renderComponentSlot = $3426187151feb9eb$var$$runtime_lazy("renderComponentSlot", "Halogen.VDom.Driver", function() {
                    return function(cs) {
                        var renderChild = $7fHqi.read(renderChildRef)();
                        var rsx = renderChild(cs)();
                        var node = getNode(rsx);
                        return $c7f8bb6dcedfcaf7$export$dc52c2e07163a142(new $c7f8bb6dcedfcaf7$export$fd55ce593607084a(node, $h2xUu.Nothing.value, $lazy_patch(117), done));
                    };
                });
                var patch = $lazy_patch(91);
                var render = $lazy_render(82);
                var renderComponentSlot = $lazy_renderComponentSlot(109);
                return render;
            };
            var buildAttributes = $639bdac132f2bf25$export$ff441cf2113a23d9(handler);
            return {
                buildWidget: buildWidget,
                buildAttributes: buildAttributes,
                document: document
            };
        };
    };
};
var $3426187151feb9eb$var$renderSpec = function(document) {
    return function(container) {
        var render = function(handler) {
            return function(child) {
                return function(v) {
                    return function(v1) {
                        if (v1 instanceof $h2xUu.Nothing) return function __do() {
                            var renderChildRef = $7fHqi.new(child)();
                            var spec = $3426187151feb9eb$var$mkSpec(handler)(renderChildRef)(document);
                            var machine = $2bb7f7bd8b4c6f39$export$7d13c0f6790d0505(spec)(v);
                            var node = $c7f8bb6dcedfcaf7$export$f9380c9a627682d3(machine);
                            $3426187151feb9eb$var$$$void($edefb1d3abce37c3$export$1b8e57c9ea42f1d2(node)($13d4e6882f9a916b$export$83a0de4644f1fbc4(container)))();
                            return {
                                machine: machine,
                                node: node,
                                renderChildRef: renderChildRef
                            };
                        };
                        if (v1 instanceof $h2xUu.Just) return function __do() {
                            $7fHqi.write(child)(v1.value0.renderChildRef)();
                            var parent = $e212d67cebc8c8ed$export$b54be7ce267a037b(v1.value0.node)();
                            var nextSib = $e212d67cebc8c8ed$export$335219007e689d29(v1.value0.node)();
                            var machine$prime = $c7f8bb6dcedfcaf7$export$35d34bc0ed591a92(v1.value0.machine, v);
                            var newNode = $c7f8bb6dcedfcaf7$export$f9380c9a627682d3(machine$prime);
                            $3426187151feb9eb$var$when($3426187151feb9eb$var$not($369b9f59978cbcde$export$54d9901699893a6)(v1.value0.node)(newNode))($3426187151feb9eb$var$substInParent(newNode)(nextSib)(parent))();
                            return {
                                machine: machine$prime,
                                node: newNode,
                                renderChildRef: v1.value0.renderChildRef
                            };
                        };
                        throw new Error("Failed pattern match at Halogen.VDom.Driver (line 157, column 5 - line 173, column 80): " + [
                            v1.constructor.name
                        ]);
                    };
                };
            };
        };
        return {
            render: render,
            renderChild: $3426187151feb9eb$var$identity,
            removeChild: $3426187151feb9eb$var$removeChild,
            dispose: $3426187151feb9eb$var$removeChild
        };
    };
};
var $3426187151feb9eb$export$32d31a833a940d1c = function(component) {
    return function(i) {
        return function(element) {
            return $3426187151feb9eb$var$bind1($3426187151feb9eb$var$liftEffect($3426187151feb9eb$var$map($5551ee6cfcdc9d35$export$ce0e204f587740c3)($3426187151feb9eb$var$bindFlipped($6bfa62c8b92a1e7d$export$5a7bfc01df82fcd1)($df82538a253b5856$export$8291e5b88f90ce4))))(function(document) {
                return $61da5bd30f2af257$export$32d31a833a940d1c($3426187151feb9eb$var$renderSpec(document)(element))(component)(i);
            });
        };
    };
};


// Generated by purs version 0.15.16

var $brrpF = parcelRequire("brrpF");

var $aJhEx = parcelRequire("aJhEx");

var $h2xUu = parcelRequire("h2xUu");

var $2XxiF = parcelRequire("2XxiF");

var $d8ahy = parcelRequire("d8ahy");
// Generated by purs version 0.15.16

var $cADnC = parcelRequire("cADnC");

var $brrpF = parcelRequire("brrpF");

var $iQTlW = parcelRequire("iQTlW");

var $aJhEx = parcelRequire("aJhEx");

var $7FzSN = parcelRequire("7FzSN");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $bqDN9 = parcelRequire("bqDN9");

var $4Fu8m = parcelRequire("4Fu8m");

var $dL9YA = parcelRequire("dL9YA");
var $c2ac860adec87e7b$var$elemIndex = /* #__PURE__ */ $brrpF.elemIndex($aJhEx.eqChar);
var $c2ac860adec87e7b$var$map = /* #__PURE__ */ $7FzSN.map($7FzSN.functorArray);
var $c2ac860adec87e7b$var$nub = /* #__PURE__ */ $brrpF.nub($gwBF5.ordChar);
var $c2ac860adec87e7b$var$elem = /* #__PURE__ */ $brrpF.elem($aJhEx.eqChar);
var $c2ac860adec87e7b$var$bind = /* #__PURE__ */ $cADnC.bind($h2xUu.bindMaybe);
var $c2ac860adec87e7b$var$map1 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $c2ac860adec87e7b$export$d9ed483ea3e04670 = /* #__PURE__ */ function() {
    function SudokuKey() {}
    SudokuKey.value = new SudokuKey();
    return SudokuKey;
}();
var $c2ac860adec87e7b$export$e0cac371fe943738 = /* #__PURE__ */ function() {
    function ColorkuKey() {}
    ColorkuKey.value = new ColorkuKey();
    return ColorkuKey;
}();
var $c2ac860adec87e7b$export$d22ec6cc485f1d69 = /* #__PURE__ */ function() {
    function WordokuKey(value0) {
        this.value0 = value0;
    }
    WordokuKey.create = function(value0) {
        return new WordokuKey(value0);
    };
    return WordokuKey;
}();
var $c2ac860adec87e7b$export$c32f3f94e3628ace = 90;
var $c2ac860adec87e7b$export$19c57040161f39ba = {
    show: function(v) {
        if (v instanceof $c2ac860adec87e7b$export$d9ed483ea3e04670) return "SudokuKey";
        if (v instanceof $c2ac860adec87e7b$export$e0cac371fe943738) return "ColorkuKey";
        if (v instanceof $c2ac860adec87e7b$export$d22ec6cc485f1d69) return "WordokuKey " + v.value0;
        throw new Error("Failed pattern match at Sudoku.Encoding (line 30, column 1 - line 33, column 43): " + [
            v.constructor.name
        ]);
    }
};
var $c2ac860adec87e7b$export$723ff87aadc80347 = 81;
var $c2ac860adec87e7b$export$ba5769724a6c9a8f = 9;
var $c2ac860adec87e7b$export$94b69359774d6c2e = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c2ac860adec87e7b$export$d9ed483ea3e04670 && y instanceof $c2ac860adec87e7b$export$d9ed483ea3e04670) return true;
            if (x instanceof $c2ac860adec87e7b$export$e0cac371fe943738 && y instanceof $c2ac860adec87e7b$export$e0cac371fe943738) return true;
            if (x instanceof $c2ac860adec87e7b$export$d22ec6cc485f1d69 && y instanceof $c2ac860adec87e7b$export$d22ec6cc485f1d69) return x.value0 === y.value0;
            return false;
        };
    }
};
var $c2ac860adec87e7b$export$9c0987062f8f5d89 = "123456789";
var $c2ac860adec87e7b$export$f8f6563c0cfc2be4 = function(v) {
    if (v instanceof $c2ac860adec87e7b$export$d9ed483ea3e04670) return $c2ac860adec87e7b$export$9c0987062f8f5d89;
    if (v instanceof $c2ac860adec87e7b$export$e0cac371fe943738) return "ROYLGBIPV";
    if (v instanceof $c2ac860adec87e7b$export$d22ec6cc485f1d69) return v.value0;
    throw new Error("Failed pattern match at Sudoku.Encoding (line 35, column 1 - line 35, column 36): " + [
        v.constructor.name
    ]);
};
var $c2ac860adec87e7b$export$addfd075832a5773 = function(normalized) {
    return function(key) {
        return normalized + $c2ac860adec87e7b$export$f8f6563c0cfc2be4(key);
    };
};
var $c2ac860adec87e7b$export$e5bf51664196260 = function(dk) {
    return function(cell) {
        var key = $c2ac860adec87e7b$export$f8f6563c0cfc2be4(dk);
        var v = $c2ac860adec87e7b$var$elemIndex(cell)($4Fu8m.toCharArray(key));
        if (v instanceof $h2xUu.Just) return $h2xUu.fromMaybe("0")($4Fu8m.charAt(v.value0)($c2ac860adec87e7b$export$9c0987062f8f5d89));
        if (v instanceof $h2xUu.Nothing) return "0";
        throw new Error("Failed pattern match at Sudoku.Encoding (line 55, column 5 - line 57, column 21): " + [
            v.constructor.name
        ]);
    };
};
var $c2ac860adec87e7b$export$a3295358bff77e = function(dk) {
    return function(puzzle) {
        return $4Fu8m.fromCharArray($c2ac860adec87e7b$var$map($c2ac860adec87e7b$export$e5bf51664196260(dk))($4Fu8m.toCharArray(puzzle)));
    };
};
var $c2ac860adec87e7b$export$94243d401ffea539 = function(v) {
    return function(v1) {
        if (v instanceof $dL9YA.Sudoku && v1 === $c2ac860adec87e7b$export$9c0987062f8f5d89) return new $h2xUu.Just($c2ac860adec87e7b$export$d9ed483ea3e04670.value);
        if (v instanceof $dL9YA.Colorku && v1 === "ROYLGBIPV") return new $h2xUu.Just($c2ac860adec87e7b$export$e0cac371fe943738.value);
        if (v instanceof $dL9YA.Wordoku && $bqDN9.length(v1) === $c2ac860adec87e7b$export$ba5769724a6c9a8f && $bqDN9.length($4Fu8m.fromCharArray($c2ac860adec87e7b$var$nub($4Fu8m.toCharArray(v1)))) === $c2ac860adec87e7b$export$ba5769724a6c9a8f && !$c2ac860adec87e7b$var$elem(".")($4Fu8m.toCharArray(v1)) && $brrpF.all(function(c) {
            return c >= "a" && c <= "z";
        })($4Fu8m.toCharArray(v1))) return new $h2xUu.Just(new $c2ac860adec87e7b$export$d22ec6cc485f1d69(v1));
        return $h2xUu.Nothing.value;
    };
};
var $c2ac860adec87e7b$export$be8b9fcbce8e8f70 = function(dk) {
    return function(normalized) {
        var key = $c2ac860adec87e7b$export$f8f6563c0cfc2be4(dk);
        var denormalizeCell = function(v) {
            if (v === "0") return ".";
            return $h2xUu.fromMaybe(".")($c2ac860adec87e7b$var$bind($c2ac860adec87e7b$var$elemIndex(v)($4Fu8m.toCharArray($c2ac860adec87e7b$export$9c0987062f8f5d89)))(function(i) {
                return $4Fu8m.charAt(i)(key);
            }));
        };
        return $4Fu8m.fromCharArray($c2ac860adec87e7b$var$map(denormalizeCell)($4Fu8m.toCharArray(normalized)));
    };
};
var $c2ac860adec87e7b$export$1b6bd15906d11955 = function(g) {
    return function(s) {
        if ($bqDN9.length(s) === $c2ac860adec87e7b$export$c32f3f94e3628ace) {
            var v = $bqDN9.splitAt($c2ac860adec87e7b$export$723ff87aadc80347)(s);
            var $41 = $brrpF.all(function(c) {
                return c >= "0" && c <= "9";
            })($4Fu8m.toCharArray(v.before));
            if ($41) return $c2ac860adec87e7b$var$map1(function(v1) {
                return {
                    puzzle: v.before,
                    key: v1
                };
            })($c2ac860adec87e7b$export$94243d401ffea539(g)(v.after));
            return $h2xUu.Nothing.value;
        }
        if ($iQTlW.otherwise) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Sudoku.Encoding (line 74, column 1 - line 74, column 80): " + [
            g.constructor.name,
            s.constructor.name
        ]);
    };
};



var $dL9YA = parcelRequire("dL9YA");
var $7a278b4e06b1b8e1$var$show = /* #__PURE__ */ $2XxiF.show($dL9YA.showValues);
var $7a278b4e06b1b8e1$var$show1 = /* #__PURE__ */ $2XxiF.show($dL9YA.showDifficulty);
var $7a278b4e06b1b8e1$var$show2 = /* #__PURE__ */ $2XxiF.show($c2ac860adec87e7b$export$19c57040161f39ba);
var $7a278b4e06b1b8e1$var$eq = /* #__PURE__ */ $aJhEx.eq($dL9YA.valuesEq);
var $7a278b4e06b1b8e1$var$eq1 = /* #__PURE__ */ $aJhEx.eq($dL9YA.difficultyEq);
var $7a278b4e06b1b8e1$var$eq3 = /* #__PURE__ */ $aJhEx.eq($c2ac860adec87e7b$export$94b69359774d6c2e);
var $7a278b4e06b1b8e1$export$b94310965bed44e6 = /* #__PURE__ */ function() {
    function Home() {}
    Home.value = new Home();
    return Home;
}();
var $7a278b4e06b1b8e1$export$570d871acb6ff9b0 = /* #__PURE__ */ function() {
    function GameRoute(value0) {
        this.value0 = value0;
    }
    GameRoute.create = function(value0) {
        return new GameRoute(value0);
    };
    return GameRoute;
}();
var $7a278b4e06b1b8e1$export$bf18bab47e9dd8b4 = /* #__PURE__ */ function() {
    function DifficultyRoute(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DifficultyRoute.create = function(value0) {
        return function(value1) {
            return new DifficultyRoute(value0, value1);
        };
    };
    return DifficultyRoute;
}();
var $7a278b4e06b1b8e1$export$85746c16b5ccd576 = /* #__PURE__ */ function() {
    function PuzzleRoute(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    PuzzleRoute.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new PuzzleRoute(value0, value1, value2, value3);
                };
            };
        };
    };
    return PuzzleRoute;
}();
var $7a278b4e06b1b8e1$export$7ac5b0d359aa9a80 = {
    show: function(v) {
        if (v instanceof $7a278b4e06b1b8e1$export$b94310965bed44e6) return "Home";
        if (v instanceof $7a278b4e06b1b8e1$export$570d871acb6ff9b0) return "GameRoute " + $7a278b4e06b1b8e1$var$show(v.value0);
        if (v instanceof $7a278b4e06b1b8e1$export$bf18bab47e9dd8b4) return "DifficultyRoute " + ($7a278b4e06b1b8e1$var$show(v.value0) + (" " + $7a278b4e06b1b8e1$var$show1(v.value1)));
        if (v instanceof $7a278b4e06b1b8e1$export$85746c16b5ccd576) return "PuzzleRoute " + ($7a278b4e06b1b8e1$var$show(v.value0) + (" " + ($7a278b4e06b1b8e1$var$show1(v.value1) + (" " + (v.value2 + (" " + $7a278b4e06b1b8e1$var$show2(v.value3)))))));
        throw new Error("Failed pattern match at Routing (line 19, column 1 - line 23, column 102): " + [
            v.constructor.name
        ]);
    }
};
var $7a278b4e06b1b8e1$export$669d7bba4879c08a = function(s) {
    var v = $d8ahy.toLower(s);
    if (v === "sudoku") return new $h2xUu.Just($dL9YA.Sudoku.value);
    if (v === "wordoku") return new $h2xUu.Just($dL9YA.Wordoku.value);
    if (v === "colorku") return new $h2xUu.Just($dL9YA.Colorku.value);
    return $h2xUu.Nothing.value;
};
var $7a278b4e06b1b8e1$export$cd442626d06113a3 = function(s) {
    var v = $d8ahy.toLower(s);
    if (v === "beginner") return new $h2xUu.Just($dL9YA.Beginner.value);
    if (v === "casual") return new $h2xUu.Just($dL9YA.Casual.value);
    if (v === "tricky") return new $h2xUu.Just($dL9YA.Tricky.value);
    if (v === "difficult") return new $h2xUu.Just($dL9YA.Difficult.value);
    if (v === "challenge") return new $h2xUu.Just($dL9YA.Challenge.value);
    return $h2xUu.Nothing.value;
};
var $7a278b4e06b1b8e1$export$8ccf933b0513f8d0 = function(path) {
    var segments = $brrpF.filter(function(v) {
        return v !== "";
    })($d8ahy.split("/")(path));
    if (segments.length === 0) return $7a278b4e06b1b8e1$export$b94310965bed44e6.value;
    if (segments.length === 1) {
        var v = $7a278b4e06b1b8e1$export$669d7bba4879c08a(segments[0]);
        if (v instanceof $h2xUu.Just) return new $7a278b4e06b1b8e1$export$570d871acb6ff9b0(v.value0);
        if (v instanceof $h2xUu.Nothing) return $7a278b4e06b1b8e1$export$b94310965bed44e6.value;
        throw new Error("Failed pattern match at Routing (line 49, column 9 - line 51, column 26): " + [
            v.constructor.name
        ]);
    }
    if (segments.length === 2) {
        var v = $7a278b4e06b1b8e1$export$669d7bba4879c08a(segments[0]);
        if (v instanceof $h2xUu.Just) {
            var v1 = $7a278b4e06b1b8e1$export$cd442626d06113a3(segments[1]);
            if (v1 instanceof $h2xUu.Just) return new $7a278b4e06b1b8e1$export$bf18bab47e9dd8b4(v.value0, v1.value0);
            if (v1 instanceof $h2xUu.Nothing) return new $7a278b4e06b1b8e1$export$570d871acb6ff9b0(v.value0);
            throw new Error("Failed pattern match at Routing (line 55, column 13 - line 57, column 37): " + [
                v1.constructor.name
            ]);
        }
        if (v instanceof $h2xUu.Nothing) return $7a278b4e06b1b8e1$export$b94310965bed44e6.value;
        throw new Error("Failed pattern match at Routing (line 53, column 9 - line 58, column 26): " + [
            v.constructor.name
        ]);
    }
    var v = $brrpF.take(3)(segments);
    if (v.length === 3) {
        var v1 = $7a278b4e06b1b8e1$export$cd442626d06113a3(v[1]);
        var v2 = $7a278b4e06b1b8e1$export$669d7bba4879c08a(v[0]);
        if (v2 instanceof $h2xUu.Just && v1 instanceof $h2xUu.Just) {
            var v3 = $c2ac860adec87e7b$export$1b6bd15906d11955(v2.value0)(v[2]);
            if (v3 instanceof $h2xUu.Just) return new $7a278b4e06b1b8e1$export$85746c16b5ccd576(v2.value0, v1.value0, v3.value0.puzzle, v3.value0.key);
            return new $7a278b4e06b1b8e1$export$bf18bab47e9dd8b4(v2.value0, v1.value0);
        }
        if (v2 instanceof $h2xUu.Just && v1 instanceof $h2xUu.Nothing) return new $7a278b4e06b1b8e1$export$570d871acb6ff9b0(v2.value0);
        return $7a278b4e06b1b8e1$export$b94310965bed44e6.value;
    }
    return $7a278b4e06b1b8e1$export$b94310965bed44e6.value;
};
var $7a278b4e06b1b8e1$export$3bb0c2add650febc = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $7a278b4e06b1b8e1$export$b94310965bed44e6 && y instanceof $7a278b4e06b1b8e1$export$b94310965bed44e6) return true;
            if (x instanceof $7a278b4e06b1b8e1$export$570d871acb6ff9b0 && y instanceof $7a278b4e06b1b8e1$export$570d871acb6ff9b0) return $7a278b4e06b1b8e1$var$eq(x.value0)(y.value0);
            if (x instanceof $7a278b4e06b1b8e1$export$bf18bab47e9dd8b4 && y instanceof $7a278b4e06b1b8e1$export$bf18bab47e9dd8b4) return $7a278b4e06b1b8e1$var$eq(x.value0)(y.value0) && $7a278b4e06b1b8e1$var$eq1(x.value1)(y.value1);
            if (x instanceof $7a278b4e06b1b8e1$export$85746c16b5ccd576 && y instanceof $7a278b4e06b1b8e1$export$85746c16b5ccd576) return $7a278b4e06b1b8e1$var$eq(x.value0)(y.value0) && $7a278b4e06b1b8e1$var$eq1(x.value1)(y.value1) && x.value2 === y.value2 && $7a278b4e06b1b8e1$var$eq3(x.value3)(y.value3);
            return false;
        };
    }
};
var $7a278b4e06b1b8e1$export$5cc7f731b5937e99 = function(g) {
    return function(d) {
        return function(p) {
            return function(k) {
                return "/" + ($d8ahy.toLower($7a278b4e06b1b8e1$var$show(g)) + ("/" + ($d8ahy.toLower($7a278b4e06b1b8e1$var$show1(d)) + ("/" + $c2ac860adec87e7b$export$addfd075832a5773(p)(k)))));
            };
        };
    };
};


// Generated by purs version 0.15.16

var $brrpF = parcelRequire("brrpF");

var $iQTlW = parcelRequire("iQTlW");

var $beQI1 = parcelRequire("beQI1");

var $dIXGo = parcelRequire("dIXGo");

var $aJhEx = parcelRequire("aJhEx");

var $8tuSi = parcelRequire("8tuSi");

var $dNwPt = parcelRequire("dNwPt");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $4Fu8m = parcelRequire("4Fu8m");


var $lM1z4 = parcelRequire("lM1z4");

var $624no = parcelRequire("624no");
var $98a9f41a871de4aa$var$foldl = /* #__PURE__ */ $dNwPt.foldl($dNwPt.foldableArray);
var $98a9f41a871de4aa$var$fromEnum = /* #__PURE__ */ $dIXGo.fromEnum($dIXGo.boundedEnumChar);
var $98a9f41a871de4aa$var$mod = /* #__PURE__ */ $8tuSi.mod($8tuSi.euclideanRingInt);
var $98a9f41a871de4aa$var$eq = /* #__PURE__ */ $aJhEx.eq(/* #__PURE__ */ $h2xUu.eqMaybe($aJhEx.eqChar));
var $98a9f41a871de4aa$var$comparing = /* #__PURE__ */ $gwBF5.comparing($gwBF5.ordInt);
var $98a9f41a871de4aa$var$max = /* #__PURE__ */ $gwBF5.max($gwBF5.ordInt);
var $98a9f41a871de4aa$var$min = /* #__PURE__ */ $gwBF5.min($gwBF5.ordInt);
var $98a9f41a871de4aa$export$d0035e0fdcf9d643 = function(v) {
    if (v) return "Clues";
    if (!v) return "Solution";
    throw new Error("Failed pattern match at Sudoku.Display (line 31, column 1 - line 31, column 41): " + [
        v.constructor.name
    ]);
};
var $98a9f41a871de4aa$export$e7f407f8afc03bf0 = $h2xUu.isNothing;
var $98a9f41a871de4aa$var$hashSeed = function(s) {
    return $98a9f41a871de4aa$var$foldl(function(acc) {
        return function(c) {
            return (acc * 31 | 0) + $98a9f41a871de4aa$var$fromEnum(c) | 0;
        };
    })(0)($4Fu8m.toCharArray(s));
};
var $98a9f41a871de4aa$export$6cec9acd98c2e87b = function(v) {
    return function(v1) {
        return function(v2) {
            return function(v3) {
                if (!v1) return v2;
                if (v1 && v3 instanceof $h2xUu.Nothing) return v2;
                if (v1 && v3 instanceof $h2xUu.Just) {
                    var v4 = $624no.mkKey($c2ac860adec87e7b$export$f8f6563c0cfc2be4(v));
                    if (v4 instanceof $beQI1.Left) return v2;
                    if (v4 instanceof $beQI1.Right) return $lM1z4.gridString(v4.value0)(v3.value0);
                    throw new Error("Failed pattern match at Sudoku.Display (line 51, column 53 - line 53, column 31): " + [
                        v4.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Sudoku.Display (line 48, column 1 - line 48, column 81): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name,
                    v3.constructor.name
                ]);
            };
        };
    };
};
var $98a9f41a871de4aa$var$cellHash = function(seed) {
    return function(idx) {
        return $98a9f41a871de4aa$var$mod((seed * -1640531535 | 0) + (idx * 618033988 | 0) | 0)(1000000007);
    };
};
var $98a9f41a871de4aa$export$4942343b2075e032 = function(puzzle) {
    var seed = $98a9f41a871de4aa$var$hashSeed(puzzle);
    var chars = $4Fu8m.toCharArray(puzzle);
    var blanks = $brrpF.filter(function(i) {
        return $98a9f41a871de4aa$var$eq($brrpF.index(chars)(i))(new $h2xUu.Just("."));
    })($brrpF.range(0)($brrpF.length(chars) - 1 | 0));
    return $brrpF.sortBy($98a9f41a871de4aa$var$comparing($98a9f41a871de4aa$var$cellHash(seed)))(blanks);
};
var $98a9f41a871de4aa$export$93ff6e4a47ef9ceb = function(st) {
    return function(incomingId) {
        return function(result) {
            if (incomingId === st.latestRequestId) {
                if (result instanceof $beQI1.Right) return {
                    solution: new $h2xUu.Just(result.value0),
                    solveError: $h2xUu.Nothing.value
                };
                if (result instanceof $beQI1.Left) return {
                    solution: $h2xUu.Nothing.value,
                    solveError: new $h2xUu.Just(result.value0)
                };
                throw new Error("Failed pattern match at Sudoku.Display (line 70, column 7 - line 72, column 64): " + [
                    result.constructor.name
                ]);
            }
            if ($iQTlW.otherwise) return {
                solution: st.currentSolution,
                solveError: st.currentSolveError
            };
            throw new Error("Failed pattern match at Sudoku.Display (line 60, column 1 - line 67, column 60): " + [
                st.constructor.name,
                incomingId.constructor.name,
                result.constructor.name
            ]);
        };
    };
};
var $98a9f41a871de4aa$export$20bb241f9ca9a913 = function(key) {
    return function(n) {
        return function(puzzle) {
            return function(grid) {
                var v = $624no.mkKey($c2ac860adec87e7b$export$f8f6563c0cfc2be4(key));
                if (v instanceof $beQI1.Left) return puzzle;
                if (v instanceof $beQI1.Right) {
                    var solvedStr = $lM1z4.gridString(v.value0)(grid);
                    var solvedChars = $4Fu8m.toCharArray(solvedStr);
                    var reveal = function(cs) {
                        return function(i) {
                            var v1 = $brrpF.index(solvedChars)(i);
                            if (v1 instanceof $h2xUu.Just) return $h2xUu.fromMaybe(cs)($brrpF.updateAt(i)(v1.value0)(cs));
                            if (v1 instanceof $h2xUu.Nothing) return cs;
                            throw new Error("Failed pattern match at Sudoku.Display (line 134, column 21 - line 136, column 22): " + [
                                v1.constructor.name
                            ]);
                        };
                    };
                    var puzzleChars = $4Fu8m.toCharArray(puzzle);
                    var order = $98a9f41a871de4aa$export$4942343b2075e032(puzzle);
                    var blankCount = $brrpF.length(order);
                    var clamped = $98a9f41a871de4aa$var$max(0)($98a9f41a871de4aa$var$min(n)(blankCount));
                    var idxsToReveal = $brrpF.take(clamped)(order);
                    return $4Fu8m.fromCharArray($98a9f41a871de4aa$var$foldl(reveal)(puzzleChars)(idxsToReveal));
                }
                throw new Error("Failed pattern match at Sudoku.Display (line 121, column 32 - line 138, column 60): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $98a9f41a871de4aa$export$7cf6441693043538 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v instanceof $h2xUu.Nothing) return true;
            if (v instanceof $h2xUu.Just) return v1 >= $brrpF.length($brrpF.filter(function(v3) {
                return v3 === ".";
            })($4Fu8m.toCharArray(v2)));
            throw new Error("Failed pattern match at Sudoku.Display (line 142, column 1 - line 142, column 64): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};



// Generated by purs version 0.15.16

var $bQdkN = parcelRequire("bQdkN");

var $cADnC = parcelRequire("cADnC");

var $brrpF = parcelRequire("brrpF");

var $beQI1 = parcelRequire("beQI1");

var $dNwPt = parcelRequire("dNwPt");

var $7FzSN = parcelRequire("7FzSN");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");

var $gwBF5 = parcelRequire("gwBF5");

var $4Fu8m = parcelRequire("4Fu8m");

var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");



var $aJZEv = parcelRequire("aJZEv");


var $41p0v = parcelRequire("41p0v");

var $dL9YA = parcelRequire("dL9YA");

var $lM1z4 = parcelRequire("lM1z4");

var $624no = parcelRequire("624no");

var $ekupQ = parcelRequire("ekupQ");

var $jy1cE = parcelRequire("jy1cE");
// Generated by purs version 0.15.16
var $e393e8362c22b0bd$exports = {};
$e393e8362c22b0bd$exports = $parcel$resolve("worker.2752150d.js");


const $108423dcaf075620$var$workerUrl = new URL($e393e8362c22b0bd$exports);
const $108423dcaf075620$var$isMobile = ()=>{
    if (typeof navigator === "undefined") return false;
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};
const $108423dcaf075620$export$3e60c9ecb603bb82 = ()=>{
    if (navigator.hardwareConcurrency) {
        if (!$108423dcaf075620$var$isMobile()) return navigator.hardwareConcurrency;
        // Avoiding OS throttling by only using half of all available cores on mobile
        return Math.floor(navigator.hardwareConcurrency / 2);
    }
    // mobile-friendly default of 4 workers
    return 4;
};
const $108423dcaf075620$export$c041e99c7428553 = (onErr)=>()=>{
        try {
            return new Worker($108423dcaf075620$var$workerUrl, {
                type: "module"
            });
        } catch (err) {
            onErr("Failed to spawn worker: " + (err.message || err))();
            return null;
        }
    };
const $108423dcaf075620$export$6196888e2b49679b = (worker)=>(msg)=>()=>worker.postMessage(msg);
const $108423dcaf075620$export$a122b4814cbcb112 = (worker)=>(msg)=>()=>worker.postMessage(msg);
const $108423dcaf075620$export$cd24c621f968a11c = (worker)=>(handler)=>()=>{
            worker.onmessage = (e)=>handler(e.data)();
        };
const $108423dcaf075620$export$7cef5e4d763dcfdd = (worker)=>(handler)=>()=>{
            worker.onerror = (e)=>{
                // Web Workers often provide very little info for module load errors
                const msg = e.message || "Worker error (likely module load failure or resource limit)";
                handler(msg)();
            };
        };
const $108423dcaf075620$export$40776998e289b663 = (worker)=>()=>worker.terminate();



var $bQdkN = parcelRequire("bQdkN");

var $brrpF = parcelRequire("brrpF");

var $beQI1 = parcelRequire("beQI1");

var $dNwPt = parcelRequire("dNwPt");

var $7FzSN = parcelRequire("7FzSN");

var $aHmxC = parcelRequire("aHmxC");

var $h2xUu = parcelRequire("h2xUu");


var $gwBF5 = parcelRequire("gwBF5");

var $d5vvq = parcelRequire("d5vvq");

var $2XxiF = parcelRequire("2XxiF");

var $9OOYG = parcelRequire("9OOYG");

var $2jM6U = parcelRequire("2jM6U");

var $1rTTn = parcelRequire("1rTTn");




var $7fHqi = parcelRequire("7fHqi");

var $41p0v = parcelRequire("41p0v");

var $dL9YA = parcelRequire("dL9YA");
var $fd953cd5988df3d9$var$lookup = /* #__PURE__ */ $aHmxC.lookup($gwBF5.ordInt);
var $fd953cd5988df3d9$var$$$delete = /* #__PURE__ */ $aHmxC.delete($gwBF5.ordInt);
var $fd953cd5988df3d9$var$insert = /* #__PURE__ */ $aHmxC.insert($gwBF5.ordInt);
var $fd953cd5988df3d9$var$show = /* #__PURE__ */ $2XxiF.show($2XxiF.showInt);
var $fd953cd5988df3d9$var$when = /* #__PURE__ */ $bQdkN.when($1rTTn.applicativeEffect);
var $fd953cd5988df3d9$var$append1 = /* #__PURE__ */ $d5vvq.append($d5vvq.semigroupArray);
var $fd953cd5988df3d9$var$map = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $fd953cd5988df3d9$var$for_ = /* #__PURE__ */ $dNwPt.for_($1rTTn.applicativeEffect)($dNwPt.foldableArray);
var $fd953cd5988df3d9$var$$$void = /* #__PURE__ */ $7FzSN.void($1rTTn.functorEffect);
var $fd953cd5988df3d9$var$min = /* #__PURE__ */ $gwBF5.min($gwBF5.ordInt);
var $fd953cd5988df3d9$var$traverse = /* #__PURE__ */ $9OOYG.traverse($9OOYG.traversableArray)($1rTTn.applicativeEffect);
var $fd953cd5988df3d9$var$show1 = /* #__PURE__ */ $2XxiF.show($dL9YA.showDifficulty);
var $fd953cd5988df3d9$export$66754f666cfc7308 = $108423dcaf075620$export$3e60c9ecb603bb82;
var $fd953cd5988df3d9$var$variantToString = function(v) {
    if (v instanceof $41p0v.Standard) return "Standard";
    if (v instanceof $41p0v.UniqueDiagonal) return "UniqueDiagonal";
    throw new Error("Failed pattern match at Sudoku.Workers (line 62, column 1 - line 62, column 37): " + [
        v.constructor.name
    ]);
};
var $fd953cd5988df3d9$var$handleFailure = function(pool) {
    return function(rid) {
        return function __do() {
            var pending = $7fHqi.read(pool.pendingRequests)();
            var v = $fd953cd5988df3d9$var$lookup(rid)(pending);
            if (v instanceof $h2xUu.Nothing) return $2jM6U.unit;
            if (v instanceof $h2xUu.Just) {
                var newCount = v.value0.outstanding - 1 | 0;
                var $42 = newCount <= 0;
                if ($42) {
                    $7fHqi.modify_($fd953cd5988df3d9$var$$$delete(rid))(pool.pendingRequests)();
                    return v.value0.cb(new $beQI1.Left($f58bea5e58d54301$export$a3bc9b8ed74fc("All workers failed for this request")))();
                }
                return $7fHqi.modify_($fd953cd5988df3d9$var$insert(rid)({
                    cb: v.value0.cb,
                    outstanding: newCount
                }))(pool.pendingRequests)();
            }
            throw new Error("Failed pattern match at Sudoku.Workers (line 144, column 3 - line 152, column 91): " + [
                v.constructor.name
            ]);
        };
    };
};
var $fd953cd5988df3d9$var$handleWorkerHardwareError = function(pool) {
    return function(ws) {
        return function(err) {
            return function __do() {
                $108423dcaf075620$export$40776998e289b663(ws.worker)();
                $7fHqi.modify_($brrpF.filter(function(x) {
                    return x.id !== ws.id;
                }))(pool.allWorkers)();
                $7fHqi.modify_($brrpF.filter(function(x) {
                    return x.id !== ws.id;
                }))(pool.idleWorkers)();
                var mjid = $7fHqi.read(ws.jobId)();
                if (mjid instanceof $h2xUu.Nothing) return $2jM6U.unit;
                if (mjid instanceof $h2xUu.Just) {
                    $63b30336f9a70767$export$bef1f36f5486a6a3("Worker hardware error during job " + ($fd953cd5988df3d9$var$show(mjid.value0) + (": " + err)))();
                    return $fd953cd5988df3d9$var$handleFailure(pool)(mjid.value0)();
                }
                throw new Error("Failed pattern match at Sudoku.Workers (line 135, column 3 - line 139, column 29): " + [
                    mjid.constructor.name
                ]);
            };
        };
    };
};
var $fd953cd5988df3d9$var$elem$prime = function(x) {
    return function(xs) {
        return $brrpF.length($brrpF.filter(function(y) {
            return y.id === x.id;
        })(xs)) > 0;
    };
};
var $fd953cd5988df3d9$var$handleMessage = function(pool) {
    return function(ws) {
        return function(msg) {
            return function __do() {
                $7fHqi.write($h2xUu.Nothing.value)(ws.jobId)();
                var all = $7fHqi.read(pool.allWorkers)();
                $fd953cd5988df3d9$var$when($fd953cd5988df3d9$var$elem$prime(ws)(all))($7fHqi.modify_(function(v) {
                    return $fd953cd5988df3d9$var$append1(v)([
                        ws
                    ]);
                })(pool.idleWorkers))();
                var pending = $7fHqi.read(pool.pendingRequests)();
                var v = $fd953cd5988df3d9$var$lookup(msg.id)(pending);
                if (v instanceof $h2xUu.Nothing) return $2jM6U.unit;
                if (v instanceof $h2xUu.Just) {
                    var v1 = $ae4217dcc85a7c03$export$1ba013b88f4f21f3(msg.error);
                    if (v1 instanceof $h2xUu.Just) {
                        $63b30336f9a70767$export$bef1f36f5486a6a3("Worker reported error for request " + ($fd953cd5988df3d9$var$show(msg.id) + (": " + v1.value0)))();
                        return $fd953cd5988df3d9$var$handleFailure(pool)(msg.id)();
                    }
                    if (v1 instanceof $h2xUu.Nothing) {
                        $7fHqi.modify_($fd953cd5988df3d9$var$$$delete(msg.id))(pool.pendingRequests)();
                        var idle = $7fHqi.read(pool.idleWorkers)();
                        var all$prime = $7fHqi.read(pool.allWorkers)();
                        var pending$prime = $7fHqi.read(pool.pendingRequests)();
                        $fd953cd5988df3d9$var$when($brrpF.length(idle) === $brrpF.length(all$prime) && $aHmxC.isEmpty(pending$prime))($63b30336f9a70767$export$bef1f36f5486a6a3("Worker pool idle (" + ($fd953cd5988df3d9$var$show($brrpF.length(all$prime)) + " workers)")))();
                        return v.value0.cb(new $beQI1.Right(msg.result))();
                    }
                    throw new Error("Failed pattern match at Sudoku.Workers (line 111, column 7 - line 124, column 36): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Sudoku.Workers (line 108, column 3 - line 124, column 36): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $fd953cd5988df3d9$var$spawnAndAdd = function(pool) {
    var handleErr = function(msg) {
        return $63b30336f9a70767$export$bef1f36f5486a6a3("Worker spawn error: " + msg);
    };
    return function __do() {
        var maybeWorker = $fd953cd5988df3d9$var$map($ae4217dcc85a7c03$export$1ba013b88f4f21f3)($108423dcaf075620$export$c041e99c7428553(handleErr))();
        if (maybeWorker instanceof $h2xUu.Just) {
            var wid = $7fHqi.modify(function(v) {
                return v + 1 | 0;
            })(pool.workerId)();
            var jobId = $7fHqi.new($h2xUu.Nothing.value)();
            var ws = {
                worker: maybeWorker.value0,
                id: wid,
                jobId: jobId
            };
            $7fHqi.modify_(function(v) {
                return $fd953cd5988df3d9$var$append1(v)([
                    ws
                ]);
            })(pool.allWorkers)();
            $7fHqi.modify_(function(v) {
                return $fd953cd5988df3d9$var$append1(v)([
                    ws
                ]);
            })(pool.idleWorkers)();
            $108423dcaf075620$export$cd24c621f968a11c(maybeWorker.value0)($fd953cd5988df3d9$var$handleMessage(pool)(ws))();
            $108423dcaf075620$export$7cef5e4d763dcfdd(maybeWorker.value0)($fd953cd5988df3d9$var$handleWorkerHardwareError(pool)(ws))();
            return new $h2xUu.Just(ws);
        }
        if (maybeWorker instanceof $h2xUu.Nothing) return $h2xUu.Nothing.value;
        throw new Error("Failed pattern match at Sudoku.Workers (line 85, column 3 - line 95, column 28): " + [
            maybeWorker.constructor.name
        ]);
    };
};
var $fd953cd5988df3d9$export$1cb4d4390a40b347 = function __do() {
    var cap = $108423dcaf075620$export$3e60c9ecb603bb82();
    var idleWorkers = $7fHqi.new([])();
    var allWorkers = $7fHqi.new([])();
    var requestId = $7fHqi.new(0)();
    var workerId = $7fHqi.new(0)();
    var pendingRequests = $7fHqi.new($aHmxC.empty)();
    var pool = {
        idleWorkers: idleWorkers,
        allWorkers: allWorkers,
        requestId: requestId,
        workerId: workerId,
        pendingRequests: pendingRequests,
        cap: cap
    };
    $fd953cd5988df3d9$var$for_($brrpF.range(1)(pool.cap))(function(v) {
        return $fd953cd5988df3d9$var$$$void($fd953cd5988df3d9$var$spawnAndAdd(pool));
    })();
    $63b30336f9a70767$export$bef1f36f5486a6a3("Warmed " + ($fd953cd5988df3d9$var$show(pool.cap) + " workers"))();
    return pool;
};
var $fd953cd5988df3d9$var$acquireWorkers = function(pool) {
    return function(rid) {
        return function(n) {
            return function(cb) {
                return function __do() {
                    var available = $7fHqi.read(pool.idleWorkers)();
                    var toTake = $fd953cd5988df3d9$var$min(n)($brrpF.length(available));
                    var dispatching = $brrpF.take(toTake)(available);
                    $7fHqi.modify_($brrpF.filter(function(ws) {
                        return !$fd953cd5988df3d9$var$elem$prime(ws)(dispatching);
                    }))(pool.idleWorkers)();
                    var allCount = $fd953cd5988df3d9$var$map($brrpF.length)($7fHqi.read(pool.allWorkers))();
                    var needed = n - $brrpF.length(dispatching) | 0;
                    var canSpawn = $fd953cd5988df3d9$var$min(needed)(pool.cap - allCount | 0);
                    var newlySpawned = function() {
                        var $52 = canSpawn > 0;
                        if ($52) return $fd953cd5988df3d9$var$map($brrpF.catMaybes)($fd953cd5988df3d9$var$traverse(function(v) {
                            return $fd953cd5988df3d9$var$spawnAndAdd(pool);
                        })($brrpF.range(1)(canSpawn)))();
                        return [];
                    }();
                    $7fHqi.modify_($brrpF.filter(function(ws) {
                        return !$fd953cd5988df3d9$var$elem$prime(ws)(newlySpawned);
                    }))(pool.idleWorkers)();
                    var totalDispatching = $fd953cd5988df3d9$var$append1(dispatching)(newlySpawned);
                    var $53 = $brrpF.length(totalDispatching) === 0;
                    if ($53) {
                        cb(new $beQI1.Left($f58bea5e58d54301$export$a3bc9b8ed74fc("No workers available")))();
                        return [];
                    }
                    $7fHqi.modify_($fd953cd5988df3d9$var$insert(rid)({
                        cb: cb,
                        outstanding: $brrpF.length(totalDispatching)
                    }))(pool.pendingRequests)();
                    return totalDispatching;
                };
            };
        };
    };
};
var $fd953cd5988df3d9$export$b99ea3ae131e05 = function(pool) {
    return function(n) {
        return function(variant) {
            return function(difficulty) {
                return $c88db571692c73b3$export$49d5975414e0a979(function(cb) {
                    return function __do() {
                        var rid = $7fHqi.modify(function(v) {
                            return v + 1 | 0;
                        })(pool.requestId)();
                        var dispatching = $fd953cd5988df3d9$var$acquireWorkers(pool)(rid)(n)(cb)();
                        $fd953cd5988df3d9$var$for_(dispatching)(function(ws) {
                            return function __do() {
                                $7fHqi.write(new $h2xUu.Just(rid))(ws.jobId)();
                                return $108423dcaf075620$export$6196888e2b49679b(ws.worker)({
                                    id: rid,
                                    variant: $fd953cd5988df3d9$var$variantToString(variant),
                                    difficulty: $fd953cd5988df3d9$var$show1(difficulty)
                                })();
                            };
                        })();
                        return $7244ec56ae5630bd$export$8deb6e154ce67af6;
                    };
                });
            };
        };
    };
};
var $fd953cd5988df3d9$export$d593c3b3b07081f6 = function(pool) {
    return function(keyStr) {
        return function(normalizedPuzzleStr) {
            return $c88db571692c73b3$export$49d5975414e0a979(function(cb) {
                return function __do() {
                    var rid = $7fHqi.modify(function(v) {
                        return v + 1 | 0;
                    })(pool.requestId)();
                    var dispatching = $fd953cd5988df3d9$var$acquireWorkers(pool)(rid)(1)(cb)();
                    $fd953cd5988df3d9$var$for_(dispatching)(function(ws) {
                        return function __do() {
                            $7fHqi.write(new $h2xUu.Just(rid))(ws.jobId)();
                            return $108423dcaf075620$export$a122b4814cbcb112(ws.worker)({
                                id: rid,
                                key: keyStr,
                                puzzle: normalizedPuzzleStr
                            })();
                        };
                    })();
                    return $7244ec56ae5630bd$export$8deb6e154ce67af6;
                };
            });
        };
    };
};


var $beb66f606645ac4a$var$map = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $beb66f606645ac4a$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($h2xUu.bindMaybe);
var $beb66f606645ac4a$var$fromFoldable = /* #__PURE__ */ $aHmxC.fromFoldable($gwBF5.ordChar)($dNwPt.foldableArray);
var $beb66f606645ac4a$var$map1 = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $beb66f606645ac4a$var$lookup = /* #__PURE__ */ $aHmxC.lookup($gwBF5.ordChar);
var $beb66f606645ac4a$var$bind = /* #__PURE__ */ $cADnC.bind($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $beb66f606645ac4a$var$pure = /* #__PURE__ */ $bQdkN.pure($7244ec56ae5630bd$export$9dc0454a98607988);
var $beb66f606645ac4a$var$liftEffect = /* #__PURE__ */ $54d5aa8d31ad5798$export$34255e15eb56d2b3($7244ec56ae5630bd$export$666a030cecdf96c);
var $beb66f606645ac4a$var$wordMap = function(word) {
    return function(sudoku) {
        var solved = $h2xUu.fromMaybe(sudoku)($beb66f606645ac4a$var$map($lM1z4.gridString($624no.sudokuKey))($beb66f606645ac4a$var$bindFlipped($ekupQ.solve($41p0v.UniqueDiagonal.value))($beQI1.hush($lM1z4.readGrid($624no.sudokuKey)(sudoku)))));
        return $beb66f606645ac4a$var$fromFoldable($brrpF.zip($4Fu8m.toCharArray($41p0v.diagonalString(solved)))($4Fu8m.toCharArray(word)));
    };
};
var $beb66f606645ac4a$export$1218f3820e9208c0 = function(v) {
    return $beb66f606645ac4a$var$map1(function() {
        var $17 = $h2xUu.fromMaybe("");
        var $18 = $brrpF.index($jy1cE.wordlist);
        return function($19) {
            return $17($18($19));
        };
    }())($aJZEv.randomInt(0)($brrpF.length($jy1cE.wordlist) - 1 | 0));
};
var $beb66f606645ac4a$var$mapValues = function(m) {
    return function(str) {
        return $brrpF.foldl(function(s) {
            return function(c) {
                return s + $4Fu8m.singleton($h2xUu.fromMaybe(".")($beb66f606645ac4a$var$lookup(c)(m)));
            };
        })("")($4Fu8m.toCharArray(str));
    };
};
var $beb66f606645ac4a$export$fd7d7c7f0e7c5756 = function(pool) {
    return function(numWorkers) {
        return function(opts) {
            if (opts.values instanceof $dL9YA.Sudoku) return $beb66f606645ac4a$var$bind($fd953cd5988df3d9$export$b99ea3ae131e05(pool)(numWorkers)(opts.variant)(opts.difficulty))(function(p) {
                return $beb66f606645ac4a$var$pure({
                    puzzle: p,
                    key: $c2ac860adec87e7b$export$d9ed483ea3e04670.value
                });
            });
            if (opts.values instanceof $dL9YA.Colorku) return $beb66f606645ac4a$var$bind($fd953cd5988df3d9$export$b99ea3ae131e05(pool)(numWorkers)(opts.variant)(opts.difficulty))(function(p) {
                var p$prime = $beb66f606645ac4a$var$mapValues($beb66f606645ac4a$var$fromFoldable($brrpF.zip($dL9YA.numChars)($4Fu8m.toCharArray($c2ac860adec87e7b$export$f8f6563c0cfc2be4($c2ac860adec87e7b$export$e0cac371fe943738.value)))))(p);
                return $beb66f606645ac4a$var$pure({
                    puzzle: p$prime,
                    key: $c2ac860adec87e7b$export$e0cac371fe943738.value
                });
            });
            if (opts.values instanceof $dL9YA.Wordoku) return $beb66f606645ac4a$var$bind($fd953cd5988df3d9$export$b99ea3ae131e05(pool)(numWorkers)(opts.variant)(opts.difficulty))(function(p) {
                return $beb66f606645ac4a$var$bind($beb66f606645ac4a$var$liftEffect($beb66f606645ac4a$export$1218f3820e9208c0($2jM6U.unit)))(function(w) {
                    var p$prime = $beb66f606645ac4a$var$mapValues($beb66f606645ac4a$var$wordMap(w)(p))(p);
                    var dk = new $c2ac860adec87e7b$export$d22ec6cc485f1d69(w);
                    return $beb66f606645ac4a$var$pure({
                        puzzle: p$prime,
                        key: dk
                    });
                });
            });
            throw new Error("Failed pattern match at Sudoku.Generator (line 55, column 44 - line 71, column 33): " + [
                opts.values.constructor.name
            ]);
        };
    };
};
var $beb66f606645ac4a$export$80d376111cc09ad7 = function(opts) {
    var game = function(o) {
        return $dL9YA.generateSudoku(o.variant)(o.difficulty);
    };
    if (opts.values instanceof $dL9YA.Sudoku) return function __do() {
        var p = game(opts)();
        return {
            puzzle: p,
            key: $c2ac860adec87e7b$export$d9ed483ea3e04670.value
        };
    };
    if (opts.values instanceof $dL9YA.Colorku) return function __do() {
        var p = game(opts)();
        var p$prime = $beb66f606645ac4a$var$mapValues($beb66f606645ac4a$var$fromFoldable($brrpF.zip($dL9YA.numChars)($4Fu8m.toCharArray($c2ac860adec87e7b$export$f8f6563c0cfc2be4($c2ac860adec87e7b$export$e0cac371fe943738.value)))))(p);
        return {
            puzzle: p$prime,
            key: $c2ac860adec87e7b$export$e0cac371fe943738.value
        };
    };
    if (opts.values instanceof $dL9YA.Wordoku) return function __do() {
        var g = game(opts)();
        var w = $beb66f606645ac4a$export$1218f3820e9208c0($2jM6U.unit)();
        var p = $beb66f606645ac4a$var$mapValues($beb66f606645ac4a$var$wordMap(w)(g))(g);
        var dk = new $c2ac860adec87e7b$export$d22ec6cc485f1d69(w);
        return {
            puzzle: p,
            key: dk
        };
    };
    throw new Error("Failed pattern match at Sudoku.Generator (line 33, column 17 - line 49, column 32): " + [
        opts.values.constructor.name
    ]);
};



var $41p0v = parcelRequire("41p0v");

var $dL9YA = parcelRequire("dL9YA");

var $lM1z4 = parcelRequire("lM1z4");

var $624no = parcelRequire("624no");






var $218c56d3ae76a4af$var$append = /* #__PURE__ */ $d5vvq.append($d5vvq.semigroupArray);
var $218c56d3ae76a4af$var$map = /* #__PURE__ */ $7FzSN.map($7FzSN.functorArray);
var $218c56d3ae76a4af$var$show = /* #__PURE__ */ $2XxiF.show($dL9YA.showDifficulty);
var $218c56d3ae76a4af$var$show1 = /* #__PURE__ */ $2XxiF.show($dL9YA.showValues);
var $218c56d3ae76a4af$var$eq1 = /* #__PURE__ */ $aJhEx.eq($dL9YA.valuesEq);
var $218c56d3ae76a4af$var$bind = /* #__PURE__ */ $cADnC.bind($497deb56c643077e$export$172cc2b2b4e6467a);
var $218c56d3ae76a4af$var$discard = /* #__PURE__ */ $cADnC.discard($cADnC.discardUnit);
var $218c56d3ae76a4af$var$discard1 = /* #__PURE__ */ $218c56d3ae76a4af$var$discard($497deb56c643077e$export$172cc2b2b4e6467a);
var $218c56d3ae76a4af$var$modify_ = /* #__PURE__ */ $60ebc5becec1930f$export$45b91115a89d6020($497deb56c643077e$export$87bf621137788b28);
var $218c56d3ae76a4af$var$$$void = /* #__PURE__ */ $7FzSN.void($497deb56c643077e$export$bf09f5de576f9cf1);
var $218c56d3ae76a4af$var$get = /* #__PURE__ */ $60ebc5becec1930f$export$3988ae62b71be9a3($497deb56c643077e$export$87bf621137788b28);
var $218c56d3ae76a4af$var$map1 = /* #__PURE__ */ $7FzSN.map($1rTTn.functorEffect);
var $218c56d3ae76a4af$var$show2 = /* #__PURE__ */ $2XxiF.show($2XxiF.showInt);
var $218c56d3ae76a4af$var$bindFlipped = /* #__PURE__ */ $cADnC.bindFlipped($1rTTn.bindEffect);
var $218c56d3ae76a4af$var$show3 = /* #__PURE__ */ $2XxiF.show($1de5dd48369d2a6b$export$1d3b9b5391a72ae7);
var $218c56d3ae76a4af$var$diff = /* #__PURE__ */ $3043ecd2e3978a63$export$a37e3c603d7117e5($1de5dd48369d2a6b$export$44304cbc75c995e8);
var $218c56d3ae76a4af$var$bind2 = /* #__PURE__ */ $cADnC.bind($7244ec56ae5630bd$export$f885f489dcf38a2d);
var $218c56d3ae76a4af$var$$$try = /* #__PURE__ */ $693a27a8782d8e71$export$410a452afcd48948($7244ec56ae5630bd$export$9efce1646e93cba4);
var $218c56d3ae76a4af$var$pure = /* #__PURE__ */ $bQdkN.pure($7244ec56ae5630bd$export$9dc0454a98607988);
var $218c56d3ae76a4af$var$bind3 = /* #__PURE__ */ $cADnC.bind($beQI1.bindEither);
var $218c56d3ae76a4af$var$when = /* #__PURE__ */ $bQdkN.when($497deb56c643077e$export$be2318e898dcc68);
var $218c56d3ae76a4af$var$pure1 = /* #__PURE__ */ $bQdkN.pure($497deb56c643077e$export$be2318e898dcc68);
var $218c56d3ae76a4af$var$min = /* #__PURE__ */ $gwBF5.min($gwBF5.ordInt);
var $218c56d3ae76a4af$var$map2 = /* #__PURE__ */ $7FzSN.map($h2xUu.functorMaybe);
var $218c56d3ae76a4af$var$type_ = /* #__PURE__ */ $269e1a26c0466abf$export$d4a6a4db5b31e621($9aad5dc74ea3040c$export$d48eb3d89026ef9);
var $218c56d3ae76a4af$export$b03b1c699c90a9b4 = /* #__PURE__ */ function() {
    function Initialize() {}
    Initialize.value = new Initialize();
    return Initialize;
}();
var $218c56d3ae76a4af$export$734a1575c93661df = /* #__PURE__ */ function() {
    function PathChanged(value0) {
        this.value0 = value0;
    }
    PathChanged.create = function(value0) {
        return new PathChanged(value0);
    };
    return PathChanged;
}();
var $218c56d3ae76a4af$export$3894e07cebd56dd8 = /* #__PURE__ */ function() {
    function Generate() {}
    Generate.value = new Generate();
    return Generate;
}();
var $218c56d3ae76a4af$export$229279b43b5fe5cc = /* #__PURE__ */ function() {
    function NextGame(value0) {
        this.value0 = value0;
    }
    NextGame.create = function(value0) {
        return new NextGame(value0);
    };
    return NextGame;
}();
var $218c56d3ae76a4af$export$21b01f86d5a9c5bf = /* #__PURE__ */ function() {
    function NextDifficulty(value0) {
        this.value0 = value0;
    }
    NextDifficulty.create = function(value0) {
        return new NextDifficulty(value0);
    };
    return NextDifficulty;
}();
var $218c56d3ae76a4af$export$19cb84009d3e8ed0 = /* #__PURE__ */ function() {
    function RequestSolve(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RequestSolve.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RequestSolve(value0, value1, value2);
            };
        };
    };
    return RequestSolve;
}();
var $218c56d3ae76a4af$export$b5a7a29d07f071e = /* #__PURE__ */ function() {
    function SolveFinished(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    SolveFinished.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new SolveFinished(value0, value1, value2);
            };
        };
    };
    return SolveFinished;
}();
var $218c56d3ae76a4af$export$d878cdcb88bed25f = /* #__PURE__ */ function() {
    function ToggleSolution() {}
    ToggleSolution.value = new ToggleSolution();
    return ToggleSolution;
}();
var $218c56d3ae76a4af$export$d93ce6e77b140bb5 = /* #__PURE__ */ function() {
    function AddClue() {}
    AddClue.value = new AddClue();
    return AddClue;
}();
var $218c56d3ae76a4af$export$6654d0dc22ad423a = function(game) {
    return function(original) {
        return function(displayed) {
            var td$prime = function(extraClueClass) {
                return function(isExtraClue) {
                    return $1c3406d2030e9515$export$159d9494db57879b([
                        $269e1a26c0466abf$export$188d75d71883854a($218c56d3ae76a4af$var$append([
                            "td"
                        ])(function() {
                            if (isExtraClue) return [
                                extraClueClass
                            ];
                            return [];
                        }()))
                    ]);
                };
            };
            var mkTable = function() {
                var $192 = $1c3406d2030e9515$export$159d9494db57879b([
                    $269e1a26c0466abf$export$d560c7e4a29451c2("table")
                ]);
                var $193 = $218c56d3ae76a4af$var$map($1c3406d2030e9515$export$159d9494db57879b([
                    $269e1a26c0466abf$export$dbf49ecbc3d3d264("tr")
                ]));
                return function($194) {
                    return $192($193($194));
                };
            }();
            var isExtra = function(origChar) {
                return function(dispChar) {
                    return origChar === "." && dispChar !== ".";
                };
            };
            var displayChar = function(v) {
                if (v === ".") return " ";
                return $4Fu8m.singleton(v);
            };
            var rows = function(pairs) {
                return $41p0v.chunksOf(9)($218c56d3ae76a4af$var$map(function(v) {
                    return td$prime("ExtraClue")(isExtra(v.value0)(v.value1))([
                        $9aad5dc74ea3040c$export$6f093cfa640b7166(displayChar(v.value1))
                    ]);
                })(pairs));
            };
            var circle$prime = function(color) {
                return $1c3406d2030e9515$export$afc1bfabebaf28a2([
                    $269e1a26c0466abf$export$dbf49ecbc3d3d264("Circle"),
                    $269e1a26c0466abf$export$7aabe8b3a840d2fd("Color")(color)
                ])([]);
            };
            var circle = function(v) {
                if (v === "R") return circle$prime("Red");
                if (v === "O") return circle$prime("Orange");
                if (v === "Y") return circle$prime("Yellow");
                if (v === "L") return circle$prime("Lime");
                if (v === "G") return circle$prime("Green");
                if (v === "B") return circle$prime("Blue");
                if (v === "I") return circle$prime("Indigo");
                if (v === "P") return circle$prime("Purple");
                if (v === "V") return circle$prime("Violet");
                return circle$prime("White");
            };
            var colorkuRows = function(pairs) {
                return $41p0v.chunksOf(9)($218c56d3ae76a4af$var$map(function(v) {
                    return td$prime("ExtraClueDot")(isExtra(v.value0)(v.value1))([
                        circle(v.value1)
                    ]);
                })(pairs));
            };
            if (game instanceof $dL9YA.Colorku) return mkTable(colorkuRows($brrpF.zip($4Fu8m.toCharArray(original))($4Fu8m.toCharArray(displayed))));
            if (game instanceof $dL9YA.Wordoku) return mkTable(rows($brrpF.zip($4Fu8m.toCharArray(original))($4Fu8m.toCharArray($d8ahy.toUpper(displayed)))));
            if (game instanceof $dL9YA.Sudoku) return mkTable(rows($brrpF.zip($4Fu8m.toCharArray(original))($4Fu8m.toCharArray(displayed))));
            throw new Error("Failed pattern match at Main (line 109, column 37 - line 112, column 88): " + [
                game.constructor.name
            ]);
        };
    };
};
var $218c56d3ae76a4af$export$5ce7fa255214eb7b = function(st) {
    var label = function(v) {
        if (v instanceof $h2xUu.Nothing) return " ";
        if (v instanceof $h2xUu.Just) return $218c56d3ae76a4af$var$show(v.value0.d) + (" " + $218c56d3ae76a4af$var$show1(v.value0.g));
        throw new Error("Failed pattern match at Main (line 153, column 3 - line 153, column 58): " + [
            v.constructor.name
        ]);
    };
    return $1c3406d2030e9515$export$3327f90baeaa2cb3([
        $1c3406d2030e9515$export$1237798dc640739a([
            $269e1a26c0466abf$export$d560c7e4a29451c2("label")
        ])([
            $9aad5dc74ea3040c$export$6f093cfa640b7166(label(st.displayed))
        ])
    ]);
};
var $218c56d3ae76a4af$export$d4c72bab9d6cc13a = function(v) {
    return {
        selected: {
            d: $dL9YA.Tricky.value,
            g: $dL9YA.Wordoku.value
        },
        displayed: $h2xUu.Nothing.value,
        loading: false,
        puzzle: $41p0v.emptySudoku,
        pool: $h2xUu.Nothing.value,
        decodedKey: $h2xUu.Nothing.value,
        solution: $h2xUu.Nothing.value,
        solveError: $h2xUu.Nothing.value,
        showingSolution: false,
        solveRequestId: 0,
        clueCount: 0
    };
};
var $218c56d3ae76a4af$export$c3e10b3846e954f3 = function(st) {
    return {
        variant: function() {
            var $94 = $218c56d3ae76a4af$var$eq1(st.selected.g)($dL9YA.Wordoku.value);
            if ($94) return $41p0v.UniqueDiagonal.value;
            return $41p0v.Standard.value;
        }(),
        values: st.selected.g,
        difficulty: st.selected.d
    };
};
var $218c56d3ae76a4af$export$c04a9f24a4230e1f = function(dictEnum) {
    var succ = $dIXGo.succ(dictEnum);
    return function($$default) {
        var $195 = $h2xUu.fromMaybe($$default);
        return function($196) {
            return $195(succ($196));
        };
    };
};
var $218c56d3ae76a4af$var$cycle1 = /* #__PURE__ */ $218c56d3ae76a4af$export$c04a9f24a4230e1f($dL9YA.valuesEnum);
var $218c56d3ae76a4af$var$cycle2 = /* #__PURE__ */ $218c56d3ae76a4af$export$c04a9f24a4230e1f($dL9YA.difficultyEnum);
var $218c56d3ae76a4af$export$6c6c3f4b7541eaf1 = function(dictMonadAff) {
    var liftEffect = $54d5aa8d31ad5798$export$34255e15eb56d2b3($497deb56c643077e$export$aecceb0bc1bf10d9(dictMonadAff.MonadEffect0()));
    var liftAff = $ec5cc86f53a11c6b$export$37f61af225938e0f($497deb56c643077e$export$6f4dec227404555(dictMonadAff));
    return function(v) {
        if (v instanceof $218c56d3ae76a4af$export$b03b1c699c90a9b4) return $218c56d3ae76a4af$var$bind(liftEffect($fd953cd5988df3d9$export$1cb4d4390a40b347))(function(pool) {
            return $218c56d3ae76a4af$var$discard1($218c56d3ae76a4af$var$modify_(function(v1) {
                var $96 = {};
                for(var $97 in v1)if (({}).hasOwnProperty.call(v1, $97)) $96[$97] = v1[$97];
                $96.pool = new $h2xUu.Just(pool);
                return $96;
            }))(function() {
                return $218c56d3ae76a4af$var$bind(liftEffect($ae794effd2a529f9$export$185802fd694ee1f5))(function(v1) {
                    return $218c56d3ae76a4af$var$discard1($218c56d3ae76a4af$var$$$void($497deb56c643077e$export$ec068583843480e7(v1.emitter)))(function() {
                        return liftEffect(function __do() {
                            var w = $df82538a253b5856$export$8291e5b88f90ce4();
                            var et = $fb7c5d2f8f53ba15$export$55c9526d22b9f8e6(w);
                            var cb = $d8dd8b0292692afb$export$f5cdf3809b4587f3(function(v2) {
                                return function __do() {
                                    var loc = $6bfa62c8b92a1e7d$export$17b07c660794dc13(w)();
                                    var path = $6f67113cfd3e1757$export$7333db99aa99d383(loc)();
                                    return $ae794effd2a529f9$export$5e14cdade93d6f7b(v1.listener)(new $218c56d3ae76a4af$export$734a1575c93661df(path))();
                                };
                            })();
                            $d8dd8b0292692afb$export$3f65cefe8380dbea("popstate")(cb)(false)(et)();
                            var loc = $6bfa62c8b92a1e7d$export$17b07c660794dc13(w)();
                            var path = $6f67113cfd3e1757$export$7333db99aa99d383(loc)();
                            return $ae794effd2a529f9$export$5e14cdade93d6f7b(v1.listener)(new $218c56d3ae76a4af$export$734a1575c93661df(path))();
                        });
                    });
                });
            });
        });
        if (v instanceof $218c56d3ae76a4af$export$734a1575c93661df) {
            var route = $7a278b4e06b1b8e1$export$8ccf933b0513f8d0(v.value0);
            if (route instanceof $7a278b4e06b1b8e1$export$b94310965bed44e6) return $218c56d3ae76a4af$var$modify_(function(v1) {
                var $103 = {};
                for(var $104 in v1)if (({}).hasOwnProperty.call(v1, $104)) $103[$104] = v1[$104];
                $103.puzzle = $41p0v.emptySudoku;
                $103.displayed = $h2xUu.Nothing.value;
                $103.decodedKey = $h2xUu.Nothing.value;
                $103.solution = $h2xUu.Nothing.value;
                $103.solveError = $h2xUu.Nothing.value;
                $103.showingSolution = false;
                $103.clueCount = 0;
                return $103;
            });
            if (route instanceof $7a278b4e06b1b8e1$export$570d871acb6ff9b0) return $218c56d3ae76a4af$var$modify_(function(v1) {
                var $109 = {};
                for(var $110 in v1)if (({}).hasOwnProperty.call(v1, $110)) $109[$110] = v1[$110];
                $109.selected = function() {
                    var $106 = {};
                    for(var $107 in v1.selected)if (({}).hasOwnProperty.call(v1.selected, $107)) $106[$107] = v1["selected"][$107];
                    $106.g = route.value0;
                    return $106;
                }();
                $109.puzzle = $41p0v.emptySudoku;
                $109.displayed = $h2xUu.Nothing.value;
                $109.decodedKey = $h2xUu.Nothing.value;
                $109.solution = $h2xUu.Nothing.value;
                $109.solveError = $h2xUu.Nothing.value;
                $109.showingSolution = false;
                $109.clueCount = 0;
                return $109;
            });
            if (route instanceof $7a278b4e06b1b8e1$export$bf18bab47e9dd8b4) return $218c56d3ae76a4af$var$modify_(function(v1) {
                var $116 = {};
                for(var $117 in v1)if (({}).hasOwnProperty.call(v1, $117)) $116[$117] = v1[$117];
                $116.selected = function() {
                    var $113 = {};
                    for(var $114 in v1.selected)if (({}).hasOwnProperty.call(v1.selected, $114)) $113[$114] = v1["selected"][$114];
                    $113.g = route.value0;
                    $113.d = route.value1;
                    return $113;
                }();
                $116.puzzle = $41p0v.emptySudoku;
                $116.displayed = $h2xUu.Nothing.value;
                $116.decodedKey = $h2xUu.Nothing.value;
                $116.solution = $h2xUu.Nothing.value;
                $116.solveError = $h2xUu.Nothing.value;
                $116.showingSolution = false;
                $116.clueCount = 0;
                return $116;
            });
            if (route instanceof $7a278b4e06b1b8e1$export$85746c16b5ccd576) {
                var displayPuzzle = $c2ac860adec87e7b$export$be8b9fcbce8e8f70(route.value3)(route.value2);
                return $218c56d3ae76a4af$var$discard1($218c56d3ae76a4af$var$modify_(function(v1) {
                    var $121 = {};
                    for(var $122 in v1)if (({}).hasOwnProperty.call(v1, $122)) $121[$122] = v1[$122];
                    $121.selected = {
                        g: route.value0,
                        d: route.value1
                    };
                    $121.displayed = new $h2xUu.Just({
                        g: route.value0,
                        d: route.value1
                    });
                    $121.puzzle = displayPuzzle;
                    $121.clueCount = 0;
                    $121.showingSolution = false;
                    $121.solution = $h2xUu.Nothing.value;
                    $121.solveError = $h2xUu.Nothing.value;
                    return $121;
                }))(function() {
                    return $218c56d3ae76a4af$export$1cfc9b0d291462ad(dictMonadAff)(route.value3)(displayPuzzle);
                });
            }
            throw new Error("Failed pattern match at Main (line 279, column 5 - line 329, column 38): " + [
                route.constructor.name
            ]);
        }
        if (v instanceof $218c56d3ae76a4af$export$229279b43b5fe5cc) return $218c56d3ae76a4af$var$modify_(function(v1) {
            var $132 = {};
            for(var $133 in v1)if (({}).hasOwnProperty.call(v1, $133)) $132[$133] = v1[$133];
            $132.selected = function() {
                var $129 = {};
                for(var $130 in v1.selected)if (({}).hasOwnProperty.call(v1.selected, $130)) $129[$130] = v1["selected"][$130];
                $129.g = $218c56d3ae76a4af$var$cycle1($dL9YA.Sudoku.value)(v.value0);
                return $129;
            }();
            return $132;
        });
        if (v instanceof $218c56d3ae76a4af$export$21b01f86d5a9c5bf) return $218c56d3ae76a4af$var$modify_(function(v1) {
            var $139 = {};
            for(var $140 in v1)if (({}).hasOwnProperty.call(v1, $140)) $139[$140] = v1[$140];
            $139.selected = function() {
                var $136 = {};
                for(var $137 in v1.selected)if (({}).hasOwnProperty.call(v1.selected, $137)) $136[$137] = v1["selected"][$137];
                $136.d = $218c56d3ae76a4af$var$cycle2($dL9YA.Beginner.value)(v.value0);
                return $136;
            }();
            return $139;
        });
        if (v instanceof $218c56d3ae76a4af$export$3894e07cebd56dd8) return $218c56d3ae76a4af$var$bind($218c56d3ae76a4af$var$get)(function(st) {
            if (st.pool instanceof $h2xUu.Nothing) return liftEffect($63b30336f9a70767$export$bef1f36f5486a6a3("Pool not initialized!"));
            if (st.pool instanceof $h2xUu.Just) return $218c56d3ae76a4af$var$discard1($218c56d3ae76a4af$var$modify_(function(v1) {
                var $144 = {};
                for(var $145 in v1)if (({}).hasOwnProperty.call(v1, $145)) $144[$145] = v1[$145];
                $144.loading = true;
                return $144;
            }))(function() {
                return $218c56d3ae76a4af$var$bind(liftEffect($218c56d3ae76a4af$var$map1($1ca97124a62e2e75$export$c2dea5c02f48568d)($6703b3904c45131d$export$461939dd4422153)))(function(start) {
                    return $218c56d3ae76a4af$var$bind(liftEffect($fd953cd5988df3d9$export$66754f666cfc7308))(function(n) {
                        return $218c56d3ae76a4af$var$discard1(liftEffect($63b30336f9a70767$export$bef1f36f5486a6a3("generating a " + ($218c56d3ae76a4af$var$show(st.selected.d) + (" " + ($218c56d3ae76a4af$var$show1(st.selected.g) + (" with " + ($218c56d3ae76a4af$var$show2(n) + " workers..."))))))))(function() {
                            return $218c56d3ae76a4af$var$bind(liftAff($beb66f606645ac4a$export$fd7d7c7f0e7c5756(st.pool.value0)(n)($218c56d3ae76a4af$export$c3e10b3846e954f3(st))))(function(result) {
                                return $218c56d3ae76a4af$var$bind(liftEffect($218c56d3ae76a4af$var$map1($1ca97124a62e2e75$export$c2dea5c02f48568d)($6703b3904c45131d$export$461939dd4422153)))(function(end) {
                                    return $218c56d3ae76a4af$var$discard1($218c56d3ae76a4af$var$modify_(function(v1) {
                                        var $148 = {};
                                        for(var $149 in v1)if (({}).hasOwnProperty.call(v1, $149)) $148[$149] = v1[$149];
                                        $148.displayed = new $h2xUu.Just({
                                            g: st.selected.g,
                                            d: st.selected.d
                                        });
                                        $148.loading = false;
                                        $148.puzzle = result.puzzle;
                                        $148.clueCount = 0;
                                        $148.showingSolution = false;
                                        $148.solution = $h2xUu.Nothing.value;
                                        $148.solveError = $h2xUu.Nothing.value;
                                        return $148;
                                    }))(function() {
                                        var normalizedPuzzle = $c2ac860adec87e7b$export$a3295358bff77e(result.key)(result.puzzle);
                                        var path = $7a278b4e06b1b8e1$export$5cc7f731b5937e99(st.selected.g)(st.selected.d)(normalizedPuzzle)(result.key);
                                        return $218c56d3ae76a4af$var$discard1(liftEffect(function __do() {
                                            var h = $218c56d3ae76a4af$var$bindFlipped($6bfa62c8b92a1e7d$export$55abd4691b317664)($df82538a253b5856$export$8291e5b88f90ce4)();
                                            $ec30226392c3a36d$export$ba0fd82af7b4fe6e($3159c1316ac7a043$export$9d82982d31d9d171($2jM6U.unit))("")(path)(h)();
                                            $63b30336f9a70767$export$bef1f36f5486a6a3("generated this game " + ($218c56d3ae76a4af$var$show3($218c56d3ae76a4af$var$diff(end)(start)) + ":"))();
                                            return $63b30336f9a70767$export$bef1f36f5486a6a3(result.puzzle)();
                                        }))(function() {
                                            return $218c56d3ae76a4af$export$1cfc9b0d291462ad(dictMonadAff)(result.key)(result.puzzle);
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
            throw new Error("Failed pattern match at Main (line 335, column 5 - line 367, column 47): " + [
                st.pool.constructor.name
            ]);
        });
        if (v instanceof $218c56d3ae76a4af$export$19cb84009d3e8ed0) return $218c56d3ae76a4af$var$bind($218c56d3ae76a4af$var$get)(function(st) {
            if (st.pool instanceof $h2xUu.Nothing) return liftEffect($63b30336f9a70767$export$bef1f36f5486a6a3("Pool not initialized! Cannot solve."));
            if (st.pool instanceof $h2xUu.Just) return $218c56d3ae76a4af$var$bind(liftAff($218c56d3ae76a4af$var$bind2($218c56d3ae76a4af$var$$$try($fd953cd5988df3d9$export$d593c3b3b07081f6(st.pool.value0)($c2ac860adec87e7b$export$f8f6563c0cfc2be4(v.value1))(v.value2)))(function(attempt) {
                return $218c56d3ae76a4af$var$pure(function() {
                    if (attempt instanceof $beQI1.Right) return new $beQI1.Right(attempt.value0);
                    if (attempt instanceof $beQI1.Left) return new $beQI1.Left($f58bea5e58d54301$export$a8ecead220dd38a6(attempt.value0));
                    throw new Error("Failed pattern match at Main (line 376, column 18 - line 378, column 43): " + [
                        attempt.constructor.name
                    ]);
                }());
            })))(function(result) {
                return $218c56d3ae76a4af$export$6c6c3f4b7541eaf1(dictMonadAff)(new $218c56d3ae76a4af$export$b5a7a29d07f071e(v.value0, v.value1, result));
            });
            throw new Error("Failed pattern match at Main (line 371, column 5 - line 379, column 54): " + [
                st.pool.constructor.name
            ]);
        });
        if (v instanceof $218c56d3ae76a4af$export$b5a7a29d07f071e) return $218c56d3ae76a4af$var$bind($218c56d3ae76a4af$var$get)(function(st) {
            var asGrid = function(v1) {
                if (v1 instanceof $beQI1.Left) return new $beQI1.Left(v1.value0);
                if (v1 instanceof $beQI1.Right) return $218c56d3ae76a4af$var$bind3($624no.mkKey($c2ac860adec87e7b$export$f8f6563c0cfc2be4(v.value1)))(function(k) {
                    return $lM1z4.readGrid(k)(v1.value0);
                });
                throw new Error("Failed pattern match at Main (line 384, column 7 - line 384, column 59): " + [
                    v1.constructor.name
                ]);
            };
            var applied = $98a9f41a871de4aa$export$93ff6e4a47ef9ceb({
                latestRequestId: st.solveRequestId,
                currentSolution: st.solution,
                currentSolveError: st.solveError
            })(v.value0)(asGrid(v.value2));
            return $218c56d3ae76a4af$var$discard1($218c56d3ae76a4af$var$when(v.value0 !== st.solveRequestId)(liftEffect($63b30336f9a70767$export$bef1f36f5486a6a3("Ignoring stale solve result for request " + $218c56d3ae76a4af$var$show2(v.value0)))))(function() {
                return $218c56d3ae76a4af$var$discard1(function() {
                    if (applied.solveError instanceof $h2xUu.Just && v.value0 === st.solveRequestId) return liftEffect($63b30336f9a70767$export$bef1f36f5486a6a3("BUG: solve failed for a displayed puzzle: " + applied.solveError.value0));
                    return $218c56d3ae76a4af$var$pure1($2jM6U.unit);
                }())(function() {
                    return $218c56d3ae76a4af$var$modify_(function(v1) {
                        var $167 = {};
                        for(var $168 in v1)if (({}).hasOwnProperty.call(v1, $168)) $167[$168] = v1[$168];
                        $167.solution = applied.solution;
                        $167.solveError = applied.solveError;
                        return $167;
                    });
                });
            });
        });
        if (v instanceof $218c56d3ae76a4af$export$d878cdcb88bed25f) return $218c56d3ae76a4af$var$bind($218c56d3ae76a4af$var$get)(function(st) {
            if (st.solution instanceof $h2xUu.Nothing) return $218c56d3ae76a4af$var$pure1($2jM6U.unit);
            if (st.solution instanceof $h2xUu.Just) return $218c56d3ae76a4af$var$modify_(function(v1) {
                var $174 = {};
                for(var $175 in v1)if (({}).hasOwnProperty.call(v1, $175)) $174[$175] = v1[$175];
                $174.showingSolution = !st.showingSolution;
                return $174;
            });
            throw new Error("Failed pattern match at Main (line 409, column 5 - line 411, column 75): " + [
                st.solution.constructor.name
            ]);
        });
        if (v instanceof $218c56d3ae76a4af$export$d93ce6e77b140bb5) return $218c56d3ae76a4af$var$bind($218c56d3ae76a4af$var$get)(function(st) {
            if (st.decodedKey instanceof $h2xUu.Nothing) return $218c56d3ae76a4af$var$pure1($2jM6U.unit);
            if (st.decodedKey instanceof $h2xUu.Just) {
                var blankCount = $brrpF.length($brrpF.filter(function(v1) {
                    return v1 === ".";
                })($4Fu8m.toCharArray(st.puzzle)));
                var newCount = $218c56d3ae76a4af$var$min(st.clueCount + 1 | 0)(blankCount);
                return $218c56d3ae76a4af$var$modify_(function(v1) {
                    var $179 = {};
                    for(var $180 in v1)if (({}).hasOwnProperty.call(v1, $180)) $179[$180] = v1[$180];
                    $179.clueCount = newCount;
                    return $179;
                });
            }
            throw new Error("Failed pattern match at Main (line 415, column 5 - line 421, column 47): " + [
                st.decodedKey.constructor.name
            ]);
        });
        throw new Error("Failed pattern match at Main (line 258, column 16 - line 421, column 47): " + [
            v.constructor.name
        ]);
    };
};
var $218c56d3ae76a4af$export$1cfc9b0d291462ad = function(dictMonadAff) {
    return function(key) {
        return function(displayPuzzle) {
            return $218c56d3ae76a4af$var$bind($218c56d3ae76a4af$var$get)(function(st) {
                var reqId = st.solveRequestId + 1 | 0;
                return $218c56d3ae76a4af$var$discard1($218c56d3ae76a4af$var$modify_(function(v) {
                    var $183 = {};
                    for(var $184 in v)if (({}).hasOwnProperty.call(v, $184)) $183[$184] = v[$184];
                    $183.decodedKey = new $h2xUu.Just(key);
                    $183.solution = $h2xUu.Nothing.value;
                    $183.solveError = $h2xUu.Nothing.value;
                    $183.showingSolution = false;
                    $183.solveRequestId = reqId;
                    return $183;
                }))(function() {
                    return $218c56d3ae76a4af$export$6c6c3f4b7541eaf1(dictMonadAff)(new $218c56d3ae76a4af$export$19cb84009d3e8ed0(reqId, key, displayPuzzle));
                });
            });
        };
    };
};
var $218c56d3ae76a4af$export$90f8c50ae1a962cd = function(st) {
    if (st.decodedKey instanceof $h2xUu.Nothing) return {
        original: st.puzzle,
        displayed: st.puzzle
    };
    if (st.decodedKey instanceof $h2xUu.Just) {
        if (st.showingSolution) {
            var s = $98a9f41a871de4aa$export$6cec9acd98c2e87b(st.decodedKey.value0)(true)(st.puzzle)(st.solution);
            return {
                original: s,
                displayed: s
            };
        }
        if ($iQTlW.otherwise) return {
            original: st.puzzle,
            displayed: $h2xUu.fromMaybe(st.puzzle)($218c56d3ae76a4af$var$map2($98a9f41a871de4aa$export$20bb241f9ca9a913(st.decodedKey.value0)(st.clueCount)(st.puzzle))(st.solution))
        };
    }
    throw new Error("Failed pattern match at Main (line 158, column 27 - line 169, column 10): " + [
        st.decodedKey.constructor.name
    ]);
};
var $218c56d3ae76a4af$export$b3890eb0ae9dca99 = function(st) {
    var display = $218c56d3ae76a4af$export$90f8c50ae1a962cd(st);
    return $1c3406d2030e9515$export$159d9494db57879b([
        $269e1a26c0466abf$export$dbf49ecbc3d3d264("VContainer")
    ])([
        $1c3406d2030e9515$export$3327f90baeaa2cb3([
            $1c3406d2030e9515$export$159d9494db57879b([
                $269e1a26c0466abf$export$dbf49ecbc3d3d264("HContainer")
            ])([
                $1c3406d2030e9515$export$762b01c17cd5ef84([
                    $9aad5dc74ea3040c$export$6f093cfa640b7166("Sudoku Generator")
                ])
            ]),
            $1c3406d2030e9515$export$159d9494db57879b([
                $269e1a26c0466abf$export$dbf49ecbc3d3d264("HContainer")
            ])([
                $1c3406d2030e9515$export$2ba01fb71ed41cb6([
                    $218c56d3ae76a4af$var$type_($d71a736f4ee3881a$export$f2f6344eac5a3091.value),
                    $269e1a26c0466abf$export$d560c7e4a29451c2("Difficulty"),
                    $269e1a26c0466abf$export$a8ff84c12d48cfa6($218c56d3ae76a4af$var$show(st.selected.d)),
                    $915100f592e460a1$export$1d5a917feb871989(function(v) {
                        return new $218c56d3ae76a4af$export$21b01f86d5a9c5bf(st.selected.d);
                    })
                ])([
                    $9aad5dc74ea3040c$export$6f093cfa640b7166($218c56d3ae76a4af$var$show(st.selected.d))
                ]),
                $1c3406d2030e9515$export$2ba01fb71ed41cb6([
                    $218c56d3ae76a4af$var$type_($d71a736f4ee3881a$export$f2f6344eac5a3091.value),
                    $269e1a26c0466abf$export$d560c7e4a29451c2("Game"),
                    $915100f592e460a1$export$1d5a917feb871989(function(v) {
                        return new $218c56d3ae76a4af$export$229279b43b5fe5cc(st.selected.g);
                    })
                ])([
                    $9aad5dc74ea3040c$export$6f093cfa640b7166($218c56d3ae76a4af$var$show1(st.selected.g))
                ])
            ]),
            $1c3406d2030e9515$export$159d9494db57879b([
                $269e1a26c0466abf$export$dbf49ecbc3d3d264("VContainer")
            ])([
                $1c3406d2030e9515$export$2ba01fb71ed41cb6([
                    $269e1a26c0466abf$export$683472f6198a076e(st.loading),
                    $269e1a26c0466abf$export$d560c7e4a29451c2("Generate"),
                    $218c56d3ae76a4af$var$type_($d71a736f4ee3881a$export$f2f6344eac5a3091.value),
                    $915100f592e460a1$export$1d5a917feb871989(function(v) {
                        return $218c56d3ae76a4af$export$3894e07cebd56dd8.value;
                    })
                ])([
                    $9aad5dc74ea3040c$export$6f093cfa640b7166(function() {
                        if (st.loading) return "Working...";
                        return "Generate";
                    }())
                ])
            ]),
            $1c3406d2030e9515$export$159d9494db57879b([
                $269e1a26c0466abf$export$dbf49ecbc3d3d264("label")
            ])([
                $218c56d3ae76a4af$export$6654d0dc22ad423a($h2xUu.maybe($dL9YA.Sudoku.value)(function(v) {
                    return v.g;
                })(st.displayed))(display.original)(display.displayed),
                $218c56d3ae76a4af$export$5ce7fa255214eb7b(st)
            ]),
            $1c3406d2030e9515$export$159d9494db57879b([
                $269e1a26c0466abf$export$dbf49ecbc3d3d264("VContainer")
            ])($218c56d3ae76a4af$var$append(function() {
                if (st.solveError instanceof $h2xUu.Just) return [
                    $1c3406d2030e9515$export$159d9494db57879b([
                        $269e1a26c0466abf$export$dbf49ecbc3d3d264("SolveError")
                    ])([
                        $9aad5dc74ea3040c$export$6f093cfa640b7166("Error solving puzzle: " + st.solveError.value0)
                    ])
                ];
                if (st.solveError instanceof $h2xUu.Nothing) return [];
                throw new Error("Failed pattern match at Main (line 215, column 19 - line 221, column 34): " + [
                    st.solveError.constructor.name
                ]);
            }())([
                $1c3406d2030e9515$export$159d9494db57879b([
                    $269e1a26c0466abf$export$dbf49ecbc3d3d264("ButtonSlot"),
                    $269e1a26c0466abf$export$1d567c320f4763bc(function() {
                        var $191 = $h2xUu.isJust(st.displayed);
                        if ($191) return "";
                        return "visibility: hidden";
                    }())
                ])([
                    $1c3406d2030e9515$export$2ba01fb71ed41cb6([
                        $269e1a26c0466abf$export$683472f6198a076e($98a9f41a871de4aa$export$e7f407f8afc03bf0(st.solution)),
                        $269e1a26c0466abf$export$d560c7e4a29451c2("Solution"),
                        $218c56d3ae76a4af$var$type_($d71a736f4ee3881a$export$f2f6344eac5a3091.value),
                        $915100f592e460a1$export$1d5a917feb871989(function(v) {
                            return $218c56d3ae76a4af$export$d878cdcb88bed25f.value;
                        })
                    ])([
                        $9aad5dc74ea3040c$export$6f093cfa640b7166($98a9f41a871de4aa$export$d0035e0fdcf9d643(st.showingSolution))
                    ]),
                    $1c3406d2030e9515$export$2ba01fb71ed41cb6([
                        $269e1a26c0466abf$export$683472f6198a076e($98a9f41a871de4aa$export$e7f407f8afc03bf0(st.solution) || $98a9f41a871de4aa$export$7cf6441693043538(st.solution)(st.clueCount)(st.puzzle)),
                        $269e1a26c0466abf$export$d560c7e4a29451c2("AddClue"),
                        $218c56d3ae76a4af$var$type_($d71a736f4ee3881a$export$f2f6344eac5a3091.value),
                        $915100f592e460a1$export$1d5a917feb871989(function(v) {
                            return $218c56d3ae76a4af$export$d93ce6e77b140bb5.value;
                        })
                    ])([
                        $9aad5dc74ea3040c$export$6f093cfa640b7166("+1 Clue")
                    ])
                ])
            ])),
            $1c3406d2030e9515$export$159d9494db57879b([
                $269e1a26c0466abf$export$dbf49ecbc3d3d264("VContainer")
            ])([
                $1c3406d2030e9515$export$70a8ff4564bfd029([
                    $9aad5dc74ea3040c$export$6f093cfa640b7166("PureScript + Netlify | Source on "),
                    $1c3406d2030e9515$export$407448d2b89b1813([
                        $269e1a26c0466abf$export$8f51af5840e0602a("https://github.com/nathaniel-may/purescript-wordoku")
                    ])([
                        $9aad5dc74ea3040c$export$6f093cfa640b7166("GitHub")
                    ])
                ])
            ])
        ])
    ]);
};
var $218c56d3ae76a4af$export$d8556a2a8f973135 = function(dictMonadAff) {
    return $02809249bead6832$export$3bb93a8213d3ef21({
        initialState: $218c56d3ae76a4af$export$d4c72bab9d6cc13a,
        render: $218c56d3ae76a4af$export$b3890eb0ae9dca99,
        "eval": $02809249bead6832$export$9eef9effff68b10a({
            handleQuery: $02809249bead6832$export$cb95887a94082d64.handleQuery,
            receive: $02809249bead6832$export$cb95887a94082d64.receive,
            finalize: $02809249bead6832$export$cb95887a94082d64.finalize,
            handleAction: $218c56d3ae76a4af$export$6c6c3f4b7541eaf1(dictMonadAff),
            initialize: new $h2xUu.Just($218c56d3ae76a4af$export$b03b1c699c90a9b4.value)
        })
    });
};
var $218c56d3ae76a4af$var$component1 = /* #__PURE__ */ $218c56d3ae76a4af$export$d8556a2a8f973135($ec5cc86f53a11c6b$export$bd75e69808ef8e57);
var $218c56d3ae76a4af$export$f22da7240b7add18 = /* #__PURE__ */ $27881bd5d2efdfe8$export$1b79e4d7fc8e4817(/* #__PURE__ */ $218c56d3ae76a4af$var$bind2($27881bd5d2efdfe8$export$f79c83a36c9670be)(function(body) {
    return $3426187151feb9eb$export$32d31a833a940d1c($218c56d3ae76a4af$var$component1)($2jM6U.unit)(body);
}));


var $049cb618cc7d1225$require$main = $218c56d3ae76a4af$export$f22da7240b7add18;
$049cb618cc7d1225$require$main();


//# sourceMappingURL=repo.2416971f.js.map
